/* tslint:disable */
/* eslint-disable */
/**
 * Delegate API
 * API endpoints for Delegate service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const AcceptedModelInput = {
    Text: 'text',
    Video: 'video',
    ImageFirstFrame: 'image_first_frame',
    ImageLastFrame: 'image_last_frame',
    ImageReference: 'image_reference',
    VideoReference: 'video_reference',
    AudioReference: 'audio_reference',
    VoiceReference: 'voice_reference',
    VideoSource: 'video_source'
} as const;

export type AcceptedModelInput = typeof AcceptedModelInput[keyof typeof AcceptedModelInput];


export interface AccountDeletionDelegationCandidates {
    'teams': Array<AccountDeletionDelegationTeamCandidates>;
}
export interface AccountDeletionDelegationSuccessorCandidate {
    'userId': number;
    'displayName': string;
    'emailAddress': string;
}
export interface AccountDeletionDelegationTeamCandidates {
    'teamId': number;
    'teamName': string;
    'delegationCount': number;
    'ownershipTransferRequired': boolean;
    'eligibleSuccessors': Array<AccountDeletionDelegationSuccessorCandidate>;
}
export interface AccountDeletionProgress {
    'requestId': string;
    'status': AccountDeletionProgressStatusEnum;
    'totalTargets': number;
    'completedTargets': number;
}

export const AccountDeletionProgressStatusEnum = {
    Requested: 'requested',
    InProgress: 'in_progress',
    Completed: 'completed'
} as const;

export type AccountDeletionProgressStatusEnum = typeof AccountDeletionProgressStatusEnum[keyof typeof AccountDeletionProgressStatusEnum];

export interface AccountDeletionReceipt {
    'progress': AccountDeletionProgress;
    'statusToken': string;
}
export interface AccountDeletionRequest {
    /**
     * Each teamId may appear at most once.
     */
    'delegationSuccessors': Set<DelegationSuccessorSelection>;
}
export interface ActionLogAgentSelected extends ActionLogEntry {
    /**
     * ID of the selected agent
     */
    'agentId': number;
    /**
     * AI model selected
     */
    'model': string;
    /**
     * AI provider selected
     */
    'provider': string;
    /**
     * Temperature setting
     */
    'temperature'?: number;
    /**
     * Maximum tokens setting
     */
    'maxTokens': number;
}


export interface ActionLogAssistantMessage extends ActionLogEntry {
    /**
     * The assistant\'s thoughts before generating the message
     */
    'thoughts'?: string;
    /**
     * Message from the assistant
     */
    'message': string;
    /**
     * Number of tokens in the prompt
     */
    'promptTokens'?: number;
    /**
     * Number of tokens in the completion\'
     */
    'completionTokens'?: number;
    'model'?: string;
    'modelProvider'?: string;
    'pricing'?: ActionLogAssistantMessageAllOfPricing;
}


/**
 * Exact USD-per-million-token rates used for this invocation
 */
export interface ActionLogAssistantMessageAllOfPricing {
    'inputPerMillion': number;
    'outputPerMillion': number;
    'notes'?: string;
}
export interface ActionLogEmailReceived extends ActionLogEntry {
    'email': ActionLogEmailReceivedAllOfEmail;
}


export interface ActionLogEmailReceivedAllOfEmail {
    /**
     * Recipient email address
     */
    'to': string;
    /**
     * Sender email address
     */
    'from': string;
    /**
     * CC email addresses
     */
    'cc'?: string;
    /**
     * Email subject
     */
    'subject': string;
    /**
     * HTML content of the email
     */
    'htmlMessage': string;
    /**
     * Plain text content of the email
     */
    'textMessage': string;
    /**
     * Unique message identifier
     */
    'messageId'?: string;
    /**
     * Message ID this email is replying to
     */
    'inReplyTo'?: string;
    /**
     * Message references for threading
     */
    'references'?: string;
}
export interface ActionLogEntry {
    /**
     * Type of action log entry
     */
    'type': ActionLogEntryTypeEnum;
    /**
     * Timestamp of the action
     */
    'date': string;
    /**
     * Unique identifier for the request
     */
    'requestUUID'?: string;
}

export const ActionLogEntryTypeEnum = {
    EmailReceived: 'email_received',
    ToolRequest: 'tool_request',
    ToolResponse: 'tool_response',
    UserMessage: 'user_message',
    AssistantMessage: 'assistant_message',
    SystemInstructions: 'system_instructions',
    SystemMessage: 'system_message',
    Error: 'error',
    ToolCallFailure: 'tool_call_failure',
    ToolCallInvalid: 'tool_call_invalid',
    AgentSelected: 'agent_selected',
    Metric: 'metric'
} as const;

export type ActionLogEntryTypeEnum = typeof ActionLogEntryTypeEnum[keyof typeof ActionLogEntryTypeEnum];

export interface ActionLogError extends ActionLogEntry {
    /**
     * Error message
     */
    'message': string;
    /**
     * Additional error details
     */
    'details'?: Record<string, any>;
    /**
     * AI model that encountered the error
     */
    'model'?: string;
    /**
     * AI provider that encountered the error
     */
    'provider'?: string;
}


export interface ActionLogMetric extends ActionLogEntry {
    /**
     * Processing time in milliseconds
     */
    'processingTimeMs': number;
    /**
     * Number of tokens sent
     */
    'tokensSent': number;
    /**
     * Number of tokens received
     */
    'tokensReceived': number;
    /**
     * Whether the operation was successful
     */
    'success': boolean;
    /**
     * Number of email send attempts
     */
    'emailSendAttempts': number;
    /**
     * Number of emails successfully sent
     */
    'emailsSent': number;
    /**
     * Number of errors encountered
     */
    'errorCount': number;
}


export interface ActionLogSystemInstructions extends ActionLogEntry {
    /**
     * AI model used
     */
    'model': string;
    /**
     * AI provider used
     */
    'provider': string;
    /**
     * System instructions provided
     */
    'instructions': string;
}


export interface ActionLogSystemMessage extends ActionLogEntry {
    /**
     * System message
     */
    'message': string;
}


export interface ActionLogToolCallFailure extends ActionLogEntry {
    /**
     * Name of the tool that failed
     */
    'tool': string;
    /**
     * Failure message
     */
    'message': string;
    /**
     * Parameters that were passed to the tool
     */
    'params'?: Record<string, any>;
}


export interface ActionLogToolCallInvalid extends ActionLogEntry {
    /**
     * Name of the tool that was invalid
     */
    'tool': string;
    /**
     * Invalid tool message
     */
    'message': string;
    /**
     * Parameters that were passed to the tool
     */
    'params'?: Record<string, any>;
}


export interface ActionLogToolRequest extends ActionLogEntry {
    /**
     * Name of the tool being requested
     */
    'tool': string;
    /**
     * Parameters passed to the tool
     */
    'params': Record<string, any>;
    /**
     * Optional identifier linking tool calls with their action log entries
     */
    'toolCallId'?: string;
    /**
     * Optional nested action log entries for tools that generate their own action logs
     */
    'actionLog'?: Array<ActionLogEntry>;
}


export interface ActionLogToolResponse extends ActionLogEntry {
    /**
     * Name of the tool that responded
     */
    'tool': string;
    /**
     * Response from the tool
     */
    'response': string;
    /**
     * Whether this is the final response from the tool
     */
    'final'?: boolean;
    /**
     * Optional identifier linking tool calls with their action log entries
     */
    'toolCallId'?: string;
}


export interface ActionLogUserMessage extends ActionLogEntry {
    /**
     * Message from the user
     */
    'message': string;
}


export interface AddKnowledgeGraphEdgeRequest {
    /**
     * Type name of the edge
     */
    'edgeTypeName': string;
    /**
     * ID of the parent node
     */
    'parentNodeId': number;
    /**
     * ID of the child node
     */
    'childNodeId': number;
    /**
     * ID of the source
     */
    'sourceId': number;
    /**
     * URL of the source
     */
    'sourceUrl': string;
    /**
     * Optional context key
     */
    'contextKey'?: string;
}
export interface AddKnowledgeGraphNodeRequest {
    /**
     * Type name of the node
     */
    'nodeTypeName': string;
    /**
     * Name of the node
     */
    'name': string;
    /**
     * Array of node features
     */
    'features'?: Array<AddKnowledgeGraphNodeRequestFeaturesInner>;
    /**
     * ID of the source
     */
    'sourceId': number;
    /**
     * URL of the source
     */
    'sourceUrl': string;
    /**
     * Optional context key
     */
    'contextKey'?: string;
}
export interface AddKnowledgeGraphNodeRequestFeaturesInner {
    /**
     * Feature name
     */
    'name': string;
    /**
     * String value
     */
    'valueString'?: string;
    /**
     * Integer value
     */
    'valueInteger'?: number;
    /**
     * Double value
     */
    'valueDouble'?: number;
    /**
     * Boolean value
     */
    'valueBoolean'?: boolean;
    /**
     * Date value
     */
    'valueDate'?: string;
    /**
     * Date-time value
     */
    'valueDateTime'?: string;
}
export interface AddTestDataRequest {
    /**
     * ID of the message to mark as test data
     */
    'messageId': string;
}
export interface Agent {
    /**
     * Unique identifier for the agent
     */
    'id'?: number;
    /**
     * Agent name
     */
    'name'?: string;
    /**
     * ID of the team the agent belongs to
     */
    'teamId'?: number;
}
export interface AgentChannelResponse {
    /**
     * Agent-channel binding id (-1 for synthesized email entries)
     */
    'id'?: number;
    'agentId'?: number;
    'agentName'?: string;
    /**
     * Non-secret binding config (Slack bot user id, workspace, events verification timestamp)
     */
    'config'?: Record<string, any>;
    /**
     * Secret keys that currently have values (values are never returned)
     */
    'secretsSet'?: Array<string>;
    'missingSecrets'?: Array<string>;
    /**
     * Slack only; the Events API request URL to configure in the Slack app
     */
    'eventsUrl'?: string;
}
export interface AgentDeletionImpact {
    'agentId': number;
    'teamId': number;
    /**
     * Team secrets deleted with the agent because it is their only assignee.
     */
    'orphanSecrets': Array<AgentDeletionSecret>;
    'issuedAt': string;
    'expiresAt': string;
    /**
     * Five-minute confirmation bound to this exact agent, team, and secret revision set.
     */
    'confirmationToken': string;
}
export interface AgentDeletionSecret {
    'id': string;
    'name': string;
    'revision': number;
}
export interface AgentLogResponse {
    'logs': Array<AgentLogResponseLogsInner>;
    'totalCount': number;
}
/**
 * @type AgentLogResponseLogsInner
 */
export type AgentLogResponseLogsInner = AgentRequestLog | AgentWorkStreamLog;

export interface AgentMemory {
    /**
     * Unique identifier for the memory
     */
    'id': number;
    /**
     * ID of the agent this memory belongs to
     */
    'agentId': number;
    /**
     * The memory text content
     */
    'text': string;
    /**
     * When the memory was created
     */
    'createdAt': string;
    /**
     * When the memory was last updated
     */
    'updatedAt': string;
    /**
     * ID of the user who created this memory
     */
    'createdByUserId': number;
}
export interface AgentModelImpact {
    'agentId': number;
    'agentName': string;
    /**
     * Null on nullable generative slots when nothing is configured
     */
    'current': ModelSlotConfig;
    'resulting': ModelSlotConfig;
    'adoptionEligible': boolean;
}
export interface AgentPermissionCeiling {
    'id': number;
    'agentId': number;
    'builtinRole'?: string;
    'roleId'?: number;
    'roleName': string;
    'createdByUserId'?: number;
    'createdAt'?: string;
}
/**
 * Exactly one of builtinRole / roleId.
 */
export interface AgentPermissionCeilingInput {
    'builtinRole'?: AgentPermissionCeilingInputBuiltinRoleEnum;
    'roleId'?: number;
}

export const AgentPermissionCeilingInputBuiltinRoleEnum = {
    Administrator: 'administrator',
    Manager: 'manager',
    Contributor: 'contributor',
    Viewer: 'viewer',
    Billing: 'billing'
} as const;

export type AgentPermissionCeilingInputBuiltinRoleEnum = typeof AgentPermissionCeilingInputBuiltinRoleEnum[keyof typeof AgentPermissionCeilingInputBuiltinRoleEnum];

export interface AgentRequest {
    /**
     * ID of the team this agent belongs to
     */
    'teamId'?: number;
    /**
     * Email address for the agent (no longer used - auto-generated based on team name and agent name)
     */
    'emailAddress'?: string;
    /**
     * Response prompt for the agent
     */
    'responsePrompt'?: string;
    /**
     * Name of the agent
     */
    'name': string;
    /**
     * Voice type for the agent
     */
    'voiceType'?: AgentRequestVoiceTypeEnum;
    /**
     * Job description for the agent — a short title like \"HR\" or a longer role summary
     */
    'jobDescription'?: string;
    /**
     * Serial agents run one card job at a time fleet-wide (for agents whose decisions on one card affect the next); parallel agents work many cards at once, optionally capped. Chat is never gated.
     */
    'executionMode'?: AgentRequestExecutionModeEnum;
    /**
     * Cap on concurrent card jobs when parallel; null = uncapped.
     */
    'maxConcurrentWork'?: number;
    /**
     * Optional recommended-persona key (from GET /api/teams/{teamId}/personas). When set on creation, the new agent inherits the persona\'s recommended model (when the team can run it) and its discipline skills.
     */
    'personaKey'?: string;
    /**
     * Model for everything except knowledge extraction and live audio (email responses, summarization, task planning, in-app chat)
     */
    'modelInteraction'?: ModelSlotPolicy;
    /**
     * Whether the interaction slot follows the team default
     */
    'modelInteractionUsesTeamDefault'?: boolean;
    /**
     * Model configuration for knowledge extraction
     */
    'modelKnowledgeExtraction'?: ModelSlotPolicy;
    /**
     * Whether the knowledge-extraction slot follows the team default
     */
    'modelKnowledgeExtractionUsesTeamDefault'?: boolean;
    /**
     * Curated voice-talk profile for live audio chat
     */
    'modelLive'?: VoiceTalkConfig;
    /**
     * Whether the live-audio slot follows the team default
     */
    'modelLiveUsesTeamDefault'?: boolean;
    /**
     * Model for image generation (must be able to output images). Null when the team has no image-capable provider.
     */
    'modelImageGeneration'?: ModelSlotPolicy;
    /**
     * Whether the image-generation slot follows the team default
     */
    'modelImageGenerationUsesTeamDefault'?: boolean;
    /**
     * Model for generated speech. Distinct from modelLive (real-time conversation) and modelMusicGeneration.
     */
    'modelSpeechGeneration'?: ModelSlotPolicy;
    /**
     * Whether the speech-generation slot follows the team default
     */
    'modelSpeechGenerationUsesTeamDefault'?: boolean;
    /**
     * Model for generated music; not a substitute for speech.
     */
    'modelMusicGeneration'?: ModelSlotPolicy;
    /**
     * Whether the music-generation slot follows the team default
     */
    'modelMusicGenerationUsesTeamDefault'?: boolean;
    /**
     * Model for generated video. Seedance 2.5 through the platform fal.ai provider is the seeded default. Nullable only for legacy records or when deliberately cleared. The stored policy remains configured, but resolution fails clearly if platform fal.ai is unavailable.
     */
    'modelVideoGeneration'?: ModelSlotPolicy;
    /**
     * Whether the video-generation slot follows the team default
     */
    'modelVideoGenerationUsesTeamDefault'?: boolean;
    /**
     * Model for inspecting video input and returning bounded text. Distinct from modelVideoGeneration and nullable when no eligible inspection model is configured.
     */
    'modelVideoInspection'?: ModelSlotPolicy;
    /**
     * Whether the video-inspection slot follows the team default
     */
    'modelVideoInspectionUsesTeamDefault'?: boolean;
    /**
     * Whether this agent may render video without asking a human first. False unless a team member turns it on; never settable by an agent.
     */
    'videoGenerationAutoApprove'?: boolean;
    /**
     * Restriction type for inbound communications
     */
    'inboundCommunicationRestriction'?: AgentRequestInboundCommunicationRestrictionEnum;
    /**
     * Restriction type for outbound communications
     */
    'outboundCommunicationRestriction'?: AgentRequestOutboundCommunicationRestrictionEnum;
    /**
     * Comma/space separated list of allowed domains for inbound communication
     */
    'inboundCommunicationDomains'?: string;
    /**
     * Comma/space separated list of user IDs for inbound communication
     */
    'inboundCommunicationUsers'?: string;
    /**
     * Comma/space separated list of domains that are always allowed as CC recipients in replies
     */
    'outboundAlwaysAllowCCDomains'?: string;
    /**
     * Comma/space separated list of user IDs for outbound communication
     */
    'outboundCommunicationUsers'?: string;
    /**
     * Comma/space separated list of allowed email addresses for inbound communication
     */
    'inboundCommunicationEmails'?: string;
    /**
     * Comma/space separated list of allowed email addresses for outbound communication
     */
    'outboundCommunicationEmails'?: string;
    /**
     * Email address to always CC on outbound communications
     */
    'alwaysCcAddress'?: string;
    /**
     * Email address to always BCC on outbound communications
     */
    'alwaysBccAddress'?: string;
    /**
     * Restriction type for error communications
     */
    'errorCommunicationPolicy'?: AgentRequestErrorCommunicationPolicyEnum;
    /**
     * Restriction type for unhandled message communications
     */
    'unhandledMessageCommunicationPolicy'?: AgentRequestUnhandledMessageCommunicationPolicyEnum;
    /**
     * Specific user ID for error communications
     */
    'errorCommunicationUser'?: string;
    /**
     * Specific user ID for unhandled message communications
     */
    'unhandledMessageCommunicationUser'?: string;
}

export const AgentRequestVoiceTypeEnum = {
    WarmAndFunny: 'WARM_AND_FUNNY',
    CourteousAndProfessional: 'COURTEOUS_AND_PROFESSIONAL',
    IntelligentAndBrief: 'INTELLIGENT_AND_BRIEF'
} as const;

export type AgentRequestVoiceTypeEnum = typeof AgentRequestVoiceTypeEnum[keyof typeof AgentRequestVoiceTypeEnum];
export const AgentRequestExecutionModeEnum = {
    Serial: 'serial',
    Parallel: 'parallel'
} as const;

export type AgentRequestExecutionModeEnum = typeof AgentRequestExecutionModeEnum[keyof typeof AgentRequestExecutionModeEnum];
export const AgentRequestInboundCommunicationRestrictionEnum = {
    AllTeamUsers: 'ALL_TEAM_USERS',
    Domains: 'DOMAINS',
    SpecificEmailAddresses: 'SPECIFIC_EMAIL_ADDRESSES',
    Public: 'PUBLIC'
} as const;

export type AgentRequestInboundCommunicationRestrictionEnum = typeof AgentRequestInboundCommunicationRestrictionEnum[keyof typeof AgentRequestInboundCommunicationRestrictionEnum];
export const AgentRequestOutboundCommunicationRestrictionEnum = {
    Sender: 'SENDER',
    SenderWithCcsInSameDomain: 'SENDER_WITH_CCS_IN_SAME_DOMAIN',
    TeamUsers: 'TEAM_USERS',
    SpecificTeamUsers: 'SPECIFIC_TEAM_USERS',
    SpecificEmailAddresses: 'SPECIFIC_EMAIL_ADDRESSES'
} as const;

export type AgentRequestOutboundCommunicationRestrictionEnum = typeof AgentRequestOutboundCommunicationRestrictionEnum[keyof typeof AgentRequestOutboundCommunicationRestrictionEnum];
export const AgentRequestErrorCommunicationPolicyEnum = {
    AllTeamUsers: 'ALL_TEAM_USERS',
    SpecificTeamUser: 'SPECIFIC_TEAM_USER',
    NoNotification: 'NO_NOTIFICATION'
} as const;

export type AgentRequestErrorCommunicationPolicyEnum = typeof AgentRequestErrorCommunicationPolicyEnum[keyof typeof AgentRequestErrorCommunicationPolicyEnum];
export const AgentRequestUnhandledMessageCommunicationPolicyEnum = {
    AllTeamUsers: 'ALL_TEAM_USERS',
    SpecificTeamUser: 'SPECIFIC_TEAM_USER',
    NoNotification: 'NO_NOTIFICATION'
} as const;

export type AgentRequestUnhandledMessageCommunicationPolicyEnum = typeof AgentRequestUnhandledMessageCommunicationPolicyEnum[keyof typeof AgentRequestUnhandledMessageCommunicationPolicyEnum];

export interface AgentRequestLog {
    'kind': AgentRequestLogKindEnum;
    'metric': MetricItem;
}

export const AgentRequestLogKindEnum = {
    Request: 'request'
} as const;

export type AgentRequestLogKindEnum = typeof AgentRequestLogKindEnum[keyof typeof AgentRequestLogKindEnum];

export interface AgentResponse {
    /**
     * Unique identifier for the agent
     */
    'id'?: number;
    /**
     * ID of the team this agent belongs to
     */
    'teamId'?: number;
    'team'?: AgentResponseTeam;
    /**
     * Name of the agent
     */
    'name'?: string;
    /**
     * List of email receivers
     */
    'emailAddresses'?: Array<string>;
    /**
     * While true, this agent starts or continues no work (all channels)
     */
    'paused'?: boolean;
    /**
     * Serial = one card job at a time fleet-wide; parallel = many at once
     */
    'executionMode'?: AgentResponseExecutionModeEnum;
    /**
     * Cap on concurrent card jobs when parallel; null = uncapped
     */
    'maxConcurrentWork'?: number;
    /**
     * Model for everything except knowledge extraction and live audio (email responses, summarization, task planning, in-app chat)
     */
    'modelInteraction'?: ModelSlotPolicy;
    'modelInteractionUsesTeamDefault'?: boolean;
    /**
     * Model configuration for knowledge extraction
     */
    'modelKnowledgeExtraction'?: ModelSlotPolicy;
    'modelKnowledgeExtractionUsesTeamDefault'?: boolean;
    /**
     * Curated voice-talk profile for live audio chat
     */
    'modelLive'?: VoiceTalkConfig;
    'modelLiveUsesTeamDefault'?: boolean;
    /**
     * Model for image generation (must be able to output images)
     */
    'modelImageGeneration'?: ModelSlotPolicy;
    'modelImageGenerationUsesTeamDefault'?: boolean;
    /**
     * Model for generated speech
     */
    'modelSpeechGeneration'?: ModelSlotPolicy;
    'modelSpeechGenerationUsesTeamDefault'?: boolean;
    /**
     * Model for generated music
     */
    'modelMusicGeneration'?: ModelSlotPolicy;
    'modelMusicGenerationUsesTeamDefault'?: boolean;
    /**
     * Model for generated video
     */
    'modelVideoGeneration'?: ModelSlotPolicy;
    'modelVideoGenerationUsesTeamDefault'?: boolean;
    /**
     * Model for inspecting video input and returning bounded text
     */
    'modelVideoInspection'?: ModelSlotPolicy;
    'modelVideoInspectionUsesTeamDefault'?: boolean;
    /**
     * Overrides paused by reverting a slot to the team default
     */
    'dormantModelOverrides'?: DormantModelOverrides;
    /**
     * Allow this agent to render video without asking
     */
    'videoGenerationAutoApprove'?: boolean;
    /**
     * Response prompt for the agent
     */
    'responsePrompt'?: string;
    /**
     * Skills configured for the agent
     */
    'skills'?: Array<Skill>;
    /**
     * Voice type for the agent
     */
    'voiceType'?: AgentResponseVoiceTypeEnum;
    /**
     * Short job description for the agent, e.g. \"HR\" or \"Software developer\"
     */
    'jobDescription'?: string;
    /**
     * Durable identity of a system-seeded agent (e.g. \'head_of_ai_resources\'). Non-null marks the agent system-managed: its name, instructions, job title, persona, ceilings, and existence cannot be changed by team members.
     */
    'systemKey'?: string;
    /**
     * Restriction type for inbound communications
     */
    'inboundCommunicationRestriction'?: AgentResponseInboundCommunicationRestrictionEnum;
    /**
     * Restriction type for outbound communications
     */
    'outboundCommunicationRestriction'?: AgentResponseOutboundCommunicationRestrictionEnum;
    /**
     * Comma/space separated list of allowed domains for inbound communication
     */
    'inboundCommunicationDomains'?: string;
    /**
     * Comma/space separated list of user IDs for inbound communication
     */
    'inboundCommunicationUsers'?: string;
    /**
     * Comma/space separated list of domains that are always allowed as CC recipients in replies
     */
    'outboundAlwaysAllowCCDomains'?: string;
    /**
     * Comma/space separated list of user IDs for outbound communication
     */
    'outboundCommunicationUsers'?: string;
    /**
     * Comma/space separated list of allowed email addresses for inbound communication
     */
    'inboundCommunicationEmails'?: string;
    /**
     * Comma/space separated list of allowed email addresses for outbound communication
     */
    'outboundCommunicationEmails'?: string;
    /**
     * Email address to always CC on outbound communications
     */
    'alwaysCcAddress'?: string;
    /**
     * Email address to always BCC on outbound communications
     */
    'alwaysBccAddress'?: string;
    /**
     * Restriction type for error communications
     */
    'errorCommunicationPolicy'?: AgentResponseErrorCommunicationPolicyEnum;
    /**
     * Restriction type for unhandled message communications
     */
    'unhandledMessageCommunicationPolicy'?: AgentResponseUnhandledMessageCommunicationPolicyEnum;
    /**
     * Specific user ID for error communications
     */
    'errorCommunicationUser'?: string;
    /**
     * Specific user ID for unhandled message communications
     */
    'unhandledMessageCommunicationUser'?: string;
}

export const AgentResponseExecutionModeEnum = {
    Serial: 'serial',
    Parallel: 'parallel'
} as const;

export type AgentResponseExecutionModeEnum = typeof AgentResponseExecutionModeEnum[keyof typeof AgentResponseExecutionModeEnum];
export const AgentResponseVoiceTypeEnum = {
    WarmAndFunny: 'WARM_AND_FUNNY',
    CourteousAndProfessional: 'COURTEOUS_AND_PROFESSIONAL',
    IntelligentAndBrief: 'INTELLIGENT_AND_BRIEF'
} as const;

export type AgentResponseVoiceTypeEnum = typeof AgentResponseVoiceTypeEnum[keyof typeof AgentResponseVoiceTypeEnum];
export const AgentResponseInboundCommunicationRestrictionEnum = {
    AllTeamUsers: 'ALL_TEAM_USERS',
    Domains: 'DOMAINS',
    SpecificEmailAddresses: 'SPECIFIC_EMAIL_ADDRESSES',
    Public: 'PUBLIC'
} as const;

export type AgentResponseInboundCommunicationRestrictionEnum = typeof AgentResponseInboundCommunicationRestrictionEnum[keyof typeof AgentResponseInboundCommunicationRestrictionEnum];
export const AgentResponseOutboundCommunicationRestrictionEnum = {
    Sender: 'SENDER',
    SenderWithCcsInSameDomain: 'SENDER_WITH_CCS_IN_SAME_DOMAIN',
    TeamUsers: 'TEAM_USERS',
    SpecificTeamUsers: 'SPECIFIC_TEAM_USERS',
    SpecificEmailAddresses: 'SPECIFIC_EMAIL_ADDRESSES'
} as const;

export type AgentResponseOutboundCommunicationRestrictionEnum = typeof AgentResponseOutboundCommunicationRestrictionEnum[keyof typeof AgentResponseOutboundCommunicationRestrictionEnum];
export const AgentResponseErrorCommunicationPolicyEnum = {
    AllTeamUsers: 'ALL_TEAM_USERS',
    SpecificTeamUser: 'SPECIFIC_TEAM_USER',
    NoNotification: 'NO_NOTIFICATION'
} as const;

export type AgentResponseErrorCommunicationPolicyEnum = typeof AgentResponseErrorCommunicationPolicyEnum[keyof typeof AgentResponseErrorCommunicationPolicyEnum];
export const AgentResponseUnhandledMessageCommunicationPolicyEnum = {
    AllTeamUsers: 'ALL_TEAM_USERS',
    SpecificTeamUser: 'SPECIFIC_TEAM_USER',
    NoNotification: 'NO_NOTIFICATION'
} as const;

export type AgentResponseUnhandledMessageCommunicationPolicyEnum = typeof AgentResponseUnhandledMessageCommunicationPolicyEnum[keyof typeof AgentResponseUnhandledMessageCommunicationPolicyEnum];

/**
 * Team information
 */
export interface AgentResponseTeam {
    /**
     * ID of the team
     */
    'id'?: number;
    /**
     * Name of the team
     */
    'name'?: string;
}
export interface AgentWorkStreamLog {
    'kind': AgentWorkStreamLogKindEnum;
    'workStreamId': number;
    'contextKind': AgentWorkStreamLogContextKindEnum;
    'teamId': number;
    'teamName': string;
    'projectId': number;
    'projectName': string;
    'cardId': number;
    'cardReference': string;
    'cardTitle': string;
    'conversationId': number;
    'conversationTitle': string;
    'status': string;
    'runtimeType': AgentWorkStreamLogRuntimeTypeEnum;
    'runtimeClient'?: string;
    'runCount': number;
    'latestActivity'?: string;
    'costUsd'?: number;
    'costCompleteness': string;
    'created': string;
    'updated': string;
}

export const AgentWorkStreamLogKindEnum = {
    WorkStream: 'work_stream'
} as const;

export type AgentWorkStreamLogKindEnum = typeof AgentWorkStreamLogKindEnum[keyof typeof AgentWorkStreamLogKindEnum];
export const AgentWorkStreamLogContextKindEnum = {
    Card: 'card',
    TeamChat: 'team_chat'
} as const;

export type AgentWorkStreamLogContextKindEnum = typeof AgentWorkStreamLogContextKindEnum[keyof typeof AgentWorkStreamLogContextKindEnum];
export const AgentWorkStreamLogRuntimeTypeEnum = {
    BuiltIn: 'built_in',
    External: 'external'
} as const;

export type AgentWorkStreamLogRuntimeTypeEnum = typeof AgentWorkStreamLogRuntimeTypeEnum[keyof typeof AgentWorkStreamLogRuntimeTypeEnum];

export interface AllowedModelsConfig {
    'mode': AllowedModelsConfigModeEnum;
    'brands'?: Array<string>;
    'models'?: Array<string>;
}

export const AllowedModelsConfigModeEnum = {
    All: 'all',
    Custom: 'custom'
} as const;

export type AllowedModelsConfigModeEnum = typeof AllowedModelsConfigModeEnum[keyof typeof AllowedModelsConfigModeEnum];

export interface AnsweredEarlierComment {
    /**
     * The comment this reply answers.
     */
    'messageId': number;
    /**
     * Who wrote that comment. Null when the author can no longer be resolved. 
     */
    'authorName'?: string;
    /**
     * When that comment arrived.
     */
    'createdAt'?: string;
}
export interface ApiAgentAgentIdLearnGet200Response {
    /**
     * ID of the agent
     */
    'agentId'?: number;
    /**
     * Name of the agent
     */
    'name'?: string;
    /**
     * Email address of the agent
     */
    'emailAddress'?: string;
    /**
     * Summary of what was learned
     */
    'summary'?: string;
}
export interface ApiAgentIdDelete200Response {
    'message'?: string;
}
export interface ApiAgentIdDelete409Response {
    'error': ApiAgentIdDelete409ResponseError;
    'currentImpact': AgentDeletionImpact;
}
export interface ApiAgentIdDelete409ResponseError {
    'code': ApiAgentIdDelete409ResponseErrorCodeEnum;
    'message': string;
}

export const ApiAgentIdDelete409ResponseErrorCodeEnum = {
    DeletionImpactChanged: 'DELETION_IMPACT_CHANGED'
} as const;

export type ApiAgentIdDelete409ResponseErrorCodeEnum = typeof ApiAgentIdDelete409ResponseErrorCodeEnum[keyof typeof ApiAgentIdDelete409ResponseErrorCodeEnum];

export interface ApiAgentIdPausedPutRequest {
    /**
     * While true, this agent starts or continues no work
     */
    'paused': boolean;
}
export interface ApiAgentsAgentIdMemoriesGet200Response {
    'memories'?: Array<AgentMemory>;
    /**
     * Total number of memories for the agent
     */
    'totalCount'?: number;
    /**
     * Number of memories skipped
     */
    'offset'?: number;
    /**
     * Maximum number of memories returned
     */
    'limitCount'?: number;
}
export interface ApiAgentsAgentIdMemoriesPostRequest {
    /**
     * The memory text content
     */
    'text': string;
}
export interface ApiAgentsAgentIdMemoriesSearchGet200Response {
    'memories'?: Array<AgentMemory>;
    /**
     * Total number of matching memories
     */
    'totalCount'?: number;
    /**
     * Number of memories skipped
     */
    'offset'?: number;
    /**
     * Maximum number of memories returned
     */
    'limitCount'?: number;
}
export interface ApiAgentsAgentIdToolActionsIdApprovePostRequest {
    'note'?: string;
}
export interface ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest {
    /**
     * Whether the agent may use this bundle at all
     */
    'enabled'?: boolean;
    /**
     * Write-only secret values for the bundle\'s declared secretFields, merged key-wise over stored values; an empty string clears a key. Values are never returned by any endpoint. 
     */
    'credentials'?: { [key: string]: string; };
    /**
     * Non-secret settings for the bundle\'s declared configFields (e.g. JIRA site URL, AWS region); an empty string clears a key 
     */
    'config'?: { [key: string]: string; };
}
export interface ApiAgentsAgentIdToolsConfigurationsIdPutRequest {
    /**
     * Name of the tool
     */
    'toolName': string;
    /**
     * Tool-specific configuration
     */
    'configuration': Record<string, any>;
    /**
     * Optional credentials object to use with this tool
     */
    'credentials'?: Record<string, any>;
}
export interface ApiAgentsAgentIdToolsConfigurationsPostRequest {
    /**
     * Name of the tool
     */
    'toolName': string;
    /**
     * Tool-specific configuration
     */
    'configuration': Record<string, any>;
    /**
     * Optional credentials object to use with this tool
     */
    'credentials'?: Record<string, any>;
}
export interface ApiAgentsAgentIdToolsUsageGet200Response {
    'usage'?: { [key: string]: number; };
}
export interface ApiApprovalsApprovalIdDecisionPost200Response {
    'approval': ApprovalItem;
    'continuation': ApiApprovalsApprovalIdDecisionPost200ResponseContinuationEnum;
}

export const ApiApprovalsApprovalIdDecisionPost200ResponseContinuationEnum = {
    Resumed: 'resumed',
    Notified: 'notified',
    None: 'none'
} as const;

export type ApiApprovalsApprovalIdDecisionPost200ResponseContinuationEnum = typeof ApiApprovalsApprovalIdDecisionPost200ResponseContinuationEnum[keyof typeof ApiApprovalsApprovalIdDecisionPost200ResponseContinuationEnum];

export interface ApiApprovalsApprovalIdGet200Response {
    'approval': ApprovalItem;
}
export interface ApiAuthenticationForgotPasswordPost200Response {
    'success'?: boolean;
    'message'?: string;
}
export interface ApiAuthenticationForgotPasswordPost429Response {
    'error'?: string;
    'message'?: string;
}
export interface ApiAuthenticationForgotPasswordPostRequest {
    /**
     * Email address for password reset
     */
    'email': string;
}
export interface ApiAuthenticationLoginPost202Response {
    'success': boolean;
    'authenticationRequired': boolean;
    'state': ApiAuthenticationLoginPost202ResponseStateEnum;
}

export const ApiAuthenticationLoginPost202ResponseStateEnum = {
    MfaRequired: 'mfa_required',
    EnrollmentRequired: 'enrollment_required'
} as const;

export type ApiAuthenticationLoginPost202ResponseStateEnum = typeof ApiAuthenticationLoginPost202ResponseStateEnum[keyof typeof ApiAuthenticationLoginPost202ResponseStateEnum];

export interface ApiAuthenticationLoginPost400Response {
    'error'?: string;
    'message'?: string;
}
export interface ApiAuthenticationLoginPost401Response {
    'error'?: string;
}
export interface ApiAuthenticationLoginPostRequest {
    /**
     * User\'s email address
     */
    'email': string;
    /**
     * User\'s password
     */
    'password': string;
}
export interface ApiAuthenticationLogoutPost200Response {
    'message'?: string;
}
export interface ApiAuthenticationMfaFactorsGet200Response {
    'passkeys': Array<ApiAuthenticationMfaFactorsGet200ResponsePasskeysInner>;
    'totp'?: Record<string, any>;
    'sms'?: Record<string, any> | null;
    'recoveryCodesRemaining': number;
}
export interface ApiAuthenticationMfaFactorsGet200ResponsePasskeysInner {
    'id': string;
    'name': string;
    'deviceType': string;
    'backedUp': boolean;
    'createdAt': string;
    'lastUsedAt'?: string | null;
}
export interface ApiAuthenticationMfaManagementStartPost200Response {
    'success': boolean;
}
export interface ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest {
    'credential': Record<string, any>;
    'name'?: string;
}
export interface ApiAuthenticationMfaPasskeysIdPatchRequest {
    'name': string;
}
export interface ApiAuthenticationMfaRecoveryCodesRegeneratePost200Response {
    'recoveryCodes': Array<string>;
}
export interface ApiAuthenticationMfaSmsConfirmPost200Response {
    'success': boolean;
    'recoveryCodes': Array<string>;
}
export interface ApiAuthenticationMfaSmsSetupPostRequest {
    'phoneNumber': string;
}
export interface ApiAuthenticationMfaStatusGet200Response {
    'state': ApiAuthenticationMfaStatusGet200ResponseStateEnum;
    'methods': Array<ApiAuthenticationMfaStatusGet200ResponseMethodsEnum>;
}

export const ApiAuthenticationMfaStatusGet200ResponseStateEnum = {
    MfaRequired: 'mfa_required',
    EnrollmentRequired: 'enrollment_required'
} as const;

export type ApiAuthenticationMfaStatusGet200ResponseStateEnum = typeof ApiAuthenticationMfaStatusGet200ResponseStateEnum[keyof typeof ApiAuthenticationMfaStatusGet200ResponseStateEnum];
export const ApiAuthenticationMfaStatusGet200ResponseMethodsEnum = {
    Passkey: 'passkey',
    Totp: 'totp',
    Sms: 'sms',
    RecoveryCode: 'recovery_code'
} as const;

export type ApiAuthenticationMfaStatusGet200ResponseMethodsEnum = typeof ApiAuthenticationMfaStatusGet200ResponseMethodsEnum[keyof typeof ApiAuthenticationMfaStatusGet200ResponseMethodsEnum];

export interface ApiAuthenticationMfaTotpConfirmPost200Response {
    'success': boolean;
    'recoveryCodes': Array<string>;
}
export interface ApiAuthenticationMfaTotpSetupPost200Response {
    'uri': string;
    'manualKey': string;
}
export interface ApiAuthenticationOauthIdentitiesGet200Response {
    'identities'?: Array<ApiAuthenticationOauthIdentitiesGet200ResponseIdentitiesInner>;
}
export interface ApiAuthenticationOauthIdentitiesGet200ResponseIdentitiesInner {
    /**
     * ID of the OAuth identity
     */
    'id'?: number;
    /**
     * OAuth provider ID
     */
    'providerId'?: string;
    /**
     * Email associated with the OAuth identity
     */
    'email'?: string;
    /**
     * When the identity was last used
     */
    'lastUsed'?: string;
    /**
     * For a SAML identity (providerId `saml:<id>`), the connection\'s own display name. Null for every other provider.
     */
    'displayName'?: string;
}
export interface ApiAuthenticationOauthIdentitiesIdDelete200Response {
    'success'?: boolean;
}
export interface ApiAuthenticationOauthIdentitiesIdDelete400Response {
    'error'?: string;
    'message'?: string;
}
export interface ApiAuthenticationOauthProviderCallbackGet400Response {
    'error'?: string;
}
export interface ApiAuthenticationOauthProviderGet400Response {
    'error'?: string;
}
export interface ApiAuthenticationOauthProvidersGet200Response {
    /**
     * List of available OAuth provider IDs
     */
    'providers'?: Array<string>;
}
export interface ApiAuthenticationResetPasswordPost200Response {
    'success'?: boolean;
    'message'?: string;
}
export interface ApiAuthenticationResetPasswordPost400Response {
    'error'?: string;
    'message'?: string;
}
export interface ApiAuthenticationResetPasswordPost429Response {
    'error'?: string;
    'message'?: string;
}
export interface ApiAuthenticationResetPasswordPostRequest {
    /**
     * Email address associated with the reset token
     */
    'email': string;
    /**
     * Password reset token
     */
    'token': string;
    /**
     * New password
     */
    'newPassword': string;
}
export interface ApiConversationsIdDelete200Response {
    'message'?: string;
}
export interface ApiHealthGet200Response {
    'status'?: ApiHealthGet200ResponseStatusEnum;
}

export const ApiHealthGet200ResponseStatusEnum = {
    Ok: 'ok'
} as const;

export type ApiHealthGet200ResponseStatusEnum = typeof ApiHealthGet200ResponseStatusEnum[keyof typeof ApiHealthGet200ResponseStatusEnum];

export interface ApiInvitesMeGet200ResponseInner {
    /**
     * ID of the invite
     */
    'id'?: number;
    /**
     * ID of the team
     */
    'teamId'?: number;
    /**
     * Email address of the invited user
     */
    'emailAddress'?: string;
    /**
     * ID of the user who sent the invite
     */
    'invitingUserId'?: number;
    /**
     * When the invite was created
     */
    'createdAt'?: string;
    /**
     * When the invite was last updated
     */
    'updatedAt'?: string;
    'team'?: ApiInvitesMeGet200ResponseInnerTeam;
    'invitingUser'?: ApiTeamsTeamIdInvitesGet200ResponseInnerInvitingUser;
}
/**
 * Team information
 */
export interface ApiInvitesMeGet200ResponseInnerTeam {
    'id'?: number;
    'name'?: string;
    'description'?: string;
}
export interface ApiLegalContactGet200Response {
    'controllerName': ApiLegalContactGet200ResponseControllerNameEnum;
    'productName': ApiLegalContactGet200ResponseProductNameEnum;
    'privacyEmail': ApiLegalContactGet200ResponsePrivacyEmailEnum;
    'postalAddress': string;
}

export const ApiLegalContactGet200ResponseControllerNameEnum = {
    DreamingWellLlc: 'DreamingWell LLC'
} as const;

export type ApiLegalContactGet200ResponseControllerNameEnum = typeof ApiLegalContactGet200ResponseControllerNameEnum[keyof typeof ApiLegalContactGet200ResponseControllerNameEnum];
export const ApiLegalContactGet200ResponseProductNameEnum = {
    Delegate: 'Delegate'
} as const;

export type ApiLegalContactGet200ResponseProductNameEnum = typeof ApiLegalContactGet200ResponseProductNameEnum[keyof typeof ApiLegalContactGet200ResponseProductNameEnum];
export const ApiLegalContactGet200ResponsePrivacyEmailEnum = {
    HellodelegateTo: 'hello@delegate.to'
} as const;

export type ApiLegalContactGet200ResponsePrivacyEmailEnum = typeof ApiLegalContactGet200ResponsePrivacyEmailEnum[keyof typeof ApiLegalContactGet200ResponsePrivacyEmailEnum];

export interface ApiMemoriesMemoryIdDelete200Response {
    'message'?: string;
}
export interface ApiMemoriesMemoryIdPutRequest {
    /**
     * The updated memory text content
     */
    'text': string;
}
export interface ApiMessagesIdDelete200Response {
    'message'?: string;
}
export interface ApiMetricsMetricIdActionLogGet200Response {
    /**
     * Array of action log entries
     */
    'actionLog'?: Array<ActionLogEntry>;
    /**
     * The metric associated with this action log
     */
    'metric'?: MetricItem;
}
export interface ApiModelsProviderGet404Response {
    'error'?: string;
}
export interface ApiNotesNoteIdDelete200Response {
    'message'?: string;
}
export interface ApiProjectCardsCardIdDependenciesPostRequest {
    'blockingCardId': number;
}
export interface ApiProjectsProjectIdCostsGet200Response {
    'projectId': number;
    'teamId': number;
    'range': string;
    'buckets': Array<ApiProjectsProjectIdCostsGet200ResponseBucketsInner>;
}
export interface ApiProjectsProjectIdCostsGet200ResponseBucketsInner {
    'day': string;
    'category': string;
    'costUsd': number;
}
export interface ApiSendgridInboundPost200Response {
    'message'?: string;
}
export interface ApiSendgridInboundPost500Response {
    /**
     * Error message
     */
    'error'?: string;
}
export interface ApiSourcesCheckUrlGet200Response {
    /**
     * Whether the URL exists as a source
     */
    'exists'?: boolean;
    /**
     * ID of the team that owns the source (if exists is true)
     */
    'teamId'?: number;
}
export interface ApiSystemConfigurationGet200Response {
    /**
     * List of available domains
     */
    'domains'?: Array<string>;
    /**
     * Root URL of the application
     */
    'rootUrl'?: string;
    /**
     * Whether a platform Twilio account is configured
     */
    'smsEnabled'?: boolean;
    /**
     * Whether every account must enroll a multi-factor method
     */
    'mfaRequired'?: boolean;
}
export interface ApiTeamPost201Response {
    /**
     * ID of the created team
     */
    'id'?: number;
    /**
     * Name of the team
     */
    'name'?: string;
    /**
     * When the team was created
     */
    'createdAt'?: string;
    /**
     * When the team was last updated
     */
    'updatedAt'?: string;
}
export interface ApiTeamPostRequest {
    /**
     * Name of the team
     */
    'name': string;
}
export interface ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost200Response {
    /**
     * Summarized content
     */
    'summary': string;
    /**
     * URL of the vector source
     */
    'url': string;
    /**
     * Original content of the vector source
     */
    'content': string;
    /**
     * Publication date of the content
     */
    'dateOfPublication'?: string;
    /**
     * ID of the source document
     */
    'sourceDocumentId': number;
}
export interface ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest {
    /**
     * The search query
     */
    'query': string;
    /**
     * Description of the information being sought
     */
    'informationSought': string;
}
export interface ApiTeamTeamIdAgentAgentIdKnowledgeSearchPost200Response {
    'documents': Array<ApiTeamTeamIdAgentAgentIdKnowledgeSearchPost200ResponseDocumentsInner>;
}
export interface ApiTeamTeamIdAgentAgentIdKnowledgeSearchPost200ResponseDocumentsInner {
    /**
     * ID of the source
     */
    'sourceId'?: number;
    /**
     * Type of the source
     */
    'sourceType'?: string;
    /**
     * URL of the document
     */
    'documentUrl': string;
    /**
     * Relevance score
     */
    'score': number;
    /**
     * ID of the document
     */
    'documentId': number;
}
export interface ApiTeamTeamIdAgentAgentIdSourcesPost200Response {
    'message'?: string;
}
export interface ApiTeamTeamIdAgentAgentIdSourcesPostRequest {
    /**
     * ID of the source to add
     */
    'sourceId': number;
    /**
     * Whether linking is allowed for this source-agent relationship
     */
    'allowLinking'?: boolean;
}
export interface ApiTeamTeamIdAgentAgentIdSourcesSourceIdDelete200Response {
    'message'?: string;
}
export interface ApiTeamTeamIdAgentAgentIdSourcesSourceIdPut200Response {
    'message'?: string;
    /**
     * Updated allowLinking value
     */
    'allowLinking'?: boolean;
}
export interface ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest {
    /**
     * Whether linking is allowed for this source-agent relationship
     */
    'allowLinking': boolean;
}
export interface ApiTeamTeamIdBillingAutoRenewPutRequest {
    'enabled': boolean;
    'minBalanceUsd'?: number;
    'amountUsd'?: number;
}
export interface ApiTeamTeamIdBillingBudgetsPutRequest {
    'projectId'?: number;
    'period': string;
    'amountUsd'?: number;
}
export interface ApiTeamTeamIdBillingCreditCodesRedeemPost429Response {
    'error': string;
    'retryAfterSeconds': number;
}
export interface ApiTeamTeamIdBillingCreditCodesRedeemPostRequest {
    'code': string;
}
export interface ApiTeamTeamIdBillingInvoicesGet200Response {
    'invoices'?: Array<SubscriptionInvoiceInfo>;
}
export interface ApiTeamTeamIdBillingLedgerGet200Response {
    'total': number;
    'page': number;
    'pageSize': number;
    'entries': Array<BillingLedgerEntryInfo>;
}
export interface ApiTeamTeamIdBillingLedgerLedgerIdAdjustPost200Response {
    'id': number;
    'adjustmentUsd': number;
}
export interface ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest {
    'adjustmentUsd': number;
    'note': string;
}
export interface ApiTeamTeamIdBillingPausesGet200Response {
    'pauses': Array<BillingPauseInfo>;
}
export interface ApiTeamTeamIdBillingPaymentMethodPostRequest {
    'setupIntentId': string;
}
export interface ApiTeamTeamIdBillingPaymentsGet200Response {
    'payments': Array<BillingPaymentInfo>;
}
export interface ApiTeamTeamIdBillingPrepayPaymentIdConfirmPost200Response {
    'paymentId': number;
    'status': string;
}
export interface ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest {
    /**
     * Required for every operation-backed payment. It must be the same caller operation identity used to start the payment; omission is accepted only for creator-owned pre-migration manual payments.
     */
    'operationId'?: string;
}
export interface ApiTeamTeamIdBillingPrepayPost200Response {
    'paymentId': number;
    'status': string;
    'clientSecret'?: string;
    'errorMessage'?: string;
}
export interface ApiTeamTeamIdBillingPrepayPostRequest {
    'amountUsd': number;
    /**
     * Caller-generated identity for one intentional Add Funds operation. Reuse it across every retry and reload.
     */
    'operationId': string;
    'currency'?: ApiTeamTeamIdBillingPrepayPostRequestCurrencyEnum;
    /**
     * Charge the saved default card off-session. A pending response identifies the same durable payment request on retries; replay this start request with the same operationId to check it, rather than treating it as a new charge. Without this flag, a clientSecret is returned for one-off card entry confirmed client-side through the confirm endpoint.
     */
    'useSavedCard'?: boolean;
    /**
     * Save the one-off card after successful confirmation. This cannot be combined with useSavedCard.
     */
    'savePaymentMethod'?: boolean;
}

export const ApiTeamTeamIdBillingPrepayPostRequestCurrencyEnum = {
    Usd: 'usd'
} as const;

export type ApiTeamTeamIdBillingPrepayPostRequestCurrencyEnum = typeof ApiTeamTeamIdBillingPrepayPostRequestCurrencyEnum[keyof typeof ApiTeamTeamIdBillingPrepayPostRequestCurrencyEnum];

export interface ApiTeamTeamIdBillingRequestLimitIncreasePost200Response {
    'ok': boolean;
}
export interface ApiTeamTeamIdBillingRequestLimitIncreasePostRequest {
    'requestedLimitUsd': number;
}
export interface ApiTeamTeamIdBillingSetupIntentPost200Response {
    'setupIntentId': string;
    'clientSecret': string;
}
export interface ApiTeamTeamIdBillingSubscriptionPreviewPostRequest {
    'tierId': number;
}
export interface ApiTeamTeamIdDelete200Response {
    'message'?: string;
}
export interface ApiTeamTeamIdPut200Response {
    'message'?: string;
}
export interface ApiTeamTeamIdPutRequest {
    /**
     * New name for the team
     */
    'name'?: string;
    /**
     * Free-text summary of the team\'s purpose
     */
    'description'?: string;
    /**
     * Provider for embeddings (e.g., \'openai\', \'google\')
     */
    'embeddingsProvider'?: string;
    /**
     * Model to use for embeddings (e.g., \'text-embedding-3-small\')
     */
    'embeddingsModel'?: string;
    /**
     * Default enforced agent invocation policy for team chats and inheriting projects
     */
    'workingStyle'?: ApiTeamTeamIdPutRequestWorkingStyleEnum;
    /**
     * Maximum re-invocations of one agent in a cautious invocation cascade
     */
    'cautiousMaxReinvocations'?: number;
    /**
     * Maximum successful agent-to-agent handoffs in a Full Send cascade
     */
    'fullSendMaxHandoffs'?: number;
    /**
     * Maximum executing cards per agent across all team projects; excess work queues
     */
    'maxParallelCardsPerAgent'?: number;
    /**
     * Maximum executing agent sessions across the team; idle and human-input waits do not count
     */
    'maxParallelAgentSessions'?: number;
    /**
     * While true, no agent on this team starts or continues any work
     */
    'paused'?: boolean;
    /**
     * Default prior-version retention for newly created secrets; existing secrets are unchanged
     */
    'defaultPriorVersionRetentionDays'?: number;
}

export const ApiTeamTeamIdPutRequestWorkingStyleEnum = {
    NoAgents: 'no_agents',
    HumansDriveAgents: 'humans_drive_agents',
    AgentsCautiouslyDriveAgents: 'agents_cautiously_drive_agents',
    AgentsFullSend: 'agents_full_send'
} as const;

export type ApiTeamTeamIdPutRequestWorkingStyleEnum = typeof ApiTeamTeamIdPutRequestWorkingStyleEnum[keyof typeof ApiTeamTeamIdPutRequestWorkingStyleEnum];

export interface ApiTeamTeamIdSourcesSourceIdDelete200Response {
    'message'?: string;
}
export interface ApiTeamTeamIdSourcesSourceIdJobsGet200Response {
    'jobs'?: Array<JobItem>;
}
export interface ApiTeamTeamIdSourcesSourceIdRefreshPost200Response {
    'message'?: string;
    'jobs'?: Array<ApiTeamTeamIdSourcesSourceIdRefreshPost200ResponseJobsInner>;
}
export interface ApiTeamTeamIdSourcesSourceIdRefreshPost200ResponseJobsInner {
    /**
     * ID of the agent
     */
    'agentId'?: number;
    /**
     * ID of the started job
     */
    'jobId'?: string;
}
export interface ApiTeamTeamIdSourcesSourceIdRefreshPostRequest {
    /**
     * Whether to force a complete refresh of the source, ignoring cache
     */
    'forceRefresh'?: boolean;
}
export interface ApiTeamTeamIdUsersGet200ResponseInner {
    /**
     * ID of the user
     */
    'id'?: number;
    /**
     * Email address of the user
     */
    'email'?: string;
    /**
     * First name of the user
     */
    'firstName'?: string;
    /**
     * Last name of the user
     */
    'lastName'?: string;
    /**
     * When the user was created
     */
    'createdAt'?: string;
    /**
     * When the user was last updated
     */
    'updatedAt'?: string;
}
export interface ApiTeamTeamIdUsersPost200Response {
    'message'?: string;
}
export interface ApiTeamTeamIdUsersPostRequest {
    /**
     * Email address of the user to add
     */
    'userEmail': string;
}
export interface ApiTeamTeamIdUsersUserEmailAddressDelete200Response {
    'message'?: string;
}
export interface ApiTeamTeamIdUsersUserEmailAddressDelete409Response {
    'error': string;
    'code'?: ApiTeamTeamIdUsersUserEmailAddressDelete409ResponseCodeEnum;
}

export const ApiTeamTeamIdUsersUserEmailAddressDelete409ResponseCodeEnum = {
    MemberDelegationHandoffConflict: 'MEMBER_DELEGATION_HANDOFF_CONFLICT'
} as const;

export type ApiTeamTeamIdUsersUserEmailAddressDelete409ResponseCodeEnum = typeof ApiTeamTeamIdUsersUserEmailAddressDelete409ResponseCodeEnum[keyof typeof ApiTeamTeamIdUsersUserEmailAddressDelete409ResponseCodeEnum];

export interface ApiTeamTeamIdUsersUserEmailAddressDeleteRequest {
    'successorUserId'?: number | null;
}
export interface ApiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet200Response {
    'delegationCount': number;
    'ownershipTransferRequired': boolean;
    'teamDeletionRequired': boolean;
    'eligibleSuccessors': Array<ApiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet200ResponseEligibleSuccessorsInner>;
}
export interface ApiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet200ResponseEligibleSuccessorsInner {
    'userId': number;
    'displayName': string;
    'emailAddress': string;
}
export interface ApiTeamsGet200ResponseInner {
    /**
     * ID of the team
     */
    'id'?: number;
    /**
     * Name of the team
     */
    'name'?: string;
    /**
     * Free-text summary of the team\'s purpose
     */
    'description'?: string;
    'workingStyle'?: ApiTeamsGet200ResponseInnerWorkingStyleEnum;
    'cautiousMaxReinvocations'?: number;
    'fullSendMaxHandoffs'?: number;
    /**
     * Maximum executing cards per agent across all team projects; excess work queues
     */
    'maxParallelCardsPerAgent'?: number;
    /**
     * Maximum executing agent sessions across the team; idle and human-input waits do not count
     */
    'maxParallelAgentSessions'?: number;
    /**
     * While true, no agent on this team starts or continues any work
     */
    'paused'?: boolean;
    /**
     * Default prior-version retention for newly created secrets
     */
    'defaultPriorVersionRetentionDays'?: number;
    /**
     * Approvals in this team waiting on the authenticated user
     */
    'pendingApprovalCount'?: number;
    /**
     * Unviewed bell notifications for the authenticated user about this team
     */
    'unreadNotificationCount'?: number;
    'subscription'?: ApiTeamsGet200ResponseInnerSubscription;
    /**
     * When the team was created
     */
    'createdAt'?: string;
    /**
     * When the team was last updated
     */
    'updatedAt'?: string;
}

export const ApiTeamsGet200ResponseInnerWorkingStyleEnum = {
    NoAgents: 'no_agents',
    HumansDriveAgents: 'humans_drive_agents',
    AgentsCautiouslyDriveAgents: 'agents_cautiously_drive_agents',
    AgentsFullSend: 'agents_full_send'
} as const;

export type ApiTeamsGet200ResponseInnerWorkingStyleEnum = typeof ApiTeamsGet200ResponseInnerWorkingStyleEnum[keyof typeof ApiTeamsGet200ResponseInnerWorkingStyleEnum];

/**
 * The team\'s platform subscription state, for list chips and the team status banner
 */
export interface ApiTeamsGet200ResponseInnerSubscription {
    'status': ApiTeamsGet200ResponseInnerSubscriptionStatusEnum;
    'trialEndsAt'?: string;
    'currentPeriodEnd'?: string;
    'graceExpiresAt'?: string;
    'tier'?: ApiTeamsGet200ResponseInnerSubscriptionTier;
}

export const ApiTeamsGet200ResponseInnerSubscriptionStatusEnum = {
    Trialing: 'trialing',
    Active: 'active',
    PastDue: 'past_due',
    Paused: 'paused',
    TrialExpired: 'trial_expired',
    Canceled: 'canceled'
} as const;

export type ApiTeamsGet200ResponseInnerSubscriptionStatusEnum = typeof ApiTeamsGet200ResponseInnerSubscriptionStatusEnum[keyof typeof ApiTeamsGet200ResponseInnerSubscriptionStatusEnum];

/**
 * The plan\'s limits and feature switches, so views can refuse an excluded creation before the server does
 */
export interface ApiTeamsGet200ResponseInnerSubscriptionTier {
    'id': number;
    'slug': string;
    'name': string;
    'level': number;
    'maxAgents'?: number;
    'maxUsers'?: number;
    'maxViewers'?: number;
    'maxProjects'?: number;
    'maxFileStorageBytes'?: number;
    'allowByoModelKeys': boolean;
    'allowCustomPermissionRoles': boolean;
    'allowCustomAgentRoles': boolean;
    'allowCustomSkills': boolean;
    'allowCustomTools': boolean;
}
export interface ApiTeamsTeamIdAcceptInvitePost200Response {
    'message'?: string;
    /**
     * ID of the team that was joined
     */
    'teamId'?: number;
}
export interface ApiTeamsTeamIdAcceptInvitePostRequest {
    /**
     * Email address of the invited user
     */
    'email': string;
}
export interface ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest {
    'mode'?: string;
}
export interface ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response {
    'success'?: boolean;
}
export interface ApiTeamsTeamIdCredentialsCredentialsIdPutRequest {
    /**
     * Credentials data (e.g., API keys, tokens, etc.)
     */
    'credentials': Record<string, any>;
}
export interface ApiTeamsTeamIdCredentialsGet200ResponseInner {
    'id'?: number;
    'type'?: string;
    'name'?: string;
}
export interface ApiTeamsTeamIdCredentialsPostRequest {
    /**
     * Type of credentials (e.g., \'github\', \'http\', etc.)
     */
    'type': string;
    /**
     * Credentials data (e.g., API keys, tokens, etc.)
     */
    'credentials': Record<string, any>;
}
export interface ApiTeamsTeamIdInvitesEmailAddressDelete200Response {
    'message'?: string;
}
export interface ApiTeamsTeamIdInvitesEmailAddressRolePut200Response {
    'message': string;
    'invite': InviteRole;
}
export interface ApiTeamsTeamIdInvitesGet200ResponseInner {
    /**
     * ID of the invite
     */
    'id'?: number;
    /**
     * ID of the team
     */
    'teamId'?: number;
    /**
     * Email address of the invited user
     */
    'emailAddress'?: string;
    /**
     * ID of the user who sent the invite
     */
    'invitingUserId'?: number;
    /**
     * Project the user will also join when they accept, if the invite was project-scoped
     */
    'projectId'?: number;
    'builtinRole'?: InviteBuiltinRole;
    /**
     * Custom role the invite will confer, if it is not a built-in one
     */
    'roleId'?: number;
    'scopeType'?: InviteScopeType;
    /**
     * Display name of the role above, resolved server-side — the built-in\'s display name, or the custom role\'s name. Null when the role no longer resolves.
     */
    'roleName'?: string;
    /**
     * When the invite was created
     */
    'createdAt'?: string;
    /**
     * When the invite was last updated
     */
    'updatedAt'?: string;
    'invitingUser'?: ApiTeamsTeamIdInvitesGet200ResponseInnerInvitingUser;
}


/**
 * User who sent the invite
 */
export interface ApiTeamsTeamIdInvitesGet200ResponseInnerInvitingUser {
    'id'?: number;
    'firstName'?: string;
    'lastName'?: string;
    'emailAddress'?: string;
}
export interface ApiTeamsTeamIdInvitesPost201Response {
    'message'?: string;
}
export interface ApiTeamsTeamIdInvitesPostRequest {
    /**
     * Email address of the user to invite
     */
    'email_address': string;
    'builtinRole'?: InviteBuiltinRole;
    /**
     * Custom role (on this team) the invite will confer. Exactly one of builtinRole or roleId must be supplied.
     */
    'roleId'?: number;
    'scopeType'?: InviteScopeType;
    /**
     * Project the grant is scoped to. Required when scopeType is \'project\', and absent otherwise. camelCase only — the route does not read project_id and treats an unrecognised name as absent, which is how this invite once landed team-scoped.
     */
    'projectId'?: number;
}


export interface ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest {
    'enabled': boolean;
}
export interface ApiTeamsTeamIdModelProvidersProviderIdDelete200Response {
    'message'?: string;
}
export interface ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest {
    'domain': string;
}
/**
 * ruleType and ports are canonical; port remains accepted for legacy TCP clients.
 */
export interface ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest {
    'ruleType'?: string;
    /**
     * A single port or inclusive dash-separated range for editable rules.
     */
    'ports'?: string;
    'port'?: number;
    'destination'?: string;
    'workspaceId'?: number;
}
export interface ApiTeamsTeamIdProjectsPost403Response {
    'error'?: string;
}
export interface ApiTeamsTeamIdProjectsProjectIdWikiPageDelete200Response {
    'deleted'?: boolean;
}
export interface ApiTeamsTeamIdRejectInvitePost200Response {
    'message'?: string;
    /**
     * ID of the team
     */
    'teamId'?: number;
}
export interface ApiTeamsTeamIdSsoBreakGlassGet200Response {
    'grants'?: Array<BreakGlassGrant>;
}
export interface ApiTeamsTeamIdSsoConnectionsGet200Response {
    'connections'?: Array<TeamSsoConnection>;
}
export interface ApiTeamsTeamIdSsoDomainsGet200Response {
    'domains'?: Array<ClaimedDomain>;
}
export interface ApiTeamsTeamIdWorkspacePolicyGet200Response {
    'policy': WorkspacePolicy;
    'provider': WorkspaceProviderTarget;
}
export interface ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet200Response {
    'capabilities': WorkspaceCapabilities;
}
export interface ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet200Response {
    'catalog': WorkspacePriceCatalog;
}
export interface ApiTeamsTeamIdWorkspaceRequestsGet200Response {
    'requests': Array<WorkspaceResourceRequest>;
}
export interface ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest {
    'revision': number;
}
export interface ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut200Response {
    'workspace'?: Workspace;
    'request'?: WorkspaceResourceRequest;
}
export interface ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest {
    'agentId': number;
    'allocation': WorkspaceAllocationRequest;
}
export interface ApiTeamsWizardEligibilityGet200Response {
    /**
     * True only when this would be the user\'s first team ever
     */
    'trialEligible': boolean;
    /**
     * The active payment provider (stripe or mock)
     */
    'billingProvider': string;
    /**
     * The Stripe publishable key when the provider is stripe
     */
    'publishableKey'?: string;
}
export interface ApiTeamsWizardPost201Response {
    'teamId': number;
    'setupIntent': ApiTeamTeamIdBillingSetupIntentPost200Response;
}
export interface ApiTeamsWizardPostRequest {
    'name': string;
    'website'?: string;
    'invites'?: Array<ApiTeamsWizardPostRequestInvitesInner>;
    'tierId': number;
    'budgets'?: ApiTeamsWizardPostRequestBudgets;
    'autoTopUp'?: ApiTeamsWizardPostRequestAutoTopUp;
}
export interface ApiTeamsWizardPostRequestAutoTopUp {
    'enabled'?: boolean;
    'minBalanceUsd'?: number;
    'amountUsd'?: number;
}
export interface ApiTeamsWizardPostRequestBudgets {
    'dailyUsd'?: number;
    'weeklyUsd'?: number;
    'monthlyUsd'?: number;
}
export interface ApiTeamsWizardPostRequestInvitesInner {
    'email': string;
    'builtinRole': ApiTeamsWizardPostRequestInvitesInnerBuiltinRoleEnum;
}

export const ApiTeamsWizardPostRequestInvitesInnerBuiltinRoleEnum = {
    Administrator: 'administrator',
    Manager: 'manager',
    Contributor: 'contributor',
    Viewer: 'viewer',
    Billing: 'billing'
} as const;

export type ApiTeamsWizardPostRequestInvitesInnerBuiltinRoleEnum = typeof ApiTeamsWizardPostRequestInvitesInnerBuiltinRoleEnum[keyof typeof ApiTeamsWizardPostRequestInvitesInnerBuiltinRoleEnum];

export interface ApiTeamsWizardTeamIdFinalizePost200Response {
    'teamId'?: number;
}
export interface ApiTeamsWizardTeamIdFinalizePostRequest {
    'setupIntentId': string;
    'tierId': number;
    'fundsUsd'?: number;
}
export interface ApiTiersGet200Response {
    'tiers'?: Array<TierInfo>;
}
export interface ApiUserChannelIdentitiesConsumeLinkTokenPost200Response {
    'success'?: boolean;
    'kind'?: ApiUserChannelIdentitiesConsumeLinkTokenPost200ResponseKindEnum;
    'value'?: string;
}

export const ApiUserChannelIdentitiesConsumeLinkTokenPost200ResponseKindEnum = {
    SlackUser: 'slack_user',
    Phone: 'phone'
} as const;

export type ApiUserChannelIdentitiesConsumeLinkTokenPost200ResponseKindEnum = typeof ApiUserChannelIdentitiesConsumeLinkTokenPost200ResponseKindEnum[keyof typeof ApiUserChannelIdentitiesConsumeLinkTokenPost200ResponseKindEnum];

export interface ApiUserChannelIdentitiesConsumeLinkTokenPostRequest {
    'token': string;
}
export interface ApiUserChannelIdentitiesGet200Response {
    'identities': Array<ChannelIdentity>;
}
export interface ApiUserPasswordPut200Response {
    'message'?: string;
}
export interface ApiUserPasswordPutRequest {
    /**
     * Current password
     */
    'currentPassword': string;
    /**
     * New password
     */
    'newPassword': string;
}
export interface ApiUserPhoneStartPost200Response {
    'success'?: boolean;
    'message'?: string;
}
export interface ApiUserPhoneStartPostRequest {
    /**
     * E.164 phone number, e.g. +15551234567
     */
    'phoneNumber': string;
}
export interface ApiUserPhoneVerifyPost200Response {
    'success'?: boolean;
    /**
     * The now-linked E.164 phone number
     */
    'value'?: string;
}
export interface ApiUserPhoneVerifyPostRequest {
    /**
     * The 6-digit one-time code
     */
    'code': string;
}
export interface ApiUserProfilePutRequest {
    /**
     * User\'s first name
     */
    'firstName': string;
    /**
     * User\'s last name
     */
    'lastName': string;
}
export interface ApiUserResendVerificationPost200Response {
    /**
     * Whether the operation was successful
     */
    'success'?: boolean;
    /**
     * Success message
     */
    'message'?: string;
}
export interface ApiUserResendVerificationPostRequest {
    /**
     * Email address to resend verification to
     */
    'email': string;
}
export interface ApiUserSearchGet200Response {
    'users': Array<UserSearchResult>;
}
export interface ApiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet200Response {
    'documentId'?: number;
    'content'?: string;
}
export interface ApiV1TeamTeamIdKnowledgeDocumentsExclusionPut200Response {
    'documents'?: Array<SourceDocument>;
    'message'?: string;
}
export interface ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest {
    /**
     * Array of source document IDs to update
     */
    'sourceDocumentIds': Array<number>;
    /**
     * Whether to mark the documents as excluded or not
     */
    'excluded': boolean;
}
export interface ApiV1TeamTeamIdKnowledgeDocumentsGet200Response {
    'documents'?: Array<SourceDocument>;
    'pagination'?: ApiV1TeamTeamIdKnowledgeDocumentsGet200ResponsePagination;
}
export interface ApiV1TeamTeamIdKnowledgeDocumentsGet200ResponsePagination {
    'offset'?: number;
    'limit'?: number;
    'total'?: number;
}
export interface ApiV1TeamTeamIdKnowledgeDocumentsRefreshPost200Response {
    'success'?: boolean;
    'message'?: string;
    'job'?: ApiV1TeamTeamIdKnowledgeDocumentsRefreshPost200ResponseJob;
}
export interface ApiV1TeamTeamIdKnowledgeDocumentsRefreshPost200ResponseJob {
    'agentId'?: number;
    'jobId'?: string;
}
export interface ApiWsAgentAgentIdLearnMockGet400Response {
    'error'?: string;
    'message'?: string;
}
export interface ApplyAgentPersonaRequest {
    'personaKey': string;
}
export interface ApplyPersonaResult {
    'personaKey': string;
    /**
     * Human-readable note on what happened to the model slot
     */
    'modelNote': string;
    'skillsCreated': Array<string>;
    'skillsSkipped': Array<string>;
}
export interface ApplyTeamModelDefaultRequest {
    'slot': ModelSlot;
    'proposedDefault': ModelSlotConfig;
    'expectedRevision': number;
    'adoptAgentIds': Array<number>;
}


export interface ApprovalDecisionRequest {
    'decision': ApprovalDecisionRequestDecisionEnum;
    'note'?: string;
    'version'?: Record<string, any>;
    'inputs'?: Record<string, any>;
}

export const ApprovalDecisionRequestDecisionEnum = {
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type ApprovalDecisionRequestDecisionEnum = typeof ApprovalDecisionRequestDecisionEnum[keyof typeof ApprovalDecisionRequestDecisionEnum];

export interface ApprovalItem {
    'id': number;
    'teamId': number;
    'type': string;
    'status': ApprovalItemStatusEnum;
    'title': string;
    'reason'?: string;
    'legacyReasonUnavailable': boolean;
    'requestingAgent': ApprovalItemRequestingAgent;
    'requestingUser'?: ApprovalItemRequestingUser;
    /**
     * What ran the turn that raised this request (chat, card, loop_task, card_monitor, ...). Null on records that predate the field.
     */
    'requestingTrigger'?: string;
    'createdAt': string;
    'origin'?: ApprovalOrigin;
    'detail': Record<string, any>;
    'decisionNote'?: string;
    'decidedAt'?: string;
    'decidedBy'?: ApprovalItemDecidedBy;
}

export const ApprovalItemStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected',
    Canceled: 'canceled',
    Failed: 'failed'
} as const;

export type ApprovalItemStatusEnum = typeof ApprovalItemStatusEnum[keyof typeof ApprovalItemStatusEnum];

export interface ApprovalItemDecidedBy {
    'id': number;
    'name': string;
}
export interface ApprovalItemRequestingAgent {
    'id'?: number;
    'name': string;
}
/**
 * The human on whose behalf the agent raised this request, recorded by the platform from the turn\'s principal (the message author or the card dispatcher), never from the agent\'s prose. Null when the turn ran unattended or the record predates the field.
 */
export interface ApprovalItemRequestingUser {
    'id': number;
    'name': string;
}
export interface ApprovalListResponse {
    'approvals': Array<ApprovalItem>;
}
export interface ApprovalOrigin {
    'kind': ApprovalOriginKindEnum;
    'teamId': number;
    'conversationId'?: number;
    'projectId'?: number;
    'cardId'?: number;
    'name'?: string;
}

export const ApprovalOriginKindEnum = {
    ChatConversation: 'chat_conversation',
    ProjectCard: 'project_card',
    ExternalConversation: 'external_conversation'
} as const;

export type ApprovalOriginKindEnum = typeof ApprovalOriginKindEnum[keyof typeof ApprovalOriginKindEnum];

export interface ApprovedEgressDomain {
    'id'?: number;
    'domain'?: string;
    'source'?: ApprovedEgressDomainSourceEnum;
    'createdAt'?: string;
}

export const ApprovedEgressDomainSourceEnum = {
    Request: 'request',
    Manual: 'manual'
} as const;

export type ApprovedEgressDomainSourceEnum = typeof ApprovedEgressDomainSourceEnum[keyof typeof ApprovedEgressDomainSourceEnum];

export interface AttributeMapping {
    /**
     * Claims tried in order to resolve the signed-in user\'s email.
     */
    'emailAttributes': Array<string>;
    'objectIdentifierAttribute': string;
    'displayNameAttribute': string;
}
export interface AuthenticatedMarketingEmailConsentRequest {
    'decision': AuthenticatedMarketingEmailConsentRequestDecisionEnum;
    'source': AuthenticatedMarketingEmailConsentRequestSourceEnum;
}

export const AuthenticatedMarketingEmailConsentRequestDecisionEnum = {
    Accepted: 'accepted',
    Declined: 'declined'
} as const;

export type AuthenticatedMarketingEmailConsentRequestDecisionEnum = typeof AuthenticatedMarketingEmailConsentRequestDecisionEnum[keyof typeof AuthenticatedMarketingEmailConsentRequestDecisionEnum];
export const AuthenticatedMarketingEmailConsentRequestSourceEnum = {
    NotificationsPrompt: 'notifications_prompt',
    AuthenticatedPreferences: 'authenticated_preferences'
} as const;

export type AuthenticatedMarketingEmailConsentRequestSourceEnum = typeof AuthenticatedMarketingEmailConsentRequestSourceEnum[keyof typeof AuthenticatedMarketingEmailConsentRequestSourceEnum];

export interface BillingBudgetStatus {
    'id': number;
    'projectId': number;
    'period': string;
    'amountUsd': number;
    'spentUsd': number;
    'reservedUsd': number;
}
export interface BillingBudgetsResponse {
    'budgets': Array<BillingBudgetStatus>;
}
export interface BillingCardSummary {
    'brand'?: string;
    'last4'?: string;
    'expMonth'?: number;
    'expYear'?: number;
}
/**
 * Read-only rolling-30-day card charge limit. Use POST /api/team/{teamId}/billing/request-limit-increase to request a higher limit; there is no endpoint to edit it directly.
 */
export interface BillingChargeCap {
    /**
     * Global per-team default limit.
     */
    'perTeam30dUsd': number;
    /**
     * Effective per-team limit (override if set, else the default).
     */
    'effectiveLimitUsd': number;
    'overrideActive': boolean;
    /**
     * Team\'s card charges (succeeded+pending) in the last 30 days.
     */
    'charged30dUsd': number;
}
export interface BillingLedgerEntryInfo {
    'id': number;
    'status': string;
    'category': string;
    'serviceProvider'?: string;
    'resource'?: string;
    'unit'?: string;
    'unitCostUsd'?: number;
    'unitCount'?: number;
    'totalCostUsd': number;
    'reservedUsd'?: number;
    'adjustmentUsd': number;
    'adjustmentNote'?: string;
    'projectId'?: number;
    'projectName'?: string;
    'agentId'?: number;
    'agentName'?: string;
    'originatingUserEmail'?: string;
    'conversationId'?: number;
    'created': string;
    'settledAt'?: string;
}
export interface BillingPauseInfo {
    'id': number;
    'origin': string;
    'reason': string;
    'status': string;
    'agentId'?: number;
    'projectId'?: number;
    'conversationId'?: number;
    'created': string;
}
export interface BillingPaymentInfo {
    'id': number;
    'amountUsd': number;
    /**
     * Funding provider; credit identifies a redeemed credit code.
     */
    'provider': string;
    /**
     * Funding origin; redemption identifies a redeemed credit code.
     */
    'origin': string;
    'status': string;
    /**
     * Null for funding without a card receipt, including credit redemption.
     */
    'receiptNumber': string | null;
    'createdByEmail'?: string;
    'cardSummary'?: BillingCardSummary;
    'error'?: string;
    'created': string;
    'consumedUsd': number;
    'remainingUsd': number;
}
export interface BillingSummary {
    'accountExists': boolean;
    'balanceUsd': number;
    'reservedUsd': number;
    'availableUsd': number;
    'autoRenewEnabled': boolean;
    'autoRenewMinBalanceUsd'?: number;
    'autoRenewAmountUsd'?: number;
    'autoRenewLastAttemptAt'?: string;
    'autoRenewLastError'?: string;
    'paymentMethod'?: BillingCardSummary;
    'provider': string;
    'publishableKey'?: string;
    'openPauseCount': number;
    'budgets': Array<BillingBudgetStatus>;
    'chargeCap': BillingChargeCap;
    /**
     * Minimum amount (USD) that can be charged to a card in one prepayment.
     */
    'minChargeUsd': number;
}
export interface BreakGlassGrant {
    'id': number;
    'userId': number;
    'userEmail': string;
    'userName': string;
    'grantedByUserId': number;
    /**
     * Null when the granting user\'s row no longer exists. The id is still returned so an operator can look them up.
     */
    'grantedByName': string;
    /**
     * Null when the granting user\'s row no longer exists.
     */
    'grantedByEmail': string;
    'reason': string;
    'expiresAt': string;
    'createdAt': string;
}
/**
 * @type BrowserTimelineItem
 */
export type BrowserTimelineItem = { itemType: 'recording' } & WorkStreamBrowserRecording | { itemType: 'screenshot' } & WorkStreamBrowserFrame;

export interface BrowserTimelinePage {
    'workStreamId': number;
    'scope': BrowserTimelinePageScopeEnum;
    'runId': number;
    'items': Array<BrowserTimelineItem>;
    'serverNow': string;
    'hasMoreBefore': boolean;
    'hasMoreAfter': boolean;
    'nextBeforeCursor': string;
    'nextAfterCursor': string;
}

export const BrowserTimelinePageScopeEnum = {
    All: 'all',
    Run: 'run'
} as const;

export type BrowserTimelinePageScopeEnum = typeof BrowserTimelinePageScopeEnum[keyof typeof BrowserTimelinePageScopeEnum];

export interface BundleConfigField {
    'key': string;
    'label': string;
    'placeholder'?: string;
}
export interface BundleSecretField {
    'key': string;
    'label': string;
    /**
     * Render a textarea (e.g. a pasted key JSON)
     */
    'multiline'?: boolean;
}
export interface CancelCardNextAction200Response {
    'nextAction': CardNextActionView;
}
export interface CancelCardNextActionRequest {
    'reason'?: string;
}
export interface CancelJobResponse {
    /**
     * Success message
     */
    'message': string;
    /**
     * Updated job details
     */
    'job': JobItem;
}
export interface CanonicalModelSummary {
    'canonicalModelId': string;
    'displayName': string;
    'brand'?: string;
    'familyId'?: string;
    'description'?: string;
    'detailedDescription'?: string;
    'outputModalities'?: Array<string>;
    /**
     * Inputs the model accepts beyond its prompt.
     */
    'acceptedInputs'?: Array<AcceptedModelInput>;
    'supportsLiveAudio'?: boolean;
    'videoCapabilities'?: VideoCapabilities;
    /**
     * True when selectable provider endpoints publish different video controls; endpoint rows carry the exact structures.
     */
    'videoCapabilitiesVary'?: boolean;
    /**
     * Provider instances reaching this model, before sub-processor expansion.
     */
    'providerCount': number;
    /**
     * Absent when no provider discloses a price for this model.
     */
    'cheapestInputPerMillion'?: number;
    'cheapestOutputPerMillion'?: number;
    'pricingUnavailable'?: boolean;
}
/**
 * An email captured (not sent) during a test run
 */
export interface CapturedTestEmail {
    /**
     * Recipient email addresses
     */
    'to'?: Array<string>;
    /**
     * CC email addresses
     */
    'cc'?: Array<string>;
    /**
     * BCC email addresses
     */
    'bcc'?: Array<string>;
    /**
     * Email subject
     */
    'subject'?: string;
    /**
     * Email message body
     */
    'message'?: string;
    /**
     * When the email was captured
     */
    'timestamp'?: string;
    /**
     * Plain text version of the message
     */
    'textMessage'?: string;
    /**
     * HTML version of the message
     */
    'htmlMessage'?: string;
}
/**
 * A memory captured (not stored) during a test run
 */
export interface CapturedTestMemory {
    /**
     * Memory text
     */
    'text'?: string;
    /**
     * When the memory was captured
     */
    'timestamp'?: string;
}
/**
 * The card\'s pending or in-flight agent work request, present from the moment work is requested (e.g. an @mention comment) until the job finishes. Queued means the work is waiting for an execution slot or job launch; running means an agent job holds the claim (its container may still be starting). 
 */
export interface CardActiveWork {
    'status': CardActiveWorkStatusEnum;
    'agentId'?: number;
    'agentName'?: string;
    /**
     * Transient \"what the agent is doing right now\" line
     */
    'liveSummary'?: string;
    /**
     * Work stream reserved for this request
     */
    'workStreamId'?: number;
    /**
     * The comment whose mention requested this work, when one did
     */
    'triggerMessageId'?: number;
    /**
     * For a queued request, the cards it depends on that have not reached Done; the dispatcher will not start it until they do. Empty for a running request. 
     */
    'waitingOn'?: Array<DependencyCardSummary>;
    /**
     * For a queued request, the name of the card\'s column when its agent-access rules forbid agent work: the request is parked until a person moves the card or changes the column. Null otherwise. 
     */
    'blockedByColumn'?: string;
}

export const CardActiveWorkStatusEnum = {
    Queued: 'queued',
    Running: 'running'
} as const;

export type CardActiveWorkStatusEnum = typeof CardActiveWorkStatusEnum[keyof typeof CardActiveWorkStatusEnum];

export interface CardNextActionView {
    'id': number;
    'cardId': number;
    'projectId': number;
    'teamId': number;
    'cardTitle'?: string;
    'projectName'?: string;
    'createdByAgentId': number;
    'createdByAgentName'?: string;
    'targetAgentId': number;
    'targetAgentName'?: string;
    'intent': string;
    /**
     * time, event, or check
     */
    'triggerKind': string;
    /**
     * Human-readable phrase for why the item is waiting
     */
    'triggerSummary': string;
    'nextCheckAt'?: string;
    /**
     * For time triggers, the exact moment (countdown rendering)
     */
    'firesAt'?: string;
    'eventDescription'?: string;
    /**
     * pending, firing, fired, cancelled, expired, or needs_attention
     */
    'status': string;
    'statusReason'?: string;
    'expiresAt': string;
    'createdAt': string;
    /**
     * Whether the calling user may cancel this item
     */
    'canCancel': boolean;
}
export interface CardRef {
    'reference'?: string;
    'cardId'?: number;
    'projectId'?: number;
    'title'?: string;
}
export interface CardRefsResponse {
    'cardRefs'?: Array<CardRef>;
}
export interface CardWatcherAgentView {
    'agentId': number;
    'name': string;
    /**
     * The agent\'s own note describing what it is watching for
     */
    'prompt': string;
    /**
     * Whether the calling user may remove this agent\'s watch
     */
    'canRemove': boolean;
}
export interface CardWatcherUserView {
    'userId': number;
    'name': string;
    /**
     * Whether this row is the calling user
     */
    'isViewer': boolean;
}
export interface CardWatchersView {
    /**
     * Whether the calling user is currently watching the card
     */
    'viewerWatching': boolean;
    'users': Array<CardWatcherUserView>;
    'agents': Array<CardWatcherAgentView>;
}
export interface CatalogPriceQuote {
    /**
     * Provider list price in USD per one million input tokens
     */
    'inputPerMillion': number;
    /**
     * Provider list price in USD per one million output tokens
     */
    'outputPerMillion': number;
    /**
     * Provider list price in USD per one million prompt tokens served from its context cache. Absent when no cached rate is published.
     */
    'cachedInputPerMillion'?: number;
    /**
     * Provider list price in USD per one million image-carrying output tokens, on models that emit images. Far above the text output rate; absent on text-only models.
     */
    'imageOutputPerMillion'?: number;
    /**
     * Provider list price in USD per one million audio-carrying output tokens. Gemini TTS tokenizes audio at about 25 tokens per second of speech.
     */
    'audioOutputPerMillion'?: number;
    /**
     * Flat charge per generation, for models billed by the artifact rather than by tokens (Lyria charges per clip).
     */
    'perGenerationUsd'?: number;
    /**
     * Flat USD charge per generated image when the provider bills by image rather than by image-output tokens.
     */
    'perImageUsd'?: number;
    /**
     * USD per second of generated video. The only rate that scales with the size of the artifact, and the only cost a video model has — its token rates are zero, so a picker that ignored this would label a dollar render \"Free\".
     */
    'videoPerSecond'?: number;
    'accuracy': CatalogPriceQuoteAccuracyEnum;
    'sourceName': string;
    'sourceUrl'?: string;
    'asOf'?: string;
    'notes'?: string;
}

export const CatalogPriceQuoteAccuracyEnum = {
    Exact: 'exact',
    Approximate: 'approximate',
    Configured: 'configured'
} as const;

export type CatalogPriceQuoteAccuracyEnum = typeof CatalogPriceQuoteAccuracyEnum[keyof typeof CatalogPriceQuoteAccuracyEnum];

export interface ChannelIdentity {
    'id': number;
    'kind': ChannelIdentityKindEnum;
    /**
     * The Slack user id or E.164 phone number
     */
    'value': string;
    'verifiedVia': ChannelIdentityVerifiedViaEnum;
    'createdAt': string;
}

export const ChannelIdentityKindEnum = {
    SlackUser: 'slack_user',
    Phone: 'phone'
} as const;

export type ChannelIdentityKindEnum = typeof ChannelIdentityKindEnum[keyof typeof ChannelIdentityKindEnum];
export const ChannelIdentityVerifiedViaEnum = {
    SlackMagicLink: 'slack_magic_link',
    SmsOtp: 'sms_otp'
} as const;

export type ChannelIdentityVerifiedViaEnum = typeof ChannelIdentityVerifiedViaEnum[keyof typeof ChannelIdentityVerifiedViaEnum];

export interface ChannelListResponse {
    'channels'?: Array<ChannelResponse>;
}
export interface ChannelResponse {
    /**
     * Null for synthesized EMAIL entries
     */
    'id'?: number;
    'teamId'?: number;
    'type'?: ChannelResponseTypeEnum;
    'name'?: string;
    'status'?: ChannelResponseStatusEnum;
    /**
     * True for synthesized EMAIL entries (managed on the agent)
     */
    'readOnly'?: boolean;
    'externalId'?: string;
    /**
     * Non-secret channel config (SMS phone number, account SID)
     */
    'config'?: Record<string, any>;
    /**
     * Custom channel prompt; null means the default for the type applies
     */
    'channelPrompt'?: string;
    /**
     * The default prompt used when channelPrompt is not set
     */
    'defaultChannelPrompt'?: string;
    'secretsSet'?: Array<string>;
    'missingSecrets'?: Array<string>;
    'agents'?: Array<AgentChannelResponse>;
    /**
     * EMAIL entries only
     */
    'emailAddress'?: string;
    'createdAt'?: string;
    'updatedAt'?: string;
}

export const ChannelResponseTypeEnum = {
    Email: 'EMAIL',
    Slack: 'SLACK',
    Sms: 'SMS'
} as const;

export type ChannelResponseTypeEnum = typeof ChannelResponseTypeEnum[keyof typeof ChannelResponseTypeEnum];
export const ChannelResponseStatusEnum = {
    PendingSetup: 'pending_setup',
    Active: 'active',
    Disabled: 'disabled'
} as const;

export type ChannelResponseStatusEnum = typeof ChannelResponseStatusEnum[keyof typeof ChannelResponseStatusEnum];

export interface ChartConfig {
    'title': string;
    /**
     * Freeform description shown with the chart.
     */
    'description'?: string;
    'type': ChartConfigTypeEnum;
    'databasePath': string;
    'sql': string;
    'encoding': ChartEncoding;
    'options': Record<string, any>;
}

export const ChartConfigTypeEnum = {
    Bar: 'bar',
    Line: 'line',
    Area: 'area',
    Pie: 'pie',
    Donut: 'donut',
    Scatter: 'scatter',
    Radar: 'radar',
    Radialbar: 'radialbar'
} as const;

export type ChartConfigTypeEnum = typeof ChartConfigTypeEnum[keyof typeof ChartConfigTypeEnum];

export interface ChartDataResponse {
    'path': string;
    'config': ChartConfig;
    'databaseVersion': number;
    'cached': boolean;
    'columns': Array<string>;
    'rows': Array<Array<any>>;
    'page': number;
    'pageSize': number;
    'hasMore': boolean;
    'truncated': boolean;
}
export interface ChartEncoding {
    'x'?: string;
    'series'?: Array<string>;
    'value'?: string;
}
export interface ChartListResponse {
    'charts': Array<ChartSummary>;
}
export interface ChartResponse {
    'path': string;
    'config': ChartConfig;
}
export interface ChartSaveRequest {
    'path': string;
    'config': ChartConfig;
}
export interface ChartSummary {
    'path': string;
    'name': string;
    /**
     * User-facing title from inside the config JSON
     */
    'title': string;
    'fileId': number;
    'updatedAt': string;
}
/**
 * Typed system event published after a video commit. Media bytes remain behind the permission-checked content-file stream endpoint.
 */
export interface ChatArtifactCreatedEvent {
    'type': ChatArtifactCreatedEventTypeEnum;
    'messageId': number;
    'createdAt': string;
    'agentId': number;
    'artifact': ChatArtifactCreatedEventArtifact;
}

export const ChatArtifactCreatedEventTypeEnum = {
    ArtifactCreated: 'artifact_created'
} as const;

export type ChatArtifactCreatedEventTypeEnum = typeof ChatArtifactCreatedEventTypeEnum[keyof typeof ChatArtifactCreatedEventTypeEnum];

export interface ChatArtifactCreatedEventArtifact {
    'contentFileId': string;
    'name': string;
    'mediaType': ChatArtifactCreatedEventArtifactMediaTypeEnum;
    'availability': ChatArtifactCreatedEventArtifactAvailabilityEnum;
}

export const ChatArtifactCreatedEventArtifactMediaTypeEnum = {
    Video: 'video'
} as const;

export type ChatArtifactCreatedEventArtifactMediaTypeEnum = typeof ChatArtifactCreatedEventArtifactMediaTypeEnum[keyof typeof ChatArtifactCreatedEventArtifactMediaTypeEnum];
export const ChatArtifactCreatedEventArtifactAvailabilityEnum = {
    Active: 'active',
    Expired: 'expired',
    Deleted: 'deleted'
} as const;

export type ChatArtifactCreatedEventArtifactAvailabilityEnum = typeof ChatArtifactCreatedEventArtifactAvailabilityEnum[keyof typeof ChatArtifactCreatedEventArtifactAvailabilityEnum];

export interface ChatChangeReceipt {
    /**
     * Stable resource identity within an agent response
     */
    'id': string;
    'kind': ChatChangeReceiptKindEnum;
    'action': ChatChangeReceiptActionEnum;
    'title': string;
    /**
     * Authorized console-relative resource link
     */
    'href': string;
}

export const ChatChangeReceiptKindEnum = {
    Project: 'project',
    Card: 'card',
    Wiki: 'wiki',
    Database: 'database',
    Chart: 'chart',
    Dashboard: 'dashboard'
} as const;

export type ChatChangeReceiptKindEnum = typeof ChatChangeReceiptKindEnum[keyof typeof ChatChangeReceiptKindEnum];
export const ChatChangeReceiptActionEnum = {
    Created: 'created',
    Edited: 'edited'
} as const;

export type ChatChangeReceiptActionEnum = typeof ChatChangeReceiptActionEnum[keyof typeof ChatChangeReceiptActionEnum];

export interface ChatConversationListResponse {
    'conversations'?: Array<ChatConversationSummary>;
}
export interface ChatConversationParticipant {
    'userId'?: number;
    'name'?: string;
}
export interface ChatConversationSummary {
    'id'?: number;
    /**
     * First user message excerpt (\"New chat\" until one exists)
     */
    'title'?: string;
    'updatedAt'?: string;
    /**
     * Conversation channel (admin_web, scheduled_task, wiki_page)
     */
    'channel'?: string;
    'wikiPage'?: ChatConversationSummaryWikiPage;
    /**
     * Total USD cost of the conversation, or null when any included usage is unpriced
     */
    'totalCostUsd': number | null;
    'knownTotalCostUsd': number;
    'costPricingState': ChatConversationSummaryCostPricingStateEnum;
    'metricCount': number;
    /**
     * Team members with access to the conversation
     */
    'participants'?: Array<ChatConversationParticipant>;
}

export const ChatConversationSummaryCostPricingStateEnum = {
    Priced: 'priced',
    PartiallyUnpriced: 'partially_unpriced',
    Unpriced: 'unpriced',
    NoUsage: 'no_usage'
} as const;

export type ChatConversationSummaryCostPricingStateEnum = typeof ChatConversationSummaryCostPricingStateEnum[keyof typeof ChatConversationSummaryCostPricingStateEnum];

/**
 * Origin page of a wiki_page conversation (highlight-to-chat)
 */
export interface ChatConversationSummaryWikiPage {
    'projectId'?: number;
    'pagePath'?: string;
}
export interface ClaimDomainRequest {
    'domain': string;
}
export interface ClaimedDomain {
    'id': number;
    'domain': string;
    'verificationState': ClaimedDomainVerificationStateEnum;
    /**
     * The only login method permitted at this domain, once set.
     */
    'loginMode': ClaimedDomainLoginModeEnum;
    /**
     * The SAML connection this domain trusts. Null until an admin binds one; setting `loginMode` to \'saml\' is refused while this is null, since no login could ever complete.
     */
    'ssoConnectionId': number;
    'verifiedAt': string;
    'lastCheckedAt': string;
    /**
     * How many scheduled DNS rechecks in a row have failed to find the TXT record. Resets to 0 on any successful recheck. A tick count, not a duration — see `firstFailureAt` for how long the current streak has actually run, which is what decides the notice and removal schedule.
     */
    'consecutiveCheckFailures': number;
    /**
     * When the most recent failed recheck happened. Stays set after a disable, which is how a pending domain that lost verification is told apart from one that was never verified.
     */
    'lastFailureAt': string;
    /**
     * When the current run of consecutive failures began. Set on the first failure of a streak, left alone on every later failure in that same streak, and cleared back to null on the next successful recheck or on a disable. A verified domain gets a daily notice once this is at least 2 days in the past, and loses verification once it is at least 7 days in the past — so a caller can state the elapsed days and the removal date without doing arithmetic on `consecutiveCheckFailures`.
     */
    'firstFailureAt': string;
    /**
     * The DNS TXT record name the team must publish.
     */
    'recordName': string;
    /**
     * The exact TXT value verification checks for.
     */
    'recordValue': string;
    /**
     * Whether anyone authenticating at this verified domain is added to the team on every login.
     */
    'autoJoinEnabled': boolean;
    /**
     * Set only when auto-join grants a built-in role.
     */
    'autoJoinBuiltinRole': string;
    /**
     * Set only when auto-join grants a custom role.
     */
    'autoJoinRoleId': number;
    /**
     * The admin who last armed auto-join for this domain.
     */
    'autoJoinGrantedByUserId': number;
}

export const ClaimedDomainVerificationStateEnum = {
    Pending: 'pending',
    Verified: 'verified',
    Failed: 'failed'
} as const;

export type ClaimedDomainVerificationStateEnum = typeof ClaimedDomainVerificationStateEnum[keyof typeof ClaimedDomainVerificationStateEnum];
export const ClaimedDomainLoginModeEnum = {
    None: 'none',
    Saml: 'saml',
    Google: 'google',
    Passkey: 'passkey',
    Password: 'password'
} as const;

export type ClaimedDomainLoginModeEnum = typeof ClaimedDomainLoginModeEnum[keyof typeof ClaimedDomainLoginModeEnum];

export interface ContinueWorkStream201Response {
    'continuation': WorkStreamContinuationResult;
}
export interface ConversationListResponse {
    /**
     * List of conversations
     */
    'conversations'?: Array<ConversationResponse>;
    'pagination'?: ConversationListResponsePagination;
}
export interface ConversationListResponsePagination {
    /**
     * Limit applied
     */
    'limit'?: number;
    /**
     * Offset applied
     */
    'offset'?: number;
    /**
     * Total results returned
     */
    'total'?: number;
}
export interface ConversationResponse {
    /**
     * Unique identifier for the conversation
     */
    'id'?: number;
    /**
     * ID of the agent for this conversation
     */
    'agentId'?: number;
    /**
     * Subject of the conversation
     */
    'subject'?: string;
    /**
     * Creation timestamp
     */
    'createdAt'?: string;
    /**
     * Last update timestamp
     */
    'updatedAt'?: string;
    /**
     * The communication channel this conversation happened over
     */
    'channelType'?: ConversationResponseChannelTypeEnum;
    /**
     * ID of the channel this conversation belongs to (absent for email or deleted channels)
     */
    'channelId'?: number;
    /**
     * Participant identifiers (email address, phone number or Slack user id, with display name when known)
     */
    'thirdPartyEmails'?: Array<string>;
    /**
     * Structured values keyed by skill ID, outcome ID, and field name
     */
    'outcomes'?: Record<string, any>;
    /**
     * Number of messages in this conversation
     */
    'messageCount'?: number;
    /**
     * Exact total, or null when any included agent turn is unpriced
     */
    'totalCostUsd'?: number | null;
    'knownTotalCostUsd'?: number;
    'costPricingState'?: ConversationResponseCostPricingStateEnum;
    'metricCount'?: number;
}

export const ConversationResponseChannelTypeEnum = {
    Email: 'email',
    Slack: 'slack',
    Sms: 'sms'
} as const;

export type ConversationResponseChannelTypeEnum = typeof ConversationResponseChannelTypeEnum[keyof typeof ConversationResponseChannelTypeEnum];
export const ConversationResponseCostPricingStateEnum = {
    Priced: 'priced',
    PartiallyUnpriced: 'partially_unpriced',
    Unpriced: 'unpriced',
    NoUsage: 'no_usage'
} as const;

export type ConversationResponseCostPricingStateEnum = typeof ConversationResponseCostPricingStateEnum[keyof typeof ConversationResponseCostPricingStateEnum];

export interface ConversationTranscriptMessage {
    'changeReceipts'?: Array<ChatChangeReceipt>;
    'id'?: number;
    'role'?: string;
    'agentId'?: number;
    'agentName'?: string;
    'content'?: string;
    'thoughts'?: string;
    'status'?: string;
    'createdAt'?: string;
    /**
     * Tokens sent in the turn that produced this message
     */
    'tokensSent'?: number;
    /**
     * Tokens received in the turn that produced this message
     */
    'tokensReceived'?: number;
    /**
     * Fully burdened USD cost of the turn (null when unknown)
     */
    'costUsd'?: number;
    'systemEvent'?: ChatArtifactCreatedEvent | null;
}
export interface ConversationTranscriptResponse {
    'conversation'?: ConversationTranscriptResponseConversation;
    'card'?: ConversationTranscriptResponseCard;
    'wikiPage'?: ConversationTranscriptResponseWikiPage;
    'messages'?: Array<ConversationTranscriptMessage>;
}
/**
 * Present for project-card threads; links back to the card
 */
export interface ConversationTranscriptResponseCard {
    'id'?: number;
    'projectId'?: number;
    'title'?: string;
    /**
     * The card\'s agent roster, for @mention autocomplete
     */
    'agents'?: Array<ProjectAgentRef>;
}
export interface ConversationTranscriptResponseConversation {
    'id'?: number;
    'title'?: string;
    'channel'?: string;
    'agentParticipants'?: Array<ProjectAgentRef>;
}
/**
 * Present for wiki-origin chats (highlight-to-chat); links back to the page
 */
export interface ConversationTranscriptResponseWikiPage {
    'projectId'?: number;
    'pagePath'?: string;
    /**
     * Current page title; null if the page was moved or deleted
     */
    'title'?: string;
}
export interface CopyLoopTaskRequest {
    'name': string;
    'nextEligibleAt': string;
}
export interface CostBucket {
    /**
     * Bucket start (server UTC date_trunc)
     */
    'start': string;
    /**
     * Agent this slice belongs to
     */
    'agentId': number;
    /**
     * Exact USD cost when fully priced; null otherwise
     */
    'costUsd': number | null;
    'knownCostUsd': number;
    'pricingState': CostPricingState;
    'metricCount': number;
}


/**
 * Token spend split by direction over the same period and buckets as the cost timeseries. Output tokens are priced several times input, so output is a small share of token volume and a large share of cost; both series sit on one USD axis. Each direction is weighted by the rate recorded on the usage itself, so it reports what tokens cost and not what a provider-reported exact cost or a per-image/per-second media charge cost. Usage whose direction had no rate to price it appears in neither series and is counted in unpricedStatCount.
 */
export interface CostByDirection {
    'totalInputCostUsd': number;
    'totalOutputCostUsd': number;
    /**
     * Output cost as a percent of priced token cost; 0 when nothing was priced
     */
    'outputSharePercent': number;
    /**
     * Model stat entries with usage but no rate for one of their directions
     */
    'unpricedStatCount': number;
    /**
     * Sparse per-bucket direction costs; empty buckets are absent
     */
    'buckets': Array<CostDirectionBucket>;
}
export interface CostDirectionBucket {
    /**
     * Bucket start (server UTC date_trunc)
     */
    'start': string;
    /**
     * What this bucket\'s input tokens cost at their own rates
     */
    'inputCostUsd': number;
    /**
     * What this bucket\'s output tokens cost at their own rates
     */
    'outputCostUsd': number;
}
export interface CostHistoryBucket {
    'start': string;
    'end': string;
    'categories': CostHistoryCategoryValues;
    'totalUsd': string | null;
    /**
     * Exact decimal USD string, rounded half-up to at most 10 decimal places
     */
    'knownTotalUsd': string;
    'pricingState': CostHistoryBucketPricingStateEnum;
}

export const CostHistoryBucketPricingStateEnum = {
    Priced: 'priced',
    PartiallyUnpriced: 'partially_unpriced',
    Unpriced: 'unpriced'
} as const;

export type CostHistoryBucketPricingStateEnum = typeof CostHistoryBucketPricingStateEnum[keyof typeof CostHistoryBucketPricingStateEnum];

export interface CostHistoryCategoryValues {
    /**
     * Exact decimal USD string, rounded half-up to at most 10 decimal places
     */
    'ai_model': string;
    /**
     * Exact decimal USD string, rounded half-up to at most 10 decimal places
     */
    'compute': string;
    /**
     * Exact decimal USD string, rounded half-up to at most 10 decimal places
     */
    'storage': string;
    /**
     * Exact decimal USD string, rounded half-up to at most 10 decimal places
     */
    'backup': string;
    /**
     * Exact decimal USD string, rounded half-up to at most 10 decimal places
     */
    'network': string;
}
export interface CostHistoryDiagnostic {
    'code': CostHistoryDiagnosticCodeEnum;
    /**
     * Stable user-safe explanation with no provider, database, or placement identifiers
     */
    'message': string;
}

export const CostHistoryDiagnosticCodeEnum = {
    CapacityAllocationIdentityInvalid: 'capacity_allocation_identity_invalid',
    CapacityPlacementIdentityInvalid: 'capacity_placement_identity_invalid',
    CapacityPlacementResourcesInvalid: 'capacity_placement_resources_invalid',
    CapacityPlacementAgentUnattributed: 'capacity_placement_agent_unattributed'
} as const;

export type CostHistoryDiagnosticCodeEnum = typeof CostHistoryDiagnosticCodeEnum[keyof typeof CostHistoryDiagnosticCodeEnum];


export const CostHistoryRange = {
    _1d: '1d',
    _3d: '3d',
    _7d: '7d',
    _30d: '30d',
    _3m: '3m',
    _6m: '6m',
    _1y: '1y',
    _2y: '2y'
} as const;

export type CostHistoryRange = typeof CostHistoryRange[keyof typeof CostHistoryRange];


/**
 * Settled usage only; this endpoint never extrapolates beyond the window end
 */
export interface CostHistoryTimelineResponse {
    'range': CostHistoryRange;
    'start': string;
    'end': string;
    'buckets': Array<CostHistoryBucket>;
    'totalUsd': string | null;
    /**
     * Exact decimal USD string, rounded half-up to at most 10 decimal places
     */
    'knownTotalUsd': string;
    'pricingState': CostHistoryTimelineResponsePricingStateEnum;
    'categoryTotals': CostHistoryCategoryValues;
    'provenance': CostHistoryTimelineResponseProvenance;
}

export const CostHistoryTimelineResponsePricingStateEnum = {
    Priced: 'priced',
    PartiallyUnpriced: 'partially_unpriced',
    Unpriced: 'unpriced'
} as const;

export type CostHistoryTimelineResponsePricingStateEnum = typeof CostHistoryTimelineResponsePricingStateEnum[keyof typeof CostHistoryTimelineResponsePricingStateEnum];

export interface CostHistoryTimelineResponseProvenance {
    'pricing': string;
    'sharedCapacityAttribution': string;
    'rounding': string;
    /**
     * Stable, sanitized attribution diagnostics; raw values and identifiers are never included
     */
    'diagnostics': Array<CostHistoryDiagnostic>;
}

export const CostPricingState = {
    Priced: 'priced',
    PartiallyUnpriced: 'partially_unpriced',
    Unpriced: 'unpriced',
    NoUsage: 'no_usage'
} as const;

export type CostPricingState = typeof CostPricingState[keyof typeof CostPricingState];


export interface CostTimeseriesResponse {
    /**
     * The preset range that was queried
     */
    'range': string;
    /**
     * Bucket size the server chose for this range
     */
    'bucket': CostTimeseriesResponseBucketEnum;
    /**
     * Start of the queried period
     */
    'startDate': string;
    /**
     * End of the queried period
     */
    'endDate': string;
    /**
     * Exact total when fully priced; null if any eligible row has unknown cost
     */
    'totalCostUsd': number | null;
    'knownTotalCostUsd': number;
    'costPricingState': CostPricingState;
    'metricCount': number;
    /**
     * Per-agent totals over the period, highest cost first
     */
    'agents': Array<CostTimeseriesResponseAgentsInner>;
    /**
     * Sparse cost buckets; buckets with no priced activity are absent
     */
    'buckets': Array<CostBucket>;
    /**
     * Per-provider totals over the period, highest cost first
     */
    'providers': Array<CostTimeseriesResponseProvidersInner>;
    /**
     * Sparse per-provider cost buckets
     */
    'providerBuckets': Array<CostTimeseriesResponseProviderBucketsInner>;
    /**
     * Per-model totals over the period, highest cost first
     */
    'models': Array<CostTimeseriesResponseModelsInner>;
    /**
     * Sparse per-model cost buckets
     */
    'modelBuckets': Array<CostTimeseriesResponseModelBucketsInner>;
    'tokens': TokenTimeseries;
    'costByDirection': CostByDirection;
}

export const CostTimeseriesResponseBucketEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type CostTimeseriesResponseBucketEnum = typeof CostTimeseriesResponseBucketEnum[keyof typeof CostTimeseriesResponseBucketEnum];

export interface CostTimeseriesResponseAgentsInner {
    'agentId': number;
    'agentName': string;
    'totalCostUsd': number | null;
    'knownTotalCostUsd': number;
    'costPricingState': CostPricingState;
    'metricCount': number;
}


export interface CostTimeseriesResponseModelBucketsInner {
    'start': string;
    'model': string;
    'modelProvider': string;
    'costUsd': number | null;
    'knownCostUsd': number;
    'pricingState': CostPricingState;
    'metricCount': number;
}


export interface CostTimeseriesResponseModelsInner {
    'model': string;
    'modelProvider': string;
    'totalCostUsd': number | null;
    'knownTotalCostUsd': number;
    'costPricingState': CostPricingState;
    'metricCount': number;
}


export interface CostTimeseriesResponseProviderBucketsInner {
    'start': string;
    'provider': string;
    'costUsd': number | null;
    'knownCostUsd': number;
    'pricingState': CostPricingState;
    'metricCount': number;
}


export interface CostTimeseriesResponseProvidersInner {
    'provider': string;
    'totalCostUsd': number | null;
    'knownTotalCostUsd': number;
    'costPricingState': CostPricingState;
    'metricCount': number;
}


export interface CountryBlock {
    'id': string;
    'displayName': string;
    'description': string;
    'source': string;
    'asOf': string;
    'countries': Array<string>;
}
export interface CreateChannelRequest {
    'type': CreateChannelRequestTypeEnum;
    'name': string;
    'config'?: Record<string, any>;
    /**
     * Write-only secret values (SMS authToken)
     */
    'credentials'?: { [key: string]: string; };
    'channelPrompt'?: string;
    'agentIds'?: Array<number>;
}

export const CreateChannelRequestTypeEnum = {
    Slack: 'SLACK',
    Sms: 'SMS'
} as const;

export type CreateChannelRequestTypeEnum = typeof CreateChannelRequestTypeEnum[keyof typeof CreateChannelRequestTypeEnum];

export interface CreateConversationRequest {
    /**
     * ID of the agent for this conversation
     */
    'agentId': number;
    /**
     * Subject of the conversation
     */
    'subject'?: string;
    /**
     * Array of third party email addresses
     */
    'thirdPartyEmails'?: Array<string>;
}
export interface CreateCustomToolRequest {
    'name': string;
    'description': string;
    'spec': CustomToolSpec;
    'requiresApproval'?: boolean;
    'rateLimitPerDay'?: number;
}
export interface CreateLoopTaskRequest {
    'agentId': number;
    'kind': LoopKind;
    'name': string;
    'instructions': string;
    'completionCondition'?: string;
    'fixedDelaySeconds': number;
    'nextEligibleAt': string;
    'budgetAmountUsd': string;
    'budgetPeriod': LoopBudgetPeriod;
    'budgetMinimumStartUsd': string;
    'maximumIterations'?: number;
    'deadlineAt'?: string;
}


export interface CreateMessageNoteRequest {
    'noteType': MessageNoteType;
    /**
     * The text content of the note
     */
    'noteText': string;
    /**
     * For POI notes, whether this POI must pass for a test run to succeed
     */
    'poiRequired'?: boolean;
}


export interface CreateMessageRequest {
    /**
     * Type of the message
     */
    'messageType': string;
    /**
     * Unique identifier for the message
     */
    'uniqueId'?: string;
    /**
     * Text content of the message
     */
    'messageText': string;
    /**
     * Subject of the message
     */
    'subject'?: string;
    /**
     * Array of TO recipient email addresses
     */
    'toEmails'?: Array<string>;
    /**
     * FROM sender email address
     */
    'fromEmail'?: string;
    /**
     * Array of CC recipient email addresses
     */
    'ccEmails'?: Array<string>;
    /**
     * Array of third party email addresses (deprecated - use toEmails, fromEmail, ccEmails instead)
     */
    'thirdPartyEmails'?: Array<string>;
    /**
     * Vector embedding for the message
     */
    'embedding'?: Array<number>;
}
export interface CreateSkillRequest {
    'name': string;
    'description': string;
    'content': string;
    'requiredBundles'?: Array<string>;
    'activationMode': SkillActivationMode;
    'outcomes'?: Array<SkillOutcomeInput>;
}


export interface CreateSsoConnectionRequest {
    'displayName': string;
    'idpEntityId': string;
    'idpSsoUrl': string;
    'idpSloUrl'?: string;
    'logoutResponseIssuer'?: string;
    /**
     * PEM-encoded IdP signing certificates. At least one required.
     */
    'idpSigningCertificates': Array<string>;
    'spEntityId': string;
    /**
     * Optional. Omit it, and the credentials object, to have the SP key pair generated server-side so no private key is ever handled by an admin. Supply it only when the team must use a certificate their own PKI issued.
     */
    'spCertificatePem'?: string;
    'credentials'?: CreateSsoConnectionRequestCredentials;
    'attributeMapping'?: AttributeMapping;
    'wantAuthnResponseSigned'?: boolean;
    'identifierFormat'?: CreateSsoConnectionRequestIdentifierFormatEnum;
    'disableRequestedAuthnContext'?: boolean;
    'requireEncryptedAssertions'?: boolean;
}

export const CreateSsoConnectionRequestIdentifierFormatEnum = {
    Persistent: 'persistent',
    EmailAddress: 'emailAddress',
    Unspecified: 'unspecified',
    Transient: 'transient'
} as const;

export type CreateSsoConnectionRequestIdentifierFormatEnum = typeof CreateSsoConnectionRequestIdentifierFormatEnum[keyof typeof CreateSsoConnectionRequestIdentifierFormatEnum];

/**
 * Write-only. Never returned by this API.
 */
export interface CreateSsoConnectionRequestCredentials {
    'spPrivateKeyPem'?: string;
}
export interface CredentialSummary {
    /**
     * Unique identifier for the credentials
     */
    'id': number;
    /**
     * The type of tool these credentials are for
     */
    'type': string;
    /**
     * A user-friendly name for the credentials
     */
    'name': string;
}
export interface CreditCodeRedemptionResponse {
    'amountUsd': number;
    'balanceUsd': number;
    'fundingEntryId': number;
}
export interface CustomTool {
    'id'?: number;
    'agentId'?: number;
    'name'?: string;
    'description'?: string;
    'status'?: CustomToolStatusEnum;
    'spec'?: CustomToolSpec;
    'requiresApproval'?: boolean;
    'rateLimitPerDay'?: number;
    'createdBy'?: string;
    'createdAt'?: string;
    'updatedAt'?: string;
    /**
     * Secret keys that already have values stored
     */
    'secretsSet'?: Array<string>;
    /**
     * Declared secret keys still awaiting a value
     */
    'missingSecrets'?: Array<string>;
}

export const CustomToolStatusEnum = {
    PendingSetup: 'pending_setup',
    Active: 'active',
    Disabled: 'disabled'
} as const;

export type CustomToolStatusEnum = typeof CustomToolStatusEnum[keyof typeof CustomToolStatusEnum];

export interface CustomToolFunction {
    'name': string;
    'description': string;
    /**
     * JSON-schema-like parameters: {properties: {...}, required: [...]}
     */
    'parameters'?: Record<string, any>;
    'request': CustomToolFunctionRequest;
    /**
     * Optional dot path projecting the JSON response
     */
    'responsePick'?: string;
    'testResponse'?: any;
}
/**
 * HTTP request template with {{param.*}} and {{secret.*}} placeholders
 */
export interface CustomToolFunctionRequest {
    'method'?: CustomToolFunctionRequestMethodEnum;
    'url'?: string;
    'query'?: { [key: string]: string; };
    'headers'?: { [key: string]: string; };
    'body'?: any;
}

export const CustomToolFunctionRequestMethodEnum = {
    Get: 'GET',
    Post: 'POST',
    Put: 'PUT',
    Patch: 'PATCH',
    Delete: 'DELETE'
} as const;

export type CustomToolFunctionRequestMethodEnum = typeof CustomToolFunctionRequestMethodEnum[keyof typeof CustomToolFunctionRequestMethodEnum];

/**
 * Declarative HTTP tool definition
 */
export interface CustomToolSpec {
    'functions': Array<CustomToolFunction>;
    'secretFields'?: Array<CustomToolSpecSecretFieldsInner>;
}
export interface CustomToolSpecSecretFieldsInner {
    /**
     * UPPER_SNAKE_CASE key referenced as {{secret.KEY}}
     */
    'key'?: string;
    /**
     * Label shown when entering the value
     */
    'label'?: string;
}
export interface DashboardConfig {
    'title': string;
    /**
     * Freeform description shown under the dashboard title.
     */
    'description'?: string;
    'layout': Array<DashboardTile>;
    'options': Record<string, any>;
}
export interface DashboardListResponse {
    'dashboards': Array<ChartSummary>;
}
export interface DashboardResponse {
    'path': string;
    'config': DashboardConfig;
}
export interface DashboardSaveRequest {
    'path': string;
    'config': DashboardConfig;
}
export interface DashboardTile {
    'chartPath': string;
    /**
     * Tile width in 12ths of a row (1-12)
     */
    'w': number;
    /**
     * Tile height in pixels
     */
    'h': number;
}
export interface DatabaseColumn {
    'name': string;
    'type': string;
    'notNull': boolean;
    'primaryKey': boolean;
}
export interface DatabaseFileDeleteResponse {
    'deleted': boolean;
}
export interface DatabaseForeignKey {
    'column': string;
    'table': string;
    'toColumn': string;
}
export interface DatabaseListResponse {
    'databases': Array<DatabaseSummary>;
}
export interface DatabaseQueryRequest {
    'path': string;
    'sql': string;
    'page'?: number;
    'pageSize'?: number;
}
export interface DatabaseQueryResponse {
    'columns': Array<string>;
    'rows': Array<Array<any>>;
    'page': number;
    'pageSize': number;
    'hasMore': boolean;
    'truncated': boolean;
    /**
     * Total rows the query yields across all pages.
     */
    'totalRows'?: number;
}
export interface DatabaseSchemaResponse {
    'tables': Array<DatabaseTable>;
    'notes'?: string;
}
export interface DatabaseSummary {
    'path': string;
    'name': string;
    'fileId': number;
    'sizeBytes': number;
    'versionCount': number;
    'latestVersion': number;
    'updatedAt': string;
}
export interface DatabaseTable {
    'name': string;
    'columns': Array<DatabaseColumn>;
    'foreignKeys': Array<DatabaseForeignKey>;
    'rowCount': number;
}
export interface DatabaseVersion {
    'versionNumber': number;
    'sizeBytes': number;
    'createdAt': string;
}
export interface DatabaseVersionsResponse {
    'versions': Array<DatabaseVersion>;
}
export interface DelegationSuccessorSelection {
    'teamId': number;
    'successorUserId': number;
}
export interface DeleteAgentRequest {
    /**
     * Required when the current deletion impact contains any orphan secrets.
     */
    'secretImpactToken'?: string;
}
export interface DeleteKnowledgeGraphEdge200Response {
    'message'?: string;
}
export interface DeleteKnowledgeGraphNode200Response {
    'message'?: string;
}
export interface DependencyCardSummary {
    'id': number;
    'reference': string;
    'title': string;
    'done': boolean;
}
export interface DisabledModelCapabilities {
    'disabledModelCapabilities': Array<ModelCapability>;
}
/**
 * Overrides an agent paused by reverting a slot to the team default, keyed by model slot. A slot absent here has nothing paused. The agent\'s own model_* fields always hold the EFFECTIVE policy; this is only what the Model screen would put back if the reader chooses to override again.
 */
export interface DormantModelOverrides {
    'interaction'?: ModelSlotPolicy;
    'knowledgeExtraction'?: ModelSlotPolicy;
    'live'?: VoiceTalkConfig;
    'imageGeneration'?: ModelSlotPolicy;
    'speechGeneration'?: ModelSlotPolicy;
    'musicGeneration'?: ModelSlotPolicy;
    'videoGeneration'?: ModelSlotPolicy;
    'videoInspection'?: ModelSlotPolicy;
}
export interface DriveActor {
    'userId'?: number;
    'agentId'?: number;
}
export interface DriveBreadcrumb {
    'id'?: number;
    'name'?: string;
}
export interface DriveCardLinkRequest {
    'cardId': number;
}
export interface DriveCardLinkResponse {
    'fileId'?: number;
    'cardId'?: number;
}
export interface DriveFile {
    'id'?: number;
    'projectId'?: number;
    'folderId'?: number;
    'name'?: string;
    'shared'?: boolean;
    'state'?: DriveFileStateEnum;
    'expiresAt'?: string | null;
    'expiredAt'?: string | null;
    'serverTime'?: string;
    'provenance'?: DriveFileProvenance;
    'createdBy'?: DriveActor;
    'createdAt'?: string;
    'updatedAt'?: string;
}

export const DriveFileStateEnum = {
    Active: 'active',
    Expired: 'expired',
    Deleting: 'deleting',
    Deleted: 'deleted'
} as const;

export type DriveFileStateEnum = typeof DriveFileStateEnum[keyof typeof DriveFileStateEnum];

export interface DriveFileEntry {
    'id'?: number;
    'projectId'?: number;
    'folderId'?: number;
    'name'?: string;
    'shared'?: boolean;
    'state'?: DriveFileEntryStateEnum;
    'expiresAt'?: string | null;
    'expiredAt'?: string | null;
    'serverTime'?: string;
    'provenance'?: DriveFileProvenance;
    'createdBy'?: DriveActor;
    'createdAt'?: string;
    'updatedAt'?: string;
    'sizeBytes'?: number;
    'sha256'?: string;
    'mimeType'?: string;
    'versionCount'?: number;
    'latestVersion'?: number;
}

export const DriveFileEntryStateEnum = {
    Active: 'active',
    Expired: 'expired',
    Deleting: 'deleting',
    Deleted: 'deleted'
} as const;

export type DriveFileEntryStateEnum = typeof DriveFileEntryStateEnum[keyof typeof DriveFileEntryStateEnum];

export interface DriveFileLifecycleRequest {
    'expiresAt': string | null;
}
export interface DriveFileLinksResponse {
    'files'?: Array<DriveLinkedFile>;
}
export interface DriveFileProvenance {
    'kind': DriveFileProvenanceKindEnum;
    'sourceContentFileId': string | null;
    'copiedBy': DriveActor;
}

export const DriveFileProvenanceKindEnum = {
    Uploaded: 'uploaded',
    ContentCopy: 'content_copy'
} as const;

export type DriveFileProvenanceKindEnum = typeof DriveFileProvenanceKindEnum[keyof typeof DriveFileProvenanceKindEnum];

export interface DriveFileResponse {
    'file'?: DriveFile;
}
export interface DriveFileUpdateRequest {
    'name'?: string;
    'folderId'?: number;
}
export interface DriveFolder {
    'id'?: number;
    'projectId'?: number;
    'parentId'?: number;
    'name'?: string;
    'shared'?: boolean;
    'createdBy'?: DriveActor;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface DriveFolderCreateRequest {
    'projectId': number;
    'parentId'?: number;
    'name': string;
}
export interface DriveFolderResponse {
    'folder'?: DriveFolder;
}
export interface DriveFolderUpdateRequest {
    'name'?: string;
    'parentId'?: number;
}
export interface DriveLinkedFile {
    'id'?: number;
    'projectId'?: number;
    'folderId'?: number;
    'name'?: string;
    'shared'?: boolean;
    'state'?: DriveLinkedFileStateEnum;
    'expiresAt'?: string;
    'expiredAt'?: string;
    'serverTime'?: string;
    'provenance'?: DriveFileProvenance;
    'createdBy'?: DriveActor;
    'createdAt'?: string;
    'updatedAt'?: string;
    'sizeBytes'?: number;
    'sha256'?: string;
    'mimeType'?: string;
    'versionCount'?: number;
    'latestVersion'?: number;
    'linkedAt'?: string;
}

export const DriveLinkedFileStateEnum = {
    Active: 'active',
    Expired: 'expired',
    Deleting: 'deleting',
    Deleted: 'deleted'
} as const;

export type DriveLinkedFileStateEnum = typeof DriveLinkedFileStateEnum[keyof typeof DriveLinkedFileStateEnum];

export interface DriveListResponse {
    'folders'?: Array<DriveFolder>;
    'files'?: Array<DriveFileEntry>;
    'breadcrumbs'?: Array<DriveBreadcrumb>;
}
export interface DriveRoot {
    'id'?: number;
    'name'?: string;
    'key'?: string;
}
export interface DriveRootsResponse {
    'projects'?: Array<DriveRoot>;
}
export interface DriveSearchResponse {
    'results'?: Array<DriveSearchResult>;
}
export interface DriveSearchResult {
    'id'?: number;
    'projectId'?: number;
    'folderId'?: number;
    'name'?: string;
    'shared'?: boolean;
    'state'?: DriveSearchResultStateEnum;
    'expiresAt'?: string;
    'expiredAt'?: string;
    'serverTime'?: string;
    'provenance'?: DriveFileProvenance;
    'createdBy'?: DriveActor;
    'createdAt'?: string;
    'updatedAt'?: string;
    'sizeBytes'?: number;
    'sha256'?: string;
    'mimeType'?: string;
    'versionCount'?: number;
    'latestVersion'?: number;
    'projectName'?: string;
}

export const DriveSearchResultStateEnum = {
    Active: 'active',
    Expired: 'expired',
    Deleting: 'deleting',
    Deleted: 'deleted'
} as const;

export type DriveSearchResultStateEnum = typeof DriveSearchResultStateEnum[keyof typeof DriveSearchResultStateEnum];

export interface DriveShareResponse {
    'shareToken'?: string;
    'url'?: string;
}
export interface DriveVersion {
    'id'?: number;
    'fileId'?: number;
    'versionNumber'?: number;
    'sizeBytes'?: number;
    'sha256'?: string;
    'mimeType'?: string;
    'uploadedByUserId'?: number;
    'uploadedByAgentId'?: number;
    'createdAt'?: string;
}
export interface DriveVersionsResponse {
    'versions'?: Array<DriveVersion>;
}
export interface EdgeResponse {
    /**
     * Unique identifier for the edge
     */
    'id': number;
    /**
     * Name of the edge (derived from edge type)
     */
    'name': string;
    /**
     * ID of the parent node
     */
    'parentNode': number;
    /**
     * ID of the child node
     */
    'childNode': number;
}
export interface EffectivePermissions {
    /**
     * resource -> highest level held. An absent resource means no access. Levels are \'view\', \'edit\' or \'manage\'. project_comment (Card comments) uses edit for archiving and manage for permanent deletion of archived comments. Only direct humans may reveal or delete archived comments. 
     */
    'team': { [key: string]: string; };
    /**
     * Keyed by project id; limited to the caller\'s visible boards
     */
    'projects': { [key: string]: { [key: string]: string; }; };
}

export const EffectivePermissionsTeamEnum = {
    View: 'view',
    Edit: 'edit',
    Manage: 'manage'
} as const;

export type EffectivePermissionsTeamEnum = typeof EffectivePermissionsTeamEnum[keyof typeof EffectivePermissionsTeamEnum];
export const EffectivePermissionsProjectsEnum = {
    View: 'view',
    Edit: 'edit',
    Manage: 'manage'
} as const;

export type EffectivePermissionsProjectsEnum = typeof EffectivePermissionsProjectsEnum[keyof typeof EffectivePermissionsProjectsEnum];

export interface EgressDecisionView {
    'destination'?: string;
    'action'?: EgressDecisionViewActionEnum;
    'reason'?: string;
    'hitCount'?: number;
    'lastSeenAt'?: string;
}

export const EgressDecisionViewActionEnum = {
    Allowed: 'allowed',
    Blocked: 'blocked'
} as const;

export type EgressDecisionViewActionEnum = typeof EgressDecisionViewActionEnum[keyof typeof EgressDecisionViewActionEnum];

export interface EgressPortRuleView {
    'id': number;
    'ruleType': string;
    'protocol': EgressPortRuleViewProtocolEnum;
    'portStart': number;
    'portEnd': number;
    'portDisplay': string;
    'destination'?: string;
    'workspaceId': number;
    'source': EgressPortRuleViewSourceEnum;
    'label': string;
}

export const EgressPortRuleViewProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp',
    Icmp: 'icmp'
} as const;

export type EgressPortRuleViewProtocolEnum = typeof EgressPortRuleViewProtocolEnum[keyof typeof EgressPortRuleViewProtocolEnum];
export const EgressPortRuleViewSourceEnum = {
    Request: 'request',
    Manual: 'manual'
} as const;

export type EgressPortRuleViewSourceEnum = typeof EgressPortRuleViewSourceEnum[keyof typeof EgressPortRuleViewSourceEnum];

export interface EgressRuleRemovalImpact {
    'rule': EgressPortRuleView;
    'affectedWorkspaceCount': number;
}
export interface EmailAccountAttachment {
    'id': string;
    'filename': string;
    'originalFilename'?: string;
    'mimeType': string;
    'size': number;
    'contentId'?: string;
    'disposition': EmailAccountAttachmentDispositionEnum;
}

export const EmailAccountAttachmentDispositionEnum = {
    Attachment: 'attachment',
    Inline: 'inline'
} as const;

export type EmailAccountAttachmentDispositionEnum = typeof EmailAccountAttachmentDispositionEnum[keyof typeof EmailAccountAttachmentDispositionEnum];

export interface EmailAccountIdentity {
    'name'?: string;
    'emailAddress': string;
}
export interface EmailAccountPage {
    'messages': Array<EmailAccountRecord>;
    'nextCursor'?: string;
    'hasNewer': boolean;
}
export interface EmailAccountRecord {
    'schemaVersion': EmailAccountRecordSchemaVersionEnum;
    'id': string;
    'teamId': number;
    'agentId': number;
    'direction': EmailAccountRecordDirectionEnum;
    'status': EmailAccountRecordStatusEnum;
    'observedAt': string;
    'sourceAt'?: string;
    'from': EmailAccountIdentity;
    'replyTo'?: EmailAccountIdentity;
    'to': Array<EmailAccountIdentity>;
    'cc': Array<EmailAccountIdentity>;
    'bcc': Array<EmailAccountIdentity>;
    'subject': string;
    'text'?: string;
    'html'?: string;
    /**
     * Original header block exactly as received from the mail provider
     */
    'rawHeaders'?: string;
    'headers': Array<string>;
    'messageId': string;
    'inReplyTo'?: string;
    'references': Array<string>;
    'inboundMetadata'?: { [key: string]: string; };
    'processingStatus'?: EmailAccountRecordProcessingStatusEnum;
    'processingDetail'?: string;
    'failureDetail'?: string;
    'attachments': Array<EmailAccountAttachment>;
}

export const EmailAccountRecordSchemaVersionEnum = {
    NUMBER_1: 1
} as const;

export type EmailAccountRecordSchemaVersionEnum = typeof EmailAccountRecordSchemaVersionEnum[keyof typeof EmailAccountRecordSchemaVersionEnum];
export const EmailAccountRecordDirectionEnum = {
    Inbound: 'inbound',
    Outbound: 'outbound'
} as const;

export type EmailAccountRecordDirectionEnum = typeof EmailAccountRecordDirectionEnum[keyof typeof EmailAccountRecordDirectionEnum];
export const EmailAccountRecordStatusEnum = {
    Received: 'received',
    Pending: 'pending',
    Sent: 'sent',
    Failed: 'failed'
} as const;

export type EmailAccountRecordStatusEnum = typeof EmailAccountRecordStatusEnum[keyof typeof EmailAccountRecordStatusEnum];
export const EmailAccountRecordProcessingStatusEnum = {
    Queued: 'queued',
    Processed: 'processed',
    Blocked: 'blocked',
    Skipped: 'skipped',
    Failed: 'failed'
} as const;

export type EmailAccountRecordProcessingStatusEnum = typeof EmailAccountRecordProcessingStatusEnum[keyof typeof EmailAccountRecordProcessingStatusEnum];

export interface EmailAccountSendFailure {
    'error': string;
    'recordId'?: string;
}
export interface EmailValidationResponse {
    /**
     * Whether the email is available for use
     */
    'available': boolean;
    /**
     * Message explaining the availability status
     */
    'message': string;
}
export interface ErrorResponse {
    /**
     * Error message
     */
    'error': string;
    /**
     * Error message
     */
    'message'?: string;
}
/**
 * All three null means no external communications role is set.
 */
export interface ExternalRole {
    'builtinRole': string;
    'roleId': number;
    'roleName': string;
}
/**
 * Exactly one of builtinRole / roleId to set; omit both (or send `{}`) to clear. 
 */
export interface ExternalRoleInput {
    /**
     * Administrator is never valid here — it cannot be an external communications role.
     */
    'builtinRole'?: ExternalRoleInputBuiltinRoleEnum;
    'roleId'?: number;
}

export const ExternalRoleInputBuiltinRoleEnum = {
    Manager: 'manager',
    Contributor: 'contributor',
    Viewer: 'viewer',
    Billing: 'billing'
} as const;

export type ExternalRoleInputBuiltinRoleEnum = typeof ExternalRoleInputBuiltinRoleEnum[keyof typeof ExternalRoleInputBuiltinRoleEnum];

export interface ExternalWorkLaunchRequest {
    'agentId': number;
}
export interface ExternalWorkLaunchResponse {
    /**
     * Short-lived single-use launch reference
     */
    'reference': string;
    'mcpUrl': string;
    'session': ExternalWorkSession;
}
export interface ExternalWorkReasonRequest {
    'reason'?: string;
}
export interface ExternalWorkSession {
    'id': number;
    'userId': number;
    'authorizingUserName'?: string;
    'teamId': number;
    'projectId': number;
    'cardId': number;
    'cardReference'?: string;
    'cardTitle'?: string;
    'agentId': number;
    'agentName'?: string;
    'conversationId': number;
    'client'?: string;
    'clientVersion'?: string;
    'reportedModel'?: string;
    'status': ExternalWorkSessionStatusEnum;
    'leaseExpiresAt'?: string;
    'createdAt'?: string;
    'claimedAt'?: string;
    'submittedAt'?: string;
    'closedAt'?: string;
    'closeReason'?: string;
}

export const ExternalWorkSessionStatusEnum = {
    PendingClaim: 'pending_claim',
    Active: 'active',
    WaitingForEvent: 'waiting_for_event',
    WaitingForUser: 'waiting_for_user',
    Paused: 'paused',
    Submitted: 'submitted',
    Cancelled: 'cancelled',
    Revoked: 'revoked',
    Expired: 'expired',
    Failed: 'failed'
} as const;

export type ExternalWorkSessionStatusEnum = typeof ExternalWorkSessionStatusEnum[keyof typeof ExternalWorkSessionStatusEnum];

export interface ExternalWorkSessionResponse {
    'session': ExternalWorkSession;
}
export interface ForceCompactAgentResult {
    'agentId': number;
    'agentName': string;
    /**
     * False when the agent\'s history already fits the keep tail
     */
    'compacted': boolean;
    /**
     * The persisted system marker row rendered as the divider
     */
    'markerMessageId'?: number;
    /**
     * What the summarize call(s) cost, when usage was reported
     */
    'costUsd'?: number;
}
export interface ForceCompactResponse {
    'results'?: Array<ForceCompactAgentResult>;
}
export interface FormAssistHandoffRequest {
    'formType': FormAssistHandoffRequestFormTypeEnum;
    /**
     * The name as submitted, which may differ from the agent\'s draft
     */
    'name': string;
    /**
     * Human reference for the new record, e.g. \"#LIG-5\" or a project key
     */
    'reference'?: string;
}

export const FormAssistHandoffRequestFormTypeEnum = {
    Card: 'card',
    Epic: 'epic',
    Sprint: 'sprint',
    Column: 'column',
    Project: 'project',
    ScheduledTask: 'scheduled_task',
    Loop: 'loop',
    Agent: 'agent'
} as const;

export type FormAssistHandoffRequestFormTypeEnum = typeof FormAssistHandoffRequestFormTypeEnum[keyof typeof FormAssistHandoffRequestFormTypeEnum];

export interface FormAssistHandoffResponse {
    /**
     * False when the conversation was already promoted (no notice posted)
     */
    'handedOff'?: boolean;
}
export interface GetExternalWorkSession200Response {
    'session': ExternalWorkSession;
    'mcpUrl': string;
}
export interface GetKnowledgeGraph200Response {
    'nodes'?: Array<NodeResponse>;
    'edges'?: Array<EdgeResponse>;
}
export interface GetLatestTeamChatConversationWorkStream200Response {
    'workStream': WorkStreamSummary;
}
export interface GetWorkStream200Response {
    'workStream': WorkStreamDetail;
}
export interface GetWorkStreamFile200Response {
    'file': WorkStreamFileDetail;
}
export interface GetWorkStreamSkill200Response {
    'skill': WorkStreamSkillActivationDetail;
}
export interface GetWorkStreamWorkSummary200Response {
    'summary': WorkStreamWorkSummary;
}
export interface GrantBreakGlassRequest {
    'userIds': Array<number>;
    'reason': string;
    'expiresAt': string;
}
export interface GuideWorkStream201Response {
    'guidance': WorkStreamGuidanceResult;
}
export interface ImportSkillRequest {
    'slug': string;
    'provider'?: string;
    'name'?: string;
}
export interface ImportSkillResult {
    'status'?: ImportSkillResultStatusEnum;
    'skill'?: Skill;
}

export const ImportSkillResultStatusEnum = {
    Created: 'created'
} as const;

export type ImportSkillResultStatusEnum = typeof ImportSkillResultStatusEnum[keyof typeof ImportSkillResultStatusEnum];

/**
 * Exactly one of metadataUrl or metadataXml is required. metadataUrl is fetched server-side through the SSRF-guarded connect path used elsewhere in the platform; metadataXml is parsed as-is (the only option for an IdP, such as Keycloak, that publishes no metadata URL at all).
 */
export interface ImportSsoMetadataRequest {
    /**
     * An identity provider\'s published federation metadata URL, e.g. https://login.microsoftonline.com/{tenant}/FederationMetadata/2007-06/FederationMetadata.xml
     */
    'metadataUrl'?: string;
    /**
     * A pasted federation metadata XML document.
     */
    'metadataXml'?: string;
}
export interface InitiateGoogleDriveOAuth200Response {
    /**
     * The Google authorization URL to redirect the user to
     */
    'url': string;
}
export interface InitiateGoogleDriveOAuthRequest {
    /**
     * The URL to redirect the user back to after the OAuth flow
     */
    'redirectUrl': string;
}
export interface InlineObject {
    'maskedPhoneNumber': string;
}
/**
 * Built-in role the invite will confer on acceptance. Administrator is team-scope only, and only an administrator may set it.
 */

export const InviteBuiltinRole = {
    Administrator: 'administrator',
    Manager: 'manager',
    Contributor: 'contributor',
    Viewer: 'viewer',
    Billing: 'billing'
} as const;

export type InviteBuiltinRole = typeof InviteBuiltinRole[keyof typeof InviteBuiltinRole];


export interface InviteRole {
    'teamId': number;
    'emailAddress': string;
    'builtinRole'?: InviteBuiltinRole;
    'roleId'?: number;
    'scopeType': InviteScopeType;
    'projectId'?: number;
    /**
     * Display name of the role, resolved server-side
     */
    'roleName'?: string;
}


/**
 * Exactly one of builtinRole or roleId must be provided. camelCase only — a caller sending builtin_role has sent no role and gets a 400.
 */
export interface InviteRoleInput {
    'builtinRole'?: InviteBuiltinRole;
    'roleId'?: number;
    'scopeType': InviteScopeType;
    /**
     * Required iff scopeType is \'project\'
     */
    'projectId'?: number;
}


/**
 * Whether the grant is team-wide or pinned to one project. A team-scoped grant reaches every project, present and future.
 */

export const InviteScopeType = {
    Team: 'team',
    Project: 'project'
} as const;

export type InviteScopeType = typeof InviteScopeType[keyof typeof InviteScopeType];


/**
 * Reference to Job entity from jobs API
 */
export interface Job {
    /**
     * Unique identifier for the job
     */
    'id'?: number;
    /**
     * Display name of the job
     */
    'name'?: string;
    /**
     * Current status of the job
     */
    'status'?: JobStatusEnum;
    /**
     * Detailed status description
     */
    'statusDescription'?: string;
    /**
     * Total number of tasks in the job
     */
    'totalTasksCount'?: number;
    /**
     * Number of completed tasks
     */
    'totalTasksCompleteCount'?: number;
    /**
     * Job creation timestamp
     */
    'createdAt'?: string;
    /**
     * Job completion timestamp
     */
    'completedAt'?: string;
}

export const JobStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Complete: 'complete',
    Error: 'error',
    CancelRequested: 'cancel_requested',
    Canceled: 'canceled'
} as const;

export type JobStatusEnum = typeof JobStatusEnum[keyof typeof JobStatusEnum];

export interface JobItem {
    /**
     * Unique identifier for the job
     */
    'id': number;
    /**
     * Name of the job
     */
    'name': string;
    /**
     * Description of the current job status
     */
    'statusDescription'?: string;
    /**
     * ID of the associated agent (if any)
     */
    'agentId'?: number;
    /**
     * Name of the associated agent (if any)
     */
    'agentName'?: string;
    /**
     * ID of the team the job belongs to
     */
    'teamId': number;
    /**
     * Name of the team the job belongs to
     */
    'teamName'?: string;
    /**
     * ID of the associated metric (if any)
     */
    'metricId'?: number;
    /**
     * Total number of tasks in the job
     */
    'totalTasksCount': number;
    /**
     * Number of completed tasks
     */
    'totalTasksCompleteCount': number;
    /**
     * Current status of the job
     */
    'status': JobItemStatusEnum;
    /**
     * Error message (if job status is error)
     */
    'errorMessage'?: string;
    /**
     * When the job was created
     */
    'createdAt': string;
    /**
     * When the job was completed (if completed)
     */
    'completedAt'?: string;
    /**
     * When the job was started (if started)
     */
    'startedAt'?: string;
}

export const JobItemStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Complete: 'complete',
    Error: 'error',
    CancelRequested: 'cancel_requested',
    Canceled: 'canceled'
} as const;

export type JobItemStatusEnum = typeof JobItemStatusEnum[keyof typeof JobItemStatusEnum];

export interface JobReference {
    /**
     * Unique identifier for the job
     */
    'id': number;
    /**
     * Name of the job
     */
    'name': string;
    /**
     * Current status of the job
     */
    'status': JobReferenceStatusEnum;
    /**
     * Total number of tasks in the job
     */
    'totalTasksCount'?: number;
    /**
     * Number of completed tasks
     */
    'totalTasksCompleteCount'?: number;
    /**
     * When the job was created
     */
    'createdAt'?: string;
}

export const JobReferenceStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Completed: 'completed',
    Error: 'error'
} as const;

export type JobReferenceStatusEnum = typeof JobReferenceStatusEnum[keyof typeof JobReferenceStatusEnum];

export interface JobResponse {
    /**
     * Job details
     */
    'job': JobItem;
    /**
     * Associated metric (if any)
     */
    'metric'?: MetricReference;
}
export interface JobsResponse {
    /**
     * Array of job records
     */
    'jobs': Array<JobItem>;
    /**
     * Total count of jobs
     */
    'totalCount': number;
}
export interface KnowledgeGraphQueryRequest {
    /**
     * The GQL query to execute against the knowledge graph
     */
    'query': string;
    /**
     * Optional array of source IDs to query against. If not provided, all sources available to the agent will be used.
     */
    'sourceIds'?: Array<number>;
    /**
     * Optional search text to incorporate into the query
     */
    'searchText'?: string;
    /**
     * Whether to include disabled nodes in the search results
     */
    'includeDisabled'?: boolean;
}
/**
 * The response from a knowledge graph query
 */
export interface KnowledgeGraphQueryResponse {
    /**
     * Array of graph nodes matching the query
     */
    'nodes'?: Array<KnowledgeGraphQueryResponseNodesInner>;
    /**
     * Array of graph edges matching the query
     */
    'edges'?: Array<KnowledgeGraphQueryResponseEdgesInner>;
}
export interface KnowledgeGraphQueryResponseEdgesInner {
    /**
     * Unique identifier for the edge
     */
    'id': number;
    /**
     * the name of the edge
     */
    'name': string;
    'parentNode': KnowledgeGraphQueryResponseEdgesInnerParentNode;
    'childNode': KnowledgeGraphQueryResponseEdgesInnerChildNode;
}
/**
 * Child node of the edge
 */
export interface KnowledgeGraphQueryResponseEdgesInnerChildNode {
    'id'?: number;
    'name'?: string;
}
/**
 * Parent node of the edge
 */
export interface KnowledgeGraphQueryResponseEdgesInnerParentNode {
    'id'?: number;
    'name'?: string;
}
export interface KnowledgeGraphQueryResponseNodesInner {
    /**
     * Unique identifier for the node
     */
    'id': number;
    /**
     * Whether the node will be readable by the agent
     */
    'enabled': boolean;
    /**
     * Name of the node
     */
    'name': string;
    /**
     * Name of the node type
     */
    'nodeTypeName': string;
    /**
     * Last update timestamp
     */
    'updatedAt': string;
    /**
     * Creation timestamp
     */
    'createdAt': string;
    'nodeType': KnowledgeGraphQueryResponseNodesInnerNodeType;
}
/**
 * Type of the node
 */
export interface KnowledgeGraphQueryResponseNodesInnerNodeType {
    'id'?: number;
    'name'?: string;
}
export interface KnowledgeGraphTypesChanges {
    /**
     * Changes to node types
     */
    'nodeTypes'?: TypeChanges;
    /**
     * Changes to edge types
     */
    'edgeTypes'?: TypeChanges;
    /**
     * Changes to node feature types
     */
    'nodeFeatureTypes'?: TypeChanges;
}
export interface KnowledgeGraphTypesValidationResult {
    /**
     * Whether the YAML is valid
     */
    'valid': boolean;
    /**
     * Error message if validation failed
     */
    'error'?: string;
    /**
     * Analysis of changes if validation succeeded
     */
    'changes'?: KnowledgeGraphTypesChanges;
}
export interface KnowledgeSearchRequest {
    /**
     * The search query
     */
    'query': string;
    /**
     * Description of the information being sought
     */
    'informationSought': string;
    /**
     * Array of source IDs to search
     */
    'sourceIds': Array<number>;
    /**
     * Maximum number of matches to return
     */
    'maxMatches'?: number;
    /**
     * Number of top results to re-rank with LLM for improved relevance. Set to 0 to disable re-ranking.
     */
    'rerankingCount'?: number;
    /**
     * Optional graph query for advanced searching
     */
    'graphQuery'?: string;
    /**
     * Whether to include disabled nodes in the search results
     */
    'includeDisabled'?: boolean;
}
/**
 * A read-only preview of what a Slack magic-link token would bind (C1 fix, final review) — never consumes the token. `expired` covers both an expired and an already-consumed token; either way there is nothing left to confirm. 
 */
export interface LinkTokenPeek {
    'kind': LinkTokenPeekKindEnum;
    /**
     * The Slack user id or E.164 phone number the token is bound to.
     */
    'value': string;
    /**
     * The sender\'s display name, captured at issue time. Null for tokens issued before this existed. 
     */
    'displayName': string;
    'expired': boolean;
}

export const LinkTokenPeekKindEnum = {
    SlackUser: 'slack_user',
    Phone: 'phone'
} as const;

export type LinkTokenPeekKindEnum = typeof LinkTokenPeekKindEnum[keyof typeof LinkTokenPeekKindEnum];

export interface ListCardNextActions200Response {
    'nextActions': Array<CardNextActionView>;
}
export interface ListCardWorkStreams200Response {
    'workStreams': Array<WorkStreamSummary>;
}
export interface ListConversationVoiceOptions200Response {
    'agents': Array<VoiceAgentOption>;
}
export interface ListExternalWorkSessionsForCard200Response {
    'sessions': Array<ExternalWorkSession>;
}
export interface ListTeamSecrets200Response {
    'items': Array<TeamSecretListItem>;
}
export interface ListVoiceProfiles200Response {
    'profiles': Array<VoiceProfileAvailability>;
}
export interface ListWorkStreamBrowserFrames200Response {
    'frames': BrowserTimelinePage;
}
export interface ListWorkStreamEvents200Response {
    'events': WorkStreamEventPage;
}
export interface ListWorkStreamFiles200Response {
    'files': WorkStreamFileTree;
}
export interface ListWorkStreamSkills200Response {
    'skills': WorkStreamSkillActivationList;
}
export interface LoopBudgetHeadroom {
    'loopTaskId': number;
    'teamId': number;
    'state': LoopState;
    'period': LoopBudgetPeriod;
    'amountUsd': string;
    'minimumStartUsd': string;
    'settledUsd': string;
    'reservedUsd': string;
    'remainingUsd': string;
    'periodStart': string;
    'nextPeriodStart': string;
    'restartEpoch': number;
}



export const LoopBudgetPeriod = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
} as const;

export type LoopBudgetPeriod = typeof LoopBudgetPeriod[keyof typeof LoopBudgetPeriod];


export interface LoopConfiguration {
    'agentId'?: number;
    'kind'?: LoopKind;
    'name'?: string;
    'instructions'?: string;
    'completionCondition'?: string;
    'fixedDelaySeconds'?: number;
    'nextEligibleAt'?: string;
    'budgetAmountUsd'?: string;
    'budgetPeriod'?: LoopBudgetPeriod;
    'budgetMinimumStartUsd'?: string;
    'maximumIterations'?: number;
    'deadlineAt'?: string;
}


export interface LoopError {
    'error': string;
}
export interface LoopIteration {
    'workStreamId': number;
    'ordinal': number;
    'status': string;
    'scheduledFor': string;
    'firstStartedAt'?: string;
    'terminalAt'?: string;
    'outcome'?: string;
    'outcomeReason'?: string;
    'outcomeNotBefore'?: string;
    'runCount': number;
    'retryCount': number;
    'activeProcessingMs': number;
    'waitDurationMs': number;
    'currentWaitDurationMs': number;
    'longestWaitDurationMs': number;
    'costUsd': string;
}
export interface LoopIterationPage {
    'iterations': Array<LoopIteration>;
    'nextBeforeOrdinal'?: number;
}

export const LoopKind = {
    Bounded: 'bounded',
    Continuous: 'continuous'
} as const;

export type LoopKind = typeof LoopKind[keyof typeof LoopKind];


export interface LoopMetricWindow {
    'iterationCount': number;
    'terminalIterationCount': number;
    'outcomeCounts': LoopOutcomeCounts;
    'startDelaySampleCount': number;
    'averageStartDelayMs'?: number;
    'p95StartDelayMs'?: number;
    'elapsedDurationSampleCount': number;
    'averageElapsedDurationMs'?: number;
    'p95ElapsedDurationMs'?: number;
    'activeProcessingSampleCount': number;
    'totalActiveProcessingMs': number;
    'averageActiveProcessingMs'?: number;
    'totalWaitDurationMs': number;
    'currentWaitDurationMs': number;
    'longestWaitDurationMs': number;
    'retryCount': number;
}
export interface LoopMetricsResponse {
    'metrics': LoopTaskMetrics;
    'budget': LoopBudgetHeadroom;
}
export interface LoopOutcomeCounts {
    'continue': number;
    'terminate': number;
    'pauseForHuman': number;
    'cannotContinue': number;
    'missing': number;
}
export interface LoopReasonRequest {
    'reason': string;
}
export interface LoopRecentRetry {
    'workStreamId': number;
    'iterationOrdinal': number;
    'runId': number;
    'runOrdinal': number;
    'triggerType': string;
    'status': string;
    'startedAt'?: string;
    'terminalAt'?: string;
}
export interface LoopStartRequest {
    'nextEligibleAt': string;
}

export const LoopState = {
    Active: 'active',
    PausedBudget: 'paused_budget',
    PausedHuman: 'paused_human',
    Completed: 'completed',
    Stopped: 'stopped',
    Failed: 'failed'
} as const;

export type LoopState = typeof LoopState[keyof typeof LoopState];


export interface LoopTaskDetail {
    'id': number;
    'teamId': number;
    'agentId': number;
    'projectId'?: number;
    'cardId'?: number;
    'copiedFromLoopTaskId'?: number;
    'kind': LoopKind;
    'state': LoopState;
    'name': string;
    'fixedDelaySeconds'?: number;
    'nextEligibleAt': string;
    'budgetAmountUsd'?: string;
    'budgetPeriod'?: LoopBudgetPeriod;
    'budgetMinimumStartUsd'?: string;
    'maximumIterations'?: number;
    'deadlineAt'?: string;
    'restartEpoch'?: number;
    'ownedByCurrentUser': boolean;
    'created'?: string;
    'updated'?: string;
    'instructions': string;
    'completionCondition'?: string;
}


export interface LoopTaskDetailResponse {
    'loopTask': LoopTaskDetail;
}
export interface LoopTaskListResponse {
    'loopTasks': Array<LoopTaskSummary>;
}
export interface LoopTaskMetrics {
    'lifetimeCostUsd': string;
    'currentPeriodCostUsd': string;
    'currentPeriodStartedAt': string;
    'latestRestartAt'?: string;
    'allTime': LoopMetricWindow;
    'sinceLatestRestart': LoopMetricWindow;
    'recentRetries': Array<LoopRecentRetry>;
    'warnings': LoopWarnings;
}
export interface LoopTaskSummary {
    'id': number;
    'teamId': number;
    'agentId': number;
    'projectId'?: number;
    'cardId'?: number;
    'copiedFromLoopTaskId'?: number;
    'kind': LoopKind;
    'state': LoopState;
    'name': string;
    'fixedDelaySeconds'?: number;
    'nextEligibleAt': string;
    'budgetAmountUsd'?: string;
    'budgetPeriod'?: LoopBudgetPeriod;
    'budgetMinimumStartUsd'?: string;
    'maximumIterations'?: number;
    'deadlineAt'?: string;
    'restartEpoch'?: number;
    'ownedByCurrentUser': boolean;
    'created'?: string;
    'updated'?: string;
}


export interface LoopWarnings {
    'currentIterationOrdinal': number;
    'currentStartDelayMs': number;
    'startDelayThresholdMs': number;
    'startDelayWarning': boolean;
    'currentElapsedMs': number;
    'elapsedThresholdMs': number;
    'elapsedWarning': boolean;
}
export interface MarketingEmailConsent {
    'state': MarketingEmailConsentStateEnum;
    'decidedAt': string;
    'source': MarketingEmailConsentSourceEnum;
}

export const MarketingEmailConsentStateEnum = {
    Undecided: 'undecided',
    Accepted: 'accepted',
    Declined: 'declined'
} as const;

export type MarketingEmailConsentStateEnum = typeof MarketingEmailConsentStateEnum[keyof typeof MarketingEmailConsentStateEnum];
export const MarketingEmailConsentSourceEnum = {
    NotificationsPrompt: 'notifications_prompt',
    AuthenticatedPreferences: 'authenticated_preferences',
    PublicPreferences: 'public_preferences',
    Migration: 'migration',
    OneClickUnsubscribe: 'one_click_unsubscribe'
} as const;

export type MarketingEmailConsentSourceEnum = typeof MarketingEmailConsentSourceEnum[keyof typeof MarketingEmailConsentSourceEnum];

export interface MarketingEmailConsentResponse {
    'marketingEmailConsent': MarketingEmailConsent;
}
export interface Message {
    /**
     * Unique identifier for the message
     */
    'id'?: number;
    /**
     * Message subject
     */
    'subject'?: string;
    /**
     * Message content
     */
    'content'?: string;
}
export interface MessageListResponse {
    /**
     * List of messages
     */
    'messages'?: Array<MessageResponse>;
    'pagination'?: ConversationListResponsePagination;
}
export interface MessageNote {
    /**
     * Unique identifier for the message note
     */
    'id'?: number;
    /**
     * ID of the message this note belongs to
     */
    'messageId'?: number;
    'noteType'?: MessageNoteType;
    /**
     * The text content of the note
     */
    'noteText'?: string;
    /**
     * For POI notes, whether this POI must pass for a test run to succeed
     */
    'poiRequired'?: boolean;
    /**
     * When the note was created
     */
    'createdAt'?: string;
    /**
     * When the note was last updated
     */
    'updatedAt'?: string;
    /**
     * ID of the user who created the note
     */
    'createdByUserId'?: number;
}


export interface MessageNoteListResponse {
    /**
     * Array of message notes
     */
    'notes'?: Array<MessageNote>;
    /**
     * Total number of notes available
     */
    'totalCount'?: number;
    /**
     * Number of notes skipped from the beginning
     */
    'offset'?: number;
    /**
     * Maximum number of notes returned in this response
     */
    'limitCount'?: number;
}
/**
 * Type of message note: - AGENT_NOT_RUNNING: Note indicating that the agent was not running when the message was processed - BLOCKED_BY_INCOMING_COMMUNICATIONS_POLICY: Note indicating that the message was blocked due to incoming communications policy - UNHANDLED_MESSAGE: Note indicating that the agent escalated the message as unhandled - PROCESSING_ERROR: Note indicating that an error occurred during message processing - FINAL_FEEDBACK: Note containing final feedback or summary information about the message processing - CUSTOM_TEXT: Note containing custom text added by users or system administrators - SPF_FAIL: Sender Policy Framework check failed - DKIM_FAIL: DomainKeys Identified Mail check failed 
 */

export const MessageNoteType = {
    AgentNotRunning: 'AGENT_NOT_RUNNING',
    BlockedByIncomingCommunicationsPolicy: 'BLOCKED_BY_INCOMING_COMMUNICATIONS_POLICY',
    UnhandledMessage: 'UNHANDLED_MESSAGE',
    ProcessingError: 'PROCESSING_ERROR',
    FinalFeedback: 'FINAL_FEEDBACK',
    CustomText: 'CUSTOM_TEXT',
    SpfFail: 'SPF_FAIL',
    DkimFail: 'DKIM_FAIL'
} as const;

export type MessageNoteType = typeof MessageNoteType[keyof typeof MessageNoteType];


export interface MessageResponse {
    /**
     * Unique identifier for the message
     */
    'id'?: number;
    /**
     * ID of the conversation this message belongs to
     */
    'conversationId'?: number;
    /**
     * ID of the agent
     */
    'agentId'?: number;
    /**
     * Type of the message
     */
    'messageType'?: string;
    /**
     * Unique identifier for the message
     */
    'uniqueId'?: string;
    /**
     * Subject of the message
     */
    'subject'?: string;
    /**
     * ID of the metric associated with this message
     */
    'metricId'?: number;
    /**
     * Flag indicating if this message is marked as test data
     */
    'testData'?: boolean;
    /**
     * Creation timestamp
     */
    'createdAt'?: string;
    /**
     * Last update timestamp
     */
    'updatedAt'?: string;
    /**
     * Array of TO recipient email addresses
     */
    'toEmails'?: Array<string>;
    /**
     * FROM sender email address
     */
    'fromEmail'?: string;
    /**
     * Array of CC recipient email addresses
     */
    'ccEmails'?: Array<string>;
    /**
     * Array of third party email addresses (deprecated - use toEmails, fromEmail, ccEmails instead)
     */
    'thirdPartyEmails'?: Array<string>;
    /**
     * Text content of the message (only included when requested)
     */
    'messageText'?: string;
    'usage'?: MessageResponseUsage;
}
/**
 * Model/token usage for the turn that produced this message
 */
export interface MessageResponseUsage {
    'model'?: string;
    'modelProvider'?: string;
    'tokensSent'?: number;
    'tokensReceived'?: number;
    /**
     * Fully burdened USD cost of the turn (null when unknown)
     */
    'costUsd'?: number;
}
export interface MessageSearchResult {
    /**
     * ID of the message
     */
    'messageId'?: number;
    /**
     * ID of the conversation
     */
    'conversationId'?: number;
    /**
     * Similarity score
     */
    'score'?: number;
    /**
     * Type of the message
     */
    'messageType'?: string;
    /**
     * Subject of the message
     */
    'subject'?: string;
    /**
     * ID of the metric associated with this message
     */
    'metricId'?: number;
    /**
     * Creation timestamp
     */
    'createdAt'?: string;
    /**
     * Array of TO recipient email addresses
     */
    'toEmails'?: Array<string>;
    /**
     * FROM sender email address
     */
    'fromEmail'?: string;
    /**
     * Array of CC recipient email addresses
     */
    'ccEmails'?: Array<string>;
    /**
     * Array of third party email addresses (deprecated - use toEmails, fromEmail, ccEmails instead)
     */
    'thirdPartyEmails'?: Array<string>;
}
export interface MessageTestData {
    /**
     * Unique identifier for the message
     */
    'id': number;
    /**
     * ID of the associated agent
     */
    'agentId': number;
    /**
     * Message subject
     */
    'subject': string;
    /**
     * Type of the message
     */
    'messageType': string;
    /**
     * Creation timestamp
     */
    'createdAt': string;
    /**
     * Flag indicating if this message is marked as test data
     */
    'testData': boolean;
    /**
     * Full text content of the message
     */
    'messageText': string;
    /**
     * Array of user notes associated with this message
     */
    'userNotes': Array<UserNote>;
}
export interface MessageTestStartRequest {
    /**
     * Number of test iterations to run for the individual message
     */
    'iterations'?: number;
}
export interface MessageTestStartResponse {
    /**
     * Success message
     */
    'message'?: string;
    /**
     * UUID of the started test job for status tracking
     */
    'jobUUID'?: string;
    /**
     * ID of the started test job for status tracking
     */
    'jobId'?: number;
}
export interface MetricItem {
    /**
     * Unique identifier for the metric
     */
    'id': number;
    /**
     * Specific AI model used
     */
    'model': string;
    /**
     * Provider of the embeddings model
     */
    'embeddingsProvider'?: string;
    /**
     * Specific embeddings model used
     */
    'embeddingsModel'?: string;
    /**
     * Per-model statistics for token usage
     */
    'modelStats': Array<MetricItemModelStatsInner>;
    /**
     * Total fully burdened USD cost of the request (null when unknown)
     */
    'costUsd'?: number;
    /**
     * When the metric was created
     */
    'created': string;
    /**
     * Whether the request was successful
     */
    'success': boolean;
    /**
     * Processing time in milliseconds
     */
    'processingTimeMs': number;
    /**
     * Unique request identifier
     */
    'requestId': string;
    /**
     * Number of email send attempts
     */
    'emailSendAttempts'?: number;
    /**
     * Number of emails successfully sent
     */
    'emailsSent'?: number;
    /**
     * Number of errors encountered
     */
    'errorCount'?: number;
    /**
     * Email subject line
     */
    'subject'?: string;
    /**
     * Email sender address
     */
    'emailFrom'?: string;
    /**
     * Associated skills (if any)
     */
    'skills'?: Array<MetricItemSkillsInner>;
    /**
     * Associated job (if any)
     */
    'job'?: JobReference;
}
export interface MetricItemModelStatsInner {
    /**
     * Model name
     */
    'model'?: string;
    /**
     * Concrete provider model used when model is a rolling alias
     */
    'modelVersion'?: string;
    /**
     * Model provider
     */
    'modelProvider'?: string;
    /**
     * Model temperature
     */
    'temperature'?: number;
    /**
     * Number of tokens sent to this model
     */
    'tokensSent'?: number;
    /**
     * Number of tokens received from this model
     */
    'tokensReceived'?: number;
    /**
     * Prompt tokens served from the provider\'s prefix cache. A subset of tokensSent, not an addition to it, so the cache hit rate is tokensCached / tokensSent.
     */
    'tokensCached'?: number;
    /**
     * Fully burdened USD cost of this model\'s usage (absent when the model has no known pricing)
     */
    'costUsd'?: number;
    'pricing'?: MetricItemModelStatsInnerPricing;
}
/**
 * Exact USD-per-million-token rates used for this model-stat row
 */
export interface MetricItemModelStatsInnerPricing {
    'inputPerMillion': number;
    'outputPerMillion': number;
    'notes'?: string;
}
export interface MetricItemSkillsInner {
    /**
     * Skill ID
     */
    'id'?: number;
    /**
     * Skill name
     */
    'name'?: string;
}
export interface MetricReference {
    /**
     * Unique identifier for the metric
     */
    'id': number;
    /**
     * Unique request identifier
     */
    'requestId': string;
    /**
     * When the metric was created
     */
    'created': string;
    /**
     * Whether the request was successful
     */
    'success': boolean;
}
export interface MetricResponse {
    /**
     * Array of metric records
     */
    'metrics': Array<MetricItem>;
    /**
     * Total count of metrics
     */
    'totalCount': number;
    'counts': MetricsCounts;
    'period'?: MetricResponsePeriod;
}
export interface MetricResponsePeriod {
    /**
     * Hours looked back
     */
    'hoursAgo'?: number;
    /**
     * Start date of the period
     */
    'startDate'?: string;
}
export interface MetricsCounts {
    /**
     * Total count of requests in the time period
     */
    'totalRequests': number;
    /**
     * Count of successful requests in the time period
     */
    'successfulRequests': number;
    /**
     * Count of failed requests in the time period
     */
    'failedRequests': number;
    /**
     * Count of emails sent in the time period
     */
    'emailsSent': number;
    /**
     * Count of errors encountered in the time period
     */
    'errorCount': number;
    /**
     * Total number of documents (vectors) the agent has access to
     */
    'documents': number;
    /**
     * Total number of knowledge graph nodes
     */
    'graphNodes'?: number;
    /**
     * Total number of knowledge graph edges
     */
    'graphEdges'?: number;
    /**
     * Total number of agent memories
     */
    'memories': number;
    /**
     * Exact total when fully priced; null if any eligible row has unknown cost
     */
    'totalCostUsd': number | null;
    'knownTotalCostUsd': number;
    'costPricingState': CostPricingState;
    'metricCount': number;
}


export interface MfaCodeRequest {
    'code': string;
}
export interface MockPageAnalysis {
    /**
     * Current status of the learning process
     */
    'status': string;
    /**
     * Any errors encountered during learning
     */
    'errors': Array<string>;
    /**
     * Mock facts extracted from the website
     */
    'facts': Array<string>;
    /**
     * Mock questions and answers extracted from the website
     */
    'questions': Array<MockPageAnalysisQuestionsInner>;
}
export interface MockPageAnalysisQuestionsInner {
    /**
     * A question related to the website content
     */
    'question'?: string;
    /**
     * The answer to the question
     */
    'answer'?: string;
}
export interface ModelCapabilitiesResponse {
    'capabilities': Array<ModelCapabilityState>;
}

export const ModelCapability = {
    Image: 'image',
    Speech: 'speech',
    Music: 'music',
    Video: 'video',
    LiveAudio: 'liveAudio'
} as const;

export type ModelCapability = typeof ModelCapability[keyof typeof ModelCapability];


export interface ModelCapabilityState {
    'capability': ModelCapability;
    'enabled': boolean;
}


export interface ModelCatalogProviderIssue {
    /**
     * Provider instance key, so a warning can be attached to one card.
     */
    'providerKey': string;
    'providerName': string;
    'providerType': ModelProviderName;
    'severity': ModelCatalogProviderIssueSeverityEnum;
    'message': string;
}

export const ModelCatalogProviderIssueSeverityEnum = {
    Unavailable: 'unavailable',
    Degraded: 'degraded'
} as const;

export type ModelCatalogProviderIssueSeverityEnum = typeof ModelCatalogProviderIssueSeverityEnum[keyof typeof ModelCatalogProviderIssueSeverityEnum];

export interface ModelConfig {
    /**
     * The model identifier
     */
    'model': string;
    /**
     * The provider of the model (google, anthropic, bedrock, openrouter, groq, openai, openai-compatible)
     */
    'modelProvider': string;
    /**
     * Team model provider instance supplying the credentials. Absent or null means the platform default instance backed by server environment keys.
     */
    'providerId'?: number;
    /**
     * Persisted context window used to trigger compaction
     */
    'contextWindow'?: number;
    /**
     * The temperature setting for the model
     */
    'temperature'?: number;
    /**
     * Maximum number of tokens to generate
     */
    'maxOutputTokens'?: number;
    /**
     * Top-p sampling parameter
     */
    'topP'?: number;
    /**
     * Presence penalty parameter
     */
    'presencePenalty'?: number;
    /**
     * Frequency penalty parameter
     */
    'frequencyPenalty'?: number;
    /**
     * Sequences that will stop generation
     */
    'stopSequences'?: Array<string>;
    /**
     * Whether to enable thinking mode
     */
    'enableThinking'?: boolean;
}
export interface ModelDescription {
    /**
     * The name of the model
     */
    'name': string;
    'displayName'?: string;
    /**
     * Model family/vendor within the provider (e.g. Anthropic on Bedrock)
     */
    'brand'?: string;
    /**
     * One-line summary for pickers
     */
    'description'?: string;
    /**
     * Longer text shown while reviewing a model
     */
    'detailedDescription'?: string;
    'pricing'?: ModelPricing;
    'contextWindow'?: number;
    /**
     * Whether the provider reports an active loaded instance
     */
    'loaded'?: boolean;
    /**
     * Whether the model supports live bidirectional audio
     */
    'supportsLiveAudio'?: boolean;
    /**
     * Output modalities the model can emit. Absent means text-only. A model listing \"image\" may be assigned to the image generation slot and to no other slot.
     */
    'outputModalities'?: Array<ModelDescriptionOutputModalitiesEnum>;
    'defaultConfig': ModelConfig;
}

export const ModelDescriptionOutputModalitiesEnum = {
    Text: 'text',
    Image: 'image',
    Audio: 'audio',
    Video: 'video'
} as const;

export type ModelDescriptionOutputModalitiesEnum = typeof ModelDescriptionOutputModalitiesEnum[keyof typeof ModelDescriptionOutputModalitiesEnum];

export interface ModelEndpoint {
    'id': string;
    'modelProvider': ModelProviderName;
    /**
     * Team provider instance, or null for the platform default.
     */
    'providerId': number | null;
    /**
     * The model id sent to this provider\'s API.
     */
    'providerModelId': string;
    'subProviderSlug': string;
    'subProviderName': string;
    /**
     * The router this upstream is reached through, when not reached directly. Part of what a team approves: a provider reached through a router is a different commercial relationship.
     */
    'routedVia'?: string;
    /**
     * OpenRouter endpoint variant tag, usable to pin routing.
     */
    'endpointTag'?: string;
    'quantization': ModelEndpointQuantizationEnum;
    'contextWindow': number;
    'maxOutputTokens'?: number;
    'catalogPrice': CatalogPriceQuote;
    'acceptedInputs'?: Array<AcceptedModelInput>;
    'videoCapabilities'?: VideoCapabilities;
    'videoPricing'?: VideoPricing;
    /**
     * Processing locations. Empty means the Unknown bucket.
     */
    'countryCodes': Array<string>;
    'locationSource': ModelEndpointLocationSourceEnum;
    /**
     * Whether the team\'s sub-processor jurisdiction policy admits this endpoint. Reported rather than filtered so the reason is visible.
     */
    'allowedByCountryPolicy': boolean;
    'uptimeLast30m'?: number;
    'status'?: number;
}

export const ModelEndpointQuantizationEnum = {
    Fp32: 'fp32',
    Bf16: 'bf16',
    Fp16: 'fp16',
    Fp8: 'fp8',
    Fp6: 'fp6',
    Fp4: 'fp4',
    Int8: 'int8',
    Int4: 'int4',
    Unknown: 'unknown'
} as const;

export type ModelEndpointQuantizationEnum = typeof ModelEndpointQuantizationEnum[keyof typeof ModelEndpointQuantizationEnum];
export const ModelEndpointLocationSourceEnum = {
    Curated: 'curated',
    Live: 'live',
    Unknown: 'unknown'
} as const;

export type ModelEndpointLocationSourceEnum = typeof ModelEndpointLocationSourceEnum[keyof typeof ModelEndpointLocationSourceEnum];

export interface ModelEndpointsResponse {
    'canonicalModelId': string;
    'endpoints': Array<ModelEndpoint>;
}
export interface ModelError {
    /**
     * Error message
     */
    'error': string;
}
export interface ModelFamily {
    'familyId': string;
    'displayName': string;
    'brand': string;
    'description': string;
    /**
     * The canonical model this family currently points at.
     */
    'latest': string;
    'members': Array<string>;
}
export interface ModelPricing {
    /**
     * USD per one million input tokens (indicative)
     */
    'inputPerMillion': number;
    /**
     * USD per one million output tokens (indicative)
     */
    'outputPerMillion': number;
    /**
     * USD per one million prompt tokens served from the provider\'s context cache. Absent when the provider publishes no cached rate.
     */
    'cachedInputPerMillion'?: number;
    /**
     * Flat USD charge per generated image
     */
    'perImageUsd'?: number;
    /**
     * USD per generated video second
     */
    'videoPerSecond'?: number;
    'notes'?: string;
}
export interface ModelProviderConfigField {
    'key': string;
    'label': string;
    'required': boolean;
    'placeholder'?: string;
    'defaultValue'?: string;
    'inputType'?: ModelProviderConfigFieldInputTypeEnum;
    'min'?: number;
    'max'?: number;
    'step'?: string;
    'insecureTransportWarning'?: string;
}

export const ModelProviderConfigFieldInputTypeEnum = {
    Text: 'text',
    Url: 'url',
    Number: 'number'
} as const;

export type ModelProviderConfigFieldInputTypeEnum = typeof ModelProviderConfigFieldInputTypeEnum[keyof typeof ModelProviderConfigFieldInputTypeEnum];

export interface ModelProviderCredentialField {
    'key': string;
    'label': string;
    'secret': boolean;
    'required': boolean;
    'placeholder'?: string;
}

export const ModelProviderName = {
    Google: 'google',
    Anthropic: 'anthropic',
    Bedrock: 'bedrock',
    Openrouter: 'openrouter',
    Groq: 'groq',
    Openai: 'openai',
    OpenaiCompatible: 'openai-compatible',
    Xai: 'xai',
    Fal: 'fal'
} as const;

export type ModelProviderName = typeof ModelProviderName[keyof typeof ModelProviderName];


export interface ModelProviderReference {
    'ownerType': ModelProviderReferenceOwnerTypeEnum;
    'ownerId': number;
    'ownerName': string;
    'slot': ModelProviderReferenceSlotEnum;
    'model': string;
    'usesTeamDefault'?: boolean;
}

export const ModelProviderReferenceOwnerTypeEnum = {
    Team: 'team',
    Agent: 'agent'
} as const;

export type ModelProviderReferenceOwnerTypeEnum = typeof ModelProviderReferenceOwnerTypeEnum[keyof typeof ModelProviderReferenceOwnerTypeEnum];
export const ModelProviderReferenceSlotEnum = {
    Interaction: 'interaction',
    KnowledgeExtraction: 'knowledgeExtraction',
    Live: 'live',
    ImageGeneration: 'imageGeneration',
    SpeechGeneration: 'speechGeneration',
    MusicGeneration: 'musicGeneration',
    VideoGeneration: 'videoGeneration',
    VideoInspection: 'videoInspection'
} as const;

export type ModelProviderReferenceSlotEnum = typeof ModelProviderReferenceSlotEnum[keyof typeof ModelProviderReferenceSlotEnum];

export interface ModelProviderType {
    'type': ModelProviderName;
    'displayName': string;
    'description': string;
    'websiteUrl': string;
    'credentialFields': Array<ModelProviderCredentialField>;
    'configFields': Array<ModelProviderConfigField>;
    'accessNote'?: string;
    'defaultAvailable': boolean;
}


export interface ModelProviderTypesResponse {
    'types': Array<ModelProviderType>;
}
export interface ModelProvidersResponse {
    /**
     * List of available model provider names
     */
    'providers': Array<string>;
}

export const ModelSlot = {
    Interaction: 'interaction',
    KnowledgeExtraction: 'knowledgeExtraction',
    Live: 'live',
    ImageGeneration: 'imageGeneration',
    SpeechGeneration: 'speechGeneration',
    MusicGeneration: 'musicGeneration',
    VideoGeneration: 'videoGeneration',
    VideoInspection: 'videoInspection'
} as const;

export type ModelSlot = typeof ModelSlot[keyof typeof ModelSlot];


/**
 * @type ModelSlotConfig
 */
export type ModelSlotConfig = ModelSlotPolicy | VoiceTalkConfig;

export interface ModelSlotPolicy {
    'version': ModelSlotPolicyVersionEnum;
    'strategy': SlotStrategy;
    'candidates': Array<SlotModelCandidate>;
    'temperature'?: number;
    'maxOutputTokens'?: number;
    'enableThinking'?: boolean;
    'thinkingEffort'?: ModelSlotPolicyThinkingEffortEnum;
    'functionCallingMode'?: ModelSlotPolicyFunctionCallingModeEnum;
    'contextWindow'?: number;
}

export const ModelSlotPolicyVersionEnum = {
    NUMBER_1: 1
} as const;

export type ModelSlotPolicyVersionEnum = typeof ModelSlotPolicyVersionEnum[keyof typeof ModelSlotPolicyVersionEnum];
export const ModelSlotPolicyThinkingEffortEnum = {
    Minimal: 'minimal',
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type ModelSlotPolicyThinkingEffortEnum = typeof ModelSlotPolicyThinkingEffortEnum[keyof typeof ModelSlotPolicyThinkingEffortEnum];
export const ModelSlotPolicyFunctionCallingModeEnum = {
    Any: 'ANY',
    Auto: 'AUTO'
} as const;

export type ModelSlotPolicyFunctionCallingModeEnum = typeof ModelSlotPolicyFunctionCallingModeEnum[keyof typeof ModelSlotPolicyFunctionCallingModeEnum];

export interface ModelsResponse {
    /**
     * The name of the provider
     */
    'provider': string;
    /**
     * List of models available for the provider
     */
    'models': Array<ModelDescription>;
}
export interface NativeModelProviderConflictResponse {
    'code': NativeModelProviderConflictResponseCodeEnum;
    'teamDefaults': Array<ModelProviderReference>;
    'directAgents': Array<ModelProviderReference>;
}

export const NativeModelProviderConflictResponseCodeEnum = {
    ModelProviderInUse: 'MODEL_PROVIDER_IN_USE'
} as const;

export type NativeModelProviderConflictResponseCodeEnum = typeof NativeModelProviderConflictResponseCodeEnum[keyof typeof NativeModelProviderConflictResponseCodeEnum];

export interface NativeModelProviderEnabledRequest {
    'enabled': boolean;
}
export interface NetworkAccessRequestView {
    'id'?: number;
    'domain'?: string;
    'ruleType'?: string;
    'protocol'?: NetworkAccessRequestViewProtocolEnum;
    'portStart'?: number;
    'portEnd'?: number;
    'portDisplay'?: string;
    'agentId'?: number;
    'status'?: string;
    'reason'?: string;
    'decisionNote'?: string;
    'cooldownUntil'?: string;
    'createdAt'?: string;
}

export const NetworkAccessRequestViewProtocolEnum = {
    Tcp: 'tcp',
    Udp: 'udp',
    Icmp: 'icmp'
} as const;

export type NetworkAccessRequestViewProtocolEnum = typeof NetworkAccessRequestViewProtocolEnum[keyof typeof NetworkAccessRequestViewProtocolEnum];

export interface NodeFeature {
    /**
     * Feature name
     */
    'name': string;
    'value': any;
    /**
     * URL of the source document associated with this feature
     */
    'documentUrl': string;
}
export interface NodeResponse {
    /**
     * Unique identifier for the node
     */
    'id': number;
    /**
     * Name of the node
     */
    'name': string;
    /**
     * Type name of the node
     */
    'nodeTypeName': string;
    /**
     * Last update timestamp
     */
    'updatedAt': string;
    /**
     * Creation timestamp
     */
    'createdAt': string;
    /**
     * Whether the node is enabled or disabled
     */
    'enabled': boolean;
    /**
     * Array of node features
     */
    'features': Array<NodeFeature>;
}

export const NotificationCategoryKey = {
    ApprovalRequest: 'approval_request',
    CardMention: 'card_mention',
    CardWatch: 'card_watch',
    ChatMention: 'chat_mention',
    ConversationInvite: 'conversation_invite',
    TeamSecretRenamed: 'team_secret_renamed',
    ReleaseNotes: 'release_notes',
    OutOfFunds: 'out_of_funds',
    AutomaticFundingTopUp: 'automatic_funding_top_up',
    SystemIssue: 'system_issue'
} as const;

export type NotificationCategoryKey = typeof NotificationCategoryKey[keyof typeof NotificationCategoryKey];


export interface NotificationChannelPreference {
    'channel': NotificationChannelPreferenceChannelEnum;
    /**
     * Whether this channel is currently enabled for the category.
     */
    'enabled': boolean;
    /**
     * Whether the channel is usable with the caller\'s current configuration.
     */
    'available': boolean;
    /**
     * Whether the channel cannot be disabled.
     */
    'locked': boolean;
    'lockedReason'?: NotificationChannelPreferenceLockedReasonEnum;
    'unavailableReason'?: NotificationChannelPreferenceUnavailableReasonEnum;
}

export const NotificationChannelPreferenceChannelEnum = {
    Email: 'email',
    Sms: 'sms',
    Slack: 'slack'
} as const;

export type NotificationChannelPreferenceChannelEnum = typeof NotificationChannelPreferenceChannelEnum[keyof typeof NotificationChannelPreferenceChannelEnum];
export const NotificationChannelPreferenceLockedReasonEnum = {
    Required: 'required'
} as const;

export type NotificationChannelPreferenceLockedReasonEnum = typeof NotificationChannelPreferenceLockedReasonEnum[keyof typeof NotificationChannelPreferenceLockedReasonEnum];
export const NotificationChannelPreferenceUnavailableReasonEnum = {
    SmsNotConfigured: 'sms_not_configured',
    PhoneIdentityRequired: 'phone_identity_required',
    SlackIdentityRequired: 'slack_identity_required',
    SlackRelinkRequired: 'slack_relink_required',
    SlackIntegrationRequired: 'slack_integration_required'
} as const;

export type NotificationChannelPreferenceUnavailableReasonEnum = typeof NotificationChannelPreferenceUnavailableReasonEnum[keyof typeof NotificationChannelPreferenceUnavailableReasonEnum];


export const NotificationCommunicationClassification = {
    Helpful: 'helpful',
    System: 'system'
} as const;

export type NotificationCommunicationClassification = typeof NotificationCommunicationClassification[keyof typeof NotificationCommunicationClassification];


export interface NotificationItem {
    'id'?: number;
    'createdAt'?: string;
    'teamId'?: number;
    'type'?: string;
    'title'?: string;
    'body'?: string;
    'data'?: Record<string, any>;
    'viewed'?: boolean;
    'viewedAt'?: string;
}
export interface NotificationPreferenceCategory {
    'category': NotificationPreferenceCategoryCategoryEnum;
    'label': string;
    'description': string;
    'classification': NotificationCommunicationClassification;
    'channels': Array<NotificationChannelPreference>;
}

export const NotificationPreferenceCategoryCategoryEnum = {
    ApprovalRequest: 'approval_request',
    CardMention: 'card_mention',
    CardWatch: 'card_watch',
    ChatMention: 'chat_mention',
    ConversationInvite: 'conversation_invite',
    TeamSecretRenamed: 'team_secret_renamed',
    ReleaseNotes: 'release_notes',
    OutOfFunds: 'out_of_funds',
    AutomaticFundingTopUp: 'automatic_funding_top_up',
    SystemIssue: 'system_issue'
} as const;

export type NotificationPreferenceCategoryCategoryEnum = typeof NotificationPreferenceCategoryCategoryEnum[keyof typeof NotificationPreferenceCategoryCategoryEnum];

export interface NotificationPreferenceExpiredResponse {
    'error': string;
    'code': NotificationPreferenceExpiredResponseCodeEnum;
}

export const NotificationPreferenceExpiredResponseCodeEnum = {
    NotificationPreferenceLinkExpired: 'NOTIFICATION_PREFERENCE_LINK_EXPIRED'
} as const;

export type NotificationPreferenceExpiredResponseCodeEnum = typeof NotificationPreferenceExpiredResponseCodeEnum[keyof typeof NotificationPreferenceExpiredResponseCodeEnum];

export interface NotificationPreferenceResendResponse {
    'ok': NotificationPreferenceResendResponseOkEnum;
    'message': string;
}

export const NotificationPreferenceResendResponseOkEnum = {
    True: true
} as const;

export type NotificationPreferenceResendResponseOkEnum = typeof NotificationPreferenceResendResponseOkEnum[keyof typeof NotificationPreferenceResendResponseOkEnum];

export interface NotificationPreferencesResponse {
    'marketingEmailConsent': MarketingEmailConsent;
    'preferences': Array<NotificationPreferenceCategory>;
    'devices': Array<WebPushDevice>;
}
export interface NotificationsResponse {
    'notifications'?: Array<NotificationItem>;
    'unviewedCount'?: number;
}
export interface OkResponse {
    'ok': boolean;
}
export interface POIResults {
    /**
     * Version of the stored POI results payload
     */
    'schemaVersion'?: number;
    /**
     * ID of the test result
     */
    'testResultId'?: number;
    /**
     * ID of the test result item
     */
    'testResultItemId'?: number;
    /**
     * ID of the Point of Interest
     */
    'poiId'?: number;
    /**
     * ID of the agent
     */
    'agentId'?: number;
    /**
     * ID of the team
     */
    'teamId'?: number;
    /**
     * Timestamp when the POI was executed
     */
    'timestamp'?: string;
    /**
     * Array of emails captured during test execution
     */
    'emailsSent'?: Array<CapturedTestEmail>;
    /**
     * Array of memories captured during test execution
     */
    'memoriesStored'?: Array<CapturedTestMemory>;
    /**
     * Array of notes created during test execution
     */
    'notesCreated'?: Array<Record<string, any>>;
    /**
     * The original email that was processed
     */
    'originalEmail'?: Record<string, any>;
    'poiEvaluation'?: POIResultsPoiEvaluation;
}
export interface POIResultsPoiEvaluation {
    /**
     * ID of the message note
     */
    'messageNoteId'?: number;
    /**
     * Whether the POI evaluation was successful
     */
    'success'?: boolean;
    /**
     * Description of the POI evaluation
     */
    'description'?: string;
    /**
     * Text content of the POI note
     */
    'noteText'?: string;
}
export interface PaginatedTestDataResponse {
    /**
     * Array of test data messages for the current page
     */
    'messages': Array<MessageTestData>;
    /**
     * Indicates if there are more messages available on subsequent pages
     */
    'hasMore': boolean;
}
export interface PaginatedTestResults {
    'results'?: Array<TestResult>;
    'pagination'?: PaginatedTestResultsPagination;
}
export interface PaginatedTestResultsPagination {
    /**
     * Current offset value
     */
    'offset'?: number;
    /**
     * Current limit value
     */
    'limit'?: number;
    /**
     * Total number of results
     */
    'total'?: number;
}
export interface ParsedEmail {
    /**
     * Email sender address
     */
    'from': string;
    /**
     * Email recipient address
     */
    'to': string;
    /**
     * Email subject line
     */
    'subject': string;
    /**
     * Plain text content of the email
     */
    'text'?: string;
    /**
     * HTML content of the email
     */
    'html'?: string;
    /**
     * IP address of the sender
     */
    'sender_ip'?: string;
    /**
     * SMTP envelope information in JSON format
     */
    'envelope'?: string;
    /**
     * Number of attachments
     */
    'attachments'?: number;
    /**
     * Information about attachments in JSON format
     */
    'attachment-info'?: string;
    /**
     * Email headers
     */
    'headers'?: string;
    /**
     * DKIM signature check result
     */
    'dkim'?: string;
    /**
     * Spam score of the email
     */
    'spam_score'?: string;
    /**
     * Detailed spam report
     */
    'spam_report'?: string;
    /**
     * SPF check result
     */
    'spf'?: string;
}
export interface PasskeySignupRequest {
    /**
     * Email address to verify before passkey registration
     */
    'email': string;
    /**
     * User\'s first name
     */
    'firstName': string;
    /**
     * User\'s last name
     */
    'lastName': string;
}
export interface PersonaCatalog {
    'catalogVersion': number;
    /**
     * Date the catalog was last reviewed (YYYY-MM-DD)
     */
    'reviewedAt': string;
    /**
     * Set when offered evidence has aged past the review horizon
     */
    'stalenessWarning'?: string;
    'personas': Array<PersonaRecommendation>;
}
export interface PersonaModelCandidate {
    'modelProvider': string;
    'model': string;
    'why': string;
    'evidence': PersonaModelCandidateEvidence;
    'status': PersonaModelCandidateStatusEnum;
    'providerId'?: number;
}

export const PersonaModelCandidateStatusEnum = {
    Selected: 'selected',
    ProviderUnavailable: 'provider-unavailable',
    ModelUnavailable: 'model-unavailable',
    NotEvaluated: 'not-evaluated'
} as const;

export type PersonaModelCandidateStatusEnum = typeof PersonaModelCandidateStatusEnum[keyof typeof PersonaModelCandidateStatusEnum];

export interface PersonaModelCandidateEvidence {
    'kind': PersonaModelCandidateEvidenceKindEnum;
    'date': string;
    'note': string;
}

export const PersonaModelCandidateEvidenceKindEnum = {
    LocalHarness: 'local-harness',
    PublicBenchmark: 'public-benchmark',
    Unmeasured: 'unmeasured'
} as const;

export type PersonaModelCandidateEvidenceKindEnum = typeof PersonaModelCandidateEvidenceKindEnum[keyof typeof PersonaModelCandidateEvidenceKindEnum];

export interface PersonaRecommendation {
    'key': string;
    'title': string;
    'useCase': string;
    /**
     * The first model preference this team can run right now, or null when none of the persona\'s candidates are available.
     */
    'recommended'?: PersonaModelCandidate;
    'candidates': Array<PersonaModelCandidate>;
    'skills': Array<PersonaRecommendationSkillsInner>;
    'caveats': Array<string>;
}
export interface PersonaRecommendationSkillsInner {
    'name': string;
    'description': string;
}
export interface PolicyPresetOption {
    'key'?: string;
    'label'?: string;
    'isDefault'?: boolean;
}
export interface PreviewTeamModelDefaultRequest {
    'slot': ModelSlot;
    'proposedDefault': ModelSlotConfig;
}


export interface Project {
    'id'?: number;
    'teamId'?: number;
    'name'?: string;
    'key'?: string;
    'description'?: string;
    'archived'?: boolean;
    /**
     * While true, no agent starts or continues work on this project
     */
    'paused'?: boolean;
    'workingStyleOverride'?: ProjectWorkingStyleOverrideEnum;
    'cautiousMaxReinvocationsOverride'?: number;
    'fullSendMaxHandoffsOverride'?: number;
    'effectiveWorkingStyle'?: ProjectEffectiveWorkingStyleEnum;
    'effectiveCautiousMaxReinvocations'?: number;
    'effectiveFullSendMaxHandoffs'?: number;
    'cardExecutionMode'?: ProjectCardExecutionModeEnum;
    /**
     * Scheduling tier boosting or lowering this project\'s queued card work relative to the team\'s other projects; never affects other teams.
     */
    'priority'?: ProjectPriorityEnum;
    /**
     * Retention period for newly-created Work stream file and browser artifacts
     */
    'workStreamArtifactRetentionDays'?: number;
    'createdByUserId'?: number;
    'createdByAgentId'?: number;
    'createdAt'?: string;
    'updatedAt'?: string;
}

export const ProjectWorkingStyleOverrideEnum = {
    NoAgents: 'no_agents',
    HumansDriveAgents: 'humans_drive_agents',
    AgentsCautiouslyDriveAgents: 'agents_cautiously_drive_agents',
    AgentsFullSend: 'agents_full_send'
} as const;

export type ProjectWorkingStyleOverrideEnum = typeof ProjectWorkingStyleOverrideEnum[keyof typeof ProjectWorkingStyleOverrideEnum];
export const ProjectEffectiveWorkingStyleEnum = {
    NoAgents: 'no_agents',
    HumansDriveAgents: 'humans_drive_agents',
    AgentsCautiouslyDriveAgents: 'agents_cautiously_drive_agents',
    AgentsFullSend: 'agents_full_send'
} as const;

export type ProjectEffectiveWorkingStyleEnum = typeof ProjectEffectiveWorkingStyleEnum[keyof typeof ProjectEffectiveWorkingStyleEnum];
export const ProjectCardExecutionModeEnum = {
    Serial: 'serial',
    Parallel: 'parallel'
} as const;

export type ProjectCardExecutionModeEnum = typeof ProjectCardExecutionModeEnum[keyof typeof ProjectCardExecutionModeEnum];
export const ProjectPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectPriorityEnum = typeof ProjectPriorityEnum[keyof typeof ProjectPriorityEnum];

export interface ProjectActivityEvent {
    'id'?: number;
    'projectId'?: number;
    'cardId'?: number;
    'type'?: string;
    'actorUserId'?: number;
    'actorAgentId'?: number;
    'actorName'?: string;
    'externalWorkSessionId'?: number;
    'externalClient'?: ProjectActivityEventExternalClientEnum;
    'externalModel'?: string;
    'data'?: Record<string, any>;
    'createdAt'?: string;
}

export const ProjectActivityEventExternalClientEnum = {
    Codex: 'codex',
    ClaudeCode: 'claude_code',
    Other: 'other'
} as const;

export type ProjectActivityEventExternalClientEnum = typeof ProjectActivityEventExternalClientEnum[keyof typeof ProjectActivityEventExternalClientEnum];

export interface ProjectActivityResponse {
    'activity'?: Array<ProjectActivityEvent>;
}
export interface ProjectAgentRef {
    'id'?: number;
    'name'?: string;
    'jobDescription'?: string;
}
export interface ProjectAgentRequest {
    'agentId': number;
}
export interface ProjectAttachment {
    'id'?: number;
    'cardId'?: number;
    'filename'?: string;
    'mimeType'?: string;
    'sizeBytes'?: number;
    /**
     * Version of this filename on the card, starting at 1.
     */
    'versionNumber'?: number;
    /**
     * Id of the attachment this one replaced, or null for a first version. Walk it to reach earlier versions of the same filename.
     */
    'previousVersionId'?: number;
    /**
     * True when a newer upload of the same filename replaced this row. Card listings only ever return current (non-superseded) rows.
     */
    'superseded'?: boolean;
    'uploadedByUserId'?: number;
    'uploadedByAgentId'?: number;
    'createdAt'?: string;
    /**
     * The verdict recorded against THIS version, or null when it has never been reviewed.
     */
    'review'?: ProjectAttachmentReview;
    /**
     * The newest verdict on a version this row replaced, set only when this row carries no review of its own. Non-null means a sign-off exists but does not cover the file the card currently shows.
     */
    'staleReview'?: ProjectAttachmentReview;
}
export interface ProjectAttachmentResponse {
    'attachment'?: ProjectAttachment;
}
export interface ProjectAttachmentReview {
    /**
     * The attachment version this verdict was recorded against.
     */
    'attachmentId'?: number;
    'versionNumber'?: number;
    'decision'?: ProjectAttachmentReviewDecisionEnum;
    'note'?: string;
    'reviewedAt'?: string;
    'reviewedByAgentId'?: number;
    'reviewedByAgentName'?: string;
}

export const ProjectAttachmentReviewDecisionEnum = {
    Approved: 'approved',
    Rejected: 'rejected',
    ChangesRequested: 'changes_requested'
} as const;

export type ProjectAttachmentReviewDecisionEnum = typeof ProjectAttachmentReviewDecisionEnum[keyof typeof ProjectAttachmentReviewDecisionEnum];

export interface ProjectAttachmentUploadRequest {
    'filename': string;
    'mimeType': string;
    'dataBase64': string;
}
export interface ProjectBoardCard {
    'id'?: number;
    'projectId'?: number;
    /**
     * Null for backlog cards (the backlog has no columns)
     */
    'columnId'?: number;
    'epicId'?: number;
    'sprintId'?: number;
    'cardNumber'?: number;
    'reference'?: string;
    'title'?: string;
    'description'?: string;
    'archived'?: boolean;
    /**
     * While true, no agent starts or continues work on this card
     */
    'paused'?: boolean;
    'priority'?: ProjectBoardCardPriorityEnum;
    'effectivePriority'?: ProjectBoardCardEffectivePriorityEnum;
    'position'?: number;
    'labelIds'?: Array<number>;
    'agentIds'?: Array<number>;
    'tasksTotal'?: number;
    'tasksDone'?: number;
    'chatConversationId'?: number;
    'activeJobStatus'?: string;
    'workingAgentName'?: string;
    /**
     * What an agent on this card is asleep waiting for, if anything. Null when no agent has an active deferred wait on the card.
     */
    'waitingFor'?: string;
    /**
     * Total USD cost of the card\'s agent conversation turns
     */
    'totalCostUsd'?: number;
    'dependsOn'?: Array<DependencyCardSummary>;
    'blocks'?: Array<DependencyCardSummary>;
    'unresolvedDependsOn'?: Array<DependencyCardSummary>;
    'createdAt'?: string;
    'updatedAt'?: string;
}

export const ProjectBoardCardPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectBoardCardPriorityEnum = typeof ProjectBoardCardPriorityEnum[keyof typeof ProjectBoardCardPriorityEnum];
export const ProjectBoardCardEffectivePriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectBoardCardEffectivePriorityEnum = typeof ProjectBoardCardEffectivePriorityEnum[keyof typeof ProjectBoardCardEffectivePriorityEnum];

export interface ProjectBoardResponse {
    'project'?: Project;
    'columns'?: Array<ProjectColumn>;
    'epics'?: Array<ProjectEpic>;
    'sprints'?: Array<ProjectSprint>;
    'cards'?: Array<ProjectBoardCard>;
    'labels'?: Array<ProjectLabel>;
    'members'?: Array<ProjectMemberRef>;
    'agents'?: Array<ProjectAgentRef>;
}
export interface ProjectCardCreateRequest {
    'title': string;
    'description'?: string;
    /**
     * Column within the card\'s epic; only valid with a sprint (backlog cards have no column)
     */
    'columnId'?: number;
    'epicId'?: number;
    'sprintId'?: number;
    'labelIds'?: Array<number>;
    'agentIds'?: Array<number>;
    'tasks'?: Array<string>;
    'priority'?: ProjectCardCreateRequestPriorityEnum;
}

export const ProjectCardCreateRequestPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectCardCreateRequestPriorityEnum = typeof ProjectCardCreateRequestPriorityEnum[keyof typeof ProjectCardCreateRequestPriorityEnum];

export interface ProjectCardDetail {
    'id'?: number;
    'projectId'?: number;
    /**
     * Null for backlog cards (the backlog has no columns)
     */
    'columnId'?: number;
    'epicId'?: number;
    'sprintId'?: number;
    'archived'?: boolean;
    /**
     * While true, no agent starts or continues work on this card
     */
    'paused'?: boolean;
    'priority'?: ProjectCardDetailPriorityEnum;
    'effectivePriority'?: ProjectCardDetailEffectivePriorityEnum;
    'projectPriority'?: ProjectCardDetailProjectPriorityEnum;
    'epicPriority'?: ProjectCardDetailEpicPriorityEnum;
    'cardNumber'?: number;
    'reference'?: string;
    'title'?: string;
    'description'?: string;
    'chatConversationId'?: number;
    'labelIds'?: Array<number>;
    'agents'?: Array<ProjectAgentRef>;
    'tasks'?: Array<ProjectTask>;
    'attachments'?: Array<ProjectAttachment>;
    /**
     * Team shared-drive files linked to this card
     */
    'linkedFiles'?: Array<ProjectLinkedFile>;
    'comments'?: Array<ProjectComment>;
    'activity'?: Array<ProjectActivityEvent>;
    'activeWork'?: CardActiveWork;
    /**
     * Total USD cost of the card\'s agent conversation turns
     */
    'totalCostUsd'?: number;
    'dependsOn'?: Array<DependencyCardSummary>;
    'blocks'?: Array<DependencyCardSummary>;
    'unresolvedDependsOn'?: Array<DependencyCardSummary>;
    'createdAt'?: string;
    'updatedAt'?: string;
}

export const ProjectCardDetailPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectCardDetailPriorityEnum = typeof ProjectCardDetailPriorityEnum[keyof typeof ProjectCardDetailPriorityEnum];
export const ProjectCardDetailEffectivePriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectCardDetailEffectivePriorityEnum = typeof ProjectCardDetailEffectivePriorityEnum[keyof typeof ProjectCardDetailEffectivePriorityEnum];
export const ProjectCardDetailProjectPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectCardDetailProjectPriorityEnum = typeof ProjectCardDetailProjectPriorityEnum[keyof typeof ProjectCardDetailProjectPriorityEnum];
export const ProjectCardDetailEpicPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectCardDetailEpicPriorityEnum = typeof ProjectCardDetailEpicPriorityEnum[keyof typeof ProjectCardDetailEpicPriorityEnum];

export interface ProjectCardDetailResponse {
    'card'?: ProjectCardDetail;
}
export interface ProjectCardDispatchChoice {
    'columnName'?: string;
    'assignees'?: Array<ProjectCardDispatchChoiceAssigneesInner>;
}
export interface ProjectCardDispatchChoiceAssigneesInner {
    'id'?: number;
    'name'?: string;
    'jobDescription'?: string;
}
/**
 * @type ProjectCardDispatchRequest
 * Exactly one of agentId or orchestrator
 */
export type ProjectCardDispatchRequest = ProjectCardDispatchToAgent | ProjectCardDispatchToOrchestrator;

export interface ProjectCardDispatchResponse {
    'dispatched'?: boolean;
    'targetAgentId'?: number;
    'jobTriggered'?: boolean;
    'alreadyQueued'?: boolean;
    'waitingOn'?: Array<string>;
    /**
     * Why nothing was dispatched (policy refusal), when dispatched is false
     */
    'reason'?: string;
}
export interface ProjectCardDispatchToAgent {
    /**
     * Start work for this agent (must be on the card or its project)
     */
    'agentId': number;
}
export interface ProjectCardDispatchToOrchestrator {
    /**
     * Let agents decide - notify the team\'s orchestrating agent to assign and dispatch; must be true
     */
    'orchestrator': boolean;
}
export interface ProjectCardMoveProjectPreflightResponse {
    /**
     * True when every assigned agent already has target access
     */
    'ok'?: boolean;
    'missingAgents'?: Array<ProjectCardMoveProjectPreflightResponseMissingAgentsInner>;
    'targetProject'?: ProjectCardMoveProjectPreflightResponseTargetProject;
}
export interface ProjectCardMoveProjectPreflightResponseMissingAgentsInner {
    'id'?: number;
    'name'?: string;
}
export interface ProjectCardMoveProjectPreflightResponseTargetProject {
    'id'?: number;
    'name'?: string;
    'key'?: string;
    'epics'?: Array<ProjectMoveDestinationOption>;
    /**
     * Every epic\'s columns; filter by epicId (columns are per-epic)
     */
    'columns'?: Array<ProjectMoveDestinationColumn>;
    'sprints'?: Array<ProjectMoveDestinationOption>;
}
export interface ProjectCardMoveProjectRequest {
    'targetProjectId': number;
    'epicId': number;
    /**
     * Column within the target epic. Omitted, the card keeps its current column name when the epic has one, else lands in the epic\'s first column. Not valid for backlog destinations — backlog cards have no column.
     */
    'columnId'?: number;
    /**
     * Omit or null for the target project\'s backlog
     */
    'sprintId'?: number;
}
export interface ProjectCardMoveProjectResponse {
    'cardId'?: number;
    'projectId'?: number;
    /**
     * The card\'s new
     */
    'reference'?: string;
}
export interface ProjectCardMoveRequest {
    /**
     * Column within the destination epic. When the epic changes and no column is given, the card lands in the same-named column there (else the epic\'s first). Not valid together with toBacklog — backlog cards have no column.
     */
    'columnId'?: number;
    'epicId'?: number;
    /**
     * Sprint to move the card into; omit to keep its sprint
     */
    'sprintId'?: number;
    /**
     * true moves the card out of every sprint, into the backlog (clearing its column)
     */
    'toBacklog'?: boolean;
    'position'?: number;
    'priority'?: ProjectCardMoveRequestPriorityEnum;
}

export const ProjectCardMoveRequestPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectCardMoveRequestPriorityEnum = typeof ProjectCardMoveRequestPriorityEnum[keyof typeof ProjectCardMoveRequestPriorityEnum];

export interface ProjectCardMoveResponse {
    'cardId'?: number;
    /**
     * Null for backlog placements
     */
    'columnId'?: number;
    'epicId'?: number;
    'sprintId'?: number;
    'position'?: number;
    'priority'?: ProjectCardMoveResponsePriorityEnum;
    'jobTriggered'?: boolean;
    /**
     * Set when a human moved the card into a column that starts work on move-in and the card has several assignees; the move is complete, and the human chooses who starts through the dispatch endpoint (or dismisses to start nobody)
     */
    'dispatchChoice'?: ProjectCardDispatchChoice;
}

export const ProjectCardMoveResponsePriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectCardMoveResponsePriorityEnum = typeof ProjectCardMoveResponsePriorityEnum[keyof typeof ProjectCardMoveResponsePriorityEnum];

export interface ProjectCardUpdateRequest {
    'title'?: string;
    'description'?: string;
    'labelIds'?: Array<number>;
    'archived'?: boolean;
    /**
     * While true, no agent starts or continues work on this card
     */
    'paused'?: boolean;
    'priority'?: ProjectCardUpdateRequestPriorityEnum;
}

export const ProjectCardUpdateRequestPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectCardUpdateRequestPriorityEnum = typeof ProjectCardUpdateRequestPriorityEnum[keyof typeof ProjectCardUpdateRequestPriorityEnum];

export interface ProjectColumn {
    'id'?: number;
    'projectId'?: number;
    /**
     * Epic that owns this column (each epic has its own column set)
     */
    'epicId'?: number;
    'name'?: string;
    /**
     * What a card sitting in this column/status means
     */
    'description'?: string;
    'position'?: number;
    'archived'?: boolean;
    /**
     * Moving a card into this column fires confetti for board viewers
     */
    'celebration'?: boolean;
    /**
     * Agents may start or claim work on cards in this column (humans are never restricted; default true)
     */
    'agentCanWork'?: boolean;
    /**
     * Agents may change fields, checklist, attachments and assignments of cards in this column (default true)
     */
    'agentCanEdit'?: boolean;
    /**
     * Agents may move a card out of this column; moving into any column is governed only by the source column (default true)
     */
    'agentCanMoveOut'?: boolean;
    /**
     * When a human moves a card into this column and agents may work here, start its single assigned agent or ask who should (default false)
     */
    'enqueueOnHumanMoveIn'?: boolean;
}
export interface ProjectColumnRequest {
    'name'?: string;
    /**
     * What a card sitting in this column/status means
     */
    'description'?: string;
    /**
     * Epic that owns the column (required when creating; columns are per-epic)
     */
    'epicId'?: number;
    'position'?: number;
    /**
     * true archives the column (its cards move to moveCardsTo); false restores it
     */
    'archived'?: boolean;
    /**
     * Active column in the same epic that receives the archived column\'s cards (required when archiving)
     */
    'moveCardsTo'?: number;
    /**
     * Moving a card into this column fires confetti for board viewers
     */
    'celebration'?: boolean;
    /**
     * Agents may start or claim work on cards in this column (humans are never restricted; default true)
     */
    'agentCanWork'?: boolean;
    /**
     * Agents may change fields, checklist, attachments and assignments of cards in this column (default true)
     */
    'agentCanEdit'?: boolean;
    /**
     * Agents may move a card out of this column; moving into any column is governed only by the source column (default true)
     */
    'agentCanMoveOut'?: boolean;
    /**
     * When a human moves a card into this column and agents may work here, start its single assigned agent or ask who should (default false)
     */
    'enqueueOnHumanMoveIn'?: boolean;
}
export interface ProjectColumnResponse {
    'column'?: ProjectColumn;
}
export interface ProjectComment {
    'changeReceipts'?: Array<ChatChangeReceipt>;
    /**
     * Archived comments are hidden by default; humans see empty placeholders until explicitly revealed.
     */
    'archivedAt'?: string;
    'id'?: number;
    'role'?: string;
    'agentId'?: number;
    'agentName'?: string;
    'externalWorkSessionId'?: number;
    'externalClient'?: ProjectCommentExternalClientEnum;
    'externalModel'?: string;
    'userId'?: number;
    'userName'?: string;
    'content'?: string;
    'mentions'?: Array<number>;
    'suppressedMentions'?: Array<SuppressedMentionAnnotation>;
    'status'?: string;
    'createdAt'?: string;
    /**
     * Agents this comment mentions that have not picked it up: no answer yet and no work request of its own. Empty once each is claimed, answered, or retired. 
     */
    'pendingMentions'?: Array<ProjectCommentPendingMentionsInner>;
    'interaction'?: Record<string, any>;
    /**
     * Set when this reply answers a comment a person had already asked past. A pending @mention gets work of its own only when the card next frees up, so an owed answer can arrive hours later, underneath a live exchange about something else. Present means the client must say which comment the reply answers; null (the ordinary case) means the reply follows what it answers. 
     */
    'answersEarlierMessage'?: AnsweredEarlierComment;
    'systemEvent'?: ChatArtifactCreatedEvent | null;
}

export const ProjectCommentExternalClientEnum = {
    Codex: 'codex',
    ClaudeCode: 'claude_code',
    Other: 'other'
} as const;

export type ProjectCommentExternalClientEnum = typeof ProjectCommentExternalClientEnum[keyof typeof ProjectCommentExternalClientEnum];

export interface ProjectCommentPendingMentionsInner {
    'agentId': number;
    'agentName': string;
}
export interface ProjectCommentRequest {
    'text': string;
}
export interface ProjectCommentResponse {
    'comment'?: ProjectComment;
    'jobTriggered'?: boolean;
    /**
     * Cards this card depends on that have not reached Done. Non-empty means the mentioned agent\'s work was queued but not started; the dispatcher starts it once every card listed is Done. 
     */
    'waitingOn'?: Array<DependencyCardSummary>;
    /**
     * The mention landed on work already queued for this card rather than creating new work. With a non-empty waitingOn this is the \"already queued, still waiting on those cards\" case. 
     */
    'alreadyQueued'?: boolean;
    /**
     * The name of the card\'s column when its agent-access rules forbid agent work. The mentioned agent\'s request exists and is queued, but parked: no agent will claim it until a person moves the card or changes the column, so neither a dependency clearing nor waiting will start it. Null when nobody was mentioned or the column permits agent work. 
     */
    'workBlockedByColumn'?: string;
    'deferredBehindAgent'?: ProjectCommentResponseDeferredBehindAgent;
}
/**
 * The agent already running on this card when the comment handed work to a different one. Nothing was queued: the mention stays pending and is offered as work of its own when the running request finishes. Null in every other case. 
 */
export interface ProjectCommentResponseDeferredBehindAgent {
    'id': number;
    'name': string;
}
export interface ProjectCommentsResponse {
    'comments'?: Array<ProjectComment>;
}
export interface ProjectCreateRequest {
    'name': string;
    'key'?: string;
    'description'?: string;
    'agentIds'?: Array<number>;
    'memberUserIds'?: Array<number>;
}
export interface ProjectEpic {
    'id'?: number;
    'projectId'?: number;
    'name'?: string;
    'description'?: string;
    /**
     * Markdown guidance for how this epic\'s card descriptions are written
     */
    'cardTemplate'?: string;
    'archived'?: boolean;
    'priority'?: ProjectEpicPriorityEnum;
}

export const ProjectEpicPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectEpicPriorityEnum = typeof ProjectEpicPriorityEnum[keyof typeof ProjectEpicPriorityEnum];

export interface ProjectEpicRequest {
    'name'?: string;
    'description'?: string;
    /**
     * Markdown guidance for how this epic\'s card descriptions are written
     */
    'cardTemplate'?: string;
    'archived'?: boolean;
    /**
     * Also put the newly created epic row on this sprint\'s screen
     */
    'sprintId'?: number;
    'priority'?: ProjectEpicRequestPriorityEnum;
}

export const ProjectEpicRequestPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectEpicRequestPriorityEnum = typeof ProjectEpicRequestPriorityEnum[keyof typeof ProjectEpicRequestPriorityEnum];

export interface ProjectEpicResponse {
    'epic'?: ProjectEpic;
}
export interface ProjectLabel {
    'id'?: number;
    'projectId'?: number;
    'name'?: string;
    /**
     * Optional organizing group; labels sharing a group are shown together. Null means ungrouped.
     */
    'group'?: string;
    'color'?: string;
    'archived'?: boolean;
}
export interface ProjectLabelGroupRenameRequest {
    /**
     * The group being renamed (matched case-insensitively)
     */
    'group': string;
    /**
     * New group name; empty or null ungroups every label that was in the group
     */
    'newGroup'?: string;
}
export interface ProjectLabelGroupRenameResponse {
    /**
     * How many labels moved
     */
    'updated'?: number;
}
export interface ProjectLabelRequest {
    'name'?: string;
    /**
     * Optional organizing group. Empty string or null clears it (the label becomes ungrouped).
     */
    'group'?: string;
    'color'?: string;
    /**
     * true archives the label (hidden but card associations kept); false restores it onto its cards
     */
    'archived'?: boolean;
}
export interface ProjectLabelResponse {
    'label'?: ProjectLabel;
}
export interface ProjectLinkedFile {
    'id'?: number;
    'name'?: string;
    'sizeBytes'?: number;
    'updatedAt'?: string;
}
export interface ProjectListResponse {
    'projects'?: Array<Project>;
}
export interface ProjectMemberRef {
    'userId'?: number;
    'name'?: string;
}
export interface ProjectMemberRequest {
    'userId': number;
}
export interface ProjectMoveDestinationColumn {
    'id'?: number;
    /**
     * Epic that owns this column
     */
    'epicId'?: number;
    'name'?: string;
}
export interface ProjectMoveDestinationOption {
    'id'?: number;
    'name'?: string;
}
export interface ProjectResponse {
    'project'?: Project;
}
export interface ProjectSearchResponse {
    'results'?: Array<ProjectSearchResult>;
}
export interface ProjectSearchResult {
    'type'?: string;
    'projectId'?: number;
    'projectName'?: string;
    'reference'?: string;
    'cardId'?: number;
    'cardTitle'?: string;
    'columnName'?: string;
    'taskId'?: number;
    'messageId'?: number;
    'snippet'?: string;
    'updatedAt'?: string;
}
export interface ProjectSprint {
    'id'?: number;
    'projectId'?: number;
    /**
     * Display name, always \"Sprint N\" (from the position)
     */
    'name'?: string;
    'description'?: string;
    'startDate'?: string;
    'endDate'?: string;
    'position'?: number;
    'archived'?: boolean;
    'active'?: boolean;
    'epicIds'?: Array<number>;
}
export interface ProjectSprintRequest {
    'description'?: string;
    'startDate'?: string;
    'endDate'?: string;
    /**
     * true archives the sprint (cards stay); false restores it
     */
    'archived'?: boolean;
    /**
     * true makes this the project\'s single active sprint
     */
    'active'?: boolean;
}
export interface ProjectSprintResponse {
    'sprint'?: ProjectSprint;
}
export interface ProjectTask {
    'id'?: number;
    'cardId'?: number;
    'title'?: string;
    'position'?: number;
    'done'?: boolean;
    'doneAt'?: string;
    'doneByUserId'?: number;
    'doneByAgentId'?: number;
}
export interface ProjectTaskRequest {
    'title'?: string;
    'position'?: number;
    'done'?: boolean;
}
export interface ProjectTaskResponse {
    'task'?: ProjectTask;
}
/**
 * Token usage for one project over a preset range, plus what those tokens cost split by direction. It carries no billing-category costs: the project cost table is served separately by /api/projects/{projectId}/costs. Tokens are attributed through the work stream that produced them (metrics.work_stream_id -> work_streams.project_id), so usage recorded without a work stream belongs to no project and is absent here. Project cost is attributed independently, from billing_ledger.project_id, so the same usage can appear in a project\'s cost total while contributing nothing to these token totals.
 */
export interface ProjectTokenTimeseriesResponse {
    /**
     * The project the series is scoped to
     */
    'projectId': number;
    /**
     * The project\'s owning team
     */
    'teamId': number;
    /**
     * The preset range that was queried
     */
    'range': string;
    /**
     * Bucket size the server chose for this range
     */
    'bucket': ProjectTokenTimeseriesResponseBucketEnum;
    /**
     * Start of the queried period
     */
    'startDate': string;
    /**
     * End of the queried period
     */
    'endDate': string;
    'tokens': TokenTimeseries;
    'costByDirection': CostByDirection;
}

export const ProjectTokenTimeseriesResponseBucketEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type ProjectTokenTimeseriesResponseBucketEnum = typeof ProjectTokenTimeseriesResponseBucketEnum[keyof typeof ProjectTokenTimeseriesResponseBucketEnum];

export interface ProjectUpdateRequest {
    'name'?: string;
    /**
     * Short uppercase team-unique key used in card references like
     */
    'key'?: string;
    'description'?: string;
    'archived'?: boolean;
    /**
     * While true, no agent starts or continues work on this project
     */
    'paused'?: boolean;
    /**
     * Null inherits the team setting
     */
    'workingStyleOverride'?: ProjectUpdateRequestWorkingStyleOverrideEnum;
    /**
     * Null inherits the team setting
     */
    'cautiousMaxReinvocationsOverride'?: number;
    /**
     * Null inherits the team setting
     */
    'fullSendMaxHandoffsOverride'?: number;
    'cardExecutionMode'?: ProjectUpdateRequestCardExecutionModeEnum;
    'priority'?: ProjectUpdateRequestPriorityEnum;
    /**
     * Retention period for newly-created Work stream file and browser artifacts
     */
    'workStreamArtifactRetentionDays'?: number;
}

export const ProjectUpdateRequestWorkingStyleOverrideEnum = {
    NoAgents: 'no_agents',
    HumansDriveAgents: 'humans_drive_agents',
    AgentsCautiouslyDriveAgents: 'agents_cautiously_drive_agents',
    AgentsFullSend: 'agents_full_send'
} as const;

export type ProjectUpdateRequestWorkingStyleOverrideEnum = typeof ProjectUpdateRequestWorkingStyleOverrideEnum[keyof typeof ProjectUpdateRequestWorkingStyleOverrideEnum];
export const ProjectUpdateRequestCardExecutionModeEnum = {
    Serial: 'serial',
    Parallel: 'parallel'
} as const;

export type ProjectUpdateRequestCardExecutionModeEnum = typeof ProjectUpdateRequestCardExecutionModeEnum[keyof typeof ProjectUpdateRequestCardExecutionModeEnum];
export const ProjectUpdateRequestPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type ProjectUpdateRequestPriorityEnum = typeof ProjectUpdateRequestPriorityEnum[keyof typeof ProjectUpdateRequestPriorityEnum];

export interface ProviderModel {
    /**
     * The model id sent to the provider API
     */
    'name': string;
    'displayName'?: string;
    'brand'?: string;
    'description'?: string;
    'detailedDescription'?: string;
    'catalogPrice': CatalogPriceQuote;
    'estimatedCustomerPrice'?: ModelPricing;
    'pricingUnavailable'?: boolean;
    'contextWindow'?: number;
    /**
     * Whether the provider reports an active loaded instance
     */
    'loaded'?: boolean;
    /**
     * Whether the model supports live bidirectional audio
     */
    'supportsLiveAudio'?: boolean;
    /**
     * Which kind of audio the model generates. Speech and music models are not substitutes and have separate slots.
     */
    'audioKind'?: ProviderModelAudioKindEnum;
    /**
     * Output modalities the model can emit. Absent means text-only. A model listing \"image\" may be assigned to the image generation slot and to no other slot.
     */
    'outputModalities'?: Array<ProviderModelOutputModalitiesEnum>;
    'acceptedInputs'?: Array<AcceptedModelInput>;
    'videoCapabilities'?: VideoCapabilities;
    'videoPricing'?: VideoPricing;
    'defaultConfig': ModelConfig;
    /**
     * Whether the instance\'s allow-list permits this model
     */
    'allowed': boolean;
}

export const ProviderModelAudioKindEnum = {
    Speech: 'speech',
    Music: 'music'
} as const;

export type ProviderModelAudioKindEnum = typeof ProviderModelAudioKindEnum[keyof typeof ProviderModelAudioKindEnum];
export const ProviderModelOutputModalitiesEnum = {
    Text: 'text',
    Image: 'image',
    Audio: 'audio',
    Video: 'video'
} as const;

export type ProviderModelOutputModalitiesEnum = typeof ProviderModelOutputModalitiesEnum[keyof typeof ProviderModelOutputModalitiesEnum];

export interface ProviderModelsResponse {
    'models': Array<ProviderModel>;
}
export interface PublicMarketingEmailConsentRequest {
    'decision': PublicMarketingEmailConsentRequestDecisionEnum;
}

export const PublicMarketingEmailConsentRequestDecisionEnum = {
    Accepted: 'accepted',
    Declined: 'declined'
} as const;

export type PublicMarketingEmailConsentRequestDecisionEnum = typeof PublicMarketingEmailConsentRequestDecisionEnum[keyof typeof PublicMarketingEmailConsentRequestDecisionEnum];


export const Quantization = {
    Fp32: 'fp32',
    Bf16: 'bf16',
    Fp16: 'fp16',
    Fp8: 'fp8',
    Fp6: 'fp6',
    Fp4: 'fp4',
    Int8: 'int8',
    Int4: 'int4',
    Unknown: 'unknown'
} as const;

export type Quantization = typeof Quantization[keyof typeof Quantization];


export interface RegisterWebPushSubscriptionRequest {
    'subscription': WebPushSubscriptionMaterial;
    'device': WebPushDeviceMetadata;
    /**
     * Explicit user intent to restore a previously revoked capability. Background reconciliation must omit this field or send false.
     */
    'reactivate'?: boolean;
    /**
     * Sanitized server device id previously returned for this browser capability. When supplied, registration atomically rotates that exact non-revoked device in place or fails closed with a continuity conflict.
     */
    'previousSubscriptionId'?: number;
}
export interface ReleaseNoteEntry {
    /**
     * Stable identity of the entry (its filename stem)
     */
    'slug'?: string;
    /**
     * Release date, YYYY-MM-DD
     */
    'date'?: string;
    'title'?: string;
    /**
     * Body markdown, with the title heading removed
     */
    'markdown'?: string;
}
export interface ReleaseNotesResponse {
    'notes'?: Array<ReleaseNoteEntry>;
    'latestSlug'?: string;
    /**
     * Release date of the newest entry this user has opened, or null if they never have.
     */
    'lastViewedDate'?: string;
}
export interface ReleaseNotesViewedResponse {
    'ok'?: boolean;
    'lastViewedDate'?: string;
}
export interface RemoveAllWebPushDevicesResponse {
    'removed': number;
}
export interface ResolveSlotPolicyRequest {
    'policy': ModelSlotPolicy;
    'slot': ModelSlot;
}


export interface ResolvedVoiceProfile {
    'config': VoiceTalkConfig;
    'profile': VoiceProfile;
}
export interface Role {
    /**
     * null for built-ins, which are code constants, not rows
     */
    'id'?: number;
    /**
     * The built-in role key; null for custom roles
     */
    'key'?: RoleKeyEnum;
    'name': string;
    'description'?: string;
    /**
     * resource -> highest level held. An absent resource means no access. Levels are \'view\', \'edit\' or \'manage\'. project_comment (Card comments) uses edit for archiving and manage for permanent deletion of archived comments. Only direct humans may reveal or delete archived comments. 
     */
    'permissions': { [key: string]: string; };
    /**
     * Built-ins are read-only templates; edits are refused
     */
    'builtIn': boolean;
    /**
     * True for Administrator, which is team scope only
     */
    'teamScopeOnly'?: boolean;
    'assignmentCount'?: number;
    /**
     * Domain names whose auto-join currently points at this role. Always empty for built-ins. 
     */
    'autoJoinDomains'?: Array<string>;
}

export const RoleKeyEnum = {
    Administrator: 'administrator',
    Manager: 'manager',
    Contributor: 'contributor',
    Viewer: 'viewer',
    Billing: 'billing'
} as const;

export type RoleKeyEnum = typeof RoleKeyEnum[keyof typeof RoleKeyEnum];
export const RolePermissionsEnum = {
    View: 'view',
    Edit: 'edit',
    Manage: 'manage'
} as const;

export type RolePermissionsEnum = typeof RolePermissionsEnum[keyof typeof RolePermissionsEnum];

export interface RoleAssignment {
    'id': number;
    'teamId': number;
    'userId': number;
    'userName'?: string;
    'userEmail'?: string;
    'builtinRole'?: RoleAssignmentBuiltinRoleEnum;
    'roleId'?: number;
    'roleName'?: string;
    'builtIn': boolean;
    'scopeType': RoleAssignmentScopeTypeEnum;
    'projectId'?: number;
    'grantedByUserId'?: number;
    'createdAt'?: string;
}

export const RoleAssignmentBuiltinRoleEnum = {
    Administrator: 'administrator',
    Manager: 'manager',
    Contributor: 'contributor',
    Viewer: 'viewer',
    Billing: 'billing'
} as const;

export type RoleAssignmentBuiltinRoleEnum = typeof RoleAssignmentBuiltinRoleEnum[keyof typeof RoleAssignmentBuiltinRoleEnum];
export const RoleAssignmentScopeTypeEnum = {
    Team: 'team',
    Project: 'project'
} as const;

export type RoleAssignmentScopeTypeEnum = typeof RoleAssignmentScopeTypeEnum[keyof typeof RoleAssignmentScopeTypeEnum];

/**
 * Exactly one of builtinRole or roleId must be provided.
 */
export interface RoleAssignmentInput {
    'userId': number;
    'builtinRole'?: RoleAssignmentInputBuiltinRoleEnum;
    'roleId'?: number;
    'scopeType': RoleAssignmentInputScopeTypeEnum;
    /**
     * Required iff scopeType is \'project\'
     */
    'projectId'?: number;
}

export const RoleAssignmentInputBuiltinRoleEnum = {
    Administrator: 'administrator',
    Manager: 'manager',
    Contributor: 'contributor',
    Viewer: 'viewer',
    Billing: 'billing'
} as const;

export type RoleAssignmentInputBuiltinRoleEnum = typeof RoleAssignmentInputBuiltinRoleEnum[keyof typeof RoleAssignmentInputBuiltinRoleEnum];
export const RoleAssignmentInputScopeTypeEnum = {
    Team: 'team',
    Project: 'project'
} as const;

export type RoleAssignmentInputScopeTypeEnum = typeof RoleAssignmentInputScopeTypeEnum[keyof typeof RoleAssignmentInputScopeTypeEnum];

export interface RoleAssignmentResult {
    'assignment': RoleAssignment;
    /**
     * True when the grant confers nothing at the scope it was made — a project-scoped grant of a role holding only team-level resources. 
     */
    'inert': boolean;
}
export interface RoleDeleteResult {
    /**
     * How many assignments the delete revoked
     */
    'removedAssignments': number;
}
export interface RoleInput {
    'name': string;
    'description'?: string;
    /**
     * resource -> highest level held. An absent resource means no access. Levels are \'view\', \'edit\' or \'manage\'. project_comment (Card comments) uses edit for archiving and manage for permanent deletion of archived comments. Only direct humans may reveal or delete archived comments. 
     */
    'permissions': { [key: string]: string; };
}

export const RoleInputPermissionsEnum = {
    View: 'view',
    Edit: 'edit',
    Manage: 'manage'
} as const;

export type RoleInputPermissionsEnum = typeof RoleInputPermissionsEnum[keyof typeof RoleInputPermissionsEnum];

export interface RoleUpdateInput {
    'name'?: string;
    'description'?: string;
    /**
     * resource -> highest level held. An absent resource means no access. Levels are \'view\', \'edit\' or \'manage\'. project_comment (Card comments) uses edit for archiving and manage for permanent deletion of archived comments. Only direct humans may reveal or delete archived comments. 
     */
    'permissions'?: { [key: string]: string; };
}

export const RoleUpdateInputPermissionsEnum = {
    View: 'view',
    Edit: 'edit',
    Manage: 'manage'
} as const;

export type RoleUpdateInputPermissionsEnum = typeof RoleUpdateInputPermissionsEnum[keyof typeof RoleUpdateInputPermissionsEnum];

export interface ScheduledTask {
    'id'?: number;
    'teamId'?: number;
    'agentId'?: number;
    'agentName'?: string;
    'createdByUserId'?: number;
    'name'?: string;
    'cronExpression'?: string;
    'prompt'?: string;
    'enabled'?: boolean;
    'nextRunAt'?: string;
    'lastRunAt'?: string;
    'lastStartedAt'?: string;
    'lastCompletedAt'?: string;
    'runningJobId'?: number;
    'lastJobId'?: number;
    'lastChatConversationId'?: number;
    'failureCount'?: number;
    'lastError'?: string;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface ScheduledTaskDispatchResponse {
    'dispatched'?: number;
    'skipped'?: number;
    'errors'?: Array<string>;
}
export interface ScheduledTaskListResponse {
    'scheduledTasks'?: Array<ScheduledTask>;
}
export interface ScheduledTaskRequest {
    'name': string;
    'cronExpression': string;
    'prompt': string;
    'enabled'?: boolean;
    'agentId'?: number;
}
export interface ScheduledTaskResponse {
    'scheduledTask'?: ScheduledTask;
}
export interface SendExternalWorkMessageRequest {
    'content': string;
}
export interface SetAutoJoinRequest {
    'enabled': boolean;
    /**
     * Exactly one of builtinRole or roleId is required when enabling; neither is read when disabling.
     */
    'builtinRole'?: string;
    'roleId'?: number;
}
export interface SetLoginModeRequest {
    'mode': SetLoginModeRequestModeEnum;
}

export const SetLoginModeRequestModeEnum = {
    None: 'none',
    Saml: 'saml',
    Google: 'google',
    Passkey: 'passkey',
    Password: 'password'
} as const;

export type SetLoginModeRequestModeEnum = typeof SetLoginModeRequestModeEnum[keyof typeof SetLoginModeRequestModeEnum];

export interface SetSsoConnectionRequest {
    /**
     * The connection this domain should trust, or null to unbind whichever one it currently trusts.
     */
    'connectionId': number;
}
export interface Skill {
    'id'?: number;
    'agentId'?: number;
    /**
     * Short lower_snake_case skill name
     */
    'name'?: string;
    /**
     * One line shown to the model in the skill catalog
     */
    'description'?: string;
    /**
     * Markdown instructions injected when the skill is loaded
     */
    'content'?: string;
    /**
     * Bundle keys auto-loaded together with this skill
     */
    'requiredBundles'?: Array<string>;
    'createdBy'?: SkillCreatedByEnum;
    'activationMode'?: SkillActivationMode;
    'outcomes'?: Array<SkillOutcome>;
    /**
     * Provenance for skills imported from a skills provider
     */
    'sourceMetadata'?: Record<string, any>;
    'createdAt'?: string;
    'updatedAt'?: string;
}

export const SkillCreatedByEnum = {
    User: 'user',
    Agent: 'agent'
} as const;

export type SkillCreatedByEnum = typeof SkillCreatedByEnum[keyof typeof SkillCreatedByEnum];


export const SkillActivationMode = {
    OnDemand: 'on_demand',
    Always: 'always',
    Disabled: 'disabled'
} as const;

export type SkillActivationMode = typeof SkillActivationMode[keyof typeof SkillActivationMode];


export interface SkillCandidate {
    'providerKey'?: string;
    'slug'?: string;
    'name'?: string;
    'description'?: string;
    'trustScore'?: number;
    'riskLevel'?: SkillCandidateRiskLevelEnum;
    'auditScore'?: number;
    'githubStars'?: number;
    'license'?: string;
    'repoUrl'?: string;
    'webUrl'?: string;
    'installCommand'?: string;
    'hasSkillMd'?: boolean;
    'hasBundledExtras'?: boolean;
}

export const SkillCandidateRiskLevelEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type SkillCandidateRiskLevelEnum = typeof SkillCandidateRiskLevelEnum[keyof typeof SkillCandidateRiskLevelEnum];

export interface SkillOutcome {
    'id': number;
    'description': string;
    'order': number;
    'fields': Array<SkillOutcomeField>;
}
export interface SkillOutcomeField {
    'id': number;
    'name': string;
    'type': SkillOutcomeFieldTypeEnum;
    'unit'?: string;
    'description'?: string;
}

export const SkillOutcomeFieldTypeEnum = {
    String: 'string',
    Number: 'number',
    Boolean: 'boolean',
    Date: 'date'
} as const;

export type SkillOutcomeFieldTypeEnum = typeof SkillOutcomeFieldTypeEnum[keyof typeof SkillOutcomeFieldTypeEnum];

export interface SkillOutcomeFieldInput {
    'id'?: number;
    'name': string;
    'type': SkillOutcomeFieldInputTypeEnum;
    'unit'?: string;
    'description'?: string;
}

export const SkillOutcomeFieldInputTypeEnum = {
    String: 'string',
    Number: 'number',
    Boolean: 'boolean',
    Date: 'date'
} as const;

export type SkillOutcomeFieldInputTypeEnum = typeof SkillOutcomeFieldInputTypeEnum[keyof typeof SkillOutcomeFieldInputTypeEnum];

export interface SkillOutcomeInput {
    'id'?: number;
    'description': string;
    'order': number;
    'fields': Array<SkillOutcomeFieldInput>;
}
export interface SkillSearchResponse {
    'providerKey'?: string;
    'externalSkillsEnabled'?: boolean;
    'filteredOutCount'?: number;
    'notImportableCount'?: number;
    'skills'?: Array<SkillCandidate>;
}
export interface SlotModelCandidate {
    'ref': SlotModelRef;
    'displayName': string;
    'order': number;
    'providers': Array<SlotProviderChoice>;
}
export interface SlotModelRef {
    'kind': SlotModelRefKindEnum;
    /**
     * Set when kind is \'model\'.
     */
    'canonicalModelId'?: string;
    /**
     * Set when kind is \'familyLatest\'. Follows our curated pointer rather than a provider\'s own moving alias, whose target changes without notice onto weights nobody here has evaluated.
     */
    'familyId'?: string;
}

export const SlotModelRefKindEnum = {
    Model: 'model',
    FamilyLatest: 'familyLatest'
} as const;

export type SlotModelRefKindEnum = typeof SlotModelRefKindEnum[keyof typeof SlotModelRefKindEnum];

export interface SlotProviderChoice {
    'modelProvider': ModelProviderName;
    /**
     * Team provider instance, or null for the platform default.
     */
    'providerId': number | null;
    /**
     * The model id THIS provider\'s API expects, which differs across providers for the same weights. Empty on a familyLatest choice, whose model id is only known once the pointer is resolved.
     */
    'providerModelId': string;
    'subProviderSlug': string;
    'subProviderName': string;
    /**
     * OpenRouter endpoint variant to pin routing to. Always null on a familyLatest choice: a tag names one model version and cannot survive the pointer moving, so those approvals are held per sub-processor and matched live instead.
     */
    'endpointTag'?: string;
    'minQuantization'?: Quantization;
    /**
     * Unapproved choices are retained so the picker can render the unchecked state, and so a provider instance cannot be deleted while any choice still names it.
     */
    'approved': boolean;
    'order': number;
    'snapshot': SlotProviderSnapshot;
}


export interface SlotProviderSnapshot {
    'quantization': Quantization;
    'contextWindow': number;
    'maxOutputTokens'?: number;
    'inputPerMillion': number;
    'outputPerMillion': number;
    /**
     * Empty means the sub-processor publishes no location.
     */
    'countryCodes': Array<string>;
}


export interface SlotResolutionPreview {
    'slot': ModelSlot;
    /**
     * Model x sub-processor pairs that survived every gate. Zero means nothing would run.
     */
    'candidateCount': number;
    'winner'?: SlotResolutionWinner;
    /**
     * Why nothing would run. Present exactly when candidateCount is 0.
     */
    'reason'?: string;
}


export interface SlotResolutionWinner {
    'displayName': string;
    'canonicalModelId': string;
    'subProviderName': string;
    /**
     * The router this sub-processor is reached through, when it is not reached directly.
     */
    'routedVia'?: string;
    'quantization': SlotResolutionWinnerQuantizationEnum;
    'contextWindow': number;
    'inputPerMillion': number;
    'outputPerMillion': number;
}

export const SlotResolutionWinnerQuantizationEnum = {
    Fp32: 'fp32',
    Bf16: 'bf16',
    Fp16: 'fp16',
    Fp8: 'fp8',
    Fp6: 'fp6',
    Fp4: 'fp4',
    Int8: 'int8',
    Int4: 'int4',
    Unknown: 'unknown'
} as const;

export type SlotResolutionWinnerQuantizationEnum = typeof SlotResolutionWinnerQuantizationEnum[keyof typeof SlotResolutionWinnerQuantizationEnum];

/**
 * How inference chooses among the approved (model x sub-processor) pairs. \'cheapest\' and \'quality\' rank every pair globally; \'manual\' honours the administrator\'s own order, models first then sub-processors.
 */

export const SlotStrategy = {
    Cheapest: 'cheapest',
    Quality: 'quality',
    Manual: 'manual'
} as const;

export type SlotStrategy = typeof SlotStrategy[keyof typeof SlotStrategy];


export interface SnapshotStatus {
    'providerKey'?: string;
    'url'?: string;
    'fetchedAt'?: string;
    'entryCount'?: number;
    'stale'?: boolean;
}
export interface SourceDocument {
    'id': number;
    'sourceId': number;
    'documentUrl': string;
    'contextKey'?: string;
    'createdAt': string;
    'updatedAt': string;
    'dateOfInterest'?: string;
    'title'?: string;
    'excluded'?: boolean;
    /**
     * Number of knowledge graph nodes associated with this document
     */
    'nodeCount'?: number;
    /**
     * Number of knowledge graph edges associated with this document
     */
    'edgeCount'?: number;
}
export interface SourceErrorResponse {
    /**
     * Error message
     */
    'message': string;
    /**
     * ID of the existing source (when a source with the same URL already exists)
     */
    'existingSourceId'?: number;
}
export interface SourceRequest {
    /**
     * Type of the source (e.g., \'http\', \'google-drive\')
     */
    'sourceType': string;
    /**
     * Source-type specific parameters
     */
    'parameters'?: Record<string, any>;
    /**
     * Optional credentials object to use with this source
     */
    'credentials'?: Record<string, any>;
    /**
     * How the source is made available to agents: \'none\' (not crawled; live lookups only), \'cache\' (local page copies stored for fast reading, no LLM indexing cost), \'full\' (cache plus searchable embeddings and knowledge graph).
     */
    'indexingMode'?: SourceRequestIndexingModeEnum;
    /**
     * Maximum number of pages a crawl of this source will visit. Configurable between 1 and 1000.
     */
    'maxPages'?: number;
}

export const SourceRequestIndexingModeEnum = {
    None: 'none',
    Cache: 'cache',
    Full: 'full'
} as const;

export type SourceRequestIndexingModeEnum = typeof SourceRequestIndexingModeEnum[keyof typeof SourceRequestIndexingModeEnum];

export interface SourceResponse {
    'id': number;
    'teamId': number;
    'sourceType': string;
    'name'?: string;
    'parameters'?: Record<string, any>;
    'createdAt': string;
    'updatedAt': string;
    /**
     * Number of vectors associated with this source
     */
    'vectorCount'?: number;
    'credential'?: CredentialSummary;
    'lastIndexingEnded'?: string;
    'lastIndexingStarted'?: string;
    /**
     * Timestamp when bot blocking behavior was last detected for this source
     */
    'botBlockerLastDetected'?: string;
    /**
     * How the source is made available to agents: \'none\' (not crawled), \'cache\' (local page copies only), \'full\' (cache plus searchable index)
     */
    'indexingMode'?: SourceResponseIndexingModeEnum;
    /**
     * Maximum number of pages a crawl of this source will visit
     */
    'maxPages'?: number;
    /**
     * Number of documents (pages) stored for this source
     */
    'documentCount'?: number;
    /**
     * Whether linking is allowed for this source-agent relationship (only present when retrieved in agent context)
     */
    'allowLinking'?: boolean;
}

export const SourceResponseIndexingModeEnum = {
    None: 'none',
    Cache: 'cache',
    Full: 'full'
} as const;

export type SourceResponseIndexingModeEnum = typeof SourceResponseIndexingModeEnum[keyof typeof SourceResponseIndexingModeEnum];

export interface SourceType {
    /**
     * Name of the source type Example: http, google-drive
     */
    'name': string;
    /**
     * A description of the source
     */
    'description': string;
    /**
     * Parameter definitions for this source type (key: param name, value: { type, required, description })
     */
    'parameters': { [key: string]: SourceTypeParametersValue; };
}
export interface SourceTypeParametersValue {
    'type'?: string;
    'required'?: boolean;
    'description'?: string;
}
export interface SsoMetadataPreview {
    'idpEntityId': string;
    'idpSsoUrl': string;
    'idpSloUrl': string;
    /**
     * PEM-encoded, in document order. Both the active and next certificate when the IdP publishes a rollover pair (e.g. Entra ID) — never only the first one found.
     */
    'idpSigningCertificates': Array<string>;
}
export interface StartVoiceSessionRequest {
    'commandId': string;
    'agentId': number;
}
export interface StopWorkStream202Response {
    'stop': WorkStreamStopResult;
}
export interface SubProcessorCountryPolicy {
    /**
     * \'all\' means the team has expressed no preference, so every sub-processor is acceptable.
     */
    'mode': SubProcessorCountryPolicyModeEnum;
    /**
     * Curated regulatory block ids, expanded to member countries.
     */
    'blocks': Array<string>;
    /**
     * Individually allowed ISO-3166-1 alpha-2 codes.
     */
    'countries': Array<string>;
    /**
     * Whether sub-processors that publish no location are acceptable. A first-class choice, because roughly a third publish none.
     */
    'allowUnknown': boolean;
}

export const SubProcessorCountryPolicyModeEnum = {
    All: 'all',
    Custom: 'custom'
} as const;

export type SubProcessorCountryPolicyModeEnum = typeof SubProcessorCountryPolicyModeEnum[keyof typeof SubProcessorCountryPolicyModeEnum];

export interface SubProcessorCountryView {
    /**
     * Null is the Unknown bucket, offered as its own choice.
     */
    'code': string;
    'name': string;
    'subProcessorCount': number;
    'allowed': boolean;
}
export interface SubProcessorPolicyView {
    'policy': SubProcessorCountryPolicy;
    'blocks': Array<CountryBlock>;
    'countries': Array<SubProcessorCountryView>;
    'subProcessors': Array<SubProcessorView>;
}
export interface SubProcessorView {
    'slug': string;
    'name': string;
    /**
     * Provider types through which this team reaches it.
     */
    'reachableVia': Array<string>;
    'countryCodes': Array<string>;
    'locationSource': SubProcessorViewLocationSourceEnum;
    'allowed': boolean;
    'privacyPolicyUrl'?: string;
    'termsOfServiceUrl'?: string;
}

export const SubProcessorViewLocationSourceEnum = {
    Curated: 'curated',
    Live: 'live',
    Unknown: 'unknown'
} as const;

export type SubProcessorViewLocationSourceEnum = typeof SubProcessorViewLocationSourceEnum[keyof typeof SubProcessorViewLocationSourceEnum];

export interface SubscriptionErrorInfo {
    'error'?: string;
    'violations'?: Array<TierViolationInfo>;
}
export interface SubscriptionInfo {
    'status': SubscriptionInfoStatusEnum;
    'tier': TierSummaryInfo;
    'scheduledTier'?: TierSummaryInfo;
    'scheduledCancellation': boolean;
    'trialEndsAt'?: string;
    'currentPeriodStart'?: string;
    'currentPeriodEnd'?: string;
    'graceExpiresAt'?: string;
    'seats': SubscriptionSeatsInfo;
    'nextRenewalAmountUsd'?: string;
}

export const SubscriptionInfoStatusEnum = {
    Trialing: 'trialing',
    Active: 'active',
    PastDue: 'past_due',
    Paused: 'paused',
    TrialExpired: 'trial_expired',
    Canceled: 'canceled'
} as const;

export type SubscriptionInfoStatusEnum = typeof SubscriptionInfoStatusEnum[keyof typeof SubscriptionInfoStatusEnum];

export interface SubscriptionInvoiceInfo {
    'id': number;
    'amountUsd': number;
    'status': string;
    'receiptNumber'?: string;
    'periodKey'?: string;
    'error'?: string;
    'created': string;
}
export interface SubscriptionSeatsInfo {
    'billableMembers': number;
    'viewerMembers': number;
    'billableInvites': number;
    'viewerInvites': number;
}
export interface SuppressedMentionAnnotation {
    'agentId': number;
    'start': number;
    'end': number;
    'outcome': SuppressedMentionAnnotationOutcomeEnum;
    'presentationText': string;
}

export const SuppressedMentionAnnotationOutcomeEnum = {
    NoActionRequested: 'no_action_requested',
    BlockedByPolicy: 'blocked_by_policy',
    ConfirmationFailed: 'confirmation_failed'
} as const;

export type SuppressedMentionAnnotationOutcomeEnum = typeof SuppressedMentionAnnotationOutcomeEnum[keyof typeof SuppressedMentionAnnotationOutcomeEnum];

export interface TeamModelCatalog {
    'models': Array<CanonicalModelSummary>;
    'families': Array<ModelFamily>;
    /**
     * Per provider instance, anything that went wrong while the catalog was assembled. Severity unavailable means it contributed no models; degraded means its models are present but worse than they look.
     */
    'providerIssues': Array<ModelCatalogProviderIssue>;
}
export interface TeamModelDefaultPreview {
    'slot': ModelSlot;
    'revision': number;
    /**
     * Null on nullable generative slots when nothing is configured
     */
    'currentDefault': ModelSlotConfig;
    'proposedDefault': ModelSlotConfig;
    'inheritingAgents': Array<AgentModelImpact>;
    'overridingAgents': Array<AgentModelImpact>;
}


export interface TeamModelDefaultsResponse {
    'revision': number;
    'interaction': ModelSlotPolicy;
    'knowledgeExtraction': ModelSlotPolicy;
    'live': VoiceTalkConfig;
    /**
     * Null when the team has no image-capable provider
     */
    'imageGeneration'?: ModelSlotPolicy;
    /**
     * Generated speech. Distinct from `live`, which is real-time conversation with the agent.
     */
    'speechGeneration'?: ModelSlotPolicy;
    /**
     * Generated music; not a substitute for speech.
     */
    'musicGeneration'?: ModelSlotPolicy;
    /**
     * Generated video. Seedance 2.5 through the platform fal.ai provider is the seeded default. Nullable only when the team deliberately clears the slot or for a legacy record. The stored policy remains configured, but resolution fails clearly if platform fal.ai is unavailable.
     */
    'videoGeneration'?: ModelSlotPolicy;
    /**
     * Video-input analysis that returns bounded text. Distinct from generated video and nullable when no eligible model is configured.
     */
    'videoInspection'?: ModelSlotPolicy;
}
export interface TeamModelProviderCreateRequest {
    'providerType': ModelProviderName;
    'name'?: string;
    'config'?: Record<string, any>;
    /**
     * Write-only; never returned by the API
     */
    'credentials'?: { [key: string]: string; };
    'allowedModels'?: AllowedModelsConfig;
}


export interface TeamModelProviderListResponse {
    'providers': Array<TeamModelProviderResponse>;
}
export interface TeamModelProviderResponse {
    /**
     * Null for platform default instances
     */
    'id'?: number;
    /**
     * Reference for the models endpoint (id or \"default-<type>\")
     */
    'key': string;
    'teamId': number;
    'providerType': ModelProviderName;
    'providerDisplayName': string;
    'description': string;
    'websiteUrl': string;
    'name': string;
    'isDefault': boolean;
    'enabled': boolean;
    'config': Record<string, any>;
    'allowedModels': AllowedModelsConfig;
    'secretsSet': Array<string>;
    'missingSecrets': Array<string>;
    'accessNote'?: string;
    /**
     * True when the team\'s plan excludes bring-your-own API keys, so this instance is listed but is not serving inference. Never set on the read-only platform defaults.
     */
    'frozenByTier'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
}


export interface TeamModelProviderUpdateRequest {
    'name'?: string;
    'config'?: Record<string, any>;
    /**
     * Write-only; merged key-wise, empty values keep stored secrets
     */
    'credentials'?: { [key: string]: string; };
    'allowedModels'?: AllowedModelsConfig;
}
export interface TeamNetworkPolicy {
    'teamId'?: number;
    'egressMode'?: TeamNetworkPolicyEgressModeEnum;
    'dnsResolver'?: string;
    'dnsResolverIps'?: string;
    'ipBlocklistProvider'?: string;
    'ipBlocklistUrl'?: string;
    'threatIntelDnsEnabled'?: boolean;
}

export const TeamNetworkPolicyEgressModeEnum = {
    PresetApproved: 'preset_approved',
    ApprovalRequired: 'approval_required',
    Off: 'off'
} as const;

export type TeamNetworkPolicyEgressModeEnum = typeof TeamNetworkPolicyEgressModeEnum[keyof typeof TeamNetworkPolicyEgressModeEnum];

export interface TeamNetworkPolicyBundle {
    'policy'?: TeamNetworkPolicy;
    'networkProtocols'?: Array<TeamNetworkPolicyBundleNetworkProtocolsEnum>;
    'presets'?: TeamNetworkPolicyBundlePresets;
    'snapshotStatus'?: Array<SnapshotStatus>;
}

export const TeamNetworkPolicyBundleNetworkProtocolsEnum = {
    Tcp: 'tcp',
    Udp: 'udp',
    Icmp: 'icmp'
} as const;

export type TeamNetworkPolicyBundleNetworkProtocolsEnum = typeof TeamNetworkPolicyBundleNetworkProtocolsEnum[keyof typeof TeamNetworkPolicyBundleNetworkProtocolsEnum];

export interface TeamNetworkPolicyBundlePresets {
    'dnsResolvers'?: Array<PolicyPresetOption>;
    'ipBlocklistProviders'?: Array<PolicyPresetOption>;
}
export interface TeamNetworkPolicyInput {
    'egressMode': string;
    'dnsResolver': string;
    'dnsResolverIps'?: string;
    'ipBlocklistProvider': string;
    'ipBlocklistUrl'?: string;
    'threatIntelDnsEnabled': boolean;
}
export interface TeamProjectActivityEvent {
    'id'?: number;
    'projectId'?: number;
    'cardId'?: number;
    'type'?: string;
    'actorUserId'?: number;
    'actorAgentId'?: number;
    'actorName'?: string;
    'externalWorkSessionId'?: number;
    'externalClient'?: TeamProjectActivityEventExternalClientEnum;
    'externalModel'?: string;
    'data'?: Record<string, any>;
    'createdAt'?: string;
    'projectName'?: string;
    'projectKey'?: string;
    'cardTitle'?: string;
}

export const TeamProjectActivityEventExternalClientEnum = {
    Codex: 'codex',
    ClaudeCode: 'claude_code',
    Other: 'other'
} as const;

export type TeamProjectActivityEventExternalClientEnum = typeof TeamProjectActivityEventExternalClientEnum[keyof typeof TeamProjectActivityEventExternalClientEnum];

export interface TeamProjectActivityResponse {
    'activity'?: Array<TeamProjectActivityEvent>;
    'nextBeforeId'?: number;
    'hasMore'?: boolean;
}
export interface TeamRoles {
    'builtin': Array<Role>;
    'custom': Array<Role>;
}
export interface TeamSecretActivityEvent {
    'id': string;
    'secretId': string | null;
    'versionId': string | null;
    'grantId': string | null;
    'requestId': string | null;
    'actor': TeamSecretActor;
    'origin': string;
    'action': string;
    'activeNameSnapshot': string;
    'beforeMetadata': TeamSecretAuditMetadata | null;
    'afterMetadata': TeamSecretAuditMetadata | null;
    'createdAt': string;
}
export interface TeamSecretActivityPage {
    'items': Array<TeamSecretActivityEvent>;
    'nextCursor': string | null;
}
export interface TeamSecretActor {
    'kind': TeamSecretActorKindEnum;
    'userId'?: number;
    'agentId'?: number;
}

export const TeamSecretActorKindEnum = {
    Human: 'human',
    Agent: 'agent',
    Migration: 'migration',
    System: 'system'
} as const;

export type TeamSecretActorKindEnum = typeof TeamSecretActorKindEnum[keyof typeof TeamSecretActorKindEnum];

export interface TeamSecretAuditMetadata {
    'normalizedName'?: string;
    'currentName'?: string;
    'description'?: string;
    'policy'?: TeamSecretPolicyV1;
    'priorVersionRetentionDays'?: number;
    'revision'?: number;
    'versionId'?: string;
    'previousVersionId'?: string;
    'currentVersionId'?: string;
    'restoredFromVersionId'?: string;
    'versionNumber'?: number;
    'grantId'?: string;
    'agentId'?: number;
    'granted'?: boolean;
    'requestId'?: string;
    'requestState'?: TeamSecretRequestState;
    'approvalRequestId'?: number;
    'mutationState'?: TeamSecretRequestState;
    'assignedAgentCount'?: number;
    'retainedVersionCount'?: number;
    'affectedSecretCount'?: number;
    'valueWillChange'?: boolean;
    'migrated'?: boolean;
    'deleted'?: boolean;
    'createdAt'?: string;
    'updatedAt'?: string;
    'supersededAt'?: string;
    'retainUntil'?: string;
    'expiresAt'?: string;
    'decidedAt'?: string;
    'deletedAt'?: string;
}


export interface TeamSecretConflictResponse {
    'error': TeamSecretError;
    'current'?: TeamSecretConflictResponseAllOfCurrent;
}
/**
 * @type TeamSecretConflictResponseAllOfCurrent
 */
export type TeamSecretConflictResponseAllOfCurrent = TeamSecretDetail | TeamSecretListItem;

export interface TeamSecretCreateRequest {
    'name': string;
    'description': string;
    'value': string;
    'policy': TeamSecretPolicyV1;
    'priorVersionRetentionDays'?: number;
}
export interface TeamSecretDeleteRequest {
    'confirmationName': string;
    'expectedRevision': number;
}
export interface TeamSecretDetail {
    'id': string;
    'currentName': string;
    'historicalNames': Array<string>;
    'description': string;
    'policy': TeamSecretPolicyV1;
    'revision': number;
    'priorVersionRetentionDays': number;
    'currentVersionId': string;
    'currentVersionNumber': number;
    'assignedAgentCount': number;
    'createdAt': string;
    'updatedAt': string;
    'names': Array<TeamSecretName>;
    'grants': Array<TeamSecretGrant>;
    'versions': Array<TeamSecretVersion>;
    'activity': Array<TeamSecretActivityEvent>;
    'activityNextCursor': string | null;
}
export interface TeamSecretError {
    'code': string;
    'message': string;
}
export interface TeamSecretErrorResponse {
    'error': TeamSecretError;
}
export interface TeamSecretErrorResponseBase {
    'error': TeamSecretError;
}
export interface TeamSecretGrant {
    'id': string;
    'agentId': number;
    'grantedByUserId': number | null;
    'grantedAt': string;
}
export interface TeamSecretListItem {
    'id': string;
    'currentName': string;
    'historicalNames': Array<string>;
    'description': string;
    'policy': TeamSecretPolicyV1;
    'revision': number;
    'priorVersionRetentionDays': number;
    'currentVersionId': string;
    'currentVersionNumber': number;
    'assignedAgentCount': number;
    'createdAt': string;
    'updatedAt': string;
}
export interface TeamSecretListItemBase {
    'id': string;
    'currentName': string;
    'historicalNames': Array<string>;
    'description': string;
    'policy': TeamSecretPolicyV1;
    'revision': number;
    'priorVersionRetentionDays': number;
    'currentVersionId': string;
    'currentVersionNumber': number;
    'assignedAgentCount': number;
    'createdAt': string;
    'updatedAt': string;
}
export interface TeamSecretName {
    'normalizedName': string;
    'current': boolean;
    'validFrom': string;
    'validUntil': string | null;
    'source': TeamSecretNameSourceEnum;
}

export const TeamSecretNameSourceEnum = {
    Create: 'create',
    Rename: 'rename',
    LegacyMigration: 'legacy_migration'
} as const;

export type TeamSecretNameSourceEnum = typeof TeamSecretNameSourceEnum[keyof typeof TeamSecretNameSourceEnum];

export interface TeamSecretPolicyV1 {
    'version': TeamSecretPolicyV1VersionEnum;
    'workspace': TeamSecretPolicyV1Workspace;
    'browser': TeamSecretPolicyV1Browser;
}

export const TeamSecretPolicyV1VersionEnum = {
    NUMBER_1: 1
} as const;

export type TeamSecretPolicyV1VersionEnum = typeof TeamSecretPolicyV1VersionEnum[keyof typeof TeamSecretPolicyV1VersionEnum];

export interface TeamSecretPolicyV1Browser {
    'enabled': boolean;
    'allowedOrigins': Array<string>;
}
export interface TeamSecretPolicyV1Workspace {
    'enabled': boolean;
    'allowedHosts': Array<string>;
}

export const TeamSecretRequestState = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected',
    Canceled: 'canceled',
    Expired: 'expired',
    Failed: 'failed'
} as const;

export type TeamSecretRequestState = typeof TeamSecretRequestState[keyof typeof TeamSecretRequestState];


export interface TeamSecretRestoreRequest {
    'expectedCurrentVersionId': string;
}
export interface TeamSecretRotateRequest {
    'expectedCurrentVersionId': string;
    'value': string;
}
export interface TeamSecretUpdateRequest {
    'expectedRevision': number;
    'name'?: string;
    'description'?: string;
    'policy'?: TeamSecretPolicyV1;
    'priorVersionRetentionDays'?: number;
}
export interface TeamSecretVersion {
    'id': string;
    'versionNumber': number;
    'current': boolean;
    'createdBy': TeamSecretActor;
    'createdAt': string;
    'supersededAt': string | null;
    'retainUntil': string | null;
}
export interface TeamSkillsPolicy {
    'teamId'?: number;
    'externalSkillsEnabled'?: boolean;
    'minTrustScore'?: number;
    'maxRisk'?: TeamSkillsPolicyMaxRiskEnum;
    'minGithubStars'?: number;
    'minAuditScore'?: number;
    'requireKnownLicense'?: boolean;
}

export const TeamSkillsPolicyMaxRiskEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type TeamSkillsPolicyMaxRiskEnum = typeof TeamSkillsPolicyMaxRiskEnum[keyof typeof TeamSkillsPolicyMaxRiskEnum];

export interface TeamSkillsPolicyInput {
    'externalSkillsEnabled': boolean;
    'minTrustScore': number;
    'maxRisk': TeamSkillsPolicyInputMaxRiskEnum;
    'minGithubStars': number;
    'minAuditScore': number;
    'requireKnownLicense': boolean;
}

export const TeamSkillsPolicyInputMaxRiskEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type TeamSkillsPolicyInputMaxRiskEnum = typeof TeamSkillsPolicyInputMaxRiskEnum[keyof typeof TeamSkillsPolicyInputMaxRiskEnum];

export interface TeamSsoConnection {
    'id': number;
    'teamId': number;
    'displayName': string;
    'idpEntityId': string;
    'idpSsoUrl': string;
    'idpSloUrl': string;
    'logoutResponseIssuer': string;
    'idpSigningCertificates': Array<TeamSsoConnectionCertificate>;
    'spEntityId': string;
    /**
     * Our SP\'s own certificate. Public — published in SP metadata.
     */
    'spCertificatePem': string;
    /**
     * Whether an SP private key is stored for this connection. The key itself is write-only and is never returned by this API.
     */
    'spPrivateKeySet': boolean;
    /**
     * The SP metadata URL to hand to the identity provider.
     */
    'metadataUrl': string;
    /**
     * The identity provider\'s federation metadata URL, when this connection was imported from one. While it is set, the scheduled refresh re-reads it and overwrites idpEntityId, idpSsoUrl, idpSloUrl and idpSigningCertificates, so those four are not the admin\'s to edit. Null when the connection was entered by hand or imported from pasted XML.
     */
    'idpMetadataUrl'?: string;
    'attributeMapping': AttributeMapping;
    'wantAuthnResponseSigned': boolean;
    'identifierFormat': TeamSsoConnectionIdentifierFormatEnum;
    'disableRequestedAuthnContext': boolean;
    'requireEncryptedAssertions': boolean;
    'createdAt': string;
    'updatedAt': string;
}

export const TeamSsoConnectionIdentifierFormatEnum = {
    Persistent: 'persistent',
    EmailAddress: 'emailAddress',
    Unspecified: 'unspecified',
    Transient: 'transient'
} as const;

export type TeamSsoConnectionIdentifierFormatEnum = typeof TeamSsoConnectionIdentifierFormatEnum[keyof typeof TeamSsoConnectionIdentifierFormatEnum];

export interface TeamSsoConnectionCertificate {
    /**
     * The PEM-encoded certificate.
     */
    'pem': string;
    /**
     * Null only if the stored PEM could not be parsed.
     */
    'subject': string;
    /**
     * When this certificate expires. Null only if the stored PEM could not be parsed. Compare against every certificate in `idpSigningCertificates`, not just the first — rotation publishes the active and next certificate together.
     */
    'notAfter': string;
}
export interface TeamWizardStepError {
    'error': string;
    'step'?: TeamWizardStepErrorStepEnum;
}

export const TeamWizardStepErrorStepEnum = {
    Card: 'card',
    Subscription: 'subscription',
    Funding: 'funding',
    Invites: 'invites'
} as const;

export type TeamWizardStepErrorStepEnum = typeof TeamWizardStepErrorStepEnum[keyof typeof TeamWizardStepErrorStepEnum];

export interface TeamWorkResponse {
    'current': Array<WorkItem>;
    'queued': Array<WorkItem>;
    /**
     * Armed card next actions - commitments expected to fire later. needs_attention rows first, then recent expiries, then by fire time. 
     */
    'waiting': Array<CardNextActionView>;
    'recent': Array<WorkItem>;
    'hasMoreRecent': boolean;
    'nextBeforeId': number;
}
export interface TestResult {
    /**
     * Unique identifier for the test result
     */
    'id'?: number;
    /**
     * ID of the associated agent
     */
    'agentId'?: number;
    /**
     * ID of the associated job for status tracking
     */
    'jobId'?: number;
    /**
     * UUID of the test execution job
     */
    'jobUUID'?: string;
    /**
     * Test creation timestamp
     */
    'createdAt'?: string;
    /**
     * Test last updated timestamp
     */
    'updatedAt'?: string;
    'configSnapshot'?: TestRunConfigSnapshot;
    'metricsSummary'?: TestRunMetricsSummary;
    'agent'?: Agent;
    'job'?: Job;
    'testResults'?: Array<TestResultItem>;
}
export interface TestResultDetails {
    'test'?: TestResult;
    'results'?: Array<TestResultItem>;
    'pagination'?: TestResultDetailsPagination;
}
export interface TestResultDetailsPagination {
    /**
     * Current offset value
     */
    'offset'?: number;
    /**
     * Current limit value
     */
    'limit'?: number;
    /**
     * Total number of results
     */
    'total'?: number;
}
export interface TestResultItem {
    /**
     * Unique identifier for the test result item
     */
    'id'?: number;
    /**
     * ID of the parent test result
     */
    'testId'?: number;
    /**
     * ID of the message that was tested
     */
    'messageId'?: number;
    /**
     * Number of correct POI evaluations
     */
    'correctCount'?: number;
    /**
     * Number of incorrect POI evaluations
     */
    'incorrectCount'?: number;
    /**
     * Test item creation timestamp
     */
    'createdAt'?: string;
    /**
     * Test item last updated timestamp
     */
    'updatedAt'?: string;
    'test'?: TestResult;
    'pois'?: Array<TestResultPois>;
}
export interface TestResultPois {
    /**
     * Unique identifier for the test result POI
     */
    'id'?: number;
    /**
     * ID of the parent test result item
     */
    'testResultId'?: number;
    /**
     * ID of the POI note this result evaluates
     */
    'messageNoteId'?: number;
    /**
     * Whether this POI evaluation was successful
     */
    'success'?: boolean;
    /**
     * Whether this POI was marked must-pass when the run started
     */
    'required'?: boolean;
    /**
     * Description of the POI evaluation result
     */
    'description'?: string;
    'messageNote'?: TestResultPoisMessageNote;
}
/**
 * The POI note this result evaluates
 */
export interface TestResultPoisMessageNote {
    /**
     * Note ID
     */
    'id'?: number;
    /**
     * POI text
     */
    'noteText'?: string;
    /**
     * Current must-pass flag on the note
     */
    'poiRequired'?: boolean;
}
/**
 * Agent configuration captured when the test run started
 */
export interface TestRunConfigSnapshot {
    /**
     * Agent name at run time
     */
    'agentName'?: string;
    /**
     * Voice type at run time
     */
    'voiceType'?: string;
    /**
     * Custom response prompt at run time
     */
    'responsePrompt'?: string;
    'modelLive'?: VoiceTalkConfig;
    'modelInteraction'?: ModelSlotPolicy;
    /**
     * Skills configured at run time
     */
    'skills'?: Array<TestRunConfigSnapshotSkillsInner>;
}
export interface TestRunConfigSnapshotSkillsInner {
    /**
     * Skill ID
     */
    'id'?: number;
    /**
     * Skill name
     */
    'name'?: string;
    'activationMode'?: TestRunConfigSnapshotSkillsInnerActivationModeEnum;
}

export const TestRunConfigSnapshotSkillsInnerActivationModeEnum = {
    OnDemand: 'on_demand',
    Always: 'always',
    Disabled: 'disabled'
} as const;

export type TestRunConfigSnapshotSkillsInnerActivationModeEnum = typeof TestRunConfigSnapshotSkillsInnerActivationModeEnum[keyof typeof TestRunConfigSnapshotSkillsInnerActivationModeEnum];

/**
 * Aggregated cost/latency numbers for the test run
 */
export interface TestRunMetricsSummary {
    /**
     * Number of iterations with recorded metrics
     */
    'iterationCount'?: number;
    /**
     * Total tokens sent across all iterations
     */
    'totalTokensSent'?: number;
    /**
     * Total tokens received across all iterations
     */
    'totalTokensReceived'?: number;
    /**
     * Average processing time per iteration in milliseconds
     */
    'averageProcessingTimeMs'?: number;
}
export interface TestStartRequest {
    /**
     * Number of test iterations to run
     */
    'iterations'?: number;
}
export interface TestStartResponse {
    /**
     * Success message
     */
    'message'?: string;
    /**
     * UUID of the started test job for status tracking
     */
    'jobUUID'?: string;
    /**
     * ID of the started test job for status tracking
     */
    'jobId'?: number;
}
export interface TierChangePreviewInfo {
    'kind': TierChangePreviewInfoKindEnum;
    'chargeNowUsd'?: string;
    'billableSeats': number;
    /**
     * Overage that blocks the change until it is shed.
     */
    'violations': Array<TierViolationInfo>;
    /**
     * Capability in use today that the target tier does not include. Informational — it never blocks the change.
     */
    'featureLosses': Array<TierViolationInfo>;
}

export const TierChangePreviewInfoKindEnum = {
    Subscribe: 'subscribe',
    Upgrade: 'upgrade',
    Downgrade: 'downgrade',
    Noop: 'noop'
} as const;

export type TierChangePreviewInfoKindEnum = typeof TierChangePreviewInfoKindEnum[keyof typeof TierChangePreviewInfoKindEnum];

export interface TierInfo {
    'id': number;
    'slug': string;
    'name': string;
    'description': string;
    'displayFeatures': Array<string>;
    'level': number;
    'pricePerSeatUsd': number;
    'maxAgents'?: number;
    'maxUsers'?: number;
    'maxViewers'?: number;
    'maxProjects'?: number;
    'maxFileStorageBytes'?: number;
    'allowByoModelKeys': boolean;
    'allowCustomPermissionRoles': boolean;
    'allowCustomAgentRoles': boolean;
    'allowCustomSkills': boolean;
    'allowCustomTools': boolean;
}
export interface TierSummaryInfo {
    'id': number;
    'slug': string;
    'name': string;
    'level': number;
    'pricePerSeatUsd': string;
}
export interface TierUsageInfo {
    'agents': number;
    'billableUsers': number;
    'viewers': number;
    'projects': number;
    'fileStorageBytes': number;
    'workspaces': number;
    'customSkills': number;
    'customTools': number;
    'customPermissionRoles': number;
    'modelProviders': number;
}
export interface TierViolationInfo {
    'limit': string;
    'current': number;
    'allowed': number;
    'message': string;
}
export interface TokenModelBucket {
    /**
     * Bucket start (server UTC date_trunc)
     */
    'start': string;
    'model': string;
    'modelProvider': string;
    'tokensSent': number;
    'tokensReceived': number;
}
export interface TokenModelTotal {
    /**
     * Model id as reported by the provider, or \'unknown\'
     */
    'model': string;
    /**
     * Provider that served the model, or \'unknown\'
     */
    'modelProvider': string;
    'tokensSent': number;
    'tokensReceived': number;
}
export interface TokenProviderBucket {
    /**
     * Bucket start (server UTC date_trunc)
     */
    'start': string;
    'provider': string;
    'tokensSent': number;
    'tokensReceived': number;
}
export interface TokenProviderTotal {
    /**
     * Provider that served the tokens, or \'unknown\'
     */
    'provider': string;
    'tokensSent': number;
    'tokensReceived': number;
}
/**
 * Token counts over the same period and buckets as the cost timeseries. Independent of pricing: unpriced usage still reports its tokens.
 */
export interface TokenTimeseries {
    'totalTokensSent': number;
    'totalTokensReceived': number;
    /**
     * Per-model totals over the period, most tokens first
     */
    'models': Array<TokenModelTotal>;
    /**
     * Sparse per-model token buckets; empty buckets are absent
     */
    'modelBuckets': Array<TokenModelBucket>;
    /**
     * Per-provider totals over the period, most tokens first
     */
    'providers': Array<TokenProviderTotal>;
    /**
     * Sparse per-provider token buckets; empty buckets are absent
     */
    'providerBuckets': Array<TokenProviderBucket>;
}
export interface ToolAction {
    'id'?: number;
    'agentId'?: number;
    'customToolId'?: number;
    'toolName'?: string;
    'functionName'?: string;
    'params'?: Record<string, any>;
    'status'?: ToolActionStatusEnum;
    'result'?: Record<string, any>;
    'createdAt'?: string;
    'decidedAt'?: string;
}

export const ToolActionStatusEnum = {
    Pending: 'pending',
    Executed: 'executed',
    Failed: 'failed',
    Rejected: 'rejected'
} as const;

export type ToolActionStatusEnum = typeof ToolActionStatusEnum[keyof typeof ToolActionStatusEnum];

export interface ToolBundle {
    'key'?: string;
    'title'?: string;
    'description'?: string;
    'builtIn'?: boolean;
    'enabled'?: boolean;
    'tools'?: Array<ToolBundleToolsInner>;
    /**
     * Secrets the bundle needs before its tools can run
     */
    'secretFields'?: Array<BundleSecretField>;
    /**
     * Non-secret settings the bundle accepts
     */
    'configFields'?: Array<BundleConfigField>;
    /**
     * Current non-secret setting values
     */
    'config'?: { [key: string]: string; };
    /**
     * Declared secret keys that have a stored value; the values themselves never leave the server 
     */
    'secretsSet'?: Array<string>;
    /**
     * Declared secret keys with no stored value yet
     */
    'missingSecrets'?: Array<string>;
    /**
     * True for bundles that only carry credentials (e.g. workspace cloud CLIs) and expose no model-facing tools 
     */
    'credentialsOnly'?: boolean;
}
export interface ToolBundleToolsInner {
    'name'?: string;
    'description'?: string;
}
export interface ToolCatalogResponse {
    'bundles'?: Array<ToolBundle>;
    /**
     * Whether the agent may define its own tools and skills
     */
    'selfBuildEnabled'?: boolean;
    /**
     * Whether the agent may create and configure other team agents on trusted admin surfaces (off by default)
     */
    'agentAdminEnabled'?: boolean;
}
export interface ToolConfigurationResponse {
    'id'?: number;
    'agentId'?: number;
    'toolName'?: string;
    'configuration'?: Record<string, any>;
    'credential'?: CredentialSummary;
    'createdAt'?: string;
    'updatedAt'?: string;
}
export interface TypeChanges {
    /**
     * Names of types that will be added
     */
    'added'?: Array<string>;
    /**
     * Names of types that will be deleted
     */
    'deleted'?: Array<string>;
}
export interface UpdateAgentSlackConfigRequest {
    /**
     * Slack bot token (xoxb-...); write-only, empty string clears
     */
    'botToken'?: string;
    /**
     * Slack app signing secret; write-only, empty string clears
     */
    'signingSecret'?: string;
}
export interface UpdateChannelAgentsRequest {
    'agentIds': Array<number>;
}
export interface UpdateChannelRequest {
    'name'?: string;
    'config'?: Record<string, any>;
    /**
     * Write-only; only provided keys change, empty string clears a key
     */
    'credentials'?: { [key: string]: string; };
    'channelPrompt'?: string;
    'status'?: UpdateChannelRequestStatusEnum;
    'agentIds'?: Array<number>;
}

export const UpdateChannelRequestStatusEnum = {
    Active: 'active',
    Disabled: 'disabled'
} as const;

export type UpdateChannelRequestStatusEnum = typeof UpdateChannelRequestStatusEnum[keyof typeof UpdateChannelRequestStatusEnum];

export interface UpdateConversationRequest {
    /**
     * Subject of the conversation
     */
    'subject'?: string;
}
export interface UpdateCustomToolRequest {
    'name'?: string;
    'description'?: string;
    'spec'?: CustomToolSpec;
    'status'?: UpdateCustomToolRequestStatusEnum;
    'requiresApproval'?: boolean;
    'rateLimitPerDay'?: number;
    /**
     * Write-only secret values keyed by secret field key. An empty string clears a stored value. Never included in responses. 
     */
    'credentials'?: { [key: string]: string; };
}

export const UpdateCustomToolRequestStatusEnum = {
    PendingSetup: 'pending_setup',
    Active: 'active',
    Disabled: 'disabled'
} as const;

export type UpdateCustomToolRequestStatusEnum = typeof UpdateCustomToolRequestStatusEnum[keyof typeof UpdateCustomToolRequestStatusEnum];

export interface UpdateKnowledgeGraphNodeEnabled200Response {
    'message'?: string;
    /**
     * ID of the updated node
     */
    'nodeId'?: number;
    /**
     * New enabled status of the node
     */
    'enabled'?: boolean;
}
export interface UpdateKnowledgeGraphNodeEnabledRequest {
    /**
     * Whether the node should be enabled or disabled
     */
    'enabled': boolean;
}
export interface UpdateKnowledgeGraphTypesYaml415Response {
    'message'?: string;
}
export interface UpdateLoopTaskRequest {
    'agentId'?: number;
    'kind'?: LoopKind;
    'name'?: string;
    'instructions'?: string;
    'completionCondition'?: string;
    'fixedDelaySeconds'?: number;
    'nextEligibleAt'?: string;
    'budgetAmountUsd'?: string;
    'budgetPeriod'?: LoopBudgetPeriod;
    'budgetMinimumStartUsd'?: string;
    'maximumIterations'?: number;
    'deadlineAt'?: string;
}


/**
 * At least one of noteType, noteText, or poiRequired must be provided
 */
export interface UpdateMessageNoteRequest {
    'noteType'?: MessageNoteType;
    /**
     * The updated text content of the note
     */
    'noteText'?: string;
    /**
     * For POI notes, whether this POI must pass for a test run to succeed
     */
    'poiRequired'?: boolean;
}


export interface UpdateMessageRequest {
    /**
     * Text content of the message
     */
    'messageText'?: string;
    /**
     * Type of the message
     */
    'messageType'?: string;
    /**
     * Unique identifier for the message
     */
    'uniqueId'?: string;
    /**
     * Subject of the message
     */
    'subject'?: string;
}
export interface UpdateNotificationPreference {
    'category': UpdateNotificationPreferenceCategoryEnum;
    'channel': UpdateNotificationPreferenceChannelEnum;
    'enabled': boolean;
}

export const UpdateNotificationPreferenceCategoryEnum = {
    ApprovalRequest: 'approval_request',
    CardMention: 'card_mention',
    CardWatch: 'card_watch',
    ChatMention: 'chat_mention',
    ConversationInvite: 'conversation_invite',
    TeamSecretRenamed: 'team_secret_renamed',
    ReleaseNotes: 'release_notes',
    OutOfFunds: 'out_of_funds',
    AutomaticFundingTopUp: 'automatic_funding_top_up',
    SystemIssue: 'system_issue'
} as const;

export type UpdateNotificationPreferenceCategoryEnum = typeof UpdateNotificationPreferenceCategoryEnum[keyof typeof UpdateNotificationPreferenceCategoryEnum];
export const UpdateNotificationPreferenceChannelEnum = {
    Email: 'email',
    Sms: 'sms',
    Slack: 'slack'
} as const;

export type UpdateNotificationPreferenceChannelEnum = typeof UpdateNotificationPreferenceChannelEnum[keyof typeof UpdateNotificationPreferenceChannelEnum];

export interface UpdateNotificationPreferencesRequest {
    'preferences': Array<UpdateNotificationPreference>;
}
export interface UpdateSkillRequest {
    'name'?: string;
    'description'?: string;
    'content'?: string;
    'requiredBundles'?: Array<string>;
    'activationMode'?: SkillActivationMode;
    'outcomes'?: Array<SkillOutcomeInput>;
}


/**
 * Every field is optional. An omitted `credentials` leaves the stored SP private key untouched; a present, non-empty `credentials.spPrivateKeyPem` is the only thing that overwrites it.
 */
export interface UpdateSsoConnectionRequest {
    'displayName'?: string;
    'idpEntityId'?: string;
    'idpSsoUrl'?: string;
    'idpSloUrl'?: string;
    'logoutResponseIssuer'?: string;
    'idpSigningCertificates'?: Array<string>;
    'spEntityId'?: string;
    'spCertificatePem'?: string;
    'credentials'?: UpdateSsoConnectionRequestCredentials;
    'attributeMapping'?: AttributeMapping;
    'wantAuthnResponseSigned'?: boolean;
    'identifierFormat'?: UpdateSsoConnectionRequestIdentifierFormatEnum;
    'disableRequestedAuthnContext'?: boolean;
    'requireEncryptedAssertions'?: boolean;
}

export const UpdateSsoConnectionRequestIdentifierFormatEnum = {
    Persistent: 'persistent',
    EmailAddress: 'emailAddress',
    Unspecified: 'unspecified',
    Transient: 'transient'
} as const;

export type UpdateSsoConnectionRequestIdentifierFormatEnum = typeof UpdateSsoConnectionRequestIdentifierFormatEnum[keyof typeof UpdateSsoConnectionRequestIdentifierFormatEnum];

export interface UpdateSsoConnectionRequestCredentials {
    'spPrivateKeyPem'?: string;
}
export interface UpdateTestDataRequest {
    /**
     * Flag to set or unset test data status
     */
    'testData': boolean;
}
export interface UpdateWebPushDevicePreference {
    'category': NotificationCategoryKey;
    'enabled': boolean;
}


export interface UpdateWebPushDevicePreferencesRequest {
    'preferences': Array<UpdateWebPushDevicePreference>;
}
export interface UserNote {
    /**
     * Unique identifier for the note
     */
    'id': number;
    /**
     * The text content of the note
     */
    'noteText': string;
    /**
     * Whether this POI must pass for a test run to succeed
     */
    'poiRequired'?: boolean;
    /**
     * When the note was created
     */
    'createdAt': string;
    /**
     * ID of the user who created the note
     */
    'createdByUserId': number;
}
export interface UserRequest {
    /**
     * User\'s email address
     */
    'email': string;
    /**
     * User\'s password
     */
    'password': string;
    /**
     * User\'s first name
     */
    'firstName': string;
    /**
     * User\'s last name
     */
    'lastName': string;
}
export interface UserResponse {
    /**
     * Unique identifier for the user
     */
    'id'?: number;
    /**
     * User\'s email address
     */
    'email'?: string;
    /**
     * User\'s first name
     */
    'firstName'?: string;
    /**
     * User\'s last name
     */
    'lastName'?: string;
    /**
     * Server-verified primary method for the current browser session
     */
    'loginMethod'?: UserResponseLoginMethodEnum | null;
}

export const UserResponseLoginMethodEnum = {
    Password: 'password',
    Google: 'google',
    Passkey: 'passkey',
    Saml: 'saml'
} as const;

export type UserResponseLoginMethodEnum = typeof UserResponseLoginMethodEnum[keyof typeof UserResponseLoginMethodEnum];

export interface UserSearchResult {
    /**
     * Unique identifier for the user
     */
    'id': number;
    /**
     * User\'s email address
     */
    'email': string;
    /**
     * User\'s first name
     */
    'firstName'?: string;
    /**
     * User\'s last name
     */
    'lastName'?: string;
}
export interface VectorSearchRequest {
    /**
     * ID of the agent to search within
     */
    'agentId': number;
    /**
     * Vector query for similarity search
     */
    'query': Array<number>;
    /**
     * Maximum number of results to return
     */
    'limit'?: number;
    /**
     * Filter by third party email addresses
     */
    'thirdPartyEmails'?: Array<string>;
}
export interface VectorSearchResponse {
    /**
     * Search results
     */
    'results'?: Array<MessageSearchResult>;
    /**
     * ID of the agent searched
     */
    'agentId'?: number;
    /**
     * Limit applied to results
     */
    'limit'?: number;
    /**
     * Total number of results returned
     */
    'total'?: number;
}
export interface VerifyModelProviderRequest {
    'providerType': ModelProviderName;
    'config'?: Record<string, any>;
    'credentials'?: { [key: string]: string; };
    'providerId'?: number;
}


export interface VerifyModelProviderResponse {
    'valid': boolean;
    'error'?: string;
    'models'?: Array<ProviderModel>;
}
export interface VideoCapabilities {
    'minSeconds': number;
    'maxSeconds': number;
    'defaultSeconds': number;
    'supportedSeconds'?: Array<number>;
    'resolutions': Array<VideoResolution>;
    'aspectRatios': Array<string>;
    'generatesAudio': boolean;
    'audioAlwaysOn'?: boolean;
    'maxReferenceImages': number;
    'maxReferenceVideos': number;
    'maxReferenceAudio': number;
    'maxReferenceVoices': number;
    'maxTotalReferences': number;
    'supportsFirstFrame'?: boolean;
    'supportsLastFrame'?: boolean;
    'supportsSourceVideo'?: boolean;
    'modes': VideoCapabilitiesModes;
}
export interface VideoCapabilitiesModes {
    'text_to_video'?: VideoModeCapabilities;
    'image_to_video'?: VideoModeCapabilities;
    'reference_to_video'?: VideoModeCapabilities;
    'edit_video'?: VideoModeCapabilities;
    'extend_video'?: VideoModeCapabilities;
}
export interface VideoCommitRequest {
    'lifecycleDays'?: number;
}
export interface VideoContentFile {
    'id': string;
    'name': string;
    'kind': VideoContentFileKindEnum;
    'state': string;
    'mimeType': string;
    'codec'?: string;
    'sizeBytes': number;
    'sha256': string;
    'durationSeconds'?: number;
    'width'?: number;
    'height'?: number;
    'expiresAt': string;
    'previewUrl'?: string;
}

export const VideoContentFileKindEnum = {
    BrowserVideo: 'browser_video'
} as const;

export type VideoContentFileKindEnum = typeof VideoContentFileKindEnum[keyof typeof VideoContentFileKindEnum];

export interface VideoContentPermanentCopyRequest {
    'idempotencyKey': string;
    'folderId'?: number;
    'name'?: string;
}
export interface VideoContentPermanentCopyResult {
    'permanent': VideoContentPermanentCopyResultPermanentEnum;
    'fileId': number;
    'versionId': number;
    'name': string;
    'projectId': number;
    'folderId': number;
}

export const VideoContentPermanentCopyResultPermanentEnum = {
    True: true
} as const;

export type VideoContentPermanentCopyResultPermanentEnum = typeof VideoContentPermanentCopyResultPermanentEnum[keyof typeof VideoContentPermanentCopyResultPermanentEnum];

export interface VideoDraft {
    'id': string;
    'name': string;
    'state': VideoDraftStateEnum;
    'durationSeconds': number;
    'width': number;
    'height': number;
    'codec': string;
    'mimeType': VideoDraftMimeTypeEnum;
    'sizeBytes': number;
    'sha256': string;
    'expiresAt': string;
    'previewUrl': string;
    'reviewInstructions': string;
}

export const VideoDraftStateEnum = {
    ReadyForReview: 'ready_for_review'
} as const;

export type VideoDraftStateEnum = typeof VideoDraftStateEnum[keyof typeof VideoDraftStateEnum];
export const VideoDraftMimeTypeEnum = {
    VideoMp4: 'video/mp4'
} as const;

export type VideoDraftMimeTypeEnum = typeof VideoDraftMimeTypeEnum[keyof typeof VideoDraftMimeTypeEnum];

export interface VideoLifecycleRequest {
    'lifecycleDays': number;
}
export interface VideoModeCapabilities {
    'minSeconds': number;
    'maxSeconds': number;
    'defaultSeconds'?: number;
    'supportedSeconds'?: Array<number>;
    'resolutions': Array<VideoResolution>;
    'aspectRatios'?: Array<string>;
    'maxInputVideoSeconds'?: number;
    'minInputVideoSeconds'?: number;
    'requiresProviderUri'?: boolean;
}
export interface VideoPricing {
    'basis': VideoPricingBasisEnum;
    'outputPerSecondByResolution'?: VideoPricingOutputPerSecondByResolution;
    'inputImageUsd'?: number;
    'inputVideoPerSecondUsd'?: number;
    'usdPerThousandComputedTokens'?: number;
}

export const VideoPricingBasisEnum = {
    PerSecond: 'per_second',
    ComputedTokens: 'computed_tokens'
} as const;

export type VideoPricingBasisEnum = typeof VideoPricingBasisEnum[keyof typeof VideoPricingBasisEnum];

export interface VideoPricingOutputPerSecondByResolution {
    '480p'?: number;
    '720p'?: number;
    '1080p'?: number;
}
/**
 * Reference-only execution binding returned after a successful handoff claim.
 */
export interface VideoProductionClaim {
    'productionId': string;
    'productionExecutionFence': number;
    'attempt': number;
    'stage': string;
    /**
     * Frozen compacted production instruction; never a raw transcript or spill payload.
     */
    'instruction': string;
    'requiredBundle': VideoProductionClaimRequiredBundleEnum;
}

export const VideoProductionClaimRequiredBundleEnum = {
    VideoProduction: 'video_production'
} as const;

export type VideoProductionClaimRequiredBundleEnum = typeof VideoProductionClaimRequiredBundleEnum[keyof typeof VideoProductionClaimRequiredBundleEnum];

/**
 * Portable, expiring and single-claim narrated-video handoff. Media and frozen context are resolved only after claim.
 */
export interface VideoProductionHandoff {
    'productionId': string;
    /**
     * Opaque single-use token bound to this protocol session and external assignment.
     */
    'handoffToken': string;
    'expiresAt': string;
    'instruction': string;
    'requiredBundle': VideoProductionHandoffRequiredBundleEnum;
    'fallback': VideoProductionHandoffFallbackEnum;
}

export const VideoProductionHandoffRequiredBundleEnum = {
    VideoProduction: 'video_production'
} as const;

export type VideoProductionHandoffRequiredBundleEnum = typeof VideoProductionHandoffRequiredBundleEnum[keyof typeof VideoProductionHandoffRequiredBundleEnum];
export const VideoProductionHandoffFallbackEnum = {
    ClaimAndExecuteInParent: 'claim_and_execute_in_parent'
} as const;

export type VideoProductionHandoffFallbackEnum = typeof VideoProductionHandoffFallbackEnum[keyof typeof VideoProductionHandoffFallbackEnum];


export const VideoResolution = {
    _480p: '480p',
    _720p: '720p',
    _1080p: '1080p'
} as const;

export type VideoResolution = typeof VideoResolution[keyof typeof VideoResolution];


export interface VoiceAgentOption {
    'agentId': number;
    'agentName': string;
    'profileId': string;
    'profile': ResolvedVoiceProfile;
    'mode': VoiceTalkMode;
    'available': boolean;
    'code'?: string;
    'unavailableReason'?: string;
}


export interface VoiceAgentOptionsResponse {
    'agents': Array<VoiceAgentOption>;
}
export interface VoiceAudioFormat {
    'mimeType': string;
    'sampleRateHz': number;
}
export interface VoiceCapabilities {
    'inputTranscription': boolean;
    'outputTranscription': boolean;
    'bargeIn': boolean;
    'sessionContinuation': boolean;
    'toolPreamble': boolean;
}
export interface VoiceComponentCostRollup {
    'sessionId': string;
    'turnId': string | null;
    'kind': VoiceComponentCostRollupKindEnum;
    'usageSurface': string;
    'component': string;
    'provider': string;
    'model': string;
    'pricingState': CostPricingState;
    'totalUsd': number | null;
    'knownTotalUsd': number;
    'metricCount': number;
}

export const VoiceComponentCostRollupKindEnum = {
    Turn: 'turn',
    SessionAdjustment: 'session_adjustment'
} as const;

export type VoiceComponentCostRollupKindEnum = typeof VoiceComponentCostRollupKindEnum[keyof typeof VoiceComponentCostRollupKindEnum];

export interface VoiceConversationCostRollup {
    'conversationId': number;
    'pricingState': CostPricingState;
    'totalUsd': number | null;
    'knownTotalUsd': number;
    'metricCount': number;
    /**
     * Provider media usage only (realtime audio, transcription, and synthesis); excludes delegated backend agent work.
     */
    'audio': VoiceCostSummary;
    'sessions': Array<VoiceSessionCostRollup>;
    'turns': Array<VoiceTurnCostRollup>;
    'components': Array<VoiceComponentCostRollup>;
    'detailPage': VoiceConversationCostRollupDetailPage;
}


export interface VoiceConversationCostRollupDetailPage {
    'sessions': VoiceCostPage;
    'turns': VoiceCostPage;
    'components': VoiceCostPage;
}
export interface VoiceCostPage {
    'limit': number;
    'offset': number;
    'total': number;
}
export interface VoiceCostSummary {
    'pricingState': CostPricingState;
    /**
     * Exact total when fully priced; null when any included metric is unpriced
     */
    'totalUsd': number | null;
    'knownTotalUsd': number;
    'metricCount': number;
}


export interface VoiceErrorResponse {
    'error': string;
    /**
     * Stable machine-readable voice error code. Runtime ownership and capacity codes are safe to retry after reconnecting.
     */
    'code': string;
    /**
     * Whether the client should reconnect and retry with fresh session state.
     */
    'retryable': boolean;
}
export interface VoiceProfile {
    'id': string;
    'displayName': string;
    'providerType': VoiceProfileProviderTypeEnum;
    'mode': VoiceTalkMode;
    'transport': VoiceTransportType;
    'realtimeModel'?: string;
    'transcriptionModel'?: string;
    'synthesisModel'?: string;
    'defaultVoice': string;
    'voices': Array<string>;
    'input': VoiceAudioFormat;
    'output': VoiceAudioFormat;
    'capabilities': VoiceCapabilities;
    'sessionLimitSeconds'?: number;
}

export const VoiceProfileProviderTypeEnum = {
    Google: 'google',
    Openai: 'openai'
} as const;

export type VoiceProfileProviderTypeEnum = typeof VoiceProfileProviderTypeEnum[keyof typeof VoiceProfileProviderTypeEnum];

export interface VoiceProfileAvailability {
    'id': string;
    'displayName': string;
    'providerType': VoiceProfileAvailabilityProviderTypeEnum;
    'mode': VoiceTalkMode;
    'transport': VoiceTransportType;
    'realtimeModel'?: string;
    'transcriptionModel'?: string;
    'synthesisModel'?: string;
    'defaultVoice': string;
    'voices': Array<string>;
    'input': VoiceAudioFormat;
    'output': VoiceAudioFormat;
    'capabilities': VoiceCapabilities;
    'sessionLimitSeconds'?: number;
    'available': boolean;
    'code'?: string;
    'unavailableReason'?: string;
}

export const VoiceProfileAvailabilityProviderTypeEnum = {
    Google: 'google',
    Openai: 'openai'
} as const;

export type VoiceProfileAvailabilityProviderTypeEnum = typeof VoiceProfileAvailabilityProviderTypeEnum[keyof typeof VoiceProfileAvailabilityProviderTypeEnum];

/**
 * @type VoiceSessionCommandRequest
 */
export type VoiceSessionCommandRequest = VoiceSessionCommandRequestOneOf | VoiceSessionCommandRequestOneOf1 | VoiceSessionCommandRequestOneOf2 | VoiceSessionCommandRequestOneOf3 | VoiceSessionCommandRequestOneOf4;

export interface VoiceSessionCommandRequestOneOf {
    'commandId': string;
    'leaseVersion': number;
    'type': VoiceSessionCommandRequestOneOfTypeEnum;
}

export const VoiceSessionCommandRequestOneOfTypeEnum = {
    Pause: 'pause'
} as const;

export type VoiceSessionCommandRequestOneOfTypeEnum = typeof VoiceSessionCommandRequestOneOfTypeEnum[keyof typeof VoiceSessionCommandRequestOneOfTypeEnum];

export interface VoiceSessionCommandRequestOneOf1 {
    'commandId': string;
    'leaseVersion': number;
    'type': VoiceSessionCommandRequestOneOf1TypeEnum;
}

export const VoiceSessionCommandRequestOneOf1TypeEnum = {
    Resume: 'resume'
} as const;

export type VoiceSessionCommandRequestOneOf1TypeEnum = typeof VoiceSessionCommandRequestOneOf1TypeEnum[keyof typeof VoiceSessionCommandRequestOneOf1TypeEnum];

export interface VoiceSessionCommandRequestOneOf2 {
    'commandId': string;
    'leaseVersion': number;
    'type': VoiceSessionCommandRequestOneOf2TypeEnum;
    'agentId': number;
}

export const VoiceSessionCommandRequestOneOf2TypeEnum = {
    SwitchAgent: 'switch_agent'
} as const;

export type VoiceSessionCommandRequestOneOf2TypeEnum = typeof VoiceSessionCommandRequestOneOf2TypeEnum[keyof typeof VoiceSessionCommandRequestOneOf2TypeEnum];

export interface VoiceSessionCommandRequestOneOf3 {
    'commandId': string;
    'leaseVersion': number;
    'type': VoiceSessionCommandRequestOneOf3TypeEnum;
}

export const VoiceSessionCommandRequestOneOf3TypeEnum = {
    End: 'end'
} as const;

export type VoiceSessionCommandRequestOneOf3TypeEnum = typeof VoiceSessionCommandRequestOneOf3TypeEnum[keyof typeof VoiceSessionCommandRequestOneOf3TypeEnum];

export interface VoiceSessionCommandRequestOneOf4 {
    'commandId': string;
    'leaseVersion': number;
    'type': VoiceSessionCommandRequestOneOf4TypeEnum;
    'mediaBindingId': string;
    'mediaGeneration': number;
}

export const VoiceSessionCommandRequestOneOf4TypeEnum = {
    ReplaceMedia: 'replace_media'
} as const;

export type VoiceSessionCommandRequestOneOf4TypeEnum = typeof VoiceSessionCommandRequestOneOf4TypeEnum[keyof typeof VoiceSessionCommandRequestOneOf4TypeEnum];

export interface VoiceSessionCostRollup {
    'sessionId': string;
    'pricingState': CostPricingState;
    'totalUsd': number | null;
    'knownTotalUsd': number;
    'metricCount': number;
    /**
     * Provider media usage only (realtime audio, transcription, and synthesis); excludes delegated backend agent work.
     */
    'audio': VoiceCostSummary;
    'settlementPending': boolean;
}


export interface VoiceSessionSnapshot {
    'sessionId': string;
    'teamId': number;
    'conversationId': number;
    'userId': number;
    'currentAgentId': number;
    'currentAgentName': string;
    'profileSnapshot': ResolvedVoiceProfile;
    'state': VoiceSessionSnapshotStateEnum;
    'leaseActive': boolean;
    'leaseVersion': number;
    'mediaBindingId': string;
    'mediaGeneration': number;
    'mediaNegotiationStatus': VoiceSessionSnapshotMediaNegotiationStatusEnum;
    'transport': VoiceSessionSnapshotTransport;
    'warmResumeDeadline': string;
    'capabilities': VoiceCapabilities;
    'terminalReason': string;
}

export const VoiceSessionSnapshotStateEnum = {
    Connecting: 'connecting',
    Active: 'active',
    Paused: 'paused',
    Reconnecting: 'reconnecting',
    Ended: 'ended'
} as const;

export type VoiceSessionSnapshotStateEnum = typeof VoiceSessionSnapshotStateEnum[keyof typeof VoiceSessionSnapshotStateEnum];
export const VoiceSessionSnapshotMediaNegotiationStatusEnum = {
    Unbound: 'unbound',
    Ready: 'ready',
    Negotiating: 'negotiating',
    Connected: 'connected',
    CleanupPending: 'cleanup_pending'
} as const;

export type VoiceSessionSnapshotMediaNegotiationStatusEnum = typeof VoiceSessionSnapshotMediaNegotiationStatusEnum[keyof typeof VoiceSessionSnapshotMediaNegotiationStatusEnum];

export interface VoiceSessionSnapshotTransport {
    'type': VoiceTransportType;
    'websocketPath': string;
}


/**
 * Curated voice-talk profile selection
 */
export interface VoiceTalkConfig {
    /**
     * Curated voice profile identifier
     */
    'profile': string;
    /**
     * Team provider instance supplying credentials. Absent or null uses the platform credential.
     */
    'providerId'?: number;
    /**
     * Optional profile-supported voice override
     */
    'voice'?: string;
}

export const VoiceTalkMode = {
    Realtime: 'realtime',
    PushToTalk: 'push_to_talk'
} as const;

export type VoiceTalkMode = typeof VoiceTalkMode[keyof typeof VoiceTalkMode];



export const VoiceTransportType = {
    Webrtc: 'webrtc',
    WebsocketPcm: 'websocket_pcm',
    RequestStream: 'request_stream'
} as const;

export type VoiceTransportType = typeof VoiceTransportType[keyof typeof VoiceTransportType];


export interface VoiceTurnCostRollup {
    'sessionId': string;
    'turnId': string | null;
    'kind': VoiceTurnCostRollupKindEnum;
    'pricingState': CostPricingState;
    'totalUsd': number | null;
    'knownTotalUsd': number;
    'metricCount': number;
}

export const VoiceTurnCostRollupKindEnum = {
    Turn: 'turn',
    SessionAdjustment: 'session_adjustment'
} as const;

export type VoiceTurnCostRollupKindEnum = typeof VoiceTurnCostRollupKindEnum[keyof typeof VoiceTurnCostRollupKindEnum];

export interface WebPushClickReceiptRequest {
    'token': string;
}
export interface WebPushConfigResponse {
    'enabled': boolean;
    /**
     * Public VAPID application-server key; private VAPID and subscription encryption keys are never returned.
     */
    'publicKey'?: string;
}
/**
 * Sanitized device metadata. Endpoint URLs, keys, digests, and encrypted capability material are deliberately omitted.
 */
export interface WebPushDevice {
    'id': number;
    'name': string;
    'browser': string;
    'platform': string;
    'createdAt': string;
    'updatedAt': string;
    'lastSeenAt': string;
    'lastSuccessAt': string;
    'lastFailureAt': string;
    'status': WebPushDeviceStatusEnum;
    'health': WebPushDeviceHealthEnum;
    'isCurrentDevice': boolean;
    'preferences': Array<WebPushDevicePreference>;
}

export const WebPushDeviceStatusEnum = {
    Active: 'active',
    Invalid: 'invalid'
} as const;

export type WebPushDeviceStatusEnum = typeof WebPushDeviceStatusEnum[keyof typeof WebPushDeviceStatusEnum];
export const WebPushDeviceHealthEnum = {
    Unknown: 'unknown',
    Healthy: 'healthy',
    Failing: 'failing'
} as const;

export type WebPushDeviceHealthEnum = typeof WebPushDeviceHealthEnum[keyof typeof WebPushDeviceHealthEnum];

export interface WebPushDeviceListResponse {
    'devices': Array<WebPushDevice>;
    'currentSubscriptionId'?: number;
}
export interface WebPushDeviceMetadata {
    'name': string;
    'browser': string;
    'platform': string;
}
export interface WebPushDevicePreference {
    'category': NotificationCategoryKey;
    'enabled': boolean;
    'locked': boolean;
}


export interface WebPushRateLimitResponse {
    'error': string;
    'retryAfterSeconds': number;
}
export interface WebPushSubscriptionConflictResponse {
    'error': string;
    'code'?: WebPushSubscriptionConflictResponseCodeEnum;
}

export const WebPushSubscriptionConflictResponseCodeEnum = {
    WebPushReactivationRequired: 'WEB_PUSH_REACTIVATION_REQUIRED',
    WebPushContinuityRequired: 'WEB_PUSH_CONTINUITY_REQUIRED',
    WebPushDeviceLimitReached: 'WEB_PUSH_DEVICE_LIMIT_REACHED',
    WebPushDeviceStorageLimitReached: 'WEB_PUSH_DEVICE_STORAGE_LIMIT_REACHED'
} as const;

export type WebPushSubscriptionConflictResponseCodeEnum = typeof WebPushSubscriptionConflictResponseCodeEnum[keyof typeof WebPushSubscriptionConflictResponseCodeEnum];

export interface WebPushSubscriptionKeys {
    /**
     * Canonical base64url uncompressed P-256 public key.
     */
    'p256dh': string;
    /**
     * Canonical base64url 16-byte Web Push authentication secret.
     */
    'auth': string;
}
export interface WebPushSubscriptionMaterial {
    'endpoint': string;
    'keys': WebPushSubscriptionKeys;
}
export interface WebPushTestRequest {
    'subscription': WebPushSubscriptionMaterial;
}
export interface WebSocketCompleteEvent {
    /**
     * Event type
     */
    'type': WebSocketCompleteEventTypeEnum;
    /**
     * ID of the agent
     */
    'agentId': number;
    /**
     * Name of the agent
     */
    'name': string;
    /**
     * Email address of the agent
     */
    'emailAddress'?: string;
    /**
     * Summary of what was learned
     */
    'summary': string;
}

export const WebSocketCompleteEventTypeEnum = {
    Complete: 'complete'
} as const;

export type WebSocketCompleteEventTypeEnum = typeof WebSocketCompleteEventTypeEnum[keyof typeof WebSocketCompleteEventTypeEnum];

export interface WebSocketErrorEvent {
    /**
     * Event type
     */
    'type': WebSocketErrorEventTypeEnum;
    /**
     * Error title
     */
    'error': string;
    /**
     * Detailed error message
     */
    'message'?: string;
}

export const WebSocketErrorEventTypeEnum = {
    Error: 'error'
} as const;

export type WebSocketErrorEventTypeEnum = typeof WebSocketErrorEventTypeEnum[keyof typeof WebSocketErrorEventTypeEnum];

export interface WebSocketFeedbackEvent {
    /**
     * Event type
     */
    'type': WebSocketFeedbackEventTypeEnum;
    /**
     * Feedback message about the learning progress
     */
    'data': string;
}

export const WebSocketFeedbackEventTypeEnum = {
    Feedback: 'feedback'
} as const;

export type WebSocketFeedbackEventTypeEnum = typeof WebSocketFeedbackEventTypeEnum[keyof typeof WebSocketFeedbackEventTypeEnum];

export interface WebSocketStartEvent {
    /**
     * Event type
     */
    'type': WebSocketStartEventTypeEnum;
    /**
     * ID of the agent
     */
    'agentId': number;
}

export const WebSocketStartEventTypeEnum = {
    Start: 'start'
} as const;

export type WebSocketStartEventTypeEnum = typeof WebSocketStartEventTypeEnum[keyof typeof WebSocketStartEventTypeEnum];

export interface WikiArchiveRequest {
    'path': string;
    'archived': boolean;
}
export interface WikiMoveRequest {
    'fromPath': string;
    'toPath': string;
}
export interface WikiMoveResponse {
    'from': string;
    'to': string;
    /**
     * Pages whose wikilinks were rewritten to the new path
     */
    'updatedPages': Array<string>;
}
export interface WikiPage {
    'path': string;
    'title': string;
    'status': WikiPageStatusEnum;
    'author'?: string;
    'tags'?: Array<string>;
    'updatedAt': string;
    'versionCount': number;
    'latestVersion': number;
    /**
     * Full page content including the frontmatter block
     */
    'markdown': string;
    /**
     * Page content without the frontmatter block
     */
    'body': string;
    /**
     * The version this content was read from
     */
    'version': number;
    'created'?: string;
    'updated'?: string;
}

export const WikiPageStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;

export type WikiPageStatusEnum = typeof WikiPageStatusEnum[keyof typeof WikiPageStatusEnum];

export interface WikiPageResponse {
    'page': WikiPage;
}
export interface WikiPageSummary {
    'path': string;
    'title': string;
    'status': WikiPageSummaryStatusEnum;
    'author'?: string;
    'tags'?: Array<string>;
    'updatedAt': string;
    'versionCount': number;
    'latestVersion': number;
}

export const WikiPageSummaryStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;

export type WikiPageSummaryStatusEnum = typeof WikiPageSummaryStatusEnum[keyof typeof WikiPageSummaryStatusEnum];

export interface WikiPagesResponse {
    'pages': Array<WikiPageSummary>;
}
export interface WikiSaveRequest {
    /**
     * Wiki-relative page path without the .md extension, e.g. \"guides/deployment\"
     */
    'path': string;
    /**
     * Page body markdown (frontmatter is managed by the server)
     */
    'markdown': string;
    'title'?: string;
    /**
     * Version the edit was based on; the save is rejected with 409 when the page has moved past it
     */
    'baseVersion'?: number;
}
export interface WikiSearchHit {
    'path': string;
    'title': string;
    'status': WikiSearchHitStatusEnum;
    'snippet': string;
}

export const WikiSearchHitStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;

export type WikiSearchHitStatusEnum = typeof WikiSearchHitStatusEnum[keyof typeof WikiSearchHitStatusEnum];

export interface WikiSearchResponse {
    'hits': Array<WikiSearchHit>;
}
export interface WikiVersion {
    'versionNumber': number;
    'author'?: string;
    'sizeBytes': number;
    'createdAt': string;
}
export interface WikiVersionsResponse {
    'versions': Array<WikiVersion>;
}
export interface WorkItem {
    'bucket': WorkItemBucketEnum;
    /**
     * Null only for queued card work that has not produced a Work stream yet; such rows link to their card instead. 
     */
    'workStreamId': number;
    'workRequestId': number;
    'agentId': number;
    'agentName': string;
    'contextKind': WorkItemContextKindEnum;
    'projectId': number;
    'projectName': string;
    'cardId': number;
    'cardReference': string;
    'cardTitle': string;
    'conversationId': number;
    'conversationTitle': string;
    'status': string;
    'runtimeType': string;
    /**
     * Scheduling tier: queued rows compute it live from the project, epic, and card tiers (the inputs the dispatcher orders by), even when pre-bound to a Work stream; claimed/running and recent rows show the tier recorded at dispatch.
     */
    'priority'?: WorkItemPriorityEnum;
    'provenance': WorkItemProvenance;
    'createdAt': string;
    'updatedAt': string;
    'startedAt'?: string;
    'terminalAt'?: string;
    'durationSeconds'?: number;
    /**
     * Populated for recent items only.
     */
    'costUsd'?: number;
    'costCompleteness'?: string;
    /**
     * The name of the card\'s column when its agent-access rules forbid agent work. A queued row with this set is parked: no agent will claim it until a person moves the card or changes the column, so it is not work about to start. Null on every other row.
     */
    'parkedInColumn'?: string;
}

export const WorkItemBucketEnum = {
    Current: 'current',
    Queued: 'queued',
    Recent: 'recent'
} as const;

export type WorkItemBucketEnum = typeof WorkItemBucketEnum[keyof typeof WorkItemBucketEnum];
export const WorkItemContextKindEnum = {
    Card: 'card',
    TeamChat: 'team_chat'
} as const;

export type WorkItemContextKindEnum = typeof WorkItemContextKindEnum[keyof typeof WorkItemContextKindEnum];
export const WorkItemPriorityEnum = {
    Urgent: 'urgent',
    High: 'high',
    Normal: 'normal',
    Low: 'low',
    VeryLow: 'very_low'
} as const;

export type WorkItemPriorityEnum = typeof WorkItemPriorityEnum[keyof typeof WorkItemPriorityEnum];

export interface WorkItemProvenance {
    'kind': WorkItemProvenanceKindEnum;
    'actorUserId'?: number;
    'actorName'?: string;
    'sourceId'?: number;
    /**
     * Monitored column or card title for monitors, task name for scheduled work. 
     */
    'sourceName'?: string;
}

export const WorkItemProvenanceKindEnum = {
    CardMention: 'card_mention',
    CardWatch: 'card_watch',
    ChatMention: 'chat_mention',
    Monitor: 'monitor',
    Scheduled: 'scheduled',
    Continuation: 'continuation',
    ExternalLaunch: 'external_launch',
    System: 'system'
} as const;

export type WorkItemProvenanceKindEnum = typeof WorkItemProvenanceKindEnum[keyof typeof WorkItemProvenanceKindEnum];

export interface WorkStreamBrowserFrame {
    'itemType': WorkStreamBrowserFrameItemTypeEnum;
    'timelineId': string;
    'startAt': string;
    'endAt': string;
    'frameId': number;
    /**
     * Global, gap-free chronology within the parent Work stream.
     */
    'ordinal': number;
    'runId': number;
    'runOrdinal': number;
    'eventId': number;
    'eventSequence': number;
    'eventKind': string;
    'eventSubtype': string;
    'relatedTool': WorkStreamToolView;
    'artifactId': number;
    'captureKind': WorkStreamBrowserFrameCaptureKindEnum;
    'state': WorkStreamBrowserFrameState;
    'reason': string;
    'actionName': string;
    'actionStatus': string;
    'safeUrl': string;
    'pageTitle': string;
    'viewport': WorkStreamBrowserFrameViewport;
    'capturedAt': string;
    'contentUrl': string;
}

export const WorkStreamBrowserFrameItemTypeEnum = {
    Screenshot: 'screenshot'
} as const;

export type WorkStreamBrowserFrameItemTypeEnum = typeof WorkStreamBrowserFrameItemTypeEnum[keyof typeof WorkStreamBrowserFrameItemTypeEnum];
export const WorkStreamBrowserFrameCaptureKindEnum = {
    Automatic: 'automatic',
    Explicit: 'explicit',
    Error: 'error'
} as const;

export type WorkStreamBrowserFrameCaptureKindEnum = typeof WorkStreamBrowserFrameCaptureKindEnum[keyof typeof WorkStreamBrowserFrameCaptureKindEnum];

/**
 * Pending capture reservations are internal and are never projected.
 */

export const WorkStreamBrowserFrameState = {
    Captured: 'captured',
    Excluded: 'excluded',
    Unavailable: 'unavailable',
    Expired: 'expired'
} as const;

export type WorkStreamBrowserFrameState = typeof WorkStreamBrowserFrameState[keyof typeof WorkStreamBrowserFrameState];


export interface WorkStreamBrowserFrameViewport {
    'width': number;
    'height': number;
}
export interface WorkStreamBrowserPageSegment {
    'index': number;
    'startedAtMs': number;
    'endedAtMs': number;
    'safeUrl': string;
    'title': string;
}
export interface WorkStreamBrowserRecording {
    'itemType': WorkStreamBrowserRecordingItemTypeEnum;
    'timelineId': string;
    'recordingId': string;
    'runId': number;
    'runOrdinal': number;
    'draftId': string;
    'contentFileId': string;
    'name': string;
    'state': WorkStreamBrowserRecordingStateEnum;
    'startAt': string;
    'endAt': string;
    'durationMs': number;
    'expiresAt': string;
    'previewUrl': string;
    'pageSegments': Array<WorkStreamBrowserPageSegment>;
    'failureReason': string;
}

export const WorkStreamBrowserRecordingItemTypeEnum = {
    Recording: 'recording'
} as const;

export type WorkStreamBrowserRecordingItemTypeEnum = typeof WorkStreamBrowserRecordingItemTypeEnum[keyof typeof WorkStreamBrowserRecordingItemTypeEnum];
export const WorkStreamBrowserRecordingStateEnum = {
    Recording: 'recording',
    Stopping: 'stopping',
    ReadyForReview: 'ready_for_review',
    Committed: 'committed',
    Deleted: 'deleted',
    Expired: 'expired',
    Failed: 'failed',
    Canceled: 'canceled'
} as const;

export type WorkStreamBrowserRecordingStateEnum = typeof WorkStreamBrowserRecordingStateEnum[keyof typeof WorkStreamBrowserRecordingStateEnum];

export interface WorkStreamBrowserRecordingResolveRequest {
    'recordingIds': Array<string>;
}
export interface WorkStreamBrowserRecordingResolveResponse {
    'recordings': Array<WorkStreamBrowserRecording>;
    'missingRecordingIds': Array<string>;
    'serverNow': string;
}
export interface WorkStreamContinuationResult {
    'messageId': number;
    'guidanceId': number;
    'deliveryState': WorkStreamContinuationResultDeliveryStateEnum;
    'runId': number;
    'externalLaunch'?: WorkStreamContinuationResultAllOfExternalLaunch;
}

export const WorkStreamContinuationResultDeliveryStateEnum = {
    Queued: 'queued'
} as const;

export type WorkStreamContinuationResultDeliveryStateEnum = typeof WorkStreamContinuationResultDeliveryStateEnum[keyof typeof WorkStreamContinuationResultDeliveryStateEnum];

export interface WorkStreamContinuationResultAllOfExternalLaunch {
    'sessionId': number;
    'status': string;
    'reference': string;
    'referenceExpiresAt': string;
}
export interface WorkStreamControls {
    'canGuide': boolean;
    'canStop': boolean;
    'canContinue': boolean;
}
export interface WorkStreamConversationMessage {
    'id': number;
    'role': string;
    'agentId'?: number;
    'userId'?: number;
    'content': string;
    'mentions': Array<number>;
    'status': string;
    'createdAt': string;
    'interaction'?: Record<string, any>;
    'deliveryState': WorkStreamConversationMessageDeliveryStateEnum;
    'deliveryFailure'?: string;
    'llmCost'?: WorkStreamCostAmount;
}

export const WorkStreamConversationMessageDeliveryStateEnum = {
    Queued: 'queued',
    Included: 'included',
    Cancelled: 'cancelled',
    Failed: 'failed'
} as const;

export type WorkStreamConversationMessageDeliveryStateEnum = typeof WorkStreamConversationMessageDeliveryStateEnum[keyof typeof WorkStreamConversationMessageDeliveryStateEnum];

export interface WorkStreamCostAmount {
    'costUsd': number;
    'completeness': WorkStreamCostAmountCompletenessEnum;
    'sourceCount': number;
}

export const WorkStreamCostAmountCompletenessEnum = {
    Accruing: 'accruing',
    Final: 'final',
    Partial: 'partial',
    Unavailable: 'unavailable'
} as const;

export type WorkStreamCostAmountCompletenessEnum = typeof WorkStreamCostAmountCompletenessEnum[keyof typeof WorkStreamCostAmountCompletenessEnum];

export interface WorkStreamCostOwner {
    'costUsd': number;
    'completeness': WorkStreamCostOwnerCompletenessEnum;
    'sourceCount': number;
    'ownerKind': WorkStreamCostOwnerOwnerKindEnum;
    'ownerId': number;
}

export const WorkStreamCostOwnerCompletenessEnum = {
    Accruing: 'accruing',
    Final: 'final',
    Partial: 'partial',
    Unavailable: 'unavailable'
} as const;

export type WorkStreamCostOwnerCompletenessEnum = typeof WorkStreamCostOwnerCompletenessEnum[keyof typeof WorkStreamCostOwnerCompletenessEnum];
export const WorkStreamCostOwnerOwnerKindEnum = {
    Event: 'event',
    Message: 'message',
    Run: 'run'
} as const;

export type WorkStreamCostOwnerOwnerKindEnum = typeof WorkStreamCostOwnerOwnerKindEnum[keyof typeof WorkStreamCostOwnerOwnerKindEnum];

export interface WorkStreamCostView {
    'workStreamId': number;
    'runId': number;
    'total': WorkStreamCostAmount;
    'externalReported': WorkStreamCostAmount;
    'owners': Array<WorkStreamCostOwner>;
    'runs': Array<WorkStreamCostViewRunsInner>;
}
export interface WorkStreamCostViewRunsInner {
    'costUsd': number;
    'completeness': WorkStreamCostViewRunsInnerCompletenessEnum;
    'sourceCount': number;
    'runId': number;
}

export const WorkStreamCostViewRunsInnerCompletenessEnum = {
    Accruing: 'accruing',
    Final: 'final',
    Partial: 'partial',
    Unavailable: 'unavailable'
} as const;

export type WorkStreamCostViewRunsInnerCompletenessEnum = typeof WorkStreamCostViewRunsInnerCompletenessEnum[keyof typeof WorkStreamCostViewRunsInnerCompletenessEnum];

export interface WorkStreamDetail {
    'id': number;
    'contextKind': WorkStreamDetailContextKindEnum;
    'teamId': number;
    'teamName': string;
    'projectId': number;
    'projectName': string;
    'cardId': number;
    'cardTitle': string;
    'cardReference': string;
    'agentId': number;
    'agentName'?: string;
    'chatConversationId': number;
    'conversationTitle': string;
    /**
     * Work stream whose agent spawned this one via start_sub_agent; null for ordinary streams. 
     */
    'parentWorkStreamId': number;
    'externalWorkSessionId'?: number;
    'runtimeType': WorkStreamDetailRuntimeTypeEnum;
    'status': WorkStreamDetailStatusEnum;
    'latestRunId'?: number;
    'latestEventSequence': number;
    'createdAt': string;
    'updatedAt': string;
    'terminalAt'?: string;
    'runCount': number;
    'isLatest': boolean;
    'controls': WorkStreamControls;
    'costs': WorkStreamCostView;
    'runs': Array<WorkStreamRun>;
    'conversation': Array<WorkStreamConversationMessage>;
    /**
     * What started this Work stream, from its first run.
     */
    'origin'?: WorkItemProvenance;
}

export const WorkStreamDetailContextKindEnum = {
    Card: 'card',
    TeamChat: 'team_chat'
} as const;

export type WorkStreamDetailContextKindEnum = typeof WorkStreamDetailContextKindEnum[keyof typeof WorkStreamDetailContextKindEnum];
export const WorkStreamDetailRuntimeTypeEnum = {
    BuiltIn: 'built_in',
    External: 'external'
} as const;

export type WorkStreamDetailRuntimeTypeEnum = typeof WorkStreamDetailRuntimeTypeEnum[keyof typeof WorkStreamDetailRuntimeTypeEnum];
export const WorkStreamDetailStatusEnum = {
    Active: 'active',
    Waiting: 'waiting',
    Completed: 'completed',
    Failed: 'failed',
    Interrupted: 'interrupted',
    Stopped: 'stopped'
} as const;

export type WorkStreamDetailStatusEnum = typeof WorkStreamDetailStatusEnum[keyof typeof WorkStreamDetailStatusEnum];

export interface WorkStreamDiffLine {
    'type': WorkStreamDiffLineTypeEnum;
    'content': string;
    'oldLineNumber': number;
    'newLineNumber': number;
    'noNewlineAtEnd': boolean;
}

export const WorkStreamDiffLineTypeEnum = {
    Context: 'context',
    Added: 'added',
    Removed: 'removed'
} as const;

export type WorkStreamDiffLineTypeEnum = typeof WorkStreamDiffLineTypeEnum[keyof typeof WorkStreamDiffLineTypeEnum];

export interface WorkStreamEvent {
    'id': number;
    'runId': number;
    'sequence': number;
    'kind': WorkStreamEventKindEnum;
    /**
     * Stable event subtype. Approval interactions use approval_requested and approval_decided; both include approvalId in details and retain the source assistant message when available. Sub-agent spawns use sub_agent_started and sub_agent_finished; both include childWorkStreamId, childAgentId, childAgentName and description in details. Browser recording lifecycle uses browser_recording_started, browser_recording_stopped, browser_recording_ready, browser_recording_committed, browser_recording_deleted, and browser_recording_expired with recordingId, nullable draftId/contentFileId, and a safe name. Generated production completion uses video_production_completed with productionId, contentFileId, and a safe name. 
     */
    'subtype': string;
    'status'?: string;
    'parentEventId'?: number;
    'summary': string;
    'details': Record<string, any>;
    'tool': WorkStreamToolView;
    'sourceChatMessageId'?: number;
    'startedAt'?: string;
    'finishedAt'?: string;
    'createdAt': string;
    'llmCost'?: WorkStreamCostAmount;
}

export const WorkStreamEventKindEnum = {
    Conversation: 'conversation',
    Progress: 'progress',
    Tool: 'tool',
    File: 'file',
    Browser: 'browser',
    Interaction: 'interaction',
    Lifecycle: 'lifecycle',
    Skill: 'skill'
} as const;

export type WorkStreamEventKindEnum = typeof WorkStreamEventKindEnum[keyof typeof WorkStreamEventKindEnum];

export interface WorkStreamEventPage {
    'items': Array<WorkStreamEvent>;
    'hasMoreBefore': boolean;
    'hasMoreAfter': boolean;
    'nextBeforeCursor': string;
    'nextAfterCursor': string;
}

export const WorkStreamFileCaptureState = {
    Captured: 'captured',
    Excluded: 'excluded',
    Binary: 'binary',
    Oversized: 'oversized',
    Unavailable: 'unavailable',
    Expired: 'expired'
} as const;

export type WorkStreamFileCaptureState = typeof WorkStreamFileCaptureState[keyof typeof WorkStreamFileCaptureState];


export interface WorkStreamFileDetail {
    'fileStateId': number;
    'root': WorkStreamFileDetailRootEnum;
    'path': string;
    'operation': WorkStreamFileOperation;
    'captureState': WorkStreamFileCaptureState;
    'addedLines': number;
    'removedLines': number;
    'runIds': Array<number>;
    'firstObservedAt': string;
    'latestObservedAt': string;
    'renamedFromStateId'?: number;
    'workStreamId': number;
    'scope': WorkStreamFileDetailScopeEnum;
    'runId': number;
    'baselineCaptureState': WorkStreamFileCaptureState;
    'latestCaptureState': WorkStreamFileCaptureState;
    'failureReason'?: string;
    'baselineLabel': string;
    'latestLabel': string;
    'netDiff': Array<WorkStreamDiffLine>;
    'latestContent': string;
    'sizeBytes'?: number;
    'mimeType'?: string;
    'history': Array<WorkStreamFileHistoryItem>;
}

export const WorkStreamFileDetailRootEnum = {
    Project: 'project',
    Workspace: 'workspace'
} as const;

export type WorkStreamFileDetailRootEnum = typeof WorkStreamFileDetailRootEnum[keyof typeof WorkStreamFileDetailRootEnum];
export const WorkStreamFileDetailScopeEnum = {
    All: 'all',
    Run: 'run'
} as const;

export type WorkStreamFileDetailScopeEnum = typeof WorkStreamFileDetailScopeEnum[keyof typeof WorkStreamFileDetailScopeEnum];

export interface WorkStreamFileHistoryItem {
    'eventId': number;
    'runId': number;
    'runOrdinal': number;
    'sequence': number;
    'operation': string;
    'captureState': string;
    'summary': string;
    'observedAt': string;
}

export const WorkStreamFileOperation = {
    Read: 'read',
    Created: 'created',
    Modified: 'modified',
    Renamed: 'renamed',
    Deleted: 'deleted'
} as const;

export type WorkStreamFileOperation = typeof WorkStreamFileOperation[keyof typeof WorkStreamFileOperation];


export interface WorkStreamFileTree {
    'workStreamId': number;
    'scope': WorkStreamFileTreeScopeEnum;
    'runId': number;
    'items': Array<WorkStreamFileTreeItem>;
}

export const WorkStreamFileTreeScopeEnum = {
    All: 'all',
    Run: 'run'
} as const;

export type WorkStreamFileTreeScopeEnum = typeof WorkStreamFileTreeScopeEnum[keyof typeof WorkStreamFileTreeScopeEnum];

export interface WorkStreamFileTreeItem {
    'fileStateId': number;
    'root': WorkStreamFileTreeItemRootEnum;
    'path': string;
    'operation': WorkStreamFileOperation;
    'captureState': WorkStreamFileCaptureState;
    'addedLines': number;
    'removedLines': number;
    'runIds': Array<number>;
    'firstObservedAt': string;
    'latestObservedAt': string;
    'renamedFromStateId'?: number;
}

export const WorkStreamFileTreeItemRootEnum = {
    Project: 'project',
    Workspace: 'workspace'
} as const;

export type WorkStreamFileTreeItemRootEnum = typeof WorkStreamFileTreeItemRootEnum[keyof typeof WorkStreamFileTreeItemRootEnum];

export interface WorkStreamGuidanceRequest {
    'content': string;
}
export interface WorkStreamGuidanceResult {
    'messageId': number;
    'guidanceId': number;
    'deliveryState': WorkStreamGuidanceResultDeliveryStateEnum;
}

export const WorkStreamGuidanceResultDeliveryStateEnum = {
    Queued: 'queued'
} as const;

export type WorkStreamGuidanceResultDeliveryStateEnum = typeof WorkStreamGuidanceResultDeliveryStateEnum[keyof typeof WorkStreamGuidanceResultDeliveryStateEnum];

export interface WorkStreamModelUsage {
    'model': string;
    'modelProvider': string;
    'tokensIn': number;
    'tokensOut': number;
}
export interface WorkStreamRun {
    'id': number;
    'ordinal': number;
    'triggerType': string;
    'status': string;
    'initiatingUserId'?: number;
    'initiatingMessageId'?: number;
    'jobId'?: number;
    'externalWorkSessionId'?: number;
    'workspaceId'?: number;
    'runtimeDetails': Record<string, any>;
    'startedAt'?: string;
    'heartbeatAt'?: string;
    'terminalAt'?: string;
    'stopRequestedAt'?: string;
    'stopRequestedByUserId'?: number;
    'stopOutcome'?: string;
    'stopReason'?: string;
    'createdAt': string;
    'updatedAt': string;
    'llmCost'?: WorkStreamCostAmount;
}
export interface WorkStreamSkillActivationDetail {
    'eventId': number;
    'runId': number;
    'runOrdinal': number;
    'eventSequence': number;
    /**
     * Position among the turn\'s activations, in activation order
     */
    'activationSequence': number;
    'skillId': number;
    'skillName': string;
    'description': string;
    /**
     * How the skill entered context: `always` (injected into the prompt), `explicit_load` (the agent called skills__load), or `bundle:<key>` (the agent loaded a tool bundle that satisfied every bundle the skill requires). 
     */
    'trigger': string;
    'summary': string;
    'activatedAt': string;
    'sourceChatMessageId': number;
    'workStreamId': number;
    'scope': WorkStreamSkillActivationDetailScopeEnum;
    /**
     * The skill\'s instructions exactly as the agent received them
     */
    'content': string;
    'contentElided': boolean;
}

export const WorkStreamSkillActivationDetailScopeEnum = {
    All: 'all',
    Run: 'run'
} as const;

export type WorkStreamSkillActivationDetailScopeEnum = typeof WorkStreamSkillActivationDetailScopeEnum[keyof typeof WorkStreamSkillActivationDetailScopeEnum];

export interface WorkStreamSkillActivationItem {
    'eventId': number;
    'runId': number;
    'runOrdinal': number;
    'eventSequence': number;
    /**
     * Position among the turn\'s activations, in activation order
     */
    'activationSequence': number;
    'skillId': number;
    'skillName': string;
    'description': string;
    /**
     * How the skill entered context: `always` (injected into the prompt), `explicit_load` (the agent called skills__load), or `bundle:<key>` (the agent loaded a tool bundle that satisfied every bundle the skill requires). 
     */
    'trigger': string;
    'summary': string;
    'activatedAt': string;
    'sourceChatMessageId': number;
}
export interface WorkStreamSkillActivationList {
    'workStreamId': number;
    'scope': WorkStreamSkillActivationListScopeEnum;
    'runId': number;
    'items': Array<WorkStreamSkillActivationItem>;
}

export const WorkStreamSkillActivationListScopeEnum = {
    All: 'all',
    Run: 'run'
} as const;

export type WorkStreamSkillActivationListScopeEnum = typeof WorkStreamSkillActivationListScopeEnum[keyof typeof WorkStreamSkillActivationListScopeEnum];

export interface WorkStreamStopResult {
    'runId': number;
    'outcome': WorkStreamStopResultOutcomeEnum;
}

export const WorkStreamStopResultOutcomeEnum = {
    Accepted: 'accepted'
} as const;

export type WorkStreamStopResultOutcomeEnum = typeof WorkStreamStopResultOutcomeEnum[keyof typeof WorkStreamStopResultOutcomeEnum];

export interface WorkStreamSummary {
    'id': number;
    'contextKind': WorkStreamSummaryContextKindEnum;
    'teamId': number;
    'teamName': string;
    'projectId': number;
    'projectName': string;
    'cardId': number;
    'cardTitle': string;
    'cardReference': string;
    'agentId': number;
    'agentName'?: string;
    'chatConversationId': number;
    'conversationTitle': string;
    /**
     * Work stream whose agent spawned this one via start_sub_agent; null for ordinary streams. 
     */
    'parentWorkStreamId': number;
    'externalWorkSessionId'?: number;
    'runtimeType': WorkStreamSummaryRuntimeTypeEnum;
    'status': WorkStreamSummaryStatusEnum;
    'latestRunId'?: number;
    'latestEventSequence': number;
    'createdAt': string;
    'updatedAt': string;
    'terminalAt'?: string;
    'runCount': number;
    'isLatest': boolean;
    'controls': WorkStreamControls;
    'costs': WorkStreamCostView;
}

export const WorkStreamSummaryContextKindEnum = {
    Card: 'card',
    TeamChat: 'team_chat'
} as const;

export type WorkStreamSummaryContextKindEnum = typeof WorkStreamSummaryContextKindEnum[keyof typeof WorkStreamSummaryContextKindEnum];
export const WorkStreamSummaryRuntimeTypeEnum = {
    BuiltIn: 'built_in',
    External: 'external'
} as const;

export type WorkStreamSummaryRuntimeTypeEnum = typeof WorkStreamSummaryRuntimeTypeEnum[keyof typeof WorkStreamSummaryRuntimeTypeEnum];
export const WorkStreamSummaryStatusEnum = {
    Active: 'active',
    Waiting: 'waiting',
    Completed: 'completed',
    Failed: 'failed',
    Interrupted: 'interrupted',
    Stopped: 'stopped'
} as const;

export type WorkStreamSummaryStatusEnum = typeof WorkStreamSummaryStatusEnum[keyof typeof WorkStreamSummaryStatusEnum];

/**
 * @type WorkStreamToolValue
 */
export type WorkStreamToolValue = Array<any> | Record<string, any> | boolean | number | string;

export interface WorkStreamToolView {
    'eventId': number;
    'toolName': string;
    'status': WorkStreamToolViewStatusEnum;
    'safeSummary': string;
    'safeInput': WorkStreamToolValue;
    'safeOutput': WorkStreamToolValue;
    'startedAt': string;
    'finishedAt': string;
    'durationMs': number;
    'llmCost': WorkStreamCostOwner;
}

export const WorkStreamToolViewStatusEnum = {
    Queued: 'queued',
    Running: 'running',
    Succeeded: 'succeeded',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type WorkStreamToolViewStatusEnum = typeof WorkStreamToolViewStatusEnum[keyof typeof WorkStreamToolViewStatusEnum];

export interface WorkStreamWorkSummary {
    'workStreamId': number;
    'scope': WorkStreamWorkSummaryScopeEnum;
    'runId': number;
    'usage': WorkStreamWorkSummaryUsage;
    'screenshotCount': number;
}

export const WorkStreamWorkSummaryScopeEnum = {
    All: 'all',
    Run: 'run'
} as const;

export type WorkStreamWorkSummaryScopeEnum = typeof WorkStreamWorkSummaryScopeEnum[keyof typeof WorkStreamWorkSummaryScopeEnum];

export interface WorkStreamWorkSummaryUsage {
    'tokensIn': number;
    'tokensOut': number;
    /**
     * Ordered by total tokens descending; first is primary.
     */
    'models': Array<WorkStreamModelUsage>;
}
export interface Workspace {
    'id'?: number;
    'name'?: string;
    'description'?: string;
    'status'?: WorkspaceStatusEnum;
    'sessionState'?: WorkspaceSessionStateEnum;
    'snapshotSizeBytes'?: number;
    'snapshotAt'?: string;
    'lastUsedAt'?: string;
    'createdAt'?: string;
    'createdByAgentId'?: number;
    'providerKey'?: string;
    'providerRegion'?: string;
    'allocation'?: WorkspaceAllocationRequest;
    'approvedQuote'?: Record<string, any>;
    'allocationGeneration'?: number;
    'currentSessionAllocation'?: WorkspaceAllocationRequest;
    'currentSessionAllocationGeneration'?: number;
}

export const WorkspaceStatusEnum = {
    Active: 'active',
    Archived: 'archived'
} as const;

export type WorkspaceStatusEnum = typeof WorkspaceStatusEnum[keyof typeof WorkspaceStatusEnum];
export const WorkspaceSessionStateEnum = {
    Idle: 'idle',
    Starting: 'starting',
    Running: 'running'
} as const;

export type WorkspaceSessionStateEnum = typeof WorkspaceSessionStateEnum[keyof typeof WorkspaceSessionStateEnum];

export interface WorkspaceAllocationRequest {
    'cpuMillis'?: number;
    'memoryMiB'?: number;
    'storageGiB'?: number;
    'gpu'?: Record<string, any>;
    'networkMode'?: WorkspaceAllocationRequestNetworkModeEnum;
    'projectionHoursPerDay'?: number;
}

export const WorkspaceAllocationRequestNetworkModeEnum = {
    None: 'none',
    AllowlistedEgress: 'allowlisted_egress'
} as const;

export type WorkspaceAllocationRequestNetworkModeEnum = typeof WorkspaceAllocationRequestNetworkModeEnum[keyof typeof WorkspaceAllocationRequestNetworkModeEnum];

export interface WorkspaceCapabilities {
    'providerKey': string;
    'region': string;
    'cpuMillis': WorkspaceResourceRange;
    'memoryMiB': WorkspaceResourceRange;
    'storageGiB': WorkspaceResourceRange;
    'gpuTypes': Array<Record<string, any>>;
    'networkModes': Array<string>;
    'networkProtocols': Array<WorkspaceCapabilitiesNetworkProtocolsEnum>;
}

export const WorkspaceCapabilitiesNetworkProtocolsEnum = {
    Tcp: 'tcp',
    Udp: 'udp',
    Icmp: 'icmp'
} as const;

export type WorkspaceCapabilitiesNetworkProtocolsEnum = typeof WorkspaceCapabilitiesNetworkProtocolsEnum[keyof typeof WorkspaceCapabilitiesNetworkProtocolsEnum];

export interface WorkspaceCommandLogEntry {
    'operationId'?: number;
    'workspaceId'?: number;
    'workspaceUuid'?: string;
    'agentId'?: number;
    'opType'?: string;
    'status'?: string;
    'request'?: Record<string, any>;
    'errorMessage'?: string;
    'createdAt'?: string;
    'startedAt'?: string;
    'completedAt'?: string;
    'durationMs'?: number;
    'resultSummary'?: string;
}
export interface WorkspaceCommandLogResponse {
    'commandLog'?: Array<WorkspaceCommandLogEntry>;
}
export interface WorkspaceListResponse {
    'workspaces'?: Array<Workspace>;
}
export interface WorkspacePolicy {
    'requiresHumanApproval': boolean;
    'maxCpuMillis': number;
    'maxMemoryMiB': number;
    'maxStorageGiB': number;
    'defaultCpuMillis': number;
    'defaultMemoryMiB': number;
    'defaultStorageGiB': number;
    'allowGpu': boolean;
    'maxGpuCount': number;
    'autoProvisionWorkspace': boolean;
    'maxWorkspacesPerAgent': number;
}
export interface WorkspacePriceCatalog {
    'id': string;
    'providerKey': string;
    'region': string;
    'version'?: string;
    'publishedAt'?: string;
    'effectiveAt'?: string;
    'fetchedAt': string;
    'cpu': Record<string, any>;
    'memory': Record<string, any>;
    'storage': Record<string, any>;
    'gpu': Record<string, any>;
}
export interface WorkspaceProviderTarget {
    'providerKey': WorkspaceProviderTargetProviderKeyEnum;
    'providerRegion': string;
}

export const WorkspaceProviderTargetProviderKeyEnum = {
    Local: 'local',
    Gke: 'gke',
    Firecracker: 'firecracker'
} as const;

export type WorkspaceProviderTargetProviderKeyEnum = typeof WorkspaceProviderTargetProviderKeyEnum[keyof typeof WorkspaceProviderTargetProviderKeyEnum];

export interface WorkspaceProvisionInput {
    'agentId': number;
    'name': string;
    'description'?: string;
    'allocation'?: WorkspaceAllocationRequest;
}
export interface WorkspaceProvisionResponse {
    'request': WorkspaceResourceRequest;
    'workspace'?: Workspace;
}
export interface WorkspaceRequestRevisionInput {
    'revision': number;
    'allocation': WorkspaceAllocationRequest;
}
export interface WorkspaceResourceRange {
    'min': number;
    'max': number;
    'step': number;
}
export interface WorkspaceResourceRequest {
    'id': number;
    'token': string;
    'resourceType': WorkspaceResourceRequestResourceTypeEnum;
    'status': WorkspaceResourceRequestStatusEnum;
    'currentRevision': number;
    'approvedRevision'?: number;
    'requestingAgentId'?: number;
    'decidedByUserId'?: number;
    'decidedAt'?: string;
    'fulfilledWorkspaceId'?: number;
    'failure'?: WorkspaceResourceRequestFailure;
    'createdAt': string;
    'updatedAt': string;
}

export const WorkspaceResourceRequestResourceTypeEnum = {
    WorkspaceCreate: 'workspace_create',
    WorkspaceResize: 'workspace_resize'
} as const;

export type WorkspaceResourceRequestResourceTypeEnum = typeof WorkspaceResourceRequestResourceTypeEnum[keyof typeof WorkspaceResourceRequestResourceTypeEnum];
export const WorkspaceResourceRequestStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected',
    Canceled: 'canceled',
    Provisioning: 'provisioning',
    Fulfilled: 'fulfilled',
    Failed: 'failed'
} as const;

export type WorkspaceResourceRequestStatusEnum = typeof WorkspaceResourceRequestStatusEnum[keyof typeof WorkspaceResourceRequestStatusEnum];

export interface WorkspaceResourceRequestDetail {
    'approvalId'?: number;
    'request': WorkspaceResourceRequest;
    'revision': WorkspaceResourceRequestRevision;
    'requestingAgent': ApprovalItemRequestingAgent;
    'requestingUser'?: WorkspaceResourceRequestDetailRequestingUser;
    'requestingTrigger'?: string;
    'origin'?: ApprovalOrigin;
}
/**
 * The human on whose behalf the agent raised the request, from the approval record\'s turn principal, never from the agent\'s prose. Null when the turn ran unattended or the record predates the field.
 */
export interface WorkspaceResourceRequestDetailRequestingUser {
    'id': number;
    'name': string;
}
export interface WorkspaceResourceRequestFailure {
    'code'?: string;
    'message'?: string;
}
export interface WorkspaceResourceRequestResponse {
    'request': WorkspaceResourceRequest;
}
export interface WorkspaceResourceRequestRevision {
    'revision': number;
    'providerKey': string;
    'providerRegion'?: string;
    'requestedAllocation': Record<string, any>;
    'normalizedAllocation': Record<string, any>;
    'quote': Record<string, any>;
    'catalog': WorkspaceResourceRequestRevisionCatalog;
}
export interface WorkspaceResourceRequestRevisionCatalog {
    'id': string;
    'version'?: string;
    'publishedAt'?: string;
    'effectiveAt'?: string;
    'fetchedAt': string;
}

/**
 * ActionLogApi - axios parameter creator
 */
export const ActionLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get action log for a specific metric
         * @param {number} metricId ID of the metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsMetricIdActionLogGet: async (metricId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('apiMetricsMetricIdActionLogGet', 'metricId', metricId)
            const localVarPath = `/api/metrics/{metricId}/action-log`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionLogApi - functional programming interface
 */
export const ActionLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get action log for a specific metric
         * @param {number} metricId ID of the metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsMetricIdActionLogGet(metricId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMetricsMetricIdActionLogGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsMetricIdActionLogGet(metricId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLogApi.apiMetricsMetricIdActionLogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionLogApi - factory interface
 */
export const ActionLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionLogApiFp(configuration)
    return {
        /**
         * 
         * @summary Get action log for a specific metric
         * @param {number} metricId ID of the metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsMetricIdActionLogGet(metricId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiMetricsMetricIdActionLogGet200Response> {
            return localVarFp.apiMetricsMetricIdActionLogGet(metricId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionLogApi - object-oriented interface
 */
export class ActionLogApi extends BaseAPI {
    /**
     * 
     * @summary Get action log for a specific metric
     * @param {number} metricId ID of the metric
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMetricsMetricIdActionLogGet(metricId: number, options?: RawAxiosRequestConfig) {
        return ActionLogApiFp(this.configuration).apiMetricsMetricIdActionLogGet(metricId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgentApi - axios parameter creator
 */
export const AgentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Learn from website for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdLearnGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdLearnGet', 'agentId', agentId)
            const localVarPath = `/api/agent/{agentId}/learn`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an agent
         * @param {number} id ID of the agent
         * @param {DeleteAgentRequest} [deleteAgentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdDelete: async (id: number, deleteAgentRequest?: DeleteAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentIdDelete', 'id', id)
            const localVarPath = `/api/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview team secrets deleted with an agent
         * @param {number} id ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdDeletionImpactGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentIdDeletionImpactGet', 'id', id)
            const localVarPath = `/api/agent/{id}/deletion-impact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get agent details
         * @param {number} id ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentIdGet', 'id', id)
            const localVarPath = `/api/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pause or resume all work for this agent
         * @param {number} id ID of the agent
         * @param {ApiAgentIdPausedPutRequest} apiAgentIdPausedPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdPausedPut: async (id: number, apiAgentIdPausedPutRequest: ApiAgentIdPausedPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentIdPausedPut', 'id', id)
            // verify required parameter 'apiAgentIdPausedPutRequest' is not null or undefined
            assertParamExists('apiAgentIdPausedPut', 'apiAgentIdPausedPutRequest', apiAgentIdPausedPutRequest)
            const localVarPath = `/api/agent/{id}/paused`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAgentIdPausedPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an agent
         * @param {number} id ID of the agent
         * @param {AgentRequest} agentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdPut: async (id: number, agentRequest: AgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentIdPut', 'id', id)
            // verify required parameter 'agentRequest' is not null or undefined
            assertParamExists('apiAgentIdPut', 'agentRequest', agentRequest)
            const localVarPath = `/api/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new agent
         * @param {AgentRequest} agentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentPost: async (agentRequest: AgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentRequest' is not null or undefined
            assertParamExists('apiAgentPost', 'agentRequest', agentRequest)
            const localVarPath = `/api/agent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate email address for an agent
         * @param {string} email Email address to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentValidateEmailEmailGet: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('apiAgentValidateEmailEmailGet', 'email', email)
            const localVarPath = `/api/agent/validate-email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get metrics for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {string} [skillIds] Comma-separated list of skill IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdMetricsGet: async (teamId: number, agentId: number, hoursAgo?: number, offset?: number, skillIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdMetricsGet', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdMetricsGet', 'agentId', agentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/metrics`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (hoursAgo !== undefined) {
                localVarQueryParameter['hoursAgo'] = hoursAgo;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (skillIds !== undefined) {
                localVarQueryParameter['skillIds'] = skillIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sources for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesGet: async (teamId: number, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesGet', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesGet', 'agentId', agentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/sources`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a source to an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdSourcesPostRequest} apiTeamTeamIdAgentAgentIdSourcesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesPost: async (teamId: number, agentId: number, apiTeamTeamIdAgentAgentIdSourcesPostRequest: ApiTeamTeamIdAgentAgentIdSourcesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesPost', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesPost', 'agentId', agentId)
            // verify required parameter 'apiTeamTeamIdAgentAgentIdSourcesPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesPost', 'apiTeamTeamIdAgentAgentIdSourcesPostRequest', apiTeamTeamIdAgentAgentIdSourcesPostRequest)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/sources`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdAgentAgentIdSourcesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a source from an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete: async (teamId: number, agentId: number, sourceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete', 'agentId', agentId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete', 'sourceId', sourceId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/sources/{sourceId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update properties of the source-agent relationship, such as allowLinking
         * @summary Update source-agent relationship properties
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest} apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesSourceIdPut: async (teamId: number, agentId: number, sourceId: number, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest: ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdPut', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdPut', 'agentId', agentId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdPut', 'sourceId', sourceId)
            // verify required parameter 'apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdPut', 'apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest', apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/sources/{sourceId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get agents for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentsGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/agents`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get agents associated with a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdAgentsGet: async (teamId: number, sourceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdAgentsGet', 'teamId', teamId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdAgentsGet', 'sourceId', sourceId)
            const localVarPath = `/api/team/{teamId}/sources/{sourceId}/agents`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiWsAgentAgentIdLearnGet', 'agentId', agentId)
            const localVarPath = `/api/ws/agent/{agentId}/learn`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnMockGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiWsAgentAgentIdLearnMockGet', 'agentId', agentId)
            const localVarPath = `/api/ws/agent/{agentId}/learn-mock`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentApi - functional programming interface
 */
export const AgentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Learn from website for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAgentAgentIdLearnGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdLearnGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiAgentAgentIdLearnGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an agent
         * @param {number} id ID of the agent
         * @param {DeleteAgentRequest} [deleteAgentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentIdDelete(id: number, deleteAgentRequest?: DeleteAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAgentIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentIdDelete(id, deleteAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiAgentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview team secrets deleted with an agent
         * @param {number} id ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentIdDeletionImpactGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDeletionImpact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentIdDeletionImpactGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiAgentIdDeletionImpactGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get agent details
         * @param {number} id ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiAgentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pause or resume all work for this agent
         * @param {number} id ID of the agent
         * @param {ApiAgentIdPausedPutRequest} apiAgentIdPausedPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentIdPausedPut(id: number, apiAgentIdPausedPutRequest: ApiAgentIdPausedPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentIdPausedPut(id, apiAgentIdPausedPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiAgentIdPausedPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an agent
         * @param {number} id ID of the agent
         * @param {AgentRequest} agentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentIdPut(id: number, agentRequest: AgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentIdPut(id, agentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiAgentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new agent
         * @param {AgentRequest} agentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentPost(agentRequest: AgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentPost(agentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiAgentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate email address for an agent
         * @param {string} email Email address to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentValidateEmailEmailGet(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentValidateEmailEmailGet(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiAgentValidateEmailEmailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get metrics for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {string} [skillIds] Comma-separated list of skill IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdMetricsGet(teamId: number, agentId: number, hoursAgo?: number, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdMetricsGet(teamId, agentId, hoursAgo, offset, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiTeamTeamIdAgentAgentIdMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sources for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSourcesGet(teamId: number, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSourcesGet(teamId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiTeamTeamIdAgentAgentIdSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a source to an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdSourcesPostRequest} apiTeamTeamIdAgentAgentIdSourcesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSourcesPost(teamId: number, agentId: number, apiTeamTeamIdAgentAgentIdSourcesPostRequest: ApiTeamTeamIdAgentAgentIdSourcesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSourcesPost(teamId, agentId, apiTeamTeamIdAgentAgentIdSourcesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiTeamTeamIdAgentAgentIdSourcesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a source from an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId: number, agentId: number, sourceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesSourceIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId, agentId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update properties of the source-agent relationship, such as allowLinking
         * @summary Update source-agent relationship properties
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest} apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId: number, agentId: number, sourceId: number, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest: ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesSourceIdPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId, agentId, sourceId, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiTeamTeamIdAgentAgentIdSourcesSourceIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get agents for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiTeamTeamIdAgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get agents associated with a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcesSourceIdAgentsGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcesSourceIdAgentsGet(teamId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiTeamTeamIdSourcesSourceIdAgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWsAgentAgentIdLearnGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiWsAgentAgentIdLearnGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWsAgentAgentIdLearnMockGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentApi.apiWsAgentAgentIdLearnMockGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentApi - factory interface
 */
export const AgentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentApiFp(configuration)
    return {
        /**
         * 
         * @summary Learn from website for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiAgentAgentIdLearnGet200Response> {
            return localVarFp.apiAgentAgentIdLearnGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an agent
         * @param {number} id ID of the agent
         * @param {DeleteAgentRequest} [deleteAgentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdDelete(id: number, deleteAgentRequest?: DeleteAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAgentIdDelete200Response> {
            return localVarFp.apiAgentIdDelete(id, deleteAgentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview team secrets deleted with an agent
         * @param {number} id ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdDeletionImpactGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<AgentDeletionImpact> {
            return localVarFp.apiAgentIdDeletionImpactGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get agent details
         * @param {number} id ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponse> {
            return localVarFp.apiAgentIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pause or resume all work for this agent
         * @param {number} id ID of the agent
         * @param {ApiAgentIdPausedPutRequest} apiAgentIdPausedPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdPausedPut(id: number, apiAgentIdPausedPutRequest: ApiAgentIdPausedPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponse> {
            return localVarFp.apiAgentIdPausedPut(id, apiAgentIdPausedPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an agent
         * @param {number} id ID of the agent
         * @param {AgentRequest} agentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentIdPut(id: number, agentRequest: AgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponse> {
            return localVarFp.apiAgentIdPut(id, agentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new agent
         * @param {AgentRequest} agentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentPost(agentRequest: AgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentResponse> {
            return localVarFp.apiAgentPost(agentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate email address for an agent
         * @param {string} email Email address to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentValidateEmailEmailGet(email: string, options?: RawAxiosRequestConfig): AxiosPromise<EmailValidationResponse> {
            return localVarFp.apiAgentValidateEmailEmailGet(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get metrics for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {string} [skillIds] Comma-separated list of skill IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdMetricsGet(teamId: number, agentId: number, hoursAgo?: number, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<MetricResponse> {
            return localVarFp.apiTeamTeamIdAgentAgentIdMetricsGet(teamId, agentId, hoursAgo, offset, skillIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sources for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesGet(teamId: number, agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceResponse>> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSourcesGet(teamId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a source to an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdSourcesPostRequest} apiTeamTeamIdAgentAgentIdSourcesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesPost(teamId: number, agentId: number, apiTeamTeamIdAgentAgentIdSourcesPostRequest: ApiTeamTeamIdAgentAgentIdSourcesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesPost200Response> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSourcesPost(teamId, agentId, apiTeamTeamIdAgentAgentIdSourcesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a source from an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId: number, agentId: number, sourceId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesSourceIdDelete200Response> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId, agentId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update properties of the source-agent relationship, such as allowLinking
         * @summary Update source-agent relationship properties
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest} apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId: number, agentId: number, sourceId: number, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest: ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesSourceIdPut200Response> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId, agentId, sourceId, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get agents for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentResponse>> {
            return localVarFp.apiTeamTeamIdAgentsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get agents associated with a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdAgentsGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentResponse>> {
            return localVarFp.apiTeamTeamIdSourcesSourceIdAgentsGet(teamId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWsAgentAgentIdLearnGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWsAgentAgentIdLearnMockGet(agentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentApi - object-oriented interface
 */
export class AgentApi extends BaseAPI {
    /**
     * 
     * @summary Learn from website for an agent
     * @param {number} agentId ID of the agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiAgentAgentIdLearnGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an agent
     * @param {number} id ID of the agent
     * @param {DeleteAgentRequest} [deleteAgentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentIdDelete(id: number, deleteAgentRequest?: DeleteAgentRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiAgentIdDelete(id, deleteAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview team secrets deleted with an agent
     * @param {number} id ID of the agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentIdDeletionImpactGet(id: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiAgentIdDeletionImpactGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get agent details
     * @param {number} id ID of the agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentIdGet(id: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiAgentIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pause or resume all work for this agent
     * @param {number} id ID of the agent
     * @param {ApiAgentIdPausedPutRequest} apiAgentIdPausedPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentIdPausedPut(id: number, apiAgentIdPausedPutRequest: ApiAgentIdPausedPutRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiAgentIdPausedPut(id, apiAgentIdPausedPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an agent
     * @param {number} id ID of the agent
     * @param {AgentRequest} agentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentIdPut(id: number, agentRequest: AgentRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiAgentIdPut(id, agentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new agent
     * @param {AgentRequest} agentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentPost(agentRequest: AgentRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiAgentPost(agentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate email address for an agent
     * @param {string} email Email address to validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentValidateEmailEmailGet(email: string, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiAgentValidateEmailEmailGet(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get metrics for an agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} [hoursAgo] Number of hours to look back (default 24)
     * @param {number} [offset] Offset for pagination (default 0)
     * @param {string} [skillIds] Comma-separated list of skill IDs to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdMetricsGet(teamId: number, agentId: number, hoursAgo?: number, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiTeamTeamIdAgentAgentIdMetricsGet(teamId, agentId, hoursAgo, offset, skillIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sources for an agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSourcesGet(teamId: number, agentId: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSourcesGet(teamId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a source to an agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {ApiTeamTeamIdAgentAgentIdSourcesPostRequest} apiTeamTeamIdAgentAgentIdSourcesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSourcesPost(teamId: number, agentId: number, apiTeamTeamIdAgentAgentIdSourcesPostRequest: ApiTeamTeamIdAgentAgentIdSourcesPostRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSourcesPost(teamId, agentId, apiTeamTeamIdAgentAgentIdSourcesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a source from an agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} sourceId ID of the source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId: number, agentId: number, sourceId: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId, agentId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update properties of the source-agent relationship, such as allowLinking
     * @summary Update source-agent relationship properties
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} sourceId ID of the source
     * @param {ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest} apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId: number, agentId: number, sourceId: number, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest: ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId, agentId, sourceId, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get agents for a team
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiTeamTeamIdAgentsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get agents associated with a source
     * @param {number} teamId ID of the team
     * @param {number} sourceId ID of the source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcesSourceIdAgentsGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiTeamTeamIdSourcesSourceIdAgentsGet(teamId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
     * @summary WebSocket endpoint for streaming agent learning progress
     * @param {number} agentId ID of the agent to learn from website
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiWsAgentAgentIdLearnGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
     * @summary WebSocket endpoint for streaming mock agent learning progress
     * @param {number} agentId ID of the agent to simulate learning
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig) {
        return AgentApiFp(this.configuration).apiWsAgentAgentIdLearnMockGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgentWideTestingApi - axios parameter creator
 */
export const AgentWideTestingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all test results for agent-wide testing
         * @summary Get test results for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdTestResultsGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdTestResultsGet', 'agentId', agentId)
            const localVarPath = `/api/agent/{agentId}/test-results`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Execute test iterations for all test data associated with an agent
         * @summary Start agent-wide test execution
         * @param {number} agentId ID of the agent to test
         * @param {TestStartRequest} [testStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdTestStartPost: async (agentId: number, testStartRequest?: TestStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdTestStartPost', 'agentId', agentId)
            const localVarPath = `/api/agent/{agentId}/test/start`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all test results for a specific agent with pagination support
         * @summary Get all test results for an agent with pagination
         * @param {number} agentId ID of the agent
         * @param {number} [offset] Number of results to skip for pagination
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdTestsResultsGet: async (agentId: number, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdTestsResultsGet', 'agentId', agentId)
            const localVarPath = `/api/agent/{agentId}/tests/results`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentWideTestingApi - functional programming interface
 */
export const AgentWideTestingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentWideTestingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all test results for agent-wide testing
         * @summary Get test results for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdTestResultsGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdTestResultsGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentWideTestingApi.apiAgentAgentIdTestResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Execute test iterations for all test data associated with an agent
         * @summary Start agent-wide test execution
         * @param {number} agentId ID of the agent to test
         * @param {TestStartRequest} [testStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdTestStartPost(agentId: number, testStartRequest?: TestStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdTestStartPost(agentId, testStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentWideTestingApi.apiAgentAgentIdTestStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all test results for a specific agent with pagination support
         * @summary Get all test results for an agent with pagination
         * @param {number} agentId ID of the agent
         * @param {number} [offset] Number of results to skip for pagination
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdTestsResultsGet(agentId: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTestResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdTestsResultsGet(agentId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentWideTestingApi.apiAgentAgentIdTestsResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentWideTestingApi - factory interface
 */
export const AgentWideTestingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentWideTestingApiFp(configuration)
    return {
        /**
         * Retrieve all test results for agent-wide testing
         * @summary Get test results for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdTestResultsGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TestResult>> {
            return localVarFp.apiAgentAgentIdTestResultsGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute test iterations for all test data associated with an agent
         * @summary Start agent-wide test execution
         * @param {number} agentId ID of the agent to test
         * @param {TestStartRequest} [testStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdTestStartPost(agentId: number, testStartRequest?: TestStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestStartResponse> {
            return localVarFp.apiAgentAgentIdTestStartPost(agentId, testStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all test results for a specific agent with pagination support
         * @summary Get all test results for an agent with pagination
         * @param {number} agentId ID of the agent
         * @param {number} [offset] Number of results to skip for pagination
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdTestsResultsGet(agentId: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTestResults> {
            return localVarFp.apiAgentAgentIdTestsResultsGet(agentId, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentWideTestingApi - object-oriented interface
 */
export class AgentWideTestingApi extends BaseAPI {
    /**
     * Retrieve all test results for agent-wide testing
     * @summary Get test results for an agent
     * @param {number} agentId ID of the agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdTestResultsGet(agentId: number, options?: RawAxiosRequestConfig) {
        return AgentWideTestingApiFp(this.configuration).apiAgentAgentIdTestResultsGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Execute test iterations for all test data associated with an agent
     * @summary Start agent-wide test execution
     * @param {number} agentId ID of the agent to test
     * @param {TestStartRequest} [testStartRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdTestStartPost(agentId: number, testStartRequest?: TestStartRequest, options?: RawAxiosRequestConfig) {
        return AgentWideTestingApiFp(this.configuration).apiAgentAgentIdTestStartPost(agentId, testStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all test results for a specific agent with pagination support
     * @summary Get all test results for an agent with pagination
     * @param {number} agentId ID of the agent
     * @param {number} [offset] Number of results to skip for pagination
     * @param {number} [limit] Maximum number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdTestsResultsGet(agentId: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return AgentWideTestingApiFp(this.configuration).apiAgentAgentIdTestsResultsGet(agentId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ApprovalsApi - axios parameter creator
 */
export const ApprovalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Human secret editors can answer secret create, access, and mutation requests without approval manage. Other kinds require approval manage and the permission exercised by an approved action. Team membership and origin visibility are required. Secret values are write-only inputs. 
         * @param {number} approvalId 
         * @param {ApprovalDecisionRequest} approvalDecisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApprovalsApprovalIdDecisionPost: async (approvalId: number, approvalDecisionRequest: ApprovalDecisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'approvalId' is not null or undefined
            assertParamExists('apiApprovalsApprovalIdDecisionPost', 'approvalId', approvalId)
            // verify required parameter 'approvalDecisionRequest' is not null or undefined
            assertParamExists('apiApprovalsApprovalIdDecisionPost', 'approvalDecisionRequest', approvalDecisionRequest)
            const localVarPath = `/api/approvals/{approvalId}/decision`
                .replace(`{${"approvalId"}}`, encodeURIComponent(String(approvalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approvalDecisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Secret requests require team secret view; other kinds require approval view. Team membership and approval origin visibility are always required. 
         * @param {number} approvalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApprovalsApprovalIdGet: async (approvalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'approvalId' is not null or undefined
            assertParamExists('apiApprovalsApprovalIdGet', 'approvalId', approvalId)
            const localVarPath = `/api/approvals/{approvalId}`
                .replace(`{${"approvalId"}}`, encodeURIComponent(String(approvalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the five oldest pending approvals across the current user\'s teams
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApprovalsGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/approvals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires approval view, or team secret view for secret requests only. Team membership and approval origin visibility are always required. 
         * @summary List the five oldest pending approvals for a team
         * @param {number} teamId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdApprovalsGet: async (teamId: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdApprovalsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/approvals`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApprovalsApi - functional programming interface
 */
export const ApprovalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApprovalsApiAxiosParamCreator(configuration)
    return {
        /**
         * Human secret editors can answer secret create, access, and mutation requests without approval manage. Other kinds require approval manage and the permission exercised by an approved action. Team membership and origin visibility are required. Secret values are write-only inputs. 
         * @param {number} approvalId 
         * @param {ApprovalDecisionRequest} approvalDecisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApprovalsApprovalIdDecisionPost(approvalId: number, approvalDecisionRequest: ApprovalDecisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiApprovalsApprovalIdDecisionPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApprovalsApprovalIdDecisionPost(approvalId, approvalDecisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApprovalsApi.apiApprovalsApprovalIdDecisionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Secret requests require team secret view; other kinds require approval view. Team membership and approval origin visibility are always required. 
         * @param {number} approvalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApprovalsApprovalIdGet(approvalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiApprovalsApprovalIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApprovalsApprovalIdGet(approvalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApprovalsApi.apiApprovalsApprovalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the five oldest pending approvals across the current user\'s teams
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApprovalsGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApprovalListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApprovalsGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApprovalsApi.apiApprovalsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires approval view, or team secret view for secret requests only. Team membership and approval origin visibility are always required. 
         * @summary List the five oldest pending approvals for a team
         * @param {number} teamId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdApprovalsGet(teamId: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApprovalListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdApprovalsGet(teamId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApprovalsApi.apiTeamsTeamIdApprovalsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApprovalsApi - factory interface
 */
export const ApprovalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApprovalsApiFp(configuration)
    return {
        /**
         * Human secret editors can answer secret create, access, and mutation requests without approval manage. Other kinds require approval manage and the permission exercised by an approved action. Team membership and origin visibility are required. Secret values are write-only inputs. 
         * @param {number} approvalId 
         * @param {ApprovalDecisionRequest} approvalDecisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApprovalsApprovalIdDecisionPost(approvalId: number, approvalDecisionRequest: ApprovalDecisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiApprovalsApprovalIdDecisionPost200Response> {
            return localVarFp.apiApprovalsApprovalIdDecisionPost(approvalId, approvalDecisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Secret requests require team secret view; other kinds require approval view. Team membership and approval origin visibility are always required. 
         * @param {number} approvalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApprovalsApprovalIdGet(approvalId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiApprovalsApprovalIdGet200Response> {
            return localVarFp.apiApprovalsApprovalIdGet(approvalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the five oldest pending approvals across the current user\'s teams
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApprovalsGet(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApprovalListResponse> {
            return localVarFp.apiApprovalsGet(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires approval view, or team secret view for secret requests only. Team membership and approval origin visibility are always required. 
         * @summary List the five oldest pending approvals for a team
         * @param {number} teamId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdApprovalsGet(teamId: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApprovalListResponse> {
            return localVarFp.apiTeamsTeamIdApprovalsGet(teamId, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApprovalsApi - object-oriented interface
 */
export class ApprovalsApi extends BaseAPI {
    /**
     * Human secret editors can answer secret create, access, and mutation requests without approval manage. Other kinds require approval manage and the permission exercised by an approved action. Team membership and origin visibility are required. Secret values are write-only inputs. 
     * @param {number} approvalId 
     * @param {ApprovalDecisionRequest} approvalDecisionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiApprovalsApprovalIdDecisionPost(approvalId: number, approvalDecisionRequest: ApprovalDecisionRequest, options?: RawAxiosRequestConfig) {
        return ApprovalsApiFp(this.configuration).apiApprovalsApprovalIdDecisionPost(approvalId, approvalDecisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Secret requests require team secret view; other kinds require approval view. Team membership and approval origin visibility are always required. 
     * @param {number} approvalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiApprovalsApprovalIdGet(approvalId: number, options?: RawAxiosRequestConfig) {
        return ApprovalsApiFp(this.configuration).apiApprovalsApprovalIdGet(approvalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the five oldest pending approvals across the current user\'s teams
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiApprovalsGet(limit?: number, options?: RawAxiosRequestConfig) {
        return ApprovalsApiFp(this.configuration).apiApprovalsGet(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires approval view, or team secret view for secret requests only. Team membership and approval origin visibility are always required. 
     * @summary List the five oldest pending approvals for a team
     * @param {number} teamId 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdApprovalsGet(teamId: number, limit?: number, options?: RawAxiosRequestConfig) {
        return ApprovalsApiFp(this.configuration).apiTeamsTeamIdApprovalsGet(teamId, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Record meaningful user activity for the current browser session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationActivityPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a password reset email
         * @param {ApiAuthenticationForgotPasswordPostRequest} apiAuthenticationForgotPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationForgotPasswordPost: async (apiAuthenticationForgotPasswordPostRequest: ApiAuthenticationForgotPasswordPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAuthenticationForgotPasswordPostRequest' is not null or undefined
            assertParamExists('apiAuthenticationForgotPasswordPost', 'apiAuthenticationForgotPasswordPostRequest', apiAuthenticationForgotPasswordPostRequest)
            const localVarPath = `/api/authentication/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAuthenticationForgotPasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with email and password
         * @param {ApiAuthenticationLoginPostRequest} apiAuthenticationLoginPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLoginPost: async (apiAuthenticationLoginPostRequest: ApiAuthenticationLoginPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAuthenticationLoginPostRequest' is not null or undefined
            assertParamExists('apiAuthenticationLoginPost', 'apiAuthenticationLoginPostRequest', apiAuthenticationLoginPostRequest)
            const localVarPath = `/api/authentication/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAuthenticationLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLogoutPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the current user\'s security methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaFactorsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/mfa/factors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove one of the current user\'s MFA factors
         * @param {ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum} type 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaFactorsTypeIdDelete: async (type: ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('apiAuthenticationMfaFactorsTypeIdDelete', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuthenticationMfaFactorsTypeIdDelete', 'id', id)
            const localVarPath = `/api/authentication/mfa/factors/{type}/{id}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Begin authenticated security-method enrollment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaManagementStartPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/mfa/management/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Begin a passkey challenge for a password or Google login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaPasskeyChallengeOptionsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/mfa/passkey/challenge/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Begin mandatory passkey enrollment for a verified account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaPasskeyRegisterOptionsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/mfa/passkey/register/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify passkey enrollment and complete login
         * @param {ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest} apiAuthenticationMfaPasskeyRegisterVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaPasskeyRegisterVerifyPost: async (apiAuthenticationMfaPasskeyRegisterVerifyPostRequest: ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAuthenticationMfaPasskeyRegisterVerifyPostRequest' is not null or undefined
            assertParamExists('apiAuthenticationMfaPasskeyRegisterVerifyPost', 'apiAuthenticationMfaPasskeyRegisterVerifyPostRequest', apiAuthenticationMfaPasskeyRegisterVerifyPostRequest)
            const localVarPath = `/api/authentication/mfa/passkey/register/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAuthenticationMfaPasskeyRegisterVerifyPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename one of the current user\'s passkeys
         * @param {string} id 
         * @param {ApiAuthenticationMfaPasskeysIdPatchRequest} apiAuthenticationMfaPasskeysIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaPasskeysIdPatch: async (id: string, apiAuthenticationMfaPasskeysIdPatchRequest: ApiAuthenticationMfaPasskeysIdPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuthenticationMfaPasskeysIdPatch', 'id', id)
            // verify required parameter 'apiAuthenticationMfaPasskeysIdPatchRequest' is not null or undefined
            assertParamExists('apiAuthenticationMfaPasskeysIdPatch', 'apiAuthenticationMfaPasskeysIdPatchRequest', apiAuthenticationMfaPasskeysIdPatchRequest)
            const localVarPath = `/api/authentication/mfa/passkeys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAuthenticationMfaPasskeysIdPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete login with a one-time recovery code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaRecoveryCodeChallengePost: async (mfaCodeRequest: MfaCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mfaCodeRequest' is not null or undefined
            assertParamExists('apiAuthenticationMfaRecoveryCodeChallengePost', 'mfaCodeRequest', mfaCodeRequest)
            const localVarPath = `/api/authentication/mfa/recovery-code/challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mfaCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace all recovery codes for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaRecoveryCodesRegeneratePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/mfa/recovery-codes/regenerate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete login with an SMS code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaSmsChallengePost: async (mfaCodeRequest: MfaCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mfaCodeRequest' is not null or undefined
            assertParamExists('apiAuthenticationMfaSmsChallengePost', 'mfaCodeRequest', mfaCodeRequest)
            const localVarPath = `/api/authentication/mfa/sms/challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mfaCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send an SMS login challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaSmsChallengeSendPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/mfa/sms/challenge/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm SMS enrollment and complete login
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaSmsConfirmPost: async (mfaCodeRequest: MfaCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mfaCodeRequest' is not null or undefined
            assertParamExists('apiAuthenticationMfaSmsConfirmPost', 'mfaCodeRequest', mfaCodeRequest)
            const localVarPath = `/api/authentication/mfa/sms/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mfaCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a code to begin SMS enrollment
         * @param {ApiAuthenticationMfaSmsSetupPostRequest} apiAuthenticationMfaSmsSetupPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaSmsSetupPost: async (apiAuthenticationMfaSmsSetupPostRequest: ApiAuthenticationMfaSmsSetupPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAuthenticationMfaSmsSetupPostRequest' is not null or undefined
            assertParamExists('apiAuthenticationMfaSmsSetupPost', 'apiAuthenticationMfaSmsSetupPostRequest', apiAuthenticationMfaSmsSetupPostRequest)
            const localVarPath = `/api/authentication/mfa/sms/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAuthenticationMfaSmsSetupPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read the current pre-authentication transaction state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/mfa/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete login with an authenticator-app code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaTotpChallengePost: async (mfaCodeRequest: MfaCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mfaCodeRequest' is not null or undefined
            assertParamExists('apiAuthenticationMfaTotpChallengePost', 'mfaCodeRequest', mfaCodeRequest)
            const localVarPath = `/api/authentication/mfa/totp/challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mfaCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm authenticator-app enrollment and complete login
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaTotpConfirmPost: async (mfaCodeRequest: MfaCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mfaCodeRequest' is not null or undefined
            assertParamExists('apiAuthenticationMfaTotpConfirmPost', 'mfaCodeRequest', mfaCodeRequest)
            const localVarPath = `/api/authentication/mfa/totp/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mfaCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Begin mandatory authenticator-app enrollment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaTotpSetupPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/mfa/totp/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get linked OAuth identities for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthIdentitiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/oauth/identities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlink an OAuth identity
         * @param {number} id ID of the OAuth identity to unlink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthIdentitiesIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuthenticationOauthIdentitiesIdDelete', 'id', id)
            const localVarPath = `/api/authentication/oauth/identities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle OAuth callback
         * @param {string} provider OAuth provider ID
         * @param {string} code Authorization code from OAuth provider
         * @param {string} state State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProviderCallbackGet: async (provider: string, code: string, state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('apiAuthenticationOauthProviderCallbackGet', 'provider', provider)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiAuthenticationOauthProviderCallbackGet', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('apiAuthenticationOauthProviderCallbackGet', 'state', state)
            const localVarPath = `/api/authentication/oauth/{provider}/callback`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initiate OAuth flow
         * @param {string} provider OAuth provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProviderGet: async (provider: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('apiAuthenticationOauthProviderGet', 'provider', provider)
            const localVarPath = `/api/authentication/oauth/{provider}`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get available OAuth providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProvidersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/oauth/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Begin identifier-free passkey authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationPasskeysOptionsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/passkeys/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify a passkey assertion and complete login
         * @param {Record<string, any>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationPasskeysVerifyPost: async (body: Record<string, any>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('apiAuthenticationPasskeysVerifyPost', 'body', body)
            const localVarPath = `/api/authentication/passkeys/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rotate the current browser session credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationRefreshPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate password reset token and redirect to reset page
         * @param {string} email Email address associated with the reset token
         * @param {string} token Password reset token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationResetPasswordGet: async (email: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('apiAuthenticationResetPasswordGet', 'email', email)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiAuthenticationResetPasswordGet', 'token', token)
            const localVarPath = `/api/authentication/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset password with token
         * @param {ApiAuthenticationResetPasswordPostRequest} apiAuthenticationResetPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationResetPasswordPost: async (apiAuthenticationResetPasswordPostRequest: ApiAuthenticationResetPasswordPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiAuthenticationResetPasswordPostRequest' is not null or undefined
            assertParamExists('apiAuthenticationResetPasswordPost', 'apiAuthenticationResetPasswordPostRequest', apiAuthenticationResetPasswordPostRequest)
            const localVarPath = `/api/authentication/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAuthenticationResetPasswordPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Record meaningful user activity for the current browser session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationActivityPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationActivityPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationActivityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request a password reset email
         * @param {ApiAuthenticationForgotPasswordPostRequest} apiAuthenticationForgotPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationForgotPasswordPost(apiAuthenticationForgotPasswordPostRequest: ApiAuthenticationForgotPasswordPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationForgotPasswordPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationForgotPasswordPost(apiAuthenticationForgotPasswordPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationForgotPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with email and password
         * @param {ApiAuthenticationLoginPostRequest} apiAuthenticationLoginPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationLoginPost(apiAuthenticationLoginPostRequest: ApiAuthenticationLoginPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationOauthIdentitiesIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationLoginPost(apiAuthenticationLoginPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationLogoutPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationLogoutPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationLogoutPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationLogoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the current user\'s security methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaFactorsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaFactorsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaFactorsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaFactorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove one of the current user\'s MFA factors
         * @param {ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum} type 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaFactorsTypeIdDelete(type: ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaFactorsTypeIdDelete(type, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaFactorsTypeIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Begin authenticated security-method enrollment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaManagementStartPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaManagementStartPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaManagementStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Begin a passkey challenge for a password or Google login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaPasskeyChallengeOptionsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Record<string, any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaPasskeyChallengeOptionsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaPasskeyChallengeOptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Begin mandatory passkey enrollment for a verified account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaPasskeyRegisterOptionsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Record<string, any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaPasskeyRegisterOptionsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaPasskeyRegisterOptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify passkey enrollment and complete login
         * @param {ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest} apiAuthenticationMfaPasskeyRegisterVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaPasskeyRegisterVerifyPost(apiAuthenticationMfaPasskeyRegisterVerifyPostRequest: ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaSmsConfirmPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaPasskeyRegisterVerifyPost(apiAuthenticationMfaPasskeyRegisterVerifyPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaPasskeyRegisterVerifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rename one of the current user\'s passkeys
         * @param {string} id 
         * @param {ApiAuthenticationMfaPasskeysIdPatchRequest} apiAuthenticationMfaPasskeysIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaPasskeysIdPatch(id: string, apiAuthenticationMfaPasskeysIdPatchRequest: ApiAuthenticationMfaPasskeysIdPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaPasskeysIdPatch(id, apiAuthenticationMfaPasskeysIdPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaPasskeysIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete login with a one-time recovery code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaRecoveryCodeChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaRecoveryCodeChallengePost(mfaCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaRecoveryCodeChallengePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace all recovery codes for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaRecoveryCodesRegeneratePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaRecoveryCodesRegeneratePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaRecoveryCodesRegeneratePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaRecoveryCodesRegeneratePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete login with an SMS code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaSmsChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaSmsChallengePost(mfaCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaSmsChallengePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send an SMS login challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaSmsChallengeSendPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaSmsChallengeSendPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaSmsChallengeSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm SMS enrollment and complete login
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaSmsConfirmPost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaSmsConfirmPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaSmsConfirmPost(mfaCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaSmsConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send a code to begin SMS enrollment
         * @param {ApiAuthenticationMfaSmsSetupPostRequest} apiAuthenticationMfaSmsSetupPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaSmsSetupPost(apiAuthenticationMfaSmsSetupPostRequest: ApiAuthenticationMfaSmsSetupPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaSmsSetupPost(apiAuthenticationMfaSmsSetupPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaSmsSetupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read the current pre-authentication transaction state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaStatusGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Complete login with an authenticator-app code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaTotpChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaTotpChallengePost(mfaCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaTotpChallengePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm authenticator-app enrollment and complete login
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaTotpConfirmPost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaTotpConfirmPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaTotpConfirmPost(mfaCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaTotpConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Begin mandatory authenticator-app enrollment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationMfaTotpSetupPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaTotpSetupPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationMfaTotpSetupPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationMfaTotpSetupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get linked OAuth identities for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthIdentitiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationOauthIdentitiesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthIdentitiesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationOauthIdentitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlink an OAuth identity
         * @param {number} id ID of the OAuth identity to unlink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationOauthIdentitiesIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthIdentitiesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationOauthIdentitiesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle OAuth callback
         * @param {string} provider OAuth provider ID
         * @param {string} code Authorization code from OAuth provider
         * @param {string} state State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthProviderCallbackGet(provider: string, code: string, state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthProviderCallbackGet(provider, code, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationOauthProviderCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initiate OAuth flow
         * @param {string} provider OAuth provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthProviderGet(provider: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthProviderGet(provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationOauthProviderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get available OAuth providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthProvidersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationOauthProvidersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthProvidersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationOauthProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Begin identifier-free passkey authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationPasskeysOptionsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Record<string, any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationPasskeysOptionsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationPasskeysOptionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify a passkey assertion and complete login
         * @param {Record<string, any>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationPasskeysVerifyPost(body: Record<string, any>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationPasskeysVerifyPost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationPasskeysVerifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rotate the current browser session credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationRefreshPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationRefreshPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate password reset token and redirect to reset page
         * @param {string} email Email address associated with the reset token
         * @param {string} token Password reset token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationResetPasswordGet(email: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationResetPasswordGet(email, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationResetPasswordGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reset password with token
         * @param {ApiAuthenticationResetPasswordPostRequest} apiAuthenticationResetPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationResetPasswordPost(apiAuthenticationResetPasswordPostRequest: ApiAuthenticationResetPasswordPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationResetPasswordPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationResetPasswordPost(apiAuthenticationResetPasswordPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.apiAuthenticationResetPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Record meaningful user activity for the current browser session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationActivityPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthenticationActivityPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a password reset email
         * @param {ApiAuthenticationForgotPasswordPostRequest} apiAuthenticationForgotPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationForgotPasswordPost(apiAuthenticationForgotPasswordPostRequest: ApiAuthenticationForgotPasswordPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationForgotPasswordPost200Response> {
            return localVarFp.apiAuthenticationForgotPasswordPost(apiAuthenticationForgotPasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with email and password
         * @param {ApiAuthenticationLoginPostRequest} apiAuthenticationLoginPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLoginPost(apiAuthenticationLoginPostRequest: ApiAuthenticationLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationOauthIdentitiesIdDelete200Response> {
            return localVarFp.apiAuthenticationLoginPost(apiAuthenticationLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationLogoutPost(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationLogoutPost200Response> {
            return localVarFp.apiAuthenticationLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the current user\'s security methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaFactorsGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaFactorsGet200Response> {
            return localVarFp.apiAuthenticationMfaFactorsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove one of the current user\'s MFA factors
         * @param {ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum} type 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaFactorsTypeIdDelete(type: ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum, id: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response> {
            return localVarFp.apiAuthenticationMfaFactorsTypeIdDelete(type, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Begin authenticated security-method enrollment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaManagementStartPost(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response> {
            return localVarFp.apiAuthenticationMfaManagementStartPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Begin a passkey challenge for a password or Google login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaPasskeyChallengeOptionsPost(options?: RawAxiosRequestConfig): AxiosPromise<Record<string, any>> {
            return localVarFp.apiAuthenticationMfaPasskeyChallengeOptionsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Begin mandatory passkey enrollment for a verified account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaPasskeyRegisterOptionsPost(options?: RawAxiosRequestConfig): AxiosPromise<Record<string, any>> {
            return localVarFp.apiAuthenticationMfaPasskeyRegisterOptionsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify passkey enrollment and complete login
         * @param {ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest} apiAuthenticationMfaPasskeyRegisterVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaPasskeyRegisterVerifyPost(apiAuthenticationMfaPasskeyRegisterVerifyPostRequest: ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaSmsConfirmPost200Response> {
            return localVarFp.apiAuthenticationMfaPasskeyRegisterVerifyPost(apiAuthenticationMfaPasskeyRegisterVerifyPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename one of the current user\'s passkeys
         * @param {string} id 
         * @param {ApiAuthenticationMfaPasskeysIdPatchRequest} apiAuthenticationMfaPasskeysIdPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaPasskeysIdPatch(id: string, apiAuthenticationMfaPasskeysIdPatchRequest: ApiAuthenticationMfaPasskeysIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response> {
            return localVarFp.apiAuthenticationMfaPasskeysIdPatch(id, apiAuthenticationMfaPasskeysIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete login with a one-time recovery code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaRecoveryCodeChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response> {
            return localVarFp.apiAuthenticationMfaRecoveryCodeChallengePost(mfaCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace all recovery codes for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaRecoveryCodesRegeneratePost(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaRecoveryCodesRegeneratePost200Response> {
            return localVarFp.apiAuthenticationMfaRecoveryCodesRegeneratePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete login with an SMS code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaSmsChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response> {
            return localVarFp.apiAuthenticationMfaSmsChallengePost(mfaCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send an SMS login challenge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaSmsChallengeSendPost(options?: RawAxiosRequestConfig): AxiosPromise<InlineObject> {
            return localVarFp.apiAuthenticationMfaSmsChallengeSendPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm SMS enrollment and complete login
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaSmsConfirmPost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaSmsConfirmPost200Response> {
            return localVarFp.apiAuthenticationMfaSmsConfirmPost(mfaCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a code to begin SMS enrollment
         * @param {ApiAuthenticationMfaSmsSetupPostRequest} apiAuthenticationMfaSmsSetupPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaSmsSetupPost(apiAuthenticationMfaSmsSetupPostRequest: ApiAuthenticationMfaSmsSetupPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<InlineObject> {
            return localVarFp.apiAuthenticationMfaSmsSetupPost(apiAuthenticationMfaSmsSetupPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read the current pre-authentication transaction state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaStatusGet200Response> {
            return localVarFp.apiAuthenticationMfaStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete login with an authenticator-app code
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaTotpChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response> {
            return localVarFp.apiAuthenticationMfaTotpChallengePost(mfaCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm authenticator-app enrollment and complete login
         * @param {MfaCodeRequest} mfaCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaTotpConfirmPost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaTotpConfirmPost200Response> {
            return localVarFp.apiAuthenticationMfaTotpConfirmPost(mfaCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Begin mandatory authenticator-app enrollment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationMfaTotpSetupPost(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaTotpSetupPost200Response> {
            return localVarFp.apiAuthenticationMfaTotpSetupPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get linked OAuth identities for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthIdentitiesGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationOauthIdentitiesGet200Response> {
            return localVarFp.apiAuthenticationOauthIdentitiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlink an OAuth identity
         * @param {number} id ID of the OAuth identity to unlink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationOauthIdentitiesIdDelete200Response> {
            return localVarFp.apiAuthenticationOauthIdentitiesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle OAuth callback
         * @param {string} provider OAuth provider ID
         * @param {string} code Authorization code from OAuth provider
         * @param {string} state State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProviderCallbackGet(provider: string, code: string, state: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthenticationOauthProviderCallbackGet(provider, code, state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initiate OAuth flow
         * @param {string} provider OAuth provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProviderGet(provider: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthenticationOauthProviderGet(provider, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get available OAuth providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProvidersGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationOauthProvidersGet200Response> {
            return localVarFp.apiAuthenticationOauthProvidersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Begin identifier-free passkey authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationPasskeysOptionsPost(options?: RawAxiosRequestConfig): AxiosPromise<Record<string, any>> {
            return localVarFp.apiAuthenticationPasskeysOptionsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify a passkey assertion and complete login
         * @param {Record<string, any>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationPasskeysVerifyPost(body: Record<string, any>, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationMfaManagementStartPost200Response> {
            return localVarFp.apiAuthenticationPasskeysVerifyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rotate the current browser session credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthenticationRefreshPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate password reset token and redirect to reset page
         * @param {string} email Email address associated with the reset token
         * @param {string} token Password reset token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationResetPasswordGet(email: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthenticationResetPasswordGet(email, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset password with token
         * @param {ApiAuthenticationResetPasswordPostRequest} apiAuthenticationResetPasswordPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationResetPasswordPost(apiAuthenticationResetPasswordPostRequest: ApiAuthenticationResetPasswordPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationResetPasswordPost200Response> {
            return localVarFp.apiAuthenticationResetPasswordPost(apiAuthenticationResetPasswordPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Record meaningful user activity for the current browser session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationActivityPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationActivityPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a password reset email
     * @param {ApiAuthenticationForgotPasswordPostRequest} apiAuthenticationForgotPasswordPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationForgotPasswordPost(apiAuthenticationForgotPasswordPostRequest: ApiAuthenticationForgotPasswordPostRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationForgotPasswordPost(apiAuthenticationForgotPasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with email and password
     * @param {ApiAuthenticationLoginPostRequest} apiAuthenticationLoginPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationLoginPost(apiAuthenticationLoginPostRequest: ApiAuthenticationLoginPostRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationLoginPost(apiAuthenticationLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationLogoutPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the current user\'s security methods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaFactorsGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaFactorsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove one of the current user\'s MFA factors
     * @param {ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum} type 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaFactorsTypeIdDelete(type: ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum, id: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaFactorsTypeIdDelete(type, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Begin authenticated security-method enrollment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaManagementStartPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaManagementStartPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Begin a passkey challenge for a password or Google login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaPasskeyChallengeOptionsPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaPasskeyChallengeOptionsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Begin mandatory passkey enrollment for a verified account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaPasskeyRegisterOptionsPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaPasskeyRegisterOptionsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify passkey enrollment and complete login
     * @param {ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest} apiAuthenticationMfaPasskeyRegisterVerifyPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaPasskeyRegisterVerifyPost(apiAuthenticationMfaPasskeyRegisterVerifyPostRequest: ApiAuthenticationMfaPasskeyRegisterVerifyPostRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaPasskeyRegisterVerifyPost(apiAuthenticationMfaPasskeyRegisterVerifyPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename one of the current user\'s passkeys
     * @param {string} id 
     * @param {ApiAuthenticationMfaPasskeysIdPatchRequest} apiAuthenticationMfaPasskeysIdPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaPasskeysIdPatch(id: string, apiAuthenticationMfaPasskeysIdPatchRequest: ApiAuthenticationMfaPasskeysIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaPasskeysIdPatch(id, apiAuthenticationMfaPasskeysIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete login with a one-time recovery code
     * @param {MfaCodeRequest} mfaCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaRecoveryCodeChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaRecoveryCodeChallengePost(mfaCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace all recovery codes for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaRecoveryCodesRegeneratePost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaRecoveryCodesRegeneratePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete login with an SMS code
     * @param {MfaCodeRequest} mfaCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaSmsChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaSmsChallengePost(mfaCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send an SMS login challenge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaSmsChallengeSendPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaSmsChallengeSendPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm SMS enrollment and complete login
     * @param {MfaCodeRequest} mfaCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaSmsConfirmPost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaSmsConfirmPost(mfaCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a code to begin SMS enrollment
     * @param {ApiAuthenticationMfaSmsSetupPostRequest} apiAuthenticationMfaSmsSetupPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaSmsSetupPost(apiAuthenticationMfaSmsSetupPostRequest: ApiAuthenticationMfaSmsSetupPostRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaSmsSetupPost(apiAuthenticationMfaSmsSetupPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read the current pre-authentication transaction state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaStatusGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete login with an authenticator-app code
     * @param {MfaCodeRequest} mfaCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaTotpChallengePost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaTotpChallengePost(mfaCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm authenticator-app enrollment and complete login
     * @param {MfaCodeRequest} mfaCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaTotpConfirmPost(mfaCodeRequest: MfaCodeRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaTotpConfirmPost(mfaCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Begin mandatory authenticator-app enrollment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationMfaTotpSetupPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationMfaTotpSetupPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get linked OAuth identities for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthIdentitiesGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationOauthIdentitiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlink an OAuth identity
     * @param {number} id ID of the OAuth identity to unlink
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationOauthIdentitiesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle OAuth callback
     * @param {string} provider OAuth provider ID
     * @param {string} code Authorization code from OAuth provider
     * @param {string} state State parameter for CSRF protection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthProviderCallbackGet(provider: string, code: string, state: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationOauthProviderCallbackGet(provider, code, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initiate OAuth flow
     * @param {string} provider OAuth provider ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthProviderGet(provider: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationOauthProviderGet(provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get available OAuth providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthProvidersGet(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationOauthProvidersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Begin identifier-free passkey authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationPasskeysOptionsPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationPasskeysOptionsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify a passkey assertion and complete login
     * @param {Record<string, any>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationPasskeysVerifyPost(body: Record<string, any>, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationPasskeysVerifyPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rotate the current browser session credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationRefreshPost(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate password reset token and redirect to reset page
     * @param {string} email Email address associated with the reset token
     * @param {string} token Password reset token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationResetPasswordGet(email: string, token: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationResetPasswordGet(email, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset password with token
     * @param {ApiAuthenticationResetPasswordPostRequest} apiAuthenticationResetPasswordPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationResetPasswordPost(apiAuthenticationResetPasswordPostRequest: ApiAuthenticationResetPasswordPostRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).apiAuthenticationResetPasswordPost(apiAuthenticationResetPasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum = {
    Passkey: 'passkey',
    Totp: 'totp',
    Sms: 'sms'
} as const;
export type ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum = typeof ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum[keyof typeof ApiAuthenticationMfaFactorsTypeIdDeleteTypeEnum];


/**
 * BillingApi - axios parameter creator
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Daily project costs by category from the billing ledger
         * @param {number} projectId 
         * @param {string} [range] One of 1d, 3d, 7d, 30d, 3m, 6m, 1y, 2y (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdCostsGet: async (projectId: number, range?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdCostsGet', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}/costs`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update auto-renew settings
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingAutoRenewPutRequest} apiTeamTeamIdBillingAutoRenewPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingAutoRenewPut: async (teamId: number, apiTeamTeamIdBillingAutoRenewPutRequest: ApiTeamTeamIdBillingAutoRenewPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingAutoRenewPut', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdBillingAutoRenewPutRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingAutoRenewPut', 'apiTeamTeamIdBillingAutoRenewPutRequest', apiTeamTeamIdBillingAutoRenewPutRequest)
            const localVarPath = `/api/team/{teamId}/billing/auto-renew`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingAutoRenewPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List budgets with current period spend
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingBudgetsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingBudgetsGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/budgets`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create, update, or delete (null amount) a budget
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingBudgetsPutRequest} apiTeamTeamIdBillingBudgetsPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingBudgetsPut: async (teamId: number, apiTeamTeamIdBillingBudgetsPutRequest: ApiTeamTeamIdBillingBudgetsPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingBudgetsPut', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdBillingBudgetsPutRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingBudgetsPut', 'apiTeamTeamIdBillingBudgetsPutRequest', apiTeamTeamIdBillingBudgetsPutRequest)
            const localVarPath = `/api/team/{teamId}/billing/budgets`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingBudgetsPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redeem a single-use credit code into the team\'s balance
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingCreditCodesRedeemPostRequest} apiTeamTeamIdBillingCreditCodesRedeemPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingCreditCodesRedeemPost: async (teamId: number, apiTeamTeamIdBillingCreditCodesRedeemPostRequest: ApiTeamTeamIdBillingCreditCodesRedeemPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingCreditCodesRedeemPost', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdBillingCreditCodesRedeemPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingCreditCodesRedeemPost', 'apiTeamTeamIdBillingCreditCodesRedeemPostRequest', apiTeamTeamIdBillingCreditCodesRedeemPostRequest)
            const localVarPath = `/api/team/{teamId}/billing/credit-codes/redeem`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingCreditCodesRedeemPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the team\'s billing summary
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List cost ledger entries (charges, reservations, adjustments)
         * @param {number} teamId ID of the team
         * @param {number} [projectId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingLedgerGet: async (teamId: number, projectId?: number, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingLedgerGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/ledger`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Administrator adjustment on a settled ledger entry
         * @param {number} teamId ID of the team
         * @param {number} ledgerId 
         * @param {ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest} apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingLedgerLedgerIdAdjustPost: async (teamId: number, ledgerId: number, apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest: ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingLedgerLedgerIdAdjustPost', 'teamId', teamId)
            // verify required parameter 'ledgerId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingLedgerLedgerIdAdjustPost', 'ledgerId', ledgerId)
            // verify required parameter 'apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingLedgerLedgerIdAdjustPost', 'apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest', apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest)
            const localVarPath = `/api/team/{teamId}/billing/ledger/{ledgerId}/adjust`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"ledgerId"}}`, encodeURIComponent(String(ledgerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List agents currently paused for lack of budget
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPausesGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPausesGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/pauses`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove the saved payment method (disables auto-renew)
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPaymentMethodDelete: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPaymentMethodDelete', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/payment-method`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attach the payment method from a confirmed setup intent
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingPaymentMethodPostRequest} apiTeamTeamIdBillingPaymentMethodPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPaymentMethodPost: async (teamId: number, apiTeamTeamIdBillingPaymentMethodPostRequest: ApiTeamTeamIdBillingPaymentMethodPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPaymentMethodPost', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdBillingPaymentMethodPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPaymentMethodPost', 'apiTeamTeamIdBillingPaymentMethodPostRequest', apiTeamTeamIdBillingPaymentMethodPostRequest)
            const localVarPath = `/api/team/{teamId}/billing/payment-method`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingPaymentMethodPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List funding history with usage burn-down
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPaymentsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPaymentsGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/payments`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the receipt PDF for completed card funding
         * @param {number} teamId ID of the team
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet: async (teamId: number, paymentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet', 'teamId', teamId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet', 'paymentId', paymentId)
            const localVarPath = `/api/team/{teamId}/billing/payments/{paymentId}/receipt`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm a prepayment and credit the balance (idempotent)
         * @param {number} teamId ID of the team
         * @param {number} paymentId 
         * @param {ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest} [apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest] Operation-backed payments require the caller-generated operationId. The body may be omitted only to drain a pre-migration manual payment, and that compatibility path is restricted to its authenticated creator and exact team/payment identity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPrepayPaymentIdConfirmPost: async (teamId: number, paymentId: number, apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest?: ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPrepayPaymentIdConfirmPost', 'teamId', teamId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPrepayPaymentIdConfirmPost', 'paymentId', paymentId)
            const localVarPath = `/api/team/{teamId}/billing/prepay/{paymentId}/confirm`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a one-off prepayment into the team\'s balance
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingPrepayPostRequest} apiTeamTeamIdBillingPrepayPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPrepayPost: async (teamId: number, apiTeamTeamIdBillingPrepayPostRequest: ApiTeamTeamIdBillingPrepayPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPrepayPost', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdBillingPrepayPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingPrepayPost', 'apiTeamTeamIdBillingPrepayPostRequest', apiTeamTeamIdBillingPrepayPostRequest)
            const localVarPath = `/api/team/{teamId}/billing/prepay`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingPrepayPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request an increase to the team\'s 30-day card charge limit (emails the request internally; does not change the limit itself)
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingRequestLimitIncreasePostRequest} apiTeamTeamIdBillingRequestLimitIncreasePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingRequestLimitIncreasePost: async (teamId: number, apiTeamTeamIdBillingRequestLimitIncreasePostRequest: ApiTeamTeamIdBillingRequestLimitIncreasePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingRequestLimitIncreasePost', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdBillingRequestLimitIncreasePostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingRequestLimitIncreasePost', 'apiTeamTeamIdBillingRequestLimitIncreasePostRequest', apiTeamTeamIdBillingRequestLimitIncreasePostRequest)
            const localVarPath = `/api/team/{teamId}/billing/request-limit-increase`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingRequestLimitIncreasePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start saving a payment method (setup intent)
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSetupIntentPost: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSetupIntentPost', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/setup-intent`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 */
export const BillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Daily project costs by category from the billing ledger
         * @param {number} projectId 
         * @param {string} [range] One of 1d, 3d, 7d, 30d, 3m, 6m, 1y, 2y (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdCostsGet(projectId: number, range?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiProjectsProjectIdCostsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdCostsGet(projectId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiProjectsProjectIdCostsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update auto-renew settings
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingAutoRenewPutRequest} apiTeamTeamIdBillingAutoRenewPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingAutoRenewPut(teamId: number, apiTeamTeamIdBillingAutoRenewPutRequest: ApiTeamTeamIdBillingAutoRenewPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingAutoRenewPut(teamId, apiTeamTeamIdBillingAutoRenewPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingAutoRenewPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List budgets with current period spend
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingBudgetsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingBudgetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingBudgetsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingBudgetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create, update, or delete (null amount) a budget
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingBudgetsPutRequest} apiTeamTeamIdBillingBudgetsPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingBudgetsPut(teamId: number, apiTeamTeamIdBillingBudgetsPutRequest: ApiTeamTeamIdBillingBudgetsPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingBudgetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingBudgetsPut(teamId, apiTeamTeamIdBillingBudgetsPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingBudgetsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Redeem a single-use credit code into the team\'s balance
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingCreditCodesRedeemPostRequest} apiTeamTeamIdBillingCreditCodesRedeemPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingCreditCodesRedeemPost(teamId: number, apiTeamTeamIdBillingCreditCodesRedeemPostRequest: ApiTeamTeamIdBillingCreditCodesRedeemPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditCodeRedemptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingCreditCodesRedeemPost(teamId, apiTeamTeamIdBillingCreditCodesRedeemPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingCreditCodesRedeemPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the team\'s billing summary
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List cost ledger entries (charges, reservations, adjustments)
         * @param {number} teamId ID of the team
         * @param {number} [projectId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingLedgerGet(teamId: number, projectId?: number, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingLedgerGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingLedgerGet(teamId, projectId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingLedgerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Administrator adjustment on a settled ledger entry
         * @param {number} teamId ID of the team
         * @param {number} ledgerId 
         * @param {ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest} apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingLedgerLedgerIdAdjustPost(teamId: number, ledgerId: number, apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest: ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingLedgerLedgerIdAdjustPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingLedgerLedgerIdAdjustPost(teamId, ledgerId, apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingLedgerLedgerIdAdjustPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List agents currently paused for lack of budget
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingPausesGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingPausesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingPausesGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingPausesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove the saved payment method (disables auto-renew)
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingPaymentMethodDelete(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingPaymentMethodDelete(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingPaymentMethodDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Attach the payment method from a confirmed setup intent
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingPaymentMethodPostRequest} apiTeamTeamIdBillingPaymentMethodPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingPaymentMethodPost(teamId: number, apiTeamTeamIdBillingPaymentMethodPostRequest: ApiTeamTeamIdBillingPaymentMethodPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingPaymentMethodPost(teamId, apiTeamTeamIdBillingPaymentMethodPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingPaymentMethodPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List funding history with usage burn-down
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingPaymentsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingPaymentsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingPaymentsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingPaymentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the receipt PDF for completed card funding
         * @param {number} teamId ID of the team
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet(teamId: number, paymentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet(teamId, paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm a prepayment and credit the balance (idempotent)
         * @param {number} teamId ID of the team
         * @param {number} paymentId 
         * @param {ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest} [apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest] Operation-backed payments require the caller-generated operationId. The body may be omitted only to drain a pre-migration manual payment, and that compatibility path is restricted to its authenticated creator and exact team/payment identity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingPrepayPaymentIdConfirmPost(teamId: number, paymentId: number, apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest?: ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingPrepayPaymentIdConfirmPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingPrepayPaymentIdConfirmPost(teamId, paymentId, apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingPrepayPaymentIdConfirmPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a one-off prepayment into the team\'s balance
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingPrepayPostRequest} apiTeamTeamIdBillingPrepayPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingPrepayPost(teamId: number, apiTeamTeamIdBillingPrepayPostRequest: ApiTeamTeamIdBillingPrepayPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingPrepayPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingPrepayPost(teamId, apiTeamTeamIdBillingPrepayPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingPrepayPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request an increase to the team\'s 30-day card charge limit (emails the request internally; does not change the limit itself)
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingRequestLimitIncreasePostRequest} apiTeamTeamIdBillingRequestLimitIncreasePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingRequestLimitIncreasePost(teamId: number, apiTeamTeamIdBillingRequestLimitIncreasePostRequest: ApiTeamTeamIdBillingRequestLimitIncreasePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingRequestLimitIncreasePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingRequestLimitIncreasePost(teamId, apiTeamTeamIdBillingRequestLimitIncreasePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingRequestLimitIncreasePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start saving a payment method (setup intent)
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingSetupIntentPost(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingSetupIntentPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingSetupIntentPost(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.apiTeamTeamIdBillingSetupIntentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingApi - factory interface
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingApiFp(configuration)
    return {
        /**
         * 
         * @summary Daily project costs by category from the billing ledger
         * @param {number} projectId 
         * @param {string} [range] One of 1d, 3d, 7d, 30d, 3m, 6m, 1y, 2y (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdCostsGet(projectId: number, range?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiProjectsProjectIdCostsGet200Response> {
            return localVarFp.apiProjectsProjectIdCostsGet(projectId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update auto-renew settings
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingAutoRenewPutRequest} apiTeamTeamIdBillingAutoRenewPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingAutoRenewPut(teamId: number, apiTeamTeamIdBillingAutoRenewPutRequest: ApiTeamTeamIdBillingAutoRenewPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillingSummary> {
            return localVarFp.apiTeamTeamIdBillingAutoRenewPut(teamId, apiTeamTeamIdBillingAutoRenewPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List budgets with current period spend
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingBudgetsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<BillingBudgetsResponse> {
            return localVarFp.apiTeamTeamIdBillingBudgetsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create, update, or delete (null amount) a budget
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingBudgetsPutRequest} apiTeamTeamIdBillingBudgetsPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingBudgetsPut(teamId: number, apiTeamTeamIdBillingBudgetsPutRequest: ApiTeamTeamIdBillingBudgetsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillingBudgetsResponse> {
            return localVarFp.apiTeamTeamIdBillingBudgetsPut(teamId, apiTeamTeamIdBillingBudgetsPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redeem a single-use credit code into the team\'s balance
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingCreditCodesRedeemPostRequest} apiTeamTeamIdBillingCreditCodesRedeemPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingCreditCodesRedeemPost(teamId: number, apiTeamTeamIdBillingCreditCodesRedeemPostRequest: ApiTeamTeamIdBillingCreditCodesRedeemPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreditCodeRedemptionResponse> {
            return localVarFp.apiTeamTeamIdBillingCreditCodesRedeemPost(teamId, apiTeamTeamIdBillingCreditCodesRedeemPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the team\'s billing summary
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<BillingSummary> {
            return localVarFp.apiTeamTeamIdBillingGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List cost ledger entries (charges, reservations, adjustments)
         * @param {number} teamId ID of the team
         * @param {number} [projectId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingLedgerGet(teamId: number, projectId?: number, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingLedgerGet200Response> {
            return localVarFp.apiTeamTeamIdBillingLedgerGet(teamId, projectId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Administrator adjustment on a settled ledger entry
         * @param {number} teamId ID of the team
         * @param {number} ledgerId 
         * @param {ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest} apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingLedgerLedgerIdAdjustPost(teamId: number, ledgerId: number, apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest: ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingLedgerLedgerIdAdjustPost200Response> {
            return localVarFp.apiTeamTeamIdBillingLedgerLedgerIdAdjustPost(teamId, ledgerId, apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List agents currently paused for lack of budget
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPausesGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingPausesGet200Response> {
            return localVarFp.apiTeamTeamIdBillingPausesGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove the saved payment method (disables auto-renew)
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPaymentMethodDelete(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<BillingSummary> {
            return localVarFp.apiTeamTeamIdBillingPaymentMethodDelete(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attach the payment method from a confirmed setup intent
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingPaymentMethodPostRequest} apiTeamTeamIdBillingPaymentMethodPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPaymentMethodPost(teamId: number, apiTeamTeamIdBillingPaymentMethodPostRequest: ApiTeamTeamIdBillingPaymentMethodPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillingSummary> {
            return localVarFp.apiTeamTeamIdBillingPaymentMethodPost(teamId, apiTeamTeamIdBillingPaymentMethodPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List funding history with usage burn-down
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPaymentsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingPaymentsGet200Response> {
            return localVarFp.apiTeamTeamIdBillingPaymentsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the receipt PDF for completed card funding
         * @param {number} teamId ID of the team
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet(teamId: number, paymentId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet(teamId, paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm a prepayment and credit the balance (idempotent)
         * @param {number} teamId ID of the team
         * @param {number} paymentId 
         * @param {ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest} [apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest] Operation-backed payments require the caller-generated operationId. The body may be omitted only to drain a pre-migration manual payment, and that compatibility path is restricted to its authenticated creator and exact team/payment identity.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPrepayPaymentIdConfirmPost(teamId: number, paymentId: number, apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest?: ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingPrepayPaymentIdConfirmPost200Response> {
            return localVarFp.apiTeamTeamIdBillingPrepayPaymentIdConfirmPost(teamId, paymentId, apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a one-off prepayment into the team\'s balance
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingPrepayPostRequest} apiTeamTeamIdBillingPrepayPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingPrepayPost(teamId: number, apiTeamTeamIdBillingPrepayPostRequest: ApiTeamTeamIdBillingPrepayPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingPrepayPost200Response> {
            return localVarFp.apiTeamTeamIdBillingPrepayPost(teamId, apiTeamTeamIdBillingPrepayPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request an increase to the team\'s 30-day card charge limit (emails the request internally; does not change the limit itself)
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdBillingRequestLimitIncreasePostRequest} apiTeamTeamIdBillingRequestLimitIncreasePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingRequestLimitIncreasePost(teamId: number, apiTeamTeamIdBillingRequestLimitIncreasePostRequest: ApiTeamTeamIdBillingRequestLimitIncreasePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingRequestLimitIncreasePost200Response> {
            return localVarFp.apiTeamTeamIdBillingRequestLimitIncreasePost(teamId, apiTeamTeamIdBillingRequestLimitIncreasePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start saving a payment method (setup intent)
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSetupIntentPost(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingSetupIntentPost200Response> {
            return localVarFp.apiTeamTeamIdBillingSetupIntentPost(teamId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillingApi - object-oriented interface
 */
export class BillingApi extends BaseAPI {
    /**
     * 
     * @summary Daily project costs by category from the billing ledger
     * @param {number} projectId 
     * @param {string} [range] One of 1d, 3d, 7d, 30d, 3m, 6m, 1y, 2y (default 30d)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdCostsGet(projectId: number, range?: string, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiProjectsProjectIdCostsGet(projectId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update auto-renew settings
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdBillingAutoRenewPutRequest} apiTeamTeamIdBillingAutoRenewPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingAutoRenewPut(teamId: number, apiTeamTeamIdBillingAutoRenewPutRequest: ApiTeamTeamIdBillingAutoRenewPutRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingAutoRenewPut(teamId, apiTeamTeamIdBillingAutoRenewPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List budgets with current period spend
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingBudgetsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingBudgetsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create, update, or delete (null amount) a budget
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdBillingBudgetsPutRequest} apiTeamTeamIdBillingBudgetsPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingBudgetsPut(teamId: number, apiTeamTeamIdBillingBudgetsPutRequest: ApiTeamTeamIdBillingBudgetsPutRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingBudgetsPut(teamId, apiTeamTeamIdBillingBudgetsPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redeem a single-use credit code into the team\'s balance
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdBillingCreditCodesRedeemPostRequest} apiTeamTeamIdBillingCreditCodesRedeemPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingCreditCodesRedeemPost(teamId: number, apiTeamTeamIdBillingCreditCodesRedeemPostRequest: ApiTeamTeamIdBillingCreditCodesRedeemPostRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingCreditCodesRedeemPost(teamId, apiTeamTeamIdBillingCreditCodesRedeemPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the team\'s billing summary
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingGet(teamId: number, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List cost ledger entries (charges, reservations, adjustments)
     * @param {number} teamId ID of the team
     * @param {number} [projectId] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingLedgerGet(teamId: number, projectId?: number, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingLedgerGet(teamId, projectId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Administrator adjustment on a settled ledger entry
     * @param {number} teamId ID of the team
     * @param {number} ledgerId 
     * @param {ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest} apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingLedgerLedgerIdAdjustPost(teamId: number, ledgerId: number, apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest: ApiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingLedgerLedgerIdAdjustPost(teamId, ledgerId, apiTeamTeamIdBillingLedgerLedgerIdAdjustPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List agents currently paused for lack of budget
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingPausesGet(teamId: number, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingPausesGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove the saved payment method (disables auto-renew)
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingPaymentMethodDelete(teamId: number, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingPaymentMethodDelete(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attach the payment method from a confirmed setup intent
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdBillingPaymentMethodPostRequest} apiTeamTeamIdBillingPaymentMethodPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingPaymentMethodPost(teamId: number, apiTeamTeamIdBillingPaymentMethodPostRequest: ApiTeamTeamIdBillingPaymentMethodPostRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingPaymentMethodPost(teamId, apiTeamTeamIdBillingPaymentMethodPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List funding history with usage burn-down
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingPaymentsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingPaymentsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the receipt PDF for completed card funding
     * @param {number} teamId ID of the team
     * @param {number} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet(teamId: number, paymentId: number, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingPaymentsPaymentIdReceiptGet(teamId, paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm a prepayment and credit the balance (idempotent)
     * @param {number} teamId ID of the team
     * @param {number} paymentId 
     * @param {ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest} [apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest] Operation-backed payments require the caller-generated operationId. The body may be omitted only to drain a pre-migration manual payment, and that compatibility path is restricted to its authenticated creator and exact team/payment identity.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingPrepayPaymentIdConfirmPost(teamId: number, paymentId: number, apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest?: ApiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingPrepayPaymentIdConfirmPost(teamId, paymentId, apiTeamTeamIdBillingPrepayPaymentIdConfirmPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a one-off prepayment into the team\'s balance
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdBillingPrepayPostRequest} apiTeamTeamIdBillingPrepayPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingPrepayPost(teamId: number, apiTeamTeamIdBillingPrepayPostRequest: ApiTeamTeamIdBillingPrepayPostRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingPrepayPost(teamId, apiTeamTeamIdBillingPrepayPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request an increase to the team\'s 30-day card charge limit (emails the request internally; does not change the limit itself)
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdBillingRequestLimitIncreasePostRequest} apiTeamTeamIdBillingRequestLimitIncreasePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingRequestLimitIncreasePost(teamId: number, apiTeamTeamIdBillingRequestLimitIncreasePostRequest: ApiTeamTeamIdBillingRequestLimitIncreasePostRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingRequestLimitIncreasePost(teamId, apiTeamTeamIdBillingRequestLimitIncreasePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start saving a payment method (setup intent)
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingSetupIntentPost(teamId: number, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).apiTeamTeamIdBillingSetupIntentPost(teamId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CardNextActionsApi - axios parameter creator
 */
export const CardNextActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Requires card management on the owning project. Agent creators and targets cancel their own items through their tools instead. 
         * @summary Cancel a pending next action
         * @param {number} cardId 
         * @param {number} actionId 
         * @param {CancelCardNextActionRequest} [cancelCardNextActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCardNextAction: async (cardId: number, actionId: number, cancelCardNextActionRequest?: CancelCardNextActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('cancelCardNextAction', 'cardId', cardId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('cancelCardNextAction', 'actionId', actionId)
            const localVarPath = `/api/project-cards/{cardId}/next-actions/{actionId}/cancel`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)))
                .replace(`{${"actionId"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelCardNextActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pending, firing, needs-attention, and recently expired follow-up commitments on a card, with human-readable trigger phrasing. 
         * @summary List a card\'s next actions
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardNextActions: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('listCardNextActions', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/next-actions`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardNextActionsApi - functional programming interface
 */
export const CardNextActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardNextActionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Requires card management on the owning project. Agent creators and targets cancel their own items through their tools instead. 
         * @summary Cancel a pending next action
         * @param {number} cardId 
         * @param {number} actionId 
         * @param {CancelCardNextActionRequest} [cancelCardNextActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCardNextAction(cardId: number, actionId: number, cancelCardNextActionRequest?: CancelCardNextActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelCardNextAction200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCardNextAction(cardId, actionId, cancelCardNextActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardNextActionsApi.cancelCardNextAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pending, firing, needs-attention, and recently expired follow-up commitments on a card, with human-readable trigger phrasing. 
         * @summary List a card\'s next actions
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCardNextActions(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCardNextActions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCardNextActions(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardNextActionsApi.listCardNextActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CardNextActionsApi - factory interface
 */
export const CardNextActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardNextActionsApiFp(configuration)
    return {
        /**
         * Requires card management on the owning project. Agent creators and targets cancel their own items through their tools instead. 
         * @summary Cancel a pending next action
         * @param {number} cardId 
         * @param {number} actionId 
         * @param {CancelCardNextActionRequest} [cancelCardNextActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCardNextAction(cardId: number, actionId: number, cancelCardNextActionRequest?: CancelCardNextActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CancelCardNextAction200Response> {
            return localVarFp.cancelCardNextAction(cardId, actionId, cancelCardNextActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Pending, firing, needs-attention, and recently expired follow-up commitments on a card, with human-readable trigger phrasing. 
         * @summary List a card\'s next actions
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardNextActions(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<ListCardNextActions200Response> {
            return localVarFp.listCardNextActions(cardId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CardNextActionsApi - object-oriented interface
 */
export class CardNextActionsApi extends BaseAPI {
    /**
     * Requires card management on the owning project. Agent creators and targets cancel their own items through their tools instead. 
     * @summary Cancel a pending next action
     * @param {number} cardId 
     * @param {number} actionId 
     * @param {CancelCardNextActionRequest} [cancelCardNextActionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelCardNextAction(cardId: number, actionId: number, cancelCardNextActionRequest?: CancelCardNextActionRequest, options?: RawAxiosRequestConfig) {
        return CardNextActionsApiFp(this.configuration).cancelCardNextAction(cardId, actionId, cancelCardNextActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pending, firing, needs-attention, and recently expired follow-up commitments on a card, with human-readable trigger phrasing. 
     * @summary List a card\'s next actions
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCardNextActions(cardId: number, options?: RawAxiosRequestConfig) {
        return CardNextActionsApiFp(this.configuration).listCardNextActions(cardId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CardWatchesApi - axios parameter creator
 */
export const CardWatchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Every active user and agent watch on the card, plus whether the calling user is currently watching it. 
         * @summary List a card\'s watchers
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardWatchers: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('listCardWatchers', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/watchers`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires card management on the owning project — removing an agent\'s watch changes what the agent does. 
         * @summary Stop an agent\'s watch on a card
         * @param {number} cardId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCardAgentWatch: async (cardId: number, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('removeCardAgentWatch', 'cardId', cardId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('removeCardAgentWatch', 'agentId', agentId)
            const localVarPath = `/api/project-cards/{cardId}/watchers/agents/{agentId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes only the calling user\'s own watch on the card. 
         * @summary Unwatch a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwatchCard: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('unwatchCard', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/watch`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Subscribes the calling user to the card. Idempotent — watching an already-watched card succeeds and creates no second watch. 
         * @summary Watch a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchCard: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('watchCard', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/watch`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardWatchesApi - functional programming interface
 */
export const CardWatchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardWatchesApiAxiosParamCreator(configuration)
    return {
        /**
         * Every active user and agent watch on the card, plus whether the calling user is currently watching it. 
         * @summary List a card\'s watchers
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCardWatchers(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardWatchersView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCardWatchers(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardWatchesApi.listCardWatchers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires card management on the owning project — removing an agent\'s watch changes what the agent does. 
         * @summary Stop an agent\'s watch on a card
         * @param {number} cardId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCardAgentWatch(cardId: number, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCardAgentWatch(cardId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardWatchesApi.removeCardAgentWatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes only the calling user\'s own watch on the card. 
         * @summary Unwatch a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwatchCard(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwatchCard(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardWatchesApi.unwatchCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Subscribes the calling user to the card. Idempotent — watching an already-watched card succeeds and creates no second watch. 
         * @summary Watch a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchCard(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchCard(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardWatchesApi.watchCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CardWatchesApi - factory interface
 */
export const CardWatchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardWatchesApiFp(configuration)
    return {
        /**
         * Every active user and agent watch on the card, plus whether the calling user is currently watching it. 
         * @summary List a card\'s watchers
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardWatchers(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<CardWatchersView> {
            return localVarFp.listCardWatchers(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires card management on the owning project — removing an agent\'s watch changes what the agent does. 
         * @summary Stop an agent\'s watch on a card
         * @param {number} cardId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCardAgentWatch(cardId: number, agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCardAgentWatch(cardId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes only the calling user\'s own watch on the card. 
         * @summary Unwatch a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwatchCard(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unwatchCard(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Subscribes the calling user to the card. Idempotent — watching an already-watched card succeeds and creates no second watch. 
         * @summary Watch a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchCard(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.watchCard(cardId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CardWatchesApi - object-oriented interface
 */
export class CardWatchesApi extends BaseAPI {
    /**
     * Every active user and agent watch on the card, plus whether the calling user is currently watching it. 
     * @summary List a card\'s watchers
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCardWatchers(cardId: number, options?: RawAxiosRequestConfig) {
        return CardWatchesApiFp(this.configuration).listCardWatchers(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires card management on the owning project — removing an agent\'s watch changes what the agent does. 
     * @summary Stop an agent\'s watch on a card
     * @param {number} cardId 
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeCardAgentWatch(cardId: number, agentId: number, options?: RawAxiosRequestConfig) {
        return CardWatchesApiFp(this.configuration).removeCardAgentWatch(cardId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes only the calling user\'s own watch on the card. 
     * @summary Unwatch a card
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwatchCard(cardId: number, options?: RawAxiosRequestConfig) {
        return CardWatchesApiFp(this.configuration).unwatchCard(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Subscribes the calling user to the card. Idempotent — watching an already-watched card succeeds and creates no second watch. 
     * @summary Watch a card
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public watchCard(cardId: number, options?: RawAxiosRequestConfig) {
        return CardWatchesApiFp(this.configuration).watchCard(cardId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChannelsApi - axios parameter creator
 */
export const ChannelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set an agent binding\'s Slack bot credentials (write-only; validated with auth.test)
         * @param {number} channelId 
         * @param {number} agentId 
         * @param {UpdateAgentSlackConfigRequest} updateAgentSlackConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdAgentsAgentIdSlackConfigPut: async (channelId: number, agentId: number, updateAgentSlackConfigRequest: UpdateAgentSlackConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('apiChannelsChannelIdAgentsAgentIdSlackConfigPut', 'channelId', channelId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiChannelsChannelIdAgentsAgentIdSlackConfigPut', 'agentId', agentId)
            // verify required parameter 'updateAgentSlackConfigRequest' is not null or undefined
            assertParamExists('apiChannelsChannelIdAgentsAgentIdSlackConfigPut', 'updateAgentSlackConfigRequest', updateAgentSlackConfigRequest)
            const localVarPath = `/api/channels/{channelId}/agents/{agentId}/slack-config`
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgentSlackConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace the channel\'s agent assignments (SMS channels take exactly one agent)
         * @param {number} channelId 
         * @param {UpdateChannelAgentsRequest} updateChannelAgentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdAgentsPut: async (channelId: number, updateChannelAgentsRequest: UpdateChannelAgentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('apiChannelsChannelIdAgentsPut', 'channelId', channelId)
            // verify required parameter 'updateChannelAgentsRequest' is not null or undefined
            assertParamExists('apiChannelsChannelIdAgentsPut', 'updateChannelAgentsRequest', updateChannelAgentsRequest)
            const localVarPath = `/api/channels/{channelId}/agents`
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChannelAgentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a channel
         * @param {number} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdDelete: async (channelId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('apiChannelsChannelIdDelete', 'channelId', channelId)
            const localVarPath = `/api/channels/{channelId}`
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a channel
         * @param {number} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdGet: async (channelId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('apiChannelsChannelIdGet', 'channelId', channelId)
            const localVarPath = `/api/channels/{channelId}`
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a channel (credentials are write-only; empty string clears a key)
         * @param {number} channelId 
         * @param {UpdateChannelRequest} updateChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdPut: async (channelId: number, updateChannelRequest: UpdateChannelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('apiChannelsChannelIdPut', 'channelId', channelId)
            // verify required parameter 'updateChannelRequest' is not null or undefined
            assertParamExists('apiChannelsChannelIdPut', 'updateChannelRequest', updateChannelRequest)
            const localVarPath = `/api/channels/{channelId}`
                .replace(`{${"channelId"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChannelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a team\'s channels, including synthesized read-only EMAIL entries
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChannelsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdChannelsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/channels`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a channel
         * @param {number} teamId 
         * @param {CreateChannelRequest} createChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChannelsPost: async (teamId: number, createChannelRequest: CreateChannelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdChannelsPost', 'teamId', teamId)
            // verify required parameter 'createChannelRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdChannelsPost', 'createChannelRequest', createChannelRequest)
            const localVarPath = `/api/teams/{teamId}/channels`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChannelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChannelsApi - functional programming interface
 */
export const ChannelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChannelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Set an agent binding\'s Slack bot credentials (write-only; validated with auth.test)
         * @param {number} channelId 
         * @param {number} agentId 
         * @param {UpdateAgentSlackConfigRequest} updateAgentSlackConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiChannelsChannelIdAgentsAgentIdSlackConfigPut(channelId: number, agentId: number, updateAgentSlackConfigRequest: UpdateAgentSlackConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiChannelsChannelIdAgentsAgentIdSlackConfigPut(channelId, agentId, updateAgentSlackConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannelsApi.apiChannelsChannelIdAgentsAgentIdSlackConfigPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace the channel\'s agent assignments (SMS channels take exactly one agent)
         * @param {number} channelId 
         * @param {UpdateChannelAgentsRequest} updateChannelAgentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiChannelsChannelIdAgentsPut(channelId: number, updateChannelAgentsRequest: UpdateChannelAgentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiChannelsChannelIdAgentsPut(channelId, updateChannelAgentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannelsApi.apiChannelsChannelIdAgentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a channel
         * @param {number} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiChannelsChannelIdDelete(channelId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiChannelsChannelIdDelete(channelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannelsApi.apiChannelsChannelIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a channel
         * @param {number} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiChannelsChannelIdGet(channelId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiChannelsChannelIdGet(channelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannelsApi.apiChannelsChannelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a channel (credentials are write-only; empty string clears a key)
         * @param {number} channelId 
         * @param {UpdateChannelRequest} updateChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiChannelsChannelIdPut(channelId: number, updateChannelRequest: UpdateChannelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiChannelsChannelIdPut(channelId, updateChannelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannelsApi.apiChannelsChannelIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a team\'s channels, including synthesized read-only EMAIL entries
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdChannelsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdChannelsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannelsApi.apiTeamsTeamIdChannelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a channel
         * @param {number} teamId 
         * @param {CreateChannelRequest} createChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdChannelsPost(teamId: number, createChannelRequest: CreateChannelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdChannelsPost(teamId, createChannelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannelsApi.apiTeamsTeamIdChannelsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChannelsApi - factory interface
 */
export const ChannelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChannelsApiFp(configuration)
    return {
        /**
         * 
         * @summary Set an agent binding\'s Slack bot credentials (write-only; validated with auth.test)
         * @param {number} channelId 
         * @param {number} agentId 
         * @param {UpdateAgentSlackConfigRequest} updateAgentSlackConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdAgentsAgentIdSlackConfigPut(channelId: number, agentId: number, updateAgentSlackConfigRequest: UpdateAgentSlackConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChannelResponse> {
            return localVarFp.apiChannelsChannelIdAgentsAgentIdSlackConfigPut(channelId, agentId, updateAgentSlackConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace the channel\'s agent assignments (SMS channels take exactly one agent)
         * @param {number} channelId 
         * @param {UpdateChannelAgentsRequest} updateChannelAgentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdAgentsPut(channelId: number, updateChannelAgentsRequest: UpdateChannelAgentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChannelResponse> {
            return localVarFp.apiChannelsChannelIdAgentsPut(channelId, updateChannelAgentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a channel
         * @param {number} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdDelete(channelId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiChannelsChannelIdDelete(channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a channel
         * @param {number} channelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdGet(channelId: number, options?: RawAxiosRequestConfig): AxiosPromise<ChannelResponse> {
            return localVarFp.apiChannelsChannelIdGet(channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a channel (credentials are write-only; empty string clears a key)
         * @param {number} channelId 
         * @param {UpdateChannelRequest} updateChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiChannelsChannelIdPut(channelId: number, updateChannelRequest: UpdateChannelRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChannelResponse> {
            return localVarFp.apiChannelsChannelIdPut(channelId, updateChannelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a team\'s channels, including synthesized read-only EMAIL entries
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChannelsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ChannelListResponse> {
            return localVarFp.apiTeamsTeamIdChannelsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a channel
         * @param {number} teamId 
         * @param {CreateChannelRequest} createChannelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChannelsPost(teamId: number, createChannelRequest: CreateChannelRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChannelResponse> {
            return localVarFp.apiTeamsTeamIdChannelsPost(teamId, createChannelRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChannelsApi - object-oriented interface
 */
export class ChannelsApi extends BaseAPI {
    /**
     * 
     * @summary Set an agent binding\'s Slack bot credentials (write-only; validated with auth.test)
     * @param {number} channelId 
     * @param {number} agentId 
     * @param {UpdateAgentSlackConfigRequest} updateAgentSlackConfigRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiChannelsChannelIdAgentsAgentIdSlackConfigPut(channelId: number, agentId: number, updateAgentSlackConfigRequest: UpdateAgentSlackConfigRequest, options?: RawAxiosRequestConfig) {
        return ChannelsApiFp(this.configuration).apiChannelsChannelIdAgentsAgentIdSlackConfigPut(channelId, agentId, updateAgentSlackConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace the channel\'s agent assignments (SMS channels take exactly one agent)
     * @param {number} channelId 
     * @param {UpdateChannelAgentsRequest} updateChannelAgentsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiChannelsChannelIdAgentsPut(channelId: number, updateChannelAgentsRequest: UpdateChannelAgentsRequest, options?: RawAxiosRequestConfig) {
        return ChannelsApiFp(this.configuration).apiChannelsChannelIdAgentsPut(channelId, updateChannelAgentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a channel
     * @param {number} channelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiChannelsChannelIdDelete(channelId: number, options?: RawAxiosRequestConfig) {
        return ChannelsApiFp(this.configuration).apiChannelsChannelIdDelete(channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a channel
     * @param {number} channelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiChannelsChannelIdGet(channelId: number, options?: RawAxiosRequestConfig) {
        return ChannelsApiFp(this.configuration).apiChannelsChannelIdGet(channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a channel (credentials are write-only; empty string clears a key)
     * @param {number} channelId 
     * @param {UpdateChannelRequest} updateChannelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiChannelsChannelIdPut(channelId: number, updateChannelRequest: UpdateChannelRequest, options?: RawAxiosRequestConfig) {
        return ChannelsApiFp(this.configuration).apiChannelsChannelIdPut(channelId, updateChannelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a team\'s channels, including synthesized read-only EMAIL entries
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdChannelsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return ChannelsApiFp(this.configuration).apiTeamsTeamIdChannelsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a channel
     * @param {number} teamId 
     * @param {CreateChannelRequest} createChannelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdChannelsPost(teamId: number, createChannelRequest: CreateChannelRequest, options?: RawAxiosRequestConfig) {
        return ChannelsApiFp(this.configuration).apiTeamsTeamIdChannelsPost(teamId, createChannelRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChatApi - axios parameter creator
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Promotes the form_assist conversation to an ordinary team chat, posts a system notice naming what was created, and wakes the agent so it can continue anything it offered to do. A no-op when the conversation was already promoted.
         * @summary Hand a submitted form-assist conversation over to the team chat
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {FormAssistHandoffRequest} formAssistHandoffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost: async (teamId: number, conversationId: number, formAssistHandoffRequest: FormAssistHandoffRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost', 'teamId', teamId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost', 'conversationId', conversationId)
            // verify required parameter 'formAssistHandoffRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost', 'formAssistHandoffRequest', formAssistHandoffRequest)
            const localVarPath = `/api/teams/{teamId}/chat-conversations/{conversationId}/form-assist-handoff`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formAssistHandoffRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the requesting user\'s chat conversations within a team, newest first
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChatConversationsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdChatConversationsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/chat-conversations`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Folds each responding agent\'s older history into a persisted summary immediately, regardless of context pressure — the same fold that runs automatically near the context-window threshold. Backs the /compact composer command. Synchronous: one summarize model call per responding agent. Never exposed to agents as a tool.
         * @summary Force conversation compaction now
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceCompactChatConversation: async (teamId: number, conversationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('forceCompactChatConversation', 'teamId', teamId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('forceCompactChatConversation', 'conversationId', conversationId)
            const localVarPath = `/api/teams/{teamId}/chat-conversations/{conversationId}/compact`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * Promotes the form_assist conversation to an ordinary team chat, posts a system notice naming what was created, and wakes the agent so it can continue anything it offered to do. A no-op when the conversation was already promoted.
         * @summary Hand a submitted form-assist conversation over to the team chat
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {FormAssistHandoffRequest} formAssistHandoffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost(teamId: number, conversationId: number, formAssistHandoffRequest: FormAssistHandoffRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormAssistHandoffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost(teamId, conversationId, formAssistHandoffRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the requesting user\'s chat conversations within a team, newest first
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdChatConversationsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatConversationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdChatConversationsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.apiTeamsTeamIdChatConversationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Folds each responding agent\'s older history into a persisted summary immediately, regardless of context pressure — the same fold that runs automatically near the context-window threshold. Backs the /compact composer command. Synchronous: one summarize model call per responding agent. Never exposed to agents as a tool.
         * @summary Force conversation compaction now
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forceCompactChatConversation(teamId: number, conversationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForceCompactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forceCompactChatConversation(teamId, conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.forceCompactChatConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * Promotes the form_assist conversation to an ordinary team chat, posts a system notice naming what was created, and wakes the agent so it can continue anything it offered to do. A no-op when the conversation was already promoted.
         * @summary Hand a submitted form-assist conversation over to the team chat
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {FormAssistHandoffRequest} formAssistHandoffRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost(teamId: number, conversationId: number, formAssistHandoffRequest: FormAssistHandoffRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormAssistHandoffResponse> {
            return localVarFp.apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost(teamId, conversationId, formAssistHandoffRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the requesting user\'s chat conversations within a team, newest first
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChatConversationsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ChatConversationListResponse> {
            return localVarFp.apiTeamsTeamIdChatConversationsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Folds each responding agent\'s older history into a persisted summary immediately, regardless of context pressure — the same fold that runs automatically near the context-window threshold. Backs the /compact composer command. Synchronous: one summarize model call per responding agent. Never exposed to agents as a tool.
         * @summary Force conversation compaction now
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceCompactChatConversation(teamId: number, conversationId: number, options?: RawAxiosRequestConfig): AxiosPromise<ForceCompactResponse> {
            return localVarFp.forceCompactChatConversation(teamId, conversationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 */
export class ChatApi extends BaseAPI {
    /**
     * Promotes the form_assist conversation to an ordinary team chat, posts a system notice naming what was created, and wakes the agent so it can continue anything it offered to do. A no-op when the conversation was already promoted.
     * @summary Hand a submitted form-assist conversation over to the team chat
     * @param {number} teamId 
     * @param {number} conversationId 
     * @param {FormAssistHandoffRequest} formAssistHandoffRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost(teamId: number, conversationId: number, formAssistHandoffRequest: FormAssistHandoffRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).apiTeamsTeamIdChatConversationsConversationIdFormAssistHandoffPost(teamId, conversationId, formAssistHandoffRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the requesting user\'s chat conversations within a team, newest first
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdChatConversationsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).apiTeamsTeamIdChatConversationsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Folds each responding agent\'s older history into a persisted summary immediately, regardless of context pressure — the same fold that runs automatically near the context-window threshold. Backs the /compact composer command. Synchronous: one summarize model call per responding agent. Never exposed to agents as a tool.
     * @summary Force conversation compaction now
     * @param {number} teamId 
     * @param {number} conversationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forceCompactChatConversation(teamId: number, conversationId: number, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).forceCompactChatConversation(teamId, conversationId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConversationsApi - axios parameter creator
 */
export const ConversationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List conversations for an agent
         * @param {number} agentId ID of the agent
         * @param {number} [limit] Maximum number of conversations to return
         * @param {number} [offset] Number of conversations to skip
         * @param {string} [searchText] Search text to filter conversations by subject or participant emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsGet: async (agentId: number, limit?: number, offset?: number, searchText?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiConversationsGet', 'agentId', agentId)
            const localVarPath = `/api/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a conversation
         * @param {number} id ID of the conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiConversationsIdDelete', 'id', id)
            const localVarPath = `/api/conversations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a conversation
         * @param {number} id ID of the conversation
         * @param {UpdateConversationRequest} updateConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsIdPut: async (id: number, updateConversationRequest: UpdateConversationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiConversationsIdPut', 'id', id)
            // verify required parameter 'updateConversationRequest' is not null or undefined
            assertParamExists('apiConversationsIdPut', 'updateConversationRequest', updateConversationRequest)
            const localVarPath = `/api/conversations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateConversationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new conversation
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsPost: async (createConversationRequest: CreateConversationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConversationRequest' is not null or undefined
            assertParamExists('apiConversationsPost', 'createConversationRequest', createConversationRequest)
            const localVarPath = `/api/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConversationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationsApi - functional programming interface
 */
export const ConversationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List conversations for an agent
         * @param {number} agentId ID of the agent
         * @param {number} [limit] Maximum number of conversations to return
         * @param {number} [offset] Number of conversations to skip
         * @param {string} [searchText] Search text to filter conversations by subject or participant emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConversationsGet(agentId: number, limit?: number, offset?: number, searchText?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConversationsGet(agentId, limit, offset, searchText, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.apiConversationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a conversation
         * @param {number} id ID of the conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConversationsIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiConversationsIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConversationsIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.apiConversationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a conversation
         * @param {number} id ID of the conversation
         * @param {UpdateConversationRequest} updateConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConversationsIdPut(id: number, updateConversationRequest: UpdateConversationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConversationsIdPut(id, updateConversationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.apiConversationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new conversation
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConversationsPost(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConversationsPost(createConversationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationsApi.apiConversationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversationsApi - factory interface
 */
export const ConversationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationsApiFp(configuration)
    return {
        /**
         * 
         * @summary List conversations for an agent
         * @param {number} agentId ID of the agent
         * @param {number} [limit] Maximum number of conversations to return
         * @param {number} [offset] Number of conversations to skip
         * @param {string} [searchText] Search text to filter conversations by subject or participant emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsGet(agentId: number, limit?: number, offset?: number, searchText?: string, options?: RawAxiosRequestConfig): AxiosPromise<ConversationListResponse> {
            return localVarFp.apiConversationsGet(agentId, limit, offset, searchText, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a conversation
         * @param {number} id ID of the conversation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiConversationsIdDelete200Response> {
            return localVarFp.apiConversationsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a conversation
         * @param {number} id ID of the conversation
         * @param {UpdateConversationRequest} updateConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsIdPut(id: number, updateConversationRequest: UpdateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationResponse> {
            return localVarFp.apiConversationsIdPut(id, updateConversationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new conversation
         * @param {CreateConversationRequest} createConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsPost(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationResponse> {
            return localVarFp.apiConversationsPost(createConversationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConversationsApi - object-oriented interface
 */
export class ConversationsApi extends BaseAPI {
    /**
     * 
     * @summary List conversations for an agent
     * @param {number} agentId ID of the agent
     * @param {number} [limit] Maximum number of conversations to return
     * @param {number} [offset] Number of conversations to skip
     * @param {string} [searchText] Search text to filter conversations by subject or participant emails
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConversationsGet(agentId: number, limit?: number, offset?: number, searchText?: string, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).apiConversationsGet(agentId, limit, offset, searchText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a conversation
     * @param {number} id ID of the conversation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConversationsIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).apiConversationsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a conversation
     * @param {number} id ID of the conversation
     * @param {UpdateConversationRequest} updateConversationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConversationsIdPut(id: number, updateConversationRequest: UpdateConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).apiConversationsIdPut(id, updateConversationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new conversation
     * @param {CreateConversationRequest} createConversationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConversationsPost(createConversationRequest: CreateConversationRequest, options?: RawAxiosRequestConfig) {
        return ConversationsApiFp(this.configuration).apiConversationsPost(createConversationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CredentialsApi - axios parameter creator
 */
export const CredentialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete credentials
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsCredentialsIdDelete: async (teamId: number, credentialsId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsCredentialsIdDelete', 'teamId', teamId)
            // verify required parameter 'credentialsId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsCredentialsIdDelete', 'credentialsId', credentialsId)
            const localVarPath = `/api/teams/{teamId}/credentials/{credentialsId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"credentialsId"}}`, encodeURIComponent(String(credentialsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get credentials by ID
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsCredentialsIdGet: async (teamId: number, credentialsId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsCredentialsIdGet', 'teamId', teamId)
            // verify required parameter 'credentialsId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsCredentialsIdGet', 'credentialsId', credentialsId)
            const localVarPath = `/api/teams/{teamId}/credentials/{credentialsId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"credentialsId"}}`, encodeURIComponent(String(credentialsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update credentials
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {ApiTeamsTeamIdCredentialsCredentialsIdPutRequest} apiTeamsTeamIdCredentialsCredentialsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsCredentialsIdPut: async (teamId: number, credentialsId: number, apiTeamsTeamIdCredentialsCredentialsIdPutRequest: ApiTeamsTeamIdCredentialsCredentialsIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsCredentialsIdPut', 'teamId', teamId)
            // verify required parameter 'credentialsId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsCredentialsIdPut', 'credentialsId', credentialsId)
            // verify required parameter 'apiTeamsTeamIdCredentialsCredentialsIdPutRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsCredentialsIdPut', 'apiTeamsTeamIdCredentialsCredentialsIdPutRequest', apiTeamsTeamIdCredentialsCredentialsIdPutRequest)
            const localVarPath = `/api/teams/{teamId}/credentials/{credentialsId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"credentialsId"}}`, encodeURIComponent(String(credentialsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdCredentialsCredentialsIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all credentials for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/credentials`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create credentials for a team
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdCredentialsPostRequest} apiTeamsTeamIdCredentialsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsPost: async (teamId: number, apiTeamsTeamIdCredentialsPostRequest: ApiTeamsTeamIdCredentialsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsPost', 'teamId', teamId)
            // verify required parameter 'apiTeamsTeamIdCredentialsPostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdCredentialsPost', 'apiTeamsTeamIdCredentialsPostRequest', apiTeamsTeamIdCredentialsPostRequest)
            const localVarPath = `/api/teams/{teamId}/credentials`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdCredentialsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CredentialsApi - functional programming interface
 */
export const CredentialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CredentialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete credentials
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdCredentialsCredentialsIdDelete(teamId: number, credentialsId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdCredentialsCredentialsIdDelete(teamId, credentialsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.apiTeamsTeamIdCredentialsCredentialsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get credentials by ID
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdCredentialsCredentialsIdGet(teamId: number, credentialsId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdCredentialsGet200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdCredentialsCredentialsIdGet(teamId, credentialsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.apiTeamsTeamIdCredentialsCredentialsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update credentials
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {ApiTeamsTeamIdCredentialsCredentialsIdPutRequest} apiTeamsTeamIdCredentialsCredentialsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdCredentialsCredentialsIdPut(teamId: number, credentialsId: number, apiTeamsTeamIdCredentialsCredentialsIdPutRequest: ApiTeamsTeamIdCredentialsCredentialsIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdCredentialsGet200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdCredentialsCredentialsIdPut(teamId, credentialsId, apiTeamsTeamIdCredentialsCredentialsIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.apiTeamsTeamIdCredentialsCredentialsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all credentials for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdCredentialsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTeamsTeamIdCredentialsGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdCredentialsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.apiTeamsTeamIdCredentialsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create credentials for a team
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdCredentialsPostRequest} apiTeamsTeamIdCredentialsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdCredentialsPost(teamId: number, apiTeamsTeamIdCredentialsPostRequest: ApiTeamsTeamIdCredentialsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdCredentialsGet200ResponseInner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdCredentialsPost(teamId, apiTeamsTeamIdCredentialsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CredentialsApi.apiTeamsTeamIdCredentialsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CredentialsApi - factory interface
 */
export const CredentialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CredentialsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete credentials
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsCredentialsIdDelete(teamId: number, credentialsId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response> {
            return localVarFp.apiTeamsTeamIdCredentialsCredentialsIdDelete(teamId, credentialsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get credentials by ID
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsCredentialsIdGet(teamId: number, credentialsId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdCredentialsGet200ResponseInner> {
            return localVarFp.apiTeamsTeamIdCredentialsCredentialsIdGet(teamId, credentialsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update credentials
         * @param {number} teamId 
         * @param {number} credentialsId 
         * @param {ApiTeamsTeamIdCredentialsCredentialsIdPutRequest} apiTeamsTeamIdCredentialsCredentialsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsCredentialsIdPut(teamId: number, credentialsId: number, apiTeamsTeamIdCredentialsCredentialsIdPutRequest: ApiTeamsTeamIdCredentialsCredentialsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdCredentialsGet200ResponseInner> {
            return localVarFp.apiTeamsTeamIdCredentialsCredentialsIdPut(teamId, credentialsId, apiTeamsTeamIdCredentialsCredentialsIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all credentials for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTeamsTeamIdCredentialsGet200ResponseInner>> {
            return localVarFp.apiTeamsTeamIdCredentialsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create credentials for a team
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdCredentialsPostRequest} apiTeamsTeamIdCredentialsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCredentialsPost(teamId: number, apiTeamsTeamIdCredentialsPostRequest: ApiTeamsTeamIdCredentialsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdCredentialsGet200ResponseInner> {
            return localVarFp.apiTeamsTeamIdCredentialsPost(teamId, apiTeamsTeamIdCredentialsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CredentialsApi - object-oriented interface
 */
export class CredentialsApi extends BaseAPI {
    /**
     * 
     * @summary Delete credentials
     * @param {number} teamId 
     * @param {number} credentialsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdCredentialsCredentialsIdDelete(teamId: number, credentialsId: number, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).apiTeamsTeamIdCredentialsCredentialsIdDelete(teamId, credentialsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get credentials by ID
     * @param {number} teamId 
     * @param {number} credentialsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdCredentialsCredentialsIdGet(teamId: number, credentialsId: number, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).apiTeamsTeamIdCredentialsCredentialsIdGet(teamId, credentialsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update credentials
     * @param {number} teamId 
     * @param {number} credentialsId 
     * @param {ApiTeamsTeamIdCredentialsCredentialsIdPutRequest} apiTeamsTeamIdCredentialsCredentialsIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdCredentialsCredentialsIdPut(teamId: number, credentialsId: number, apiTeamsTeamIdCredentialsCredentialsIdPutRequest: ApiTeamsTeamIdCredentialsCredentialsIdPutRequest, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).apiTeamsTeamIdCredentialsCredentialsIdPut(teamId, credentialsId, apiTeamsTeamIdCredentialsCredentialsIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all credentials for a team
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdCredentialsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).apiTeamsTeamIdCredentialsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create credentials for a team
     * @param {number} teamId 
     * @param {ApiTeamsTeamIdCredentialsPostRequest} apiTeamsTeamIdCredentialsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdCredentialsPost(teamId: number, apiTeamsTeamIdCredentialsPostRequest: ApiTeamsTeamIdCredentialsPostRequest, options?: RawAxiosRequestConfig) {
        return CredentialsApiFp(this.configuration).apiTeamsTeamIdCredentialsPost(teamId, apiTeamsTeamIdCredentialsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomToolsApi - axios parameter creator
 */
export const CustomToolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all custom tools for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdCustomToolsGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdCustomToolsGet', 'agentId', agentId)
            const localVarPath = `/api/agents/{agentId}/custom-tools`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a custom tool
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdCustomToolsIdDelete: async (agentId: number, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdCustomToolsIdDelete', 'agentId', agentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentsAgentIdCustomToolsIdDelete', 'id', id)
            const localVarPath = `/api/agents/{agentId}/custom-tools/{id}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a custom tool (definition, settings, status, or secret values)
         * @param {number} agentId 
         * @param {number} id 
         * @param {UpdateCustomToolRequest} updateCustomToolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdCustomToolsIdPut: async (agentId: number, id: number, updateCustomToolRequest: UpdateCustomToolRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdCustomToolsIdPut', 'agentId', agentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentsAgentIdCustomToolsIdPut', 'id', id)
            // verify required parameter 'updateCustomToolRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdCustomToolsIdPut', 'updateCustomToolRequest', updateCustomToolRequest)
            const localVarPath = `/api/agents/{agentId}/custom-tools/{id}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomToolRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a custom tool for an agent
         * @param {number} agentId 
         * @param {CreateCustomToolRequest} createCustomToolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdCustomToolsPost: async (agentId: number, createCustomToolRequest: CreateCustomToolRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdCustomToolsPost', 'agentId', agentId)
            // verify required parameter 'createCustomToolRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdCustomToolsPost', 'createCustomToolRequest', createCustomToolRequest)
            const localVarPath = `/api/agents/{agentId}/custom-tools`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomToolRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the tool approval queue for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolActionsGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolActionsGet', 'agentId', agentId)
            const localVarPath = `/api/agents/{agentId}/tool-actions`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve a queued tool action (executes it now)
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolActionsIdApprovePostRequest} [apiAgentsAgentIdToolActionsIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolActionsIdApprovePost: async (agentId: number, id: number, apiAgentsAgentIdToolActionsIdApprovePostRequest?: ApiAgentsAgentIdToolActionsIdApprovePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolActionsIdApprovePost', 'agentId', agentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolActionsIdApprovePost', 'id', id)
            const localVarPath = `/api/agents/{agentId}/tool-actions/{id}/approve`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAgentsAgentIdToolActionsIdApprovePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject a queued tool action
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolActionsIdApprovePostRequest} [apiAgentsAgentIdToolActionsIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolActionsIdRejectPost: async (agentId: number, id: number, apiAgentsAgentIdToolActionsIdApprovePostRequest?: ApiAgentsAgentIdToolActionsIdApprovePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolActionsIdRejectPost', 'agentId', agentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolActionsIdRejectPost', 'id', id)
            const localVarPath = `/api/agents/{agentId}/tool-actions/{id}/reject`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAgentsAgentIdToolActionsIdApprovePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomToolsApi - functional programming interface
 */
export const CustomToolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomToolsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all custom tools for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdCustomToolsGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomTool>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdCustomToolsGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.apiAgentsAgentIdCustomToolsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a custom tool
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdCustomToolsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdCustomToolsIdDelete(agentId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.apiAgentsAgentIdCustomToolsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a custom tool (definition, settings, status, or secret values)
         * @param {number} agentId 
         * @param {number} id 
         * @param {UpdateCustomToolRequest} updateCustomToolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdCustomToolsIdPut(agentId: number, id: number, updateCustomToolRequest: UpdateCustomToolRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomTool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdCustomToolsIdPut(agentId, id, updateCustomToolRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.apiAgentsAgentIdCustomToolsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a custom tool for an agent
         * @param {number} agentId 
         * @param {CreateCustomToolRequest} createCustomToolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdCustomToolsPost(agentId: number, createCustomToolRequest: CreateCustomToolRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomTool>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdCustomToolsPost(agentId, createCustomToolRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.apiAgentsAgentIdCustomToolsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the tool approval queue for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolActionsGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToolAction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolActionsGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.apiAgentsAgentIdToolActionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Approve a queued tool action (executes it now)
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolActionsIdApprovePostRequest} [apiAgentsAgentIdToolActionsIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolActionsIdApprovePost(agentId: number, id: number, apiAgentsAgentIdToolActionsIdApprovePostRequest?: ApiAgentsAgentIdToolActionsIdApprovePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolActionsIdApprovePost(agentId, id, apiAgentsAgentIdToolActionsIdApprovePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.apiAgentsAgentIdToolActionsIdApprovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject a queued tool action
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolActionsIdApprovePostRequest} [apiAgentsAgentIdToolActionsIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolActionsIdRejectPost(agentId: number, id: number, apiAgentsAgentIdToolActionsIdApprovePostRequest?: ApiAgentsAgentIdToolActionsIdApprovePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolActionsIdRejectPost(agentId, id, apiAgentsAgentIdToolActionsIdApprovePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomToolsApi.apiAgentsAgentIdToolActionsIdRejectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomToolsApi - factory interface
 */
export const CustomToolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomToolsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all custom tools for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdCustomToolsGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomTool>> {
            return localVarFp.apiAgentsAgentIdCustomToolsGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a custom tool
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdCustomToolsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response> {
            return localVarFp.apiAgentsAgentIdCustomToolsIdDelete(agentId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a custom tool (definition, settings, status, or secret values)
         * @param {number} agentId 
         * @param {number} id 
         * @param {UpdateCustomToolRequest} updateCustomToolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdCustomToolsIdPut(agentId: number, id: number, updateCustomToolRequest: UpdateCustomToolRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomTool> {
            return localVarFp.apiAgentsAgentIdCustomToolsIdPut(agentId, id, updateCustomToolRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a custom tool for an agent
         * @param {number} agentId 
         * @param {CreateCustomToolRequest} createCustomToolRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdCustomToolsPost(agentId: number, createCustomToolRequest: CreateCustomToolRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomTool> {
            return localVarFp.apiAgentsAgentIdCustomToolsPost(agentId, createCustomToolRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the tool approval queue for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolActionsGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToolAction>> {
            return localVarFp.apiAgentsAgentIdToolActionsGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve a queued tool action (executes it now)
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolActionsIdApprovePostRequest} [apiAgentsAgentIdToolActionsIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolActionsIdApprovePost(agentId: number, id: number, apiAgentsAgentIdToolActionsIdApprovePostRequest?: ApiAgentsAgentIdToolActionsIdApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToolAction> {
            return localVarFp.apiAgentsAgentIdToolActionsIdApprovePost(agentId, id, apiAgentsAgentIdToolActionsIdApprovePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject a queued tool action
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolActionsIdApprovePostRequest} [apiAgentsAgentIdToolActionsIdApprovePostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolActionsIdRejectPost(agentId: number, id: number, apiAgentsAgentIdToolActionsIdApprovePostRequest?: ApiAgentsAgentIdToolActionsIdApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToolAction> {
            return localVarFp.apiAgentsAgentIdToolActionsIdRejectPost(agentId, id, apiAgentsAgentIdToolActionsIdApprovePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomToolsApi - object-oriented interface
 */
export class CustomToolsApi extends BaseAPI {
    /**
     * 
     * @summary Get all custom tools for an agent
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdCustomToolsGet(agentId: number, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).apiAgentsAgentIdCustomToolsGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a custom tool
     * @param {number} agentId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdCustomToolsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).apiAgentsAgentIdCustomToolsIdDelete(agentId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a custom tool (definition, settings, status, or secret values)
     * @param {number} agentId 
     * @param {number} id 
     * @param {UpdateCustomToolRequest} updateCustomToolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdCustomToolsIdPut(agentId: number, id: number, updateCustomToolRequest: UpdateCustomToolRequest, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).apiAgentsAgentIdCustomToolsIdPut(agentId, id, updateCustomToolRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a custom tool for an agent
     * @param {number} agentId 
     * @param {CreateCustomToolRequest} createCustomToolRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdCustomToolsPost(agentId: number, createCustomToolRequest: CreateCustomToolRequest, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).apiAgentsAgentIdCustomToolsPost(agentId, createCustomToolRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the tool approval queue for an agent
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolActionsGet(agentId: number, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).apiAgentsAgentIdToolActionsGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve a queued tool action (executes it now)
     * @param {number} agentId 
     * @param {number} id 
     * @param {ApiAgentsAgentIdToolActionsIdApprovePostRequest} [apiAgentsAgentIdToolActionsIdApprovePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolActionsIdApprovePost(agentId: number, id: number, apiAgentsAgentIdToolActionsIdApprovePostRequest?: ApiAgentsAgentIdToolActionsIdApprovePostRequest, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).apiAgentsAgentIdToolActionsIdApprovePost(agentId, id, apiAgentsAgentIdToolActionsIdApprovePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject a queued tool action
     * @param {number} agentId 
     * @param {number} id 
     * @param {ApiAgentsAgentIdToolActionsIdApprovePostRequest} [apiAgentsAgentIdToolActionsIdApprovePostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolActionsIdRejectPost(agentId: number, id: number, apiAgentsAgentIdToolActionsIdApprovePostRequest?: ApiAgentsAgentIdToolActionsIdApprovePostRequest, options?: RawAxiosRequestConfig) {
        return CustomToolsApiFp(this.configuration).apiAgentsAgentIdToolActionsIdRejectPost(agentId, id, apiAgentsAgentIdToolActionsIdApprovePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DatabasesApi - axios parameter creator
 */
export const DatabasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Run a chart\'s query read-only and return its rows (paginated, cached per database version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet: async (teamId: number, projectId: number, path: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/chart/data`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a chart definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesChartGet: async (teamId: number, projectId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartGet', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartGet', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/chart`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or replace a chart definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {ChartSaveRequest} chartSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesChartPut: async (teamId: number, projectId: number, chartSaveRequest: ChartSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartPut', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartPut', 'projectId', projectId)
            // verify required parameter 'chartSaveRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartPut', 'chartSaveRequest', chartSaveRequest)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/chart`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chartSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the project\'s chart definitions
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet: async (teamId: number, projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet', 'projectId', projectId)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/charts`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a dashboard definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet: async (teamId: number, projectId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/dashboard`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or replace a dashboard definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {DashboardSaveRequest} dashboardSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut: async (teamId: number, projectId: number, dashboardSaveRequest: DashboardSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut', 'projectId', projectId)
            // verify required parameter 'dashboardSaveRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut', 'dashboardSaveRequest', dashboardSaveRequest)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/dashboard`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the project\'s dashboards
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet: async (teamId: number, projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet', 'projectId', projectId)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/dashboards`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a databases/ file (database, chart, or dashboard) and all of its versions
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete: async (teamId: number, projectId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/file`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the project\'s SQLite databases
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesGet: async (teamId: number, projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesGet', 'projectId', projectId)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run a read-only SQL query against a database (server-side, worker-isolated, bounded)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {DatabaseQueryRequest} databaseQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost: async (teamId: number, projectId: number, databaseQueryRequest: DatabaseQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost', 'projectId', projectId)
            // verify required parameter 'databaseQueryRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost', 'databaseQueryRequest', databaseQueryRequest)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/query`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(databaseQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a database\'s schema (tables, columns, foreign keys, row counts) and notes
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet: async (teamId: number, projectId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/schema`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a database\'s version history
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet: async (teamId: number, projectId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/databases/versions`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatabasesApi - functional programming interface
 */
export const DatabasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatabasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Run a chart\'s query read-only and return its rows (paginated, cached per database version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet(teamId: number, projectId: number, path: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet(teamId, projectId, path, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a chart definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesChartGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesChartGet(teamId, projectId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesChartGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create or replace a chart definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {ChartSaveRequest} chartSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesChartPut(teamId: number, projectId: number, chartSaveRequest: ChartSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesChartPut(teamId, projectId, chartSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesChartPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the project\'s chart definitions
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet(teamId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a dashboard definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet(teamId, projectId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create or replace a dashboard definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {DashboardSaveRequest} dashboardSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut(teamId: number, projectId: number, dashboardSaveRequest: DashboardSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut(teamId, projectId, dashboardSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the project\'s dashboards
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet(teamId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a databases/ file (database, chart, or dashboard) and all of its versions
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseFileDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete(teamId, projectId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the project\'s SQLite databases
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesGet(teamId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run a read-only SQL query against a database (server-side, worker-isolated, bounded)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {DatabaseQueryRequest} databaseQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost(teamId: number, projectId: number, databaseQueryRequest: DatabaseQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost(teamId, projectId, databaseQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a database\'s schema (tables, columns, foreign keys, row counts) and notes
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseSchemaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet(teamId, projectId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a database\'s version history
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseVersionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet(teamId, projectId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DatabasesApi.apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DatabasesApi - factory interface
 */
export const DatabasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatabasesApiFp(configuration)
    return {
        /**
         * 
         * @summary Run a chart\'s query read-only and return its rows (paginated, cached per database version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet(teamId: number, projectId: number, path: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ChartDataResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet(teamId, projectId, path, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a chart definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesChartGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<ChartResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesChartGet(teamId, projectId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or replace a chart definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {ChartSaveRequest} chartSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesChartPut(teamId: number, projectId: number, chartSaveRequest: ChartSaveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChartResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesChartPut(teamId, projectId, chartSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the project\'s chart definitions
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ChartListResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet(teamId, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a dashboard definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet(teamId, projectId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or replace a dashboard definition
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {DashboardSaveRequest} dashboardSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut(teamId: number, projectId: number, dashboardSaveRequest: DashboardSaveRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut(teamId, projectId, dashboardSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the project\'s dashboards
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<DashboardListResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet(teamId, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a databases/ file (database, chart, or dashboard) and all of its versions
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseFileDeleteResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete(teamId, projectId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the project\'s SQLite databases
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseListResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesGet(teamId, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run a read-only SQL query against a database (server-side, worker-isolated, bounded)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {DatabaseQueryRequest} databaseQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost(teamId: number, projectId: number, databaseQueryRequest: DatabaseQueryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseQueryResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost(teamId, projectId, databaseQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a database\'s schema (tables, columns, foreign keys, row counts) and notes
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseSchemaResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet(teamId, projectId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a database\'s version history
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseVersionsResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet(teamId, projectId, path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatabasesApi - object-oriented interface
 */
export class DatabasesApi extends BaseAPI {
    /**
     * 
     * @summary Run a chart\'s query read-only and return its rows (paginated, cached per database version)
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet(teamId: number, projectId: number, path: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesChartDataGet(teamId, projectId, path, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a chart definition
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesChartGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesChartGet(teamId, projectId, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or replace a chart definition
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {ChartSaveRequest} chartSaveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesChartPut(teamId: number, projectId: number, chartSaveRequest: ChartSaveRequest, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesChartPut(teamId, projectId, chartSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the project\'s chart definitions
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesChartsGet(teamId, projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a dashboard definition
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesDashboardGet(teamId, projectId, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or replace a dashboard definition
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {DashboardSaveRequest} dashboardSaveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut(teamId: number, projectId: number, dashboardSaveRequest: DashboardSaveRequest, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesDashboardPut(teamId, projectId, dashboardSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the project\'s dashboards
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesDashboardsGet(teamId, projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a databases/ file (database, chart, or dashboard) and all of its versions
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesFileDelete(teamId, projectId, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the project\'s SQLite databases
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesGet(teamId: number, projectId: number, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesGet(teamId, projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run a read-only SQL query against a database (server-side, worker-isolated, bounded)
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {DatabaseQueryRequest} databaseQueryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost(teamId: number, projectId: number, databaseQueryRequest: DatabaseQueryRequest, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesQueryPost(teamId, projectId, databaseQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a database\'s schema (tables, columns, foreign keys, row counts) and notes
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesSchemaGet(teamId, projectId, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a database\'s version history
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdDatabasesVersionsGet(teamId, projectId, path, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves a paginated list of memories for the specified agent. Requires user to be a team member.
         * @summary List memories for an agent
         * @param {number} agentId The ID of the agent
         * @param {number} [offset] Number of memories to skip
         * @param {number} [limitCount] Maximum number of memories to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdMemoriesGet: async (agentId: number, offset?: number, limitCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdMemoriesGet', 'agentId', agentId)
            const localVarPath = `/api/agents/{agentId}/memories`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limitCount !== undefined) {
                localVarQueryParameter['limitCount'] = limitCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new memory for the specified agent. Requires user to be a team member.
         * @summary Add a new memory to an agent
         * @param {number} agentId The ID of the agent
         * @param {ApiAgentsAgentIdMemoriesPostRequest} apiAgentsAgentIdMemoriesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdMemoriesPost: async (agentId: number, apiAgentsAgentIdMemoriesPostRequest: ApiAgentsAgentIdMemoriesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdMemoriesPost', 'agentId', agentId)
            // verify required parameter 'apiAgentsAgentIdMemoriesPostRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdMemoriesPost', 'apiAgentsAgentIdMemoriesPostRequest', apiAgentsAgentIdMemoriesPostRequest)
            const localVarPath = `/api/agents/{agentId}/memories`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAgentsAgentIdMemoriesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Searches memories for the specified agent using semantic similarity. Requires user to be a team member.
         * @summary Search memories for an agent
         * @param {number} agentId The ID of the agent
         * @param {string} query The search query text
         * @param {number} [offset] Number of memories to skip
         * @param {number} [limitCount] Maximum number of memories to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdMemoriesSearchGet: async (agentId: number, query: string, offset?: number, limitCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdMemoriesSearchGet', 'agentId', agentId)
            // verify required parameter 'query' is not null or undefined
            assertParamExists('apiAgentsAgentIdMemoriesSearchGet', 'query', query)
            const localVarPath = `/api/agents/{agentId}/memories/search`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limitCount !== undefined) {
                localVarQueryParameter['limitCount'] = limitCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an existing memory. Requires user to be a team member.
         * @summary Delete a memory
         * @param {number} memoryId The ID of the memory to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMemoriesMemoryIdDelete: async (memoryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memoryId' is not null or undefined
            assertParamExists('apiMemoriesMemoryIdDelete', 'memoryId', memoryId)
            const localVarPath = `/api/memories/{memoryId}`
                .replace(`{${"memoryId"}}`, encodeURIComponent(String(memoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the text content of an existing memory. Requires user to be a team member.
         * @summary Update a memory
         * @param {number} memoryId The ID of the memory to update
         * @param {ApiMemoriesMemoryIdPutRequest} apiMemoriesMemoryIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMemoriesMemoryIdPut: async (memoryId: number, apiMemoriesMemoryIdPutRequest: ApiMemoriesMemoryIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memoryId' is not null or undefined
            assertParamExists('apiMemoriesMemoryIdPut', 'memoryId', memoryId)
            // verify required parameter 'apiMemoriesMemoryIdPutRequest' is not null or undefined
            assertParamExists('apiMemoriesMemoryIdPut', 'apiMemoriesMemoryIdPutRequest', apiMemoriesMemoryIdPutRequest)
            const localVarPath = `/api/memories/{memoryId}`
                .replace(`{${"memoryId"}}`, encodeURIComponent(String(memoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiMemoriesMemoryIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply an idempotent voice lifecycle command
         * @param {string} sessionId 
         * @param {VoiceSessionCommandRequest} voiceSessionCommandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandVoiceSession: async (sessionId: string, voiceSessionCommandRequest: VoiceSessionCommandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('commandVoiceSession', 'sessionId', sessionId)
            // verify required parameter 'voiceSessionCommandRequest' is not null or undefined
            assertParamExists('commandVoiceSession', 'voiceSessionCommandRequest', voiceSessionCommandRequest)
            const localVarPath = `/api/voice-sessions/{sessionId}/commands`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceSessionCommandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Negotiate an OpenAI Realtime WebRTC session
         * @param {string} sessionId 
         * @param {number} xVoiceLeaseVersion 
         * @param {string} xVoiceMediaBindingId 
         * @param {number} xVoiceMediaGeneration 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpenAIRealtimeOffer: async (sessionId: string, xVoiceLeaseVersion: number, xVoiceMediaBindingId: string, xVoiceMediaGeneration: number, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('createOpenAIRealtimeOffer', 'sessionId', sessionId)
            // verify required parameter 'xVoiceLeaseVersion' is not null or undefined
            assertParamExists('createOpenAIRealtimeOffer', 'xVoiceLeaseVersion', xVoiceLeaseVersion)
            // verify required parameter 'xVoiceMediaBindingId' is not null or undefined
            assertParamExists('createOpenAIRealtimeOffer', 'xVoiceMediaBindingId', xVoiceMediaBindingId)
            // verify required parameter 'xVoiceMediaGeneration' is not null or undefined
            assertParamExists('createOpenAIRealtimeOffer', 'xVoiceMediaGeneration', xVoiceMediaGeneration)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createOpenAIRealtimeOffer', 'body', body)
            const localVarPath = `/api/voice-sessions/{sessionId}/openai/realtime-offer`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/sdp';

            if (xVoiceLeaseVersion != null) {
                localVarHeaderParameter['X-Voice-Lease-Version'] = typeof xVoiceLeaseVersion === 'string'
                    ? xVoiceLeaseVersion
                    : JSON.stringify(xVoiceLeaseVersion);
            }
            if (xVoiceMediaBindingId != null) {
                localVarHeaderParameter['X-Voice-Media-Binding-Id'] = String(xVoiceMediaBindingId);
            }
            if (xVoiceMediaGeneration != null) {
                localVarHeaderParameter['X-Voice-Media-Generation'] = typeof xVoiceMediaGeneration === 'string'
                    ? xVoiceMediaGeneration
                    : JSON.stringify(xVoiceMediaGeneration);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List eligible voice agents with resolved profiles
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationVoiceOptions: async (teamId: number, conversationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listConversationVoiceOptions', 'teamId', teamId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('listConversationVoiceOptions', 'conversationId', conversationId)
            const localVarPath = `/api/teams/{teamId}/chat/conversations/{conversationId}/voice-options`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List team voice agents with resolved profiles
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamVoiceOptions: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamVoiceOptions', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/voice-options`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List curated voice profiles and their availability
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVoiceProfiles: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listVoiceProfiles', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/voice-profiles`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start or idempotently resume a voice session
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {StartVoiceSessionRequest} startVoiceSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startVoiceSession: async (teamId: number, conversationId: number, startVoiceSessionRequest: StartVoiceSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('startVoiceSession', 'teamId', teamId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('startVoiceSession', 'conversationId', conversationId)
            // verify required parameter 'startVoiceSessionRequest' is not null or undefined
            assertParamExists('startVoiceSession', 'startVoiceSessionRequest', startVoiceSessionRequest)
            const localVarPath = `/api/teams/{teamId}/chat/conversations/{conversationId}/voice-sessions`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startVoiceSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves a paginated list of memories for the specified agent. Requires user to be a team member.
         * @summary List memories for an agent
         * @param {number} agentId The ID of the agent
         * @param {number} [offset] Number of memories to skip
         * @param {number} [limitCount] Maximum number of memories to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdMemoriesGet(agentId: number, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAgentsAgentIdMemoriesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdMemoriesGet(agentId, offset, limitCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiAgentsAgentIdMemoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new memory for the specified agent. Requires user to be a team member.
         * @summary Add a new memory to an agent
         * @param {number} agentId The ID of the agent
         * @param {ApiAgentsAgentIdMemoriesPostRequest} apiAgentsAgentIdMemoriesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdMemoriesPost(agentId: number, apiAgentsAgentIdMemoriesPostRequest: ApiAgentsAgentIdMemoriesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMemory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdMemoriesPost(agentId, apiAgentsAgentIdMemoriesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiAgentsAgentIdMemoriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Searches memories for the specified agent using semantic similarity. Requires user to be a team member.
         * @summary Search memories for an agent
         * @param {number} agentId The ID of the agent
         * @param {string} query The search query text
         * @param {number} [offset] Number of memories to skip
         * @param {number} [limitCount] Maximum number of memories to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdMemoriesSearchGet(agentId: number, query: string, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAgentsAgentIdMemoriesSearchGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdMemoriesSearchGet(agentId, query, offset, limitCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiAgentsAgentIdMemoriesSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an existing memory. Requires user to be a team member.
         * @summary Delete a memory
         * @param {number} memoryId The ID of the memory to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMemoriesMemoryIdDelete(memoryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMemoriesMemoryIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMemoriesMemoryIdDelete(memoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiMemoriesMemoryIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the text content of an existing memory. Requires user to be a team member.
         * @summary Update a memory
         * @param {number} memoryId The ID of the memory to update
         * @param {ApiMemoriesMemoryIdPutRequest} apiMemoriesMemoryIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMemoriesMemoryIdPut(memoryId: number, apiMemoriesMemoryIdPutRequest: ApiMemoriesMemoryIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentMemory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMemoriesMemoryIdPut(memoryId, apiMemoriesMemoryIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiMemoriesMemoryIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Apply an idempotent voice lifecycle command
         * @param {string} sessionId 
         * @param {VoiceSessionCommandRequest} voiceSessionCommandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandVoiceSession(sessionId: string, voiceSessionCommandRequest: VoiceSessionCommandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSessionSnapshot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandVoiceSession(sessionId, voiceSessionCommandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.commandVoiceSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Negotiate an OpenAI Realtime WebRTC session
         * @param {string} sessionId 
         * @param {number} xVoiceLeaseVersion 
         * @param {string} xVoiceMediaBindingId 
         * @param {number} xVoiceMediaGeneration 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOpenAIRealtimeOffer(sessionId: string, xVoiceLeaseVersion: number, xVoiceMediaBindingId: string, xVoiceMediaGeneration: number, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOpenAIRealtimeOffer(sessionId, xVoiceLeaseVersion, xVoiceMediaBindingId, xVoiceMediaGeneration, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createOpenAIRealtimeOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List eligible voice agents with resolved profiles
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConversationVoiceOptions(teamId: number, conversationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListConversationVoiceOptions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConversationVoiceOptions(teamId, conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listConversationVoiceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List team voice agents with resolved profiles
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamVoiceOptions(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceAgentOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamVoiceOptions(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listTeamVoiceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List curated voice profiles and their availability
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVoiceProfiles(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListVoiceProfiles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVoiceProfiles(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listVoiceProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start or idempotently resume a voice session
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {StartVoiceSessionRequest} startVoiceSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startVoiceSession(teamId: number, conversationId: number, startVoiceSessionRequest: StartVoiceSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceSessionSnapshot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startVoiceSession(teamId, conversationId, startVoiceSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.startVoiceSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Retrieves a paginated list of memories for the specified agent. Requires user to be a team member.
         * @summary List memories for an agent
         * @param {number} agentId The ID of the agent
         * @param {number} [offset] Number of memories to skip
         * @param {number} [limitCount] Maximum number of memories to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdMemoriesGet(agentId: number, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiAgentsAgentIdMemoriesGet200Response> {
            return localVarFp.apiAgentsAgentIdMemoriesGet(agentId, offset, limitCount, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new memory for the specified agent. Requires user to be a team member.
         * @summary Add a new memory to an agent
         * @param {number} agentId The ID of the agent
         * @param {ApiAgentsAgentIdMemoriesPostRequest} apiAgentsAgentIdMemoriesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdMemoriesPost(agentId: number, apiAgentsAgentIdMemoriesPostRequest: ApiAgentsAgentIdMemoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentMemory> {
            return localVarFp.apiAgentsAgentIdMemoriesPost(agentId, apiAgentsAgentIdMemoriesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches memories for the specified agent using semantic similarity. Requires user to be a team member.
         * @summary Search memories for an agent
         * @param {number} agentId The ID of the agent
         * @param {string} query The search query text
         * @param {number} [offset] Number of memories to skip
         * @param {number} [limitCount] Maximum number of memories to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdMemoriesSearchGet(agentId: number, query: string, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiAgentsAgentIdMemoriesSearchGet200Response> {
            return localVarFp.apiAgentsAgentIdMemoriesSearchGet(agentId, query, offset, limitCount, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an existing memory. Requires user to be a team member.
         * @summary Delete a memory
         * @param {number} memoryId The ID of the memory to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMemoriesMemoryIdDelete(memoryId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiMemoriesMemoryIdDelete200Response> {
            return localVarFp.apiMemoriesMemoryIdDelete(memoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the text content of an existing memory. Requires user to be a team member.
         * @summary Update a memory
         * @param {number} memoryId The ID of the memory to update
         * @param {ApiMemoriesMemoryIdPutRequest} apiMemoriesMemoryIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMemoriesMemoryIdPut(memoryId: number, apiMemoriesMemoryIdPutRequest: ApiMemoriesMemoryIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgentMemory> {
            return localVarFp.apiMemoriesMemoryIdPut(memoryId, apiMemoriesMemoryIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply an idempotent voice lifecycle command
         * @param {string} sessionId 
         * @param {VoiceSessionCommandRequest} voiceSessionCommandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandVoiceSession(sessionId: string, voiceSessionCommandRequest: VoiceSessionCommandRequest, options?: RawAxiosRequestConfig): AxiosPromise<VoiceSessionSnapshot> {
            return localVarFp.commandVoiceSession(sessionId, voiceSessionCommandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Negotiate an OpenAI Realtime WebRTC session
         * @param {string} sessionId 
         * @param {number} xVoiceLeaseVersion 
         * @param {string} xVoiceMediaBindingId 
         * @param {number} xVoiceMediaGeneration 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOpenAIRealtimeOffer(sessionId: string, xVoiceLeaseVersion: number, xVoiceMediaBindingId: string, xVoiceMediaGeneration: number, body: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createOpenAIRealtimeOffer(sessionId, xVoiceLeaseVersion, xVoiceMediaBindingId, xVoiceMediaGeneration, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List eligible voice agents with resolved profiles
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationVoiceOptions(teamId: number, conversationId: number, options?: RawAxiosRequestConfig): AxiosPromise<ListConversationVoiceOptions200Response> {
            return localVarFp.listConversationVoiceOptions(teamId, conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List team voice agents with resolved profiles
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamVoiceOptions(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<VoiceAgentOptionsResponse> {
            return localVarFp.listTeamVoiceOptions(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List curated voice profiles and their availability
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVoiceProfiles(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ListVoiceProfiles200Response> {
            return localVarFp.listVoiceProfiles(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start or idempotently resume a voice session
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {StartVoiceSessionRequest} startVoiceSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startVoiceSession(teamId: number, conversationId: number, startVoiceSessionRequest: StartVoiceSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<VoiceSessionSnapshot> {
            return localVarFp.startVoiceSession(teamId, conversationId, startVoiceSessionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     * Retrieves a paginated list of memories for the specified agent. Requires user to be a team member.
     * @summary List memories for an agent
     * @param {number} agentId The ID of the agent
     * @param {number} [offset] Number of memories to skip
     * @param {number} [limitCount] Maximum number of memories to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdMemoriesGet(agentId: number, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiAgentsAgentIdMemoriesGet(agentId, offset, limitCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new memory for the specified agent. Requires user to be a team member.
     * @summary Add a new memory to an agent
     * @param {number} agentId The ID of the agent
     * @param {ApiAgentsAgentIdMemoriesPostRequest} apiAgentsAgentIdMemoriesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdMemoriesPost(agentId: number, apiAgentsAgentIdMemoriesPostRequest: ApiAgentsAgentIdMemoriesPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiAgentsAgentIdMemoriesPost(agentId, apiAgentsAgentIdMemoriesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Searches memories for the specified agent using semantic similarity. Requires user to be a team member.
     * @summary Search memories for an agent
     * @param {number} agentId The ID of the agent
     * @param {string} query The search query text
     * @param {number} [offset] Number of memories to skip
     * @param {number} [limitCount] Maximum number of memories to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdMemoriesSearchGet(agentId: number, query: string, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiAgentsAgentIdMemoriesSearchGet(agentId, query, offset, limitCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an existing memory. Requires user to be a team member.
     * @summary Delete a memory
     * @param {number} memoryId The ID of the memory to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMemoriesMemoryIdDelete(memoryId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiMemoriesMemoryIdDelete(memoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the text content of an existing memory. Requires user to be a team member.
     * @summary Update a memory
     * @param {number} memoryId The ID of the memory to update
     * @param {ApiMemoriesMemoryIdPutRequest} apiMemoriesMemoryIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMemoriesMemoryIdPut(memoryId: number, apiMemoriesMemoryIdPutRequest: ApiMemoriesMemoryIdPutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiMemoriesMemoryIdPut(memoryId, apiMemoriesMemoryIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply an idempotent voice lifecycle command
     * @param {string} sessionId 
     * @param {VoiceSessionCommandRequest} voiceSessionCommandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public commandVoiceSession(sessionId: string, voiceSessionCommandRequest: VoiceSessionCommandRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).commandVoiceSession(sessionId, voiceSessionCommandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Negotiate an OpenAI Realtime WebRTC session
     * @param {string} sessionId 
     * @param {number} xVoiceLeaseVersion 
     * @param {string} xVoiceMediaBindingId 
     * @param {number} xVoiceMediaGeneration 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOpenAIRealtimeOffer(sessionId: string, xVoiceLeaseVersion: number, xVoiceMediaBindingId: string, xVoiceMediaGeneration: number, body: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createOpenAIRealtimeOffer(sessionId, xVoiceLeaseVersion, xVoiceMediaBindingId, xVoiceMediaGeneration, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List eligible voice agents with resolved profiles
     * @param {number} teamId 
     * @param {number} conversationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConversationVoiceOptions(teamId: number, conversationId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listConversationVoiceOptions(teamId, conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List team voice agents with resolved profiles
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTeamVoiceOptions(teamId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listTeamVoiceOptions(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List curated voice profiles and their availability
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listVoiceProfiles(teamId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listVoiceProfiles(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start or idempotently resume a voice session
     * @param {number} teamId 
     * @param {number} conversationId 
     * @param {StartVoiceSessionRequest} startVoiceSessionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startVoiceSession(teamId: number, conversationId: number, startVoiceSessionRequest: StartVoiceSessionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).startVoiceSession(teamId, conversationId, startVoiceSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailApi - axios parameter creator
 */
export const EmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint receives parsed emails from SendGrid\'s Inbound Parse webhook. It processes incoming emails and forwards them to the appropriate agent for handling. 
         * @summary Webhook endpoint for SendGrid Inbound Parse
         * @param {string} from Email sender address
         * @param {string} to Email recipient address
         * @param {string} subject Email subject line
         * @param {string} [text] Plain text content of the email
         * @param {string} [html] HTML content of the email
         * @param {string} [senderIp] IP address of the sender
         * @param {string} [envelope] SMTP envelope information in JSON format
         * @param {number} [attachments] Number of attachments
         * @param {string} [attachmentInfo] Information about attachments in JSON format
         * @param {string} [headers] Email headers
         * @param {string} [dkim] DKIM signature check result
         * @param {string} [spamScore] Spam score of the email
         * @param {string} [spamReport] Detailed spam report
         * @param {string} [spf] SPF check result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSendgridInboundPost: async (from: string, to: string, subject: string, text?: string, html?: string, senderIp?: string, envelope?: string, attachments?: number, attachmentInfo?: string, headers?: string, dkim?: string, spamScore?: string, spamReport?: string, spf?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('apiSendgridInboundPost', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('apiSendgridInboundPost', 'to', to)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('apiSendgridInboundPost', 'subject', subject)
            const localVarPath = `/api/sendgrid/inbound`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }
    
            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }
    
            if (subject !== undefined) { 
                localVarFormParams.append('subject', subject as any);
            }
    
            if (text !== undefined) { 
                localVarFormParams.append('text', text as any);
            }
    
            if (html !== undefined) { 
                localVarFormParams.append('html', html as any);
            }
    
            if (senderIp !== undefined) { 
                localVarFormParams.append('sender_ip', senderIp as any);
            }
    
            if (envelope !== undefined) { 
                localVarFormParams.append('envelope', envelope as any);
            }
    
            if (attachments !== undefined) { 
                localVarFormParams.append('attachments', attachments as any);
            }
    
            if (attachmentInfo !== undefined) { 
                localVarFormParams.append('attachment-info', attachmentInfo as any);
            }
    
            if (headers !== undefined) { 
                localVarFormParams.append('headers', headers as any);
            }
    
            if (dkim !== undefined) { 
                localVarFormParams.append('dkim', dkim as any);
            }
    
            if (spamScore !== undefined) { 
                localVarFormParams.append('spam_score', spamScore as any);
            }
    
            if (spamReport !== undefined) { 
                localVarFormParams.append('spam_report', spamReport as any);
            }
    
            if (spf !== undefined) { 
                localVarFormParams.append('spf', spf as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailApi - functional programming interface
 */
export const EmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint receives parsed emails from SendGrid\'s Inbound Parse webhook. It processes incoming emails and forwards them to the appropriate agent for handling. 
         * @summary Webhook endpoint for SendGrid Inbound Parse
         * @param {string} from Email sender address
         * @param {string} to Email recipient address
         * @param {string} subject Email subject line
         * @param {string} [text] Plain text content of the email
         * @param {string} [html] HTML content of the email
         * @param {string} [senderIp] IP address of the sender
         * @param {string} [envelope] SMTP envelope information in JSON format
         * @param {number} [attachments] Number of attachments
         * @param {string} [attachmentInfo] Information about attachments in JSON format
         * @param {string} [headers] Email headers
         * @param {string} [dkim] DKIM signature check result
         * @param {string} [spamScore] Spam score of the email
         * @param {string} [spamReport] Detailed spam report
         * @param {string} [spf] SPF check result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSendgridInboundPost(from: string, to: string, subject: string, text?: string, html?: string, senderIp?: string, envelope?: string, attachments?: number, attachmentInfo?: string, headers?: string, dkim?: string, spamScore?: string, spamReport?: string, spf?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSendgridInboundPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSendgridInboundPost(from, to, subject, text, html, senderIp, envelope, attachments, attachmentInfo, headers, dkim, spamScore, spamReport, spf, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailApi.apiSendgridInboundPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailApi - factory interface
 */
export const EmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailApiFp(configuration)
    return {
        /**
         * This endpoint receives parsed emails from SendGrid\'s Inbound Parse webhook. It processes incoming emails and forwards them to the appropriate agent for handling. 
         * @summary Webhook endpoint for SendGrid Inbound Parse
         * @param {string} from Email sender address
         * @param {string} to Email recipient address
         * @param {string} subject Email subject line
         * @param {string} [text] Plain text content of the email
         * @param {string} [html] HTML content of the email
         * @param {string} [senderIp] IP address of the sender
         * @param {string} [envelope] SMTP envelope information in JSON format
         * @param {number} [attachments] Number of attachments
         * @param {string} [attachmentInfo] Information about attachments in JSON format
         * @param {string} [headers] Email headers
         * @param {string} [dkim] DKIM signature check result
         * @param {string} [spamScore] Spam score of the email
         * @param {string} [spamReport] Detailed spam report
         * @param {string} [spf] SPF check result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSendgridInboundPost(from: string, to: string, subject: string, text?: string, html?: string, senderIp?: string, envelope?: string, attachments?: number, attachmentInfo?: string, headers?: string, dkim?: string, spamScore?: string, spamReport?: string, spf?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiSendgridInboundPost200Response> {
            return localVarFp.apiSendgridInboundPost(from, to, subject, text, html, senderIp, envelope, attachments, attachmentInfo, headers, dkim, spamScore, spamReport, spf, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailApi - object-oriented interface
 */
export class EmailApi extends BaseAPI {
    /**
     * This endpoint receives parsed emails from SendGrid\'s Inbound Parse webhook. It processes incoming emails and forwards them to the appropriate agent for handling. 
     * @summary Webhook endpoint for SendGrid Inbound Parse
     * @param {string} from Email sender address
     * @param {string} to Email recipient address
     * @param {string} subject Email subject line
     * @param {string} [text] Plain text content of the email
     * @param {string} [html] HTML content of the email
     * @param {string} [senderIp] IP address of the sender
     * @param {string} [envelope] SMTP envelope information in JSON format
     * @param {number} [attachments] Number of attachments
     * @param {string} [attachmentInfo] Information about attachments in JSON format
     * @param {string} [headers] Email headers
     * @param {string} [dkim] DKIM signature check result
     * @param {string} [spamScore] Spam score of the email
     * @param {string} [spamReport] Detailed spam report
     * @param {string} [spf] SPF check result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSendgridInboundPost(from: string, to: string, subject: string, text?: string, html?: string, senderIp?: string, envelope?: string, attachments?: number, attachmentInfo?: string, headers?: string, dkim?: string, spamScore?: string, spamReport?: string, spf?: string, options?: RawAxiosRequestConfig) {
        return EmailApiFp(this.configuration).apiSendgridInboundPost(from, to, subject, text, html, senderIp, envelope, attachments, attachmentInfo, headers, dkim, spamScore, spamReport, spf, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailAccountApi - axios parameter creator
 */
export const EmailAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {string} messageId 
         * @param {string} attachmentId 
         * @param {GetEmailAccountAttachmentDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailAccountAttachment: async (teamId: number, agentId: number, messageId: string, attachmentId: string, direction?: GetEmailAccountAttachmentDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getEmailAccountAttachment', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getEmailAccountAttachment', 'agentId', agentId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getEmailAccountAttachment', 'messageId', messageId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getEmailAccountAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/email-account/messages/{messageId}/attachments/{attachmentId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {string} messageId 
         * @param {GetEmailAccountMessageDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailAccountMessage: async (teamId: number, agentId: number, messageId: string, direction?: GetEmailAccountMessageDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getEmailAccountMessage', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getEmailAccountMessage', 'agentId', agentId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getEmailAccountMessage', 'messageId', messageId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/email-account/messages/{messageId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ListEmailAccountMessagesDirectionEnum} [direction] 
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {string} [afterId] 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailAccountMessages: async (teamId: number, agentId: number, direction?: ListEmailAccountMessagesDirectionEnum, before?: string, after?: string, afterId?: string, cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listEmailAccountMessages', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listEmailAccountMessages', 'agentId', agentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/email-account/messages`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (before !== undefined) {
                localVarQueryParameter['before'] = (before as any instanceof Date) ?
                    (before as any).toISOString() :
                    before;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = (after as any instanceof Date) ?
                    (after as any).toISOString() :
                    after;
            }

            if (afterId !== undefined) {
                localVarQueryParameter['afterId'] = afterId;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {Array<string>} to 
         * @param {string} subject 
         * @param {string} text 
         * @param {Array<string>} [cc] 
         * @param {Array<string>} [bcc] 
         * @param {string} [replyToMessageId] 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailAccountMessage: async (teamId: number, agentId: number, to: Array<string>, subject: string, text: string, cc?: Array<string>, bcc?: Array<string>, replyToMessageId?: string, attachments?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('sendEmailAccountMessage', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('sendEmailAccountMessage', 'agentId', agentId)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('sendEmailAccountMessage', 'to', to)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('sendEmailAccountMessage', 'subject', subject)
            // verify required parameter 'text' is not null or undefined
            assertParamExists('sendEmailAccountMessage', 'text', text)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/email-account/messages`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (to) {
                localVarFormParams.append('to', to.join(COLLECTION_FORMATS.csv));
            }

                if (cc) {
                localVarFormParams.append('cc', cc.join(COLLECTION_FORMATS.csv));
            }

                if (bcc) {
                localVarFormParams.append('bcc', bcc.join(COLLECTION_FORMATS.csv));
            }

    
            if (subject !== undefined) { 
                localVarFormParams.append('subject', subject as any);
            }
    
            if (text !== undefined) { 
                localVarFormParams.append('text', text as any);
            }
    
            if (replyToMessageId !== undefined) { 
                localVarFormParams.append('replyToMessageId', replyToMessageId as any);
            }
                if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailAccountApi - functional programming interface
 */
export const EmailAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {string} messageId 
         * @param {string} attachmentId 
         * @param {GetEmailAccountAttachmentDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailAccountAttachment(teamId: number, agentId: number, messageId: string, attachmentId: string, direction?: GetEmailAccountAttachmentDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailAccountAttachment(teamId, agentId, messageId, attachmentId, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailAccountApi.getEmailAccountAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {string} messageId 
         * @param {GetEmailAccountMessageDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailAccountMessage(teamId: number, agentId: number, messageId: string, direction?: GetEmailAccountMessageDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailAccountRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailAccountMessage(teamId, agentId, messageId, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailAccountApi.getEmailAccountMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ListEmailAccountMessagesDirectionEnum} [direction] 
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {string} [afterId] 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmailAccountMessages(teamId: number, agentId: number, direction?: ListEmailAccountMessagesDirectionEnum, before?: string, after?: string, afterId?: string, cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailAccountPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmailAccountMessages(teamId, agentId, direction, before, after, afterId, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailAccountApi.listEmailAccountMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {Array<string>} to 
         * @param {string} subject 
         * @param {string} text 
         * @param {Array<string>} [cc] 
         * @param {Array<string>} [bcc] 
         * @param {string} [replyToMessageId] 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailAccountMessage(teamId: number, agentId: number, to: Array<string>, subject: string, text: string, cc?: Array<string>, bcc?: Array<string>, replyToMessageId?: string, attachments?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailAccountRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailAccountMessage(teamId, agentId, to, subject, text, cc, bcc, replyToMessageId, attachments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailAccountApi.sendEmailAccountMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailAccountApi - factory interface
 */
export const EmailAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailAccountApiFp(configuration)
    return {
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {string} messageId 
         * @param {string} attachmentId 
         * @param {GetEmailAccountAttachmentDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailAccountAttachment(teamId: number, agentId: number, messageId: string, attachmentId: string, direction?: GetEmailAccountAttachmentDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getEmailAccountAttachment(teamId, agentId, messageId, attachmentId, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {string} messageId 
         * @param {GetEmailAccountMessageDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailAccountMessage(teamId: number, agentId: number, messageId: string, direction?: GetEmailAccountMessageDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<EmailAccountRecord> {
            return localVarFp.getEmailAccountMessage(teamId, agentId, messageId, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ListEmailAccountMessagesDirectionEnum} [direction] 
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {string} [afterId] 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailAccountMessages(teamId: number, agentId: number, direction?: ListEmailAccountMessagesDirectionEnum, before?: string, after?: string, afterId?: string, cursor?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<EmailAccountPage> {
            return localVarFp.listEmailAccountMessages(teamId, agentId, direction, before, after, afterId, cursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {Array<string>} to 
         * @param {string} subject 
         * @param {string} text 
         * @param {Array<string>} [cc] 
         * @param {Array<string>} [bcc] 
         * @param {string} [replyToMessageId] 
         * @param {Array<File>} [attachments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailAccountMessage(teamId: number, agentId: number, to: Array<string>, subject: string, text: string, cc?: Array<string>, bcc?: Array<string>, replyToMessageId?: string, attachments?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<EmailAccountRecord> {
            return localVarFp.sendEmailAccountMessage(teamId, agentId, to, subject, text, cc, bcc, replyToMessageId, attachments, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailAccountApi - object-oriented interface
 */
export class EmailAccountApi extends BaseAPI {
    /**
     * 
     * @param {number} teamId 
     * @param {number} agentId 
     * @param {string} messageId 
     * @param {string} attachmentId 
     * @param {GetEmailAccountAttachmentDirectionEnum} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmailAccountAttachment(teamId: number, agentId: number, messageId: string, attachmentId: string, direction?: GetEmailAccountAttachmentDirectionEnum, options?: RawAxiosRequestConfig) {
        return EmailAccountApiFp(this.configuration).getEmailAccountAttachment(teamId, agentId, messageId, attachmentId, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} teamId 
     * @param {number} agentId 
     * @param {string} messageId 
     * @param {GetEmailAccountMessageDirectionEnum} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmailAccountMessage(teamId: number, agentId: number, messageId: string, direction?: GetEmailAccountMessageDirectionEnum, options?: RawAxiosRequestConfig) {
        return EmailAccountApiFp(this.configuration).getEmailAccountMessage(teamId, agentId, messageId, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} teamId 
     * @param {number} agentId 
     * @param {ListEmailAccountMessagesDirectionEnum} [direction] 
     * @param {string} [before] 
     * @param {string} [after] 
     * @param {string} [afterId] 
     * @param {string} [cursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listEmailAccountMessages(teamId: number, agentId: number, direction?: ListEmailAccountMessagesDirectionEnum, before?: string, after?: string, afterId?: string, cursor?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return EmailAccountApiFp(this.configuration).listEmailAccountMessages(teamId, agentId, direction, before, after, afterId, cursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} teamId 
     * @param {number} agentId 
     * @param {Array<string>} to 
     * @param {string} subject 
     * @param {string} text 
     * @param {Array<string>} [cc] 
     * @param {Array<string>} [bcc] 
     * @param {string} [replyToMessageId] 
     * @param {Array<File>} [attachments] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendEmailAccountMessage(teamId: number, agentId: number, to: Array<string>, subject: string, text: string, cc?: Array<string>, bcc?: Array<string>, replyToMessageId?: string, attachments?: Array<File>, options?: RawAxiosRequestConfig) {
        return EmailAccountApiFp(this.configuration).sendEmailAccountMessage(teamId, agentId, to, subject, text, cc, bcc, replyToMessageId, attachments, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetEmailAccountAttachmentDirectionEnum = {
    Inbound: 'inbound',
    Outbound: 'outbound'
} as const;
export type GetEmailAccountAttachmentDirectionEnum = typeof GetEmailAccountAttachmentDirectionEnum[keyof typeof GetEmailAccountAttachmentDirectionEnum];
export const GetEmailAccountMessageDirectionEnum = {
    Inbound: 'inbound',
    Outbound: 'outbound'
} as const;
export type GetEmailAccountMessageDirectionEnum = typeof GetEmailAccountMessageDirectionEnum[keyof typeof GetEmailAccountMessageDirectionEnum];
export const ListEmailAccountMessagesDirectionEnum = {
    Inbound: 'inbound',
    Outbound: 'outbound'
} as const;
export type ListEmailAccountMessagesDirectionEnum = typeof ListEmailAccountMessagesDirectionEnum[keyof typeof ListEmailAccountMessagesDirectionEnum];


/**
 * ExternalWorkApi - axios parameter creator
 */
export const ExternalWorkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} cardId 
         * @param {ExternalWorkLaunchRequest} externalWorkLaunchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalWorkSession: async (cardId: number, externalWorkLaunchRequest: ExternalWorkLaunchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('createExternalWorkSession', 'cardId', cardId)
            // verify required parameter 'externalWorkLaunchRequest' is not null or undefined
            assertParamExists('createExternalWorkSession', 'externalWorkLaunchRequest', externalWorkLaunchRequest)
            const localVarPath = `/api/project-cards/{cardId}/external-work-sessions`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalWorkLaunchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalWorkSession: async (sessionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getExternalWorkSession', 'sessionId', sessionId)
            const localVarPath = `/api/external-work-sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExternalWorkSessionsForCard: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('listExternalWorkSessionsForCard', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/external-work-sessions`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ExternalWorkReasonRequest} [externalWorkReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseExternalWorkSession: async (sessionId: number, externalWorkReasonRequest?: ExternalWorkReasonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('pauseExternalWorkSession', 'sessionId', sessionId)
            const localVarPath = `/api/external-work-sessions/{sessionId}/pause`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalWorkReasonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeExternalWorkSession: async (sessionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('resumeExternalWorkSession', 'sessionId', sessionId)
            const localVarPath = `/api/external-work-sessions/{sessionId}/resume`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ExternalWorkReasonRequest} [externalWorkReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeExternalWorkSession: async (sessionId: number, externalWorkReasonRequest?: ExternalWorkReasonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('revokeExternalWorkSession', 'sessionId', sessionId)
            const localVarPath = `/api/external-work-sessions/{sessionId}/revoke`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalWorkReasonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {SendExternalWorkMessageRequest} sendExternalWorkMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendExternalWorkMessage: async (sessionId: number, sendExternalWorkMessageRequest: SendExternalWorkMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sendExternalWorkMessage', 'sessionId', sessionId)
            // verify required parameter 'sendExternalWorkMessageRequest' is not null or undefined
            assertParamExists('sendExternalWorkMessage', 'sendExternalWorkMessageRequest', sendExternalWorkMessageRequest)
            const localVarPath = `/api/external-work-sessions/{sessionId}/messages`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendExternalWorkMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalWorkApi - functional programming interface
 */
export const ExternalWorkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalWorkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} cardId 
         * @param {ExternalWorkLaunchRequest} externalWorkLaunchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExternalWorkSession(cardId: number, externalWorkLaunchRequest: ExternalWorkLaunchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalWorkLaunchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExternalWorkSession(cardId, externalWorkLaunchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalWorkApi.createExternalWorkSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalWorkSession(sessionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExternalWorkSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalWorkSession(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalWorkApi.getExternalWorkSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listExternalWorkSessionsForCard(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListExternalWorkSessionsForCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listExternalWorkSessionsForCard(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalWorkApi.listExternalWorkSessionsForCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ExternalWorkReasonRequest} [externalWorkReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseExternalWorkSession(sessionId: number, externalWorkReasonRequest?: ExternalWorkReasonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalWorkSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseExternalWorkSession(sessionId, externalWorkReasonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalWorkApi.pauseExternalWorkSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeExternalWorkSession(sessionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalWorkLaunchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeExternalWorkSession(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalWorkApi.resumeExternalWorkSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ExternalWorkReasonRequest} [externalWorkReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeExternalWorkSession(sessionId: number, externalWorkReasonRequest?: ExternalWorkReasonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalWorkSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeExternalWorkSession(sessionId, externalWorkReasonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalWorkApi.revokeExternalWorkSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {SendExternalWorkMessageRequest} sendExternalWorkMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendExternalWorkMessage(sessionId: number, sendExternalWorkMessageRequest: SendExternalWorkMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendExternalWorkMessage(sessionId, sendExternalWorkMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalWorkApi.sendExternalWorkMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalWorkApi - factory interface
 */
export const ExternalWorkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalWorkApiFp(configuration)
    return {
        /**
         * 
         * @param {number} cardId 
         * @param {ExternalWorkLaunchRequest} externalWorkLaunchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalWorkSession(cardId: number, externalWorkLaunchRequest: ExternalWorkLaunchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalWorkLaunchResponse> {
            return localVarFp.createExternalWorkSession(cardId, externalWorkLaunchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalWorkSession(sessionId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetExternalWorkSession200Response> {
            return localVarFp.getExternalWorkSession(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExternalWorkSessionsForCard(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<ListExternalWorkSessionsForCard200Response> {
            return localVarFp.listExternalWorkSessionsForCard(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ExternalWorkReasonRequest} [externalWorkReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseExternalWorkSession(sessionId: number, externalWorkReasonRequest?: ExternalWorkReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalWorkSessionResponse> {
            return localVarFp.pauseExternalWorkSession(sessionId, externalWorkReasonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeExternalWorkSession(sessionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExternalWorkLaunchResponse> {
            return localVarFp.resumeExternalWorkSession(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {ExternalWorkReasonRequest} [externalWorkReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeExternalWorkSession(sessionId: number, externalWorkReasonRequest?: ExternalWorkReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalWorkSessionResponse> {
            return localVarFp.revokeExternalWorkSession(sessionId, externalWorkReasonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {SendExternalWorkMessageRequest} sendExternalWorkMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendExternalWorkMessage(sessionId: number, sendExternalWorkMessageRequest: SendExternalWorkMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendExternalWorkMessage(sessionId, sendExternalWorkMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalWorkApi - object-oriented interface
 */
export class ExternalWorkApi extends BaseAPI {
    /**
     * 
     * @param {number} cardId 
     * @param {ExternalWorkLaunchRequest} externalWorkLaunchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createExternalWorkSession(cardId: number, externalWorkLaunchRequest: ExternalWorkLaunchRequest, options?: RawAxiosRequestConfig) {
        return ExternalWorkApiFp(this.configuration).createExternalWorkSession(cardId, externalWorkLaunchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getExternalWorkSession(sessionId: number, options?: RawAxiosRequestConfig) {
        return ExternalWorkApiFp(this.configuration).getExternalWorkSession(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listExternalWorkSessionsForCard(cardId: number, options?: RawAxiosRequestConfig) {
        return ExternalWorkApiFp(this.configuration).listExternalWorkSessionsForCard(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sessionId 
     * @param {ExternalWorkReasonRequest} [externalWorkReasonRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pauseExternalWorkSession(sessionId: number, externalWorkReasonRequest?: ExternalWorkReasonRequest, options?: RawAxiosRequestConfig) {
        return ExternalWorkApiFp(this.configuration).pauseExternalWorkSession(sessionId, externalWorkReasonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeExternalWorkSession(sessionId: number, options?: RawAxiosRequestConfig) {
        return ExternalWorkApiFp(this.configuration).resumeExternalWorkSession(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sessionId 
     * @param {ExternalWorkReasonRequest} [externalWorkReasonRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeExternalWorkSession(sessionId: number, externalWorkReasonRequest?: ExternalWorkReasonRequest, options?: RawAxiosRequestConfig) {
        return ExternalWorkApiFp(this.configuration).revokeExternalWorkSession(sessionId, externalWorkReasonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sessionId 
     * @param {SendExternalWorkMessageRequest} sendExternalWorkMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendExternalWorkMessage(sessionId: number, sendExternalWorkMessageRequest: SendExternalWorkMessageRequest, options?: RawAxiosRequestConfig) {
        return ExternalWorkApiFp(this.configuration).sendExternalWorkMessage(sessionId, sendExternalWorkMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GoogleDriveOAuthApi - axios parameter creator
 */
export const GoogleDriveOAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Handle Google Drive OAuth callback
         * @param {string} code The authorization code from Google
         * @param {string} state The state parameter returned by Google (should contain the original redirect URL)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGoogleDriveOAuthCallback: async (code: string, state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('handleGoogleDriveOAuthCallback', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('handleGoogleDriveOAuthCallback', 'state', state)
            const localVarPath = `/api/google-drive-oauth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initiate Google Drive OAuth flow
         * @param {InitiateGoogleDriveOAuthRequest} initiateGoogleDriveOAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateGoogleDriveOAuth: async (initiateGoogleDriveOAuthRequest: InitiateGoogleDriveOAuthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initiateGoogleDriveOAuthRequest' is not null or undefined
            assertParamExists('initiateGoogleDriveOAuth', 'initiateGoogleDriveOAuthRequest', initiateGoogleDriveOAuthRequest)
            const localVarPath = `/api/google-drive-oauth/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiateGoogleDriveOAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoogleDriveOAuthApi - functional programming interface
 */
export const GoogleDriveOAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoogleDriveOAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Handle Google Drive OAuth callback
         * @param {string} code The authorization code from Google
         * @param {string} state The state parameter returned by Google (should contain the original redirect URL)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleGoogleDriveOAuthCallback(code: string, state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleGoogleDriveOAuthCallback(code, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleDriveOAuthApi.handleGoogleDriveOAuthCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initiate Google Drive OAuth flow
         * @param {InitiateGoogleDriveOAuthRequest} initiateGoogleDriveOAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateGoogleDriveOAuth(initiateGoogleDriveOAuthRequest: InitiateGoogleDriveOAuthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitiateGoogleDriveOAuth200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateGoogleDriveOAuth(initiateGoogleDriveOAuthRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoogleDriveOAuthApi.initiateGoogleDriveOAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GoogleDriveOAuthApi - factory interface
 */
export const GoogleDriveOAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoogleDriveOAuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Handle Google Drive OAuth callback
         * @param {string} code The authorization code from Google
         * @param {string} state The state parameter returned by Google (should contain the original redirect URL)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleGoogleDriveOAuthCallback(code: string, state: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleGoogleDriveOAuthCallback(code, state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initiate Google Drive OAuth flow
         * @param {InitiateGoogleDriveOAuthRequest} initiateGoogleDriveOAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateGoogleDriveOAuth(initiateGoogleDriveOAuthRequest: InitiateGoogleDriveOAuthRequest, options?: RawAxiosRequestConfig): AxiosPromise<InitiateGoogleDriveOAuth200Response> {
            return localVarFp.initiateGoogleDriveOAuth(initiateGoogleDriveOAuthRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoogleDriveOAuthApi - object-oriented interface
 */
export class GoogleDriveOAuthApi extends BaseAPI {
    /**
     * 
     * @summary Handle Google Drive OAuth callback
     * @param {string} code The authorization code from Google
     * @param {string} state The state parameter returned by Google (should contain the original redirect URL)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public handleGoogleDriveOAuthCallback(code: string, state: string, options?: RawAxiosRequestConfig) {
        return GoogleDriveOAuthApiFp(this.configuration).handleGoogleDriveOAuthCallback(code, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initiate Google Drive OAuth flow
     * @param {InitiateGoogleDriveOAuthRequest} initiateGoogleDriveOAuthRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initiateGoogleDriveOAuth(initiateGoogleDriveOAuthRequest: InitiateGoogleDriveOAuthRequest, options?: RawAxiosRequestConfig) {
        return GoogleDriveOAuthApiFp(this.configuration).initiateGoogleDriveOAuth(initiateGoogleDriveOAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check service health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check service health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiHealthGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiHealthGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.apiHealthGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary Check service health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiHealthGet200Response> {
            return localVarFp.apiHealthGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary Check service health status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiHealthGet(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).apiHealthGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IndividualMessageTestingApi - axios parameter creator
 */
export const IndividualMessageTestingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all test results for a specific message
         * @summary Get test results for an individual message
         * @param {number} messageId ID of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDataMessageIdTestResultsGet: async (messageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiTestDataMessageIdTestResultsGet', 'messageId', messageId)
            const localVarPath = `/api/test-data/{messageId}/test-results`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Execute test iterations for a specific message with POI evaluation
         * @summary Start test for an individual message
         * @param {number} messageId ID of the message to test
         * @param {MessageTestStartRequest} [messageTestStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDataMessageIdTestStartPost: async (messageId: number, messageTestStartRequest?: MessageTestStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiTestDataMessageIdTestStartPost', 'messageId', messageId)
            const localVarPath = `/api/test-data/{messageId}/test/start`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageTestStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndividualMessageTestingApi - functional programming interface
 */
export const IndividualMessageTestingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IndividualMessageTestingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all test results for a specific message
         * @summary Get test results for an individual message
         * @param {number} messageId ID of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestDataMessageIdTestResultsGet(messageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TestResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestDataMessageIdTestResultsGet(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualMessageTestingApi.apiTestDataMessageIdTestResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Execute test iterations for a specific message with POI evaluation
         * @summary Start test for an individual message
         * @param {number} messageId ID of the message to test
         * @param {MessageTestStartRequest} [messageTestStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestDataMessageIdTestStartPost(messageId: number, messageTestStartRequest?: MessageTestStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageTestStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestDataMessageIdTestStartPost(messageId, messageTestStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualMessageTestingApi.apiTestDataMessageIdTestStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IndividualMessageTestingApi - factory interface
 */
export const IndividualMessageTestingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IndividualMessageTestingApiFp(configuration)
    return {
        /**
         * Retrieve all test results for a specific message
         * @summary Get test results for an individual message
         * @param {number} messageId ID of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDataMessageIdTestResultsGet(messageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TestResult>> {
            return localVarFp.apiTestDataMessageIdTestResultsGet(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute test iterations for a specific message with POI evaluation
         * @summary Start test for an individual message
         * @param {number} messageId ID of the message to test
         * @param {MessageTestStartRequest} [messageTestStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDataMessageIdTestStartPost(messageId: number, messageTestStartRequest?: MessageTestStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageTestStartResponse> {
            return localVarFp.apiTestDataMessageIdTestStartPost(messageId, messageTestStartRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IndividualMessageTestingApi - object-oriented interface
 */
export class IndividualMessageTestingApi extends BaseAPI {
    /**
     * Retrieve all test results for a specific message
     * @summary Get test results for an individual message
     * @param {number} messageId ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTestDataMessageIdTestResultsGet(messageId: number, options?: RawAxiosRequestConfig) {
        return IndividualMessageTestingApiFp(this.configuration).apiTestDataMessageIdTestResultsGet(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Execute test iterations for a specific message with POI evaluation
     * @summary Start test for an individual message
     * @param {number} messageId ID of the message to test
     * @param {MessageTestStartRequest} [messageTestStartRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTestDataMessageIdTestStartPost(messageId: number, messageTestStartRequest?: MessageTestStartRequest, options?: RawAxiosRequestConfig) {
        return IndividualMessageTestingApiFp(this.configuration).apiTestDataMessageIdTestStartPost(messageId, messageTestStartRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvitesApi - axios parameter creator
 */
export const InvitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current user\'s pending team invites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvitesMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/invites/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdAcceptInvitePostRequest} apiTeamsTeamIdAcceptInvitePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdAcceptInvitePost: async (teamId: number, apiTeamsTeamIdAcceptInvitePostRequest: ApiTeamsTeamIdAcceptInvitePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdAcceptInvitePost', 'teamId', teamId)
            // verify required parameter 'apiTeamsTeamIdAcceptInvitePostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdAcceptInvitePost', 'apiTeamsTeamIdAcceptInvitePostRequest', apiTeamsTeamIdAcceptInvitePostRequest)
            const localVarPath = `/api/teams/{teamId}/accept-invite`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdAcceptInvitePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a team invitation
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesEmailAddressDelete: async (teamId: number, emailAddress: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressDelete', 'teamId', teamId)
            // verify required parameter 'emailAddress' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressDelete', 'emailAddress', emailAddress)
            const localVarPath = `/api/teams/{teamId}/invites/{emailAddress}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"emailAddress"}}`, encodeURIComponent(String(emailAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the invite\'s role outright — this is not a merge, because merging a team-scoped builtinRole onto a leftover project scope would authorize one thing and store another. Gated at exactly the level that CREATES an invite (team_member:edit): an invite whose role can be rewritten more cheaply than it was set is an invite whose role was never really fixed. Invites have no status column — acceptance and cancellation both delete the row — so a missing row is disambiguated by asking whether the address is now a member: 409 if accepted, 404 if cancelled or never existed.
         * @summary Change the role a pending invitation will confer
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {InviteRoleInput} inviteRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesEmailAddressRolePut: async (teamId: number, emailAddress: string, inviteRoleInput: InviteRoleInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressRolePut', 'teamId', teamId)
            // verify required parameter 'emailAddress' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressRolePut', 'emailAddress', emailAddress)
            // verify required parameter 'inviteRoleInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressRolePut', 'inviteRoleInput', inviteRoleInput)
            const localVarPath = `/api/teams/{teamId}/invites/{emailAddress}/role`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"emailAddress"}}`, encodeURIComponent(String(emailAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteRoleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get team invitations
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/invites`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdInvitesPostRequest} apiTeamsTeamIdInvitesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesPost: async (teamId: number, apiTeamsTeamIdInvitesPostRequest: ApiTeamsTeamIdInvitesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesPost', 'teamId', teamId)
            // verify required parameter 'apiTeamsTeamIdInvitesPostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesPost', 'apiTeamsTeamIdInvitesPostRequest', apiTeamsTeamIdInvitesPostRequest)
            const localVarPath = `/api/teams/{teamId}/invites`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdInvitesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject a team invitation
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRejectInvitePost: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRejectInvitePost', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/reject-invite`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvitesApi - functional programming interface
 */
export const InvitesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvitesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current user\'s pending team invites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiInvitesMeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiInvitesMeGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiInvitesMeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiInvitesMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdAcceptInvitePostRequest} apiTeamsTeamIdAcceptInvitePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdAcceptInvitePost(teamId: number, apiTeamsTeamIdAcceptInvitePostRequest: ApiTeamsTeamIdAcceptInvitePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdAcceptInvitePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdAcceptInvitePost(teamId, apiTeamsTeamIdAcceptInvitePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiTeamsTeamIdAcceptInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a team invitation
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdInvitesEmailAddressDelete(teamId: number, emailAddress: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdInvitesEmailAddressDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdInvitesEmailAddressDelete(teamId, emailAddress, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiTeamsTeamIdInvitesEmailAddressDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the invite\'s role outright — this is not a merge, because merging a team-scoped builtinRole onto a leftover project scope would authorize one thing and store another. Gated at exactly the level that CREATES an invite (team_member:edit): an invite whose role can be rewritten more cheaply than it was set is an invite whose role was never really fixed. Invites have no status column — acceptance and cancellation both delete the row — so a missing row is disambiguated by asking whether the address is now a member: 409 if accepted, 404 if cancelled or never existed.
         * @summary Change the role a pending invitation will confer
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {InviteRoleInput} inviteRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdInvitesEmailAddressRolePut(teamId: number, emailAddress: string, inviteRoleInput: InviteRoleInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdInvitesEmailAddressRolePut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdInvitesEmailAddressRolePut(teamId, emailAddress, inviteRoleInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiTeamsTeamIdInvitesEmailAddressRolePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get team invitations
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdInvitesGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTeamsTeamIdInvitesGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdInvitesGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiTeamsTeamIdInvitesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdInvitesPostRequest} apiTeamsTeamIdInvitesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdInvitesPost(teamId: number, apiTeamsTeamIdInvitesPostRequest: ApiTeamsTeamIdInvitesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdInvitesPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdInvitesPost(teamId, apiTeamsTeamIdInvitesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiTeamsTeamIdInvitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject a team invitation
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRejectInvitePost(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdRejectInvitePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRejectInvitePost(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.apiTeamsTeamIdRejectInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvitesApi - factory interface
 */
export const InvitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvitesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current user\'s pending team invites
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiInvitesMeGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiInvitesMeGet200ResponseInner>> {
            return localVarFp.apiInvitesMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdAcceptInvitePostRequest} apiTeamsTeamIdAcceptInvitePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdAcceptInvitePost(teamId: number, apiTeamsTeamIdAcceptInvitePostRequest: ApiTeamsTeamIdAcceptInvitePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdAcceptInvitePost200Response> {
            return localVarFp.apiTeamsTeamIdAcceptInvitePost(teamId, apiTeamsTeamIdAcceptInvitePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a team invitation
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesEmailAddressDelete(teamId: number, emailAddress: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdInvitesEmailAddressDelete200Response> {
            return localVarFp.apiTeamsTeamIdInvitesEmailAddressDelete(teamId, emailAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the invite\'s role outright — this is not a merge, because merging a team-scoped builtinRole onto a leftover project scope would authorize one thing and store another. Gated at exactly the level that CREATES an invite (team_member:edit): an invite whose role can be rewritten more cheaply than it was set is an invite whose role was never really fixed. Invites have no status column — acceptance and cancellation both delete the row — so a missing row is disambiguated by asking whether the address is now a member: 409 if accepted, 404 if cancelled or never existed.
         * @summary Change the role a pending invitation will confer
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {InviteRoleInput} inviteRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesEmailAddressRolePut(teamId: number, emailAddress: string, inviteRoleInput: InviteRoleInput, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdInvitesEmailAddressRolePut200Response> {
            return localVarFp.apiTeamsTeamIdInvitesEmailAddressRolePut(teamId, emailAddress, inviteRoleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get team invitations
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTeamsTeamIdInvitesGet200ResponseInner>> {
            return localVarFp.apiTeamsTeamIdInvitesGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdInvitesPostRequest} apiTeamsTeamIdInvitesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesPost(teamId: number, apiTeamsTeamIdInvitesPostRequest: ApiTeamsTeamIdInvitesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdInvitesPost201Response> {
            return localVarFp.apiTeamsTeamIdInvitesPost(teamId, apiTeamsTeamIdInvitesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject a team invitation
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRejectInvitePost(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdRejectInvitePost200Response> {
            return localVarFp.apiTeamsTeamIdRejectInvitePost(teamId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvitesApi - object-oriented interface
 */
export class InvitesApi extends BaseAPI {
    /**
     * 
     * @summary Get current user\'s pending team invites
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiInvitesMeGet(options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiInvitesMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept a team invitation
     * @param {number} teamId ID of the team
     * @param {ApiTeamsTeamIdAcceptInvitePostRequest} apiTeamsTeamIdAcceptInvitePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdAcceptInvitePost(teamId: number, apiTeamsTeamIdAcceptInvitePostRequest: ApiTeamsTeamIdAcceptInvitePostRequest, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiTeamsTeamIdAcceptInvitePost(teamId, apiTeamsTeamIdAcceptInvitePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a team invitation
     * @param {number} teamId ID of the team
     * @param {string} emailAddress Email address of the invited user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdInvitesEmailAddressDelete(teamId: number, emailAddress: string, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiTeamsTeamIdInvitesEmailAddressDelete(teamId, emailAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the invite\'s role outright — this is not a merge, because merging a team-scoped builtinRole onto a leftover project scope would authorize one thing and store another. Gated at exactly the level that CREATES an invite (team_member:edit): an invite whose role can be rewritten more cheaply than it was set is an invite whose role was never really fixed. Invites have no status column — acceptance and cancellation both delete the row — so a missing row is disambiguated by asking whether the address is now a member: 409 if accepted, 404 if cancelled or never existed.
     * @summary Change the role a pending invitation will confer
     * @param {number} teamId ID of the team
     * @param {string} emailAddress Email address of the invited user
     * @param {InviteRoleInput} inviteRoleInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdInvitesEmailAddressRolePut(teamId: number, emailAddress: string, inviteRoleInput: InviteRoleInput, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiTeamsTeamIdInvitesEmailAddressRolePut(teamId, emailAddress, inviteRoleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get team invitations
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdInvitesGet(teamId: number, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiTeamsTeamIdInvitesGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a team invitation
     * @param {number} teamId ID of the team
     * @param {ApiTeamsTeamIdInvitesPostRequest} apiTeamsTeamIdInvitesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdInvitesPost(teamId: number, apiTeamsTeamIdInvitesPostRequest: ApiTeamsTeamIdInvitesPostRequest, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiTeamsTeamIdInvitesPost(teamId, apiTeamsTeamIdInvitesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject a team invitation
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRejectInvitePost(teamId: number, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).apiTeamsTeamIdRejectInvitePost(teamId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobsApi - axios parameter creator
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get active and recent jobs for the current user
         * @param {number} [limit] Maximum number of jobs to return (default 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJobsActiveGet: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/jobs/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a job
         * @param {number} jobId ID of the job to cancel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJobsJobIdCancelPost: async (jobId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiJobsJobIdCancelPost', 'jobId', jobId)
            const localVarPath = `/api/jobs/{jobId}/cancel`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get job by ID
         * @param {string} jobId ID of the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJobsJobIdGet: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiJobsJobIdGet', 'jobId', jobId)
            const localVarPath = `/api/jobs/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get active and recent jobs for the current user
         * @param {number} [limit] Maximum number of jobs to return (default 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiJobsActiveGet(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiJobsActiveGet(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.apiJobsActiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel a job
         * @param {number} jobId ID of the job to cancel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiJobsJobIdCancelPost(jobId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiJobsJobIdCancelPost(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.apiJobsJobIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get job by ID
         * @param {string} jobId ID of the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiJobsJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.apiJobsJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobsApi - factory interface
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get active and recent jobs for the current user
         * @param {number} [limit] Maximum number of jobs to return (default 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJobsActiveGet(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<JobsResponse> {
            return localVarFp.apiJobsActiveGet(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a job
         * @param {number} jobId ID of the job to cancel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJobsJobIdCancelPost(jobId: number, options?: RawAxiosRequestConfig): AxiosPromise<CancelJobResponse> {
            return localVarFp.apiJobsJobIdCancelPost(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get job by ID
         * @param {string} jobId ID of the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<JobResponse> {
            return localVarFp.apiJobsJobIdGet(jobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @summary Get active and recent jobs for the current user
     * @param {number} [limit] Maximum number of jobs to return (default 10)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiJobsActiveGet(limit?: number, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).apiJobsActiveGet(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a job
     * @param {number} jobId ID of the job to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiJobsJobIdCancelPost(jobId: number, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).apiJobsJobIdCancelPost(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get job by ID
     * @param {string} jobId ID of the job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiJobsJobIdGet(jobId: string, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).apiJobsJobIdGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KnowledgeApi - axios parameter creator
 */
export const KnowledgeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Summarize a specific document
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} documentId ID of the document to summarize
         * @param {ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest} apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost: async (teamId: number, agentId: number, documentId: number, apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest: ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost', 'agentId', agentId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost', 'documentId', documentId)
            // verify required parameter 'apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost', 'apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest', apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/knowledge/document/{documentId}/summarize`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for relevant vectors without summarization
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {KnowledgeSearchRequest} knowledgeSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdKnowledgeSearchPost: async (teamId: number, agentId: number, knowledgeSearchRequest: KnowledgeSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeSearchPost', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeSearchPost', 'agentId', agentId)
            // verify required parameter 'knowledgeSearchRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeSearchPost', 'knowledgeSearchRequest', knowledgeSearchRequest)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/knowledge/search`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KnowledgeApi - functional programming interface
 */
export const KnowledgeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KnowledgeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Summarize a specific document
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} documentId ID of the document to summarize
         * @param {ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest} apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost(teamId: number, agentId: number, documentId: number, apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest: ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost(teamId, agentId, documentId, apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeApi.apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for relevant vectors without summarization
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {KnowledgeSearchRequest} knowledgeSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdKnowledgeSearchPost(teamId: number, agentId: number, knowledgeSearchRequest: KnowledgeSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdAgentAgentIdKnowledgeSearchPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdKnowledgeSearchPost(teamId, agentId, knowledgeSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeApi.apiTeamTeamIdAgentAgentIdKnowledgeSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KnowledgeApi - factory interface
 */
export const KnowledgeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KnowledgeApiFp(configuration)
    return {
        /**
         * 
         * @summary Summarize a specific document
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} documentId ID of the document to summarize
         * @param {ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest} apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost(teamId: number, agentId: number, documentId: number, apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest: ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost200Response> {
            return localVarFp.apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost(teamId, agentId, documentId, apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for relevant vectors without summarization
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {KnowledgeSearchRequest} knowledgeSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdKnowledgeSearchPost(teamId: number, agentId: number, knowledgeSearchRequest: KnowledgeSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdAgentAgentIdKnowledgeSearchPost200Response> {
            return localVarFp.apiTeamTeamIdAgentAgentIdKnowledgeSearchPost(teamId, agentId, knowledgeSearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KnowledgeApi - object-oriented interface
 */
export class KnowledgeApi extends BaseAPI {
    /**
     * 
     * @summary Summarize a specific document
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} documentId ID of the document to summarize
     * @param {ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest} apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost(teamId: number, agentId: number, documentId: number, apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest: ApiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeApiFp(this.configuration).apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePost(teamId, agentId, documentId, apiTeamTeamIdAgentAgentIdKnowledgeDocumentDocumentIdSummarizePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for relevant vectors without summarization
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {KnowledgeSearchRequest} knowledgeSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdKnowledgeSearchPost(teamId: number, agentId: number, knowledgeSearchRequest: KnowledgeSearchRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeApiFp(this.configuration).apiTeamTeamIdAgentAgentIdKnowledgeSearchPost(teamId, agentId, knowledgeSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KnowledgeGraphApi - axios parameter creator
 */
export const KnowledgeGraphApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add an edge to the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {AddKnowledgeGraphEdgeRequest} addKnowledgeGraphEdgeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnowledgeGraphEdge: async (agentId: number, addKnowledgeGraphEdgeRequest: AddKnowledgeGraphEdgeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addKnowledgeGraphEdge', 'agentId', agentId)
            // verify required parameter 'addKnowledgeGraphEdgeRequest' is not null or undefined
            assertParamExists('addKnowledgeGraphEdge', 'addKnowledgeGraphEdgeRequest', addKnowledgeGraphEdgeRequest)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph/edges`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addKnowledgeGraphEdgeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a node to the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {AddKnowledgeGraphNodeRequest} addKnowledgeGraphNodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnowledgeGraphNode: async (agentId: number, addKnowledgeGraphNodeRequest: AddKnowledgeGraphNodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addKnowledgeGraphNode', 'agentId', agentId)
            // verify required parameter 'addKnowledgeGraphNodeRequest' is not null or undefined
            assertParamExists('addKnowledgeGraphNode', 'addKnowledgeGraphNodeRequest', addKnowledgeGraphNodeRequest)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph/nodes`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addKnowledgeGraphNodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the knowledge graph using GQL
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {KnowledgeGraphQueryRequest} knowledgeGraphQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost: async (teamId: number, agentId: number, knowledgeGraphQueryRequest: KnowledgeGraphQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost', 'agentId', agentId)
            // verify required parameter 'knowledgeGraphQueryRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost', 'knowledgeGraphQueryRequest', knowledgeGraphQueryRequest)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/knowledge/graph/query`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(knowledgeGraphQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an edge from the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {number} edgeId ID of the edge to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnowledgeGraphEdge: async (agentId: number, edgeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteKnowledgeGraphEdge', 'agentId', agentId)
            // verify required parameter 'edgeId' is not null or undefined
            assertParamExists('deleteKnowledgeGraphEdge', 'edgeId', edgeId)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph/edges/{edgeId}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"edgeId"}}`, encodeURIComponent(String(edgeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a node from the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {number} nodeId ID of the node to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnowledgeGraphNode: async (agentId: number, nodeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteKnowledgeGraphNode', 'agentId', agentId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('deleteKnowledgeGraphNode', 'nodeId', nodeId)
            const localVarPath = `/api/v1/knowledge-graph/nodes/{nodeId}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get knowledge graph nodes and edges for an agent
         * @param {number} agentId ID of the agent
         * @param {Array<number>} [sourceIds] Optional array of source IDs to filter by
         * @param {string} [nodeTypeName] Optional node type name to filter nodes by
         * @param {string} [edgeTypeName] Optional edge type name to filter edges by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraph: async (agentId: number, sourceIds?: Array<number>, nodeTypeName?: string, edgeTypeName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getKnowledgeGraph', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (sourceIds) {
                localVarQueryParameter['sourceIds'] = sourceIds;
            }

            if (nodeTypeName !== undefined) {
                localVarQueryParameter['nodeTypeName'] = nodeTypeName;
            }

            if (edgeTypeName !== undefined) {
                localVarQueryParameter['edgeTypeName'] = edgeTypeName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get knowledge graph edges for an agent
         * @param {number} agentId ID of the agent
         * @param {string} [edgeTypeName] Optional edge type name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraphEdges: async (agentId: number, edgeTypeName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getKnowledgeGraphEdges', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph/edges`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (edgeTypeName !== undefined) {
                localVarQueryParameter['edgeTypeName'] = edgeTypeName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific node from the knowledge graph
         * @param {number} nodeId ID of the node to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraphNode: async (nodeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('getKnowledgeGraphNode', 'nodeId', nodeId)
            const localVarPath = `/api/v1/knowledge-graph/nodes/{nodeId}`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get knowledge graph nodes for an agent
         * @param {number} agentId ID of the agent
         * @param {string} [nodeTypeName] Optional node type name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraphNodes: async (agentId: number, nodeTypeName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getKnowledgeGraphNodes', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph/nodes`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (nodeTypeName !== undefined) {
                localVarQueryParameter['nodeTypeName'] = nodeTypeName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the enabled status of a node
         * @param {number} nodeId ID of the node to update
         * @param {UpdateKnowledgeGraphNodeEnabledRequest} updateKnowledgeGraphNodeEnabledRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeGraphNodeEnabled: async (nodeId: number, updateKnowledgeGraphNodeEnabledRequest: UpdateKnowledgeGraphNodeEnabledRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('updateKnowledgeGraphNodeEnabled', 'nodeId', nodeId)
            // verify required parameter 'updateKnowledgeGraphNodeEnabledRequest' is not null or undefined
            assertParamExists('updateKnowledgeGraphNodeEnabled', 'updateKnowledgeGraphNodeEnabledRequest', updateKnowledgeGraphNodeEnabledRequest)
            const localVarPath = `/api/v1/knowledge-graph/nodes/{nodeId}/enabled`
                .replace(`{${"nodeId"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKnowledgeGraphNodeEnabledRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KnowledgeGraphApi - functional programming interface
 */
export const KnowledgeGraphApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KnowledgeGraphApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add an edge to the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {AddKnowledgeGraphEdgeRequest} addKnowledgeGraphEdgeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addKnowledgeGraphEdge(agentId: number, addKnowledgeGraphEdgeRequest: AddKnowledgeGraphEdgeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EdgeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addKnowledgeGraphEdge(agentId, addKnowledgeGraphEdgeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.addKnowledgeGraphEdge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a node to the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {AddKnowledgeGraphNodeRequest} addKnowledgeGraphNodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addKnowledgeGraphNode(agentId: number, addKnowledgeGraphNodeRequest: AddKnowledgeGraphNodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addKnowledgeGraphNode(agentId, addKnowledgeGraphNodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.addKnowledgeGraphNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query the knowledge graph using GQL
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {KnowledgeGraphQueryRequest} knowledgeGraphQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost(teamId: number, agentId: number, knowledgeGraphQueryRequest: KnowledgeGraphQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeGraphQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost(teamId, agentId, knowledgeGraphQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an edge from the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {number} edgeId ID of the edge to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteKnowledgeGraphEdge(agentId: number, edgeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteKnowledgeGraphEdge200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteKnowledgeGraphEdge(agentId, edgeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.deleteKnowledgeGraphEdge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a node from the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {number} nodeId ID of the node to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteKnowledgeGraphNode(agentId: number, nodeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteKnowledgeGraphNode200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteKnowledgeGraphNode(agentId, nodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.deleteKnowledgeGraphNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get knowledge graph nodes and edges for an agent
         * @param {number} agentId ID of the agent
         * @param {Array<number>} [sourceIds] Optional array of source IDs to filter by
         * @param {string} [nodeTypeName] Optional node type name to filter nodes by
         * @param {string} [edgeTypeName] Optional edge type name to filter edges by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeGraph(agentId: number, sourceIds?: Array<number>, nodeTypeName?: string, edgeTypeName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetKnowledgeGraph200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeGraph(agentId, sourceIds, nodeTypeName, edgeTypeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.getKnowledgeGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get knowledge graph edges for an agent
         * @param {number} agentId ID of the agent
         * @param {string} [edgeTypeName] Optional edge type name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeGraphEdges(agentId: number, edgeTypeName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EdgeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeGraphEdges(agentId, edgeTypeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.getKnowledgeGraphEdges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific node from the knowledge graph
         * @param {number} nodeId ID of the node to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeGraphNode(nodeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeGraphNode(nodeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.getKnowledgeGraphNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get knowledge graph nodes for an agent
         * @param {number} agentId ID of the agent
         * @param {string} [nodeTypeName] Optional node type name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeGraphNodes(agentId: number, nodeTypeName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NodeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeGraphNodes(agentId, nodeTypeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.getKnowledgeGraphNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the enabled status of a node
         * @param {number} nodeId ID of the node to update
         * @param {UpdateKnowledgeGraphNodeEnabledRequest} updateKnowledgeGraphNodeEnabledRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKnowledgeGraphNodeEnabled(nodeId: number, updateKnowledgeGraphNodeEnabledRequest: UpdateKnowledgeGraphNodeEnabledRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateKnowledgeGraphNodeEnabled200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKnowledgeGraphNodeEnabled(nodeId, updateKnowledgeGraphNodeEnabledRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphApi.updateKnowledgeGraphNodeEnabled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KnowledgeGraphApi - factory interface
 */
export const KnowledgeGraphApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KnowledgeGraphApiFp(configuration)
    return {
        /**
         * 
         * @summary Add an edge to the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {AddKnowledgeGraphEdgeRequest} addKnowledgeGraphEdgeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnowledgeGraphEdge(agentId: number, addKnowledgeGraphEdgeRequest: AddKnowledgeGraphEdgeRequest, options?: RawAxiosRequestConfig): AxiosPromise<EdgeResponse> {
            return localVarFp.addKnowledgeGraphEdge(agentId, addKnowledgeGraphEdgeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a node to the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {AddKnowledgeGraphNodeRequest} addKnowledgeGraphNodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnowledgeGraphNode(agentId: number, addKnowledgeGraphNodeRequest: AddKnowledgeGraphNodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeResponse> {
            return localVarFp.addKnowledgeGraphNode(agentId, addKnowledgeGraphNodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the knowledge graph using GQL
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {KnowledgeGraphQueryRequest} knowledgeGraphQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost(teamId: number, agentId: number, knowledgeGraphQueryRequest: KnowledgeGraphQueryRequest, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeGraphQueryResponse> {
            return localVarFp.apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost(teamId, agentId, knowledgeGraphQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an edge from the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {number} edgeId ID of the edge to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnowledgeGraphEdge(agentId: number, edgeId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteKnowledgeGraphEdge200Response> {
            return localVarFp.deleteKnowledgeGraphEdge(agentId, edgeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a node from the knowledge graph
         * @param {number} agentId ID of the agent
         * @param {number} nodeId ID of the node to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteKnowledgeGraphNode(agentId: number, nodeId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteKnowledgeGraphNode200Response> {
            return localVarFp.deleteKnowledgeGraphNode(agentId, nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get knowledge graph nodes and edges for an agent
         * @param {number} agentId ID of the agent
         * @param {Array<number>} [sourceIds] Optional array of source IDs to filter by
         * @param {string} [nodeTypeName] Optional node type name to filter nodes by
         * @param {string} [edgeTypeName] Optional edge type name to filter edges by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraph(agentId: number, sourceIds?: Array<number>, nodeTypeName?: string, edgeTypeName?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetKnowledgeGraph200Response> {
            return localVarFp.getKnowledgeGraph(agentId, sourceIds, nodeTypeName, edgeTypeName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get knowledge graph edges for an agent
         * @param {number} agentId ID of the agent
         * @param {string} [edgeTypeName] Optional edge type name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraphEdges(agentId: number, edgeTypeName?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EdgeResponse>> {
            return localVarFp.getKnowledgeGraphEdges(agentId, edgeTypeName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific node from the knowledge graph
         * @param {number} nodeId ID of the node to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraphNode(nodeId: number, options?: RawAxiosRequestConfig): AxiosPromise<NodeResponse> {
            return localVarFp.getKnowledgeGraphNode(nodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get knowledge graph nodes for an agent
         * @param {number} agentId ID of the agent
         * @param {string} [nodeTypeName] Optional node type name to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraphNodes(agentId: number, nodeTypeName?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NodeResponse>> {
            return localVarFp.getKnowledgeGraphNodes(agentId, nodeTypeName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the enabled status of a node
         * @param {number} nodeId ID of the node to update
         * @param {UpdateKnowledgeGraphNodeEnabledRequest} updateKnowledgeGraphNodeEnabledRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeGraphNodeEnabled(nodeId: number, updateKnowledgeGraphNodeEnabledRequest: UpdateKnowledgeGraphNodeEnabledRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateKnowledgeGraphNodeEnabled200Response> {
            return localVarFp.updateKnowledgeGraphNodeEnabled(nodeId, updateKnowledgeGraphNodeEnabledRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KnowledgeGraphApi - object-oriented interface
 */
export class KnowledgeGraphApi extends BaseAPI {
    /**
     * 
     * @summary Add an edge to the knowledge graph
     * @param {number} agentId ID of the agent
     * @param {AddKnowledgeGraphEdgeRequest} addKnowledgeGraphEdgeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addKnowledgeGraphEdge(agentId: number, addKnowledgeGraphEdgeRequest: AddKnowledgeGraphEdgeRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).addKnowledgeGraphEdge(agentId, addKnowledgeGraphEdgeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a node to the knowledge graph
     * @param {number} agentId ID of the agent
     * @param {AddKnowledgeGraphNodeRequest} addKnowledgeGraphNodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addKnowledgeGraphNode(agentId: number, addKnowledgeGraphNodeRequest: AddKnowledgeGraphNodeRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).addKnowledgeGraphNode(agentId, addKnowledgeGraphNodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the knowledge graph using GQL
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {KnowledgeGraphQueryRequest} knowledgeGraphQueryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost(teamId: number, agentId: number, knowledgeGraphQueryRequest: KnowledgeGraphQueryRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).apiTeamTeamIdAgentAgentIdKnowledgeGraphQueryPost(teamId, agentId, knowledgeGraphQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an edge from the knowledge graph
     * @param {number} agentId ID of the agent
     * @param {number} edgeId ID of the edge to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteKnowledgeGraphEdge(agentId: number, edgeId: number, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).deleteKnowledgeGraphEdge(agentId, edgeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a node from the knowledge graph
     * @param {number} agentId ID of the agent
     * @param {number} nodeId ID of the node to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteKnowledgeGraphNode(agentId: number, nodeId: number, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).deleteKnowledgeGraphNode(agentId, nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get knowledge graph nodes and edges for an agent
     * @param {number} agentId ID of the agent
     * @param {Array<number>} [sourceIds] Optional array of source IDs to filter by
     * @param {string} [nodeTypeName] Optional node type name to filter nodes by
     * @param {string} [edgeTypeName] Optional edge type name to filter edges by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getKnowledgeGraph(agentId: number, sourceIds?: Array<number>, nodeTypeName?: string, edgeTypeName?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).getKnowledgeGraph(agentId, sourceIds, nodeTypeName, edgeTypeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get knowledge graph edges for an agent
     * @param {number} agentId ID of the agent
     * @param {string} [edgeTypeName] Optional edge type name to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getKnowledgeGraphEdges(agentId: number, edgeTypeName?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).getKnowledgeGraphEdges(agentId, edgeTypeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific node from the knowledge graph
     * @param {number} nodeId ID of the node to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getKnowledgeGraphNode(nodeId: number, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).getKnowledgeGraphNode(nodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get knowledge graph nodes for an agent
     * @param {number} agentId ID of the agent
     * @param {string} [nodeTypeName] Optional node type name to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getKnowledgeGraphNodes(agentId: number, nodeTypeName?: string, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).getKnowledgeGraphNodes(agentId, nodeTypeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the enabled status of a node
     * @param {number} nodeId ID of the node to update
     * @param {UpdateKnowledgeGraphNodeEnabledRequest} updateKnowledgeGraphNodeEnabledRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateKnowledgeGraphNodeEnabled(nodeId: number, updateKnowledgeGraphNodeEnabledRequest: UpdateKnowledgeGraphNodeEnabledRequest, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphApiFp(this.configuration).updateKnowledgeGraphNodeEnabled(nodeId, updateKnowledgeGraphNodeEnabledRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KnowledgeGraphTypesApi - axios parameter creator
 */
export const KnowledgeGraphTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get knowledge graph types as YAML for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraphTypesYaml: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getKnowledgeGraphTypesYaml', 'agentId', agentId)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph/types/yaml`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update knowledge graph types from YAML for an agent
         * @param {number} agentId ID of the agent
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeGraphTypesYaml: async (agentId: number, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateKnowledgeGraphTypesYaml', 'agentId', agentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateKnowledgeGraphTypesYaml', 'body', body)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph/types/yaml`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/yaml';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate knowledge graph types YAML and return change analysis
         * @param {number} agentId ID of the agent
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateKnowledgeGraphTypesYaml: async (agentId: number, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('validateKnowledgeGraphTypesYaml', 'agentId', agentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('validateKnowledgeGraphTypesYaml', 'body', body)
            const localVarPath = `/api/v1/agents/{agentId}/knowledge-graph/types/validate`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/yaml';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KnowledgeGraphTypesApi - functional programming interface
 */
export const KnowledgeGraphTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KnowledgeGraphTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get knowledge graph types as YAML for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKnowledgeGraphTypesYaml(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKnowledgeGraphTypesYaml(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphTypesApi.getKnowledgeGraphTypesYaml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update knowledge graph types from YAML for an agent
         * @param {number} agentId ID of the agent
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateKnowledgeGraphTypesYaml(agentId: number, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateKnowledgeGraphTypesYaml(agentId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphTypesApi.updateKnowledgeGraphTypesYaml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate knowledge graph types YAML and return change analysis
         * @param {number} agentId ID of the agent
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateKnowledgeGraphTypesYaml(agentId: number, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KnowledgeGraphTypesValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateKnowledgeGraphTypesYaml(agentId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KnowledgeGraphTypesApi.validateKnowledgeGraphTypesYaml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KnowledgeGraphTypesApi - factory interface
 */
export const KnowledgeGraphTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KnowledgeGraphTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get knowledge graph types as YAML for an agent
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnowledgeGraphTypesYaml(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getKnowledgeGraphTypesYaml(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update knowledge graph types from YAML for an agent
         * @param {number} agentId ID of the agent
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKnowledgeGraphTypesYaml(agentId: number, body: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateKnowledgeGraphTypesYaml(agentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate knowledge graph types YAML and return change analysis
         * @param {number} agentId ID of the agent
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateKnowledgeGraphTypesYaml(agentId: number, body: string, options?: RawAxiosRequestConfig): AxiosPromise<KnowledgeGraphTypesValidationResult> {
            return localVarFp.validateKnowledgeGraphTypesYaml(agentId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KnowledgeGraphTypesApi - object-oriented interface
 */
export class KnowledgeGraphTypesApi extends BaseAPI {
    /**
     * 
     * @summary Get knowledge graph types as YAML for an agent
     * @param {number} agentId ID of the agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getKnowledgeGraphTypesYaml(agentId: number, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphTypesApiFp(this.configuration).getKnowledgeGraphTypesYaml(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update knowledge graph types from YAML for an agent
     * @param {number} agentId ID of the agent
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateKnowledgeGraphTypesYaml(agentId: number, body: string, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphTypesApiFp(this.configuration).updateKnowledgeGraphTypesYaml(agentId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate knowledge graph types YAML and return change analysis
     * @param {number} agentId ID of the agent
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateKnowledgeGraphTypesYaml(agentId: number, body: string, options?: RawAxiosRequestConfig) {
        return KnowledgeGraphTypesApiFp(this.configuration).validateKnowledgeGraphTypesYaml(agentId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LearningApi - axios parameter creator
 */
export const LearningApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiWsAgentAgentIdLearnGet', 'agentId', agentId)
            const localVarPath = `/api/ws/agent/{agentId}/learn`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnMockGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiWsAgentAgentIdLearnMockGet', 'agentId', agentId)
            const localVarPath = `/api/ws/agent/{agentId}/learn-mock`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LearningApi - functional programming interface
 */
export const LearningApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LearningApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWsAgentAgentIdLearnGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LearningApi.apiWsAgentAgentIdLearnGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWsAgentAgentIdLearnMockGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LearningApi.apiWsAgentAgentIdLearnMockGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LearningApi - factory interface
 */
export const LearningApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LearningApiFp(configuration)
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWsAgentAgentIdLearnGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWsAgentAgentIdLearnMockGet(agentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LearningApi - object-oriented interface
 */
export class LearningApi extends BaseAPI {
    /**
     * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
     * @summary WebSocket endpoint for streaming agent learning progress
     * @param {number} agentId ID of the agent to learn from website
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig) {
        return LearningApiFp(this.configuration).apiWsAgentAgentIdLearnGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
     * @summary WebSocket endpoint for streaming mock agent learning progress
     * @param {number} agentId ID of the agent to simulate learning
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig) {
        return LearningApiFp(this.configuration).apiWsAgentAgentIdLearnMockGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LegalApi - axios parameter creator
 */
export const LegalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the public legal contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalContactGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/legal/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegalApi - functional programming interface
 */
export const LegalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the public legal contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLegalContactGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLegalContactGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLegalContactGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalApi.apiLegalContactGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegalApi - factory interface
 */
export const LegalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegalApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the public legal contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLegalContactGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiLegalContactGet200Response> {
            return localVarFp.apiLegalContactGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegalApi - object-oriented interface
 */
export class LegalApi extends BaseAPI {
    /**
     * 
     * @summary Get the public legal contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiLegalContactGet(options?: RawAxiosRequestConfig) {
        return LegalApiFp(this.configuration).apiLegalContactGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoopTasksApi - axios parameter creator
 */
export const LoopTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Copy a loop into a new loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {CopyLoopTaskRequest} copyLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyLoopTask: async (loopTaskId: number, idempotencyKey: string, copyLoopTaskRequest: CopyLoopTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('copyLoopTask', 'loopTaskId', loopTaskId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('copyLoopTask', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'copyLoopTaskRequest' is not null or undefined
            assertParamExists('copyLoopTask', 'copyLoopTaskRequest', copyLoopTaskRequest)
            const localVarPath = `/api/loop-tasks/{loopTaskId}/copy`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (idempotencyKey != null) {
                localVarHeaderParameter['Idempotency-Key'] = String(idempotencyKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyLoopTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a loop with a dedicated owner conversation
         * @param {number} teamId 
         * @param {CreateLoopTaskRequest} createLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoopTask: async (teamId: number, createLoopTaskRequest: CreateLoopTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createLoopTask', 'teamId', teamId)
            // verify required parameter 'createLoopTaskRequest' is not null or undefined
            assertParamExists('createLoopTask', 'createLoopTaskRequest', createLoopTaskRequest)
            const localVarPath = `/api/teams/{teamId}/loop-tasks`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLoopTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an authorized loop
         * @param {number} loopTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoopTask: async (loopTaskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('getLoopTask', 'loopTaskId', loopTaskId)
            const localVarPath = `/api/loop-tasks/{loopTaskId}`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get lifetime, current-period, timing, and budget metrics
         * @param {number} loopTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoopTaskMetrics: async (loopTaskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('getLoopTaskMetrics', 'loopTaskId', loopTaskId)
            const localVarPath = `/api/loop-tasks/{loopTaskId}/metrics`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List root iterations in descending ordinal order
         * @param {number} loopTaskId 
         * @param {number} [beforeOrdinal] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoopTaskIterations: async (loopTaskId: number, beforeOrdinal?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('listLoopTaskIterations', 'loopTaskId', loopTaskId)
            const localVarPath = `/api/loop-tasks/{loopTaskId}/iterations`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (beforeOrdinal !== undefined) {
                localVarQueryParameter['beforeOrdinal'] = beforeOrdinal;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List visible loops for a team
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {string} [status] active, previous, or a comma-separated persisted state list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoopTasks: async (teamId: number, agentId?: number, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listLoopTasks', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/loop-tasks`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pause a loop for human review
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopReasonRequest} loopReasonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseLoopTask: async (loopTaskId: number, idempotencyKey: string, loopReasonRequest: LoopReasonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('pauseLoopTask', 'loopTaskId', loopTaskId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('pauseLoopTask', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'loopReasonRequest' is not null or undefined
            assertParamExists('pauseLoopTask', 'loopReasonRequest', loopReasonRequest)
            const localVarPath = `/api/loop-tasks/{loopTaskId}/pause`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (idempotencyKey != null) {
                localVarHeaderParameter['Idempotency-Key'] = String(idempotencyKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loopReasonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reanimate a terminal loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopStartRequest} loopStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartLoopTask: async (loopTaskId: number, idempotencyKey: string, loopStartRequest: LoopStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('restartLoopTask', 'loopTaskId', loopTaskId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('restartLoopTask', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'loopStartRequest' is not null or undefined
            assertParamExists('restartLoopTask', 'loopStartRequest', loopStartRequest)
            const localVarPath = `/api/loop-tasks/{loopTaskId}/restart`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (idempotencyKey != null) {
                localVarHeaderParameter['Idempotency-Key'] = String(idempotencyKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loopStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resume a paused loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopStartRequest} loopStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeLoopTask: async (loopTaskId: number, idempotencyKey: string, loopStartRequest: LoopStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('resumeLoopTask', 'loopTaskId', loopTaskId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('resumeLoopTask', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'loopStartRequest' is not null or undefined
            assertParamExists('resumeLoopTask', 'loopStartRequest', loopStartRequest)
            const localVarPath = `/api/loop-tasks/{loopTaskId}/resume`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (idempotencyKey != null) {
                localVarHeaderParameter['Idempotency-Key'] = String(idempotencyKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loopStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stop a loop and its active iteration
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopReasonRequest} loopReasonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopLoopTask: async (loopTaskId: number, idempotencyKey: string, loopReasonRequest: LoopReasonRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('stopLoopTask', 'loopTaskId', loopTaskId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('stopLoopTask', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'loopReasonRequest' is not null or undefined
            assertParamExists('stopLoopTask', 'loopReasonRequest', loopReasonRequest)
            const localVarPath = `/api/loop-tasks/{loopTaskId}/stop`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (idempotencyKey != null) {
                localVarHeaderParameter['Idempotency-Key'] = String(idempotencyKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loopReasonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update idle loop configuration
         * @param {number} loopTaskId 
         * @param {UpdateLoopTaskRequest} updateLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoopTask: async (loopTaskId: number, updateLoopTaskRequest: UpdateLoopTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loopTaskId' is not null or undefined
            assertParamExists('updateLoopTask', 'loopTaskId', loopTaskId)
            // verify required parameter 'updateLoopTaskRequest' is not null or undefined
            assertParamExists('updateLoopTask', 'updateLoopTaskRequest', updateLoopTaskRequest)
            const localVarPath = `/api/loop-tasks/{loopTaskId}`
                .replace(`{${"loopTaskId"}}`, encodeURIComponent(String(loopTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoopTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoopTasksApi - functional programming interface
 */
export const LoopTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoopTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Copy a loop into a new loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {CopyLoopTaskRequest} copyLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyLoopTask(loopTaskId: number, idempotencyKey: string, copyLoopTaskRequest: CopyLoopTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyLoopTask(loopTaskId, idempotencyKey, copyLoopTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.copyLoopTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a loop with a dedicated owner conversation
         * @param {number} teamId 
         * @param {CreateLoopTaskRequest} createLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLoopTask(teamId: number, createLoopTaskRequest: CreateLoopTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLoopTask(teamId, createLoopTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.createLoopTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an authorized loop
         * @param {number} loopTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoopTask(loopTaskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoopTask(loopTaskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.getLoopTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get lifetime, current-period, timing, and budget metrics
         * @param {number} loopTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoopTaskMetrics(loopTaskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopMetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoopTaskMetrics(loopTaskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.getLoopTaskMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List root iterations in descending ordinal order
         * @param {number} loopTaskId 
         * @param {number} [beforeOrdinal] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoopTaskIterations(loopTaskId: number, beforeOrdinal?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopIterationPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoopTaskIterations(loopTaskId, beforeOrdinal, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.listLoopTaskIterations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List visible loops for a team
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {string} [status] active, previous, or a comma-separated persisted state list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoopTasks(teamId: number, agentId?: number, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoopTasks(teamId, agentId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.listLoopTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pause a loop for human review
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopReasonRequest} loopReasonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseLoopTask(loopTaskId: number, idempotencyKey: string, loopReasonRequest: LoopReasonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseLoopTask(loopTaskId, idempotencyKey, loopReasonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.pauseLoopTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reanimate a terminal loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopStartRequest} loopStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restartLoopTask(loopTaskId: number, idempotencyKey: string, loopStartRequest: LoopStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restartLoopTask(loopTaskId, idempotencyKey, loopStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.restartLoopTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resume a paused loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopStartRequest} loopStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeLoopTask(loopTaskId: number, idempotencyKey: string, loopStartRequest: LoopStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeLoopTask(loopTaskId, idempotencyKey, loopStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.resumeLoopTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stop a loop and its active iteration
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopReasonRequest} loopReasonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopLoopTask(loopTaskId: number, idempotencyKey: string, loopReasonRequest: LoopReasonRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopLoopTask(loopTaskId, idempotencyKey, loopReasonRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.stopLoopTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update idle loop configuration
         * @param {number} loopTaskId 
         * @param {UpdateLoopTaskRequest} updateLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLoopTask(loopTaskId: number, updateLoopTaskRequest: UpdateLoopTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoopTaskDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLoopTask(loopTaskId, updateLoopTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoopTasksApi.updateLoopTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoopTasksApi - factory interface
 */
export const LoopTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoopTasksApiFp(configuration)
    return {
        /**
         * 
         * @summary Copy a loop into a new loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {CopyLoopTaskRequest} copyLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyLoopTask(loopTaskId: number, idempotencyKey: string, copyLoopTaskRequest: CopyLoopTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskDetailResponse> {
            return localVarFp.copyLoopTask(loopTaskId, idempotencyKey, copyLoopTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a loop with a dedicated owner conversation
         * @param {number} teamId 
         * @param {CreateLoopTaskRequest} createLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoopTask(teamId: number, createLoopTaskRequest: CreateLoopTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskDetailResponse> {
            return localVarFp.createLoopTask(teamId, createLoopTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an authorized loop
         * @param {number} loopTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoopTask(loopTaskId: number, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskDetailResponse> {
            return localVarFp.getLoopTask(loopTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get lifetime, current-period, timing, and budget metrics
         * @param {number} loopTaskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoopTaskMetrics(loopTaskId: number, options?: RawAxiosRequestConfig): AxiosPromise<LoopMetricsResponse> {
            return localVarFp.getLoopTaskMetrics(loopTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List root iterations in descending ordinal order
         * @param {number} loopTaskId 
         * @param {number} [beforeOrdinal] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoopTaskIterations(loopTaskId: number, beforeOrdinal?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<LoopIterationPage> {
            return localVarFp.listLoopTaskIterations(loopTaskId, beforeOrdinal, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List visible loops for a team
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {string} [status] active, previous, or a comma-separated persisted state list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoopTasks(teamId: number, agentId?: number, status?: string, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskListResponse> {
            return localVarFp.listLoopTasks(teamId, agentId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pause a loop for human review
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopReasonRequest} loopReasonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseLoopTask(loopTaskId: number, idempotencyKey: string, loopReasonRequest: LoopReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskDetailResponse> {
            return localVarFp.pauseLoopTask(loopTaskId, idempotencyKey, loopReasonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reanimate a terminal loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopStartRequest} loopStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartLoopTask(loopTaskId: number, idempotencyKey: string, loopStartRequest: LoopStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskDetailResponse> {
            return localVarFp.restartLoopTask(loopTaskId, idempotencyKey, loopStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resume a paused loop
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopStartRequest} loopStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeLoopTask(loopTaskId: number, idempotencyKey: string, loopStartRequest: LoopStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskDetailResponse> {
            return localVarFp.resumeLoopTask(loopTaskId, idempotencyKey, loopStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stop a loop and its active iteration
         * @param {number} loopTaskId 
         * @param {string} idempotencyKey 
         * @param {LoopReasonRequest} loopReasonRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopLoopTask(loopTaskId: number, idempotencyKey: string, loopReasonRequest: LoopReasonRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskDetailResponse> {
            return localVarFp.stopLoopTask(loopTaskId, idempotencyKey, loopReasonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update idle loop configuration
         * @param {number} loopTaskId 
         * @param {UpdateLoopTaskRequest} updateLoopTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoopTask(loopTaskId: number, updateLoopTaskRequest: UpdateLoopTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoopTaskDetailResponse> {
            return localVarFp.updateLoopTask(loopTaskId, updateLoopTaskRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoopTasksApi - object-oriented interface
 */
export class LoopTasksApi extends BaseAPI {
    /**
     * 
     * @summary Copy a loop into a new loop
     * @param {number} loopTaskId 
     * @param {string} idempotencyKey 
     * @param {CopyLoopTaskRequest} copyLoopTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyLoopTask(loopTaskId: number, idempotencyKey: string, copyLoopTaskRequest: CopyLoopTaskRequest, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).copyLoopTask(loopTaskId, idempotencyKey, copyLoopTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a loop with a dedicated owner conversation
     * @param {number} teamId 
     * @param {CreateLoopTaskRequest} createLoopTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLoopTask(teamId: number, createLoopTaskRequest: CreateLoopTaskRequest, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).createLoopTask(teamId, createLoopTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an authorized loop
     * @param {number} loopTaskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoopTask(loopTaskId: number, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).getLoopTask(loopTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get lifetime, current-period, timing, and budget metrics
     * @param {number} loopTaskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoopTaskMetrics(loopTaskId: number, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).getLoopTaskMetrics(loopTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List root iterations in descending ordinal order
     * @param {number} loopTaskId 
     * @param {number} [beforeOrdinal] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listLoopTaskIterations(loopTaskId: number, beforeOrdinal?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).listLoopTaskIterations(loopTaskId, beforeOrdinal, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List visible loops for a team
     * @param {number} teamId 
     * @param {number} [agentId] 
     * @param {string} [status] active, previous, or a comma-separated persisted state list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listLoopTasks(teamId: number, agentId?: number, status?: string, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).listLoopTasks(teamId, agentId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pause a loop for human review
     * @param {number} loopTaskId 
     * @param {string} idempotencyKey 
     * @param {LoopReasonRequest} loopReasonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pauseLoopTask(loopTaskId: number, idempotencyKey: string, loopReasonRequest: LoopReasonRequest, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).pauseLoopTask(loopTaskId, idempotencyKey, loopReasonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reanimate a terminal loop
     * @param {number} loopTaskId 
     * @param {string} idempotencyKey 
     * @param {LoopStartRequest} loopStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public restartLoopTask(loopTaskId: number, idempotencyKey: string, loopStartRequest: LoopStartRequest, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).restartLoopTask(loopTaskId, idempotencyKey, loopStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resume a paused loop
     * @param {number} loopTaskId 
     * @param {string} idempotencyKey 
     * @param {LoopStartRequest} loopStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resumeLoopTask(loopTaskId: number, idempotencyKey: string, loopStartRequest: LoopStartRequest, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).resumeLoopTask(loopTaskId, idempotencyKey, loopStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stop a loop and its active iteration
     * @param {number} loopTaskId 
     * @param {string} idempotencyKey 
     * @param {LoopReasonRequest} loopReasonRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stopLoopTask(loopTaskId: number, idempotencyKey: string, loopReasonRequest: LoopReasonRequest, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).stopLoopTask(loopTaskId, idempotencyKey, loopReasonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update idle loop configuration
     * @param {number} loopTaskId 
     * @param {UpdateLoopTaskRequest} updateLoopTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLoopTask(loopTaskId: number, updateLoopTaskRequest: UpdateLoopTaskRequest, options?: RawAxiosRequestConfig) {
        return LoopTasksApiFp(this.configuration).updateLoopTask(loopTaskId, updateLoopTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessageNotesApi - axios parameter creator
 */
export const MessageNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves all notes attached to a specific message with pagination. Requires authorization to access the message\'s agent.
         * @summary List notes for a message
         * @param {number} messageId ID of the message to retrieve notes for
         * @param {number} [offset] Number of notes to skip from the beginning
         * @param {number} [limitCount] Maximum number of notes to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesMessageIdNotesGet: async (messageId: number, offset?: number, limitCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMessagesMessageIdNotesGet', 'messageId', messageId)
            const localVarPath = `/api/messages/{messageId}/notes`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limitCount !== undefined) {
                localVarQueryParameter['limitCount'] = limitCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new note attached to a specific message. Requires authorization to access the message\'s agent.
         * @summary Create a new message note
         * @param {number} messageId ID of the message to attach the note to
         * @param {CreateMessageNoteRequest} createMessageNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesMessageIdNotesPost: async (messageId: number, createMessageNoteRequest: CreateMessageNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMessagesMessageIdNotesPost', 'messageId', messageId)
            // verify required parameter 'createMessageNoteRequest' is not null or undefined
            assertParamExists('apiMessagesMessageIdNotesPost', 'createMessageNoteRequest', createMessageNoteRequest)
            const localVarPath = `/api/messages/{messageId}/notes`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMessageNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a message note. Requires authorization to access the note\'s associated message agent.
         * @summary Delete a note
         * @param {number} noteId ID of the note to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesNoteIdDelete: async (noteId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('apiNotesNoteIdDelete', 'noteId', noteId)
            const localVarPath = `/api/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the content or type of an existing message note. Requires authorization to access the note\'s associated message agent.
         * @summary Update an existing note
         * @param {number} noteId ID of the note to update
         * @param {UpdateMessageNoteRequest} updateMessageNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesNoteIdPut: async (noteId: number, updateMessageNoteRequest: UpdateMessageNoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('apiNotesNoteIdPut', 'noteId', noteId)
            // verify required parameter 'updateMessageNoteRequest' is not null or undefined
            assertParamExists('apiNotesNoteIdPut', 'updateMessageNoteRequest', updateMessageNoteRequest)
            const localVarPath = `/api/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMessageNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageNotesApi - functional programming interface
 */
export const MessageNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves all notes attached to a specific message with pagination. Requires authorization to access the message\'s agent.
         * @summary List notes for a message
         * @param {number} messageId ID of the message to retrieve notes for
         * @param {number} [offset] Number of notes to skip from the beginning
         * @param {number} [limitCount] Maximum number of notes to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesMessageIdNotesGet(messageId: number, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageNoteListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesMessageIdNotesGet(messageId, offset, limitCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageNotesApi.apiMessagesMessageIdNotesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new note attached to a specific message. Requires authorization to access the message\'s agent.
         * @summary Create a new message note
         * @param {number} messageId ID of the message to attach the note to
         * @param {CreateMessageNoteRequest} createMessageNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesMessageIdNotesPost(messageId: number, createMessageNoteRequest: CreateMessageNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageNote>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesMessageIdNotesPost(messageId, createMessageNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageNotesApi.apiMessagesMessageIdNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently deletes a message note. Requires authorization to access the note\'s associated message agent.
         * @summary Delete a note
         * @param {number} noteId ID of the note to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotesNoteIdDelete(noteId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiNotesNoteIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotesNoteIdDelete(noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageNotesApi.apiNotesNoteIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the content or type of an existing message note. Requires authorization to access the note\'s associated message agent.
         * @summary Update an existing note
         * @param {number} noteId ID of the note to update
         * @param {UpdateMessageNoteRequest} updateMessageNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotesNoteIdPut(noteId: number, updateMessageNoteRequest: UpdateMessageNoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageNote>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotesNoteIdPut(noteId, updateMessageNoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageNotesApi.apiNotesNoteIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessageNotesApi - factory interface
 */
export const MessageNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageNotesApiFp(configuration)
    return {
        /**
         * Retrieves all notes attached to a specific message with pagination. Requires authorization to access the message\'s agent.
         * @summary List notes for a message
         * @param {number} messageId ID of the message to retrieve notes for
         * @param {number} [offset] Number of notes to skip from the beginning
         * @param {number} [limitCount] Maximum number of notes to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesMessageIdNotesGet(messageId: number, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<MessageNoteListResponse> {
            return localVarFp.apiMessagesMessageIdNotesGet(messageId, offset, limitCount, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new note attached to a specific message. Requires authorization to access the message\'s agent.
         * @summary Create a new message note
         * @param {number} messageId ID of the message to attach the note to
         * @param {CreateMessageNoteRequest} createMessageNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesMessageIdNotesPost(messageId: number, createMessageNoteRequest: CreateMessageNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageNote> {
            return localVarFp.apiMessagesMessageIdNotesPost(messageId, createMessageNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a message note. Requires authorization to access the note\'s associated message agent.
         * @summary Delete a note
         * @param {number} noteId ID of the note to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesNoteIdDelete(noteId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiNotesNoteIdDelete200Response> {
            return localVarFp.apiNotesNoteIdDelete(noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the content or type of an existing message note. Requires authorization to access the note\'s associated message agent.
         * @summary Update an existing note
         * @param {number} noteId ID of the note to update
         * @param {UpdateMessageNoteRequest} updateMessageNoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotesNoteIdPut(noteId: number, updateMessageNoteRequest: UpdateMessageNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageNote> {
            return localVarFp.apiNotesNoteIdPut(noteId, updateMessageNoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessageNotesApi - object-oriented interface
 */
export class MessageNotesApi extends BaseAPI {
    /**
     * Retrieves all notes attached to a specific message with pagination. Requires authorization to access the message\'s agent.
     * @summary List notes for a message
     * @param {number} messageId ID of the message to retrieve notes for
     * @param {number} [offset] Number of notes to skip from the beginning
     * @param {number} [limitCount] Maximum number of notes to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMessagesMessageIdNotesGet(messageId: number, offset?: number, limitCount?: number, options?: RawAxiosRequestConfig) {
        return MessageNotesApiFp(this.configuration).apiMessagesMessageIdNotesGet(messageId, offset, limitCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new note attached to a specific message. Requires authorization to access the message\'s agent.
     * @summary Create a new message note
     * @param {number} messageId ID of the message to attach the note to
     * @param {CreateMessageNoteRequest} createMessageNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMessagesMessageIdNotesPost(messageId: number, createMessageNoteRequest: CreateMessageNoteRequest, options?: RawAxiosRequestConfig) {
        return MessageNotesApiFp(this.configuration).apiMessagesMessageIdNotesPost(messageId, createMessageNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently deletes a message note. Requires authorization to access the note\'s associated message agent.
     * @summary Delete a note
     * @param {number} noteId ID of the note to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotesNoteIdDelete(noteId: number, options?: RawAxiosRequestConfig) {
        return MessageNotesApiFp(this.configuration).apiNotesNoteIdDelete(noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the content or type of an existing message note. Requires authorization to access the note\'s associated message agent.
     * @summary Update an existing note
     * @param {number} noteId ID of the note to update
     * @param {UpdateMessageNoteRequest} updateMessageNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotesNoteIdPut(noteId: number, updateMessageNoteRequest: UpdateMessageNoteRequest, options?: RawAxiosRequestConfig) {
        return MessageNotesApiFp(this.configuration).apiNotesNoteIdPut(noteId, updateMessageNoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessagesApi - axios parameter creator
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get messages for a conversation
         * @param {number} id ID of the conversation
         * @param {number} [limit] Maximum number of messages to return
         * @param {number} [offset] Number of messages to skip
         * @param {boolean} [includeText] Whether to include message text content
         * @param {ApiConversationsIdMessagesGetSortOrderEnum} [sortOrder] Sort order for messages (asc &#x3D; oldest first, desc &#x3D; newest first)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsIdMessagesGet: async (id: number, limit?: number, offset?: number, includeText?: boolean, sortOrder?: ApiConversationsIdMessagesGetSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiConversationsIdMessagesGet', 'id', id)
            const localVarPath = `/api/conversations/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (includeText !== undefined) {
                localVarQueryParameter['includeText'] = includeText;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a message to a conversation
         * @param {number} id ID of the conversation
         * @param {CreateMessageRequest} createMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsIdMessagesPost: async (id: number, createMessageRequest: CreateMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiConversationsIdMessagesPost', 'id', id)
            // verify required parameter 'createMessageRequest' is not null or undefined
            assertParamExists('apiConversationsIdMessagesPost', 'createMessageRequest', createMessageRequest)
            const localVarPath = `/api/conversations/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a message
         * @param {number} id ID of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMessagesIdDelete', 'id', id)
            const localVarPath = `/api/messages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a message
         * @param {number} id ID of the message
         * @param {UpdateMessageRequest} updateMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdPut: async (id: number, updateMessageRequest: UpdateMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiMessagesIdPut', 'id', id)
            // verify required parameter 'updateMessageRequest' is not null or undefined
            assertParamExists('apiMessagesIdPut', 'updateMessageRequest', updateMessageRequest)
            const localVarPath = `/api/messages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesApi - functional programming interface
 */
export const MessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get messages for a conversation
         * @param {number} id ID of the conversation
         * @param {number} [limit] Maximum number of messages to return
         * @param {number} [offset] Number of messages to skip
         * @param {boolean} [includeText] Whether to include message text content
         * @param {ApiConversationsIdMessagesGetSortOrderEnum} [sortOrder] Sort order for messages (asc &#x3D; oldest first, desc &#x3D; newest first)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConversationsIdMessagesGet(id: number, limit?: number, offset?: number, includeText?: boolean, sortOrder?: ApiConversationsIdMessagesGetSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConversationsIdMessagesGet(id, limit, offset, includeText, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.apiConversationsIdMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a message to a conversation
         * @param {number} id ID of the conversation
         * @param {CreateMessageRequest} createMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConversationsIdMessagesPost(id: number, createMessageRequest: CreateMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConversationsIdMessagesPost(id, createMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.apiConversationsIdMessagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a message
         * @param {number} id ID of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMessagesIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.apiMessagesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a message
         * @param {number} id ID of the message
         * @param {UpdateMessageRequest} updateMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMessagesIdPut(id: number, updateMessageRequest: UpdateMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMessagesIdPut(id, updateMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.apiMessagesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessagesApi - factory interface
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get messages for a conversation
         * @param {number} id ID of the conversation
         * @param {number} [limit] Maximum number of messages to return
         * @param {number} [offset] Number of messages to skip
         * @param {boolean} [includeText] Whether to include message text content
         * @param {ApiConversationsIdMessagesGetSortOrderEnum} [sortOrder] Sort order for messages (asc &#x3D; oldest first, desc &#x3D; newest first)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsIdMessagesGet(id: number, limit?: number, offset?: number, includeText?: boolean, sortOrder?: ApiConversationsIdMessagesGetSortOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<MessageListResponse> {
            return localVarFp.apiConversationsIdMessagesGet(id, limit, offset, includeText, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a message to a conversation
         * @param {number} id ID of the conversation
         * @param {CreateMessageRequest} createMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsIdMessagesPost(id: number, createMessageRequest: CreateMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.apiConversationsIdMessagesPost(id, createMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a message
         * @param {number} id ID of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiMessagesIdDelete200Response> {
            return localVarFp.apiMessagesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a message
         * @param {number} id ID of the message
         * @param {UpdateMessageRequest} updateMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMessagesIdPut(id: number, updateMessageRequest: UpdateMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageResponse> {
            return localVarFp.apiMessagesIdPut(id, updateMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessagesApi - object-oriented interface
 */
export class MessagesApi extends BaseAPI {
    /**
     * 
     * @summary Get messages for a conversation
     * @param {number} id ID of the conversation
     * @param {number} [limit] Maximum number of messages to return
     * @param {number} [offset] Number of messages to skip
     * @param {boolean} [includeText] Whether to include message text content
     * @param {ApiConversationsIdMessagesGetSortOrderEnum} [sortOrder] Sort order for messages (asc &#x3D; oldest first, desc &#x3D; newest first)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConversationsIdMessagesGet(id: number, limit?: number, offset?: number, includeText?: boolean, sortOrder?: ApiConversationsIdMessagesGetSortOrderEnum, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).apiConversationsIdMessagesGet(id, limit, offset, includeText, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a message to a conversation
     * @param {number} id ID of the conversation
     * @param {CreateMessageRequest} createMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConversationsIdMessagesPost(id: number, createMessageRequest: CreateMessageRequest, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).apiConversationsIdMessagesPost(id, createMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a message
     * @param {number} id ID of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMessagesIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).apiMessagesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a message
     * @param {number} id ID of the message
     * @param {UpdateMessageRequest} updateMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMessagesIdPut(id: number, updateMessageRequest: UpdateMessageRequest, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).apiMessagesIdPut(id, updateMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ApiConversationsIdMessagesGetSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiConversationsIdMessagesGetSortOrderEnum = typeof ApiConversationsIdMessagesGetSortOrderEnum[keyof typeof ApiConversationsIdMessagesGetSortOrderEnum];


/**
 * MetricsApi - axios parameter creator
 */
export const MetricsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get action log for a specific metric
         * @param {number} metricId ID of the metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsMetricIdActionLogGet: async (metricId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metricId' is not null or undefined
            assertParamExists('apiMetricsMetricIdActionLogGet', 'metricId', metricId)
            const localVarPath = `/api/metrics/{metricId}/action-log`
                .replace(`{${"metricId"}}`, encodeURIComponent(String(metricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Scoped through metrics.work_stream_id -> work_streams.project_id, so AI usage outside a work stream belongs to no project and appears here in none of them.
         * @summary Get cost-over-time for one project, bucketed and broken down by agent
         * @param {number} projectId ID of the project
         * @param {ApiProjectsProjectIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMetricsCostsGet: async (projectId: number, range?: ApiProjectsProjectIdMetricsCostsGetRangeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdMetricsCostsGet', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}/metrics/costs`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Workspace usage narrows by workspace_usage_intervals.project_id and AI usage by metrics.work_stream_id -> work_streams.project_id. Shared provider capacity carries no project attribution and is excluded, so a project\'s compute total omits its share of shared hosts; the response provenance states this.
         * @summary Get the settled cost timeline for one project
         * @param {number} projectId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMetricsCostsHistoryGet: async (projectId: number, range?: CostHistoryRange, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdMetricsCostsHistoryGet', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}/metrics/costs/history`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get token-usage-over-time and token spend by direction for one project
         * @param {number} projectId ID of the project
         * @param {ApiProjectsProjectIdMetricsTokensGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMetricsTokensGet: async (projectId: number, range?: ApiProjectsProjectIdMetricsTokensGetRangeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdMetricsTokensGet', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}/metrics/tokens`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cost-over-time for one agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdMetricsCostsGet: async (teamId: number, agentId: number, range?: ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdMetricsCostsGet', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdMetricsCostsGet', 'agentId', agentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/metrics/costs`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the settled cost timeline for an agent
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet: async (teamId: number, agentId: number, range?: CostHistoryRange, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet', 'agentId', agentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/metrics/costs/history`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get metrics for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {string} [skillIds] Comma-separated list of skill IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdMetricsGet: async (teamId: number, agentId: number, hoursAgo?: number, offset?: number, skillIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdMetricsGet', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdMetricsGet', 'agentId', agentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/metrics`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (hoursAgo !== undefined) {
                localVarQueryParameter['hoursAgo'] = hoursAgo;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (skillIds !== undefined) {
                localVarQueryParameter['skillIds'] = skillIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get metrics for a skill
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} skillId ID of the skill
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet: async (teamId: number, agentId: number, skillId: number, hoursAgo?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet', 'agentId', agentId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet', 'skillId', skillId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/skill/{skillId}/metrics`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"skillId"}}`, encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (hoursAgo !== undefined) {
                localVarQueryParameter['hoursAgo'] = hoursAgo;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cost-over-time for a team, bucketed and broken down by agent
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsCostsGet: async (teamId: number, range?: ApiTeamTeamIdMetricsCostsGetRangeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdMetricsCostsGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/metrics/costs`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the settled cost timeline for a team
         * @param {number} teamId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsCostsHistoryGet: async (teamId: number, range?: CostHistoryRange, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdMetricsCostsHistoryGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/metrics/costs/history`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get metrics for a team
         * @param {number} teamId ID of the team
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsGet: async (teamId: number, hoursAgo?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdMetricsGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/metrics`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (hoursAgo !== undefined) {
                localVarQueryParameter['hoursAgo'] = hoursAgo;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get settled voice costs for one team chat conversation
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {number} [sessionLimit] 
         * @param {number} [sessionOffset] 
         * @param {number} [turnLimit] 
         * @param {number} [turnOffset] 
         * @param {number} [componentLimit] 
         * @param {number} [componentOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsVoiceCostsConversationIdGet: async (teamId: number, conversationId: number, sessionLimit?: number, sessionOffset?: number, turnLimit?: number, turnOffset?: number, componentLimit?: number, componentOffset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdMetricsVoiceCostsConversationIdGet', 'teamId', teamId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('apiTeamTeamIdMetricsVoiceCostsConversationIdGet', 'conversationId', conversationId)
            const localVarPath = `/api/team/{teamId}/metrics/voice-costs/{conversationId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (sessionLimit !== undefined) {
                localVarQueryParameter['sessionLimit'] = sessionLimit;
            }

            if (sessionOffset !== undefined) {
                localVarQueryParameter['sessionOffset'] = sessionOffset;
            }

            if (turnLimit !== undefined) {
                localVarQueryParameter['turnLimit'] = turnLimit;
            }

            if (turnOffset !== undefined) {
                localVarQueryParameter['turnOffset'] = turnOffset;
            }

            if (componentLimit !== undefined) {
                localVarQueryParameter['componentLimit'] = componentLimit;
            }

            if (componentOffset !== undefined) {
                localVarQueryParameter['componentOffset'] = componentOffset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Work streams and ungrouped request logs for an agent
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ListAgentLogsKindEnum} [kind] 
         * @param {number} [offset] 
         * @param {string} [skillIds] Comma-separated skill IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentLogs: async (teamId: number, agentId: number, kind?: ListAgentLogsKindEnum, offset?: number, skillIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listAgentLogs', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('listAgentLogs', 'agentId', agentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/logs`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (skillIds !== undefined) {
                localVarQueryParameter['skillIds'] = skillIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetricsApi - functional programming interface
 */
export const MetricsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetricsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get action log for a specific metric
         * @param {number} metricId ID of the metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsMetricIdActionLogGet(metricId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiMetricsMetricIdActionLogGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsMetricIdActionLogGet(metricId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiMetricsMetricIdActionLogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Scoped through metrics.work_stream_id -> work_streams.project_id, so AI usage outside a work stream belongs to no project and appears here in none of them.
         * @summary Get cost-over-time for one project, bucketed and broken down by agent
         * @param {number} projectId ID of the project
         * @param {ApiProjectsProjectIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdMetricsCostsGet(projectId: number, range?: ApiProjectsProjectIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostTimeseriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdMetricsCostsGet(projectId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiProjectsProjectIdMetricsCostsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Workspace usage narrows by workspace_usage_intervals.project_id and AI usage by metrics.work_stream_id -> work_streams.project_id. Shared provider capacity carries no project attribution and is excluded, so a project\'s compute total omits its share of shared hosts; the response provenance states this.
         * @summary Get the settled cost timeline for one project
         * @param {number} projectId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdMetricsCostsHistoryGet(projectId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostHistoryTimelineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdMetricsCostsHistoryGet(projectId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiProjectsProjectIdMetricsCostsHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get token-usage-over-time and token spend by direction for one project
         * @param {number} projectId ID of the project
         * @param {ApiProjectsProjectIdMetricsTokensGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdMetricsTokensGet(projectId: number, range?: ApiProjectsProjectIdMetricsTokensGetRangeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectTokenTimeseriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdMetricsTokensGet(projectId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiProjectsProjectIdMetricsTokensGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get cost-over-time for one agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdMetricsCostsGet(teamId: number, agentId: number, range?: ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostTimeseriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdMetricsCostsGet(teamId, agentId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiTeamTeamIdAgentAgentIdMetricsCostsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the settled cost timeline for an agent
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet(teamId: number, agentId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostHistoryTimelineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet(teamId, agentId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get metrics for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {string} [skillIds] Comma-separated list of skill IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdMetricsGet(teamId: number, agentId: number, hoursAgo?: number, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdMetricsGet(teamId, agentId, hoursAgo, offset, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiTeamTeamIdAgentAgentIdMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get metrics for a skill
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} skillId ID of the skill
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId: number, agentId: number, skillId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId, agentId, skillId, hoursAgo, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get cost-over-time for a team, bucketed and broken down by agent
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdMetricsCostsGet(teamId: number, range?: ApiTeamTeamIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostTimeseriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdMetricsCostsGet(teamId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiTeamTeamIdMetricsCostsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the settled cost timeline for a team
         * @param {number} teamId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdMetricsCostsHistoryGet(teamId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostHistoryTimelineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdMetricsCostsHistoryGet(teamId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiTeamTeamIdMetricsCostsHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get metrics for a team
         * @param {number} teamId ID of the team
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdMetricsGet(teamId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdMetricsGet(teamId, hoursAgo, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiTeamTeamIdMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get settled voice costs for one team chat conversation
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {number} [sessionLimit] 
         * @param {number} [sessionOffset] 
         * @param {number} [turnLimit] 
         * @param {number} [turnOffset] 
         * @param {number} [componentLimit] 
         * @param {number} [componentOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdMetricsVoiceCostsConversationIdGet(teamId: number, conversationId: number, sessionLimit?: number, sessionOffset?: number, turnLimit?: number, turnOffset?: number, componentLimit?: number, componentOffset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceConversationCostRollup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdMetricsVoiceCostsConversationIdGet(teamId, conversationId, sessionLimit, sessionOffset, turnLimit, turnOffset, componentLimit, componentOffset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.apiTeamTeamIdMetricsVoiceCostsConversationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Work streams and ungrouped request logs for an agent
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ListAgentLogsKindEnum} [kind] 
         * @param {number} [offset] 
         * @param {string} [skillIds] Comma-separated skill IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgentLogs(teamId: number, agentId: number, kind?: ListAgentLogsKindEnum, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgentLogs(teamId, agentId, kind, offset, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetricsApi.listAgentLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetricsApi - factory interface
 */
export const MetricsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetricsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get action log for a specific metric
         * @param {number} metricId ID of the metric
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsMetricIdActionLogGet(metricId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiMetricsMetricIdActionLogGet200Response> {
            return localVarFp.apiMetricsMetricIdActionLogGet(metricId, options).then((request) => request(axios, basePath));
        },
        /**
         * Scoped through metrics.work_stream_id -> work_streams.project_id, so AI usage outside a work stream belongs to no project and appears here in none of them.
         * @summary Get cost-over-time for one project, bucketed and broken down by agent
         * @param {number} projectId ID of the project
         * @param {ApiProjectsProjectIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMetricsCostsGet(projectId: number, range?: ApiProjectsProjectIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig): AxiosPromise<CostTimeseriesResponse> {
            return localVarFp.apiProjectsProjectIdMetricsCostsGet(projectId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * Workspace usage narrows by workspace_usage_intervals.project_id and AI usage by metrics.work_stream_id -> work_streams.project_id. Shared provider capacity carries no project attribution and is excluded, so a project\'s compute total omits its share of shared hosts; the response provenance states this.
         * @summary Get the settled cost timeline for one project
         * @param {number} projectId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMetricsCostsHistoryGet(projectId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig): AxiosPromise<CostHistoryTimelineResponse> {
            return localVarFp.apiProjectsProjectIdMetricsCostsHistoryGet(projectId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get token-usage-over-time and token spend by direction for one project
         * @param {number} projectId ID of the project
         * @param {ApiProjectsProjectIdMetricsTokensGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMetricsTokensGet(projectId: number, range?: ApiProjectsProjectIdMetricsTokensGetRangeEnum, options?: RawAxiosRequestConfig): AxiosPromise<ProjectTokenTimeseriesResponse> {
            return localVarFp.apiProjectsProjectIdMetricsTokensGet(projectId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get cost-over-time for one agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdMetricsCostsGet(teamId: number, agentId: number, range?: ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig): AxiosPromise<CostTimeseriesResponse> {
            return localVarFp.apiTeamTeamIdAgentAgentIdMetricsCostsGet(teamId, agentId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the settled cost timeline for an agent
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet(teamId: number, agentId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig): AxiosPromise<CostHistoryTimelineResponse> {
            return localVarFp.apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet(teamId, agentId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get metrics for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {string} [skillIds] Comma-separated list of skill IDs to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdMetricsGet(teamId: number, agentId: number, hoursAgo?: number, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<MetricResponse> {
            return localVarFp.apiTeamTeamIdAgentAgentIdMetricsGet(teamId, agentId, hoursAgo, offset, skillIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get metrics for a skill
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} skillId ID of the skill
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId: number, agentId: number, skillId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricResponse> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId, agentId, skillId, hoursAgo, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get cost-over-time for a team, bucketed and broken down by agent
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsCostsGet(teamId: number, range?: ApiTeamTeamIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig): AxiosPromise<CostTimeseriesResponse> {
            return localVarFp.apiTeamTeamIdMetricsCostsGet(teamId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the settled cost timeline for a team
         * @param {number} teamId 
         * @param {CostHistoryRange} [range] Window preset (default 30d)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsCostsHistoryGet(teamId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig): AxiosPromise<CostHistoryTimelineResponse> {
            return localVarFp.apiTeamTeamIdMetricsCostsHistoryGet(teamId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get metrics for a team
         * @param {number} teamId ID of the team
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsGet(teamId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricResponse> {
            return localVarFp.apiTeamTeamIdMetricsGet(teamId, hoursAgo, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get settled voice costs for one team chat conversation
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {number} [sessionLimit] 
         * @param {number} [sessionOffset] 
         * @param {number} [turnLimit] 
         * @param {number} [turnOffset] 
         * @param {number} [componentLimit] 
         * @param {number} [componentOffset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsVoiceCostsConversationIdGet(teamId: number, conversationId: number, sessionLimit?: number, sessionOffset?: number, turnLimit?: number, turnOffset?: number, componentLimit?: number, componentOffset?: number, options?: RawAxiosRequestConfig): AxiosPromise<VoiceConversationCostRollup> {
            return localVarFp.apiTeamTeamIdMetricsVoiceCostsConversationIdGet(teamId, conversationId, sessionLimit, sessionOffset, turnLimit, turnOffset, componentLimit, componentOffset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Work streams and ungrouped request logs for an agent
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ListAgentLogsKindEnum} [kind] 
         * @param {number} [offset] 
         * @param {string} [skillIds] Comma-separated skill IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgentLogs(teamId: number, agentId: number, kind?: ListAgentLogsKindEnum, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentLogResponse> {
            return localVarFp.listAgentLogs(teamId, agentId, kind, offset, skillIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetricsApi - object-oriented interface
 */
export class MetricsApi extends BaseAPI {
    /**
     * 
     * @summary Get action log for a specific metric
     * @param {number} metricId ID of the metric
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiMetricsMetricIdActionLogGet(metricId: number, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsMetricIdActionLogGet(metricId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Scoped through metrics.work_stream_id -> work_streams.project_id, so AI usage outside a work stream belongs to no project and appears here in none of them.
     * @summary Get cost-over-time for one project, bucketed and broken down by agent
     * @param {number} projectId ID of the project
     * @param {ApiProjectsProjectIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdMetricsCostsGet(projectId: number, range?: ApiProjectsProjectIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiProjectsProjectIdMetricsCostsGet(projectId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Workspace usage narrows by workspace_usage_intervals.project_id and AI usage by metrics.work_stream_id -> work_streams.project_id. Shared provider capacity carries no project attribution and is excluded, so a project\'s compute total omits its share of shared hosts; the response provenance states this.
     * @summary Get the settled cost timeline for one project
     * @param {number} projectId 
     * @param {CostHistoryRange} [range] Window preset (default 30d)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdMetricsCostsHistoryGet(projectId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiProjectsProjectIdMetricsCostsHistoryGet(projectId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get token-usage-over-time and token spend by direction for one project
     * @param {number} projectId ID of the project
     * @param {ApiProjectsProjectIdMetricsTokensGetRangeEnum} [range] Preset time range (default 30d)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdMetricsTokensGet(projectId: number, range?: ApiProjectsProjectIdMetricsTokensGetRangeEnum, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiProjectsProjectIdMetricsTokensGet(projectId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get cost-over-time for one agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdMetricsCostsGet(teamId: number, agentId: number, range?: ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiTeamTeamIdAgentAgentIdMetricsCostsGet(teamId, agentId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the settled cost timeline for an agent
     * @param {number} teamId 
     * @param {number} agentId 
     * @param {CostHistoryRange} [range] Window preset (default 30d)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet(teamId: number, agentId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiTeamTeamIdAgentAgentIdMetricsCostsHistoryGet(teamId, agentId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get metrics for an agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} [hoursAgo] Number of hours to look back (default 24)
     * @param {number} [offset] Offset for pagination (default 0)
     * @param {string} [skillIds] Comma-separated list of skill IDs to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdMetricsGet(teamId: number, agentId: number, hoursAgo?: number, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiTeamTeamIdAgentAgentIdMetricsGet(teamId, agentId, hoursAgo, offset, skillIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get metrics for a skill
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} skillId ID of the skill
     * @param {number} [hoursAgo] Number of hours to look back (default 24)
     * @param {number} [offset] Offset for pagination (default 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId: number, agentId: number, skillId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId, agentId, skillId, hoursAgo, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get cost-over-time for a team, bucketed and broken down by agent
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdMetricsCostsGetRangeEnum} [range] Preset time range (default 30d)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdMetricsCostsGet(teamId: number, range?: ApiTeamTeamIdMetricsCostsGetRangeEnum, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiTeamTeamIdMetricsCostsGet(teamId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the settled cost timeline for a team
     * @param {number} teamId 
     * @param {CostHistoryRange} [range] Window preset (default 30d)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdMetricsCostsHistoryGet(teamId: number, range?: CostHistoryRange, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiTeamTeamIdMetricsCostsHistoryGet(teamId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get metrics for a team
     * @param {number} teamId ID of the team
     * @param {number} [hoursAgo] Number of hours to look back (default 24)
     * @param {number} [offset] Offset for pagination (default 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdMetricsGet(teamId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiTeamTeamIdMetricsGet(teamId, hoursAgo, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get settled voice costs for one team chat conversation
     * @param {number} teamId 
     * @param {number} conversationId 
     * @param {number} [sessionLimit] 
     * @param {number} [sessionOffset] 
     * @param {number} [turnLimit] 
     * @param {number} [turnOffset] 
     * @param {number} [componentLimit] 
     * @param {number} [componentOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdMetricsVoiceCostsConversationIdGet(teamId: number, conversationId: number, sessionLimit?: number, sessionOffset?: number, turnLimit?: number, turnOffset?: number, componentLimit?: number, componentOffset?: number, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiTeamTeamIdMetricsVoiceCostsConversationIdGet(teamId, conversationId, sessionLimit, sessionOffset, turnLimit, turnOffset, componentLimit, componentOffset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Work streams and ungrouped request logs for an agent
     * @param {number} teamId 
     * @param {number} agentId 
     * @param {ListAgentLogsKindEnum} [kind] 
     * @param {number} [offset] 
     * @param {string} [skillIds] Comma-separated skill IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAgentLogs(teamId: number, agentId: number, kind?: ListAgentLogsKindEnum, offset?: number, skillIds?: string, options?: RawAxiosRequestConfig) {
        return MetricsApiFp(this.configuration).listAgentLogs(teamId, agentId, kind, offset, skillIds, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ApiProjectsProjectIdMetricsCostsGetRangeEnum = {
    _1d: '1d',
    _3d: '3d',
    _7d: '7d',
    _30d: '30d',
    _3m: '3m',
    _6m: '6m',
    _1y: '1y',
    _2y: '2y'
} as const;
export type ApiProjectsProjectIdMetricsCostsGetRangeEnum = typeof ApiProjectsProjectIdMetricsCostsGetRangeEnum[keyof typeof ApiProjectsProjectIdMetricsCostsGetRangeEnum];
export const ApiProjectsProjectIdMetricsTokensGetRangeEnum = {
    _1d: '1d',
    _3d: '3d',
    _7d: '7d',
    _30d: '30d',
    _3m: '3m',
    _6m: '6m',
    _1y: '1y',
    _2y: '2y'
} as const;
export type ApiProjectsProjectIdMetricsTokensGetRangeEnum = typeof ApiProjectsProjectIdMetricsTokensGetRangeEnum[keyof typeof ApiProjectsProjectIdMetricsTokensGetRangeEnum];
export const ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum = {
    _1d: '1d',
    _3d: '3d',
    _7d: '7d',
    _30d: '30d',
    _3m: '3m',
    _6m: '6m',
    _1y: '1y',
    _2y: '2y'
} as const;
export type ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum = typeof ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum[keyof typeof ApiTeamTeamIdAgentAgentIdMetricsCostsGetRangeEnum];
export const ApiTeamTeamIdMetricsCostsGetRangeEnum = {
    _1d: '1d',
    _3d: '3d',
    _7d: '7d',
    _30d: '30d',
    _3m: '3m',
    _6m: '6m',
    _1y: '1y',
    _2y: '2y'
} as const;
export type ApiTeamTeamIdMetricsCostsGetRangeEnum = typeof ApiTeamTeamIdMetricsCostsGetRangeEnum[keyof typeof ApiTeamTeamIdMetricsCostsGetRangeEnum];
export const ListAgentLogsKindEnum = {
    WorkStream: 'work_stream',
    Request: 'request'
} as const;
export type ListAgentLogsKindEnum = typeof ListAgentLogsKindEnum[keyof typeof ListAgentLogsKindEnum];


/**
 * ModelCatalogApi - axios parameter creator
 */
export const ModelCatalogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List the sub-processors that can serve one model
         * @param {number} teamId 
         * @param {string} [model] Canonical model id. Required unless family is given.
         * @param {string} [family] Curated family id. Resolves to the family\&#39;s current latest model, so a caller never has to know which member that is.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCatalogEndpointsGet: async (teamId: number, model?: string, family?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelCatalogEndpointsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/model-catalog/endpoints`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (family !== undefined) {
                localVarQueryParameter['family'] = family;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List every model a team can reach, one row per model
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCatalogGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelCatalogGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/model-catalog`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Answers \"what would this run\" for a draft policy, using the resolver a turn uses and the team\'s jurisdiction policy. Writes nothing; a POST only because a whole policy does not fit in a query string. A draft that resolves to nothing is answered with candidateCount 0 and a reason, not an error.
         * @summary Resolve an unsaved slot policy through the real ranking algorithm
         * @param {number} teamId 
         * @param {ResolveSlotPolicyRequest} resolveSlotPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCatalogResolvePost: async (teamId: number, resolveSlotPolicyRequest: ResolveSlotPolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelCatalogResolvePost', 'teamId', teamId)
            // verify required parameter 'resolveSlotPolicyRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelCatalogResolvePost', 'resolveSlotPolicyRequest', resolveSlotPolicyRequest)
            const localVarPath = `/api/teams/{teamId}/model-catalog/resolve`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveSlotPolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelCatalogApi - functional programming interface
 */
export const ModelCatalogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelCatalogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List the sub-processors that can serve one model
         * @param {number} teamId 
         * @param {string} [model] Canonical model id. Required unless family is given.
         * @param {string} [family] Curated family id. Resolves to the family\&#39;s current latest model, so a caller never has to know which member that is.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelCatalogEndpointsGet(teamId: number, model?: string, family?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelEndpointsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelCatalogEndpointsGet(teamId, model, family, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelCatalogApi.apiTeamsTeamIdModelCatalogEndpointsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List every model a team can reach, one row per model
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelCatalogGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamModelCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelCatalogGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelCatalogApi.apiTeamsTeamIdModelCatalogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Answers \"what would this run\" for a draft policy, using the resolver a turn uses and the team\'s jurisdiction policy. Writes nothing; a POST only because a whole policy does not fit in a query string. A draft that resolves to nothing is answered with candidateCount 0 and a reason, not an error.
         * @summary Resolve an unsaved slot policy through the real ranking algorithm
         * @param {number} teamId 
         * @param {ResolveSlotPolicyRequest} resolveSlotPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelCatalogResolvePost(teamId: number, resolveSlotPolicyRequest: ResolveSlotPolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SlotResolutionPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelCatalogResolvePost(teamId, resolveSlotPolicyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelCatalogApi.apiTeamsTeamIdModelCatalogResolvePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModelCatalogApi - factory interface
 */
export const ModelCatalogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelCatalogApiFp(configuration)
    return {
        /**
         * 
         * @summary List the sub-processors that can serve one model
         * @param {number} teamId 
         * @param {string} [model] Canonical model id. Required unless family is given.
         * @param {string} [family] Curated family id. Resolves to the family\&#39;s current latest model, so a caller never has to know which member that is.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCatalogEndpointsGet(teamId: number, model?: string, family?: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelEndpointsResponse> {
            return localVarFp.apiTeamsTeamIdModelCatalogEndpointsGet(teamId, model, family, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List every model a team can reach, one row per model
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCatalogGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamModelCatalog> {
            return localVarFp.apiTeamsTeamIdModelCatalogGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Answers \"what would this run\" for a draft policy, using the resolver a turn uses and the team\'s jurisdiction policy. Writes nothing; a POST only because a whole policy does not fit in a query string. A draft that resolves to nothing is answered with candidateCount 0 and a reason, not an error.
         * @summary Resolve an unsaved slot policy through the real ranking algorithm
         * @param {number} teamId 
         * @param {ResolveSlotPolicyRequest} resolveSlotPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCatalogResolvePost(teamId: number, resolveSlotPolicyRequest: ResolveSlotPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SlotResolutionPreview> {
            return localVarFp.apiTeamsTeamIdModelCatalogResolvePost(teamId, resolveSlotPolicyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModelCatalogApi - object-oriented interface
 */
export class ModelCatalogApi extends BaseAPI {
    /**
     * 
     * @summary List the sub-processors that can serve one model
     * @param {number} teamId 
     * @param {string} [model] Canonical model id. Required unless family is given.
     * @param {string} [family] Curated family id. Resolves to the family\&#39;s current latest model, so a caller never has to know which member that is.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelCatalogEndpointsGet(teamId: number, model?: string, family?: string, options?: RawAxiosRequestConfig) {
        return ModelCatalogApiFp(this.configuration).apiTeamsTeamIdModelCatalogEndpointsGet(teamId, model, family, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List every model a team can reach, one row per model
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelCatalogGet(teamId: number, options?: RawAxiosRequestConfig) {
        return ModelCatalogApiFp(this.configuration).apiTeamsTeamIdModelCatalogGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Answers \"what would this run\" for a draft policy, using the resolver a turn uses and the team\'s jurisdiction policy. Writes nothing; a POST only because a whole policy does not fit in a query string. A draft that resolves to nothing is answered with candidateCount 0 and a reason, not an error.
     * @summary Resolve an unsaved slot policy through the real ranking algorithm
     * @param {number} teamId 
     * @param {ResolveSlotPolicyRequest} resolveSlotPolicyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelCatalogResolvePost(teamId: number, resolveSlotPolicyRequest: ResolveSlotPolicyRequest, options?: RawAxiosRequestConfig) {
        return ModelCatalogApiFp(this.configuration).apiTeamsTeamIdModelCatalogResolvePost(teamId, resolveSlotPolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ModelProvidersApi - axios parameter creator
 */
export const ModelProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List the provider types the system supports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModelProviderTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/model-provider-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Turn a generative capability on or off for this team
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum} capability 
         * @param {ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest} apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCapabilitiesCapabilityPut: async (teamId: number, capability: ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum, apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest: ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelCapabilitiesCapabilityPut', 'teamId', teamId)
            // verify required parameter 'capability' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelCapabilitiesCapabilityPut', 'capability', capability)
            // verify required parameter 'apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelCapabilitiesCapabilityPut', 'apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest', apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest)
            const localVarPath = `/api/teams/{teamId}/model-capabilities/{capability}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"capability"}}`, encodeURIComponent(String(capability)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List which generative capabilities this team allows
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCapabilitiesGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelCapabilitiesGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/model-capabilities`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a team\'s model provider instances, including read-only platform defaults
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/model-providers`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a team model provider instance
         * @param {number} teamId 
         * @param {TeamModelProviderCreateRequest} teamModelProviderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersPost: async (teamId: number, teamModelProviderCreateRequest: TeamModelProviderCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersPost', 'teamId', teamId)
            // verify required parameter 'teamModelProviderCreateRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersPost', 'teamModelProviderCreateRequest', teamModelProviderCreateRequest)
            const localVarPath = `/api/teams/{teamId}/model-providers`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamModelProviderCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a team model provider instance
         * @param {number} teamId 
         * @param {number} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersProviderIdDelete: async (teamId: number, providerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersProviderIdDelete', 'teamId', teamId)
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersProviderIdDelete', 'providerId', providerId)
            const localVarPath = `/api/teams/{teamId}/model-providers/{providerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a team model provider instance
         * @param {number} teamId 
         * @param {number} providerId 
         * @param {TeamModelProviderUpdateRequest} teamModelProviderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersProviderIdPut: async (teamId: number, providerId: number, teamModelProviderUpdateRequest: TeamModelProviderUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersProviderIdPut', 'teamId', teamId)
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersProviderIdPut', 'providerId', providerId)
            // verify required parameter 'teamModelProviderUpdateRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersProviderIdPut', 'teamModelProviderUpdateRequest', teamModelProviderUpdateRequest)
            const localVarPath = `/api/teams/{teamId}/model-providers/{providerId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamModelProviderUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts a platform default reference such as default-google or the numeric key of a team-created provider instance.
         * @summary Enable or disable a model provider for a team
         * @param {number} teamId 
         * @param {string} ref 
         * @param {NativeModelProviderEnabledRequest} nativeModelProviderEnabledRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersRefEnabledPut: async (teamId: number, ref: string, nativeModelProviderEnabledRequest: NativeModelProviderEnabledRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersRefEnabledPut', 'teamId', teamId)
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersRefEnabledPut', 'ref', ref)
            // verify required parameter 'nativeModelProviderEnabledRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersRefEnabledPut', 'nativeModelProviderEnabledRequest', nativeModelProviderEnabledRequest)
            const localVarPath = `/api/teams/{teamId}/model-providers/{ref}/enabled`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nativeModelProviderEnabledRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ref is a numeric provider instance id or \"default-<type>\" for a platform default instance. By default only models permitted by the instance\'s allow-list are returned; pass all=true to include disallowed models with allowed flags (settings screen view).
         * @summary List the model catalog for one provider instance
         * @param {number} teamId 
         * @param {string} ref 
         * @param {ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersRefModelsGet: async (teamId: number, ref: string, all?: ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersRefModelsGet', 'teamId', teamId)
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersRefModelsGet', 'ref', ref)
            const localVarPath = `/api/teams/{teamId}/model-providers/{ref}/models`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks the credentials against the provider with a cheap read-only call. On success, returns the model catalog (live-fetched where the provider supports it) so the client can present allow-list choices. Pass providerId to merge an existing instance\'s stored secrets with any newly entered values (edit flow).
         * @summary Verify provider credentials and return the live model catalog
         * @param {number} teamId 
         * @param {VerifyModelProviderRequest} verifyModelProviderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersVerifyPost: async (teamId: number, verifyModelProviderRequest: VerifyModelProviderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersVerifyPost', 'teamId', teamId)
            // verify required parameter 'verifyModelProviderRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelProvidersVerifyPost', 'verifyModelProviderRequest', verifyModelProviderRequest)
            const localVarPath = `/api/teams/{teamId}/model-providers/verify`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyModelProviderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a team\'s sub-processor jurisdiction policy
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSubProcessorPolicyGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSubProcessorPolicyGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/sub-processor-policy`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set a team\'s sub-processor jurisdiction policy
         * @param {number} teamId 
         * @param {SubProcessorCountryPolicy} subProcessorCountryPolicy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSubProcessorPolicyPut: async (teamId: number, subProcessorCountryPolicy: SubProcessorCountryPolicy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSubProcessorPolicyPut', 'teamId', teamId)
            // verify required parameter 'subProcessorCountryPolicy' is not null or undefined
            assertParamExists('apiTeamsTeamIdSubProcessorPolicyPut', 'subProcessorCountryPolicy', subProcessorCountryPolicy)
            const localVarPath = `/api/teams/{teamId}/sub-processor-policy`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subProcessorCountryPolicy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelProvidersApi - functional programming interface
 */
export const ModelProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List the provider types the system supports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiModelProviderTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelProviderTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiModelProviderTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiModelProviderTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Turn a generative capability on or off for this team
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum} capability 
         * @param {ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest} apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelCapabilitiesCapabilityPut(teamId: number, capability: ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum, apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest: ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisabledModelCapabilities>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelCapabilitiesCapabilityPut(teamId, capability, apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelCapabilitiesCapabilityPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List which generative capabilities this team allows
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelCapabilitiesGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelCapabilitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelCapabilitiesGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelCapabilitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a team\'s model provider instances, including read-only platform defaults
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelProvidersGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamModelProviderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelProvidersGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a team model provider instance
         * @param {number} teamId 
         * @param {TeamModelProviderCreateRequest} teamModelProviderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelProvidersPost(teamId: number, teamModelProviderCreateRequest: TeamModelProviderCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamModelProviderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelProvidersPost(teamId, teamModelProviderCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelProvidersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a team model provider instance
         * @param {number} teamId 
         * @param {number} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelProvidersProviderIdDelete(teamId: number, providerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdModelProvidersProviderIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelProvidersProviderIdDelete(teamId, providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelProvidersProviderIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a team model provider instance
         * @param {number} teamId 
         * @param {number} providerId 
         * @param {TeamModelProviderUpdateRequest} teamModelProviderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelProvidersProviderIdPut(teamId: number, providerId: number, teamModelProviderUpdateRequest: TeamModelProviderUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamModelProviderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelProvidersProviderIdPut(teamId, providerId, teamModelProviderUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelProvidersProviderIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts a platform default reference such as default-google or the numeric key of a team-created provider instance.
         * @summary Enable or disable a model provider for a team
         * @param {number} teamId 
         * @param {string} ref 
         * @param {NativeModelProviderEnabledRequest} nativeModelProviderEnabledRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelProvidersRefEnabledPut(teamId: number, ref: string, nativeModelProviderEnabledRequest: NativeModelProviderEnabledRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamModelProviderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelProvidersRefEnabledPut(teamId, ref, nativeModelProviderEnabledRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelProvidersRefEnabledPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ref is a numeric provider instance id or \"default-<type>\" for a platform default instance. By default only models permitted by the instance\'s allow-list are returned; pass all=true to include disallowed models with allowed flags (settings screen view).
         * @summary List the model catalog for one provider instance
         * @param {number} teamId 
         * @param {string} ref 
         * @param {ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelProvidersRefModelsGet(teamId: number, ref: string, all?: ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderModelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelProvidersRefModelsGet(teamId, ref, all, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelProvidersRefModelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks the credentials against the provider with a cheap read-only call. On success, returns the model catalog (live-fetched where the provider supports it) so the client can present allow-list choices. Pass providerId to merge an existing instance\'s stored secrets with any newly entered values (edit flow).
         * @summary Verify provider credentials and return the live model catalog
         * @param {number} teamId 
         * @param {VerifyModelProviderRequest} verifyModelProviderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelProvidersVerifyPost(teamId: number, verifyModelProviderRequest: VerifyModelProviderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyModelProviderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelProvidersVerifyPost(teamId, verifyModelProviderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdModelProvidersVerifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a team\'s sub-processor jurisdiction policy
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSubProcessorPolicyGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubProcessorPolicyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSubProcessorPolicyGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdSubProcessorPolicyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set a team\'s sub-processor jurisdiction policy
         * @param {number} teamId 
         * @param {SubProcessorCountryPolicy} subProcessorCountryPolicy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSubProcessorPolicyPut(teamId: number, subProcessorCountryPolicy: SubProcessorCountryPolicy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubProcessorPolicyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSubProcessorPolicyPut(teamId, subProcessorCountryPolicy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelProvidersApi.apiTeamsTeamIdSubProcessorPolicyPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModelProvidersApi - factory interface
 */
export const ModelProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelProvidersApiFp(configuration)
    return {
        /**
         * 
         * @summary List the provider types the system supports
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModelProviderTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<ModelProviderTypesResponse> {
            return localVarFp.apiModelProviderTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Turn a generative capability on or off for this team
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum} capability 
         * @param {ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest} apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCapabilitiesCapabilityPut(teamId: number, capability: ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum, apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest: ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<DisabledModelCapabilities> {
            return localVarFp.apiTeamsTeamIdModelCapabilitiesCapabilityPut(teamId, capability, apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List which generative capabilities this team allows
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelCapabilitiesGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ModelCapabilitiesResponse> {
            return localVarFp.apiTeamsTeamIdModelCapabilitiesGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a team\'s model provider instances, including read-only platform defaults
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamModelProviderListResponse> {
            return localVarFp.apiTeamsTeamIdModelProvidersGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a team model provider instance
         * @param {number} teamId 
         * @param {TeamModelProviderCreateRequest} teamModelProviderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersPost(teamId: number, teamModelProviderCreateRequest: TeamModelProviderCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamModelProviderResponse> {
            return localVarFp.apiTeamsTeamIdModelProvidersPost(teamId, teamModelProviderCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a team model provider instance
         * @param {number} teamId 
         * @param {number} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersProviderIdDelete(teamId: number, providerId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdModelProvidersProviderIdDelete200Response> {
            return localVarFp.apiTeamsTeamIdModelProvidersProviderIdDelete(teamId, providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a team model provider instance
         * @param {number} teamId 
         * @param {number} providerId 
         * @param {TeamModelProviderUpdateRequest} teamModelProviderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersProviderIdPut(teamId: number, providerId: number, teamModelProviderUpdateRequest: TeamModelProviderUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamModelProviderResponse> {
            return localVarFp.apiTeamsTeamIdModelProvidersProviderIdPut(teamId, providerId, teamModelProviderUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts a platform default reference such as default-google or the numeric key of a team-created provider instance.
         * @summary Enable or disable a model provider for a team
         * @param {number} teamId 
         * @param {string} ref 
         * @param {NativeModelProviderEnabledRequest} nativeModelProviderEnabledRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersRefEnabledPut(teamId: number, ref: string, nativeModelProviderEnabledRequest: NativeModelProviderEnabledRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamModelProviderResponse> {
            return localVarFp.apiTeamsTeamIdModelProvidersRefEnabledPut(teamId, ref, nativeModelProviderEnabledRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ref is a numeric provider instance id or \"default-<type>\" for a platform default instance. By default only models permitted by the instance\'s allow-list are returned; pass all=true to include disallowed models with allowed flags (settings screen view).
         * @summary List the model catalog for one provider instance
         * @param {number} teamId 
         * @param {string} ref 
         * @param {ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersRefModelsGet(teamId: number, ref: string, all?: ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum, options?: RawAxiosRequestConfig): AxiosPromise<ProviderModelsResponse> {
            return localVarFp.apiTeamsTeamIdModelProvidersRefModelsGet(teamId, ref, all, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks the credentials against the provider with a cheap read-only call. On success, returns the model catalog (live-fetched where the provider supports it) so the client can present allow-list choices. Pass providerId to merge an existing instance\'s stored secrets with any newly entered values (edit flow).
         * @summary Verify provider credentials and return the live model catalog
         * @param {number} teamId 
         * @param {VerifyModelProviderRequest} verifyModelProviderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelProvidersVerifyPost(teamId: number, verifyModelProviderRequest: VerifyModelProviderRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyModelProviderResponse> {
            return localVarFp.apiTeamsTeamIdModelProvidersVerifyPost(teamId, verifyModelProviderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a team\'s sub-processor jurisdiction policy
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSubProcessorPolicyGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<SubProcessorPolicyView> {
            return localVarFp.apiTeamsTeamIdSubProcessorPolicyGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set a team\'s sub-processor jurisdiction policy
         * @param {number} teamId 
         * @param {SubProcessorCountryPolicy} subProcessorCountryPolicy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSubProcessorPolicyPut(teamId: number, subProcessorCountryPolicy: SubProcessorCountryPolicy, options?: RawAxiosRequestConfig): AxiosPromise<SubProcessorPolicyView> {
            return localVarFp.apiTeamsTeamIdSubProcessorPolicyPut(teamId, subProcessorCountryPolicy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModelProvidersApi - object-oriented interface
 */
export class ModelProvidersApi extends BaseAPI {
    /**
     * 
     * @summary List the provider types the system supports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiModelProviderTypesGet(options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiModelProviderTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Turn a generative capability on or off for this team
     * @param {number} teamId 
     * @param {ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum} capability 
     * @param {ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest} apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelCapabilitiesCapabilityPut(teamId: number, capability: ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum, apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest: ApiTeamsTeamIdModelCapabilitiesCapabilityPutRequest, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelCapabilitiesCapabilityPut(teamId, capability, apiTeamsTeamIdModelCapabilitiesCapabilityPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List which generative capabilities this team allows
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelCapabilitiesGet(teamId: number, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelCapabilitiesGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a team\'s model provider instances, including read-only platform defaults
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelProvidersGet(teamId: number, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelProvidersGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a team model provider instance
     * @param {number} teamId 
     * @param {TeamModelProviderCreateRequest} teamModelProviderCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelProvidersPost(teamId: number, teamModelProviderCreateRequest: TeamModelProviderCreateRequest, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelProvidersPost(teamId, teamModelProviderCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a team model provider instance
     * @param {number} teamId 
     * @param {number} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelProvidersProviderIdDelete(teamId: number, providerId: number, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelProvidersProviderIdDelete(teamId, providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a team model provider instance
     * @param {number} teamId 
     * @param {number} providerId 
     * @param {TeamModelProviderUpdateRequest} teamModelProviderUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelProvidersProviderIdPut(teamId: number, providerId: number, teamModelProviderUpdateRequest: TeamModelProviderUpdateRequest, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelProvidersProviderIdPut(teamId, providerId, teamModelProviderUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts a platform default reference such as default-google or the numeric key of a team-created provider instance.
     * @summary Enable or disable a model provider for a team
     * @param {number} teamId 
     * @param {string} ref 
     * @param {NativeModelProviderEnabledRequest} nativeModelProviderEnabledRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelProvidersRefEnabledPut(teamId: number, ref: string, nativeModelProviderEnabledRequest: NativeModelProviderEnabledRequest, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelProvidersRefEnabledPut(teamId, ref, nativeModelProviderEnabledRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ref is a numeric provider instance id or \"default-<type>\" for a platform default instance. By default only models permitted by the instance\'s allow-list are returned; pass all=true to include disallowed models with allowed flags (settings screen view).
     * @summary List the model catalog for one provider instance
     * @param {number} teamId 
     * @param {string} ref 
     * @param {ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum} [all] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelProvidersRefModelsGet(teamId: number, ref: string, all?: ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelProvidersRefModelsGet(teamId, ref, all, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks the credentials against the provider with a cheap read-only call. On success, returns the model catalog (live-fetched where the provider supports it) so the client can present allow-list choices. Pass providerId to merge an existing instance\'s stored secrets with any newly entered values (edit flow).
     * @summary Verify provider credentials and return the live model catalog
     * @param {number} teamId 
     * @param {VerifyModelProviderRequest} verifyModelProviderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelProvidersVerifyPost(teamId: number, verifyModelProviderRequest: VerifyModelProviderRequest, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdModelProvidersVerifyPost(teamId, verifyModelProviderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a team\'s sub-processor jurisdiction policy
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSubProcessorPolicyGet(teamId: number, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdSubProcessorPolicyGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set a team\'s sub-processor jurisdiction policy
     * @param {number} teamId 
     * @param {SubProcessorCountryPolicy} subProcessorCountryPolicy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSubProcessorPolicyPut(teamId: number, subProcessorCountryPolicy: SubProcessorCountryPolicy, options?: RawAxiosRequestConfig) {
        return ModelProvidersApiFp(this.configuration).apiTeamsTeamIdSubProcessorPolicyPut(teamId, subProcessorCountryPolicy, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum = {
    Image: 'image',
    Speech: 'speech',
    Music: 'music',
    Video: 'video',
    LiveAudio: 'liveAudio'
} as const;
export type ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum = typeof ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum[keyof typeof ApiTeamsTeamIdModelCapabilitiesCapabilityPutCapabilityEnum];
export const ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum = {
    True: 'true',
    False: 'false'
} as const;
export type ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum = typeof ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum[keyof typeof ApiTeamsTeamIdModelProvidersRefModelsGetAllEnum];


/**
 * ModelsApi - axios parameter creator
 */
export const ModelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of all model providers available in the system
         * @summary Get all available model providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModelProvidersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/model-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of models available for the specified provider
         * @summary Get models for a specific provider
         * @param {string} provider Name of the model provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModelsProviderGet: async (provider: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('apiModelsProviderGet', 'provider', provider)
            const localVarPath = `/api/models/{provider}`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelsApi - functional programming interface
 */
export const ModelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of all model providers available in the system
         * @summary Get all available model providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiModelProvidersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelProvidersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiModelProvidersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelsApi.apiModelProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of models available for the specified provider
         * @summary Get models for a specific provider
         * @param {string} provider Name of the model provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiModelsProviderGet(provider: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiModelsProviderGet(provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ModelsApi.apiModelsProviderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ModelsApi - factory interface
 */
export const ModelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelsApiFp(configuration)
    return {
        /**
         * Returns a list of all model providers available in the system
         * @summary Get all available model providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModelProvidersGet(options?: RawAxiosRequestConfig): AxiosPromise<ModelProvidersResponse> {
            return localVarFp.apiModelProvidersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of models available for the specified provider
         * @summary Get models for a specific provider
         * @param {string} provider Name of the model provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModelsProviderGet(provider: string, options?: RawAxiosRequestConfig): AxiosPromise<ModelsResponse> {
            return localVarFp.apiModelsProviderGet(provider, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModelsApi - object-oriented interface
 */
export class ModelsApi extends BaseAPI {
    /**
     * Returns a list of all model providers available in the system
     * @summary Get all available model providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiModelProvidersGet(options?: RawAxiosRequestConfig) {
        return ModelsApiFp(this.configuration).apiModelProvidersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of models available for the specified provider
     * @summary Get models for a specific provider
     * @param {string} provider Name of the model provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiModelsProviderGet(provider: string, options?: RawAxiosRequestConfig) {
        return ModelsApiFp(this.configuration).apiModelsProviderGet(provider, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NetworkPolicyApi - axios parameter creator
 */
export const NetworkPolicyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set or clear an agent\'s egress mode override
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest} apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut: async (teamId: number, agentId: number, apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest: ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut', 'agentId', agentId)
            // verify required parameter 'apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut', 'apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest', apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest)
            const localVarPath = `/api/teams/{teamId}/agents/{agentId}/network-egress-mode`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke an approved domain
         * @param {number} teamId 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete: async (teamId: number, domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete', 'teamId', teamId)
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete', 'domain', domain)
            const localVarPath = `/api/teams/{teamId}/network-policy/approved-domains`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List approved egress domains
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyApprovedDomainsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyApprovedDomainsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/network-policy/approved-domains`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually approve a domain
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest} apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyApprovedDomainsPost: async (teamId: number, apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest: ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyApprovedDomainsPost', 'teamId', teamId)
            // verify required parameter 'apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyApprovedDomainsPost', 'apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest', apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest)
            const localVarPath = `/api/teams/{teamId}/network-policy/approved-domains`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recent egress allow/block activity
         * @param {number} teamId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyDecisionsGet: async (teamId: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyDecisionsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/network-policy/decisions`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a team\'s network policy, presets, and snapshot status
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/network-policy`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List egress port rules for the team (or a workspace)
         * @param {number} teamId 
         * @param {number} [workspaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPortRulesGet: async (teamId: number, workspaceId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPortRulesGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/network-policy/port-rules`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an egress port rule
         * @param {number} teamId 
         * @param {number} id 
         * @param {ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum} [workspaceDisposition] Required for team rules; ignored for workspace-scoped rules.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPortRulesIdDelete: async (teamId: number, id: number, workspaceDisposition?: ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPortRulesIdDelete', 'teamId', teamId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPortRulesIdDelete', 'id', id)
            const localVarPath = `/api/teams/{teamId}/network-policy/port-rules/{id}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (workspaceDisposition !== undefined) {
                localVarQueryParameter['workspaceDisposition'] = workspaceDisposition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count workspaces affected by removing a team egress rule
         * @param {number} teamId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet: async (teamId: number, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet', 'teamId', teamId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet', 'id', id)
            const localVarPath = `/api/teams/{teamId}/network-policy/port-rules/{id}/removal-impact`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add an egress port rule
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest} apiTeamsTeamIdNetworkPolicyPortRulesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPortRulesPost: async (teamId: number, apiTeamsTeamIdNetworkPolicyPortRulesPostRequest: ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPortRulesPost', 'teamId', teamId)
            // verify required parameter 'apiTeamsTeamIdNetworkPolicyPortRulesPostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPortRulesPost', 'apiTeamsTeamIdNetworkPolicyPortRulesPostRequest', apiTeamsTeamIdNetworkPolicyPortRulesPostRequest)
            const localVarPath = `/api/teams/{teamId}/network-policy/port-rules`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdNetworkPolicyPortRulesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a team\'s network policy
         * @param {number} teamId 
         * @param {TeamNetworkPolicyInput} teamNetworkPolicyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPut: async (teamId: number, teamNetworkPolicyInput: TeamNetworkPolicyInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPut', 'teamId', teamId)
            // verify required parameter 'teamNetworkPolicyInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyPut', 'teamNetworkPolicyInput', teamNetworkPolicyInput)
            const localVarPath = `/api/teams/{teamId}/network-policy`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamNetworkPolicyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Network access request history
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyRequestsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyRequestsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/network-policy/requests`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all workspace-scoped port rules for the team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/network-policy/workspace-port-rules`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetworkPolicyApi - functional programming interface
 */
export const NetworkPolicyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NetworkPolicyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Set or clear an agent\'s egress mode override
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest} apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut(teamId: number, agentId: number, apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest: ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut(teamId, agentId, apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke an approved domain
         * @param {number} teamId 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete(teamId: number, domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete(teamId, domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List approved egress domains
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyApprovedDomainsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApprovedEgressDomain>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyApprovedDomainsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyApprovedDomainsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manually approve a domain
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest} apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyApprovedDomainsPost(teamId: number, apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest: ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyApprovedDomainsPost(teamId, apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyApprovedDomainsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recent egress allow/block activity
         * @param {number} teamId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyDecisionsGet(teamId: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EgressDecisionView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyDecisionsGet(teamId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyDecisionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a team\'s network policy, presets, and snapshot status
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamNetworkPolicyBundle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List egress port rules for the team (or a workspace)
         * @param {number} teamId 
         * @param {number} [workspaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyPortRulesGet(teamId: number, workspaceId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EgressPortRuleView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyPortRulesGet(teamId, workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyPortRulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove an egress port rule
         * @param {number} teamId 
         * @param {number} id 
         * @param {ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum} [workspaceDisposition] Required for team rules; ignored for workspace-scoped rules.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyPortRulesIdDelete(teamId: number, id: number, workspaceDisposition?: ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyPortRulesIdDelete(teamId, id, workspaceDisposition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyPortRulesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Count workspaces affected by removing a team egress rule
         * @param {number} teamId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet(teamId: number, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EgressRuleRemovalImpact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet(teamId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add an egress port rule
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest} apiTeamsTeamIdNetworkPolicyPortRulesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyPortRulesPost(teamId: number, apiTeamsTeamIdNetworkPolicyPortRulesPostRequest: ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyPortRulesPost(teamId, apiTeamsTeamIdNetworkPolicyPortRulesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyPortRulesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a team\'s network policy
         * @param {number} teamId 
         * @param {TeamNetworkPolicyInput} teamNetworkPolicyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyPut(teamId: number, teamNetworkPolicyInput: TeamNetworkPolicyInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyPut(teamId, teamNetworkPolicyInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Network access request history
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyRequestsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetworkAccessRequestView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyRequestsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all workspace-scoped port rules for the team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EgressPortRuleView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NetworkPolicyApi.apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NetworkPolicyApi - factory interface
 */
export const NetworkPolicyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NetworkPolicyApiFp(configuration)
    return {
        /**
         * 
         * @summary Set or clear an agent\'s egress mode override
         * @param {number} teamId 
         * @param {number} agentId 
         * @param {ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest} apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut(teamId: number, agentId: number, apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest: ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut(teamId, agentId, apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke an approved domain
         * @param {number} teamId 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete(teamId: number, domain: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete(teamId, domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List approved egress domains
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyApprovedDomainsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApprovedEgressDomain>> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyApprovedDomainsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually approve a domain
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest} apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyApprovedDomainsPost(teamId: number, apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest: ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyApprovedDomainsPost(teamId, apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recent egress allow/block activity
         * @param {number} teamId 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyDecisionsGet(teamId: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EgressDecisionView>> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyDecisionsGet(teamId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a team\'s network policy, presets, and snapshot status
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamNetworkPolicyBundle> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List egress port rules for the team (or a workspace)
         * @param {number} teamId 
         * @param {number} [workspaceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPortRulesGet(teamId: number, workspaceId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EgressPortRuleView>> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyPortRulesGet(teamId, workspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an egress port rule
         * @param {number} teamId 
         * @param {number} id 
         * @param {ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum} [workspaceDisposition] Required for team rules; ignored for workspace-scoped rules.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPortRulesIdDelete(teamId: number, id: number, workspaceDisposition?: ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyPortRulesIdDelete(teamId, id, workspaceDisposition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count workspaces affected by removing a team egress rule
         * @param {number} teamId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet(teamId: number, id: number, options?: RawAxiosRequestConfig): AxiosPromise<EgressRuleRemovalImpact> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet(teamId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add an egress port rule
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest} apiTeamsTeamIdNetworkPolicyPortRulesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPortRulesPost(teamId: number, apiTeamsTeamIdNetworkPolicyPortRulesPostRequest: ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyPortRulesPost(teamId, apiTeamsTeamIdNetworkPolicyPortRulesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a team\'s network policy
         * @param {number} teamId 
         * @param {TeamNetworkPolicyInput} teamNetworkPolicyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyPut(teamId: number, teamNetworkPolicyInput: TeamNetworkPolicyInput, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyPut(teamId, teamNetworkPolicyInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Network access request history
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyRequestsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<NetworkAccessRequestView>> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyRequestsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all workspace-scoped port rules for the team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EgressPortRuleView>> {
            return localVarFp.apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet(teamId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetworkPolicyApi - object-oriented interface
 */
export class NetworkPolicyApi extends BaseAPI {
    /**
     * 
     * @summary Set or clear an agent\'s egress mode override
     * @param {number} teamId 
     * @param {number} agentId 
     * @param {ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest} apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut(teamId: number, agentId: number, apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest: ApiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdAgentsAgentIdNetworkEgressModePut(teamId, agentId, apiTeamsTeamIdAgentsAgentIdNetworkEgressModePutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke an approved domain
     * @param {number} teamId 
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete(teamId: number, domain: string, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyApprovedDomainsDelete(teamId, domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List approved egress domains
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyApprovedDomainsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyApprovedDomainsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manually approve a domain
     * @param {number} teamId 
     * @param {ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest} apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyApprovedDomainsPost(teamId: number, apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest: ApiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyApprovedDomainsPost(teamId, apiTeamsTeamIdNetworkPolicyApprovedDomainsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recent egress allow/block activity
     * @param {number} teamId 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyDecisionsGet(teamId: number, limit?: number, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyDecisionsGet(teamId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a team\'s network policy, presets, and snapshot status
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyGet(teamId: number, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List egress port rules for the team (or a workspace)
     * @param {number} teamId 
     * @param {number} [workspaceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyPortRulesGet(teamId: number, workspaceId?: number, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyPortRulesGet(teamId, workspaceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an egress port rule
     * @param {number} teamId 
     * @param {number} id 
     * @param {ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum} [workspaceDisposition] Required for team rules; ignored for workspace-scoped rules.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyPortRulesIdDelete(teamId: number, id: number, workspaceDisposition?: ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyPortRulesIdDelete(teamId, id, workspaceDisposition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count workspaces affected by removing a team egress rule
     * @param {number} teamId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet(teamId: number, id: number, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyPortRulesIdRemovalImpactGet(teamId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add an egress port rule
     * @param {number} teamId 
     * @param {ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest} apiTeamsTeamIdNetworkPolicyPortRulesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyPortRulesPost(teamId: number, apiTeamsTeamIdNetworkPolicyPortRulesPostRequest: ApiTeamsTeamIdNetworkPolicyPortRulesPostRequest, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyPortRulesPost(teamId, apiTeamsTeamIdNetworkPolicyPortRulesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a team\'s network policy
     * @param {number} teamId 
     * @param {TeamNetworkPolicyInput} teamNetworkPolicyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyPut(teamId: number, teamNetworkPolicyInput: TeamNetworkPolicyInput, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyPut(teamId, teamNetworkPolicyInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Network access request history
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyRequestsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyRequestsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all workspace-scoped port rules for the team
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet(teamId: number, options?: RawAxiosRequestConfig) {
        return NetworkPolicyApiFp(this.configuration).apiTeamsTeamIdNetworkPolicyWorkspacePortRulesGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum = {
    Keep: 'keep',
    Remove: 'remove'
} as const;
export type ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum = typeof ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum[keyof typeof ApiTeamsTeamIdNetworkPolicyPortRulesIdDeleteWorkspaceDispositionEnum];


/**
 * NotificationsApi - axios parameter creator
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List the current user\'s notifications (newest first)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark one notification as viewed
         * @param {number} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsNotificationIdViewedPost: async (notificationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('apiNotificationsNotificationIdViewedPost', 'notificationId', notificationId)
            const localVarPath = `/api/notifications/{notificationId}/viewed`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the current user\'s notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPreferencesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the current user\'s notification preferences
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPreferencesPut: async (updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateNotificationPreferencesRequest' is not null or undefined
            assertParamExists('apiNotificationsPreferencesPut', 'updateNotificationPreferencesRequest', updateNotificationPreferencesRequest)
            const localVarPath = `/api/notifications/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationPreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark all of the current user\'s notifications as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsViewedAllPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/viewed-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm a visible Helpful Communications unsubscribe action
         * @param {string} token Signed Helpful-only unsubscribe capability.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmHelpfulCommunicationsUnsubscribe: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('confirmHelpfulCommunicationsUnsubscribe', 'token', token)
            const localVarPath = `/api/notification-preferences/unsubscribe/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove all of the current user\'s App notification devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllWebPushSubscriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/push/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove one existing App notification device using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublicWebPushDevice: async (xNotificationPreferenceToken: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xNotificationPreferenceToken' is not null or undefined
            assertParamExists('deletePublicWebPushDevice', 'xNotificationPreferenceToken', xNotificationPreferenceToken)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePublicWebPushDevice', 'id', id)
            const localVarPath = `/api/notification-preferences/devices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xNotificationPreferenceToken != null) {
                localVarHeaderParameter['X-Notification-Preference-Token'] = String(xNotificationPreferenceToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove one App notification device owned by the current user
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebPushSubscription: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteWebPushSubscription', 'id', id)
            const localVarPath = `/api/notifications/push/subscriptions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read sanitized notification preferences using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicNotificationPreferences: async (xNotificationPreferenceToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xNotificationPreferenceToken' is not null or undefined
            assertParamExists('getPublicNotificationPreferences', 'xNotificationPreferenceToken', xNotificationPreferenceToken)
            const localVarPath = `/api/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xNotificationPreferenceToken != null) {
                localVarHeaderParameter['X-Notification-Preference-Token'] = String(xNotificationPreferenceToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get App notification Web Push configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebPushConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/push/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the current user\'s sanitized App notification devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebPushSubscriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/push/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark the notification represented by a signed App notification click receipt as viewed
         * @param {WebPushClickReceiptRequest} webPushClickReceiptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markWebPushClickViewed: async (webPushClickReceiptRequest: WebPushClickReceiptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webPushClickReceiptRequest' is not null or undefined
            assertParamExists('markWebPushClickViewed', 'webPushClickReceiptRequest', webPushClickReceiptRequest)
            const localVarPath = `/api/notifications/push/click/viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webPushClickReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary RFC 8058 one-click Helpful Communications unsubscribe
         * @param {string} token Signed Helpful-only unsubscribe capability.
         * @param {OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum} listUnsubscribe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oneClickUnsubscribeHelpfulCommunications: async (token: string, listUnsubscribe: OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('oneClickUnsubscribeHelpfulCommunications', 'token', token)
            // verify required parameter 'listUnsubscribe' is not null or undefined
            assertParamExists('oneClickUnsubscribeHelpfulCommunications', 'listUnsubscribe', listUnsubscribe)
            const localVarPath = `/api/notification-preferences/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


            if (listUnsubscribe !== undefined) { 
                localVarFormParams.set('List-Unsubscribe', listUnsubscribe as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts only the full local Push API subscription capability. It never accepts a notification destination URL.
         * @summary Queue a safe test App notification for the current local subscription
         * @param {WebPushTestRequest} webPushTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueWebPushTestNotification: async (webPushTestRequest: WebPushTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webPushTestRequest' is not null or undefined
            assertParamExists('queueWebPushTestNotification', 'webPushTestRequest', webPushTestRequest)
            const localVarPath = `/api/notifications/push/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webPushTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register or reconcile this browser\'s App notification device
         * @param {RegisterWebPushSubscriptionRequest} registerWebPushSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWebPushSubscription: async (registerWebPushSubscriptionRequest: RegisterWebPushSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerWebPushSubscriptionRequest' is not null or undefined
            assertParamExists('registerWebPushSubscription', 'registerWebPushSubscriptionRequest', registerWebPushSubscriptionRequest)
            const localVarPath = `/api/notifications/push/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerWebPushSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Neutrally request a replacement for a correctly signed expired management link
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendPublicNotificationPreferenceLink: async (xNotificationPreferenceToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xNotificationPreferenceToken' is not null or undefined
            assertParamExists('resendPublicNotificationPreferenceLink', 'xNotificationPreferenceToken', xNotificationPreferenceToken)
            const localVarPath = `/api/notification-preferences/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xNotificationPreferenceToken != null) {
                localVarHeaderParameter['X-Notification-Preference-Token'] = String(xNotificationPreferenceToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record the current user\'s Helpful Communications email consent
         * @param {AuthenticatedMarketingEmailConsentRequest} authenticatedMarketingEmailConsentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingEmailConsent: async (authenticatedMarketingEmailConsentRequest: AuthenticatedMarketingEmailConsentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authenticatedMarketingEmailConsentRequest' is not null or undefined
            assertParamExists('updateMarketingEmailConsent', 'authenticatedMarketingEmailConsentRequest', authenticatedMarketingEmailConsentRequest)
            const localVarPath = `/api/notifications/preferences/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticatedMarketingEmailConsentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record Helpful Communications email consent using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {PublicMarketingEmailConsentRequest} publicMarketingEmailConsentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicMarketingEmailConsent: async (xNotificationPreferenceToken: string, publicMarketingEmailConsentRequest: PublicMarketingEmailConsentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xNotificationPreferenceToken' is not null or undefined
            assertParamExists('updatePublicMarketingEmailConsent', 'xNotificationPreferenceToken', xNotificationPreferenceToken)
            // verify required parameter 'publicMarketingEmailConsentRequest' is not null or undefined
            assertParamExists('updatePublicMarketingEmailConsent', 'publicMarketingEmailConsentRequest', publicMarketingEmailConsentRequest)
            const localVarPath = `/api/notification-preferences/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xNotificationPreferenceToken != null) {
                localVarHeaderParameter['X-Notification-Preference-Token'] = String(xNotificationPreferenceToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicMarketingEmailConsentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update account notification preferences using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicNotificationPreferences: async (xNotificationPreferenceToken: string, updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xNotificationPreferenceToken' is not null or undefined
            assertParamExists('updatePublicNotificationPreferences', 'xNotificationPreferenceToken', xNotificationPreferenceToken)
            // verify required parameter 'updateNotificationPreferencesRequest' is not null or undefined
            assertParamExists('updatePublicNotificationPreferences', 'updateNotificationPreferencesRequest', updateNotificationPreferencesRequest)
            const localVarPath = `/api/notification-preferences/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xNotificationPreferenceToken != null) {
                localVarHeaderParameter['X-Notification-Preference-Token'] = String(xNotificationPreferenceToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationPreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update one existing App notification device using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {number} id 
         * @param {UpdateWebPushDevicePreferencesRequest} updateWebPushDevicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicWebPushDevicePreferences: async (xNotificationPreferenceToken: string, id: number, updateWebPushDevicePreferencesRequest: UpdateWebPushDevicePreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xNotificationPreferenceToken' is not null or undefined
            assertParamExists('updatePublicWebPushDevicePreferences', 'xNotificationPreferenceToken', xNotificationPreferenceToken)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePublicWebPushDevicePreferences', 'id', id)
            // verify required parameter 'updateWebPushDevicePreferencesRequest' is not null or undefined
            assertParamExists('updatePublicWebPushDevicePreferences', 'updateWebPushDevicePreferencesRequest', updateWebPushDevicePreferencesRequest)
            const localVarPath = `/api/notification-preferences/devices/{id}/preferences`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xNotificationPreferenceToken != null) {
                localVarHeaderParameter['X-Notification-Preference-Token'] = String(xNotificationPreferenceToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWebPushDevicePreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update category preferences for one App notification device
         * @param {number} id 
         * @param {UpdateWebPushDevicePreferencesRequest} updateWebPushDevicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebPushDevicePreferences: async (id: number, updateWebPushDevicePreferencesRequest: UpdateWebPushDevicePreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWebPushDevicePreferences', 'id', id)
            // verify required parameter 'updateWebPushDevicePreferencesRequest' is not null or undefined
            assertParamExists('updateWebPushDevicePreferences', 'updateWebPushDevicePreferencesRequest', updateWebPushDevicePreferencesRequest)
            const localVarPath = `/api/notifications/push/subscriptions/{id}/preferences`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWebPushDevicePreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List the current user\'s notifications (newest first)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark one notification as viewed
         * @param {number} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsNotificationIdViewedPost(notificationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsNotificationIdViewedPost(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsNotificationIdViewedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the current user\'s notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsPreferencesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsPreferencesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsPreferencesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the current user\'s notification preferences
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsPreferencesPut(updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsPreferencesPut(updateNotificationPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsPreferencesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark all of the current user\'s notifications as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsViewedAllPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsViewedAllPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsViewedAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm a visible Helpful Communications unsubscribe action
         * @param {string} token Signed Helpful-only unsubscribe capability.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmHelpfulCommunicationsUnsubscribe(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmHelpfulCommunicationsUnsubscribe(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.confirmHelpfulCommunicationsUnsubscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove all of the current user\'s App notification devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllWebPushSubscriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveAllWebPushDevicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllWebPushSubscriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.deleteAllWebPushSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove one existing App notification device using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePublicWebPushDevice(xNotificationPreferenceToken: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePublicWebPushDevice(xNotificationPreferenceToken, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.deletePublicWebPushDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove one App notification device owned by the current user
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWebPushSubscription(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWebPushSubscription(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.deleteWebPushSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read sanitized notification preferences using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicNotificationPreferences(xNotificationPreferenceToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicNotificationPreferences(xNotificationPreferenceToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getPublicNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get App notification Web Push configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebPushConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebPushConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebPushConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getWebPushConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the current user\'s sanitized App notification devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWebPushSubscriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebPushDeviceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWebPushSubscriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listWebPushSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark the notification represented by a signed App notification click receipt as viewed
         * @param {WebPushClickReceiptRequest} webPushClickReceiptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markWebPushClickViewed(webPushClickReceiptRequest: WebPushClickReceiptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markWebPushClickViewed(webPushClickReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markWebPushClickViewed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary RFC 8058 one-click Helpful Communications unsubscribe
         * @param {string} token Signed Helpful-only unsubscribe capability.
         * @param {OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum} listUnsubscribe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oneClickUnsubscribeHelpfulCommunications(token: string, listUnsubscribe: OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oneClickUnsubscribeHelpfulCommunications(token, listUnsubscribe, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.oneClickUnsubscribeHelpfulCommunications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts only the full local Push API subscription capability. It never accepts a notification destination URL.
         * @summary Queue a safe test App notification for the current local subscription
         * @param {WebPushTestRequest} webPushTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queueWebPushTestNotification(webPushTestRequest: WebPushTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queueWebPushTestNotification(webPushTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.queueWebPushTestNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register or reconcile this browser\'s App notification device
         * @param {RegisterWebPushSubscriptionRequest} registerWebPushSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerWebPushSubscription(registerWebPushSubscriptionRequest: RegisterWebPushSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebPushDeviceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerWebPushSubscription(registerWebPushSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.registerWebPushSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Neutrally request a replacement for a correctly signed expired management link
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendPublicNotificationPreferenceLink(xNotificationPreferenceToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationPreferenceResendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendPublicNotificationPreferenceLink(xNotificationPreferenceToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.resendPublicNotificationPreferenceLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record the current user\'s Helpful Communications email consent
         * @param {AuthenticatedMarketingEmailConsentRequest} authenticatedMarketingEmailConsentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMarketingEmailConsent(authenticatedMarketingEmailConsentRequest: AuthenticatedMarketingEmailConsentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingEmailConsentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMarketingEmailConsent(authenticatedMarketingEmailConsentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateMarketingEmailConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record Helpful Communications email consent using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {PublicMarketingEmailConsentRequest} publicMarketingEmailConsentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePublicMarketingEmailConsent(xNotificationPreferenceToken: string, publicMarketingEmailConsentRequest: PublicMarketingEmailConsentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingEmailConsentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePublicMarketingEmailConsent(xNotificationPreferenceToken, publicMarketingEmailConsentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updatePublicMarketingEmailConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update account notification preferences using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePublicNotificationPreferences(xNotificationPreferenceToken: string, updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePublicNotificationPreferences(xNotificationPreferenceToken, updateNotificationPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updatePublicNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update one existing App notification device using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {number} id 
         * @param {UpdateWebPushDevicePreferencesRequest} updateWebPushDevicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePublicWebPushDevicePreferences(xNotificationPreferenceToken: string, id: number, updateWebPushDevicePreferencesRequest: UpdateWebPushDevicePreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebPushDeviceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePublicWebPushDevicePreferences(xNotificationPreferenceToken, id, updateWebPushDevicePreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updatePublicWebPushDevicePreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update category preferences for one App notification device
         * @param {number} id 
         * @param {UpdateWebPushDevicePreferencesRequest} updateWebPushDevicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWebPushDevicePreferences(id: number, updateWebPushDevicePreferencesRequest: UpdateWebPushDevicePreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebPushDeviceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWebPushDevicePreferences(id, updateWebPushDevicePreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateWebPushDevicePreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary List the current user\'s notifications (newest first)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGet(options?: RawAxiosRequestConfig): AxiosPromise<NotificationsResponse> {
            return localVarFp.apiNotificationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark one notification as viewed
         * @param {number} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsNotificationIdViewedPost(notificationId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiNotificationsNotificationIdViewedPost(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the current user\'s notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPreferencesGet(options?: RawAxiosRequestConfig): AxiosPromise<NotificationPreferencesResponse> {
            return localVarFp.apiNotificationsPreferencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the current user\'s notification preferences
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPreferencesPut(updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiNotificationsPreferencesPut(updateNotificationPreferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark all of the current user\'s notifications as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsViewedAllPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiNotificationsViewedAllPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm a visible Helpful Communications unsubscribe action
         * @param {string} token Signed Helpful-only unsubscribe capability.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmHelpfulCommunicationsUnsubscribe(token: string, options?: RawAxiosRequestConfig): AxiosPromise<OkResponse> {
            return localVarFp.confirmHelpfulCommunicationsUnsubscribe(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove all of the current user\'s App notification devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllWebPushSubscriptions(options?: RawAxiosRequestConfig): AxiosPromise<RemoveAllWebPushDevicesResponse> {
            return localVarFp.deleteAllWebPushSubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove one existing App notification device using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublicWebPushDevice(xNotificationPreferenceToken: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<OkResponse> {
            return localVarFp.deletePublicWebPushDevice(xNotificationPreferenceToken, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove one App notification device owned by the current user
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWebPushSubscription(id: number, options?: RawAxiosRequestConfig): AxiosPromise<OkResponse> {
            return localVarFp.deleteWebPushSubscription(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read sanitized notification preferences using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicNotificationPreferences(xNotificationPreferenceToken: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationPreferencesResponse> {
            return localVarFp.getPublicNotificationPreferences(xNotificationPreferenceToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get App notification Web Push configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebPushConfig(options?: RawAxiosRequestConfig): AxiosPromise<WebPushConfigResponse> {
            return localVarFp.getWebPushConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the current user\'s sanitized App notification devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebPushSubscriptions(options?: RawAxiosRequestConfig): AxiosPromise<WebPushDeviceListResponse> {
            return localVarFp.listWebPushSubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark the notification represented by a signed App notification click receipt as viewed
         * @param {WebPushClickReceiptRequest} webPushClickReceiptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markWebPushClickViewed(webPushClickReceiptRequest: WebPushClickReceiptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markWebPushClickViewed(webPushClickReceiptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary RFC 8058 one-click Helpful Communications unsubscribe
         * @param {string} token Signed Helpful-only unsubscribe capability.
         * @param {OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum} listUnsubscribe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oneClickUnsubscribeHelpfulCommunications(token: string, listUnsubscribe: OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.oneClickUnsubscribeHelpfulCommunications(token, listUnsubscribe, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts only the full local Push API subscription capability. It never accepts a notification destination URL.
         * @summary Queue a safe test App notification for the current local subscription
         * @param {WebPushTestRequest} webPushTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueWebPushTestNotification(webPushTestRequest: WebPushTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<OkResponse> {
            return localVarFp.queueWebPushTestNotification(webPushTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register or reconcile this browser\'s App notification device
         * @param {RegisterWebPushSubscriptionRequest} registerWebPushSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWebPushSubscription(registerWebPushSubscriptionRequest: RegisterWebPushSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebPushDeviceListResponse> {
            return localVarFp.registerWebPushSubscription(registerWebPushSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Neutrally request a replacement for a correctly signed expired management link
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendPublicNotificationPreferenceLink(xNotificationPreferenceToken: string, options?: RawAxiosRequestConfig): AxiosPromise<NotificationPreferenceResendResponse> {
            return localVarFp.resendPublicNotificationPreferenceLink(xNotificationPreferenceToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record the current user\'s Helpful Communications email consent
         * @param {AuthenticatedMarketingEmailConsentRequest} authenticatedMarketingEmailConsentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingEmailConsent(authenticatedMarketingEmailConsentRequest: AuthenticatedMarketingEmailConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarketingEmailConsentResponse> {
            return localVarFp.updateMarketingEmailConsent(authenticatedMarketingEmailConsentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record Helpful Communications email consent using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {PublicMarketingEmailConsentRequest} publicMarketingEmailConsentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicMarketingEmailConsent(xNotificationPreferenceToken: string, publicMarketingEmailConsentRequest: PublicMarketingEmailConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarketingEmailConsentResponse> {
            return localVarFp.updatePublicMarketingEmailConsent(xNotificationPreferenceToken, publicMarketingEmailConsentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update account notification preferences using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicNotificationPreferences(xNotificationPreferenceToken: string, updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<OkResponse> {
            return localVarFp.updatePublicNotificationPreferences(xNotificationPreferenceToken, updateNotificationPreferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update one existing App notification device using a management capability
         * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
         * @param {number} id 
         * @param {UpdateWebPushDevicePreferencesRequest} updateWebPushDevicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublicWebPushDevicePreferences(xNotificationPreferenceToken: string, id: number, updateWebPushDevicePreferencesRequest: UpdateWebPushDevicePreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebPushDeviceListResponse> {
            return localVarFp.updatePublicWebPushDevicePreferences(xNotificationPreferenceToken, id, updateWebPushDevicePreferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update category preferences for one App notification device
         * @param {number} id 
         * @param {UpdateWebPushDevicePreferencesRequest} updateWebPushDevicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebPushDevicePreferences(id: number, updateWebPushDevicePreferencesRequest: UpdateWebPushDevicePreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebPushDeviceListResponse> {
            return localVarFp.updateWebPushDevicePreferences(id, updateWebPushDevicePreferencesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary List the current user\'s notifications (newest first)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark one notification as viewed
     * @param {number} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsNotificationIdViewedPost(notificationId: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsNotificationIdViewedPost(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the current user\'s notification preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsPreferencesGet(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsPreferencesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the current user\'s notification preferences
     * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsPreferencesPut(updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsPreferencesPut(updateNotificationPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark all of the current user\'s notifications as viewed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiNotificationsViewedAllPost(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsViewedAllPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm a visible Helpful Communications unsubscribe action
     * @param {string} token Signed Helpful-only unsubscribe capability.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmHelpfulCommunicationsUnsubscribe(token: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).confirmHelpfulCommunicationsUnsubscribe(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove all of the current user\'s App notification devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAllWebPushSubscriptions(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).deleteAllWebPushSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove one existing App notification device using a management capability
     * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePublicWebPushDevice(xNotificationPreferenceToken: string, id: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).deletePublicWebPushDevice(xNotificationPreferenceToken, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove one App notification device owned by the current user
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteWebPushSubscription(id: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).deleteWebPushSubscription(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read sanitized notification preferences using a management capability
     * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPublicNotificationPreferences(xNotificationPreferenceToken: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getPublicNotificationPreferences(xNotificationPreferenceToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get App notification Web Push configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebPushConfig(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getWebPushConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the current user\'s sanitized App notification devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWebPushSubscriptions(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listWebPushSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark the notification represented by a signed App notification click receipt as viewed
     * @param {WebPushClickReceiptRequest} webPushClickReceiptRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markWebPushClickViewed(webPushClickReceiptRequest: WebPushClickReceiptRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markWebPushClickViewed(webPushClickReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary RFC 8058 one-click Helpful Communications unsubscribe
     * @param {string} token Signed Helpful-only unsubscribe capability.
     * @param {OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum} listUnsubscribe 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public oneClickUnsubscribeHelpfulCommunications(token: string, listUnsubscribe: OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).oneClickUnsubscribeHelpfulCommunications(token, listUnsubscribe, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts only the full local Push API subscription capability. It never accepts a notification destination URL.
     * @summary Queue a safe test App notification for the current local subscription
     * @param {WebPushTestRequest} webPushTestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queueWebPushTestNotification(webPushTestRequest: WebPushTestRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).queueWebPushTestNotification(webPushTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register or reconcile this browser\'s App notification device
     * @param {RegisterWebPushSubscriptionRequest} registerWebPushSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerWebPushSubscription(registerWebPushSubscriptionRequest: RegisterWebPushSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).registerWebPushSubscription(registerWebPushSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Neutrally request a replacement for a correctly signed expired management link
     * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendPublicNotificationPreferenceLink(xNotificationPreferenceToken: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).resendPublicNotificationPreferenceLink(xNotificationPreferenceToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record the current user\'s Helpful Communications email consent
     * @param {AuthenticatedMarketingEmailConsentRequest} authenticatedMarketingEmailConsentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMarketingEmailConsent(authenticatedMarketingEmailConsentRequest: AuthenticatedMarketingEmailConsentRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateMarketingEmailConsent(authenticatedMarketingEmailConsentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record Helpful Communications email consent using a management capability
     * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
     * @param {PublicMarketingEmailConsentRequest} publicMarketingEmailConsentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePublicMarketingEmailConsent(xNotificationPreferenceToken: string, publicMarketingEmailConsentRequest: PublicMarketingEmailConsentRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updatePublicMarketingEmailConsent(xNotificationPreferenceToken, publicMarketingEmailConsentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update account notification preferences using a management capability
     * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
     * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePublicNotificationPreferences(xNotificationPreferenceToken: string, updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updatePublicNotificationPreferences(xNotificationPreferenceToken, updateNotificationPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update one existing App notification device using a management capability
     * @param {string} xNotificationPreferenceToken Signed 24-hour management capability. It is never returned in a response.
     * @param {number} id 
     * @param {UpdateWebPushDevicePreferencesRequest} updateWebPushDevicePreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePublicWebPushDevicePreferences(xNotificationPreferenceToken: string, id: number, updateWebPushDevicePreferencesRequest: UpdateWebPushDevicePreferencesRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updatePublicWebPushDevicePreferences(xNotificationPreferenceToken, id, updateWebPushDevicePreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update category preferences for one App notification device
     * @param {number} id 
     * @param {UpdateWebPushDevicePreferencesRequest} updateWebPushDevicePreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWebPushDevicePreferences(id: number, updateWebPushDevicePreferencesRequest: UpdateWebPushDevicePreferencesRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateWebPushDevicePreferences(id, updateWebPushDevicePreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum = {
    OneClick: 'One-Click'
} as const;
export type OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum = typeof OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum[keyof typeof OneClickUnsubscribeHelpfulCommunicationsListUnsubscribeEnum];


/**
 * OAuthApi - axios parameter creator
 */
export const OAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get linked OAuth identities for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthIdentitiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/oauth/identities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlink an OAuth identity
         * @param {number} id ID of the OAuth identity to unlink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthIdentitiesIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAuthenticationOauthIdentitiesIdDelete', 'id', id)
            const localVarPath = `/api/authentication/oauth/identities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Handle OAuth callback
         * @param {string} provider OAuth provider ID
         * @param {string} code Authorization code from OAuth provider
         * @param {string} state State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProviderCallbackGet: async (provider: string, code: string, state: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('apiAuthenticationOauthProviderCallbackGet', 'provider', provider)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiAuthenticationOauthProviderCallbackGet', 'code', code)
            // verify required parameter 'state' is not null or undefined
            assertParamExists('apiAuthenticationOauthProviderCallbackGet', 'state', state)
            const localVarPath = `/api/authentication/oauth/{provider}/callback`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initiate OAuth flow
         * @param {string} provider OAuth provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProviderGet: async (provider: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('apiAuthenticationOauthProviderGet', 'provider', provider)
            const localVarPath = `/api/authentication/oauth/{provider}`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get available OAuth providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProvidersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/authentication/oauth/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OAuthApi - functional programming interface
 */
export const OAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get linked OAuth identities for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthIdentitiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationOauthIdentitiesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthIdentitiesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.apiAuthenticationOauthIdentitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlink an OAuth identity
         * @param {number} id ID of the OAuth identity to unlink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationOauthIdentitiesIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthIdentitiesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.apiAuthenticationOauthIdentitiesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Handle OAuth callback
         * @param {string} provider OAuth provider ID
         * @param {string} code Authorization code from OAuth provider
         * @param {string} state State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthProviderCallbackGet(provider: string, code: string, state: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthProviderCallbackGet(provider, code, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.apiAuthenticationOauthProviderCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initiate OAuth flow
         * @param {string} provider OAuth provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthProviderGet(provider: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthProviderGet(provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.apiAuthenticationOauthProviderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get available OAuth providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticationOauthProvidersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAuthenticationOauthProvidersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticationOauthProvidersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OAuthApi.apiAuthenticationOauthProvidersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OAuthApi - factory interface
 */
export const OAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OAuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Get linked OAuth identities for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthIdentitiesGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationOauthIdentitiesGet200Response> {
            return localVarFp.apiAuthenticationOauthIdentitiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlink an OAuth identity
         * @param {number} id ID of the OAuth identity to unlink
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationOauthIdentitiesIdDelete200Response> {
            return localVarFp.apiAuthenticationOauthIdentitiesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Handle OAuth callback
         * @param {string} provider OAuth provider ID
         * @param {string} code Authorization code from OAuth provider
         * @param {string} state State parameter for CSRF protection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProviderCallbackGet(provider: string, code: string, state: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthenticationOauthProviderCallbackGet(provider, code, state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initiate OAuth flow
         * @param {string} provider OAuth provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProviderGet(provider: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAuthenticationOauthProviderGet(provider, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get available OAuth providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticationOauthProvidersGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiAuthenticationOauthProvidersGet200Response> {
            return localVarFp.apiAuthenticationOauthProvidersGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OAuthApi - object-oriented interface
 */
export class OAuthApi extends BaseAPI {
    /**
     * 
     * @summary Get linked OAuth identities for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthIdentitiesGet(options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).apiAuthenticationOauthIdentitiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlink an OAuth identity
     * @param {number} id ID of the OAuth identity to unlink
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).apiAuthenticationOauthIdentitiesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Handle OAuth callback
     * @param {string} provider OAuth provider ID
     * @param {string} code Authorization code from OAuth provider
     * @param {string} state State parameter for CSRF protection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthProviderCallbackGet(provider: string, code: string, state: string, options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).apiAuthenticationOauthProviderCallbackGet(provider, code, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initiate OAuth flow
     * @param {string} provider OAuth provider ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthProviderGet(provider: string, options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).apiAuthenticationOauthProviderGet(provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get available OAuth providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAuthenticationOauthProvidersGet(options?: RawAxiosRequestConfig) {
        return OAuthApiFp(this.configuration).apiAuthenticationOauthProvidersGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * POIResultsApi - axios parameter creator
 */
export const POIResultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the generated emails and test data for a specific Point of Interest (POI)
         * @summary Get generated emails for a POI
         * @param {number} poiId ID of the POI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestResultsPoiPoiIdGeneratedEmailsGet: async (poiId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poiId' is not null or undefined
            assertParamExists('apiTestResultsPoiPoiIdGeneratedEmailsGet', 'poiId', poiId)
            const localVarPath = `/api/test-results/poi/{poiId}/generated-emails`
                .replace(`{${"poiId"}}`, encodeURIComponent(String(poiId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * POIResultsApi - functional programming interface
 */
export const POIResultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = POIResultsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the generated emails and test data for a specific Point of Interest (POI)
         * @summary Get generated emails for a POI
         * @param {number} poiId ID of the POI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestResultsPoiPoiIdGeneratedEmailsGet(poiId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<POIResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestResultsPoiPoiIdGeneratedEmailsGet(poiId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['POIResultsApi.apiTestResultsPoiPoiIdGeneratedEmailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * POIResultsApi - factory interface
 */
export const POIResultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = POIResultsApiFp(configuration)
    return {
        /**
         * Retrieve the generated emails and test data for a specific Point of Interest (POI)
         * @summary Get generated emails for a POI
         * @param {number} poiId ID of the POI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestResultsPoiPoiIdGeneratedEmailsGet(poiId: number, options?: RawAxiosRequestConfig): AxiosPromise<POIResults> {
            return localVarFp.apiTestResultsPoiPoiIdGeneratedEmailsGet(poiId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * POIResultsApi - object-oriented interface
 */
export class POIResultsApi extends BaseAPI {
    /**
     * Retrieve the generated emails and test data for a specific Point of Interest (POI)
     * @summary Get generated emails for a POI
     * @param {number} poiId ID of the POI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTestResultsPoiPoiIdGeneratedEmailsGet(poiId: number, options?: RawAxiosRequestConfig) {
        return POIResultsApiFp(this.configuration).apiTestResultsPoiPoiIdGeneratedEmailsGet(poiId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PersonasApi - axios parameter creator
 */
export const PersonasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Pins the agent\'s interaction model to the persona\'s first recommendation the team can run (the team default is kept when none resolves) and seeds the persona\'s discipline skills. User-authored skills with the same names are never overwritten.
         * @summary Apply a recommended persona to an existing agent
         * @param {number} agentId 
         * @param {ApplyAgentPersonaRequest} applyAgentPersonaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAgentPersona: async (agentId: number, applyAgentPersonaRequest: ApplyAgentPersonaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('applyAgentPersona', 'agentId', agentId)
            // verify required parameter 'applyAgentPersonaRequest' is not null or undefined
            assertParamExists('applyAgentPersona', 'applyAgentPersonaRequest', applyAgentPersonaRequest)
            const localVarPath = `/api/agents/{agentId}/persona`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyAgentPersonaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List recommended personas resolved for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamPersonas: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamPersonas', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/personas`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonasApi - functional programming interface
 */
export const PersonasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonasApiAxiosParamCreator(configuration)
    return {
        /**
         * Pins the agent\'s interaction model to the persona\'s first recommendation the team can run (the team default is kept when none resolves) and seeds the persona\'s discipline skills. User-authored skills with the same names are never overwritten.
         * @summary Apply a recommended persona to an existing agent
         * @param {number} agentId 
         * @param {ApplyAgentPersonaRequest} applyAgentPersonaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyAgentPersona(agentId: number, applyAgentPersonaRequest: ApplyAgentPersonaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplyPersonaResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyAgentPersona(agentId, applyAgentPersonaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonasApi.applyAgentPersona']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List recommended personas resolved for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamPersonas(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamPersonas(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonasApi.listTeamPersonas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PersonasApi - factory interface
 */
export const PersonasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonasApiFp(configuration)
    return {
        /**
         * Pins the agent\'s interaction model to the persona\'s first recommendation the team can run (the team default is kept when none resolves) and seeds the persona\'s discipline skills. User-authored skills with the same names are never overwritten.
         * @summary Apply a recommended persona to an existing agent
         * @param {number} agentId 
         * @param {ApplyAgentPersonaRequest} applyAgentPersonaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAgentPersona(agentId: number, applyAgentPersonaRequest: ApplyAgentPersonaRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplyPersonaResult> {
            return localVarFp.applyAgentPersona(agentId, applyAgentPersonaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List recommended personas resolved for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamPersonas(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<PersonaCatalog> {
            return localVarFp.listTeamPersonas(teamId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonasApi - object-oriented interface
 */
export class PersonasApi extends BaseAPI {
    /**
     * Pins the agent\'s interaction model to the persona\'s first recommendation the team can run (the team default is kept when none resolves) and seeds the persona\'s discipline skills. User-authored skills with the same names are never overwritten.
     * @summary Apply a recommended persona to an existing agent
     * @param {number} agentId 
     * @param {ApplyAgentPersonaRequest} applyAgentPersonaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public applyAgentPersona(agentId: number, applyAgentPersonaRequest: ApplyAgentPersonaRequest, options?: RawAxiosRequestConfig) {
        return PersonasApiFp(this.configuration).applyAgentPersona(agentId, applyAgentPersonaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List recommended personas resolved for a team
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTeamPersonas(teamId: number, options?: RawAxiosRequestConfig) {
        return PersonasApiFp(this.configuration).listTeamPersonas(teamId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectsApi - axios parameter creator
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a card attachment
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardAttachmentsAttachmentIdDelete: async (attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiProjectCardAttachmentsAttachmentIdDelete', 'attachmentId', attachmentId)
            const localVarPath = `/api/project-card-attachments/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a card attachment
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardAttachmentsAttachmentIdGet: async (attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('apiProjectCardAttachmentsAttachmentIdGet', 'attachmentId', attachmentId)
            const localVarPath = `/api/project-card-attachments/{attachmentId}`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a checklist task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardTasksTaskIdDelete: async (taskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('apiProjectCardTasksTaskIdDelete', 'taskId', taskId)
            const localVarPath = `/api/project-card-tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update or check off a checklist task
         * @param {number} taskId 
         * @param {ProjectTaskRequest} projectTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardTasksTaskIdPut: async (taskId: number, projectTaskRequest: ProjectTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('apiProjectCardTasksTaskIdPut', 'taskId', taskId)
            // verify required parameter 'projectTaskRequest' is not null or undefined
            assertParamExists('apiProjectCardTasksTaskIdPut', 'projectTaskRequest', projectTaskRequest)
            const localVarPath = `/api/project-card-tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Card activity feed
         * @param {number} cardId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdActivityGet: async (cardId: number, beforeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdActivityGet', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/activity`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (beforeId !== undefined) {
                localVarQueryParameter['beforeId'] = beforeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unassign an agent from a card
         * @param {number} cardId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdAgentsAgentIdDelete: async (cardId: number, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdAgentsAgentIdDelete', 'cardId', cardId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdAgentsAgentIdDelete', 'agentId', agentId)
            const localVarPath = `/api/project-cards/{cardId}/agents/{agentId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign an agent to a card
         * @param {number} cardId 
         * @param {ProjectAgentRequest} projectAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdAgentsPost: async (cardId: number, projectAgentRequest: ProjectAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdAgentsPost', 'cardId', cardId)
            // verify required parameter 'projectAgentRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdAgentsPost', 'projectAgentRequest', projectAgentRequest)
            const localVarPath = `/api/project-cards/{cardId}/agents`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an attachment to a card
         * @param {number} cardId 
         * @param {ProjectAttachmentUploadRequest} projectAttachmentUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdAttachmentsPost: async (cardId: number, projectAttachmentUploadRequest: ProjectAttachmentUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdAttachmentsPost', 'cardId', cardId)
            // verify required parameter 'projectAttachmentUploadRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdAttachmentsPost', 'projectAttachmentUploadRequest', projectAttachmentUploadRequest)
            const localVarPath = `/api/project-cards/{cardId}/attachments`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectAttachmentUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a card comment (Card comments edit permission)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsCommentIdArchivePost: async (cardId: number, commentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsCommentIdArchivePost', 'cardId', cardId)
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsCommentIdArchivePost', 'commentId', commentId)
            const localVarPath = `/api/project-cards/{cardId}/comments/{commentId}/archive`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)))
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reveal an archived card comment (human card viewers only)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsCommentIdArchivedGet: async (cardId: number, commentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsCommentIdArchivedGet', 'cardId', cardId)
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsCommentIdArchivedGet', 'commentId', commentId)
            const localVarPath = `/api/project-cards/{cardId}/comments/{commentId}/archived`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)))
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete an archived card comment (human Card comments manage permission)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsCommentIdDelete: async (cardId: number, commentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsCommentIdDelete', 'cardId', cardId)
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsCommentIdDelete', 'commentId', commentId)
            const localVarPath = `/api/project-cards/{cardId}/comments/{commentId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)))
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List card comments
         * @param {number} cardId 
         * @param {number} [afterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsGet: async (cardId: number, afterId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsGet', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/comments`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (afterId !== undefined) {
                localVarQueryParameter['afterId'] = afterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Comment on a card (mention agents with @)
         * @param {number} cardId 
         * @param {ProjectCommentRequest} projectCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsPost: async (cardId: number, projectCommentRequest: ProjectCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsPost', 'cardId', cardId)
            // verify required parameter 'projectCommentRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdCommentsPost', 'projectCommentRequest', projectCommentRequest)
            const localVarPath = `/api/project-cards/{cardId}/comments`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete an archived card (archive it first)
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdDelete: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdDelete', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a card dependency
         * @param {number} cardId 
         * @param {number} blockingCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdDependenciesBlockingCardIdDelete: async (cardId: number, blockingCardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdDependenciesBlockingCardIdDelete', 'cardId', cardId)
            // verify required parameter 'blockingCardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdDependenciesBlockingCardIdDelete', 'blockingCardId', blockingCardId)
            const localVarPath = `/api/project-cards/{cardId}/dependencies/{blockingCardId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)))
                .replace(`{${"blockingCardId"}}`, encodeURIComponent(String(blockingCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a dependency that must reach Done before this card can run
         * @param {number} cardId 
         * @param {ApiProjectCardsCardIdDependenciesPostRequest} apiProjectCardsCardIdDependenciesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdDependenciesPost: async (cardId: number, apiProjectCardsCardIdDependenciesPostRequest: ApiProjectCardsCardIdDependenciesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdDependenciesPost', 'cardId', cardId)
            // verify required parameter 'apiProjectCardsCardIdDependenciesPostRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdDependenciesPost', 'apiProjectCardsCardIdDependenciesPostRequest', apiProjectCardsCardIdDependenciesPostRequest)
            const localVarPath = `/api/project-cards/{cardId}/dependencies`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiProjectCardsCardIdDependenciesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start card work on a human\'s say-so (the move-in choice); refused for agent principals
         * @param {number} cardId 
         * @param {ProjectCardDispatchRequest} projectCardDispatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdDispatchPost: async (cardId: number, projectCardDispatchRequest: ProjectCardDispatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdDispatchPost', 'cardId', cardId)
            // verify required parameter 'projectCardDispatchRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdDispatchPost', 'projectCardDispatchRequest', projectCardDispatchRequest)
            const localVarPath = `/api/project-cards/{cardId}/dispatch`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCardDispatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get card detail
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdGet: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdGet', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move a card between columns
         * @param {number} cardId 
         * @param {ProjectCardMoveRequest} projectCardMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdMovePost: async (cardId: number, projectCardMoveRequest: ProjectCardMoveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdMovePost', 'cardId', cardId)
            // verify required parameter 'projectCardMoveRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdMovePost', 'projectCardMoveRequest', projectCardMoveRequest)
            const localVarPath = `/api/project-cards/{cardId}/move`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCardMoveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move a card to another project in the team
         * @param {number} cardId 
         * @param {ProjectCardMoveProjectRequest} projectCardMoveProjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdMoveProjectPost: async (cardId: number, projectCardMoveProjectRequest: ProjectCardMoveProjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdMoveProjectPost', 'cardId', cardId)
            // verify required parameter 'projectCardMoveProjectRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdMoveProjectPost', 'projectCardMoveProjectRequest', projectCardMoveProjectRequest)
            const localVarPath = `/api/project-cards/{cardId}/move-project`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCardMoveProjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary What must be resolved before moving this card to another project
         * @param {number} cardId 
         * @param {number} targetProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdMoveProjectPreflightGet: async (cardId: number, targetProjectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdMoveProjectPreflightGet', 'cardId', cardId)
            // verify required parameter 'targetProjectId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdMoveProjectPreflightGet', 'targetProjectId', targetProjectId)
            const localVarPath = `/api/project-cards/{cardId}/move-project-preflight`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (targetProjectId !== undefined) {
                localVarQueryParameter['targetProjectId'] = targetProjectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a card
         * @param {number} cardId 
         * @param {ProjectCardUpdateRequest} projectCardUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdPut: async (cardId: number, projectCardUpdateRequest: ProjectCardUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdPut', 'cardId', cardId)
            // verify required parameter 'projectCardUpdateRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdPut', 'projectCardUpdateRequest', projectCardUpdateRequest)
            const localVarPath = `/api/project-cards/{cardId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCardUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a checklist task
         * @param {number} cardId 
         * @param {ProjectTaskRequest} projectTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdTasksPost: async (cardId: number, projectTaskRequest: ProjectTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdTasksPost', 'cardId', cardId)
            // verify required parameter 'projectTaskRequest' is not null or undefined
            assertParamExists('apiProjectCardsCardIdTasksPost', 'projectTaskRequest', projectTaskRequest)
            const localVarPath = `/api/project-cards/{cardId}/tasks`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete an archived column (archive it first)
         * @param {number} columnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectColumnsColumnIdDelete: async (columnId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnId' is not null or undefined
            assertParamExists('apiProjectColumnsColumnIdDelete', 'columnId', columnId)
            const localVarPath = `/api/project-columns/{columnId}`
                .replace(`{${"columnId"}}`, encodeURIComponent(String(columnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update or archive/restore a board column (archiving moves its cards)
         * @param {number} columnId 
         * @param {ProjectColumnRequest} projectColumnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectColumnsColumnIdPut: async (columnId: number, projectColumnRequest: ProjectColumnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'columnId' is not null or undefined
            assertParamExists('apiProjectColumnsColumnIdPut', 'columnId', columnId)
            // verify required parameter 'projectColumnRequest' is not null or undefined
            assertParamExists('apiProjectColumnsColumnIdPut', 'projectColumnRequest', projectColumnRequest)
            const localVarPath = `/api/project-columns/{columnId}`
                .replace(`{${"columnId"}}`, encodeURIComponent(String(columnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectColumnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete an archived epic and its archived cards (archive it first)
         * @param {number} epicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectEpicsEpicIdDelete: async (epicId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'epicId' is not null or undefined
            assertParamExists('apiProjectEpicsEpicIdDelete', 'epicId', epicId)
            const localVarPath = `/api/project-epics/{epicId}`
                .replace(`{${"epicId"}}`, encodeURIComponent(String(epicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update or archive/restore an epic (archiving archives its cards; restoring restores them)
         * @param {number} epicId 
         * @param {ProjectEpicRequest} projectEpicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectEpicsEpicIdPut: async (epicId: number, projectEpicRequest: ProjectEpicRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'epicId' is not null or undefined
            assertParamExists('apiProjectEpicsEpicIdPut', 'epicId', epicId)
            // verify required parameter 'projectEpicRequest' is not null or undefined
            assertParamExists('apiProjectEpicsEpicIdPut', 'projectEpicRequest', projectEpicRequest)
            const localVarPath = `/api/project-epics/{epicId}`
                .replace(`{${"epicId"}}`, encodeURIComponent(String(epicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectEpicRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete an archived label (archive it first)
         * @param {number} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectLabelsLabelIdDelete: async (labelId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('apiProjectLabelsLabelIdDelete', 'labelId', labelId)
            const localVarPath = `/api/project-labels/{labelId}`
                .replace(`{${"labelId"}}`, encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update or archive/restore a label (archived labels keep their card associations)
         * @param {number} labelId 
         * @param {ProjectLabelRequest} projectLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectLabelsLabelIdPut: async (labelId: number, projectLabelRequest: ProjectLabelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('apiProjectLabelsLabelIdPut', 'labelId', labelId)
            // verify required parameter 'projectLabelRequest' is not null or undefined
            assertParamExists('apiProjectLabelsLabelIdPut', 'projectLabelRequest', projectLabelRequest)
            const localVarPath = `/api/project-labels/{labelId}`
                .replace(`{${"labelId"}}`, encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectLabelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete an archived sprint; its cards drop to the backlog (archive it first)
         * @param {number} sprintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectSprintsSprintIdDelete: async (sprintId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sprintId' is not null or undefined
            assertParamExists('apiProjectSprintsSprintIdDelete', 'sprintId', sprintId)
            const localVarPath = `/api/project-sprints/{sprintId}`
                .replace(`{${"sprintId"}}`, encodeURIComponent(String(sprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Take an epic row off a sprint, moving its sprint cards to another epic
         * @param {number} sprintId 
         * @param {number} epicId 
         * @param {number} moveCardsTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectSprintsSprintIdEpicsEpicIdDelete: async (sprintId: number, epicId: number, moveCardsTo: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sprintId' is not null or undefined
            assertParamExists('apiProjectSprintsSprintIdEpicsEpicIdDelete', 'sprintId', sprintId)
            // verify required parameter 'epicId' is not null or undefined
            assertParamExists('apiProjectSprintsSprintIdEpicsEpicIdDelete', 'epicId', epicId)
            // verify required parameter 'moveCardsTo' is not null or undefined
            assertParamExists('apiProjectSprintsSprintIdEpicsEpicIdDelete', 'moveCardsTo', moveCardsTo)
            const localVarPath = `/api/project-sprints/{sprintId}/epics/{epicId}`
                .replace(`{${"sprintId"}}`, encodeURIComponent(String(sprintId)))
                .replace(`{${"epicId"}}`, encodeURIComponent(String(epicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (moveCardsTo !== undefined) {
                localVarQueryParameter['moveCardsTo'] = moveCardsTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update or archive a sprint (an archived sprint keeps its cards)
         * @param {number} sprintId 
         * @param {ProjectSprintRequest} projectSprintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectSprintsSprintIdPut: async (sprintId: number, projectSprintRequest: ProjectSprintRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sprintId' is not null or undefined
            assertParamExists('apiProjectSprintsSprintIdPut', 'sprintId', sprintId)
            // verify required parameter 'projectSprintRequest' is not null or undefined
            assertParamExists('apiProjectSprintsSprintIdPut', 'projectSprintRequest', projectSprintRequest)
            const localVarPath = `/api/project-sprints/{sprintId}`
                .replace(`{${"sprintId"}}`, encodeURIComponent(String(sprintId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectSprintRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Project activity feed
         * @param {number} projectId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdActivityGet: async (projectId: number, beforeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdActivityGet', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}/activity`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (beforeId !== undefined) {
                localVarQueryParameter['beforeId'] = beforeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an agent from a project
         * @param {number} projectId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdAgentsAgentIdDelete: async (projectId: number, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdAgentsAgentIdDelete', 'projectId', projectId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiProjectsProjectIdAgentsAgentIdDelete', 'agentId', agentId)
            const localVarPath = `/api/projects/{projectId}/agents/{agentId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Associate an agent with a project
         * @param {number} projectId 
         * @param {ProjectAgentRequest} projectAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdAgentsPost: async (projectId: number, projectAgentRequest: ProjectAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdAgentsPost', 'projectId', projectId)
            // verify required parameter 'projectAgentRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdAgentsPost', 'projectAgentRequest', projectAgentRequest)
            const localVarPath = `/api/projects/{projectId}/agents`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a card (milestone)
         * @param {number} projectId 
         * @param {ProjectCardCreateRequest} projectCardCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdCardsPost: async (projectId: number, projectCardCreateRequest: ProjectCardCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdCardsPost', 'projectId', projectId)
            // verify required parameter 'projectCardCreateRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdCardsPost', 'projectCardCreateRequest', projectCardCreateRequest)
            const localVarPath = `/api/projects/{projectId}/cards`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCardCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a board column
         * @param {number} projectId 
         * @param {ProjectColumnRequest} projectColumnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdColumnsPost: async (projectId: number, projectColumnRequest: ProjectColumnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdColumnsPost', 'projectId', projectId)
            // verify required parameter 'projectColumnRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdColumnsPost', 'projectColumnRequest', projectColumnRequest)
            const localVarPath = `/api/projects/{projectId}/columns`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectColumnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete an archived project (archive it first)
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdDelete: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdDelete', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an epic (board row)
         * @param {number} projectId 
         * @param {ProjectEpicRequest} projectEpicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdEpicsPost: async (projectId: number, projectEpicRequest: ProjectEpicRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdEpicsPost', 'projectId', projectId)
            // verify required parameter 'projectEpicRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdEpicsPost', 'projectEpicRequest', projectEpicRequest)
            const localVarPath = `/api/projects/{projectId}/epics`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectEpicRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the project board
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdGet: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdGet', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename a label group; every label in it moves at once
         * @param {number} projectId 
         * @param {ProjectLabelGroupRenameRequest} projectLabelGroupRenameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdLabelGroupsPut: async (projectId: number, projectLabelGroupRenameRequest: ProjectLabelGroupRenameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdLabelGroupsPut', 'projectId', projectId)
            // verify required parameter 'projectLabelGroupRenameRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdLabelGroupsPut', 'projectLabelGroupRenameRequest', projectLabelGroupRenameRequest)
            const localVarPath = `/api/projects/{projectId}/label-groups`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectLabelGroupRenameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a label
         * @param {number} projectId 
         * @param {ProjectLabelRequest} projectLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdLabelsPost: async (projectId: number, projectLabelRequest: ProjectLabelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdLabelsPost', 'projectId', projectId)
            // verify required parameter 'projectLabelRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdLabelsPost', 'projectLabelRequest', projectLabelRequest)
            const localVarPath = `/api/projects/{projectId}/labels`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectLabelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a member to a project
         * @param {number} projectId 
         * @param {ProjectMemberRequest} projectMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMembersPost: async (projectId: number, projectMemberRequest: ProjectMemberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdMembersPost', 'projectId', projectId)
            // verify required parameter 'projectMemberRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdMembersPost', 'projectMemberRequest', projectMemberRequest)
            const localVarPath = `/api/projects/{projectId}/members`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a member from a project
         * @param {number} projectId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMembersUserIdDelete: async (projectId: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdMembersUserIdDelete', 'projectId', projectId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('apiProjectsProjectIdMembersUserIdDelete', 'userId', userId)
            const localVarPath = `/api/projects/{projectId}/members/{userId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a project
         * @param {number} projectId 
         * @param {ProjectUpdateRequest} projectUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPut: async (projectId: number, projectUpdateRequest: ProjectUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdPut', 'projectId', projectId)
            // verify required parameter 'projectUpdateRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdPut', 'projectUpdateRequest', projectUpdateRequest)
            const localVarPath = `/api/projects/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a sprint (board screen)
         * @param {number} projectId 
         * @param {ProjectSprintRequest} projectSprintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdSprintsPost: async (projectId: number, projectSprintRequest: ProjectSprintRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdSprintsPost', 'projectId', projectId)
            // verify required parameter 'projectSprintRequest' is not null or undefined
            assertParamExists('apiProjectsProjectIdSprintsPost', 'projectSprintRequest', projectSprintRequest)
            const localVarPath = `/api/projects/{projectId}/sprints`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectSprintRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Card references for autocomplete and display expansion
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCardRefsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdCardRefsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/card-refs`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a shared conversation transcript (agent exchanges, card threads)
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChatConversationsConversationIdMessagesGet: async (teamId: number, conversationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdChatConversationsConversationIdMessagesGet', 'teamId', teamId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('apiTeamsTeamIdChatConversationsConversationIdMessagesGet', 'conversationId', conversationId)
            const localVarPath = `/api/teams/{teamId}/chat-conversations/{conversationId}/messages`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recent project and card activity visible to a team member
         * @param {number} teamId 
         * @param {number} [beforeId] 
         * @param {number} [limit] 
         * @param {number} [actorUserId] Only activity performed by this team member
         * @param {number} [actorAgentId] Only activity performed by this agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectActivityGet: async (teamId: number, beforeId?: number, limit?: number, actorUserId?: number, actorAgentId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectActivityGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/project-activity`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (beforeId !== undefined) {
                localVarQueryParameter['beforeId'] = beforeId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (actorUserId !== undefined) {
                localVarQueryParameter['actorUserId'] = actorUserId;
            }

            if (actorAgentId !== undefined) {
                localVarQueryParameter['actorAgentId'] = actorAgentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List projects the user is a member of
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/projects`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a project
         * @param {number} teamId 
         * @param {ProjectCreateRequest} projectCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsPost: async (teamId: number, projectCreateRequest: ProjectCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsPost', 'teamId', teamId)
            // verify required parameter 'projectCreateRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsPost', 'projectCreateRequest', projectCreateRequest)
            const localVarPath = `/api/teams/{teamId}/projects`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search projects, cards, tasks, and comments
         * @param {number} teamId 
         * @param {string} q 
         * @param {number} [projectId] 
         * @param {string} [labelName] 
         * @param {string} [columnName] 
         * @param {string} [agentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsSearchGet: async (teamId: number, q: string, projectId?: number, labelName?: string, columnName?: string, agentName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsSearchGet', 'teamId', teamId)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsSearchGet', 'q', q)
            const localVarPath = `/api/teams/{teamId}/projects/search`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (labelName !== undefined) {
                localVarQueryParameter['labelName'] = labelName;
            }

            if (columnName !== undefined) {
                localVarQueryParameter['columnName'] = columnName;
            }

            if (agentName !== undefined) {
                localVarQueryParameter['agentName'] = agentName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a card attachment
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardAttachmentsAttachmentIdDelete(attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardAttachmentsAttachmentIdDelete(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardAttachmentsAttachmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download a card attachment
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardAttachmentsAttachmentIdGet(attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardAttachmentsAttachmentIdGet(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardAttachmentsAttachmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a checklist task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardTasksTaskIdDelete(taskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardTasksTaskIdDelete(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardTasksTaskIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update or check off a checklist task
         * @param {number} taskId 
         * @param {ProjectTaskRequest} projectTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardTasksTaskIdPut(taskId: number, projectTaskRequest: ProjectTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardTasksTaskIdPut(taskId, projectTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardTasksTaskIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Card activity feed
         * @param {number} cardId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdActivityGet(cardId: number, beforeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdActivityGet(cardId, beforeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdActivityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unassign an agent from a card
         * @param {number} cardId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdAgentsAgentIdDelete(cardId: number, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdAgentsAgentIdDelete(cardId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdAgentsAgentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign an agent to a card
         * @param {number} cardId 
         * @param {ProjectAgentRequest} projectAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdAgentsPost(cardId: number, projectAgentRequest: ProjectAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdAgentsPost(cardId, projectAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdAgentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload an attachment to a card
         * @param {number} cardId 
         * @param {ProjectAttachmentUploadRequest} projectAttachmentUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdAttachmentsPost(cardId: number, projectAttachmentUploadRequest: ProjectAttachmentUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectAttachmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdAttachmentsPost(cardId, projectAttachmentUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdAttachmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Archive a card comment (Card comments edit permission)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdCommentsCommentIdArchivePost(cardId: number, commentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCommentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdCommentsCommentIdArchivePost(cardId, commentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdCommentsCommentIdArchivePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reveal an archived card comment (human card viewers only)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdCommentsCommentIdArchivedGet(cardId: number, commentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCommentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdCommentsCommentIdArchivedGet(cardId, commentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdCommentsCommentIdArchivedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete an archived card comment (human Card comments manage permission)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdCommentsCommentIdDelete(cardId: number, commentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdCommentsCommentIdDelete(cardId, commentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdCommentsCommentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List card comments
         * @param {number} cardId 
         * @param {number} [afterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdCommentsGet(cardId: number, afterId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCommentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdCommentsGet(cardId, afterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdCommentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Comment on a card (mention agents with @)
         * @param {number} cardId 
         * @param {ProjectCommentRequest} projectCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdCommentsPost(cardId: number, projectCommentRequest: ProjectCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCommentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdCommentsPost(cardId, projectCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdCommentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete an archived card (archive it first)
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdDelete(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdDelete(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a card dependency
         * @param {number} cardId 
         * @param {number} blockingCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdDependenciesBlockingCardIdDelete(cardId: number, blockingCardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdDependenciesBlockingCardIdDelete(cardId, blockingCardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdDependenciesBlockingCardIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a dependency that must reach Done before this card can run
         * @param {number} cardId 
         * @param {ApiProjectCardsCardIdDependenciesPostRequest} apiProjectCardsCardIdDependenciesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdDependenciesPost(cardId: number, apiProjectCardsCardIdDependenciesPostRequest: ApiProjectCardsCardIdDependenciesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCardDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdDependenciesPost(cardId, apiProjectCardsCardIdDependenciesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdDependenciesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start card work on a human\'s say-so (the move-in choice); refused for agent principals
         * @param {number} cardId 
         * @param {ProjectCardDispatchRequest} projectCardDispatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdDispatchPost(cardId: number, projectCardDispatchRequest: ProjectCardDispatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCardDispatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdDispatchPost(cardId, projectCardDispatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdDispatchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get card detail
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdGet(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCardDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdGet(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move a card between columns
         * @param {number} cardId 
         * @param {ProjectCardMoveRequest} projectCardMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdMovePost(cardId: number, projectCardMoveRequest: ProjectCardMoveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCardMoveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdMovePost(cardId, projectCardMoveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdMovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move a card to another project in the team
         * @param {number} cardId 
         * @param {ProjectCardMoveProjectRequest} projectCardMoveProjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdMoveProjectPost(cardId: number, projectCardMoveProjectRequest: ProjectCardMoveProjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCardMoveProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdMoveProjectPost(cardId, projectCardMoveProjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdMoveProjectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary What must be resolved before moving this card to another project
         * @param {number} cardId 
         * @param {number} targetProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdMoveProjectPreflightGet(cardId: number, targetProjectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCardMoveProjectPreflightResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdMoveProjectPreflightGet(cardId, targetProjectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdMoveProjectPreflightGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a card
         * @param {number} cardId 
         * @param {ProjectCardUpdateRequest} projectCardUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdPut(cardId: number, projectCardUpdateRequest: ProjectCardUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCardDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdPut(cardId, projectCardUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a checklist task
         * @param {number} cardId 
         * @param {ProjectTaskRequest} projectTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdTasksPost(cardId: number, projectTaskRequest: ProjectTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdTasksPost(cardId, projectTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectCardsCardIdTasksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete an archived column (archive it first)
         * @param {number} columnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectColumnsColumnIdDelete(columnId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectColumnsColumnIdDelete(columnId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectColumnsColumnIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update or archive/restore a board column (archiving moves its cards)
         * @param {number} columnId 
         * @param {ProjectColumnRequest} projectColumnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectColumnsColumnIdPut(columnId: number, projectColumnRequest: ProjectColumnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectColumnResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectColumnsColumnIdPut(columnId, projectColumnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectColumnsColumnIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete an archived epic and its archived cards (archive it first)
         * @param {number} epicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectEpicsEpicIdDelete(epicId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectEpicsEpicIdDelete(epicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectEpicsEpicIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update or archive/restore an epic (archiving archives its cards; restoring restores them)
         * @param {number} epicId 
         * @param {ProjectEpicRequest} projectEpicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectEpicsEpicIdPut(epicId: number, projectEpicRequest: ProjectEpicRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectEpicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectEpicsEpicIdPut(epicId, projectEpicRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectEpicsEpicIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete an archived label (archive it first)
         * @param {number} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectLabelsLabelIdDelete(labelId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectLabelsLabelIdDelete(labelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectLabelsLabelIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update or archive/restore a label (archived labels keep their card associations)
         * @param {number} labelId 
         * @param {ProjectLabelRequest} projectLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectLabelsLabelIdPut(labelId: number, projectLabelRequest: ProjectLabelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectLabelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectLabelsLabelIdPut(labelId, projectLabelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectLabelsLabelIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete an archived sprint; its cards drop to the backlog (archive it first)
         * @param {number} sprintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectSprintsSprintIdDelete(sprintId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectSprintsSprintIdDelete(sprintId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectSprintsSprintIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Take an epic row off a sprint, moving its sprint cards to another epic
         * @param {number} sprintId 
         * @param {number} epicId 
         * @param {number} moveCardsTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectSprintsSprintIdEpicsEpicIdDelete(sprintId: number, epicId: number, moveCardsTo: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectSprintsSprintIdEpicsEpicIdDelete(sprintId, epicId, moveCardsTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectSprintsSprintIdEpicsEpicIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update or archive a sprint (an archived sprint keeps its cards)
         * @param {number} sprintId 
         * @param {ProjectSprintRequest} projectSprintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectSprintsSprintIdPut(sprintId: number, projectSprintRequest: ProjectSprintRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSprintResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectSprintsSprintIdPut(sprintId, projectSprintRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectSprintsSprintIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Project activity feed
         * @param {number} projectId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdActivityGet(projectId: number, beforeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdActivityGet(projectId, beforeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdActivityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove an agent from a project
         * @param {number} projectId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdAgentsAgentIdDelete(projectId: number, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdAgentsAgentIdDelete(projectId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdAgentsAgentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Associate an agent with a project
         * @param {number} projectId 
         * @param {ProjectAgentRequest} projectAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdAgentsPost(projectId: number, projectAgentRequest: ProjectAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdAgentsPost(projectId, projectAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdAgentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a card (milestone)
         * @param {number} projectId 
         * @param {ProjectCardCreateRequest} projectCardCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdCardsPost(projectId: number, projectCardCreateRequest: ProjectCardCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectCardDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdCardsPost(projectId, projectCardCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdCardsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a board column
         * @param {number} projectId 
         * @param {ProjectColumnRequest} projectColumnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdColumnsPost(projectId: number, projectColumnRequest: ProjectColumnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectColumnResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdColumnsPost(projectId, projectColumnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdColumnsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete an archived project (archive it first)
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdDelete(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdDelete(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an epic (board row)
         * @param {number} projectId 
         * @param {ProjectEpicRequest} projectEpicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdEpicsPost(projectId: number, projectEpicRequest: ProjectEpicRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectEpicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdEpicsPost(projectId, projectEpicRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdEpicsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the project board
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdGet(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectBoardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdGet(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rename a label group; every label in it moves at once
         * @param {number} projectId 
         * @param {ProjectLabelGroupRenameRequest} projectLabelGroupRenameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdLabelGroupsPut(projectId: number, projectLabelGroupRenameRequest: ProjectLabelGroupRenameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectLabelGroupRenameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdLabelGroupsPut(projectId, projectLabelGroupRenameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdLabelGroupsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a label
         * @param {number} projectId 
         * @param {ProjectLabelRequest} projectLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdLabelsPost(projectId: number, projectLabelRequest: ProjectLabelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectLabelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdLabelsPost(projectId, projectLabelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdLabelsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a member to a project
         * @param {number} projectId 
         * @param {ProjectMemberRequest} projectMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdMembersPost(projectId: number, projectMemberRequest: ProjectMemberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdMembersPost(projectId, projectMemberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdMembersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a member from a project
         * @param {number} projectId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdMembersUserIdDelete(projectId: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdMembersUserIdDelete(projectId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdMembersUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a project
         * @param {number} projectId 
         * @param {ProjectUpdateRequest} projectUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdPut(projectId: number, projectUpdateRequest: ProjectUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdPut(projectId, projectUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a sprint (board screen)
         * @param {number} projectId 
         * @param {ProjectSprintRequest} projectSprintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdSprintsPost(projectId: number, projectSprintRequest: ProjectSprintRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSprintResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdSprintsPost(projectId, projectSprintRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiProjectsProjectIdSprintsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Card references for autocomplete and display expansion
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdCardRefsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardRefsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdCardRefsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdCardRefsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a shared conversation transcript (agent exchanges, card threads)
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdChatConversationsConversationIdMessagesGet(teamId: number, conversationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationTranscriptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdChatConversationsConversationIdMessagesGet(teamId, conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdChatConversationsConversationIdMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recent project and card activity visible to a team member
         * @param {number} teamId 
         * @param {number} [beforeId] 
         * @param {number} [limit] 
         * @param {number} [actorUserId] Only activity performed by this team member
         * @param {number} [actorAgentId] Only activity performed by this agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectActivityGet(teamId: number, beforeId?: number, limit?: number, actorUserId?: number, actorAgentId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamProjectActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectActivityGet(teamId, beforeId, limit, actorUserId, actorAgentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdProjectActivityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List projects the user is a member of
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdProjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a project
         * @param {number} teamId 
         * @param {ProjectCreateRequest} projectCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsPost(teamId: number, projectCreateRequest: ProjectCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsPost(teamId, projectCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdProjectsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search projects, cards, tasks, and comments
         * @param {number} teamId 
         * @param {string} q 
         * @param {number} [projectId] 
         * @param {string} [labelName] 
         * @param {string} [columnName] 
         * @param {string} [agentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsSearchGet(teamId: number, q: string, projectId?: number, labelName?: string, columnName?: string, agentName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsSearchGet(teamId, q, projectId, labelName, columnName, agentName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.apiTeamsTeamIdProjectsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectsApi - factory interface
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a card attachment
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardAttachmentsAttachmentIdDelete(attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectCardAttachmentsAttachmentIdDelete(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a card attachment
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardAttachmentsAttachmentIdGet(attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiProjectCardAttachmentsAttachmentIdGet(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a checklist task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardTasksTaskIdDelete(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectCardTasksTaskIdDelete(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update or check off a checklist task
         * @param {number} taskId 
         * @param {ProjectTaskRequest} projectTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardTasksTaskIdPut(taskId: number, projectTaskRequest: ProjectTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectTaskResponse> {
            return localVarFp.apiProjectCardTasksTaskIdPut(taskId, projectTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Card activity feed
         * @param {number} cardId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdActivityGet(cardId: number, beforeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectActivityResponse> {
            return localVarFp.apiProjectCardsCardIdActivityGet(cardId, beforeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unassign an agent from a card
         * @param {number} cardId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdAgentsAgentIdDelete(cardId: number, agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectCardsCardIdAgentsAgentIdDelete(cardId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign an agent to a card
         * @param {number} cardId 
         * @param {ProjectAgentRequest} projectAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdAgentsPost(cardId: number, projectAgentRequest: ProjectAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectCardsCardIdAgentsPost(cardId, projectAgentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an attachment to a card
         * @param {number} cardId 
         * @param {ProjectAttachmentUploadRequest} projectAttachmentUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdAttachmentsPost(cardId: number, projectAttachmentUploadRequest: ProjectAttachmentUploadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectAttachmentResponse> {
            return localVarFp.apiProjectCardsCardIdAttachmentsPost(cardId, projectAttachmentUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a card comment (Card comments edit permission)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsCommentIdArchivePost(cardId: number, commentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCommentResponse> {
            return localVarFp.apiProjectCardsCardIdCommentsCommentIdArchivePost(cardId, commentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reveal an archived card comment (human card viewers only)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsCommentIdArchivedGet(cardId: number, commentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCommentResponse> {
            return localVarFp.apiProjectCardsCardIdCommentsCommentIdArchivedGet(cardId, commentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete an archived card comment (human Card comments manage permission)
         * @param {number} cardId 
         * @param {number} commentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsCommentIdDelete(cardId: number, commentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectCardsCardIdCommentsCommentIdDelete(cardId, commentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List card comments
         * @param {number} cardId 
         * @param {number} [afterId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsGet(cardId: number, afterId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCommentsResponse> {
            return localVarFp.apiProjectCardsCardIdCommentsGet(cardId, afterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Comment on a card (mention agents with @)
         * @param {number} cardId 
         * @param {ProjectCommentRequest} projectCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdCommentsPost(cardId: number, projectCommentRequest: ProjectCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCommentResponse> {
            return localVarFp.apiProjectCardsCardIdCommentsPost(cardId, projectCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete an archived card (archive it first)
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdDelete(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectCardsCardIdDelete(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a card dependency
         * @param {number} cardId 
         * @param {number} blockingCardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdDependenciesBlockingCardIdDelete(cardId: number, blockingCardId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectCardsCardIdDependenciesBlockingCardIdDelete(cardId, blockingCardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a dependency that must reach Done before this card can run
         * @param {number} cardId 
         * @param {ApiProjectCardsCardIdDependenciesPostRequest} apiProjectCardsCardIdDependenciesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdDependenciesPost(cardId: number, apiProjectCardsCardIdDependenciesPostRequest: ApiProjectCardsCardIdDependenciesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCardDetailResponse> {
            return localVarFp.apiProjectCardsCardIdDependenciesPost(cardId, apiProjectCardsCardIdDependenciesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start card work on a human\'s say-so (the move-in choice); refused for agent principals
         * @param {number} cardId 
         * @param {ProjectCardDispatchRequest} projectCardDispatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdDispatchPost(cardId: number, projectCardDispatchRequest: ProjectCardDispatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCardDispatchResponse> {
            return localVarFp.apiProjectCardsCardIdDispatchPost(cardId, projectCardDispatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get card detail
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdGet(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCardDetailResponse> {
            return localVarFp.apiProjectCardsCardIdGet(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move a card between columns
         * @param {number} cardId 
         * @param {ProjectCardMoveRequest} projectCardMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdMovePost(cardId: number, projectCardMoveRequest: ProjectCardMoveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCardMoveResponse> {
            return localVarFp.apiProjectCardsCardIdMovePost(cardId, projectCardMoveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move a card to another project in the team
         * @param {number} cardId 
         * @param {ProjectCardMoveProjectRequest} projectCardMoveProjectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdMoveProjectPost(cardId: number, projectCardMoveProjectRequest: ProjectCardMoveProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCardMoveProjectResponse> {
            return localVarFp.apiProjectCardsCardIdMoveProjectPost(cardId, projectCardMoveProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary What must be resolved before moving this card to another project
         * @param {number} cardId 
         * @param {number} targetProjectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdMoveProjectPreflightGet(cardId: number, targetProjectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCardMoveProjectPreflightResponse> {
            return localVarFp.apiProjectCardsCardIdMoveProjectPreflightGet(cardId, targetProjectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a card
         * @param {number} cardId 
         * @param {ProjectCardUpdateRequest} projectCardUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdPut(cardId: number, projectCardUpdateRequest: ProjectCardUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCardDetailResponse> {
            return localVarFp.apiProjectCardsCardIdPut(cardId, projectCardUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a checklist task
         * @param {number} cardId 
         * @param {ProjectTaskRequest} projectTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdTasksPost(cardId: number, projectTaskRequest: ProjectTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectTaskResponse> {
            return localVarFp.apiProjectCardsCardIdTasksPost(cardId, projectTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete an archived column (archive it first)
         * @param {number} columnId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectColumnsColumnIdDelete(columnId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectColumnsColumnIdDelete(columnId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update or archive/restore a board column (archiving moves its cards)
         * @param {number} columnId 
         * @param {ProjectColumnRequest} projectColumnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectColumnsColumnIdPut(columnId: number, projectColumnRequest: ProjectColumnRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectColumnResponse> {
            return localVarFp.apiProjectColumnsColumnIdPut(columnId, projectColumnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete an archived epic and its archived cards (archive it first)
         * @param {number} epicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectEpicsEpicIdDelete(epicId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectEpicsEpicIdDelete(epicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update or archive/restore an epic (archiving archives its cards; restoring restores them)
         * @param {number} epicId 
         * @param {ProjectEpicRequest} projectEpicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectEpicsEpicIdPut(epicId: number, projectEpicRequest: ProjectEpicRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectEpicResponse> {
            return localVarFp.apiProjectEpicsEpicIdPut(epicId, projectEpicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete an archived label (archive it first)
         * @param {number} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectLabelsLabelIdDelete(labelId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectLabelsLabelIdDelete(labelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update or archive/restore a label (archived labels keep their card associations)
         * @param {number} labelId 
         * @param {ProjectLabelRequest} projectLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectLabelsLabelIdPut(labelId: number, projectLabelRequest: ProjectLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectLabelResponse> {
            return localVarFp.apiProjectLabelsLabelIdPut(labelId, projectLabelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete an archived sprint; its cards drop to the backlog (archive it first)
         * @param {number} sprintId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectSprintsSprintIdDelete(sprintId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectSprintsSprintIdDelete(sprintId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Take an epic row off a sprint, moving its sprint cards to another epic
         * @param {number} sprintId 
         * @param {number} epicId 
         * @param {number} moveCardsTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectSprintsSprintIdEpicsEpicIdDelete(sprintId: number, epicId: number, moveCardsTo: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectSprintsSprintIdEpicsEpicIdDelete(sprintId, epicId, moveCardsTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update or archive a sprint (an archived sprint keeps its cards)
         * @param {number} sprintId 
         * @param {ProjectSprintRequest} projectSprintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectSprintsSprintIdPut(sprintId: number, projectSprintRequest: ProjectSprintRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectSprintResponse> {
            return localVarFp.apiProjectSprintsSprintIdPut(sprintId, projectSprintRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Project activity feed
         * @param {number} projectId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdActivityGet(projectId: number, beforeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectActivityResponse> {
            return localVarFp.apiProjectsProjectIdActivityGet(projectId, beforeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an agent from a project
         * @param {number} projectId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdAgentsAgentIdDelete(projectId: number, agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdAgentsAgentIdDelete(projectId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Associate an agent with a project
         * @param {number} projectId 
         * @param {ProjectAgentRequest} projectAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdAgentsPost(projectId: number, projectAgentRequest: ProjectAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdAgentsPost(projectId, projectAgentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a card (milestone)
         * @param {number} projectId 
         * @param {ProjectCardCreateRequest} projectCardCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdCardsPost(projectId: number, projectCardCreateRequest: ProjectCardCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectCardDetailResponse> {
            return localVarFp.apiProjectsProjectIdCardsPost(projectId, projectCardCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a board column
         * @param {number} projectId 
         * @param {ProjectColumnRequest} projectColumnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdColumnsPost(projectId: number, projectColumnRequest: ProjectColumnRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectColumnResponse> {
            return localVarFp.apiProjectsProjectIdColumnsPost(projectId, projectColumnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete an archived project (archive it first)
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdDelete(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdDelete(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an epic (board row)
         * @param {number} projectId 
         * @param {ProjectEpicRequest} projectEpicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdEpicsPost(projectId: number, projectEpicRequest: ProjectEpicRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectEpicResponse> {
            return localVarFp.apiProjectsProjectIdEpicsPost(projectId, projectEpicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the project board
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdGet(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectBoardResponse> {
            return localVarFp.apiProjectsProjectIdGet(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename a label group; every label in it moves at once
         * @param {number} projectId 
         * @param {ProjectLabelGroupRenameRequest} projectLabelGroupRenameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdLabelGroupsPut(projectId: number, projectLabelGroupRenameRequest: ProjectLabelGroupRenameRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectLabelGroupRenameResponse> {
            return localVarFp.apiProjectsProjectIdLabelGroupsPut(projectId, projectLabelGroupRenameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a label
         * @param {number} projectId 
         * @param {ProjectLabelRequest} projectLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdLabelsPost(projectId: number, projectLabelRequest: ProjectLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectLabelResponse> {
            return localVarFp.apiProjectsProjectIdLabelsPost(projectId, projectLabelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a member to a project
         * @param {number} projectId 
         * @param {ProjectMemberRequest} projectMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMembersPost(projectId: number, projectMemberRequest: ProjectMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdMembersPost(projectId, projectMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a member from a project
         * @param {number} projectId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdMembersUserIdDelete(projectId: number, userId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdMembersUserIdDelete(projectId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a project
         * @param {number} projectId 
         * @param {ProjectUpdateRequest} projectUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPut(projectId: number, projectUpdateRequest: ProjectUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectResponse> {
            return localVarFp.apiProjectsProjectIdPut(projectId, projectUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a sprint (board screen)
         * @param {number} projectId 
         * @param {ProjectSprintRequest} projectSprintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdSprintsPost(projectId: number, projectSprintRequest: ProjectSprintRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectSprintResponse> {
            return localVarFp.apiProjectsProjectIdSprintsPost(projectId, projectSprintRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Card references for autocomplete and display expansion
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdCardRefsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<CardRefsResponse> {
            return localVarFp.apiTeamsTeamIdCardRefsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a shared conversation transcript (agent exchanges, card threads)
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdChatConversationsConversationIdMessagesGet(teamId: number, conversationId: number, options?: RawAxiosRequestConfig): AxiosPromise<ConversationTranscriptResponse> {
            return localVarFp.apiTeamsTeamIdChatConversationsConversationIdMessagesGet(teamId, conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recent project and card activity visible to a team member
         * @param {number} teamId 
         * @param {number} [beforeId] 
         * @param {number} [limit] 
         * @param {number} [actorUserId] Only activity performed by this team member
         * @param {number} [actorAgentId] Only activity performed by this agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectActivityGet(teamId: number, beforeId?: number, limit?: number, actorUserId?: number, actorAgentId?: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamProjectActivityResponse> {
            return localVarFp.apiTeamsTeamIdProjectActivityGet(teamId, beforeId, limit, actorUserId, actorAgentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List projects the user is a member of
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProjectListResponse> {
            return localVarFp.apiTeamsTeamIdProjectsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a project
         * @param {number} teamId 
         * @param {ProjectCreateRequest} projectCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsPost(teamId: number, projectCreateRequest: ProjectCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectResponse> {
            return localVarFp.apiTeamsTeamIdProjectsPost(teamId, projectCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search projects, cards, tasks, and comments
         * @param {number} teamId 
         * @param {string} q 
         * @param {number} [projectId] 
         * @param {string} [labelName] 
         * @param {string} [columnName] 
         * @param {string} [agentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsSearchGet(teamId: number, q: string, projectId?: number, labelName?: string, columnName?: string, agentName?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProjectSearchResponse> {
            return localVarFp.apiTeamsTeamIdProjectsSearchGet(teamId, q, projectId, labelName, columnName, agentName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsApi - object-oriented interface
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @summary Delete a card attachment
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardAttachmentsAttachmentIdDelete(attachmentId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardAttachmentsAttachmentIdDelete(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a card attachment
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardAttachmentsAttachmentIdGet(attachmentId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardAttachmentsAttachmentIdGet(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a checklist task
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardTasksTaskIdDelete(taskId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardTasksTaskIdDelete(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update or check off a checklist task
     * @param {number} taskId 
     * @param {ProjectTaskRequest} projectTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardTasksTaskIdPut(taskId: number, projectTaskRequest: ProjectTaskRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardTasksTaskIdPut(taskId, projectTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Card activity feed
     * @param {number} cardId 
     * @param {number} [beforeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdActivityGet(cardId: number, beforeId?: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdActivityGet(cardId, beforeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unassign an agent from a card
     * @param {number} cardId 
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdAgentsAgentIdDelete(cardId: number, agentId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdAgentsAgentIdDelete(cardId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign an agent to a card
     * @param {number} cardId 
     * @param {ProjectAgentRequest} projectAgentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdAgentsPost(cardId: number, projectAgentRequest: ProjectAgentRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdAgentsPost(cardId, projectAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an attachment to a card
     * @param {number} cardId 
     * @param {ProjectAttachmentUploadRequest} projectAttachmentUploadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdAttachmentsPost(cardId: number, projectAttachmentUploadRequest: ProjectAttachmentUploadRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdAttachmentsPost(cardId, projectAttachmentUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a card comment (Card comments edit permission)
     * @param {number} cardId 
     * @param {number} commentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdCommentsCommentIdArchivePost(cardId: number, commentId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdCommentsCommentIdArchivePost(cardId, commentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reveal an archived card comment (human card viewers only)
     * @param {number} cardId 
     * @param {number} commentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdCommentsCommentIdArchivedGet(cardId: number, commentId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdCommentsCommentIdArchivedGet(cardId, commentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete an archived card comment (human Card comments manage permission)
     * @param {number} cardId 
     * @param {number} commentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdCommentsCommentIdDelete(cardId: number, commentId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdCommentsCommentIdDelete(cardId, commentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List card comments
     * @param {number} cardId 
     * @param {number} [afterId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdCommentsGet(cardId: number, afterId?: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdCommentsGet(cardId, afterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Comment on a card (mention agents with @)
     * @param {number} cardId 
     * @param {ProjectCommentRequest} projectCommentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdCommentsPost(cardId: number, projectCommentRequest: ProjectCommentRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdCommentsPost(cardId, projectCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete an archived card (archive it first)
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdDelete(cardId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdDelete(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a card dependency
     * @param {number} cardId 
     * @param {number} blockingCardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdDependenciesBlockingCardIdDelete(cardId: number, blockingCardId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdDependenciesBlockingCardIdDelete(cardId, blockingCardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a dependency that must reach Done before this card can run
     * @param {number} cardId 
     * @param {ApiProjectCardsCardIdDependenciesPostRequest} apiProjectCardsCardIdDependenciesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdDependenciesPost(cardId: number, apiProjectCardsCardIdDependenciesPostRequest: ApiProjectCardsCardIdDependenciesPostRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdDependenciesPost(cardId, apiProjectCardsCardIdDependenciesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start card work on a human\'s say-so (the move-in choice); refused for agent principals
     * @param {number} cardId 
     * @param {ProjectCardDispatchRequest} projectCardDispatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdDispatchPost(cardId: number, projectCardDispatchRequest: ProjectCardDispatchRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdDispatchPost(cardId, projectCardDispatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get card detail
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdGet(cardId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdGet(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move a card between columns
     * @param {number} cardId 
     * @param {ProjectCardMoveRequest} projectCardMoveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdMovePost(cardId: number, projectCardMoveRequest: ProjectCardMoveRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdMovePost(cardId, projectCardMoveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move a card to another project in the team
     * @param {number} cardId 
     * @param {ProjectCardMoveProjectRequest} projectCardMoveProjectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdMoveProjectPost(cardId: number, projectCardMoveProjectRequest: ProjectCardMoveProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdMoveProjectPost(cardId, projectCardMoveProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary What must be resolved before moving this card to another project
     * @param {number} cardId 
     * @param {number} targetProjectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdMoveProjectPreflightGet(cardId: number, targetProjectId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdMoveProjectPreflightGet(cardId, targetProjectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a card
     * @param {number} cardId 
     * @param {ProjectCardUpdateRequest} projectCardUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdPut(cardId: number, projectCardUpdateRequest: ProjectCardUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdPut(cardId, projectCardUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a checklist task
     * @param {number} cardId 
     * @param {ProjectTaskRequest} projectTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdTasksPost(cardId: number, projectTaskRequest: ProjectTaskRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectCardsCardIdTasksPost(cardId, projectTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete an archived column (archive it first)
     * @param {number} columnId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectColumnsColumnIdDelete(columnId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectColumnsColumnIdDelete(columnId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update or archive/restore a board column (archiving moves its cards)
     * @param {number} columnId 
     * @param {ProjectColumnRequest} projectColumnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectColumnsColumnIdPut(columnId: number, projectColumnRequest: ProjectColumnRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectColumnsColumnIdPut(columnId, projectColumnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete an archived epic and its archived cards (archive it first)
     * @param {number} epicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectEpicsEpicIdDelete(epicId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectEpicsEpicIdDelete(epicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update or archive/restore an epic (archiving archives its cards; restoring restores them)
     * @param {number} epicId 
     * @param {ProjectEpicRequest} projectEpicRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectEpicsEpicIdPut(epicId: number, projectEpicRequest: ProjectEpicRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectEpicsEpicIdPut(epicId, projectEpicRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete an archived label (archive it first)
     * @param {number} labelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectLabelsLabelIdDelete(labelId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectLabelsLabelIdDelete(labelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update or archive/restore a label (archived labels keep their card associations)
     * @param {number} labelId 
     * @param {ProjectLabelRequest} projectLabelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectLabelsLabelIdPut(labelId: number, projectLabelRequest: ProjectLabelRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectLabelsLabelIdPut(labelId, projectLabelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete an archived sprint; its cards drop to the backlog (archive it first)
     * @param {number} sprintId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectSprintsSprintIdDelete(sprintId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectSprintsSprintIdDelete(sprintId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Take an epic row off a sprint, moving its sprint cards to another epic
     * @param {number} sprintId 
     * @param {number} epicId 
     * @param {number} moveCardsTo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectSprintsSprintIdEpicsEpicIdDelete(sprintId: number, epicId: number, moveCardsTo: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectSprintsSprintIdEpicsEpicIdDelete(sprintId, epicId, moveCardsTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update or archive a sprint (an archived sprint keeps its cards)
     * @param {number} sprintId 
     * @param {ProjectSprintRequest} projectSprintRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectSprintsSprintIdPut(sprintId: number, projectSprintRequest: ProjectSprintRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectSprintsSprintIdPut(sprintId, projectSprintRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Project activity feed
     * @param {number} projectId 
     * @param {number} [beforeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdActivityGet(projectId: number, beforeId?: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdActivityGet(projectId, beforeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an agent from a project
     * @param {number} projectId 
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdAgentsAgentIdDelete(projectId: number, agentId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdAgentsAgentIdDelete(projectId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Associate an agent with a project
     * @param {number} projectId 
     * @param {ProjectAgentRequest} projectAgentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdAgentsPost(projectId: number, projectAgentRequest: ProjectAgentRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdAgentsPost(projectId, projectAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a card (milestone)
     * @param {number} projectId 
     * @param {ProjectCardCreateRequest} projectCardCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdCardsPost(projectId: number, projectCardCreateRequest: ProjectCardCreateRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdCardsPost(projectId, projectCardCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a board column
     * @param {number} projectId 
     * @param {ProjectColumnRequest} projectColumnRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdColumnsPost(projectId: number, projectColumnRequest: ProjectColumnRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdColumnsPost(projectId, projectColumnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete an archived project (archive it first)
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdDelete(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdDelete(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an epic (board row)
     * @param {number} projectId 
     * @param {ProjectEpicRequest} projectEpicRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdEpicsPost(projectId: number, projectEpicRequest: ProjectEpicRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdEpicsPost(projectId, projectEpicRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the project board
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdGet(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdGet(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename a label group; every label in it moves at once
     * @param {number} projectId 
     * @param {ProjectLabelGroupRenameRequest} projectLabelGroupRenameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdLabelGroupsPut(projectId: number, projectLabelGroupRenameRequest: ProjectLabelGroupRenameRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdLabelGroupsPut(projectId, projectLabelGroupRenameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a label
     * @param {number} projectId 
     * @param {ProjectLabelRequest} projectLabelRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdLabelsPost(projectId: number, projectLabelRequest: ProjectLabelRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdLabelsPost(projectId, projectLabelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a member to a project
     * @param {number} projectId 
     * @param {ProjectMemberRequest} projectMemberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdMembersPost(projectId: number, projectMemberRequest: ProjectMemberRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdMembersPost(projectId, projectMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a member from a project
     * @param {number} projectId 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdMembersUserIdDelete(projectId: number, userId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdMembersUserIdDelete(projectId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a project
     * @param {number} projectId 
     * @param {ProjectUpdateRequest} projectUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdPut(projectId: number, projectUpdateRequest: ProjectUpdateRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdPut(projectId, projectUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a sprint (board screen)
     * @param {number} projectId 
     * @param {ProjectSprintRequest} projectSprintRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectsProjectIdSprintsPost(projectId: number, projectSprintRequest: ProjectSprintRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiProjectsProjectIdSprintsPost(projectId, projectSprintRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Card references for autocomplete and display expansion
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdCardRefsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdCardRefsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a shared conversation transcript (agent exchanges, card threads)
     * @param {number} teamId 
     * @param {number} conversationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdChatConversationsConversationIdMessagesGet(teamId: number, conversationId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdChatConversationsConversationIdMessagesGet(teamId, conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recent project and card activity visible to a team member
     * @param {number} teamId 
     * @param {number} [beforeId] 
     * @param {number} [limit] 
     * @param {number} [actorUserId] Only activity performed by this team member
     * @param {number} [actorAgentId] Only activity performed by this agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectActivityGet(teamId: number, beforeId?: number, limit?: number, actorUserId?: number, actorAgentId?: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdProjectActivityGet(teamId, beforeId, limit, actorUserId, actorAgentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List projects the user is a member of
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdProjectsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a project
     * @param {number} teamId 
     * @param {ProjectCreateRequest} projectCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsPost(teamId: number, projectCreateRequest: ProjectCreateRequest, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdProjectsPost(teamId, projectCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search projects, cards, tasks, and comments
     * @param {number} teamId 
     * @param {string} q 
     * @param {number} [projectId] 
     * @param {string} [labelName] 
     * @param {string} [columnName] 
     * @param {string} [agentName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsSearchGet(teamId: number, q: string, projectId?: number, labelName?: string, columnName?: string, agentName?: string, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).apiTeamsTeamIdProjectsSearchGet(teamId, q, projectId, labelName, columnName, agentName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReleaseNotesApi - axios parameter creator
 */
export const ReleaseNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Every release-notes entry, newest first, plus how far the current user has read. The client walks history locally via \"Previous notes\".
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReleaseNotesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/release-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record that the current user has read up to the newest entry and clear their pending release-notes notification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReleaseNotesViewedPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/release-notes/viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReleaseNotesApi - functional programming interface
 */
export const ReleaseNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReleaseNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Every release-notes entry, newest first, plus how far the current user has read. The client walks history locally via \"Previous notes\".
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReleaseNotesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReleaseNotesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReleaseNotesApi.apiReleaseNotesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record that the current user has read up to the newest entry and clear their pending release-notes notification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReleaseNotesViewedPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReleaseNotesViewedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReleaseNotesViewedPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReleaseNotesApi.apiReleaseNotesViewedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReleaseNotesApi - factory interface
 */
export const ReleaseNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReleaseNotesApiFp(configuration)
    return {
        /**
         * 
         * @summary Every release-notes entry, newest first, plus how far the current user has read. The client walks history locally via \"Previous notes\".
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReleaseNotesGet(options?: RawAxiosRequestConfig): AxiosPromise<ReleaseNotesResponse> {
            return localVarFp.apiReleaseNotesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record that the current user has read up to the newest entry and clear their pending release-notes notification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReleaseNotesViewedPost(options?: RawAxiosRequestConfig): AxiosPromise<ReleaseNotesViewedResponse> {
            return localVarFp.apiReleaseNotesViewedPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReleaseNotesApi - object-oriented interface
 */
export class ReleaseNotesApi extends BaseAPI {
    /**
     * 
     * @summary Every release-notes entry, newest first, plus how far the current user has read. The client walks history locally via \"Previous notes\".
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiReleaseNotesGet(options?: RawAxiosRequestConfig) {
        return ReleaseNotesApiFp(this.configuration).apiReleaseNotesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record that the current user has read up to the newest entry and clear their pending release-notes notification.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiReleaseNotesViewedPost(options?: RawAxiosRequestConfig) {
        return ReleaseNotesApiFp(this.configuration).apiReleaseNotesViewedPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RolesApi - axios parameter creator
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A SURFACE CEILING, never a grant — applies only to turns from senders who are not team members. Neither field set means the agent does not talk to outsiders at all. 
         * @summary Get the agent\'s external communications role
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdExternalRoleGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdExternalRoleGet', 'agentId', agentId)
            const localVarPath = `/api/agent/{agentId}/external-role`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set, replace, or clear the agent\'s external communications role
         * @param {number} agentId 
         * @param {ExternalRoleInput} externalRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdExternalRolePut: async (agentId: number, externalRoleInput: ExternalRoleInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdExternalRolePut', 'agentId', agentId)
            // verify required parameter 'externalRoleInput' is not null or undefined
            assertParamExists('apiAgentAgentIdExternalRolePut', 'externalRoleInput', externalRoleInput)
            const localVarPath = `/api/agent/{agentId}/external-role`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalRoleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a ceiling role from the agent
         * @param {number} agentId 
         * @param {number} ceilingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdPermissionCeilingsCeilingIdDelete: async (agentId: number, ceilingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdPermissionCeilingsCeilingIdDelete', 'agentId', agentId)
            // verify required parameter 'ceilingId' is not null or undefined
            assertParamExists('apiAgentAgentIdPermissionCeilingsCeilingIdDelete', 'ceilingId', ceilingId)
            const localVarPath = `/api/agent/{agentId}/permission-ceilings/{ceilingId}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"ceilingId"}}`, encodeURIComponent(String(ceilingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the agent\'s ceiling roles
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdPermissionCeilingsGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdPermissionCeilingsGet', 'agentId', agentId)
            const localVarPath = `/api/agent/{agentId}/permission-ceilings`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attach a ceiling role to the agent
         * @param {number} agentId 
         * @param {AgentPermissionCeilingInput} agentPermissionCeilingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdPermissionCeilingsPost: async (agentId: number, agentPermissionCeilingInput: AgentPermissionCeilingInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentAgentIdPermissionCeilingsPost', 'agentId', agentId)
            // verify required parameter 'agentPermissionCeilingInput' is not null or undefined
            assertParamExists('apiAgentAgentIdPermissionCeilingsPost', 'agentPermissionCeilingInput', agentPermissionCeilingInput)
            const localVarPath = `/api/agent/{agentId}/permission-ceilings`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentPermissionCeilingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The caller\'s own effective permissions in this team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdPermissionsMeGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdPermissionsMeGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/permissions/me`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke a role assignment
         * @param {number} teamId 
         * @param {number} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete: async (teamId: number, assignmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete', 'teamId', teamId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete', 'assignmentId', assignmentId)
            const localVarPath = `/api/teams/{teamId}/role-assignments/{assignmentId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List every role assignment in the team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRoleAssignmentsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRoleAssignmentsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/role-assignments`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grant a role at team or project scope
         * @param {number} teamId 
         * @param {RoleAssignmentInput} roleAssignmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRoleAssignmentsPost: async (teamId: number, roleAssignmentInput: RoleAssignmentInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRoleAssignmentsPost', 'teamId', teamId)
            // verify required parameter 'roleAssignmentInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdRoleAssignmentsPost', 'roleAssignmentInput', roleAssignmentInput)
            const localVarPath = `/api/teams/{teamId}/role-assignments`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleAssignmentInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the team\'s built-in and custom roles
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/roles`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a custom role
         * @param {number} teamId 
         * @param {RoleInput} roleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesPost: async (teamId: number, roleInput: RoleInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesPost', 'teamId', teamId)
            // verify required parameter 'roleInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesPost', 'roleInput', roleInput)
            const localVarPath = `/api/teams/{teamId}/roles`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a custom role
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {boolean} [force] Cascade: revoke every assignment referencing this role. Without it a role still in use is refused with 409 and the count. A cascading delete is a mass revocation and requires ROLE:manage, not the ROLE:edit a plain delete takes. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesRoleIdDelete: async (teamId: number, roleId: string, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesRoleIdDelete', 'teamId', teamId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesRoleIdDelete', 'roleId', roleId)
            const localVarPath = `/api/teams/{teamId}/roles/{roleId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one role — a numeric custom role id, or a built-in key
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesRoleIdGet: async (teamId: number, roleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesRoleIdGet', 'teamId', teamId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesRoleIdGet', 'roleId', roleId)
            const localVarPath = `/api/teams/{teamId}/roles/{roleId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a custom role (built-ins are read-only)
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {RoleUpdateInput} roleUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesRoleIdPut: async (teamId: number, roleId: string, roleUpdateInput: RoleUpdateInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesRoleIdPut', 'teamId', teamId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesRoleIdPut', 'roleId', roleId)
            // verify required parameter 'roleUpdateInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdRolesRoleIdPut', 'roleUpdateInput', roleUpdateInput)
            const localVarPath = `/api/teams/{teamId}/roles/{roleId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleUpdateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * A SURFACE CEILING, never a grant — applies only to turns from senders who are not team members. Neither field set means the agent does not talk to outsiders at all. 
         * @summary Get the agent\'s external communications role
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdExternalRoleGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdExternalRoleGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiAgentAgentIdExternalRoleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set, replace, or clear the agent\'s external communications role
         * @param {number} agentId 
         * @param {ExternalRoleInput} externalRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdExternalRolePut(agentId: number, externalRoleInput: ExternalRoleInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdExternalRolePut(agentId, externalRoleInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiAgentAgentIdExternalRolePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a ceiling role from the agent
         * @param {number} agentId 
         * @param {number} ceilingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdPermissionCeilingsCeilingIdDelete(agentId: number, ceilingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdPermissionCeilingsCeilingIdDelete(agentId, ceilingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiAgentAgentIdPermissionCeilingsCeilingIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the agent\'s ceiling roles
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdPermissionCeilingsGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentPermissionCeiling>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdPermissionCeilingsGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiAgentAgentIdPermissionCeilingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Attach a ceiling role to the agent
         * @param {number} agentId 
         * @param {AgentPermissionCeilingInput} agentPermissionCeilingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentAgentIdPermissionCeilingsPost(agentId: number, agentPermissionCeilingInput: AgentPermissionCeilingInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentPermissionCeiling>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentAgentIdPermissionCeilingsPost(agentId, agentPermissionCeilingInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiAgentAgentIdPermissionCeilingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The caller\'s own effective permissions in this team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdPermissionsMeGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectivePermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdPermissionsMeGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdPermissionsMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke a role assignment
         * @param {number} teamId 
         * @param {number} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete(teamId: number, assignmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete(teamId, assignmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List every role assignment in the team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRoleAssignmentsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleAssignment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRoleAssignmentsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdRoleAssignmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grant a role at team or project scope
         * @param {number} teamId 
         * @param {RoleAssignmentInput} roleAssignmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRoleAssignmentsPost(teamId: number, roleAssignmentInput: RoleAssignmentInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleAssignmentResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRoleAssignmentsPost(teamId, roleAssignmentInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdRoleAssignmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the team\'s built-in and custom roles
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRolesGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamRoles>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRolesGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a custom role
         * @param {number} teamId 
         * @param {RoleInput} roleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRolesPost(teamId: number, roleInput: RoleInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Role>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRolesPost(teamId, roleInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdRolesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a custom role
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {boolean} [force] Cascade: revoke every assignment referencing this role. Without it a role still in use is refused with 409 and the count. A cascading delete is a mass revocation and requires ROLE:manage, not the ROLE:edit a plain delete takes. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRolesRoleIdDelete(teamId: number, roleId: string, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDeleteResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRolesRoleIdDelete(teamId, roleId, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdRolesRoleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get one role — a numeric custom role id, or a built-in key
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRolesRoleIdGet(teamId: number, roleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Role>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRolesRoleIdGet(teamId, roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdRolesRoleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a custom role (built-ins are read-only)
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {RoleUpdateInput} roleUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRolesRoleIdPut(teamId: number, roleId: string, roleUpdateInput: RoleUpdateInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Role>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRolesRoleIdPut(teamId, roleId, roleUpdateInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.apiTeamsTeamIdRolesRoleIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesApi - factory interface
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * A SURFACE CEILING, never a grant — applies only to turns from senders who are not team members. Neither field set means the agent does not talk to outsiders at all. 
         * @summary Get the agent\'s external communications role
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdExternalRoleGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExternalRole> {
            return localVarFp.apiAgentAgentIdExternalRoleGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set, replace, or clear the agent\'s external communications role
         * @param {number} agentId 
         * @param {ExternalRoleInput} externalRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdExternalRolePut(agentId: number, externalRoleInput: ExternalRoleInput, options?: RawAxiosRequestConfig): AxiosPromise<ExternalRole> {
            return localVarFp.apiAgentAgentIdExternalRolePut(agentId, externalRoleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a ceiling role from the agent
         * @param {number} agentId 
         * @param {number} ceilingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdPermissionCeilingsCeilingIdDelete(agentId: number, ceilingId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiAgentAgentIdPermissionCeilingsCeilingIdDelete(agentId, ceilingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the agent\'s ceiling roles
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdPermissionCeilingsGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentPermissionCeiling>> {
            return localVarFp.apiAgentAgentIdPermissionCeilingsGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attach a ceiling role to the agent
         * @param {number} agentId 
         * @param {AgentPermissionCeilingInput} agentPermissionCeilingInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentAgentIdPermissionCeilingsPost(agentId: number, agentPermissionCeilingInput: AgentPermissionCeilingInput, options?: RawAxiosRequestConfig): AxiosPromise<AgentPermissionCeiling> {
            return localVarFp.apiAgentAgentIdPermissionCeilingsPost(agentId, agentPermissionCeilingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The caller\'s own effective permissions in this team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdPermissionsMeGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<EffectivePermissions> {
            return localVarFp.apiTeamsTeamIdPermissionsMeGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke a role assignment
         * @param {number} teamId 
         * @param {number} assignmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete(teamId: number, assignmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete(teamId, assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List every role assignment in the team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRoleAssignmentsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleAssignment>> {
            return localVarFp.apiTeamsTeamIdRoleAssignmentsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grant a role at team or project scope
         * @param {number} teamId 
         * @param {RoleAssignmentInput} roleAssignmentInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRoleAssignmentsPost(teamId: number, roleAssignmentInput: RoleAssignmentInput, options?: RawAxiosRequestConfig): AxiosPromise<RoleAssignmentResult> {
            return localVarFp.apiTeamsTeamIdRoleAssignmentsPost(teamId, roleAssignmentInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the team\'s built-in and custom roles
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamRoles> {
            return localVarFp.apiTeamsTeamIdRolesGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a custom role
         * @param {number} teamId 
         * @param {RoleInput} roleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesPost(teamId: number, roleInput: RoleInput, options?: RawAxiosRequestConfig): AxiosPromise<Role> {
            return localVarFp.apiTeamsTeamIdRolesPost(teamId, roleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a custom role
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {boolean} [force] Cascade: revoke every assignment referencing this role. Without it a role still in use is refused with 409 and the count. A cascading delete is a mass revocation and requires ROLE:manage, not the ROLE:edit a plain delete takes. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesRoleIdDelete(teamId: number, roleId: string, force?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<RoleDeleteResult> {
            return localVarFp.apiTeamsTeamIdRolesRoleIdDelete(teamId, roleId, force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one role — a numeric custom role id, or a built-in key
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesRoleIdGet(teamId: number, roleId: string, options?: RawAxiosRequestConfig): AxiosPromise<Role> {
            return localVarFp.apiTeamsTeamIdRolesRoleIdGet(teamId, roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a custom role (built-ins are read-only)
         * @param {number} teamId 
         * @param {string} roleId 
         * @param {RoleUpdateInput} roleUpdateInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRolesRoleIdPut(teamId: number, roleId: string, roleUpdateInput: RoleUpdateInput, options?: RawAxiosRequestConfig): AxiosPromise<Role> {
            return localVarFp.apiTeamsTeamIdRolesRoleIdPut(teamId, roleId, roleUpdateInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 */
export class RolesApi extends BaseAPI {
    /**
     * A SURFACE CEILING, never a grant — applies only to turns from senders who are not team members. Neither field set means the agent does not talk to outsiders at all. 
     * @summary Get the agent\'s external communications role
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdExternalRoleGet(agentId: number, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiAgentAgentIdExternalRoleGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set, replace, or clear the agent\'s external communications role
     * @param {number} agentId 
     * @param {ExternalRoleInput} externalRoleInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdExternalRolePut(agentId: number, externalRoleInput: ExternalRoleInput, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiAgentAgentIdExternalRolePut(agentId, externalRoleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a ceiling role from the agent
     * @param {number} agentId 
     * @param {number} ceilingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdPermissionCeilingsCeilingIdDelete(agentId: number, ceilingId: number, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiAgentAgentIdPermissionCeilingsCeilingIdDelete(agentId, ceilingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the agent\'s ceiling roles
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdPermissionCeilingsGet(agentId: number, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiAgentAgentIdPermissionCeilingsGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attach a ceiling role to the agent
     * @param {number} agentId 
     * @param {AgentPermissionCeilingInput} agentPermissionCeilingInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentAgentIdPermissionCeilingsPost(agentId: number, agentPermissionCeilingInput: AgentPermissionCeilingInput, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiAgentAgentIdPermissionCeilingsPost(agentId, agentPermissionCeilingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The caller\'s own effective permissions in this team
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdPermissionsMeGet(teamId: number, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdPermissionsMeGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke a role assignment
     * @param {number} teamId 
     * @param {number} assignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete(teamId: number, assignmentId: number, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdRoleAssignmentsAssignmentIdDelete(teamId, assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List every role assignment in the team
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRoleAssignmentsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdRoleAssignmentsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grant a role at team or project scope
     * @param {number} teamId 
     * @param {RoleAssignmentInput} roleAssignmentInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRoleAssignmentsPost(teamId: number, roleAssignmentInput: RoleAssignmentInput, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdRoleAssignmentsPost(teamId, roleAssignmentInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the team\'s built-in and custom roles
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRolesGet(teamId: number, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdRolesGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a custom role
     * @param {number} teamId 
     * @param {RoleInput} roleInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRolesPost(teamId: number, roleInput: RoleInput, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdRolesPost(teamId, roleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a custom role
     * @param {number} teamId 
     * @param {string} roleId 
     * @param {boolean} [force] Cascade: revoke every assignment referencing this role. Without it a role still in use is refused with 409 and the count. A cascading delete is a mass revocation and requires ROLE:manage, not the ROLE:edit a plain delete takes. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRolesRoleIdDelete(teamId: number, roleId: string, force?: boolean, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdRolesRoleIdDelete(teamId, roleId, force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one role — a numeric custom role id, or a built-in key
     * @param {number} teamId 
     * @param {string} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRolesRoleIdGet(teamId: number, roleId: string, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdRolesRoleIdGet(teamId, roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a custom role (built-ins are read-only)
     * @param {number} teamId 
     * @param {string} roleId 
     * @param {RoleUpdateInput} roleUpdateInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRolesRoleIdPut(teamId: number, roleId: string, roleUpdateInput: RoleUpdateInput, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).apiTeamsTeamIdRolesRoleIdPut(teamId, roleId, roleUpdateInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SSOApi - axios parameter creator
 */
export const SSOApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List a team\'s active break-glass grants
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoBreakGlassGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoBreakGlassGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/sso/break-glass`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke a break-glass grant
         * @param {number} teamId 
         * @param {number} grantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoBreakGlassGrantIdDelete: async (teamId: number, grantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoBreakGlassGrantIdDelete', 'teamId', teamId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoBreakGlassGrantIdDelete', 'grantId', grantId)
            const localVarPath = `/api/teams/{teamId}/sso/break-glass/{grantId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"grantId"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grant a break-glass exemption to one or more users
         * @param {number} teamId 
         * @param {GrantBreakGlassRequest} grantBreakGlassRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoBreakGlassPost: async (teamId: number, grantBreakGlassRequest: GrantBreakGlassRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoBreakGlassPost', 'teamId', teamId)
            // verify required parameter 'grantBreakGlassRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoBreakGlassPost', 'grantBreakGlassRequest', grantBreakGlassRequest)
            const localVarPath = `/api/teams/{teamId}/sso/break-glass`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantBreakGlassRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a SAML connection
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsConnectionIdDelete: async (teamId: number, connectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsConnectionIdDelete', 'teamId', teamId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsConnectionIdDelete', 'connectionId', connectionId)
            const localVarPath = `/api/teams/{teamId}/sso/connections/{connectionId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-populate an existing connection\'s IdP endpoints and signing certificates from fresh federation metadata (URL or pasted XML)
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {ImportSsoMetadataRequest} importSsoMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost: async (teamId: number, connectionId: number, importSsoMetadataRequest: ImportSsoMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost', 'teamId', teamId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost', 'connectionId', connectionId)
            // verify required parameter 'importSsoMetadataRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost', 'importSsoMetadataRequest', importSsoMetadataRequest)
            const localVarPath = `/api/teams/{teamId}/sso/connections/{connectionId}/metadata-import`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importSsoMetadataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a SAML connection
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {UpdateSsoConnectionRequest} updateSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsConnectionIdPut: async (teamId: number, connectionId: number, updateSsoConnectionRequest: UpdateSsoConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsConnectionIdPut', 'teamId', teamId)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsConnectionIdPut', 'connectionId', connectionId)
            // verify required parameter 'updateSsoConnectionRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsConnectionIdPut', 'updateSsoConnectionRequest', updateSsoConnectionRequest)
            const localVarPath = `/api/teams/{teamId}/sso/connections/{connectionId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"connectionId"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSsoConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a team\'s SAML connections
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/sso/connections`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Parse an identity provider\'s federation metadata (URL or pasted XML) and return the fields it names, without creating a connection
         * @param {number} teamId 
         * @param {ImportSsoMetadataRequest} importSsoMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsMetadataPreviewPost: async (teamId: number, importSsoMetadataRequest: ImportSsoMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsMetadataPreviewPost', 'teamId', teamId)
            // verify required parameter 'importSsoMetadataRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsMetadataPreviewPost', 'importSsoMetadataRequest', importSsoMetadataRequest)
            const localVarPath = `/api/teams/{teamId}/sso/connections/metadata-preview`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importSsoMetadataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a SAML connection
         * @param {number} teamId 
         * @param {CreateSsoConnectionRequest} createSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsPost: async (teamId: number, createSsoConnectionRequest: CreateSsoConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsPost', 'teamId', teamId)
            // verify required parameter 'createSsoConnectionRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoConnectionsPost', 'createSsoConnectionRequest', createSsoConnectionRequest)
            const localVarPath = `/api/teams/{teamId}/sso/connections`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSsoConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Switch a verified domain\'s auto-join on or off
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetAutoJoinRequest} setAutoJoinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut: async (teamId: number, domainId: number, setAutoJoinRequest: SetAutoJoinRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut', 'teamId', teamId)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut', 'domainId', domainId)
            // verify required parameter 'setAutoJoinRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut', 'setAutoJoinRequest', setAutoJoinRequest)
            const localVarPath = `/api/teams/{teamId}/sso/domains/{domainId}/auto-join`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"domainId"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAutoJoinRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recheck a claimed domain\'s DNS verification
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdCheckPost: async (teamId: number, domainId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdCheckPost', 'teamId', teamId)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdCheckPost', 'domainId', domainId)
            const localVarPath = `/api/teams/{teamId}/sso/domains/{domainId}/check`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"domainId"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bind (or unbind) the SAML connection a verified domain trusts
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetSsoConnectionRequest} setSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdConnectionPut: async (teamId: number, domainId: number, setSsoConnectionRequest: SetSsoConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdConnectionPut', 'teamId', teamId)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdConnectionPut', 'domainId', domainId)
            // verify required parameter 'setSsoConnectionRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdConnectionPut', 'setSsoConnectionRequest', setSsoConnectionRequest)
            const localVarPath = `/api/teams/{teamId}/sso/domains/{domainId}/connection`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"domainId"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSsoConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a claimed domain
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdDelete: async (teamId: number, domainId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdDelete', 'teamId', teamId)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdDelete', 'domainId', domainId)
            const localVarPath = `/api/teams/{teamId}/sso/domains/{domainId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"domainId"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the login mode a verified domain enforces
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetLoginModeRequest} setLoginModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdLoginModePut: async (teamId: number, domainId: number, setLoginModeRequest: SetLoginModeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdLoginModePut', 'teamId', teamId)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdLoginModePut', 'domainId', domainId)
            // verify required parameter 'setLoginModeRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsDomainIdLoginModePut', 'setLoginModeRequest', setLoginModeRequest)
            const localVarPath = `/api/teams/{teamId}/sso/domains/{domainId}/login-mode`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"domainId"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setLoginModeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a team\'s claimed domains
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/sso/domains`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Claim an email domain for the team
         * @param {number} teamId 
         * @param {ClaimDomainRequest} claimDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsPost: async (teamId: number, claimDomainRequest: ClaimDomainRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsPost', 'teamId', teamId)
            // verify required parameter 'claimDomainRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdSsoDomainsPost', 'claimDomainRequest', claimDomainRequest)
            const localVarPath = `/api/teams/{teamId}/sso/domains`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimDomainRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SSOApi - functional programming interface
 */
export const SSOApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SSOApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List a team\'s active break-glass grants
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoBreakGlassGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdSsoBreakGlassGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoBreakGlassGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoBreakGlassGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke a break-glass grant
         * @param {number} teamId 
         * @param {number} grantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoBreakGlassGrantIdDelete(teamId: number, grantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoBreakGlassGrantIdDelete(teamId, grantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoBreakGlassGrantIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grant a break-glass exemption to one or more users
         * @param {number} teamId 
         * @param {GrantBreakGlassRequest} grantBreakGlassRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoBreakGlassPost(teamId: number, grantBreakGlassRequest: GrantBreakGlassRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdSsoBreakGlassGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoBreakGlassPost(teamId, grantBreakGlassRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoBreakGlassPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a SAML connection
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoConnectionsConnectionIdDelete(teamId: number, connectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoConnectionsConnectionIdDelete(teamId, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoConnectionsConnectionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Re-populate an existing connection\'s IdP endpoints and signing certificates from fresh federation metadata (URL or pasted XML)
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {ImportSsoMetadataRequest} importSsoMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost(teamId: number, connectionId: number, importSsoMetadataRequest: ImportSsoMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSsoConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost(teamId, connectionId, importSsoMetadataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a SAML connection
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {UpdateSsoConnectionRequest} updateSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoConnectionsConnectionIdPut(teamId: number, connectionId: number, updateSsoConnectionRequest: UpdateSsoConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSsoConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoConnectionsConnectionIdPut(teamId, connectionId, updateSsoConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoConnectionsConnectionIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a team\'s SAML connections
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoConnectionsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdSsoConnectionsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoConnectionsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoConnectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Parse an identity provider\'s federation metadata (URL or pasted XML) and return the fields it names, without creating a connection
         * @param {number} teamId 
         * @param {ImportSsoMetadataRequest} importSsoMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoConnectionsMetadataPreviewPost(teamId: number, importSsoMetadataRequest: ImportSsoMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoMetadataPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoConnectionsMetadataPreviewPost(teamId, importSsoMetadataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoConnectionsMetadataPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a SAML connection
         * @param {number} teamId 
         * @param {CreateSsoConnectionRequest} createSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoConnectionsPost(teamId: number, createSsoConnectionRequest: CreateSsoConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSsoConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoConnectionsPost(teamId, createSsoConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoConnectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Switch a verified domain\'s auto-join on or off
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetAutoJoinRequest} setAutoJoinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut(teamId: number, domainId: number, setAutoJoinRequest: SetAutoJoinRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimedDomain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut(teamId, domainId, setAutoJoinRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recheck a claimed domain\'s DNS verification
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoDomainsDomainIdCheckPost(teamId: number, domainId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimedDomain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoDomainsDomainIdCheckPost(teamId, domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoDomainsDomainIdCheckPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bind (or unbind) the SAML connection a verified domain trusts
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetSsoConnectionRequest} setSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoDomainsDomainIdConnectionPut(teamId: number, domainId: number, setSsoConnectionRequest: SetSsoConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimedDomain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoDomainsDomainIdConnectionPut(teamId, domainId, setSsoConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoDomainsDomainIdConnectionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a claimed domain
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoDomainsDomainIdDelete(teamId: number, domainId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoDomainsDomainIdDelete(teamId, domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoDomainsDomainIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set the login mode a verified domain enforces
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetLoginModeRequest} setLoginModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoDomainsDomainIdLoginModePut(teamId: number, domainId: number, setLoginModeRequest: SetLoginModeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimedDomain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoDomainsDomainIdLoginModePut(teamId, domainId, setLoginModeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoDomainsDomainIdLoginModePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a team\'s claimed domains
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoDomainsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdSsoDomainsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoDomainsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoDomainsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Claim an email domain for the team
         * @param {number} teamId 
         * @param {ClaimDomainRequest} claimDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSsoDomainsPost(teamId: number, claimDomainRequest: ClaimDomainRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimedDomain>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSsoDomainsPost(teamId, claimDomainRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOApi.apiTeamsTeamIdSsoDomainsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SSOApi - factory interface
 */
export const SSOApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SSOApiFp(configuration)
    return {
        /**
         * 
         * @summary List a team\'s active break-glass grants
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoBreakGlassGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdSsoBreakGlassGet200Response> {
            return localVarFp.apiTeamsTeamIdSsoBreakGlassGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke a break-glass grant
         * @param {number} teamId 
         * @param {number} grantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoBreakGlassGrantIdDelete(teamId: number, grantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdSsoBreakGlassGrantIdDelete(teamId, grantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grant a break-glass exemption to one or more users
         * @param {number} teamId 
         * @param {GrantBreakGlassRequest} grantBreakGlassRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoBreakGlassPost(teamId: number, grantBreakGlassRequest: GrantBreakGlassRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdSsoBreakGlassGet200Response> {
            return localVarFp.apiTeamsTeamIdSsoBreakGlassPost(teamId, grantBreakGlassRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a SAML connection
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsConnectionIdDelete(teamId: number, connectionId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdSsoConnectionsConnectionIdDelete(teamId, connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-populate an existing connection\'s IdP endpoints and signing certificates from fresh federation metadata (URL or pasted XML)
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {ImportSsoMetadataRequest} importSsoMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost(teamId: number, connectionId: number, importSsoMetadataRequest: ImportSsoMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamSsoConnection> {
            return localVarFp.apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost(teamId, connectionId, importSsoMetadataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a SAML connection
         * @param {number} teamId 
         * @param {number} connectionId 
         * @param {UpdateSsoConnectionRequest} updateSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsConnectionIdPut(teamId: number, connectionId: number, updateSsoConnectionRequest: UpdateSsoConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamSsoConnection> {
            return localVarFp.apiTeamsTeamIdSsoConnectionsConnectionIdPut(teamId, connectionId, updateSsoConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a team\'s SAML connections
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdSsoConnectionsGet200Response> {
            return localVarFp.apiTeamsTeamIdSsoConnectionsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Parse an identity provider\'s federation metadata (URL or pasted XML) and return the fields it names, without creating a connection
         * @param {number} teamId 
         * @param {ImportSsoMetadataRequest} importSsoMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsMetadataPreviewPost(teamId: number, importSsoMetadataRequest: ImportSsoMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<SsoMetadataPreview> {
            return localVarFp.apiTeamsTeamIdSsoConnectionsMetadataPreviewPost(teamId, importSsoMetadataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a SAML connection
         * @param {number} teamId 
         * @param {CreateSsoConnectionRequest} createSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoConnectionsPost(teamId: number, createSsoConnectionRequest: CreateSsoConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamSsoConnection> {
            return localVarFp.apiTeamsTeamIdSsoConnectionsPost(teamId, createSsoConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Switch a verified domain\'s auto-join on or off
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetAutoJoinRequest} setAutoJoinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut(teamId: number, domainId: number, setAutoJoinRequest: SetAutoJoinRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimedDomain> {
            return localVarFp.apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut(teamId, domainId, setAutoJoinRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recheck a claimed domain\'s DNS verification
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdCheckPost(teamId: number, domainId: number, options?: RawAxiosRequestConfig): AxiosPromise<ClaimedDomain> {
            return localVarFp.apiTeamsTeamIdSsoDomainsDomainIdCheckPost(teamId, domainId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bind (or unbind) the SAML connection a verified domain trusts
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetSsoConnectionRequest} setSsoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdConnectionPut(teamId: number, domainId: number, setSsoConnectionRequest: SetSsoConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimedDomain> {
            return localVarFp.apiTeamsTeamIdSsoDomainsDomainIdConnectionPut(teamId, domainId, setSsoConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a claimed domain
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdDelete(teamId: number, domainId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdSsoDomainsDomainIdDelete(teamId, domainId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the login mode a verified domain enforces
         * @param {number} teamId 
         * @param {number} domainId 
         * @param {SetLoginModeRequest} setLoginModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsDomainIdLoginModePut(teamId: number, domainId: number, setLoginModeRequest: SetLoginModeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimedDomain> {
            return localVarFp.apiTeamsTeamIdSsoDomainsDomainIdLoginModePut(teamId, domainId, setLoginModeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a team\'s claimed domains
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdSsoDomainsGet200Response> {
            return localVarFp.apiTeamsTeamIdSsoDomainsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Claim an email domain for the team
         * @param {number} teamId 
         * @param {ClaimDomainRequest} claimDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSsoDomainsPost(teamId: number, claimDomainRequest: ClaimDomainRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimedDomain> {
            return localVarFp.apiTeamsTeamIdSsoDomainsPost(teamId, claimDomainRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SSOApi - object-oriented interface
 */
export class SSOApi extends BaseAPI {
    /**
     * 
     * @summary List a team\'s active break-glass grants
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoBreakGlassGet(teamId: number, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoBreakGlassGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke a break-glass grant
     * @param {number} teamId 
     * @param {number} grantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoBreakGlassGrantIdDelete(teamId: number, grantId: number, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoBreakGlassGrantIdDelete(teamId, grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grant a break-glass exemption to one or more users
     * @param {number} teamId 
     * @param {GrantBreakGlassRequest} grantBreakGlassRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoBreakGlassPost(teamId: number, grantBreakGlassRequest: GrantBreakGlassRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoBreakGlassPost(teamId, grantBreakGlassRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a SAML connection
     * @param {number} teamId 
     * @param {number} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoConnectionsConnectionIdDelete(teamId: number, connectionId: number, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoConnectionsConnectionIdDelete(teamId, connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-populate an existing connection\'s IdP endpoints and signing certificates from fresh federation metadata (URL or pasted XML)
     * @param {number} teamId 
     * @param {number} connectionId 
     * @param {ImportSsoMetadataRequest} importSsoMetadataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost(teamId: number, connectionId: number, importSsoMetadataRequest: ImportSsoMetadataRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoConnectionsConnectionIdMetadataImportPost(teamId, connectionId, importSsoMetadataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a SAML connection
     * @param {number} teamId 
     * @param {number} connectionId 
     * @param {UpdateSsoConnectionRequest} updateSsoConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoConnectionsConnectionIdPut(teamId: number, connectionId: number, updateSsoConnectionRequest: UpdateSsoConnectionRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoConnectionsConnectionIdPut(teamId, connectionId, updateSsoConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a team\'s SAML connections
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoConnectionsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoConnectionsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Parse an identity provider\'s federation metadata (URL or pasted XML) and return the fields it names, without creating a connection
     * @param {number} teamId 
     * @param {ImportSsoMetadataRequest} importSsoMetadataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoConnectionsMetadataPreviewPost(teamId: number, importSsoMetadataRequest: ImportSsoMetadataRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoConnectionsMetadataPreviewPost(teamId, importSsoMetadataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a SAML connection
     * @param {number} teamId 
     * @param {CreateSsoConnectionRequest} createSsoConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoConnectionsPost(teamId: number, createSsoConnectionRequest: CreateSsoConnectionRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoConnectionsPost(teamId, createSsoConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Switch a verified domain\'s auto-join on or off
     * @param {number} teamId 
     * @param {number} domainId 
     * @param {SetAutoJoinRequest} setAutoJoinRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut(teamId: number, domainId: number, setAutoJoinRequest: SetAutoJoinRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoDomainsDomainIdAutoJoinPut(teamId, domainId, setAutoJoinRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recheck a claimed domain\'s DNS verification
     * @param {number} teamId 
     * @param {number} domainId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoDomainsDomainIdCheckPost(teamId: number, domainId: number, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoDomainsDomainIdCheckPost(teamId, domainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bind (or unbind) the SAML connection a verified domain trusts
     * @param {number} teamId 
     * @param {number} domainId 
     * @param {SetSsoConnectionRequest} setSsoConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoDomainsDomainIdConnectionPut(teamId: number, domainId: number, setSsoConnectionRequest: SetSsoConnectionRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoDomainsDomainIdConnectionPut(teamId, domainId, setSsoConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a claimed domain
     * @param {number} teamId 
     * @param {number} domainId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoDomainsDomainIdDelete(teamId: number, domainId: number, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoDomainsDomainIdDelete(teamId, domainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the login mode a verified domain enforces
     * @param {number} teamId 
     * @param {number} domainId 
     * @param {SetLoginModeRequest} setLoginModeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoDomainsDomainIdLoginModePut(teamId: number, domainId: number, setLoginModeRequest: SetLoginModeRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoDomainsDomainIdLoginModePut(teamId, domainId, setLoginModeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a team\'s claimed domains
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoDomainsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoDomainsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Claim an email domain for the team
     * @param {number} teamId 
     * @param {ClaimDomainRequest} claimDomainRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSsoDomainsPost(teamId: number, claimDomainRequest: ClaimDomainRequest, options?: RawAxiosRequestConfig) {
        return SSOApiFp(this.configuration).apiTeamsTeamIdSsoDomainsPost(teamId, claimDomainRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScheduledTasksApi - axios parameter creator
 */
export const ScheduledTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dispatch due scheduled tasks and reconcile loop tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScheduledTasksDispatchDuePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scheduled-tasks/dispatch-due`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a scheduled task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScheduledTasksTaskIdDelete: async (taskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('apiScheduledTasksTaskIdDelete', 'taskId', taskId)
            const localVarPath = `/api/scheduled-tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a scheduled task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScheduledTasksTaskIdGet: async (taskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('apiScheduledTasksTaskIdGet', 'taskId', taskId)
            const localVarPath = `/api/scheduled-tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a scheduled task
         * @param {number} taskId 
         * @param {ScheduledTaskRequest} scheduledTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScheduledTasksTaskIdPut: async (taskId: number, scheduledTaskRequest: ScheduledTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('apiScheduledTasksTaskIdPut', 'taskId', taskId)
            // verify required parameter 'scheduledTaskRequest' is not null or undefined
            assertParamExists('apiScheduledTasksTaskIdPut', 'scheduledTaskRequest', scheduledTaskRequest)
            const localVarPath = `/api/scheduled-tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduledTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List scheduled tasks for a team
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdScheduledTasksGet: async (teamId: number, agentId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdScheduledTasksGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/scheduled-tasks`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a scheduled task
         * @param {number} teamId 
         * @param {ScheduledTaskRequest} scheduledTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdScheduledTasksPost: async (teamId: number, scheduledTaskRequest: ScheduledTaskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdScheduledTasksPost', 'teamId', teamId)
            // verify required parameter 'scheduledTaskRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdScheduledTasksPost', 'scheduledTaskRequest', scheduledTaskRequest)
            const localVarPath = `/api/teams/{teamId}/scheduled-tasks`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduledTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduledTasksApi - functional programming interface
 */
export const ScheduledTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScheduledTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Dispatch due scheduled tasks and reconcile loop tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScheduledTasksDispatchDuePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledTaskDispatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScheduledTasksDispatchDuePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledTasksApi.apiScheduledTasksDispatchDuePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a scheduled task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScheduledTasksTaskIdDelete(taskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScheduledTasksTaskIdDelete(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledTasksApi.apiScheduledTasksTaskIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a scheduled task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScheduledTasksTaskIdGet(taskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScheduledTasksTaskIdGet(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledTasksApi.apiScheduledTasksTaskIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a scheduled task
         * @param {number} taskId 
         * @param {ScheduledTaskRequest} scheduledTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScheduledTasksTaskIdPut(taskId: number, scheduledTaskRequest: ScheduledTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScheduledTasksTaskIdPut(taskId, scheduledTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledTasksApi.apiScheduledTasksTaskIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List scheduled tasks for a team
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdScheduledTasksGet(teamId: number, agentId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledTaskListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdScheduledTasksGet(teamId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledTasksApi.apiTeamsTeamIdScheduledTasksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a scheduled task
         * @param {number} teamId 
         * @param {ScheduledTaskRequest} scheduledTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdScheduledTasksPost(teamId: number, scheduledTaskRequest: ScheduledTaskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdScheduledTasksPost(teamId, scheduledTaskRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledTasksApi.apiTeamsTeamIdScheduledTasksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScheduledTasksApi - factory interface
 */
export const ScheduledTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScheduledTasksApiFp(configuration)
    return {
        /**
         * 
         * @summary Dispatch due scheduled tasks and reconcile loop tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScheduledTasksDispatchDuePost(options?: RawAxiosRequestConfig): AxiosPromise<ScheduledTaskDispatchResponse> {
            return localVarFp.apiScheduledTasksDispatchDuePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a scheduled task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScheduledTasksTaskIdDelete(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiScheduledTasksTaskIdDelete(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a scheduled task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScheduledTasksTaskIdGet(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledTaskResponse> {
            return localVarFp.apiScheduledTasksTaskIdGet(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a scheduled task
         * @param {number} taskId 
         * @param {ScheduledTaskRequest} scheduledTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScheduledTasksTaskIdPut(taskId: number, scheduledTaskRequest: ScheduledTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledTaskResponse> {
            return localVarFp.apiScheduledTasksTaskIdPut(taskId, scheduledTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List scheduled tasks for a team
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdScheduledTasksGet(teamId: number, agentId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledTaskListResponse> {
            return localVarFp.apiTeamsTeamIdScheduledTasksGet(teamId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a scheduled task
         * @param {number} teamId 
         * @param {ScheduledTaskRequest} scheduledTaskRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdScheduledTasksPost(teamId: number, scheduledTaskRequest: ScheduledTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledTaskResponse> {
            return localVarFp.apiTeamsTeamIdScheduledTasksPost(teamId, scheduledTaskRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScheduledTasksApi - object-oriented interface
 */
export class ScheduledTasksApi extends BaseAPI {
    /**
     * 
     * @summary Dispatch due scheduled tasks and reconcile loop tasks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiScheduledTasksDispatchDuePost(options?: RawAxiosRequestConfig) {
        return ScheduledTasksApiFp(this.configuration).apiScheduledTasksDispatchDuePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a scheduled task
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiScheduledTasksTaskIdDelete(taskId: number, options?: RawAxiosRequestConfig) {
        return ScheduledTasksApiFp(this.configuration).apiScheduledTasksTaskIdDelete(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a scheduled task
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiScheduledTasksTaskIdGet(taskId: number, options?: RawAxiosRequestConfig) {
        return ScheduledTasksApiFp(this.configuration).apiScheduledTasksTaskIdGet(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a scheduled task
     * @param {number} taskId 
     * @param {ScheduledTaskRequest} scheduledTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiScheduledTasksTaskIdPut(taskId: number, scheduledTaskRequest: ScheduledTaskRequest, options?: RawAxiosRequestConfig) {
        return ScheduledTasksApiFp(this.configuration).apiScheduledTasksTaskIdPut(taskId, scheduledTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List scheduled tasks for a team
     * @param {number} teamId 
     * @param {number} [agentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdScheduledTasksGet(teamId: number, agentId?: number, options?: RawAxiosRequestConfig) {
        return ScheduledTasksApiFp(this.configuration).apiTeamsTeamIdScheduledTasksGet(teamId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a scheduled task
     * @param {number} teamId 
     * @param {ScheduledTaskRequest} scheduledTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdScheduledTasksPost(teamId: number, scheduledTaskRequest: ScheduledTaskRequest, options?: RawAxiosRequestConfig) {
        return ScheduledTasksApiFp(this.configuration).apiTeamsTeamIdScheduledTasksPost(teamId, scheduledTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SearchApi - axios parameter creator
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search conversations and messages by vector similarity
         * @param {VectorSearchRequest} vectorSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsSearchPost: async (vectorSearchRequest: VectorSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vectorSearchRequest' is not null or undefined
            assertParamExists('apiConversationsSearchPost', 'vectorSearchRequest', vectorSearchRequest)
            const localVarPath = `/api/conversations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vectorSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Search conversations and messages by vector similarity
         * @param {VectorSearchRequest} vectorSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiConversationsSearchPost(vectorSearchRequest: VectorSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VectorSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiConversationsSearchPost(vectorSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.apiConversationsSearchPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchApi - factory interface
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         * 
         * @summary Search conversations and messages by vector similarity
         * @param {VectorSearchRequest} vectorSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConversationsSearchPost(vectorSearchRequest: VectorSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<VectorSearchResponse> {
            return localVarFp.apiConversationsSearchPost(vectorSearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchApi - object-oriented interface
 */
export class SearchApi extends BaseAPI {
    /**
     * 
     * @summary Search conversations and messages by vector similarity
     * @param {VectorSearchRequest} vectorSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiConversationsSearchPost(vectorSearchRequest: VectorSearchRequest, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).apiConversationsSearchPost(vectorSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SendGridApi - axios parameter creator
 */
export const SendGridApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint receives parsed emails from SendGrid\'s Inbound Parse webhook. It processes incoming emails and forwards them to the appropriate agent for handling. 
         * @summary Webhook endpoint for SendGrid Inbound Parse
         * @param {string} from Email sender address
         * @param {string} to Email recipient address
         * @param {string} subject Email subject line
         * @param {string} [text] Plain text content of the email
         * @param {string} [html] HTML content of the email
         * @param {string} [senderIp] IP address of the sender
         * @param {string} [envelope] SMTP envelope information in JSON format
         * @param {number} [attachments] Number of attachments
         * @param {string} [attachmentInfo] Information about attachments in JSON format
         * @param {string} [headers] Email headers
         * @param {string} [dkim] DKIM signature check result
         * @param {string} [spamScore] Spam score of the email
         * @param {string} [spamReport] Detailed spam report
         * @param {string} [spf] SPF check result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSendgridInboundPost: async (from: string, to: string, subject: string, text?: string, html?: string, senderIp?: string, envelope?: string, attachments?: number, attachmentInfo?: string, headers?: string, dkim?: string, spamScore?: string, spamReport?: string, spf?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('apiSendgridInboundPost', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('apiSendgridInboundPost', 'to', to)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('apiSendgridInboundPost', 'subject', subject)
            const localVarPath = `/api/sendgrid/inbound`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (from !== undefined) { 
                localVarFormParams.append('from', from as any);
            }
    
            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }
    
            if (subject !== undefined) { 
                localVarFormParams.append('subject', subject as any);
            }
    
            if (text !== undefined) { 
                localVarFormParams.append('text', text as any);
            }
    
            if (html !== undefined) { 
                localVarFormParams.append('html', html as any);
            }
    
            if (senderIp !== undefined) { 
                localVarFormParams.append('sender_ip', senderIp as any);
            }
    
            if (envelope !== undefined) { 
                localVarFormParams.append('envelope', envelope as any);
            }
    
            if (attachments !== undefined) { 
                localVarFormParams.append('attachments', attachments as any);
            }
    
            if (attachmentInfo !== undefined) { 
                localVarFormParams.append('attachment-info', attachmentInfo as any);
            }
    
            if (headers !== undefined) { 
                localVarFormParams.append('headers', headers as any);
            }
    
            if (dkim !== undefined) { 
                localVarFormParams.append('dkim', dkim as any);
            }
    
            if (spamScore !== undefined) { 
                localVarFormParams.append('spam_score', spamScore as any);
            }
    
            if (spamReport !== undefined) { 
                localVarFormParams.append('spam_report', spamReport as any);
            }
    
            if (spf !== undefined) { 
                localVarFormParams.append('spf', spf as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SendGridApi - functional programming interface
 */
export const SendGridApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SendGridApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint receives parsed emails from SendGrid\'s Inbound Parse webhook. It processes incoming emails and forwards them to the appropriate agent for handling. 
         * @summary Webhook endpoint for SendGrid Inbound Parse
         * @param {string} from Email sender address
         * @param {string} to Email recipient address
         * @param {string} subject Email subject line
         * @param {string} [text] Plain text content of the email
         * @param {string} [html] HTML content of the email
         * @param {string} [senderIp] IP address of the sender
         * @param {string} [envelope] SMTP envelope information in JSON format
         * @param {number} [attachments] Number of attachments
         * @param {string} [attachmentInfo] Information about attachments in JSON format
         * @param {string} [headers] Email headers
         * @param {string} [dkim] DKIM signature check result
         * @param {string} [spamScore] Spam score of the email
         * @param {string} [spamReport] Detailed spam report
         * @param {string} [spf] SPF check result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSendgridInboundPost(from: string, to: string, subject: string, text?: string, html?: string, senderIp?: string, envelope?: string, attachments?: number, attachmentInfo?: string, headers?: string, dkim?: string, spamScore?: string, spamReport?: string, spf?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSendgridInboundPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSendgridInboundPost(from, to, subject, text, html, senderIp, envelope, attachments, attachmentInfo, headers, dkim, spamScore, spamReport, spf, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SendGridApi.apiSendgridInboundPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SendGridApi - factory interface
 */
export const SendGridApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SendGridApiFp(configuration)
    return {
        /**
         * This endpoint receives parsed emails from SendGrid\'s Inbound Parse webhook. It processes incoming emails and forwards them to the appropriate agent for handling. 
         * @summary Webhook endpoint for SendGrid Inbound Parse
         * @param {string} from Email sender address
         * @param {string} to Email recipient address
         * @param {string} subject Email subject line
         * @param {string} [text] Plain text content of the email
         * @param {string} [html] HTML content of the email
         * @param {string} [senderIp] IP address of the sender
         * @param {string} [envelope] SMTP envelope information in JSON format
         * @param {number} [attachments] Number of attachments
         * @param {string} [attachmentInfo] Information about attachments in JSON format
         * @param {string} [headers] Email headers
         * @param {string} [dkim] DKIM signature check result
         * @param {string} [spamScore] Spam score of the email
         * @param {string} [spamReport] Detailed spam report
         * @param {string} [spf] SPF check result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSendgridInboundPost(from: string, to: string, subject: string, text?: string, html?: string, senderIp?: string, envelope?: string, attachments?: number, attachmentInfo?: string, headers?: string, dkim?: string, spamScore?: string, spamReport?: string, spf?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiSendgridInboundPost200Response> {
            return localVarFp.apiSendgridInboundPost(from, to, subject, text, html, senderIp, envelope, attachments, attachmentInfo, headers, dkim, spamScore, spamReport, spf, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SendGridApi - object-oriented interface
 */
export class SendGridApi extends BaseAPI {
    /**
     * This endpoint receives parsed emails from SendGrid\'s Inbound Parse webhook. It processes incoming emails and forwards them to the appropriate agent for handling. 
     * @summary Webhook endpoint for SendGrid Inbound Parse
     * @param {string} from Email sender address
     * @param {string} to Email recipient address
     * @param {string} subject Email subject line
     * @param {string} [text] Plain text content of the email
     * @param {string} [html] HTML content of the email
     * @param {string} [senderIp] IP address of the sender
     * @param {string} [envelope] SMTP envelope information in JSON format
     * @param {number} [attachments] Number of attachments
     * @param {string} [attachmentInfo] Information about attachments in JSON format
     * @param {string} [headers] Email headers
     * @param {string} [dkim] DKIM signature check result
     * @param {string} [spamScore] Spam score of the email
     * @param {string} [spamReport] Detailed spam report
     * @param {string} [spf] SPF check result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSendgridInboundPost(from: string, to: string, subject: string, text?: string, html?: string, senderIp?: string, envelope?: string, attachments?: number, attachmentInfo?: string, headers?: string, dkim?: string, spamScore?: string, spamReport?: string, spf?: string, options?: RawAxiosRequestConfig) {
        return SendGridApiFp(this.configuration).apiSendgridInboundPost(from, to, subject, text, html, senderIp, envelope, attachments, attachmentInfo, headers, dkim, spamScore, spamReport, spf, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillApi - axios parameter creator
 */
export const SkillApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get metrics for a skill
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} skillId ID of the skill
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet: async (teamId: number, agentId: number, skillId: number, hoursAgo?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet', 'agentId', agentId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet', 'skillId', skillId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/skill/{skillId}/metrics`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"skillId"}}`, encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (hoursAgo !== undefined) {
                localVarQueryParameter['hoursAgo'] = hoursAgo;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillApi - functional programming interface
 */
export const SkillApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get metrics for a skill
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} skillId ID of the skill
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId: number, agentId: number, skillId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId, agentId, skillId, hoursAgo, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillApi.apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillApi - factory interface
 */
export const SkillApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillApiFp(configuration)
    return {
        /**
         * 
         * @summary Get metrics for a skill
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} skillId ID of the skill
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId: number, agentId: number, skillId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricResponse> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId, agentId, skillId, hoursAgo, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillApi - object-oriented interface
 */
export class SkillApi extends BaseAPI {
    /**
     * 
     * @summary Get metrics for a skill
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} skillId ID of the skill
     * @param {number} [hoursAgo] Number of hours to look back (default 24)
     * @param {number} [offset] Offset for pagination (default 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId: number, agentId: number, skillId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return SkillApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSkillSkillIdMetricsGet(teamId, agentId, skillId, hoursAgo, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillsApi - axios parameter creator
 */
export const SkillsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all skills for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsGet', 'agentId', agentId)
            const localVarPath = `/api/agents/{agentId}/skills`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a skill
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsIdDelete: async (agentId: number, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsIdDelete', 'agentId', agentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsIdDelete', 'id', id)
            const localVarPath = `/api/agents/{agentId}/skills/{id}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a skill
         * @param {number} agentId 
         * @param {number} id 
         * @param {UpdateSkillRequest} updateSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsIdPut: async (agentId: number, id: number, updateSkillRequest: UpdateSkillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsIdPut', 'agentId', agentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsIdPut', 'id', id)
            // verify required parameter 'updateSkillRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsIdPut', 'updateSkillRequest', updateSkillRequest)
            const localVarPath = `/api/agents/{agentId}/skills/{id}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSkillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import (assign) a found skill to this agent
         * @param {number} agentId 
         * @param {ImportSkillRequest} importSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsImportPost: async (agentId: number, importSkillRequest: ImportSkillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsImportPost', 'agentId', agentId)
            // verify required parameter 'importSkillRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsImportPost', 'importSkillRequest', importSkillRequest)
            const localVarPath = `/api/agents/{agentId}/skills/import`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importSkillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a skill for an agent
         * @param {number} agentId 
         * @param {CreateSkillRequest} createSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsPost: async (agentId: number, createSkillRequest: CreateSkillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsPost', 'agentId', agentId)
            // verify required parameter 'createSkillRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsPost', 'createSkillRequest', createSkillRequest)
            const localVarPath = `/api/agents/{agentId}/skills`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSkillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search an external skills provider for skills assignable to this agent
         * @param {number} agentId 
         * @param {string} q 
         * @param {string} [provider] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsSearchGet: async (agentId: number, q: string, provider?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsSearchGet', 'agentId', agentId)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiAgentsAgentIdSkillsSearchGet', 'q', q)
            const localVarPath = `/api/agents/{agentId}/skills/search`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillsApi - functional programming interface
 */
export const SkillsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all skills for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdSkillsGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Skill>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdSkillsGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.apiAgentsAgentIdSkillsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a skill
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdSkillsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdSkillsIdDelete(agentId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.apiAgentsAgentIdSkillsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a skill
         * @param {number} agentId 
         * @param {number} id 
         * @param {UpdateSkillRequest} updateSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdSkillsIdPut(agentId: number, id: number, updateSkillRequest: UpdateSkillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdSkillsIdPut(agentId, id, updateSkillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.apiAgentsAgentIdSkillsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import (assign) a found skill to this agent
         * @param {number} agentId 
         * @param {ImportSkillRequest} importSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdSkillsImportPost(agentId: number, importSkillRequest: ImportSkillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportSkillResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdSkillsImportPost(agentId, importSkillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.apiAgentsAgentIdSkillsImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a skill for an agent
         * @param {number} agentId 
         * @param {CreateSkillRequest} createSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdSkillsPost(agentId: number, createSkillRequest: CreateSkillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdSkillsPost(agentId, createSkillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.apiAgentsAgentIdSkillsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search an external skills provider for skills assignable to this agent
         * @param {number} agentId 
         * @param {string} q 
         * @param {string} [provider] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdSkillsSearchGet(agentId: number, q: string, provider?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdSkillsSearchGet(agentId, q, provider, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.apiAgentsAgentIdSkillsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillsApi - factory interface
 */
export const SkillsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all skills for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Skill>> {
            return localVarFp.apiAgentsAgentIdSkillsGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a skill
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response> {
            return localVarFp.apiAgentsAgentIdSkillsIdDelete(agentId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a skill
         * @param {number} agentId 
         * @param {number} id 
         * @param {UpdateSkillRequest} updateSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsIdPut(agentId: number, id: number, updateSkillRequest: UpdateSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<Skill> {
            return localVarFp.apiAgentsAgentIdSkillsIdPut(agentId, id, updateSkillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import (assign) a found skill to this agent
         * @param {number} agentId 
         * @param {ImportSkillRequest} importSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsImportPost(agentId: number, importSkillRequest: ImportSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImportSkillResult> {
            return localVarFp.apiAgentsAgentIdSkillsImportPost(agentId, importSkillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a skill for an agent
         * @param {number} agentId 
         * @param {CreateSkillRequest} createSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsPost(agentId: number, createSkillRequest: CreateSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<Skill> {
            return localVarFp.apiAgentsAgentIdSkillsPost(agentId, createSkillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search an external skills provider for skills assignable to this agent
         * @param {number} agentId 
         * @param {string} q 
         * @param {string} [provider] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdSkillsSearchGet(agentId: number, q: string, provider?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<SkillSearchResponse> {
            return localVarFp.apiAgentsAgentIdSkillsSearchGet(agentId, q, provider, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillsApi - object-oriented interface
 */
export class SkillsApi extends BaseAPI {
    /**
     * 
     * @summary Get all skills for an agent
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdSkillsGet(agentId: number, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).apiAgentsAgentIdSkillsGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a skill
     * @param {number} agentId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdSkillsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).apiAgentsAgentIdSkillsIdDelete(agentId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a skill
     * @param {number} agentId 
     * @param {number} id 
     * @param {UpdateSkillRequest} updateSkillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdSkillsIdPut(agentId: number, id: number, updateSkillRequest: UpdateSkillRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).apiAgentsAgentIdSkillsIdPut(agentId, id, updateSkillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import (assign) a found skill to this agent
     * @param {number} agentId 
     * @param {ImportSkillRequest} importSkillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdSkillsImportPost(agentId: number, importSkillRequest: ImportSkillRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).apiAgentsAgentIdSkillsImportPost(agentId, importSkillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a skill for an agent
     * @param {number} agentId 
     * @param {CreateSkillRequest} createSkillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdSkillsPost(agentId: number, createSkillRequest: CreateSkillRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).apiAgentsAgentIdSkillsPost(agentId, createSkillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search an external skills provider for skills assignable to this agent
     * @param {number} agentId 
     * @param {string} q 
     * @param {string} [provider] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdSkillsSearchGet(agentId: number, q: string, provider?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).apiAgentsAgentIdSkillsSearchGet(agentId, q, provider, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillsPolicyApi - axios parameter creator
 */
export const SkillsPolicyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a team\'s skills policy
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSkillsPolicyGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSkillsPolicyGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/skills-policy`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a team\'s skills policy
         * @param {number} teamId 
         * @param {TeamSkillsPolicyInput} teamSkillsPolicyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSkillsPolicyPut: async (teamId: number, teamSkillsPolicyInput: TeamSkillsPolicyInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdSkillsPolicyPut', 'teamId', teamId)
            // verify required parameter 'teamSkillsPolicyInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdSkillsPolicyPut', 'teamSkillsPolicyInput', teamSkillsPolicyInput)
            const localVarPath = `/api/teams/{teamId}/skills-policy`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamSkillsPolicyInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillsPolicyApi - functional programming interface
 */
export const SkillsPolicyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillsPolicyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a team\'s skills policy
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSkillsPolicyGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSkillsPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSkillsPolicyGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsPolicyApi.apiTeamsTeamIdSkillsPolicyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a team\'s skills policy
         * @param {number} teamId 
         * @param {TeamSkillsPolicyInput} teamSkillsPolicyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdSkillsPolicyPut(teamId: number, teamSkillsPolicyInput: TeamSkillsPolicyInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSkillsPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdSkillsPolicyPut(teamId, teamSkillsPolicyInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsPolicyApi.apiTeamsTeamIdSkillsPolicyPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillsPolicyApi - factory interface
 */
export const SkillsPolicyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillsPolicyApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a team\'s skills policy
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSkillsPolicyGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamSkillsPolicy> {
            return localVarFp.apiTeamsTeamIdSkillsPolicyGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a team\'s skills policy
         * @param {number} teamId 
         * @param {TeamSkillsPolicyInput} teamSkillsPolicyInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdSkillsPolicyPut(teamId: number, teamSkillsPolicyInput: TeamSkillsPolicyInput, options?: RawAxiosRequestConfig): AxiosPromise<TeamSkillsPolicy> {
            return localVarFp.apiTeamsTeamIdSkillsPolicyPut(teamId, teamSkillsPolicyInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillsPolicyApi - object-oriented interface
 */
export class SkillsPolicyApi extends BaseAPI {
    /**
     * 
     * @summary Get a team\'s skills policy
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSkillsPolicyGet(teamId: number, options?: RawAxiosRequestConfig) {
        return SkillsPolicyApiFp(this.configuration).apiTeamsTeamIdSkillsPolicyGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a team\'s skills policy
     * @param {number} teamId 
     * @param {TeamSkillsPolicyInput} teamSkillsPolicyInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdSkillsPolicyPut(teamId: number, teamSkillsPolicyInput: TeamSkillsPolicyInput, options?: RawAxiosRequestConfig) {
        return SkillsPolicyApiFp(this.configuration).apiTeamsTeamIdSkillsPolicyPut(teamId, teamSkillsPolicyInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SourceApi - axios parameter creator
 */
export const SourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves client-specific configuration information for a source type
         * @summary Get client info for a specific source type
         * @param {string} sourceType The type of source to get client info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSourceSourceTypeClientInfoGet: async (sourceType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceType' is not null or undefined
            assertParamExists('apiSourceSourceTypeClientInfoGet', 'sourceType', sourceType)
            const localVarPath = `/api/source/{sourceType}/clientInfo`
                .replace(`{${"sourceType"}}`, encodeURIComponent(String(sourceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all configured source types that can be created.
         * @summary Get available source types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSourceTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/source-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if a URL already exists as a source
         * @param {string} url URL to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSourcesCheckUrlGet: async (url: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'url' is not null or undefined
            assertParamExists('apiSourcesCheckUrlGet', 'url', url)
            const localVarPath = `/api/sources/check-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sources for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesGet: async (teamId: number, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesGet', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesGet', 'agentId', agentId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/sources`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a source to an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdSourcesPostRequest} apiTeamTeamIdAgentAgentIdSourcesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesPost: async (teamId: number, agentId: number, apiTeamTeamIdAgentAgentIdSourcesPostRequest: ApiTeamTeamIdAgentAgentIdSourcesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesPost', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesPost', 'agentId', agentId)
            // verify required parameter 'apiTeamTeamIdAgentAgentIdSourcesPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesPost', 'apiTeamTeamIdAgentAgentIdSourcesPostRequest', apiTeamTeamIdAgentAgentIdSourcesPostRequest)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/sources`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdAgentAgentIdSourcesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a source from an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete: async (teamId: number, agentId: number, sourceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete', 'agentId', agentId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete', 'sourceId', sourceId)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/sources/{sourceId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update properties of the source-agent relationship, such as allowLinking
         * @summary Update source-agent relationship properties
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest} apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesSourceIdPut: async (teamId: number, agentId: number, sourceId: number, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest: ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdPut', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdPut', 'agentId', agentId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdPut', 'sourceId', sourceId)
            // verify required parameter 'apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentAgentIdSourcesSourceIdPut', 'apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest', apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest)
            const localVarPath = `/api/team/{teamId}/agent/{agentId}/sources/{sourceId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new source
         * @param {number} teamId ID of the team
         * @param {SourceRequest} sourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcePost: async (teamId: number, sourceRequest: SourceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcePost', 'teamId', teamId)
            // verify required parameter 'sourceRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcePost', 'sourceRequest', sourceRequest)
            const localVarPath = `/api/team/{teamId}/source`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sources for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/sources`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get agents associated with a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdAgentsGet: async (teamId: number, sourceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdAgentsGet', 'teamId', teamId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdAgentsGet', 'sourceId', sourceId)
            const localVarPath = `/api/team/{teamId}/sources/{sourceId}/agents`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdDelete: async (teamId: number, sourceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdDelete', 'teamId', teamId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdDelete', 'sourceId', sourceId)
            const localVarPath = `/api/team/{teamId}/sources/{sourceId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a source by ID
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdGet: async (teamId: number, sourceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdGet', 'teamId', teamId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdGet', 'sourceId', sourceId)
            const localVarPath = `/api/team/{teamId}/sources/{sourceId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the most recent index-source jobs for the source, newest first, for the crawl status indicator on the source details page
         * @summary Get recent crawl/index jobs for a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {number} [limit] Maximum number of jobs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdJobsGet: async (teamId: number, sourceId: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdJobsGet', 'teamId', teamId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdJobsGet', 'sourceId', sourceId)
            const localVarPath = `/api/team/{teamId}/sources/{sourceId}/jobs`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {SourceRequest} sourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdPut: async (teamId: number, sourceId: number, sourceRequest: SourceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdPut', 'teamId', teamId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdPut', 'sourceId', sourceId)
            // verify required parameter 'sourceRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdPut', 'sourceRequest', sourceRequest)
            const localVarPath = `/api/team/{teamId}/sources/{sourceId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts background jobs to refresh the knowledge for a source across all associated agents
         * @summary Refresh a source\'s knowledge (start background job)
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdSourcesSourceIdRefreshPostRequest} [apiTeamTeamIdSourcesSourceIdRefreshPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdRefreshPost: async (teamId: number, sourceId: number, apiTeamTeamIdSourcesSourceIdRefreshPostRequest?: ApiTeamTeamIdSourcesSourceIdRefreshPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdRefreshPost', 'teamId', teamId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiTeamTeamIdSourcesSourceIdRefreshPost', 'sourceId', sourceId)
            const localVarPath = `/api/team/{teamId}/sources/{sourceId}/refresh`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"sourceId"}}`, encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdSourcesSourceIdRefreshPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SourceApi - functional programming interface
 */
export const SourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SourceApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves client-specific configuration information for a source type
         * @summary Get client info for a specific source type
         * @param {string} sourceType The type of source to get client info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSourceSourceTypeClientInfoGet(sourceType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Record<string, any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSourceSourceTypeClientInfoGet(sourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiSourceSourceTypeClientInfoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of all configured source types that can be created.
         * @summary Get available source types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSourceTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSourceTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiSourceTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if a URL already exists as a source
         * @param {string} url URL to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSourcesCheckUrlGet(url: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSourcesCheckUrlGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSourcesCheckUrlGet(url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiSourcesCheckUrlGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sources for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSourcesGet(teamId: number, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSourcesGet(teamId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdAgentAgentIdSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a source to an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdSourcesPostRequest} apiTeamTeamIdAgentAgentIdSourcesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSourcesPost(teamId: number, agentId: number, apiTeamTeamIdAgentAgentIdSourcesPostRequest: ApiTeamTeamIdAgentAgentIdSourcesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSourcesPost(teamId, agentId, apiTeamTeamIdAgentAgentIdSourcesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdAgentAgentIdSourcesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a source from an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId: number, agentId: number, sourceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesSourceIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId, agentId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update properties of the source-agent relationship, such as allowLinking
         * @summary Update source-agent relationship properties
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest} apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId: number, agentId: number, sourceId: number, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest: ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesSourceIdPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId, agentId, sourceId, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdAgentAgentIdSourcesSourceIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new source
         * @param {number} teamId ID of the team
         * @param {SourceRequest} sourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcePost(teamId: number, sourceRequest: SourceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcePost(teamId, sourceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdSourcePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sources for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcesGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcesGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdSourcesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get agents associated with a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcesSourceIdAgentsGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcesSourceIdAgentsGet(teamId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdSourcesSourceIdAgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcesSourceIdDelete(teamId: number, sourceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdSourcesSourceIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcesSourceIdDelete(teamId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdSourcesSourceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a source by ID
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcesSourceIdGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcesSourceIdGet(teamId, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdSourcesSourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the most recent index-source jobs for the source, newest first, for the crawl status indicator on the source details page
         * @summary Get recent crawl/index jobs for a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {number} [limit] Maximum number of jobs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcesSourceIdJobsGet(teamId: number, sourceId: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdSourcesSourceIdJobsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcesSourceIdJobsGet(teamId, sourceId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdSourcesSourceIdJobsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {SourceRequest} sourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcesSourceIdPut(teamId: number, sourceId: number, sourceRequest: SourceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcesSourceIdPut(teamId, sourceId, sourceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdSourcesSourceIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts background jobs to refresh the knowledge for a source across all associated agents
         * @summary Refresh a source\'s knowledge (start background job)
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdSourcesSourceIdRefreshPostRequest} [apiTeamTeamIdSourcesSourceIdRefreshPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdSourcesSourceIdRefreshPost(teamId: number, sourceId: number, apiTeamTeamIdSourcesSourceIdRefreshPostRequest?: ApiTeamTeamIdSourcesSourceIdRefreshPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdSourcesSourceIdRefreshPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdSourcesSourceIdRefreshPost(teamId, sourceId, apiTeamTeamIdSourcesSourceIdRefreshPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceApi.apiTeamTeamIdSourcesSourceIdRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SourceApi - factory interface
 */
export const SourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SourceApiFp(configuration)
    return {
        /**
         * Retrieves client-specific configuration information for a source type
         * @summary Get client info for a specific source type
         * @param {string} sourceType The type of source to get client info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSourceSourceTypeClientInfoGet(sourceType: string, options?: RawAxiosRequestConfig): AxiosPromise<Record<string, any>> {
            return localVarFp.apiSourceSourceTypeClientInfoGet(sourceType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all configured source types that can be created.
         * @summary Get available source types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSourceTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceType>> {
            return localVarFp.apiSourceTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if a URL already exists as a source
         * @param {string} url URL to check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSourcesCheckUrlGet(url: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiSourcesCheckUrlGet200Response> {
            return localVarFp.apiSourcesCheckUrlGet(url, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sources for an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesGet(teamId: number, agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceResponse>> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSourcesGet(teamId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a source to an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {ApiTeamTeamIdAgentAgentIdSourcesPostRequest} apiTeamTeamIdAgentAgentIdSourcesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesPost(teamId: number, agentId: number, apiTeamTeamIdAgentAgentIdSourcesPostRequest: ApiTeamTeamIdAgentAgentIdSourcesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesPost200Response> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSourcesPost(teamId, agentId, apiTeamTeamIdAgentAgentIdSourcesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a source from an agent
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId: number, agentId: number, sourceId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesSourceIdDelete200Response> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId, agentId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update properties of the source-agent relationship, such as allowLinking
         * @summary Update source-agent relationship properties
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest} apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId: number, agentId: number, sourceId: number, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest: ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdAgentAgentIdSourcesSourceIdPut200Response> {
            return localVarFp.apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId, agentId, sourceId, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new source
         * @param {number} teamId ID of the team
         * @param {SourceRequest} sourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcePost(teamId: number, sourceRequest: SourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<SourceResponse> {
            return localVarFp.apiTeamTeamIdSourcePost(teamId, sourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sources for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceResponse>> {
            return localVarFp.apiTeamTeamIdSourcesGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get agents associated with a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdAgentsGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentResponse>> {
            return localVarFp.apiTeamTeamIdSourcesSourceIdAgentsGet(teamId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdDelete(teamId: number, sourceId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdSourcesSourceIdDelete200Response> {
            return localVarFp.apiTeamTeamIdSourcesSourceIdDelete(teamId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a source by ID
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig): AxiosPromise<SourceResponse> {
            return localVarFp.apiTeamTeamIdSourcesSourceIdGet(teamId, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the most recent index-source jobs for the source, newest first, for the crawl status indicator on the source details page
         * @summary Get recent crawl/index jobs for a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {number} [limit] Maximum number of jobs to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdJobsGet(teamId: number, sourceId: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdSourcesSourceIdJobsGet200Response> {
            return localVarFp.apiTeamTeamIdSourcesSourceIdJobsGet(teamId, sourceId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a source
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {SourceRequest} sourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdPut(teamId: number, sourceId: number, sourceRequest: SourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<SourceResponse> {
            return localVarFp.apiTeamTeamIdSourcesSourceIdPut(teamId, sourceId, sourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts background jobs to refresh the knowledge for a source across all associated agents
         * @summary Refresh a source\'s knowledge (start background job)
         * @param {number} teamId ID of the team
         * @param {number} sourceId ID of the source
         * @param {ApiTeamTeamIdSourcesSourceIdRefreshPostRequest} [apiTeamTeamIdSourcesSourceIdRefreshPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdSourcesSourceIdRefreshPost(teamId: number, sourceId: number, apiTeamTeamIdSourcesSourceIdRefreshPostRequest?: ApiTeamTeamIdSourcesSourceIdRefreshPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdSourcesSourceIdRefreshPost200Response> {
            return localVarFp.apiTeamTeamIdSourcesSourceIdRefreshPost(teamId, sourceId, apiTeamTeamIdSourcesSourceIdRefreshPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SourceApi - object-oriented interface
 */
export class SourceApi extends BaseAPI {
    /**
     * Retrieves client-specific configuration information for a source type
     * @summary Get client info for a specific source type
     * @param {string} sourceType The type of source to get client info for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSourceSourceTypeClientInfoGet(sourceType: string, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiSourceSourceTypeClientInfoGet(sourceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all configured source types that can be created.
     * @summary Get available source types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSourceTypesGet(options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiSourceTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if a URL already exists as a source
     * @param {string} url URL to check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSourcesCheckUrlGet(url: string, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiSourcesCheckUrlGet(url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sources for an agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSourcesGet(teamId: number, agentId: number, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSourcesGet(teamId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a source to an agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {ApiTeamTeamIdAgentAgentIdSourcesPostRequest} apiTeamTeamIdAgentAgentIdSourcesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSourcesPost(teamId: number, agentId: number, apiTeamTeamIdAgentAgentIdSourcesPostRequest: ApiTeamTeamIdAgentAgentIdSourcesPostRequest, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSourcesPost(teamId, agentId, apiTeamTeamIdAgentAgentIdSourcesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a source from an agent
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} sourceId ID of the source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId: number, agentId: number, sourceId: number, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSourcesSourceIdDelete(teamId, agentId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update properties of the source-agent relationship, such as allowLinking
     * @summary Update source-agent relationship properties
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} sourceId ID of the source
     * @param {ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest} apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId: number, agentId: number, sourceId: number, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest: ApiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdAgentAgentIdSourcesSourceIdPut(teamId, agentId, sourceId, apiTeamTeamIdAgentAgentIdSourcesSourceIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new source
     * @param {number} teamId ID of the team
     * @param {SourceRequest} sourceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcePost(teamId: number, sourceRequest: SourceRequest, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdSourcePost(teamId, sourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sources for a team
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcesGet(teamId: number, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdSourcesGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get agents associated with a source
     * @param {number} teamId ID of the team
     * @param {number} sourceId ID of the source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcesSourceIdAgentsGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdSourcesSourceIdAgentsGet(teamId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a source
     * @param {number} teamId ID of the team
     * @param {number} sourceId ID of the source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcesSourceIdDelete(teamId: number, sourceId: number, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdSourcesSourceIdDelete(teamId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a source by ID
     * @param {number} teamId ID of the team
     * @param {number} sourceId ID of the source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcesSourceIdGet(teamId: number, sourceId: number, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdSourcesSourceIdGet(teamId, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the most recent index-source jobs for the source, newest first, for the crawl status indicator on the source details page
     * @summary Get recent crawl/index jobs for a source
     * @param {number} teamId ID of the team
     * @param {number} sourceId ID of the source
     * @param {number} [limit] Maximum number of jobs to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcesSourceIdJobsGet(teamId: number, sourceId: number, limit?: number, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdSourcesSourceIdJobsGet(teamId, sourceId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a source
     * @param {number} teamId ID of the team
     * @param {number} sourceId ID of the source
     * @param {SourceRequest} sourceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcesSourceIdPut(teamId: number, sourceId: number, sourceRequest: SourceRequest, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdSourcesSourceIdPut(teamId, sourceId, sourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts background jobs to refresh the knowledge for a source across all associated agents
     * @summary Refresh a source\'s knowledge (start background job)
     * @param {number} teamId ID of the team
     * @param {number} sourceId ID of the source
     * @param {ApiTeamTeamIdSourcesSourceIdRefreshPostRequest} [apiTeamTeamIdSourcesSourceIdRefreshPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdSourcesSourceIdRefreshPost(teamId: number, sourceId: number, apiTeamTeamIdSourcesSourceIdRefreshPostRequest?: ApiTeamTeamIdSourcesSourceIdRefreshPostRequest, options?: RawAxiosRequestConfig) {
        return SourceApiFp(this.configuration).apiTeamTeamIdSourcesSourceIdRefreshPost(teamId, sourceId, apiTeamTeamIdSourcesSourceIdRefreshPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SourceDocumentsApi - axios parameter creator
 */
export const SourceDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get cached content for a specific document
         * @param {number} teamId ID of the team
         * @param {number} documentId ID of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet: async (teamId: number, documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet', 'teamId', teamId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet', 'documentId', documentId)
            const localVarPath = `/api/v1/team/{teamId}/knowledge/documents/{documentId}/cache`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the exclusion status of source documents
         * @param {number} teamId ID of the team
         * @param {ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest} apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TeamTeamIdKnowledgeDocumentsExclusionPut: async (teamId: number, apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest: ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsExclusionPut', 'teamId', teamId)
            // verify required parameter 'apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsExclusionPut', 'apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest', apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest)
            const localVarPath = `/api/v1/team/{teamId}/knowledge/documents/exclusion`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get knowledge documents for the given source IDs
         * @param {number} teamId ID of the team
         * @param {string} sourceIds Comma-separated list of source IDs
         * @param {number} [offset] Number of documents to skip
         * @param {number} [limit] Maximum number of documents to return
         * @param {string} [searchText] Text to search for in document URL and title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TeamTeamIdKnowledgeDocumentsGet: async (teamId: number, sourceIds: string, offset?: number, limit?: number, searchText?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsGet', 'teamId', teamId)
            // verify required parameter 'sourceIds' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsGet', 'sourceIds', sourceIds)
            const localVarPath = `/api/v1/team/{teamId}/knowledge/documents`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (sourceIds !== undefined) {
                localVarQueryParameter['sourceIds'] = sourceIds;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh a specific document from a source
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {string} url URL of the document to refresh
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TeamTeamIdKnowledgeDocumentsRefreshPost: async (teamId: number, agentId: number, sourceId: number, url: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsRefreshPost', 'teamId', teamId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsRefreshPost', 'agentId', agentId)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsRefreshPost', 'sourceId', sourceId)
            // verify required parameter 'url' is not null or undefined
            assertParamExists('apiV1TeamTeamIdKnowledgeDocumentsRefreshPost', 'url', url)
            const localVarPath = `/api/v1/team/{teamId}/knowledge/documents/refresh`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SourceDocumentsApi - functional programming interface
 */
export const SourceDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SourceDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get cached content for a specific document
         * @param {number} teamId ID of the team
         * @param {number} documentId ID of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet(teamId: number, documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet(teamId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceDocumentsApi.apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the exclusion status of source documents
         * @param {number} teamId ID of the team
         * @param {ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest} apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TeamTeamIdKnowledgeDocumentsExclusionPut(teamId: number, apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest: ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1TeamTeamIdKnowledgeDocumentsExclusionPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TeamTeamIdKnowledgeDocumentsExclusionPut(teamId, apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceDocumentsApi.apiV1TeamTeamIdKnowledgeDocumentsExclusionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get knowledge documents for the given source IDs
         * @param {number} teamId ID of the team
         * @param {string} sourceIds Comma-separated list of source IDs
         * @param {number} [offset] Number of documents to skip
         * @param {number} [limit] Maximum number of documents to return
         * @param {string} [searchText] Text to search for in document URL and title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TeamTeamIdKnowledgeDocumentsGet(teamId: number, sourceIds: string, offset?: number, limit?: number, searchText?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1TeamTeamIdKnowledgeDocumentsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TeamTeamIdKnowledgeDocumentsGet(teamId, sourceIds, offset, limit, searchText, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceDocumentsApi.apiV1TeamTeamIdKnowledgeDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh a specific document from a source
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {string} url URL of the document to refresh
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TeamTeamIdKnowledgeDocumentsRefreshPost(teamId: number, agentId: number, sourceId: number, url: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1TeamTeamIdKnowledgeDocumentsRefreshPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TeamTeamIdKnowledgeDocumentsRefreshPost(teamId, agentId, sourceId, url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceDocumentsApi.apiV1TeamTeamIdKnowledgeDocumentsRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SourceDocumentsApi - factory interface
 */
export const SourceDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SourceDocumentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get cached content for a specific document
         * @param {number} teamId ID of the team
         * @param {number} documentId ID of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet(teamId: number, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet200Response> {
            return localVarFp.apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet(teamId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the exclusion status of source documents
         * @param {number} teamId ID of the team
         * @param {ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest} apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TeamTeamIdKnowledgeDocumentsExclusionPut(teamId: number, apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest: ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1TeamTeamIdKnowledgeDocumentsExclusionPut200Response> {
            return localVarFp.apiV1TeamTeamIdKnowledgeDocumentsExclusionPut(teamId, apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get knowledge documents for the given source IDs
         * @param {number} teamId ID of the team
         * @param {string} sourceIds Comma-separated list of source IDs
         * @param {number} [offset] Number of documents to skip
         * @param {number} [limit] Maximum number of documents to return
         * @param {string} [searchText] Text to search for in document URL and title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TeamTeamIdKnowledgeDocumentsGet(teamId: number, sourceIds: string, offset?: number, limit?: number, searchText?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1TeamTeamIdKnowledgeDocumentsGet200Response> {
            return localVarFp.apiV1TeamTeamIdKnowledgeDocumentsGet(teamId, sourceIds, offset, limit, searchText, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh a specific document from a source
         * @param {number} teamId ID of the team
         * @param {number} agentId ID of the agent
         * @param {number} sourceId ID of the source
         * @param {string} url URL of the document to refresh
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TeamTeamIdKnowledgeDocumentsRefreshPost(teamId: number, agentId: number, sourceId: number, url: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1TeamTeamIdKnowledgeDocumentsRefreshPost200Response> {
            return localVarFp.apiV1TeamTeamIdKnowledgeDocumentsRefreshPost(teamId, agentId, sourceId, url, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SourceDocumentsApi - object-oriented interface
 */
export class SourceDocumentsApi extends BaseAPI {
    /**
     * 
     * @summary Get cached content for a specific document
     * @param {number} teamId ID of the team
     * @param {number} documentId ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet(teamId: number, documentId: number, options?: RawAxiosRequestConfig) {
        return SourceDocumentsApiFp(this.configuration).apiV1TeamTeamIdKnowledgeDocumentsDocumentIdCacheGet(teamId, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the exclusion status of source documents
     * @param {number} teamId ID of the team
     * @param {ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest} apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1TeamTeamIdKnowledgeDocumentsExclusionPut(teamId: number, apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest: ApiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest, options?: RawAxiosRequestConfig) {
        return SourceDocumentsApiFp(this.configuration).apiV1TeamTeamIdKnowledgeDocumentsExclusionPut(teamId, apiV1TeamTeamIdKnowledgeDocumentsExclusionPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get knowledge documents for the given source IDs
     * @param {number} teamId ID of the team
     * @param {string} sourceIds Comma-separated list of source IDs
     * @param {number} [offset] Number of documents to skip
     * @param {number} [limit] Maximum number of documents to return
     * @param {string} [searchText] Text to search for in document URL and title
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1TeamTeamIdKnowledgeDocumentsGet(teamId: number, sourceIds: string, offset?: number, limit?: number, searchText?: string, options?: RawAxiosRequestConfig) {
        return SourceDocumentsApiFp(this.configuration).apiV1TeamTeamIdKnowledgeDocumentsGet(teamId, sourceIds, offset, limit, searchText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh a specific document from a source
     * @param {number} teamId ID of the team
     * @param {number} agentId ID of the agent
     * @param {number} sourceId ID of the source
     * @param {string} url URL of the document to refresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1TeamTeamIdKnowledgeDocumentsRefreshPost(teamId: number, agentId: number, sourceId: number, url: string, options?: RawAxiosRequestConfig) {
        return SourceDocumentsApiFp(this.configuration).apiV1TeamTeamIdKnowledgeDocumentsRefreshPost(teamId, agentId, sourceId, url, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatusApi - axios parameter creator
 */
export const StatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check service status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusApi - functional programming interface
 */
export const StatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check service status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiHealthGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatusApi.apiStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatusApi - factory interface
 */
export const StatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatusApiFp(configuration)
    return {
        /**
         * 
         * @summary Check service status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiHealthGet200Response> {
            return localVarFp.apiStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatusApi - object-oriented interface
 */
export class StatusApi extends BaseAPI {
    /**
     * 
     * @summary Check service status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiStatusGet(options?: RawAxiosRequestConfig) {
        return StatusApiFp(this.configuration).apiStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionsApi - axios parameter creator
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List subscription invoices
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingInvoicesGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingInvoicesGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/invoices`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an invoice PDF
         * @param {number} teamId 
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingInvoicesPaymentIdPdfGet: async (teamId: number, paymentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingInvoicesPaymentIdPdfGet', 'teamId', teamId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingInvoicesPaymentIdPdfGet', 'paymentId', paymentId)
            const localVarPath = `/api/team/{teamId}/billing/invoices/{paymentId}/pdf`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schedule cancellation at the period boundary
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionCancelPost: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionCancelPost', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/subscription/cancel`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the team\'s subscription state
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/subscription`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retry the outstanding renewal charge now
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionPayPost: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionPayPost', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/subscription/pay`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview a tier change (charge estimate or downgrade violations)
         * @param {number} teamId 
         * @param {ApiTeamTeamIdBillingSubscriptionPreviewPostRequest} apiTeamTeamIdBillingSubscriptionPreviewPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionPreviewPost: async (teamId: number, apiTeamTeamIdBillingSubscriptionPreviewPostRequest: ApiTeamTeamIdBillingSubscriptionPreviewPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionPreviewPost', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdBillingSubscriptionPreviewPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionPreviewPost', 'apiTeamTeamIdBillingSubscriptionPreviewPostRequest', apiTeamTeamIdBillingSubscriptionPreviewPostRequest)
            const localVarPath = `/api/team/{teamId}/billing/subscription/preview`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingSubscriptionPreviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a scheduled downgrade or cancellation
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionScheduledChangeDelete: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionScheduledChangeDelete', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/subscription/scheduled-change`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Subscribe or upgrade immediately, or schedule a downgrade
         * @param {number} teamId 
         * @param {ApiTeamTeamIdBillingSubscriptionPreviewPostRequest} apiTeamTeamIdBillingSubscriptionPreviewPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionTierPut: async (teamId: number, apiTeamTeamIdBillingSubscriptionPreviewPostRequest: ApiTeamTeamIdBillingSubscriptionPreviewPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionTierPut', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdBillingSubscriptionPreviewPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionTierPut', 'apiTeamTeamIdBillingSubscriptionPreviewPostRequest', apiTeamTeamIdBillingSubscriptionPreviewPostRequest)
            const localVarPath = `/api/team/{teamId}/billing/subscription/tier`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdBillingSubscriptionPreviewPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A tier-agnostic snapshot the plan picker weighs against each tier\'s limits and feature switches, so a card can say what choosing it costs.
         * @summary What the team holds in every tier-limited dimension
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionUsageGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdBillingSubscriptionUsageGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/billing/subscription/usage`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List selectable subscription tiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTiersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionsApi - functional programming interface
 */
export const SubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List subscription invoices
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingInvoicesGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdBillingInvoicesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingInvoicesGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingInvoicesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download an invoice PDF
         * @param {number} teamId 
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingInvoicesPaymentIdPdfGet(teamId: number, paymentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingInvoicesPaymentIdPdfGet(teamId, paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingInvoicesPaymentIdPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Schedule cancellation at the period boundary
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingSubscriptionCancelPost(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingSubscriptionCancelPost(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingSubscriptionCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the team\'s subscription state
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingSubscriptionGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingSubscriptionGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingSubscriptionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retry the outstanding renewal charge now
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingSubscriptionPayPost(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingSubscriptionPayPost(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingSubscriptionPayPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview a tier change (charge estimate or downgrade violations)
         * @param {number} teamId 
         * @param {ApiTeamTeamIdBillingSubscriptionPreviewPostRequest} apiTeamTeamIdBillingSubscriptionPreviewPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingSubscriptionPreviewPost(teamId: number, apiTeamTeamIdBillingSubscriptionPreviewPostRequest: ApiTeamTeamIdBillingSubscriptionPreviewPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TierChangePreviewInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingSubscriptionPreviewPost(teamId, apiTeamTeamIdBillingSubscriptionPreviewPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingSubscriptionPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel a scheduled downgrade or cancellation
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingSubscriptionScheduledChangeDelete(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingSubscriptionScheduledChangeDelete(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingSubscriptionScheduledChangeDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Subscribe or upgrade immediately, or schedule a downgrade
         * @param {number} teamId 
         * @param {ApiTeamTeamIdBillingSubscriptionPreviewPostRequest} apiTeamTeamIdBillingSubscriptionPreviewPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingSubscriptionTierPut(teamId: number, apiTeamTeamIdBillingSubscriptionPreviewPostRequest: ApiTeamTeamIdBillingSubscriptionPreviewPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingSubscriptionTierPut(teamId, apiTeamTeamIdBillingSubscriptionPreviewPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingSubscriptionTierPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A tier-agnostic snapshot the plan picker weighs against each tier\'s limits and feature switches, so a card can say what choosing it costs.
         * @summary What the team holds in every tier-limited dimension
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdBillingSubscriptionUsageGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TierUsageInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdBillingSubscriptionUsageGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTeamTeamIdBillingSubscriptionUsageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List selectable subscription tiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTiersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTiersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTiersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.apiTiersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionsApi - factory interface
 */
export const SubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionsApiFp(configuration)
    return {
        /**
         * 
         * @summary List subscription invoices
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingInvoicesGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdBillingInvoicesGet200Response> {
            return localVarFp.apiTeamTeamIdBillingInvoicesGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an invoice PDF
         * @param {number} teamId 
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingInvoicesPaymentIdPdfGet(teamId: number, paymentId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTeamTeamIdBillingInvoicesPaymentIdPdfGet(teamId, paymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schedule cancellation at the period boundary
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionCancelPost(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionInfo> {
            return localVarFp.apiTeamTeamIdBillingSubscriptionCancelPost(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the team\'s subscription state
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionInfo> {
            return localVarFp.apiTeamTeamIdBillingSubscriptionGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retry the outstanding renewal charge now
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionPayPost(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionInfo> {
            return localVarFp.apiTeamTeamIdBillingSubscriptionPayPost(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview a tier change (charge estimate or downgrade violations)
         * @param {number} teamId 
         * @param {ApiTeamTeamIdBillingSubscriptionPreviewPostRequest} apiTeamTeamIdBillingSubscriptionPreviewPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionPreviewPost(teamId: number, apiTeamTeamIdBillingSubscriptionPreviewPostRequest: ApiTeamTeamIdBillingSubscriptionPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TierChangePreviewInfo> {
            return localVarFp.apiTeamTeamIdBillingSubscriptionPreviewPost(teamId, apiTeamTeamIdBillingSubscriptionPreviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a scheduled downgrade or cancellation
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionScheduledChangeDelete(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionInfo> {
            return localVarFp.apiTeamTeamIdBillingSubscriptionScheduledChangeDelete(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Subscribe or upgrade immediately, or schedule a downgrade
         * @param {number} teamId 
         * @param {ApiTeamTeamIdBillingSubscriptionPreviewPostRequest} apiTeamTeamIdBillingSubscriptionPreviewPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionTierPut(teamId: number, apiTeamTeamIdBillingSubscriptionPreviewPostRequest: ApiTeamTeamIdBillingSubscriptionPreviewPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionInfo> {
            return localVarFp.apiTeamTeamIdBillingSubscriptionTierPut(teamId, apiTeamTeamIdBillingSubscriptionPreviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * A tier-agnostic snapshot the plan picker weighs against each tier\'s limits and feature switches, so a card can say what choosing it costs.
         * @summary What the team holds in every tier-limited dimension
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdBillingSubscriptionUsageGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<TierUsageInfo> {
            return localVarFp.apiTeamTeamIdBillingSubscriptionUsageGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List selectable subscription tiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTiersGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiTiersGet200Response> {
            return localVarFp.apiTiersGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionsApi - object-oriented interface
 */
export class SubscriptionsApi extends BaseAPI {
    /**
     * 
     * @summary List subscription invoices
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingInvoicesGet(teamId: number, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingInvoicesGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an invoice PDF
     * @param {number} teamId 
     * @param {number} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingInvoicesPaymentIdPdfGet(teamId: number, paymentId: number, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingInvoicesPaymentIdPdfGet(teamId, paymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schedule cancellation at the period boundary
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingSubscriptionCancelPost(teamId: number, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingSubscriptionCancelPost(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the team\'s subscription state
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingSubscriptionGet(teamId: number, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingSubscriptionGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retry the outstanding renewal charge now
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingSubscriptionPayPost(teamId: number, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingSubscriptionPayPost(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview a tier change (charge estimate or downgrade violations)
     * @param {number} teamId 
     * @param {ApiTeamTeamIdBillingSubscriptionPreviewPostRequest} apiTeamTeamIdBillingSubscriptionPreviewPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingSubscriptionPreviewPost(teamId: number, apiTeamTeamIdBillingSubscriptionPreviewPostRequest: ApiTeamTeamIdBillingSubscriptionPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingSubscriptionPreviewPost(teamId, apiTeamTeamIdBillingSubscriptionPreviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a scheduled downgrade or cancellation
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingSubscriptionScheduledChangeDelete(teamId: number, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingSubscriptionScheduledChangeDelete(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Subscribe or upgrade immediately, or schedule a downgrade
     * @param {number} teamId 
     * @param {ApiTeamTeamIdBillingSubscriptionPreviewPostRequest} apiTeamTeamIdBillingSubscriptionPreviewPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingSubscriptionTierPut(teamId: number, apiTeamTeamIdBillingSubscriptionPreviewPostRequest: ApiTeamTeamIdBillingSubscriptionPreviewPostRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingSubscriptionTierPut(teamId, apiTeamTeamIdBillingSubscriptionPreviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A tier-agnostic snapshot the plan picker weighs against each tier\'s limits and feature switches, so a card can say what choosing it costs.
     * @summary What the team holds in every tier-limited dimension
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdBillingSubscriptionUsageGet(teamId: number, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTeamTeamIdBillingSubscriptionUsageGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List selectable subscription tiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTiersGet(options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).apiTiersGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns system configuration including available domains and root URL
         * @summary Get system configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemConfigurationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/system/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns system configuration including available domains and root URL
         * @summary Get system configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemConfigurationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiSystemConfigurationGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemConfigurationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.apiSystemConfigurationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SystemApi - factory interface
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * Returns system configuration including available domains and root URL
         * @summary Get system configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemConfigurationGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiSystemConfigurationGet200Response> {
            return localVarFp.apiSystemConfigurationGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 */
export class SystemApi extends BaseAPI {
    /**
     * Returns system configuration including available domains and root URL
     * @summary Get system configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiSystemConfigurationGet(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).apiSystemConfigurationGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamApi - axios parameter creator
 */
export const TeamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new team
         * @param {ApiTeamPostRequest} apiTeamPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamPost: async (apiTeamPostRequest: ApiTeamPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiTeamPostRequest' is not null or undefined
            assertParamExists('apiTeamPost', 'apiTeamPostRequest', apiTeamPostRequest)
            const localVarPath = `/api/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get agents for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdAgentsGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/agents`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdDelete: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdDelete', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get metrics for a team
         * @param {number} teamId ID of the team
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsGet: async (teamId: number, hoursAgo?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdMetricsGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/metrics`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (hoursAgo !== undefined) {
                localVarQueryParameter['hoursAgo'] = hoursAgo;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdPutRequest} apiTeamTeamIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdPut: async (teamId: number, apiTeamTeamIdPutRequest: ApiTeamTeamIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdPut', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdPutRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdPut', 'apiTeamTeamIdPutRequest', apiTeamTeamIdPutRequest)
            const localVarPath = `/api/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/users`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a user to a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdUsersPostRequest} apiTeamTeamIdUsersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersPost: async (teamId: number, apiTeamTeamIdUsersPostRequest: ApiTeamTeamIdUsersPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersPost', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdUsersPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersPost', 'apiTeamTeamIdUsersPostRequest', apiTeamTeamIdUsersPostRequest)
            const localVarPath = `/api/team/{teamId}/users`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdUsersPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a user from a team
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {ApiTeamTeamIdUsersUserEmailAddressDeleteRequest} [apiTeamTeamIdUsersUserEmailAddressDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersUserEmailAddressDelete: async (teamId: number, userEmailAddress: string, apiTeamTeamIdUsersUserEmailAddressDeleteRequest?: ApiTeamTeamIdUsersUserEmailAddressDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersUserEmailAddressDelete', 'teamId', teamId)
            // verify required parameter 'userEmailAddress' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersUserEmailAddressDelete', 'userEmailAddress', userEmailAddress)
            const localVarPath = `/api/team/{teamId}/users/{userEmailAddress}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"userEmailAddress"}}`, encodeURIComponent(String(userEmailAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdUsersUserEmailAddressDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get eligible delegation successors before removing a team member
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet: async (teamId: number, userEmailAddress: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet', 'teamId', teamId)
            // verify required parameter 'userEmailAddress' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet', 'userEmailAddress', userEmailAddress)
            const localVarPath = `/api/team/{teamId}/users/{userEmailAddress}/removal-delegation-candidates`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"userEmailAddress"}}`, encodeURIComponent(String(userEmailAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get teams for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdAcceptInvitePostRequest} apiTeamsTeamIdAcceptInvitePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdAcceptInvitePost: async (teamId: number, apiTeamsTeamIdAcceptInvitePostRequest: ApiTeamsTeamIdAcceptInvitePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdAcceptInvitePost', 'teamId', teamId)
            // verify required parameter 'apiTeamsTeamIdAcceptInvitePostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdAcceptInvitePost', 'apiTeamsTeamIdAcceptInvitePostRequest', apiTeamsTeamIdAcceptInvitePostRequest)
            const localVarPath = `/api/teams/{teamId}/accept-invite`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdAcceptInvitePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a team invitation
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesEmailAddressDelete: async (teamId: number, emailAddress: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressDelete', 'teamId', teamId)
            // verify required parameter 'emailAddress' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressDelete', 'emailAddress', emailAddress)
            const localVarPath = `/api/teams/{teamId}/invites/{emailAddress}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"emailAddress"}}`, encodeURIComponent(String(emailAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the invite\'s role outright — this is not a merge, because merging a team-scoped builtinRole onto a leftover project scope would authorize one thing and store another. Gated at exactly the level that CREATES an invite (team_member:edit): an invite whose role can be rewritten more cheaply than it was set is an invite whose role was never really fixed. Invites have no status column — acceptance and cancellation both delete the row — so a missing row is disambiguated by asking whether the address is now a member: 409 if accepted, 404 if cancelled or never existed.
         * @summary Change the role a pending invitation will confer
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {InviteRoleInput} inviteRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesEmailAddressRolePut: async (teamId: number, emailAddress: string, inviteRoleInput: InviteRoleInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressRolePut', 'teamId', teamId)
            // verify required parameter 'emailAddress' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressRolePut', 'emailAddress', emailAddress)
            // verify required parameter 'inviteRoleInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesEmailAddressRolePut', 'inviteRoleInput', inviteRoleInput)
            const localVarPath = `/api/teams/{teamId}/invites/{emailAddress}/role`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"emailAddress"}}`, encodeURIComponent(String(emailAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteRoleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get team invitations
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/invites`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdInvitesPostRequest} apiTeamsTeamIdInvitesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesPost: async (teamId: number, apiTeamsTeamIdInvitesPostRequest: ApiTeamsTeamIdInvitesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesPost', 'teamId', teamId)
            // verify required parameter 'apiTeamsTeamIdInvitesPostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdInvitesPost', 'apiTeamsTeamIdInvitesPostRequest', apiTeamsTeamIdInvitesPostRequest)
            const localVarPath = `/api/teams/{teamId}/invites`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdInvitesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject a team invitation
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRejectInvitePost: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdRejectInvitePost', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/reject-invite`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the stored output as plain text. Authorisation is the conversation\'s: a row is reachable only by someone who may read the conversation that produced it.
         * @summary Read stored tool output
         * @param {number} teamId ID of the team that owns the stored output
         * @param {number} spillId ID of the stored output
         * @param {number} [offset] First line to return, 1-based. Omit to return the whole thing.
         * @param {number} [limit] Lines to return from the offset, capped server-side.
         * @param {string} [download] Present at any value to send Content-Disposition: attachment, so the browser saves the output as &lt;toolName&gt;-&lt;handle&gt;.txt instead of rendering it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdToolOutputsSpillIdGet: async (teamId: number, spillId: number, offset?: number, limit?: number, download?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdToolOutputsSpillIdGet', 'teamId', teamId)
            // verify required parameter 'spillId' is not null or undefined
            assertParamExists('apiTeamsTeamIdToolOutputsSpillIdGet', 'spillId', spillId)
            const localVarPath = `/api/teams/{teamId}/tool-outputs/{spillId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"spillId"}}`, encodeURIComponent(String(spillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (download !== undefined) {
                localVarQueryParameter['download'] = download;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamApi - functional programming interface
 */
export const TeamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new team
         * @param {ApiTeamPostRequest} apiTeamPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamPost(apiTeamPostRequest: ApiTeamPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamPost(apiTeamPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get agents for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdAgentsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdAgentsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamTeamIdAgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdDelete(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdDelete(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamTeamIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get metrics for a team
         * @param {number} teamId ID of the team
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdMetricsGet(teamId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdMetricsGet(teamId, hoursAgo, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamTeamIdMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdPutRequest} apiTeamTeamIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdPut(teamId: number, apiTeamTeamIdPutRequest: ApiTeamTeamIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdPut(teamId, apiTeamTeamIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamTeamIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get users for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdUsersGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTeamTeamIdUsersGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdUsersGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamTeamIdUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a user to a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdUsersPostRequest} apiTeamTeamIdUsersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdUsersPost(teamId: number, apiTeamTeamIdUsersPostRequest: ApiTeamTeamIdUsersPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdUsersPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdUsersPost(teamId, apiTeamTeamIdUsersPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamTeamIdUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a user from a team
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {ApiTeamTeamIdUsersUserEmailAddressDeleteRequest} [apiTeamTeamIdUsersUserEmailAddressDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdUsersUserEmailAddressDelete(teamId: number, userEmailAddress: string, apiTeamTeamIdUsersUserEmailAddressDeleteRequest?: ApiTeamTeamIdUsersUserEmailAddressDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdUsersUserEmailAddressDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdUsersUserEmailAddressDelete(teamId, userEmailAddress, apiTeamTeamIdUsersUserEmailAddressDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamTeamIdUsersUserEmailAddressDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get eligible delegation successors before removing a team member
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId: number, userEmailAddress: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId, userEmailAddress, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get teams for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTeamsGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdAcceptInvitePostRequest} apiTeamsTeamIdAcceptInvitePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdAcceptInvitePost(teamId: number, apiTeamsTeamIdAcceptInvitePostRequest: ApiTeamsTeamIdAcceptInvitePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdAcceptInvitePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdAcceptInvitePost(teamId, apiTeamsTeamIdAcceptInvitePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamsTeamIdAcceptInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a team invitation
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdInvitesEmailAddressDelete(teamId: number, emailAddress: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdInvitesEmailAddressDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdInvitesEmailAddressDelete(teamId, emailAddress, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamsTeamIdInvitesEmailAddressDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the invite\'s role outright — this is not a merge, because merging a team-scoped builtinRole onto a leftover project scope would authorize one thing and store another. Gated at exactly the level that CREATES an invite (team_member:edit): an invite whose role can be rewritten more cheaply than it was set is an invite whose role was never really fixed. Invites have no status column — acceptance and cancellation both delete the row — so a missing row is disambiguated by asking whether the address is now a member: 409 if accepted, 404 if cancelled or never existed.
         * @summary Change the role a pending invitation will confer
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {InviteRoleInput} inviteRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdInvitesEmailAddressRolePut(teamId: number, emailAddress: string, inviteRoleInput: InviteRoleInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdInvitesEmailAddressRolePut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdInvitesEmailAddressRolePut(teamId, emailAddress, inviteRoleInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamsTeamIdInvitesEmailAddressRolePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get team invitations
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdInvitesGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTeamsTeamIdInvitesGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdInvitesGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamsTeamIdInvitesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdInvitesPostRequest} apiTeamsTeamIdInvitesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdInvitesPost(teamId: number, apiTeamsTeamIdInvitesPostRequest: ApiTeamsTeamIdInvitesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdInvitesPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdInvitesPost(teamId, apiTeamsTeamIdInvitesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamsTeamIdInvitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject a team invitation
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdRejectInvitePost(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdRejectInvitePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdRejectInvitePost(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamsTeamIdRejectInvitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the stored output as plain text. Authorisation is the conversation\'s: a row is reachable only by someone who may read the conversation that produced it.
         * @summary Read stored tool output
         * @param {number} teamId ID of the team that owns the stored output
         * @param {number} spillId ID of the stored output
         * @param {number} [offset] First line to return, 1-based. Omit to return the whole thing.
         * @param {number} [limit] Lines to return from the offset, capped server-side.
         * @param {string} [download] Present at any value to send Content-Disposition: attachment, so the browser saves the output as &lt;toolName&gt;-&lt;handle&gt;.txt instead of rendering it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdToolOutputsSpillIdGet(teamId: number, spillId: number, offset?: number, limit?: number, download?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdToolOutputsSpillIdGet(teamId, spillId, offset, limit, download, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.apiTeamsTeamIdToolOutputsSpillIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamApi - factory interface
 */
export const TeamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new team
         * @param {ApiTeamPostRequest} apiTeamPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamPost(apiTeamPostRequest: ApiTeamPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamPost201Response> {
            return localVarFp.apiTeamPost(apiTeamPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get agents for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdAgentsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentResponse>> {
            return localVarFp.apiTeamTeamIdAgentsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdDelete(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdDelete200Response> {
            return localVarFp.apiTeamTeamIdDelete(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get metrics for a team
         * @param {number} teamId ID of the team
         * @param {number} [hoursAgo] Number of hours to look back (default 24)
         * @param {number} [offset] Offset for pagination (default 0)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdMetricsGet(teamId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricResponse> {
            return localVarFp.apiTeamTeamIdMetricsGet(teamId, hoursAgo, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdPutRequest} apiTeamTeamIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdPut(teamId: number, apiTeamTeamIdPutRequest: ApiTeamTeamIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdPut200Response> {
            return localVarFp.apiTeamTeamIdPut(teamId, apiTeamTeamIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTeamTeamIdUsersGet200ResponseInner>> {
            return localVarFp.apiTeamTeamIdUsersGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a user to a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdUsersPostRequest} apiTeamTeamIdUsersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersPost(teamId: number, apiTeamTeamIdUsersPostRequest: ApiTeamTeamIdUsersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdUsersPost200Response> {
            return localVarFp.apiTeamTeamIdUsersPost(teamId, apiTeamTeamIdUsersPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a user from a team
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {ApiTeamTeamIdUsersUserEmailAddressDeleteRequest} [apiTeamTeamIdUsersUserEmailAddressDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersUserEmailAddressDelete(teamId: number, userEmailAddress: string, apiTeamTeamIdUsersUserEmailAddressDeleteRequest?: ApiTeamTeamIdUsersUserEmailAddressDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdUsersUserEmailAddressDelete200Response> {
            return localVarFp.apiTeamTeamIdUsersUserEmailAddressDelete(teamId, userEmailAddress, apiTeamTeamIdUsersUserEmailAddressDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get eligible delegation successors before removing a team member
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId: number, userEmailAddress: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet200Response> {
            return localVarFp.apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId, userEmailAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get teams for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTeamsGet200ResponseInner>> {
            return localVarFp.apiTeamsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdAcceptInvitePostRequest} apiTeamsTeamIdAcceptInvitePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdAcceptInvitePost(teamId: number, apiTeamsTeamIdAcceptInvitePostRequest: ApiTeamsTeamIdAcceptInvitePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdAcceptInvitePost200Response> {
            return localVarFp.apiTeamsTeamIdAcceptInvitePost(teamId, apiTeamsTeamIdAcceptInvitePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a team invitation
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesEmailAddressDelete(teamId: number, emailAddress: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdInvitesEmailAddressDelete200Response> {
            return localVarFp.apiTeamsTeamIdInvitesEmailAddressDelete(teamId, emailAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the invite\'s role outright — this is not a merge, because merging a team-scoped builtinRole onto a leftover project scope would authorize one thing and store another. Gated at exactly the level that CREATES an invite (team_member:edit): an invite whose role can be rewritten more cheaply than it was set is an invite whose role was never really fixed. Invites have no status column — acceptance and cancellation both delete the row — so a missing row is disambiguated by asking whether the address is now a member: 409 if accepted, 404 if cancelled or never existed.
         * @summary Change the role a pending invitation will confer
         * @param {number} teamId ID of the team
         * @param {string} emailAddress Email address of the invited user
         * @param {InviteRoleInput} inviteRoleInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesEmailAddressRolePut(teamId: number, emailAddress: string, inviteRoleInput: InviteRoleInput, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdInvitesEmailAddressRolePut200Response> {
            return localVarFp.apiTeamsTeamIdInvitesEmailAddressRolePut(teamId, emailAddress, inviteRoleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get team invitations
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTeamsTeamIdInvitesGet200ResponseInner>> {
            return localVarFp.apiTeamsTeamIdInvitesGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a team invitation
         * @param {number} teamId ID of the team
         * @param {ApiTeamsTeamIdInvitesPostRequest} apiTeamsTeamIdInvitesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdInvitesPost(teamId: number, apiTeamsTeamIdInvitesPostRequest: ApiTeamsTeamIdInvitesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdInvitesPost201Response> {
            return localVarFp.apiTeamsTeamIdInvitesPost(teamId, apiTeamsTeamIdInvitesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject a team invitation
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdRejectInvitePost(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdRejectInvitePost200Response> {
            return localVarFp.apiTeamsTeamIdRejectInvitePost(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the stored output as plain text. Authorisation is the conversation\'s: a row is reachable only by someone who may read the conversation that produced it.
         * @summary Read stored tool output
         * @param {number} teamId ID of the team that owns the stored output
         * @param {number} spillId ID of the stored output
         * @param {number} [offset] First line to return, 1-based. Omit to return the whole thing.
         * @param {number} [limit] Lines to return from the offset, capped server-side.
         * @param {string} [download] Present at any value to send Content-Disposition: attachment, so the browser saves the output as &lt;toolName&gt;-&lt;handle&gt;.txt instead of rendering it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdToolOutputsSpillIdGet(teamId: number, spillId: number, offset?: number, limit?: number, download?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTeamsTeamIdToolOutputsSpillIdGet(teamId, spillId, offset, limit, download, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamApi - object-oriented interface
 */
export class TeamApi extends BaseAPI {
    /**
     * 
     * @summary Create a new team
     * @param {ApiTeamPostRequest} apiTeamPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamPost(apiTeamPostRequest: ApiTeamPostRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamPost(apiTeamPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get agents for a team
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdAgentsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamTeamIdAgentsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a team
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdDelete(teamId: number, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamTeamIdDelete(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get metrics for a team
     * @param {number} teamId ID of the team
     * @param {number} [hoursAgo] Number of hours to look back (default 24)
     * @param {number} [offset] Offset for pagination (default 0)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdMetricsGet(teamId: number, hoursAgo?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamTeamIdMetricsGet(teamId, hoursAgo, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a team
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdPutRequest} apiTeamTeamIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdPut(teamId: number, apiTeamTeamIdPutRequest: ApiTeamTeamIdPutRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamTeamIdPut(teamId, apiTeamTeamIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users for a team
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdUsersGet(teamId: number, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamTeamIdUsersGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a user to a team
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdUsersPostRequest} apiTeamTeamIdUsersPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdUsersPost(teamId: number, apiTeamTeamIdUsersPostRequest: ApiTeamTeamIdUsersPostRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamTeamIdUsersPost(teamId, apiTeamTeamIdUsersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a user from a team
     * @param {number} teamId ID of the team
     * @param {string} userEmailAddress Email address of the user to remove
     * @param {ApiTeamTeamIdUsersUserEmailAddressDeleteRequest} [apiTeamTeamIdUsersUserEmailAddressDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdUsersUserEmailAddressDelete(teamId: number, userEmailAddress: string, apiTeamTeamIdUsersUserEmailAddressDeleteRequest?: ApiTeamTeamIdUsersUserEmailAddressDeleteRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamTeamIdUsersUserEmailAddressDelete(teamId, userEmailAddress, apiTeamTeamIdUsersUserEmailAddressDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get eligible delegation successors before removing a team member
     * @param {number} teamId ID of the team
     * @param {string} userEmailAddress Email address of the user to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId: number, userEmailAddress: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId, userEmailAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get teams for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsGet(options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept a team invitation
     * @param {number} teamId ID of the team
     * @param {ApiTeamsTeamIdAcceptInvitePostRequest} apiTeamsTeamIdAcceptInvitePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdAcceptInvitePost(teamId: number, apiTeamsTeamIdAcceptInvitePostRequest: ApiTeamsTeamIdAcceptInvitePostRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamsTeamIdAcceptInvitePost(teamId, apiTeamsTeamIdAcceptInvitePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a team invitation
     * @param {number} teamId ID of the team
     * @param {string} emailAddress Email address of the invited user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdInvitesEmailAddressDelete(teamId: number, emailAddress: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamsTeamIdInvitesEmailAddressDelete(teamId, emailAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the invite\'s role outright — this is not a merge, because merging a team-scoped builtinRole onto a leftover project scope would authorize one thing and store another. Gated at exactly the level that CREATES an invite (team_member:edit): an invite whose role can be rewritten more cheaply than it was set is an invite whose role was never really fixed. Invites have no status column — acceptance and cancellation both delete the row — so a missing row is disambiguated by asking whether the address is now a member: 409 if accepted, 404 if cancelled or never existed.
     * @summary Change the role a pending invitation will confer
     * @param {number} teamId ID of the team
     * @param {string} emailAddress Email address of the invited user
     * @param {InviteRoleInput} inviteRoleInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdInvitesEmailAddressRolePut(teamId: number, emailAddress: string, inviteRoleInput: InviteRoleInput, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamsTeamIdInvitesEmailAddressRolePut(teamId, emailAddress, inviteRoleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get team invitations
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdInvitesGet(teamId: number, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamsTeamIdInvitesGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a team invitation
     * @param {number} teamId ID of the team
     * @param {ApiTeamsTeamIdInvitesPostRequest} apiTeamsTeamIdInvitesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdInvitesPost(teamId: number, apiTeamsTeamIdInvitesPostRequest: ApiTeamsTeamIdInvitesPostRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamsTeamIdInvitesPost(teamId, apiTeamsTeamIdInvitesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject a team invitation
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdRejectInvitePost(teamId: number, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamsTeamIdRejectInvitePost(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the stored output as plain text. Authorisation is the conversation\'s: a row is reachable only by someone who may read the conversation that produced it.
     * @summary Read stored tool output
     * @param {number} teamId ID of the team that owns the stored output
     * @param {number} spillId ID of the stored output
     * @param {number} [offset] First line to return, 1-based. Omit to return the whole thing.
     * @param {number} [limit] Lines to return from the offset, capped server-side.
     * @param {string} [download] Present at any value to send Content-Disposition: attachment, so the browser saves the output as &lt;toolName&gt;-&lt;handle&gt;.txt instead of rendering it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdToolOutputsSpillIdGet(teamId: number, spillId: number, offset?: number, limit?: number, download?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).apiTeamsTeamIdToolOutputsSpillIdGet(teamId, spillId, offset, limit, download, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamFilesApi - axios parameter creator
 */
export const TeamFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List the drive files linked to a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdFileLinksGet: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiProjectCardsCardIdFileLinksGet', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/file-links`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a folder and everything under it
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdDelete: async (folderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('apiTeamFileFoldersFolderIdDelete', 'folderId', folderId)
            const localVarPath = `/api/team-file-folders/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename and/or move a folder
         * @param {number} folderId 
         * @param {DriveFolderUpdateRequest} driveFolderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdPatch: async (folderId: number, driveFolderUpdateRequest: DriveFolderUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('apiTeamFileFoldersFolderIdPatch', 'folderId', folderId)
            // verify required parameter 'driveFolderUpdateRequest' is not null or undefined
            assertParamExists('apiTeamFileFoldersFolderIdPatch', 'driveFolderUpdateRequest', driveFolderUpdateRequest)
            const localVarPath = `/api/team-file-folders/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driveFolderUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke a folder\'s public share link
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdShareDelete: async (folderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('apiTeamFileFoldersFolderIdShareDelete', 'folderId', folderId)
            const localVarPath = `/api/team-file-folders/{folderId}/share`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a folder\'s current public share link, if any
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdShareGet: async (folderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('apiTeamFileFoldersFolderIdShareGet', 'folderId', folderId)
            const localVarPath = `/api/team-file-folders/{folderId}/share`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new public share link for a folder (replaces any existing link)
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdSharePost: async (folderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('apiTeamFileFoldersFolderIdSharePost', 'folderId', folderId)
            const localVarPath = `/api/team-file-folders/{folderId}/share`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlink a file from a project card
         * @param {number} fileId 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdCardLinksCardIdDelete: async (fileId: number, cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdCardLinksCardIdDelete', 'fileId', fileId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdCardLinksCardIdDelete', 'cardId', cardId)
            const localVarPath = `/api/team-files/{fileId}/card-links/{cardId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Link a file to a project card (idempotent)
         * @param {number} fileId 
         * @param {DriveCardLinkRequest} driveCardLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdCardLinksPost: async (fileId: number, driveCardLinkRequest: DriveCardLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdCardLinksPost', 'fileId', fileId)
            // verify required parameter 'driveCardLinkRequest' is not null or undefined
            assertParamExists('apiTeamFilesFileIdCardLinksPost', 'driveCardLinkRequest', driveCardLinkRequest)
            const localVarPath = `/api/team-files/{fileId}/card-links`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driveCardLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a file and all of its versions
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdDelete: async (fileId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdDelete', 'fileId', fileId)
            const localVarPath = `/api/team-files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download authenticated file bytes
         * @param {number} fileId 
         * @param {number} [version] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdDownloadGet: async (fileId: number, version?: number, range?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdDownloadGet', 'fileId', fileId)
            const localVarPath = `/api/team-files/{fileId}/download`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            if (range != null) {
                localVarHeaderParameter['Range'] = String(range);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set or clear a logical file expiry
         * @param {number} fileId 
         * @param {DriveFileLifecycleRequest} driveFileLifecycleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdLifecyclePatch: async (fileId: number, driveFileLifecycleRequest: DriveFileLifecycleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdLifecyclePatch', 'fileId', fileId)
            // verify required parameter 'driveFileLifecycleRequest' is not null or undefined
            assertParamExists('apiTeamFilesFileIdLifecyclePatch', 'driveFileLifecycleRequest', driveFileLifecycleRequest)
            const localVarPath = `/api/team-files/{fileId}/lifecycle`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driveFileLifecycleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rename and/or move a file (folderId null moves to project root)
         * @param {number} fileId 
         * @param {DriveFileUpdateRequest} driveFileUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdPatch: async (fileId: number, driveFileUpdateRequest: DriveFileUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdPatch', 'fileId', fileId)
            // verify required parameter 'driveFileUpdateRequest' is not null or undefined
            assertParamExists('apiTeamFilesFileIdPatch', 'driveFileUpdateRequest', driveFileUpdateRequest)
            const localVarPath = `/api/team-files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driveFileUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview authenticated file bytes
         * @param {number} fileId 
         * @param {number} [version] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdPreviewGet: async (fileId: number, version?: number, range?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdPreviewGet', 'fileId', fileId)
            const localVarPath = `/api/team-files/{fileId}/preview`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            if (range != null) {
                localVarHeaderParameter['Range'] = String(range);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke a file\'s public share link
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdShareDelete: async (fileId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdShareDelete', 'fileId', fileId)
            const localVarPath = `/api/team-files/{fileId}/share`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a file\'s current public share link, if any
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdShareGet: async (fileId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdShareGet', 'fileId', fileId)
            const localVarPath = `/api/team-files/{fileId}/share`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new public share link for a file (replaces any existing link)
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdSharePost: async (fileId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdSharePost', 'fileId', fileId)
            const localVarPath = `/api/team-files/{fileId}/share`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a file\'s versions, newest first
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdVersionsGet: async (fileId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdVersionsGet', 'fileId', fileId)
            const localVarPath = `/api/team-files/{fileId}/versions`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restore an earlier version as a new current version
         * @param {number} fileId 
         * @param {number} versionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdVersionsVersionNumberRestorePost: async (fileId: number, versionNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiTeamFilesFileIdVersionsVersionNumberRestorePost', 'fileId', fileId)
            // verify required parameter 'versionNumber' is not null or undefined
            assertParamExists('apiTeamFilesFileIdVersionsVersionNumberRestorePost', 'versionNumber', versionNumber)
            const localVarPath = `/api/team-files/{fileId}/versions/{versionNumber}/restore`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
                .replace(`{${"versionNumber"}}`, encodeURIComponent(String(versionNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a folder
         * @param {number} teamId 
         * @param {DriveFolderCreateRequest} driveFolderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdFilesFoldersPost: async (teamId: number, driveFolderCreateRequest: DriveFolderCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdFilesFoldersPost', 'teamId', teamId)
            // verify required parameter 'driveFolderCreateRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdFilesFoldersPost', 'driveFolderCreateRequest', driveFolderCreateRequest)
            const localVarPath = `/api/teams/{teamId}/files/folders`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driveFolderCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a drive folder (project root when folderId is omitted)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {number} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdFilesListGet: async (teamId: number, projectId: number, folderId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdFilesListGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdFilesListGet', 'projectId', projectId)
            const localVarPath = `/api/teams/{teamId}/files/list`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List drive roots (the caller\'s member projects)
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdFilesRootsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdFilesRootsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/files/roots`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search files by name across the caller\'s member projects
         * @param {number} teamId 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdFilesSearchGet: async (teamId: number, q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdFilesSearchGet', 'teamId', teamId)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiTeamsTeamIdFilesSearchGet', 'q', q)
            const localVarPath = `/api/teams/{teamId}/files/search`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamFilesApi - functional programming interface
 */
export const TeamFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List the drive files linked to a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectCardsCardIdFileLinksGet(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveFileLinksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectCardsCardIdFileLinksGet(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiProjectCardsCardIdFileLinksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a folder and everything under it
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFileFoldersFolderIdDelete(folderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFileFoldersFolderIdDelete(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFileFoldersFolderIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rename and/or move a folder
         * @param {number} folderId 
         * @param {DriveFolderUpdateRequest} driveFolderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFileFoldersFolderIdPatch(folderId: number, driveFolderUpdateRequest: DriveFolderUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveFolderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFileFoldersFolderIdPatch(folderId, driveFolderUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFileFoldersFolderIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke a folder\'s public share link
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFileFoldersFolderIdShareDelete(folderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFileFoldersFolderIdShareDelete(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFileFoldersFolderIdShareDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a folder\'s current public share link, if any
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFileFoldersFolderIdShareGet(folderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveShareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFileFoldersFolderIdShareGet(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFileFoldersFolderIdShareGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new public share link for a folder (replaces any existing link)
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFileFoldersFolderIdSharePost(folderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveShareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFileFoldersFolderIdSharePost(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFileFoldersFolderIdSharePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlink a file from a project card
         * @param {number} fileId 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdCardLinksCardIdDelete(fileId: number, cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdCardLinksCardIdDelete(fileId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdCardLinksCardIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Link a file to a project card (idempotent)
         * @param {number} fileId 
         * @param {DriveCardLinkRequest} driveCardLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdCardLinksPost(fileId: number, driveCardLinkRequest: DriveCardLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveCardLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdCardLinksPost(fileId, driveCardLinkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdCardLinksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a file and all of its versions
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdDelete(fileId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdDelete(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download authenticated file bytes
         * @param {number} fileId 
         * @param {number} [version] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdDownloadGet(fileId: number, version?: number, range?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdDownloadGet(fileId, version, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set or clear a logical file expiry
         * @param {number} fileId 
         * @param {DriveFileLifecycleRequest} driveFileLifecycleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdLifecyclePatch(fileId: number, driveFileLifecycleRequest: DriveFileLifecycleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdLifecyclePatch(fileId, driveFileLifecycleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdLifecyclePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rename and/or move a file (folderId null moves to project root)
         * @param {number} fileId 
         * @param {DriveFileUpdateRequest} driveFileUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdPatch(fileId: number, driveFileUpdateRequest: DriveFileUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdPatch(fileId, driveFileUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview authenticated file bytes
         * @param {number} fileId 
         * @param {number} [version] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdPreviewGet(fileId: number, version?: number, range?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdPreviewGet(fileId, version, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdPreviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke a file\'s public share link
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdShareDelete(fileId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdShareDelete(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdShareDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a file\'s current public share link, if any
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdShareGet(fileId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveShareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdShareGet(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdShareGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new public share link for a file (replaces any existing link)
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdSharePost(fileId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveShareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdSharePost(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdSharePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a file\'s versions, newest first
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdVersionsGet(fileId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveVersionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdVersionsGet(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Restore an earlier version as a new current version
         * @param {number} fileId 
         * @param {number} versionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamFilesFileIdVersionsVersionNumberRestorePost(fileId: number, versionNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamFilesFileIdVersionsVersionNumberRestorePost(fileId, versionNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamFilesFileIdVersionsVersionNumberRestorePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a folder
         * @param {number} teamId 
         * @param {DriveFolderCreateRequest} driveFolderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdFilesFoldersPost(teamId: number, driveFolderCreateRequest: DriveFolderCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveFolderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdFilesFoldersPost(teamId, driveFolderCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamsTeamIdFilesFoldersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a drive folder (project root when folderId is omitted)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {number} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdFilesListGet(teamId: number, projectId: number, folderId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdFilesListGet(teamId, projectId, folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamsTeamIdFilesListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List drive roots (the caller\'s member projects)
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdFilesRootsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveRootsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdFilesRootsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamsTeamIdFilesRootsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search files by name across the caller\'s member projects
         * @param {number} teamId 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdFilesSearchGet(teamId: number, q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriveSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdFilesSearchGet(teamId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamFilesApi.apiTeamsTeamIdFilesSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamFilesApi - factory interface
 */
export const TeamFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamFilesApiFp(configuration)
    return {
        /**
         * 
         * @summary List the drive files linked to a card
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectCardsCardIdFileLinksGet(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<DriveFileLinksResponse> {
            return localVarFp.apiProjectCardsCardIdFileLinksGet(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a folder and everything under it
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdDelete(folderId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamFileFoldersFolderIdDelete(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename and/or move a folder
         * @param {number} folderId 
         * @param {DriveFolderUpdateRequest} driveFolderUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdPatch(folderId: number, driveFolderUpdateRequest: DriveFolderUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DriveFolderResponse> {
            return localVarFp.apiTeamFileFoldersFolderIdPatch(folderId, driveFolderUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke a folder\'s public share link
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdShareDelete(folderId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamFileFoldersFolderIdShareDelete(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a folder\'s current public share link, if any
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdShareGet(folderId: number, options?: RawAxiosRequestConfig): AxiosPromise<DriveShareResponse> {
            return localVarFp.apiTeamFileFoldersFolderIdShareGet(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new public share link for a folder (replaces any existing link)
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFileFoldersFolderIdSharePost(folderId: number, options?: RawAxiosRequestConfig): AxiosPromise<DriveShareResponse> {
            return localVarFp.apiTeamFileFoldersFolderIdSharePost(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlink a file from a project card
         * @param {number} fileId 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdCardLinksCardIdDelete(fileId: number, cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamFilesFileIdCardLinksCardIdDelete(fileId, cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Link a file to a project card (idempotent)
         * @param {number} fileId 
         * @param {DriveCardLinkRequest} driveCardLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdCardLinksPost(fileId: number, driveCardLinkRequest: DriveCardLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<DriveCardLinkResponse> {
            return localVarFp.apiTeamFilesFileIdCardLinksPost(fileId, driveCardLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a file and all of its versions
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdDelete(fileId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamFilesFileIdDelete(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download authenticated file bytes
         * @param {number} fileId 
         * @param {number} [version] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdDownloadGet(fileId: number, version?: number, range?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTeamFilesFileIdDownloadGet(fileId, version, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set or clear a logical file expiry
         * @param {number} fileId 
         * @param {DriveFileLifecycleRequest} driveFileLifecycleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdLifecyclePatch(fileId: number, driveFileLifecycleRequest: DriveFileLifecycleRequest, options?: RawAxiosRequestConfig): AxiosPromise<DriveFileResponse> {
            return localVarFp.apiTeamFilesFileIdLifecyclePatch(fileId, driveFileLifecycleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rename and/or move a file (folderId null moves to project root)
         * @param {number} fileId 
         * @param {DriveFileUpdateRequest} driveFileUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdPatch(fileId: number, driveFileUpdateRequest: DriveFileUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DriveFileResponse> {
            return localVarFp.apiTeamFilesFileIdPatch(fileId, driveFileUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview authenticated file bytes
         * @param {number} fileId 
         * @param {number} [version] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdPreviewGet(fileId: number, version?: number, range?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTeamFilesFileIdPreviewGet(fileId, version, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke a file\'s public share link
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdShareDelete(fileId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamFilesFileIdShareDelete(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a file\'s current public share link, if any
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdShareGet(fileId: number, options?: RawAxiosRequestConfig): AxiosPromise<DriveShareResponse> {
            return localVarFp.apiTeamFilesFileIdShareGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new public share link for a file (replaces any existing link)
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdSharePost(fileId: number, options?: RawAxiosRequestConfig): AxiosPromise<DriveShareResponse> {
            return localVarFp.apiTeamFilesFileIdSharePost(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a file\'s versions, newest first
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdVersionsGet(fileId: number, options?: RawAxiosRequestConfig): AxiosPromise<DriveVersionsResponse> {
            return localVarFp.apiTeamFilesFileIdVersionsGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restore an earlier version as a new current version
         * @param {number} fileId 
         * @param {number} versionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamFilesFileIdVersionsVersionNumberRestorePost(fileId: number, versionNumber: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamFilesFileIdVersionsVersionNumberRestorePost(fileId, versionNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a folder
         * @param {number} teamId 
         * @param {DriveFolderCreateRequest} driveFolderCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdFilesFoldersPost(teamId: number, driveFolderCreateRequest: DriveFolderCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DriveFolderResponse> {
            return localVarFp.apiTeamsTeamIdFilesFoldersPost(teamId, driveFolderCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a drive folder (project root when folderId is omitted)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {number} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdFilesListGet(teamId: number, projectId: number, folderId?: number, options?: RawAxiosRequestConfig): AxiosPromise<DriveListResponse> {
            return localVarFp.apiTeamsTeamIdFilesListGet(teamId, projectId, folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List drive roots (the caller\'s member projects)
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdFilesRootsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<DriveRootsResponse> {
            return localVarFp.apiTeamsTeamIdFilesRootsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search files by name across the caller\'s member projects
         * @param {number} teamId 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdFilesSearchGet(teamId: number, q: string, options?: RawAxiosRequestConfig): AxiosPromise<DriveSearchResponse> {
            return localVarFp.apiTeamsTeamIdFilesSearchGet(teamId, q, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamFilesApi - object-oriented interface
 */
export class TeamFilesApi extends BaseAPI {
    /**
     * 
     * @summary List the drive files linked to a card
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiProjectCardsCardIdFileLinksGet(cardId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiProjectCardsCardIdFileLinksGet(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a folder and everything under it
     * @param {number} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFileFoldersFolderIdDelete(folderId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFileFoldersFolderIdDelete(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename and/or move a folder
     * @param {number} folderId 
     * @param {DriveFolderUpdateRequest} driveFolderUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFileFoldersFolderIdPatch(folderId: number, driveFolderUpdateRequest: DriveFolderUpdateRequest, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFileFoldersFolderIdPatch(folderId, driveFolderUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke a folder\'s public share link
     * @param {number} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFileFoldersFolderIdShareDelete(folderId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFileFoldersFolderIdShareDelete(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a folder\'s current public share link, if any
     * @param {number} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFileFoldersFolderIdShareGet(folderId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFileFoldersFolderIdShareGet(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new public share link for a folder (replaces any existing link)
     * @param {number} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFileFoldersFolderIdSharePost(folderId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFileFoldersFolderIdSharePost(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlink a file from a project card
     * @param {number} fileId 
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdCardLinksCardIdDelete(fileId: number, cardId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdCardLinksCardIdDelete(fileId, cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Link a file to a project card (idempotent)
     * @param {number} fileId 
     * @param {DriveCardLinkRequest} driveCardLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdCardLinksPost(fileId: number, driveCardLinkRequest: DriveCardLinkRequest, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdCardLinksPost(fileId, driveCardLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a file and all of its versions
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdDelete(fileId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdDelete(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download authenticated file bytes
     * @param {number} fileId 
     * @param {number} [version] 
     * @param {string} [range] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdDownloadGet(fileId: number, version?: number, range?: string, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdDownloadGet(fileId, version, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set or clear a logical file expiry
     * @param {number} fileId 
     * @param {DriveFileLifecycleRequest} driveFileLifecycleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdLifecyclePatch(fileId: number, driveFileLifecycleRequest: DriveFileLifecycleRequest, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdLifecyclePatch(fileId, driveFileLifecycleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rename and/or move a file (folderId null moves to project root)
     * @param {number} fileId 
     * @param {DriveFileUpdateRequest} driveFileUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdPatch(fileId: number, driveFileUpdateRequest: DriveFileUpdateRequest, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdPatch(fileId, driveFileUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview authenticated file bytes
     * @param {number} fileId 
     * @param {number} [version] 
     * @param {string} [range] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdPreviewGet(fileId: number, version?: number, range?: string, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdPreviewGet(fileId, version, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke a file\'s public share link
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdShareDelete(fileId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdShareDelete(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a file\'s current public share link, if any
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdShareGet(fileId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdShareGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new public share link for a file (replaces any existing link)
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdSharePost(fileId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdSharePost(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a file\'s versions, newest first
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdVersionsGet(fileId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdVersionsGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restore an earlier version as a new current version
     * @param {number} fileId 
     * @param {number} versionNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamFilesFileIdVersionsVersionNumberRestorePost(fileId: number, versionNumber: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamFilesFileIdVersionsVersionNumberRestorePost(fileId, versionNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a folder
     * @param {number} teamId 
     * @param {DriveFolderCreateRequest} driveFolderCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdFilesFoldersPost(teamId: number, driveFolderCreateRequest: DriveFolderCreateRequest, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamsTeamIdFilesFoldersPost(teamId, driveFolderCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a drive folder (project root when folderId is omitted)
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {number} [folderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdFilesListGet(teamId: number, projectId: number, folderId?: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamsTeamIdFilesListGet(teamId, projectId, folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List drive roots (the caller\'s member projects)
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdFilesRootsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamsTeamIdFilesRootsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search files by name across the caller\'s member projects
     * @param {number} teamId 
     * @param {string} q 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdFilesSearchGet(teamId: number, q: string, options?: RawAxiosRequestConfig) {
        return TeamFilesApiFp(this.configuration).apiTeamsTeamIdFilesSearchGet(teamId, q, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamModelDefaultsApi - axios parameter creator
 */
export const TeamModelDefaultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a team\'s effective default models
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelDefaultsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelDefaultsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/model-defaults`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Preview affected and overriding agents without writing
         * @param {number} teamId 
         * @param {PreviewTeamModelDefaultRequest} previewTeamModelDefaultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelDefaultsPreviewPost: async (teamId: number, previewTeamModelDefaultRequest: PreviewTeamModelDefaultRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelDefaultsPreviewPost', 'teamId', teamId)
            // verify required parameter 'previewTeamModelDefaultRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelDefaultsPreviewPost', 'previewTeamModelDefaultRequest', previewTeamModelDefaultRequest)
            const localVarPath = `/api/teams/{teamId}/model-defaults/preview`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewTeamModelDefaultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Atomically apply one team model default change
         * @param {number} teamId 
         * @param {ApplyTeamModelDefaultRequest} applyTeamModelDefaultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelDefaultsPut: async (teamId: number, applyTeamModelDefaultRequest: ApplyTeamModelDefaultRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelDefaultsPut', 'teamId', teamId)
            // verify required parameter 'applyTeamModelDefaultRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdModelDefaultsPut', 'applyTeamModelDefaultRequest', applyTeamModelDefaultRequest)
            const localVarPath = `/api/teams/{teamId}/model-defaults`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyTeamModelDefaultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamModelDefaultsApi - functional programming interface
 */
export const TeamModelDefaultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamModelDefaultsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a team\'s effective default models
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelDefaultsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamModelDefaultsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelDefaultsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamModelDefaultsApi.apiTeamsTeamIdModelDefaultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Preview affected and overriding agents without writing
         * @param {number} teamId 
         * @param {PreviewTeamModelDefaultRequest} previewTeamModelDefaultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelDefaultsPreviewPost(teamId: number, previewTeamModelDefaultRequest: PreviewTeamModelDefaultRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamModelDefaultPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelDefaultsPreviewPost(teamId, previewTeamModelDefaultRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamModelDefaultsApi.apiTeamsTeamIdModelDefaultsPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Atomically apply one team model default change
         * @param {number} teamId 
         * @param {ApplyTeamModelDefaultRequest} applyTeamModelDefaultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdModelDefaultsPut(teamId: number, applyTeamModelDefaultRequest: ApplyTeamModelDefaultRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamModelDefaultPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdModelDefaultsPut(teamId, applyTeamModelDefaultRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamModelDefaultsApi.apiTeamsTeamIdModelDefaultsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamModelDefaultsApi - factory interface
 */
export const TeamModelDefaultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamModelDefaultsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a team\'s effective default models
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelDefaultsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamModelDefaultsResponse> {
            return localVarFp.apiTeamsTeamIdModelDefaultsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Preview affected and overriding agents without writing
         * @param {number} teamId 
         * @param {PreviewTeamModelDefaultRequest} previewTeamModelDefaultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelDefaultsPreviewPost(teamId: number, previewTeamModelDefaultRequest: PreviewTeamModelDefaultRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamModelDefaultPreview> {
            return localVarFp.apiTeamsTeamIdModelDefaultsPreviewPost(teamId, previewTeamModelDefaultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Atomically apply one team model default change
         * @param {number} teamId 
         * @param {ApplyTeamModelDefaultRequest} applyTeamModelDefaultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdModelDefaultsPut(teamId: number, applyTeamModelDefaultRequest: ApplyTeamModelDefaultRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamModelDefaultPreview> {
            return localVarFp.apiTeamsTeamIdModelDefaultsPut(teamId, applyTeamModelDefaultRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamModelDefaultsApi - object-oriented interface
 */
export class TeamModelDefaultsApi extends BaseAPI {
    /**
     * 
     * @summary Get a team\'s effective default models
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelDefaultsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return TeamModelDefaultsApiFp(this.configuration).apiTeamsTeamIdModelDefaultsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Preview affected and overriding agents without writing
     * @param {number} teamId 
     * @param {PreviewTeamModelDefaultRequest} previewTeamModelDefaultRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelDefaultsPreviewPost(teamId: number, previewTeamModelDefaultRequest: PreviewTeamModelDefaultRequest, options?: RawAxiosRequestConfig) {
        return TeamModelDefaultsApiFp(this.configuration).apiTeamsTeamIdModelDefaultsPreviewPost(teamId, previewTeamModelDefaultRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Atomically apply one team model default change
     * @param {number} teamId 
     * @param {ApplyTeamModelDefaultRequest} applyTeamModelDefaultRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdModelDefaultsPut(teamId: number, applyTeamModelDefaultRequest: ApplyTeamModelDefaultRequest, options?: RawAxiosRequestConfig) {
        return TeamModelDefaultsApiFp(this.configuration).apiTeamsTeamIdModelDefaultsPut(teamId, applyTeamModelDefaultRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamSecretsApi - axios parameter creator
 */
export const TeamSecretsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a team secret
         * @param {number} teamId 
         * @param {TeamSecretCreateRequest} teamSecretCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamSecret: async (teamId: number, teamSecretCreateRequest: TeamSecretCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamSecret', 'teamId', teamId)
            // verify required parameter 'teamSecretCreateRequest' is not null or undefined
            assertParamExists('createTeamSecret', 'teamSecretCreateRequest', teamSecretCreateRequest)
            const localVarPath = `/api/teams/{teamId}/secrets`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamSecretCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretDeleteRequest} teamSecretDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamSecret: async (teamId: number, secretId: string, teamSecretDeleteRequest: TeamSecretDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeamSecret', 'teamId', teamId)
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('deleteTeamSecret', 'secretId', secretId)
            // verify required parameter 'teamSecretDeleteRequest' is not null or undefined
            assertParamExists('deleteTeamSecret', 'teamSecretDeleteRequest', teamSecretDeleteRequest)
            const localVarPath = `/api/teams/{teamId}/secrets/{secretId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamSecretDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete a prior version
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamSecretVersion: async (teamId: number, secretId: string, versionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeamSecretVersion', 'teamId', teamId)
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('deleteTeamSecretVersion', 'secretId', secretId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('deleteTeamSecretVersion', 'versionId', versionId)
            const localVarPath = `/api/teams/{teamId}/secrets/{secretId}/versions/{versionId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get safe team-secret detail
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamSecret: async (teamId: number, secretId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamSecret', 'teamId', teamId)
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('getTeamSecret', 'secretId', secretId)
            const localVarPath = `/api/teams/{teamId}/secrets/{secretId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grant an agent access to a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantTeamSecret: async (teamId: number, secretId: string, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('grantTeamSecret', 'teamId', teamId)
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('grantTeamSecret', 'secretId', secretId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('grantTeamSecret', 'agentId', agentId)
            const localVarPath = `/api/teams/{teamId}/secrets/{secretId}/grants/{agentId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read cursor-paginated safe team-secret activity
         * @param {number} teamId 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamSecretActivity: async (teamId: number, cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamSecretActivity', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/secrets/activity`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List safe team-secret metadata
         * @param {number} teamId 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamSecrets: async (teamId: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamSecrets', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/secrets`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Restore a prior value as a new current version
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {string} versionId 
         * @param {TeamSecretRestoreRequest} teamSecretRestoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreTeamSecretVersion: async (teamId: number, secretId: string, versionId: string, teamSecretRestoreRequest: TeamSecretRestoreRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('restoreTeamSecretVersion', 'teamId', teamId)
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('restoreTeamSecretVersion', 'secretId', secretId)
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('restoreTeamSecretVersion', 'versionId', versionId)
            // verify required parameter 'teamSecretRestoreRequest' is not null or undefined
            assertParamExists('restoreTeamSecretVersion', 'teamSecretRestoreRequest', teamSecretRestoreRequest)
            const localVarPath = `/api/teams/{teamId}/secrets/{secretId}/versions/{versionId}/restore`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamSecretRestoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Write a new current value
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretRotateRequest} teamSecretRotateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateTeamSecret: async (teamId: number, secretId: string, teamSecretRotateRequest: TeamSecretRotateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('rotateTeamSecret', 'teamId', teamId)
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('rotateTeamSecret', 'secretId', secretId)
            // verify required parameter 'teamSecretRotateRequest' is not null or undefined
            assertParamExists('rotateTeamSecret', 'teamSecretRotateRequest', teamSecretRotateRequest)
            const localVarPath = `/api/teams/{teamId}/secrets/{secretId}/rotate`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamSecretRotateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an agent\'s access to a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ungrantTeamSecret: async (teamId: number, secretId: string, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('ungrantTeamSecret', 'teamId', teamId)
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('ungrantTeamSecret', 'secretId', secretId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('ungrantTeamSecret', 'agentId', agentId)
            const localVarPath = `/api/teams/{teamId}/secrets/{secretId}/grants/{agentId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)))
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update safe team-secret metadata or policy
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretUpdateRequest} teamSecretUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamSecret: async (teamId: number, secretId: string, teamSecretUpdateRequest: TeamSecretUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamSecret', 'teamId', teamId)
            // verify required parameter 'secretId' is not null or undefined
            assertParamExists('updateTeamSecret', 'secretId', secretId)
            // verify required parameter 'teamSecretUpdateRequest' is not null or undefined
            assertParamExists('updateTeamSecret', 'teamSecretUpdateRequest', teamSecretUpdateRequest)
            const localVarPath = `/api/teams/{teamId}/secrets/{secretId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"secretId"}}`, encodeURIComponent(String(secretId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamSecretUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamSecretsApi - functional programming interface
 */
export const TeamSecretsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamSecretsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a team secret
         * @param {number} teamId 
         * @param {TeamSecretCreateRequest} teamSecretCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamSecret(teamId: number, teamSecretCreateRequest: TeamSecretCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamSecret(teamId, teamSecretCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.createTeamSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretDeleteRequest} teamSecretDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamSecret(teamId: number, secretId: string, teamSecretDeleteRequest: TeamSecretDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamSecret(teamId, secretId, teamSecretDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.deleteTeamSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete a prior version
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamSecretVersion(teamId: number, secretId: string, versionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamSecretVersion(teamId, secretId, versionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.deleteTeamSecretVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get safe team-secret detail
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamSecret(teamId: number, secretId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamSecret(teamId, secretId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.getTeamSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grant an agent access to a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantTeamSecret(teamId: number, secretId: string, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantTeamSecret(teamId, secretId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.grantTeamSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read cursor-paginated safe team-secret activity
         * @param {number} teamId 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamSecretActivity(teamId: number, cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretActivityPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamSecretActivity(teamId, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.listTeamSecretActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List safe team-secret metadata
         * @param {number} teamId 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamSecrets(teamId: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTeamSecrets200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamSecrets(teamId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.listTeamSecrets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Restore a prior value as a new current version
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {string} versionId 
         * @param {TeamSecretRestoreRequest} teamSecretRestoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreTeamSecretVersion(teamId: number, secretId: string, versionId: string, teamSecretRestoreRequest: TeamSecretRestoreRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreTeamSecretVersion(teamId, secretId, versionId, teamSecretRestoreRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.restoreTeamSecretVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Write a new current value
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretRotateRequest} teamSecretRotateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rotateTeamSecret(teamId: number, secretId: string, teamSecretRotateRequest: TeamSecretRotateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rotateTeamSecret(teamId, secretId, teamSecretRotateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.rotateTeamSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove an agent\'s access to a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ungrantTeamSecret(teamId: number, secretId: string, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ungrantTeamSecret(teamId, secretId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.ungrantTeamSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update safe team-secret metadata or policy
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretUpdateRequest} teamSecretUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamSecret(teamId: number, secretId: string, teamSecretUpdateRequest: TeamSecretUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamSecretDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamSecret(teamId, secretId, teamSecretUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamSecretsApi.updateTeamSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamSecretsApi - factory interface
 */
export const TeamSecretsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamSecretsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a team secret
         * @param {number} teamId 
         * @param {TeamSecretCreateRequest} teamSecretCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamSecret(teamId: number, teamSecretCreateRequest: TeamSecretCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretDetail> {
            return localVarFp.createTeamSecret(teamId, teamSecretCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretDeleteRequest} teamSecretDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamSecret(teamId: number, secretId: string, teamSecretDeleteRequest: TeamSecretDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeamSecret(teamId, secretId, teamSecretDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete a prior version
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {string} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamSecretVersion(teamId: number, secretId: string, versionId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretDetail> {
            return localVarFp.deleteTeamSecretVersion(teamId, secretId, versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get safe team-secret detail
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamSecret(teamId: number, secretId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretDetail> {
            return localVarFp.getTeamSecret(teamId, secretId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grant an agent access to a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantTeamSecret(teamId: number, secretId: string, agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretDetail> {
            return localVarFp.grantTeamSecret(teamId, secretId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read cursor-paginated safe team-secret activity
         * @param {number} teamId 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamSecretActivity(teamId: number, cursor?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretActivityPage> {
            return localVarFp.listTeamSecretActivity(teamId, cursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List safe team-secret metadata
         * @param {number} teamId 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamSecrets(teamId: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListTeamSecrets200Response> {
            return localVarFp.listTeamSecrets(teamId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Restore a prior value as a new current version
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {string} versionId 
         * @param {TeamSecretRestoreRequest} teamSecretRestoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreTeamSecretVersion(teamId: number, secretId: string, versionId: string, teamSecretRestoreRequest: TeamSecretRestoreRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretDetail> {
            return localVarFp.restoreTeamSecretVersion(teamId, secretId, versionId, teamSecretRestoreRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Write a new current value
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretRotateRequest} teamSecretRotateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateTeamSecret(teamId: number, secretId: string, teamSecretRotateRequest: TeamSecretRotateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretDetail> {
            return localVarFp.rotateTeamSecret(teamId, secretId, teamSecretRotateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an agent\'s access to a team secret
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ungrantTeamSecret(teamId: number, secretId: string, agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretDetail> {
            return localVarFp.ungrantTeamSecret(teamId, secretId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update safe team-secret metadata or policy
         * @param {number} teamId 
         * @param {string} secretId 
         * @param {TeamSecretUpdateRequest} teamSecretUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamSecret(teamId: number, secretId: string, teamSecretUpdateRequest: TeamSecretUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamSecretDetail> {
            return localVarFp.updateTeamSecret(teamId, secretId, teamSecretUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamSecretsApi - object-oriented interface
 */
export class TeamSecretsApi extends BaseAPI {
    /**
     * 
     * @summary Create a team secret
     * @param {number} teamId 
     * @param {TeamSecretCreateRequest} teamSecretCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTeamSecret(teamId: number, teamSecretCreateRequest: TeamSecretCreateRequest, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).createTeamSecret(teamId, teamSecretCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete a team secret
     * @param {number} teamId 
     * @param {string} secretId 
     * @param {TeamSecretDeleteRequest} teamSecretDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTeamSecret(teamId: number, secretId: string, teamSecretDeleteRequest: TeamSecretDeleteRequest, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).deleteTeamSecret(teamId, secretId, teamSecretDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete a prior version
     * @param {number} teamId 
     * @param {string} secretId 
     * @param {string} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTeamSecretVersion(teamId: number, secretId: string, versionId: string, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).deleteTeamSecretVersion(teamId, secretId, versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get safe team-secret detail
     * @param {number} teamId 
     * @param {string} secretId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTeamSecret(teamId: number, secretId: string, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).getTeamSecret(teamId, secretId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grant an agent access to a team secret
     * @param {number} teamId 
     * @param {string} secretId 
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public grantTeamSecret(teamId: number, secretId: string, agentId: number, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).grantTeamSecret(teamId, secretId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read cursor-paginated safe team-secret activity
     * @param {number} teamId 
     * @param {string} [cursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTeamSecretActivity(teamId: number, cursor?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).listTeamSecretActivity(teamId, cursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List safe team-secret metadata
     * @param {number} teamId 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTeamSecrets(teamId: number, search?: string, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).listTeamSecrets(teamId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Restore a prior value as a new current version
     * @param {number} teamId 
     * @param {string} secretId 
     * @param {string} versionId 
     * @param {TeamSecretRestoreRequest} teamSecretRestoreRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public restoreTeamSecretVersion(teamId: number, secretId: string, versionId: string, teamSecretRestoreRequest: TeamSecretRestoreRequest, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).restoreTeamSecretVersion(teamId, secretId, versionId, teamSecretRestoreRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Write a new current value
     * @param {number} teamId 
     * @param {string} secretId 
     * @param {TeamSecretRotateRequest} teamSecretRotateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rotateTeamSecret(teamId: number, secretId: string, teamSecretRotateRequest: TeamSecretRotateRequest, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).rotateTeamSecret(teamId, secretId, teamSecretRotateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an agent\'s access to a team secret
     * @param {number} teamId 
     * @param {string} secretId 
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ungrantTeamSecret(teamId: number, secretId: string, agentId: number, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).ungrantTeamSecret(teamId, secretId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update safe team-secret metadata or policy
     * @param {number} teamId 
     * @param {string} secretId 
     * @param {TeamSecretUpdateRequest} teamSecretUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTeamSecret(teamId: number, secretId: string, teamSecretUpdateRequest: TeamSecretUpdateRequest, options?: RawAxiosRequestConfig) {
        return TeamSecretsApiFp(this.configuration).updateTeamSecret(teamId, secretId, teamSecretUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamWizardApi - axios parameter creator
 */
export const TeamWizardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Whether a new team may start on the free trial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsWizardEligibilityGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/teams/wizard/eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create the team, budgets, auto-top-up, and invite seats (no emails, no charges)
         * @param {ApiTeamsWizardPostRequest} apiTeamsWizardPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsWizardPost: async (apiTeamsWizardPostRequest: ApiTeamsWizardPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiTeamsWizardPostRequest' is not null or undefined
            assertParamExists('apiTeamsWizardPost', 'apiTeamsWizardPostRequest', apiTeamsWizardPostRequest)
            const localVarPath = `/api/teams/wizard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsWizardPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attach the card, subscribe (first invoice), add funds, send invites — in order
         * @param {number} teamId 
         * @param {ApiTeamsWizardTeamIdFinalizePostRequest} apiTeamsWizardTeamIdFinalizePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsWizardTeamIdFinalizePost: async (teamId: number, apiTeamsWizardTeamIdFinalizePostRequest: ApiTeamsWizardTeamIdFinalizePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsWizardTeamIdFinalizePost', 'teamId', teamId)
            // verify required parameter 'apiTeamsWizardTeamIdFinalizePostRequest' is not null or undefined
            assertParamExists('apiTeamsWizardTeamIdFinalizePost', 'apiTeamsWizardTeamIdFinalizePostRequest', apiTeamsWizardTeamIdFinalizePostRequest)
            const localVarPath = `/api/teams/wizard/{teamId}/finalize`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsWizardTeamIdFinalizePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamWizardApi - functional programming interface
 */
export const TeamWizardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamWizardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Whether a new team may start on the free trial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsWizardEligibilityGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsWizardEligibilityGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsWizardEligibilityGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamWizardApi.apiTeamsWizardEligibilityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create the team, budgets, auto-top-up, and invite seats (no emails, no charges)
         * @param {ApiTeamsWizardPostRequest} apiTeamsWizardPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsWizardPost(apiTeamsWizardPostRequest: ApiTeamsWizardPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsWizardPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsWizardPost(apiTeamsWizardPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamWizardApi.apiTeamsWizardPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Attach the card, subscribe (first invoice), add funds, send invites — in order
         * @param {number} teamId 
         * @param {ApiTeamsWizardTeamIdFinalizePostRequest} apiTeamsWizardTeamIdFinalizePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsWizardTeamIdFinalizePost(teamId: number, apiTeamsWizardTeamIdFinalizePostRequest: ApiTeamsWizardTeamIdFinalizePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsWizardTeamIdFinalizePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsWizardTeamIdFinalizePost(teamId, apiTeamsWizardTeamIdFinalizePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamWizardApi.apiTeamsWizardTeamIdFinalizePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamWizardApi - factory interface
 */
export const TeamWizardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamWizardApiFp(configuration)
    return {
        /**
         * 
         * @summary Whether a new team may start on the free trial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsWizardEligibilityGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsWizardEligibilityGet200Response> {
            return localVarFp.apiTeamsWizardEligibilityGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create the team, budgets, auto-top-up, and invite seats (no emails, no charges)
         * @param {ApiTeamsWizardPostRequest} apiTeamsWizardPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsWizardPost(apiTeamsWizardPostRequest: ApiTeamsWizardPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsWizardPost201Response> {
            return localVarFp.apiTeamsWizardPost(apiTeamsWizardPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attach the card, subscribe (first invoice), add funds, send invites — in order
         * @param {number} teamId 
         * @param {ApiTeamsWizardTeamIdFinalizePostRequest} apiTeamsWizardTeamIdFinalizePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsWizardTeamIdFinalizePost(teamId: number, apiTeamsWizardTeamIdFinalizePostRequest: ApiTeamsWizardTeamIdFinalizePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsWizardTeamIdFinalizePost200Response> {
            return localVarFp.apiTeamsWizardTeamIdFinalizePost(teamId, apiTeamsWizardTeamIdFinalizePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamWizardApi - object-oriented interface
 */
export class TeamWizardApi extends BaseAPI {
    /**
     * 
     * @summary Whether a new team may start on the free trial
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsWizardEligibilityGet(options?: RawAxiosRequestConfig) {
        return TeamWizardApiFp(this.configuration).apiTeamsWizardEligibilityGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create the team, budgets, auto-top-up, and invite seats (no emails, no charges)
     * @param {ApiTeamsWizardPostRequest} apiTeamsWizardPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsWizardPost(apiTeamsWizardPostRequest: ApiTeamsWizardPostRequest, options?: RawAxiosRequestConfig) {
        return TeamWizardApiFp(this.configuration).apiTeamsWizardPost(apiTeamsWizardPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attach the card, subscribe (first invoice), add funds, send invites — in order
     * @param {number} teamId 
     * @param {ApiTeamsWizardTeamIdFinalizePostRequest} apiTeamsWizardTeamIdFinalizePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsWizardTeamIdFinalizePost(teamId: number, apiTeamsWizardTeamIdFinalizePostRequest: ApiTeamsWizardTeamIdFinalizePostRequest, options?: RawAxiosRequestConfig) {
        return TeamWizardApiFp(this.configuration).apiTeamsWizardTeamIdFinalizePost(teamId, apiTeamsWizardTeamIdFinalizePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestDataApi - axios parameter creator
 */
export const TestDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Marks an existing message as test data by setting the testData flag to true
         * @summary Mark a message as test data
         * @param {number} agentId ID of the agent
         * @param {AddTestDataRequest} addTestDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAgentTestData: async (agentId: number, addTestDataRequest: AddTestDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('addAgentTestData', 'agentId', agentId)
            // verify required parameter 'addTestDataRequest' is not null or undefined
            assertParamExists('addAgentTestData', 'addTestDataRequest', addTestDataRequest)
            const localVarPath = `/api/agent/{agentId}/test-data`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTestDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates test data by marking an existing message as test data
         * @summary Create test data from a message
         * @param {number} messageId ID of the message to create test data from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestDataFromMessage: async (messageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('createTestDataFromMessage', 'messageId', messageId)
            const localVarPath = `/api/message/{messageId}/create-test-data`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes the test data flag from a message by setting testData to false
         * @summary Remove test data flag from message
         * @param {number} messageId ID of the message to remove test data flag from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTestDataById: async (messageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('deleteTestDataById', 'messageId', messageId)
            const localVarPath = `/api/test-data/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated messages with testData=true for the specified agent
         * @summary Get test data messages for an agent
         * @param {number} agentId ID of the agent
         * @param {number} [page] Page number for pagination (1-based)
         * @param {number} [limit] Maximum number of messages to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTestData: async (agentId: number, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentTestData', 'agentId', agentId)
            const localVarPath = `/api/agent/{agentId}/test-data`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves details for a specific test data message
         * @summary Get a single test data message by ID
         * @param {number} messageId ID of the message to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestDataById: async (messageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getTestDataById', 'messageId', messageId)
            const localVarPath = `/api/test-data/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the testData flag for a specific message
         * @summary Update message test data flag
         * @param {number} messageId ID of the message to update
         * @param {UpdateTestDataRequest} updateTestDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestDataById: async (messageId: number, updateTestDataRequest: UpdateTestDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('updateTestDataById', 'messageId', messageId)
            // verify required parameter 'updateTestDataRequest' is not null or undefined
            assertParamExists('updateTestDataById', 'updateTestDataRequest', updateTestDataRequest)
            const localVarPath = `/api/test-data/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTestDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestDataApi - functional programming interface
 */
export const TestDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Marks an existing message as test data by setting the testData flag to true
         * @summary Mark a message as test data
         * @param {number} agentId ID of the agent
         * @param {AddTestDataRequest} addTestDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAgentTestData(agentId: number, addTestDataRequest: AddTestDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageTestData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAgentTestData(agentId, addTestDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestDataApi.addAgentTestData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates test data by marking an existing message as test data
         * @summary Create test data from a message
         * @param {number} messageId ID of the message to create test data from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestDataFromMessage(messageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageTestData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestDataFromMessage(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestDataApi.createTestDataFromMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes the test data flag from a message by setting testData to false
         * @summary Remove test data flag from message
         * @param {number} messageId ID of the message to remove test data flag from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTestDataById(messageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTestDataById(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestDataApi.deleteTestDataById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated messages with testData=true for the specified agent
         * @summary Get test data messages for an agent
         * @param {number} agentId ID of the agent
         * @param {number} [page] Page number for pagination (1-based)
         * @param {number} [limit] Maximum number of messages to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentTestData(agentId: number, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTestDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentTestData(agentId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestDataApi.getAgentTestData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves details for a specific test data message
         * @summary Get a single test data message by ID
         * @param {number} messageId ID of the message to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestDataById(messageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageTestData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestDataById(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestDataApi.getTestDataById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the testData flag for a specific message
         * @summary Update message test data flag
         * @param {number} messageId ID of the message to update
         * @param {UpdateTestDataRequest} updateTestDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTestDataById(messageId: number, updateTestDataRequest: UpdateTestDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageTestData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTestDataById(messageId, updateTestDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestDataApi.updateTestDataById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestDataApi - factory interface
 */
export const TestDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestDataApiFp(configuration)
    return {
        /**
         * Marks an existing message as test data by setting the testData flag to true
         * @summary Mark a message as test data
         * @param {number} agentId ID of the agent
         * @param {AddTestDataRequest} addTestDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAgentTestData(agentId: number, addTestDataRequest: AddTestDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageTestData> {
            return localVarFp.addAgentTestData(agentId, addTestDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates test data by marking an existing message as test data
         * @summary Create test data from a message
         * @param {number} messageId ID of the message to create test data from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestDataFromMessage(messageId: number, options?: RawAxiosRequestConfig): AxiosPromise<MessageTestData> {
            return localVarFp.createTestDataFromMessage(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the test data flag from a message by setting testData to false
         * @summary Remove test data flag from message
         * @param {number} messageId ID of the message to remove test data flag from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTestDataById(messageId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTestDataById(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated messages with testData=true for the specified agent
         * @summary Get test data messages for an agent
         * @param {number} agentId ID of the agent
         * @param {number} [page] Page number for pagination (1-based)
         * @param {number} [limit] Maximum number of messages to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTestData(agentId: number, page?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTestDataResponse> {
            return localVarFp.getAgentTestData(agentId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves details for a specific test data message
         * @summary Get a single test data message by ID
         * @param {number} messageId ID of the message to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestDataById(messageId: number, options?: RawAxiosRequestConfig): AxiosPromise<MessageTestData> {
            return localVarFp.getTestDataById(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the testData flag for a specific message
         * @summary Update message test data flag
         * @param {number} messageId ID of the message to update
         * @param {UpdateTestDataRequest} updateTestDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestDataById(messageId: number, updateTestDataRequest: UpdateTestDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageTestData> {
            return localVarFp.updateTestDataById(messageId, updateTestDataRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestDataApi - object-oriented interface
 */
export class TestDataApi extends BaseAPI {
    /**
     * Marks an existing message as test data by setting the testData flag to true
     * @summary Mark a message as test data
     * @param {number} agentId ID of the agent
     * @param {AddTestDataRequest} addTestDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addAgentTestData(agentId: number, addTestDataRequest: AddTestDataRequest, options?: RawAxiosRequestConfig) {
        return TestDataApiFp(this.configuration).addAgentTestData(agentId, addTestDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates test data by marking an existing message as test data
     * @summary Create test data from a message
     * @param {number} messageId ID of the message to create test data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTestDataFromMessage(messageId: number, options?: RawAxiosRequestConfig) {
        return TestDataApiFp(this.configuration).createTestDataFromMessage(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes the test data flag from a message by setting testData to false
     * @summary Remove test data flag from message
     * @param {number} messageId ID of the message to remove test data flag from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTestDataById(messageId: number, options?: RawAxiosRequestConfig) {
        return TestDataApiFp(this.configuration).deleteTestDataById(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated messages with testData=true for the specified agent
     * @summary Get test data messages for an agent
     * @param {number} agentId ID of the agent
     * @param {number} [page] Page number for pagination (1-based)
     * @param {number} [limit] Maximum number of messages to return per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAgentTestData(agentId: number, page?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return TestDataApiFp(this.configuration).getAgentTestData(agentId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves details for a specific test data message
     * @summary Get a single test data message by ID
     * @param {number} messageId ID of the message to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestDataById(messageId: number, options?: RawAxiosRequestConfig) {
        return TestDataApiFp(this.configuration).getTestDataById(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the testData flag for a specific message
     * @summary Update message test data flag
     * @param {number} messageId ID of the message to update
     * @param {UpdateTestDataRequest} updateTestDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTestDataById(messageId: number, updateTestDataRequest: UpdateTestDataRequest, options?: RawAxiosRequestConfig) {
        return TestDataApiFp(this.configuration).updateTestDataById(messageId, updateTestDataRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestResultsApi - axios parameter creator
 */
export const TestResultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete test by test ID
         * @param {number} testId ID of the test to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestResultsPoiPoiIdGeneratedEmailsDelete: async (testId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('apiTestResultsPoiPoiIdGeneratedEmailsDelete', 'testId', testId)
            const localVarPath = `/api/test-results/poi/{poiId}/generated-emails`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve test details with optional pagination for test result items
         * @summary Get test details by test ID
         * @param {number} testId ID of the test
         * @param {number} [offset] Number of results to skip for pagination
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsTestIdResultsGet: async (testId: number, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('apiTestsTestIdResultsGet', 'testId', testId)
            const localVarPath = `/api/tests/{testId}/results`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestResultsApi - functional programming interface
 */
export const TestResultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestResultsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete test by test ID
         * @param {number} testId ID of the test to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestResultsPoiPoiIdGeneratedEmailsDelete(testId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestResultsPoiPoiIdGeneratedEmailsDelete(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestResultsApi.apiTestResultsPoiPoiIdGeneratedEmailsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve test details with optional pagination for test result items
         * @summary Get test details by test ID
         * @param {number} testId ID of the test
         * @param {number} [offset] Number of results to skip for pagination
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsTestIdResultsGet(testId: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestResultDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsTestIdResultsGet(testId, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestResultsApi.apiTestsTestIdResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestResultsApi - factory interface
 */
export const TestResultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestResultsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete test by test ID
         * @param {number} testId ID of the test to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestResultsPoiPoiIdGeneratedEmailsDelete(testId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTestResultsPoiPoiIdGeneratedEmailsDelete(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve test details with optional pagination for test result items
         * @summary Get test details by test ID
         * @param {number} testId ID of the test
         * @param {number} [offset] Number of results to skip for pagination
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsTestIdResultsGet(testId: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<TestResultDetails> {
            return localVarFp.apiTestsTestIdResultsGet(testId, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestResultsApi - object-oriented interface
 */
export class TestResultsApi extends BaseAPI {
    /**
     * 
     * @summary Delete test by test ID
     * @param {number} testId ID of the test to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTestResultsPoiPoiIdGeneratedEmailsDelete(testId: number, options?: RawAxiosRequestConfig) {
        return TestResultsApiFp(this.configuration).apiTestResultsPoiPoiIdGeneratedEmailsDelete(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve test details with optional pagination for test result items
     * @summary Get test details by test ID
     * @param {number} testId ID of the test
     * @param {number} [offset] Number of results to skip for pagination
     * @param {number} [limit] Maximum number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTestsTestIdResultsGet(testId: number, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return TestResultsApiFp(this.configuration).apiTestsTestIdResultsGet(testId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestingApi - axios parameter creator
 */
export const TestingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnMockGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiWsAgentAgentIdLearnMockGet', 'agentId', agentId)
            const localVarPath = `/api/ws/agent/{agentId}/learn-mock`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestingApi - functional programming interface
 */
export const TestingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestingApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWsAgentAgentIdLearnMockGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingApi.apiWsAgentAgentIdLearnMockGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestingApi - factory interface
 */
export const TestingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestingApiFp(configuration)
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWsAgentAgentIdLearnMockGet(agentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestingApi - object-oriented interface
 */
export class TestingApi extends BaseAPI {
    /**
     * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
     * @summary WebSocket endpoint for streaming mock agent learning progress
     * @param {number} agentId ID of the agent to simulate learning
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig) {
        return TestingApiFp(this.configuration).apiWsAgentAgentIdLearnMockGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ToolConfigurationsApi - axios parameter creator
 */
export const ToolConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update per-agent settings for a tool bundle
         * @param {number} agentId 
         * @param {string} bundleKey 
         * @param {ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest} apiAgentsAgentIdToolsBundlesBundleKeyPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsBundlesBundleKeyPut: async (agentId: number, bundleKey: string, apiAgentsAgentIdToolsBundlesBundleKeyPutRequest: ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsBundlesBundleKeyPut', 'agentId', agentId)
            // verify required parameter 'bundleKey' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsBundlesBundleKeyPut', 'bundleKey', bundleKey)
            // verify required parameter 'apiAgentsAgentIdToolsBundlesBundleKeyPutRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsBundlesBundleKeyPut', 'apiAgentsAgentIdToolsBundlesBundleKeyPutRequest', apiAgentsAgentIdToolsBundlesBundleKeyPutRequest)
            const localVarPath = `/api/agents/{agentId}/tools/bundles/{bundleKey}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"bundleKey"}}`, encodeURIComponent(String(bundleKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAgentsAgentIdToolsBundlesBundleKeyPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Built-in bundles merged with the agent\'s per-bundle settings
         * @summary Get the tool bundle catalog for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsCatalogGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsCatalogGet', 'agentId', agentId)
            const localVarPath = `/api/agents/{agentId}/tools/catalog`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all tool configurations for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsConfigurationsGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsConfigurationsGet', 'agentId', agentId)
            const localVarPath = `/api/agents/{agentId}/tools/configurations`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a tool configuration
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsConfigurationsIdDelete: async (agentId: number, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsConfigurationsIdDelete', 'agentId', agentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsConfigurationsIdDelete', 'id', id)
            const localVarPath = `/api/agents/{agentId}/tools/configurations/{id}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a tool configuration
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolsConfigurationsIdPutRequest} apiAgentsAgentIdToolsConfigurationsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsConfigurationsIdPut: async (agentId: number, id: number, apiAgentsAgentIdToolsConfigurationsIdPutRequest: ApiAgentsAgentIdToolsConfigurationsIdPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsConfigurationsIdPut', 'agentId', agentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsConfigurationsIdPut', 'id', id)
            // verify required parameter 'apiAgentsAgentIdToolsConfigurationsIdPutRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsConfigurationsIdPut', 'apiAgentsAgentIdToolsConfigurationsIdPutRequest', apiAgentsAgentIdToolsConfigurationsIdPutRequest)
            const localVarPath = `/api/agents/{agentId}/tools/configurations/{id}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAgentsAgentIdToolsConfigurationsIdPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a tool configuration for an agent
         * @param {number} agentId 
         * @param {ApiAgentsAgentIdToolsConfigurationsPostRequest} apiAgentsAgentIdToolsConfigurationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsConfigurationsPost: async (agentId: number, apiAgentsAgentIdToolsConfigurationsPostRequest: ApiAgentsAgentIdToolsConfigurationsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsConfigurationsPost', 'agentId', agentId)
            // verify required parameter 'apiAgentsAgentIdToolsConfigurationsPostRequest' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsConfigurationsPost', 'apiAgentsAgentIdToolsConfigurationsPostRequest', apiAgentsAgentIdToolsConfigurationsPostRequest)
            const localVarPath = `/api/agents/{agentId}/tools/configurations`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAgentsAgentIdToolsConfigurationsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get per-function execution totals for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsUsageGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiAgentsAgentIdToolsUsageGet', 'agentId', agentId)
            const localVarPath = `/api/agents/{agentId}/tools/usage`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToolConfigurationsApi - functional programming interface
 */
export const ToolConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ToolConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update per-agent settings for a tool bundle
         * @param {number} agentId 
         * @param {string} bundleKey 
         * @param {ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest} apiAgentsAgentIdToolsBundlesBundleKeyPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolsBundlesBundleKeyPut(agentId: number, bundleKey: string, apiAgentsAgentIdToolsBundlesBundleKeyPutRequest: ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolsBundlesBundleKeyPut(agentId, bundleKey, apiAgentsAgentIdToolsBundlesBundleKeyPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolConfigurationsApi.apiAgentsAgentIdToolsBundlesBundleKeyPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Built-in bundles merged with the agent\'s per-bundle settings
         * @summary Get the tool bundle catalog for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolsCatalogGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolsCatalogGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolConfigurationsApi.apiAgentsAgentIdToolsCatalogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all tool configurations for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolsConfigurationsGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToolConfigurationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolsConfigurationsGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolConfigurationsApi.apiAgentsAgentIdToolsConfigurationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a tool configuration
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolsConfigurationsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolsConfigurationsIdDelete(agentId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolConfigurationsApi.apiAgentsAgentIdToolsConfigurationsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a tool configuration
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolsConfigurationsIdPutRequest} apiAgentsAgentIdToolsConfigurationsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolsConfigurationsIdPut(agentId: number, id: number, apiAgentsAgentIdToolsConfigurationsIdPutRequest: ApiAgentsAgentIdToolsConfigurationsIdPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolsConfigurationsIdPut(agentId, id, apiAgentsAgentIdToolsConfigurationsIdPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolConfigurationsApi.apiAgentsAgentIdToolsConfigurationsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a tool configuration for an agent
         * @param {number} agentId 
         * @param {ApiAgentsAgentIdToolsConfigurationsPostRequest} apiAgentsAgentIdToolsConfigurationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolsConfigurationsPost(agentId: number, apiAgentsAgentIdToolsConfigurationsPostRequest: ApiAgentsAgentIdToolsConfigurationsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolsConfigurationsPost(agentId, apiAgentsAgentIdToolsConfigurationsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolConfigurationsApi.apiAgentsAgentIdToolsConfigurationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get per-function execution totals for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAgentsAgentIdToolsUsageGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiAgentsAgentIdToolsUsageGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAgentsAgentIdToolsUsageGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolConfigurationsApi.apiAgentsAgentIdToolsUsageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ToolConfigurationsApi - factory interface
 */
export const ToolConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ToolConfigurationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Update per-agent settings for a tool bundle
         * @param {number} agentId 
         * @param {string} bundleKey 
         * @param {ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest} apiAgentsAgentIdToolsBundlesBundleKeyPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsBundlesBundleKeyPut(agentId: number, bundleKey: string, apiAgentsAgentIdToolsBundlesBundleKeyPutRequest: ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToolCatalogResponse> {
            return localVarFp.apiAgentsAgentIdToolsBundlesBundleKeyPut(agentId, bundleKey, apiAgentsAgentIdToolsBundlesBundleKeyPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Built-in bundles merged with the agent\'s per-bundle settings
         * @summary Get the tool bundle catalog for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsCatalogGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ToolCatalogResponse> {
            return localVarFp.apiAgentsAgentIdToolsCatalogGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all tool configurations for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsConfigurationsGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToolConfigurationResponse>> {
            return localVarFp.apiAgentsAgentIdToolsConfigurationsGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a tool configuration
         * @param {number} agentId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsConfigurationsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response> {
            return localVarFp.apiAgentsAgentIdToolsConfigurationsIdDelete(agentId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a tool configuration
         * @param {number} agentId 
         * @param {number} id 
         * @param {ApiAgentsAgentIdToolsConfigurationsIdPutRequest} apiAgentsAgentIdToolsConfigurationsIdPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsConfigurationsIdPut(agentId: number, id: number, apiAgentsAgentIdToolsConfigurationsIdPutRequest: ApiAgentsAgentIdToolsConfigurationsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToolConfigurationResponse> {
            return localVarFp.apiAgentsAgentIdToolsConfigurationsIdPut(agentId, id, apiAgentsAgentIdToolsConfigurationsIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a tool configuration for an agent
         * @param {number} agentId 
         * @param {ApiAgentsAgentIdToolsConfigurationsPostRequest} apiAgentsAgentIdToolsConfigurationsPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsConfigurationsPost(agentId: number, apiAgentsAgentIdToolsConfigurationsPostRequest: ApiAgentsAgentIdToolsConfigurationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToolConfigurationResponse> {
            return localVarFp.apiAgentsAgentIdToolsConfigurationsPost(agentId, apiAgentsAgentIdToolsConfigurationsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get per-function execution totals for an agent
         * @param {number} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAgentsAgentIdToolsUsageGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiAgentsAgentIdToolsUsageGet200Response> {
            return localVarFp.apiAgentsAgentIdToolsUsageGet(agentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ToolConfigurationsApi - object-oriented interface
 */
export class ToolConfigurationsApi extends BaseAPI {
    /**
     * 
     * @summary Update per-agent settings for a tool bundle
     * @param {number} agentId 
     * @param {string} bundleKey 
     * @param {ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest} apiAgentsAgentIdToolsBundlesBundleKeyPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolsBundlesBundleKeyPut(agentId: number, bundleKey: string, apiAgentsAgentIdToolsBundlesBundleKeyPutRequest: ApiAgentsAgentIdToolsBundlesBundleKeyPutRequest, options?: RawAxiosRequestConfig) {
        return ToolConfigurationsApiFp(this.configuration).apiAgentsAgentIdToolsBundlesBundleKeyPut(agentId, bundleKey, apiAgentsAgentIdToolsBundlesBundleKeyPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Built-in bundles merged with the agent\'s per-bundle settings
     * @summary Get the tool bundle catalog for an agent
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolsCatalogGet(agentId: number, options?: RawAxiosRequestConfig) {
        return ToolConfigurationsApiFp(this.configuration).apiAgentsAgentIdToolsCatalogGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all tool configurations for an agent
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolsConfigurationsGet(agentId: number, options?: RawAxiosRequestConfig) {
        return ToolConfigurationsApiFp(this.configuration).apiAgentsAgentIdToolsConfigurationsGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a tool configuration
     * @param {number} agentId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolsConfigurationsIdDelete(agentId: number, id: number, options?: RawAxiosRequestConfig) {
        return ToolConfigurationsApiFp(this.configuration).apiAgentsAgentIdToolsConfigurationsIdDelete(agentId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a tool configuration
     * @param {number} agentId 
     * @param {number} id 
     * @param {ApiAgentsAgentIdToolsConfigurationsIdPutRequest} apiAgentsAgentIdToolsConfigurationsIdPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolsConfigurationsIdPut(agentId: number, id: number, apiAgentsAgentIdToolsConfigurationsIdPutRequest: ApiAgentsAgentIdToolsConfigurationsIdPutRequest, options?: RawAxiosRequestConfig) {
        return ToolConfigurationsApiFp(this.configuration).apiAgentsAgentIdToolsConfigurationsIdPut(agentId, id, apiAgentsAgentIdToolsConfigurationsIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a tool configuration for an agent
     * @param {number} agentId 
     * @param {ApiAgentsAgentIdToolsConfigurationsPostRequest} apiAgentsAgentIdToolsConfigurationsPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolsConfigurationsPost(agentId: number, apiAgentsAgentIdToolsConfigurationsPostRequest: ApiAgentsAgentIdToolsConfigurationsPostRequest, options?: RawAxiosRequestConfig) {
        return ToolConfigurationsApiFp(this.configuration).apiAgentsAgentIdToolsConfigurationsPost(agentId, apiAgentsAgentIdToolsConfigurationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get per-function execution totals for an agent
     * @param {number} agentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAgentsAgentIdToolsUsageGet(agentId: number, options?: RawAxiosRequestConfig) {
        return ToolConfigurationsApiFp(this.configuration).apiAgentsAgentIdToolsUsageGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ToolOutputsApi - axios parameter creator
 */
export const ToolOutputsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the stored output as plain text. Authorisation is the conversation\'s: a row is reachable only by someone who may read the conversation that produced it.
         * @summary Read stored tool output
         * @param {number} teamId ID of the team that owns the stored output
         * @param {number} spillId ID of the stored output
         * @param {number} [offset] First line to return, 1-based. Omit to return the whole thing.
         * @param {number} [limit] Lines to return from the offset, capped server-side.
         * @param {string} [download] Present at any value to send Content-Disposition: attachment, so the browser saves the output as &lt;toolName&gt;-&lt;handle&gt;.txt instead of rendering it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdToolOutputsSpillIdGet: async (teamId: number, spillId: number, offset?: number, limit?: number, download?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdToolOutputsSpillIdGet', 'teamId', teamId)
            // verify required parameter 'spillId' is not null or undefined
            assertParamExists('apiTeamsTeamIdToolOutputsSpillIdGet', 'spillId', spillId)
            const localVarPath = `/api/teams/{teamId}/tool-outputs/{spillId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"spillId"}}`, encodeURIComponent(String(spillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (download !== undefined) {
                localVarQueryParameter['download'] = download;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToolOutputsApi - functional programming interface
 */
export const ToolOutputsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ToolOutputsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the stored output as plain text. Authorisation is the conversation\'s: a row is reachable only by someone who may read the conversation that produced it.
         * @summary Read stored tool output
         * @param {number} teamId ID of the team that owns the stored output
         * @param {number} spillId ID of the stored output
         * @param {number} [offset] First line to return, 1-based. Omit to return the whole thing.
         * @param {number} [limit] Lines to return from the offset, capped server-side.
         * @param {string} [download] Present at any value to send Content-Disposition: attachment, so the browser saves the output as &lt;toolName&gt;-&lt;handle&gt;.txt instead of rendering it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdToolOutputsSpillIdGet(teamId: number, spillId: number, offset?: number, limit?: number, download?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdToolOutputsSpillIdGet(teamId, spillId, offset, limit, download, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolOutputsApi.apiTeamsTeamIdToolOutputsSpillIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ToolOutputsApi - factory interface
 */
export const ToolOutputsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ToolOutputsApiFp(configuration)
    return {
        /**
         * Returns the stored output as plain text. Authorisation is the conversation\'s: a row is reachable only by someone who may read the conversation that produced it.
         * @summary Read stored tool output
         * @param {number} teamId ID of the team that owns the stored output
         * @param {number} spillId ID of the stored output
         * @param {number} [offset] First line to return, 1-based. Omit to return the whole thing.
         * @param {number} [limit] Lines to return from the offset, capped server-side.
         * @param {string} [download] Present at any value to send Content-Disposition: attachment, so the browser saves the output as &lt;toolName&gt;-&lt;handle&gt;.txt instead of rendering it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdToolOutputsSpillIdGet(teamId: number, spillId: number, offset?: number, limit?: number, download?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTeamsTeamIdToolOutputsSpillIdGet(teamId, spillId, offset, limit, download, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ToolOutputsApi - object-oriented interface
 */
export class ToolOutputsApi extends BaseAPI {
    /**
     * Returns the stored output as plain text. Authorisation is the conversation\'s: a row is reachable only by someone who may read the conversation that produced it.
     * @summary Read stored tool output
     * @param {number} teamId ID of the team that owns the stored output
     * @param {number} spillId ID of the stored output
     * @param {number} [offset] First line to return, 1-based. Omit to return the whole thing.
     * @param {number} [limit] Lines to return from the offset, capped server-side.
     * @param {string} [download] Present at any value to send Content-Disposition: attachment, so the browser saves the output as &lt;toolName&gt;-&lt;handle&gt;.txt instead of rendering it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdToolOutputsSpillIdGet(teamId: number, spillId: number, offset?: number, limit?: number, download?: string, options?: RawAxiosRequestConfig) {
        return ToolOutputsApiFp(this.configuration).apiTeamsTeamIdToolOutputsSpillIdGet(teamId, spillId, offset, limit, download, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get users for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersGet', 'teamId', teamId)
            const localVarPath = `/api/team/{teamId}/users`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a user to a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdUsersPostRequest} apiTeamTeamIdUsersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersPost: async (teamId: number, apiTeamTeamIdUsersPostRequest: ApiTeamTeamIdUsersPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersPost', 'teamId', teamId)
            // verify required parameter 'apiTeamTeamIdUsersPostRequest' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersPost', 'apiTeamTeamIdUsersPostRequest', apiTeamTeamIdUsersPostRequest)
            const localVarPath = `/api/team/{teamId}/users`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdUsersPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a user from a team
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {ApiTeamTeamIdUsersUserEmailAddressDeleteRequest} [apiTeamTeamIdUsersUserEmailAddressDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersUserEmailAddressDelete: async (teamId: number, userEmailAddress: string, apiTeamTeamIdUsersUserEmailAddressDeleteRequest?: ApiTeamTeamIdUsersUserEmailAddressDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersUserEmailAddressDelete', 'teamId', teamId)
            // verify required parameter 'userEmailAddress' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersUserEmailAddressDelete', 'userEmailAddress', userEmailAddress)
            const localVarPath = `/api/team/{teamId}/users/{userEmailAddress}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"userEmailAddress"}}`, encodeURIComponent(String(userEmailAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamTeamIdUsersUserEmailAddressDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get eligible delegation successors before removing a team member
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet: async (teamId: number, userEmailAddress: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet', 'teamId', teamId)
            // verify required parameter 'userEmailAddress' is not null or undefined
            assertParamExists('apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet', 'userEmailAddress', userEmailAddress)
            const localVarPath = `/api/team/{teamId}/users/{userEmailAddress}/removal-delegation-candidates`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"userEmailAddress"}}`, encodeURIComponent(String(userEmailAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links the (kind, value) bound to the token at issue time to the calling user\'s account — never a value the request supplies. The token is single-use and short-lived; unknown, already-consumed, and expired tokens all map to the same generic 400 so a caller probing tokens learns nothing about which case they hit. 
         * @summary Consume a Slack bot-delivered magic-link token
         * @param {ApiUserChannelIdentitiesConsumeLinkTokenPostRequest} apiUserChannelIdentitiesConsumeLinkTokenPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChannelIdentitiesConsumeLinkTokenPost: async (apiUserChannelIdentitiesConsumeLinkTokenPostRequest: ApiUserChannelIdentitiesConsumeLinkTokenPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUserChannelIdentitiesConsumeLinkTokenPostRequest' is not null or undefined
            assertParamExists('apiUserChannelIdentitiesConsumeLinkTokenPost', 'apiUserChannelIdentitiesConsumeLinkTokenPostRequest', apiUserChannelIdentitiesConsumeLinkTokenPostRequest)
            const localVarPath = `/api/user/channel-identities/consume-link-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUserChannelIdentitiesConsumeLinkTokenPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Account-level, not team-scoped — the \"Linked identities\" section of account settings (linked Slack identities and verified phone number). 
         * @summary List the caller\'s linked channel identities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChannelIdentitiesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/channel-identities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlink one of the caller\'s own channel identities
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChannelIdentitiesIdDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserChannelIdentitiesIdDelete', 'id', id)
            const localVarPath = `/api/user/channel-identities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * C1 fix (final review): the account-settings landing page calls this FIRST, before ever consuming a `?link-token=`, so it can show whose identity the link names (\"Link Slack account {displayName} ({value}) to your account?\") and require an explicit confirm. This endpoint NEVER sets `consumed_at` — it is safe to call any number of times. 
         * @summary Preview what a Slack magic-link token would bind, without consuming it
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChannelIdentitiesLinkTokenTokenGet: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiUserChannelIdentitiesLinkTokenTokenGet', 'token', token)
            const localVarPath = `/api/user/channel-identities/link-token/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List eligible successors for affected shared-team delegations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletionDelegationCandidatesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/deletion/delegation-candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request deletion of the current account
         * @param {AccountDeletionRequest} accountDeletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletionPost: async (accountDeletionRequest: AccountDeletionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountDeletionRequest' is not null or undefined
            assertParamExists('apiUserDeletionPost', 'accountDeletionRequest', accountDeletionRequest)
            const localVarPath = `/api/user/deletion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountDeletionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint ignores browser login cookies and never refreshes a browser session.
         * @summary Read account deletion progress with the one-time status credential
         * @param {string} requestId 
         * @param {string} xDeletionStatusToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletionRequestIdGet: async (requestId: string, xDeletionStatusToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('apiUserDeletionRequestIdGet', 'requestId', requestId)
            // verify required parameter 'xDeletionStatusToken' is not null or undefined
            assertParamExists('apiUserDeletionRequestIdGet', 'xDeletionStatusToken', xDeletionStatusToken)
            const localVarPath = `/api/user/deletion/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xDeletionStatusToken != null) {
                localVarHeaderParameter['X-Deletion-Status-Token'] = String(xDeletionStatusToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke the final account deletion browser session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletionSessionDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/deletion/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a pending passwordless account for verified passkey signup
         * @param {PasskeySignupRequest} passkeySignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPasskeySignupPost: async (passkeySignupRequest: PasskeySignupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passkeySignupRequest' is not null or undefined
            assertParamExists('apiUserPasskeySignupPost', 'passkeySignupRequest', passkeySignupRequest)
            const localVarPath = `/api/user/passkey-signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passkeySignupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user password
         * @param {ApiUserPasswordPutRequest} apiUserPasswordPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPasswordPut: async (apiUserPasswordPutRequest: ApiUserPasswordPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUserPasswordPutRequest' is not null or undefined
            assertParamExists('apiUserPasswordPut', 'apiUserPasswordPutRequest', apiUserPasswordPutRequest)
            const localVarPath = `/api/user/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUserPasswordPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates E.164 shape, enforces a 60-second resend cooldown, and texts a 6-digit one-time code via the account-level Twilio sender (design doc decision 5b). The phone is not linked until the code is verified via /api/user/phone/verify. 
         * @summary Start (or restart) phone-number verification
         * @param {ApiUserPhoneStartPostRequest} apiUserPhoneStartPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPhoneStartPost: async (apiUserPhoneStartPostRequest: ApiUserPhoneStartPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUserPhoneStartPostRequest' is not null or undefined
            assertParamExists('apiUserPhoneStartPost', 'apiUserPhoneStartPostRequest', apiUserPhoneStartPostRequest)
            const localVarPath = `/api/user/phone/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUserPhoneStartPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Attempt-limited (5) and expiring (10 minutes); hitting the attempt cap clears the pending verification and locks with a 429. A correct code links the phone number in `user_channel_identities` via `sms_otp` and clears all OTP state either way (including when the phone is already linked to a different account, which 409s). 
         * @summary Verify the phone OTP code and link the phone identity
         * @param {ApiUserPhoneVerifyPostRequest} apiUserPhoneVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPhoneVerifyPost: async (apiUserPhoneVerifyPostRequest: ApiUserPhoneVerifyPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUserPhoneVerifyPostRequest' is not null or undefined
            assertParamExists('apiUserPhoneVerifyPost', 'apiUserPhoneVerifyPostRequest', apiUserPhoneVerifyPostRequest)
            const localVarPath = `/api/user/phone/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUserPhoneVerifyPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new user
         * @param {UserRequest} userRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPost: async (userRequest: UserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRequest' is not null or undefined
            assertParamExists('apiUserPost', 'userRequest', userRequest)
            const localVarPath = `/api/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user profile
         * @param {ApiUserProfilePutRequest} apiUserProfilePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserProfilePut: async (apiUserProfilePutRequest: ApiUserProfilePutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUserProfilePutRequest' is not null or undefined
            assertParamExists('apiUserProfilePut', 'apiUserProfilePutRequest', apiUserProfilePutRequest)
            const localVarPath = `/api/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUserProfilePutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend verification email
         * @param {ApiUserResendVerificationPostRequest} apiUserResendVerificationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserResendVerificationPost: async (apiUserResendVerificationPostRequest: ApiUserResendVerificationPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiUserResendVerificationPostRequest' is not null or undefined
            assertParamExists('apiUserResendVerificationPost', 'apiUserResendVerificationPostRequest', apiUserResendVerificationPostRequest)
            const localVarPath = `/api/user/resend-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUserResendVerificationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite/mention autocomplete. Matches first name, last name, or email address; returns at most 10 users.
         * @summary Search users who share a team with the requester
         * @param {string} q Search text (minimum 2 characters; shorter queries return an empty list)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSearchGet: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiUserSearchGet', 'q', q)
            const localVarPath = `/api/user/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify a user\'s email address
         * @param {string} email Email address to verify
         * @param {string} token Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserVerifyGet: async (email: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('apiUserVerifyGet', 'email', email)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiUserVerifyGet', 'token', token)
            const localVarPath = `/api/user/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get users for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdUsersGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiTeamTeamIdUsersGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdUsersGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiTeamTeamIdUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a user to a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdUsersPostRequest} apiTeamTeamIdUsersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdUsersPost(teamId: number, apiTeamTeamIdUsersPostRequest: ApiTeamTeamIdUsersPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdUsersPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdUsersPost(teamId, apiTeamTeamIdUsersPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiTeamTeamIdUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a user from a team
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {ApiTeamTeamIdUsersUserEmailAddressDeleteRequest} [apiTeamTeamIdUsersUserEmailAddressDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdUsersUserEmailAddressDelete(teamId: number, userEmailAddress: string, apiTeamTeamIdUsersUserEmailAddressDeleteRequest?: ApiTeamTeamIdUsersUserEmailAddressDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdUsersUserEmailAddressDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdUsersUserEmailAddressDelete(teamId, userEmailAddress, apiTeamTeamIdUsersUserEmailAddressDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiTeamTeamIdUsersUserEmailAddressDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get eligible delegation successors before removing a team member
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId: number, userEmailAddress: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId, userEmailAddress, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Links the (kind, value) bound to the token at issue time to the calling user\'s account — never a value the request supplies. The token is single-use and short-lived; unknown, already-consumed, and expired tokens all map to the same generic 400 so a caller probing tokens learns nothing about which case they hit. 
         * @summary Consume a Slack bot-delivered magic-link token
         * @param {ApiUserChannelIdentitiesConsumeLinkTokenPostRequest} apiUserChannelIdentitiesConsumeLinkTokenPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserChannelIdentitiesConsumeLinkTokenPost(apiUserChannelIdentitiesConsumeLinkTokenPostRequest: ApiUserChannelIdentitiesConsumeLinkTokenPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserChannelIdentitiesConsumeLinkTokenPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserChannelIdentitiesConsumeLinkTokenPost(apiUserChannelIdentitiesConsumeLinkTokenPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserChannelIdentitiesConsumeLinkTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Account-level, not team-scoped — the \"Linked identities\" section of account settings (linked Slack identities and verified phone number). 
         * @summary List the caller\'s linked channel identities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserChannelIdentitiesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserChannelIdentitiesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserChannelIdentitiesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserChannelIdentitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlink one of the caller\'s own channel identities
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserChannelIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserChannelIdentitiesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserChannelIdentitiesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * C1 fix (final review): the account-settings landing page calls this FIRST, before ever consuming a `?link-token=`, so it can show whose identity the link names (\"Link Slack account {displayName} ({value}) to your account?\") and require an explicit confirm. This endpoint NEVER sets `consumed_at` — it is safe to call any number of times. 
         * @summary Preview what a Slack magic-link token would bind, without consuming it
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserChannelIdentitiesLinkTokenTokenGet(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkTokenPeek>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserChannelIdentitiesLinkTokenTokenGet(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserChannelIdentitiesLinkTokenTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List eligible successors for affected shared-team delegations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserDeletionDelegationCandidatesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDeletionDelegationCandidates>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserDeletionDelegationCandidatesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserDeletionDelegationCandidatesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request deletion of the current account
         * @param {AccountDeletionRequest} accountDeletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserDeletionPost(accountDeletionRequest: AccountDeletionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDeletionReceipt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserDeletionPost(accountDeletionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserDeletionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint ignores browser login cookies and never refreshes a browser session.
         * @summary Read account deletion progress with the one-time status credential
         * @param {string} requestId 
         * @param {string} xDeletionStatusToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserDeletionRequestIdGet(requestId: string, xDeletionStatusToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDeletionProgress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserDeletionRequestIdGet(requestId, xDeletionStatusToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserDeletionRequestIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke the final account deletion browser session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserDeletionSessionDelete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserDeletionSessionDelete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserDeletionSessionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserMeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserMeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserMeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a pending passwordless account for verified passkey signup
         * @param {PasskeySignupRequest} passkeySignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPasskeySignupPost(passkeySignupRequest: PasskeySignupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPasskeySignupPost(passkeySignupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserPasskeySignupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user password
         * @param {ApiUserPasswordPutRequest} apiUserPasswordPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPasswordPut(apiUserPasswordPutRequest: ApiUserPasswordPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserPasswordPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPasswordPut(apiUserPasswordPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserPasswordPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates E.164 shape, enforces a 60-second resend cooldown, and texts a 6-digit one-time code via the account-level Twilio sender (design doc decision 5b). The phone is not linked until the code is verified via /api/user/phone/verify. 
         * @summary Start (or restart) phone-number verification
         * @param {ApiUserPhoneStartPostRequest} apiUserPhoneStartPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPhoneStartPost(apiUserPhoneStartPostRequest: ApiUserPhoneStartPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserPhoneStartPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPhoneStartPost(apiUserPhoneStartPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserPhoneStartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Attempt-limited (5) and expiring (10 minutes); hitting the attempt cap clears the pending verification and locks with a 429. A correct code links the phone number in `user_channel_identities` via `sms_otp` and clears all OTP state either way (including when the phone is already linked to a different account, which 409s). 
         * @summary Verify the phone OTP code and link the phone identity
         * @param {ApiUserPhoneVerifyPostRequest} apiUserPhoneVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPhoneVerifyPost(apiUserPhoneVerifyPostRequest: ApiUserPhoneVerifyPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserPhoneVerifyPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPhoneVerifyPost(apiUserPhoneVerifyPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserPhoneVerifyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new user
         * @param {UserRequest} userRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPost(userRequest: UserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPost(userRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user profile
         * @param {ApiUserProfilePutRequest} apiUserProfilePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserProfilePut(apiUserProfilePutRequest: ApiUserProfilePutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserProfilePut(apiUserProfilePutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserProfilePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend verification email
         * @param {ApiUserResendVerificationPostRequest} apiUserResendVerificationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserResendVerificationPost(apiUserResendVerificationPostRequest: ApiUserResendVerificationPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserResendVerificationPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserResendVerificationPost(apiUserResendVerificationPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserResendVerificationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite/mention autocomplete. Matches first name, last name, or email address; returns at most 10 users.
         * @summary Search users who share a team with the requester
         * @param {string} q Search text (minimum 2 characters; shorter queries return an empty list)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSearchGet(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserSearchGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSearchGet(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify a user\'s email address
         * @param {string} email Email address to verify
         * @param {string} token Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserVerifyGet(email: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserVerifyGet(email, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.apiUserVerifyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Get users for a team
         * @param {number} teamId ID of the team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiTeamTeamIdUsersGet200ResponseInner>> {
            return localVarFp.apiTeamTeamIdUsersGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a user to a team
         * @param {number} teamId ID of the team
         * @param {ApiTeamTeamIdUsersPostRequest} apiTeamTeamIdUsersPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersPost(teamId: number, apiTeamTeamIdUsersPostRequest: ApiTeamTeamIdUsersPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdUsersPost200Response> {
            return localVarFp.apiTeamTeamIdUsersPost(teamId, apiTeamTeamIdUsersPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a user from a team
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {ApiTeamTeamIdUsersUserEmailAddressDeleteRequest} [apiTeamTeamIdUsersUserEmailAddressDeleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersUserEmailAddressDelete(teamId: number, userEmailAddress: string, apiTeamTeamIdUsersUserEmailAddressDeleteRequest?: ApiTeamTeamIdUsersUserEmailAddressDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdUsersUserEmailAddressDelete200Response> {
            return localVarFp.apiTeamTeamIdUsersUserEmailAddressDelete(teamId, userEmailAddress, apiTeamTeamIdUsersUserEmailAddressDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get eligible delegation successors before removing a team member
         * @param {number} teamId ID of the team
         * @param {string} userEmailAddress Email address of the user to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId: number, userEmailAddress: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet200Response> {
            return localVarFp.apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId, userEmailAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Links the (kind, value) bound to the token at issue time to the calling user\'s account — never a value the request supplies. The token is single-use and short-lived; unknown, already-consumed, and expired tokens all map to the same generic 400 so a caller probing tokens learns nothing about which case they hit. 
         * @summary Consume a Slack bot-delivered magic-link token
         * @param {ApiUserChannelIdentitiesConsumeLinkTokenPostRequest} apiUserChannelIdentitiesConsumeLinkTokenPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChannelIdentitiesConsumeLinkTokenPost(apiUserChannelIdentitiesConsumeLinkTokenPostRequest: ApiUserChannelIdentitiesConsumeLinkTokenPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUserChannelIdentitiesConsumeLinkTokenPost200Response> {
            return localVarFp.apiUserChannelIdentitiesConsumeLinkTokenPost(apiUserChannelIdentitiesConsumeLinkTokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Account-level, not team-scoped — the \"Linked identities\" section of account settings (linked Slack identities and verified phone number). 
         * @summary List the caller\'s linked channel identities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChannelIdentitiesGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiUserChannelIdentitiesGet200Response> {
            return localVarFp.apiUserChannelIdentitiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlink one of the caller\'s own channel identities
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChannelIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdCredentialsCredentialsIdDelete200Response> {
            return localVarFp.apiUserChannelIdentitiesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * C1 fix (final review): the account-settings landing page calls this FIRST, before ever consuming a `?link-token=`, so it can show whose identity the link names (\"Link Slack account {displayName} ({value}) to your account?\") and require an explicit confirm. This endpoint NEVER sets `consumed_at` — it is safe to call any number of times. 
         * @summary Preview what a Slack magic-link token would bind, without consuming it
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChannelIdentitiesLinkTokenTokenGet(token: string, options?: RawAxiosRequestConfig): AxiosPromise<LinkTokenPeek> {
            return localVarFp.apiUserChannelIdentitiesLinkTokenTokenGet(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List eligible successors for affected shared-team delegations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletionDelegationCandidatesGet(options?: RawAxiosRequestConfig): AxiosPromise<AccountDeletionDelegationCandidates> {
            return localVarFp.apiUserDeletionDelegationCandidatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request deletion of the current account
         * @param {AccountDeletionRequest} accountDeletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletionPost(accountDeletionRequest: AccountDeletionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountDeletionReceipt> {
            return localVarFp.apiUserDeletionPost(accountDeletionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint ignores browser login cookies and never refreshes a browser session.
         * @summary Read account deletion progress with the one-time status credential
         * @param {string} requestId 
         * @param {string} xDeletionStatusToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletionRequestIdGet(requestId: string, xDeletionStatusToken: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountDeletionProgress> {
            return localVarFp.apiUserDeletionRequestIdGet(requestId, xDeletionStatusToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke the final account deletion browser session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserDeletionSessionDelete(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUserDeletionSessionDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserMeGet(options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.apiUserMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a pending passwordless account for verified passkey signup
         * @param {PasskeySignupRequest} passkeySignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPasskeySignupPost(passkeySignupRequest: PasskeySignupRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.apiUserPasskeySignupPost(passkeySignupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user password
         * @param {ApiUserPasswordPutRequest} apiUserPasswordPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPasswordPut(apiUserPasswordPutRequest: ApiUserPasswordPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUserPasswordPut200Response> {
            return localVarFp.apiUserPasswordPut(apiUserPasswordPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates E.164 shape, enforces a 60-second resend cooldown, and texts a 6-digit one-time code via the account-level Twilio sender (design doc decision 5b). The phone is not linked until the code is verified via /api/user/phone/verify. 
         * @summary Start (or restart) phone-number verification
         * @param {ApiUserPhoneStartPostRequest} apiUserPhoneStartPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPhoneStartPost(apiUserPhoneStartPostRequest: ApiUserPhoneStartPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUserPhoneStartPost200Response> {
            return localVarFp.apiUserPhoneStartPost(apiUserPhoneStartPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Attempt-limited (5) and expiring (10 minutes); hitting the attempt cap clears the pending verification and locks with a 429. A correct code links the phone number in `user_channel_identities` via `sms_otp` and clears all OTP state either way (including when the phone is already linked to a different account, which 409s). 
         * @summary Verify the phone OTP code and link the phone identity
         * @param {ApiUserPhoneVerifyPostRequest} apiUserPhoneVerifyPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPhoneVerifyPost(apiUserPhoneVerifyPostRequest: ApiUserPhoneVerifyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUserPhoneVerifyPost200Response> {
            return localVarFp.apiUserPhoneVerifyPost(apiUserPhoneVerifyPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new user
         * @param {UserRequest} userRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPost(userRequest: UserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.apiUserPost(userRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user profile
         * @param {ApiUserProfilePutRequest} apiUserProfilePutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserProfilePut(apiUserProfilePutRequest: ApiUserProfilePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.apiUserProfilePut(apiUserProfilePutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend verification email
         * @param {ApiUserResendVerificationPostRequest} apiUserResendVerificationPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserResendVerificationPost(apiUserResendVerificationPostRequest: ApiUserResendVerificationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUserResendVerificationPost200Response> {
            return localVarFp.apiUserResendVerificationPost(apiUserResendVerificationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite/mention autocomplete. Matches first name, last name, or email address; returns at most 10 users.
         * @summary Search users who share a team with the requester
         * @param {string} q Search text (minimum 2 characters; shorter queries return an empty list)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSearchGet(q: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiUserSearchGet200Response> {
            return localVarFp.apiUserSearchGet(q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify a user\'s email address
         * @param {string} email Email address to verify
         * @param {string} token Verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserVerifyGet(email: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUserVerifyGet(email, token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Get users for a team
     * @param {number} teamId ID of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdUsersGet(teamId: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiTeamTeamIdUsersGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a user to a team
     * @param {number} teamId ID of the team
     * @param {ApiTeamTeamIdUsersPostRequest} apiTeamTeamIdUsersPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdUsersPost(teamId: number, apiTeamTeamIdUsersPostRequest: ApiTeamTeamIdUsersPostRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiTeamTeamIdUsersPost(teamId, apiTeamTeamIdUsersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a user from a team
     * @param {number} teamId ID of the team
     * @param {string} userEmailAddress Email address of the user to remove
     * @param {ApiTeamTeamIdUsersUserEmailAddressDeleteRequest} [apiTeamTeamIdUsersUserEmailAddressDeleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdUsersUserEmailAddressDelete(teamId: number, userEmailAddress: string, apiTeamTeamIdUsersUserEmailAddressDeleteRequest?: ApiTeamTeamIdUsersUserEmailAddressDeleteRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiTeamTeamIdUsersUserEmailAddressDelete(teamId, userEmailAddress, apiTeamTeamIdUsersUserEmailAddressDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get eligible delegation successors before removing a team member
     * @param {number} teamId ID of the team
     * @param {string} userEmailAddress Email address of the user to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId: number, userEmailAddress: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiTeamTeamIdUsersUserEmailAddressRemovalDelegationCandidatesGet(teamId, userEmailAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Links the (kind, value) bound to the token at issue time to the calling user\'s account — never a value the request supplies. The token is single-use and short-lived; unknown, already-consumed, and expired tokens all map to the same generic 400 so a caller probing tokens learns nothing about which case they hit. 
     * @summary Consume a Slack bot-delivered magic-link token
     * @param {ApiUserChannelIdentitiesConsumeLinkTokenPostRequest} apiUserChannelIdentitiesConsumeLinkTokenPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserChannelIdentitiesConsumeLinkTokenPost(apiUserChannelIdentitiesConsumeLinkTokenPostRequest: ApiUserChannelIdentitiesConsumeLinkTokenPostRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserChannelIdentitiesConsumeLinkTokenPost(apiUserChannelIdentitiesConsumeLinkTokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Account-level, not team-scoped — the \"Linked identities\" section of account settings (linked Slack identities and verified phone number). 
     * @summary List the caller\'s linked channel identities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserChannelIdentitiesGet(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserChannelIdentitiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlink one of the caller\'s own channel identities
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserChannelIdentitiesIdDelete(id: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserChannelIdentitiesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * C1 fix (final review): the account-settings landing page calls this FIRST, before ever consuming a `?link-token=`, so it can show whose identity the link names (\"Link Slack account {displayName} ({value}) to your account?\") and require an explicit confirm. This endpoint NEVER sets `consumed_at` — it is safe to call any number of times. 
     * @summary Preview what a Slack magic-link token would bind, without consuming it
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserChannelIdentitiesLinkTokenTokenGet(token: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserChannelIdentitiesLinkTokenTokenGet(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List eligible successors for affected shared-team delegations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserDeletionDelegationCandidatesGet(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserDeletionDelegationCandidatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request deletion of the current account
     * @param {AccountDeletionRequest} accountDeletionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserDeletionPost(accountDeletionRequest: AccountDeletionRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserDeletionPost(accountDeletionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint ignores browser login cookies and never refreshes a browser session.
     * @summary Read account deletion progress with the one-time status credential
     * @param {string} requestId 
     * @param {string} xDeletionStatusToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserDeletionRequestIdGet(requestId: string, xDeletionStatusToken: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserDeletionRequestIdGet(requestId, xDeletionStatusToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke the final account deletion browser session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserDeletionSessionDelete(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserDeletionSessionDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserMeGet(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a pending passwordless account for verified passkey signup
     * @param {PasskeySignupRequest} passkeySignupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserPasskeySignupPost(passkeySignupRequest: PasskeySignupRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserPasskeySignupPost(passkeySignupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user password
     * @param {ApiUserPasswordPutRequest} apiUserPasswordPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserPasswordPut(apiUserPasswordPutRequest: ApiUserPasswordPutRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserPasswordPut(apiUserPasswordPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates E.164 shape, enforces a 60-second resend cooldown, and texts a 6-digit one-time code via the account-level Twilio sender (design doc decision 5b). The phone is not linked until the code is verified via /api/user/phone/verify. 
     * @summary Start (or restart) phone-number verification
     * @param {ApiUserPhoneStartPostRequest} apiUserPhoneStartPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserPhoneStartPost(apiUserPhoneStartPostRequest: ApiUserPhoneStartPostRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserPhoneStartPost(apiUserPhoneStartPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Attempt-limited (5) and expiring (10 minutes); hitting the attempt cap clears the pending verification and locks with a 429. A correct code links the phone number in `user_channel_identities` via `sms_otp` and clears all OTP state either way (including when the phone is already linked to a different account, which 409s). 
     * @summary Verify the phone OTP code and link the phone identity
     * @param {ApiUserPhoneVerifyPostRequest} apiUserPhoneVerifyPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserPhoneVerifyPost(apiUserPhoneVerifyPostRequest: ApiUserPhoneVerifyPostRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserPhoneVerifyPost(apiUserPhoneVerifyPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new user
     * @param {UserRequest} userRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserPost(userRequest: UserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserPost(userRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user profile
     * @param {ApiUserProfilePutRequest} apiUserProfilePutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserProfilePut(apiUserProfilePutRequest: ApiUserProfilePutRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserProfilePut(apiUserProfilePutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend verification email
     * @param {ApiUserResendVerificationPostRequest} apiUserResendVerificationPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserResendVerificationPost(apiUserResendVerificationPostRequest: ApiUserResendVerificationPostRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserResendVerificationPost(apiUserResendVerificationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite/mention autocomplete. Matches first name, last name, or email address; returns at most 10 users.
     * @summary Search users who share a team with the requester
     * @param {string} q Search text (minimum 2 characters; shorter queries return an empty list)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserSearchGet(q: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserSearchGet(q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify a user\'s email address
     * @param {string} email Email address to verify
     * @param {string} token Verification token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiUserVerifyGet(email: string, token: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).apiUserVerifyGet(email, token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VideoContentApi - axios parameter creator
 */
export const VideoContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Read browser-compatible selectable captions for committed video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdContentFilesContentFileIdCaptionsGet: async (teamId: number, contentFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdCaptionsGet', 'teamId', teamId)
            // verify required parameter 'contentFileId' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdCaptionsGet', 'contentFileId', contentFileId)
            const localVarPath = `/api/teams/{teamId}/content-files/{contentFileId}/captions`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"contentFileId"}}`, encodeURIComponent(String(contentFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Inspect a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdContentFilesContentFileIdGet: async (teamId: number, contentFileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdGet', 'teamId', teamId)
            // verify required parameter 'contentFileId' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdGet', 'contentFileId', contentFileId)
            const localVarPath = `/api/teams/{teamId}/content-files/{contentFileId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"contentFileId"}}`, encodeURIComponent(String(contentFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change the finite lifecycle of a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {VideoLifecycleRequest} videoLifecycleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch: async (teamId: number, contentFileId: string, videoLifecycleRequest: VideoLifecycleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch', 'teamId', teamId)
            // verify required parameter 'contentFileId' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch', 'contentFileId', contentFileId)
            // verify required parameter 'videoLifecycleRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch', 'videoLifecycleRequest', videoLifecycleRequest)
            const localVarPath = `/api/teams/{teamId}/content-files/{contentFileId}/lifecycle`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"contentFileId"}}`, encodeURIComponent(String(contentFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoLifecycleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stream a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdContentFilesContentFileIdStreamGet: async (teamId: number, contentFileId: string, range?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdStreamGet', 'teamId', teamId)
            // verify required parameter 'contentFileId' is not null or undefined
            assertParamExists('apiTeamsTeamIdContentFilesContentFileIdStreamGet', 'contentFileId', contentFileId)
            const localVarPath = `/api/teams/{teamId}/content-files/{contentFileId}/stream`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"contentFileId"}}`, encodeURIComponent(String(contentFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (range != null) {
                localVarHeaderParameter['Range'] = String(range);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Copy temporary content into a permanent project Team File
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} contentFileId 
         * @param {VideoContentPermanentCopyRequest} videoContentPermanentCopyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost: async (teamId: number, projectId: number, contentFileId: string, videoContentPermanentCopyRequest: VideoContentPermanentCopyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost', 'projectId', projectId)
            // verify required parameter 'contentFileId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost', 'contentFileId', contentFileId)
            // verify required parameter 'videoContentPermanentCopyRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost', 'videoContentPermanentCopyRequest', videoContentPermanentCopyRequest)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/content-files/{contentFileId}/copy-to-team-files`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"contentFileId"}}`, encodeURIComponent(String(contentFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoContentPermanentCopyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read browser-compatible selectable captions for a review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet: async (teamId: number, draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet', 'teamId', teamId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet', 'draftId', draftId)
            const localVarPath = `/api/teams/{teamId}/video-drafts/{draftId}/captions`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Idempotent for a draft. The default finite lifecycle is 30 days.
         * @summary Commit a reviewed draft into managed content storage
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {VideoCommitRequest} [videoCommitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdCommitPost: async (teamId: number, draftId: string, videoCommitRequest?: VideoCommitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdCommitPost', 'teamId', teamId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdCommitPost', 'draftId', draftId)
            const localVarPath = `/api/teams/{teamId}/video-drafts/{draftId}/commit`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoCommitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdDelete: async (teamId: number, draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdDelete', 'teamId', teamId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdDelete', 'draftId', draftId)
            const localVarPath = `/api/teams/{teamId}/video-drafts/{draftId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Inspect a browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdGet: async (teamId: number, draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdGet', 'teamId', teamId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdGet', 'draftId', draftId)
            const localVarPath = `/api/teams/{teamId}/video-drafts/{draftId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stream an expiring browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdStreamGet: async (teamId: number, draftId: string, range?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdStreamGet', 'teamId', teamId)
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('apiTeamsTeamIdVideoDraftsDraftIdStreamGet', 'draftId', draftId)
            const localVarPath = `/api/teams/{teamId}/video-drafts/{draftId}/stream`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"draftId"}}`, encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (range != null) {
                localVarHeaderParameter['Range'] = String(range);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VideoContentApi - functional programming interface
 */
export const VideoContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VideoContentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Read browser-compatible selectable captions for committed video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdContentFilesContentFileIdCaptionsGet(teamId: number, contentFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdContentFilesContentFileIdCaptionsGet(teamId, contentFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdContentFilesContentFileIdCaptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Inspect a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdContentFilesContentFileIdGet(teamId: number, contentFileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoContentFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdContentFilesContentFileIdGet(teamId, contentFileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdContentFilesContentFileIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change the finite lifecycle of a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {VideoLifecycleRequest} videoLifecycleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch(teamId: number, contentFileId: string, videoLifecycleRequest: VideoLifecycleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoContentFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch(teamId, contentFileId, videoLifecycleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stream a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdContentFilesContentFileIdStreamGet(teamId: number, contentFileId: string, range?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdContentFilesContentFileIdStreamGet(teamId, contentFileId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdContentFilesContentFileIdStreamGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Copy temporary content into a permanent project Team File
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} contentFileId 
         * @param {VideoContentPermanentCopyRequest} videoContentPermanentCopyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost(teamId: number, projectId: number, contentFileId: string, videoContentPermanentCopyRequest: VideoContentPermanentCopyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoContentPermanentCopyResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost(teamId, projectId, contentFileId, videoContentPermanentCopyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read browser-compatible selectable captions for a review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet(teamId: number, draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet(teamId, draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Idempotent for a draft. The default finite lifecycle is 30 days.
         * @summary Commit a reviewed draft into managed content storage
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {VideoCommitRequest} [videoCommitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdVideoDraftsDraftIdCommitPost(teamId: number, draftId: string, videoCommitRequest?: VideoCommitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoContentFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdVideoDraftsDraftIdCommitPost(teamId, draftId, videoCommitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdVideoDraftsDraftIdCommitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdVideoDraftsDraftIdDelete(teamId: number, draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdVideoDraftsDraftIdDelete(teamId, draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdVideoDraftsDraftIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Inspect a browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdVideoDraftsDraftIdGet(teamId: number, draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoDraft>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdVideoDraftsDraftIdGet(teamId, draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdVideoDraftsDraftIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stream an expiring browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdVideoDraftsDraftIdStreamGet(teamId: number, draftId: string, range?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdVideoDraftsDraftIdStreamGet(teamId, draftId, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoContentApi.apiTeamsTeamIdVideoDraftsDraftIdStreamGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VideoContentApi - factory interface
 */
export const VideoContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VideoContentApiFp(configuration)
    return {
        /**
         * 
         * @summary Read browser-compatible selectable captions for committed video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdContentFilesContentFileIdCaptionsGet(teamId: number, contentFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTeamsTeamIdContentFilesContentFileIdCaptionsGet(teamId, contentFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Inspect a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdContentFilesContentFileIdGet(teamId: number, contentFileId: string, options?: RawAxiosRequestConfig): AxiosPromise<VideoContentFile> {
            return localVarFp.apiTeamsTeamIdContentFilesContentFileIdGet(teamId, contentFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change the finite lifecycle of a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {VideoLifecycleRequest} videoLifecycleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch(teamId: number, contentFileId: string, videoLifecycleRequest: VideoLifecycleRequest, options?: RawAxiosRequestConfig): AxiosPromise<VideoContentFile> {
            return localVarFp.apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch(teamId, contentFileId, videoLifecycleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stream a committed browser video
         * @param {number} teamId 
         * @param {string} contentFileId 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdContentFilesContentFileIdStreamGet(teamId: number, contentFileId: string, range?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTeamsTeamIdContentFilesContentFileIdStreamGet(teamId, contentFileId, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Copy temporary content into a permanent project Team File
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} contentFileId 
         * @param {VideoContentPermanentCopyRequest} videoContentPermanentCopyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost(teamId: number, projectId: number, contentFileId: string, videoContentPermanentCopyRequest: VideoContentPermanentCopyRequest, options?: RawAxiosRequestConfig): AxiosPromise<VideoContentPermanentCopyResult> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost(teamId, projectId, contentFileId, videoContentPermanentCopyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read browser-compatible selectable captions for a review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet(teamId: number, draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet(teamId, draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * Idempotent for a draft. The default finite lifecycle is 30 days.
         * @summary Commit a reviewed draft into managed content storage
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {VideoCommitRequest} [videoCommitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdCommitPost(teamId: number, draftId: string, videoCommitRequest?: VideoCommitRequest, options?: RawAxiosRequestConfig): AxiosPromise<VideoContentFile> {
            return localVarFp.apiTeamsTeamIdVideoDraftsDraftIdCommitPost(teamId, draftId, videoCommitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdDelete(teamId: number, draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdVideoDraftsDraftIdDelete(teamId, draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Inspect a browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdGet(teamId: number, draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<VideoDraft> {
            return localVarFp.apiTeamsTeamIdVideoDraftsDraftIdGet(teamId, draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stream an expiring browser video review draft
         * @param {number} teamId 
         * @param {string} draftId 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdVideoDraftsDraftIdStreamGet(teamId: number, draftId: string, range?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiTeamsTeamIdVideoDraftsDraftIdStreamGet(teamId, draftId, range, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VideoContentApi - object-oriented interface
 */
export class VideoContentApi extends BaseAPI {
    /**
     * 
     * @summary Read browser-compatible selectable captions for committed video
     * @param {number} teamId 
     * @param {string} contentFileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdContentFilesContentFileIdCaptionsGet(teamId: number, contentFileId: string, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdContentFilesContentFileIdCaptionsGet(teamId, contentFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Inspect a committed browser video
     * @param {number} teamId 
     * @param {string} contentFileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdContentFilesContentFileIdGet(teamId: number, contentFileId: string, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdContentFilesContentFileIdGet(teamId, contentFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change the finite lifecycle of a committed browser video
     * @param {number} teamId 
     * @param {string} contentFileId 
     * @param {VideoLifecycleRequest} videoLifecycleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch(teamId: number, contentFileId: string, videoLifecycleRequest: VideoLifecycleRequest, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdContentFilesContentFileIdLifecyclePatch(teamId, contentFileId, videoLifecycleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stream a committed browser video
     * @param {number} teamId 
     * @param {string} contentFileId 
     * @param {string} [range] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdContentFilesContentFileIdStreamGet(teamId: number, contentFileId: string, range?: string, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdContentFilesContentFileIdStreamGet(teamId, contentFileId, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Copy temporary content into a permanent project Team File
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} contentFileId 
     * @param {VideoContentPermanentCopyRequest} videoContentPermanentCopyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost(teamId: number, projectId: number, contentFileId: string, videoContentPermanentCopyRequest: VideoContentPermanentCopyRequest, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdContentFilesContentFileIdCopyToTeamFilesPost(teamId, projectId, contentFileId, videoContentPermanentCopyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read browser-compatible selectable captions for a review draft
     * @param {number} teamId 
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet(teamId: number, draftId: string, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdVideoDraftsDraftIdCaptionsGet(teamId, draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Idempotent for a draft. The default finite lifecycle is 30 days.
     * @summary Commit a reviewed draft into managed content storage
     * @param {number} teamId 
     * @param {string} draftId 
     * @param {VideoCommitRequest} [videoCommitRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdVideoDraftsDraftIdCommitPost(teamId: number, draftId: string, videoCommitRequest?: VideoCommitRequest, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdVideoDraftsDraftIdCommitPost(teamId, draftId, videoCommitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a browser video review draft
     * @param {number} teamId 
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdVideoDraftsDraftIdDelete(teamId: number, draftId: string, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdVideoDraftsDraftIdDelete(teamId, draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Inspect a browser video review draft
     * @param {number} teamId 
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdVideoDraftsDraftIdGet(teamId: number, draftId: string, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdVideoDraftsDraftIdGet(teamId, draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stream an expiring browser video review draft
     * @param {number} teamId 
     * @param {string} draftId 
     * @param {string} [range] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdVideoDraftsDraftIdStreamGet(teamId: number, draftId: string, range?: string, options?: RawAxiosRequestConfig) {
        return VideoContentApiFp(this.configuration).apiTeamsTeamIdVideoDraftsDraftIdStreamGet(teamId, draftId, range, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebSocketApi - axios parameter creator
 */
export const WebSocketApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiWsAgentAgentIdLearnGet', 'agentId', agentId)
            const localVarPath = `/api/ws/agent/{agentId}/learn`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnMockGet: async (agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiWsAgentAgentIdLearnMockGet', 'agentId', agentId)
            const localVarPath = `/api/ws/agent/{agentId}/learn-mock`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebSocketApi - functional programming interface
 */
export const WebSocketApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebSocketApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWsAgentAgentIdLearnGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebSocketApi.apiWsAgentAgentIdLearnGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWsAgentAgentIdLearnMockGet(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebSocketApi.apiWsAgentAgentIdLearnMockGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebSocketApi - factory interface
 */
export const WebSocketApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebSocketApiFp(configuration)
    return {
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming agent learning progress
         * @param {number} agentId ID of the agent to learn from website
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWsAgentAgentIdLearnGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
         * @summary WebSocket endpoint for streaming mock agent learning progress
         * @param {number} agentId ID of the agent to simulate learning
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiWsAgentAgentIdLearnMockGet(agentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebSocketApi - object-oriented interface
 */
export class WebSocketApi extends BaseAPI {
    /**
     * This endpoint requires a WebSocket connection. When connected, it streams real-time feedback about the agent\'s learning progress from a website. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn` with a valid short-lived access token in the cookies. 
     * @summary WebSocket endpoint for streaming agent learning progress
     * @param {number} agentId ID of the agent to learn from website
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiWsAgentAgentIdLearnGet(agentId: number, options?: RawAxiosRequestConfig) {
        return WebSocketApiFp(this.configuration).apiWsAgentAgentIdLearnGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint requires a WebSocket connection. When connected, it streams simulated real-time feedback about the agent\'s learning progress. This is a mock version of the /api/ws/agent/{agentId}/learn endpoint intended for testing purposes. The client will receive various event types:  - `start`: Indicates the learning process has started - `feedback`: Contains simulated progress updates during the learning process - `complete`: Indicates the learning process has completed successfully - `error`: Contains error information if the learning process fails  To use this endpoint, establish a WebSocket connection to `/api/ws/agent/{agentId}/learn-mock` with a valid short-lived access token in the cookies. 
     * @summary WebSocket endpoint for streaming mock agent learning progress
     * @param {number} agentId ID of the agent to simulate learning
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiWsAgentAgentIdLearnMockGet(agentId: number, options?: RawAxiosRequestConfig) {
        return WebSocketApiFp(this.configuration).apiWsAgentAgentIdLearnMockGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WikiApi - axios parameter creator
 */
export const WikiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Archive or unarchive a wiki page
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiArchiveRequest} wikiArchiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost: async (teamId: number, projectId: number, wikiArchiveRequest: WikiArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost', 'projectId', projectId)
            // verify required parameter 'wikiArchiveRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost', 'wikiArchiveRequest', wikiArchiveRequest)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/wiki/page/archive`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wikiArchiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a wiki page and all of its versions (members only)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPageDelete: async (teamId: number, projectId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageDelete', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageDelete', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageDelete', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/wiki/page`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a wiki page (latest or a specific version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPageGet: async (teamId: number, projectId: number, path: string, version?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageGet', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageGet', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/wiki/page`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move/rename a page, rewriting wikilinks that pointed at it
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiMoveRequest} wikiMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPageMovePost: async (teamId: number, projectId: number, wikiMoveRequest: WikiMoveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageMovePost', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageMovePost', 'projectId', projectId)
            // verify required parameter 'wikiMoveRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPageMovePost', 'wikiMoveRequest', wikiMoveRequest)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/wiki/page/move`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wikiMoveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or edit a wiki page (writes a new version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiSaveRequest} wikiSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPagePut: async (teamId: number, projectId: number, wikiSaveRequest: WikiSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPagePut', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPagePut', 'projectId', projectId)
            // verify required parameter 'wikiSaveRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPagePut', 'wikiSaveRequest', wikiSaveRequest)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/wiki/page`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wikiSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List the project\'s wiki pages
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPagesGet: async (teamId: number, projectId: number, includeArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPagesGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiPagesGet', 'projectId', projectId)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/wiki/pages`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeArchived !== undefined) {
                localVarQueryParameter['includeArchived'] = includeArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search page titles and bodies within the project wiki
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiSearchGet: async (teamId: number, projectId: number, q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiSearchGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiSearchGet', 'projectId', projectId)
            // verify required parameter 'q' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiSearchGet', 'q', q)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/wiki/search`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a wiki page\'s version history
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiVersionsGet: async (teamId: number, projectId: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiVersionsGet', 'teamId', teamId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiVersionsGet', 'projectId', projectId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('apiTeamsTeamIdProjectsProjectIdWikiVersionsGet', 'path', path)
            const localVarPath = `/api/teams/{teamId}/projects/{projectId}/wiki/versions`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WikiApi - functional programming interface
 */
export const WikiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WikiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Archive or unarchive a wiki page
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiArchiveRequest} wikiArchiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost(teamId: number, projectId: number, wikiArchiveRequest: WikiArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WikiPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost(teamId, projectId, wikiArchiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiApi.apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a wiki page and all of its versions (members only)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdWikiPageDelete(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdProjectsProjectIdWikiPageDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdWikiPageDelete(teamId, projectId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiApi.apiTeamsTeamIdProjectsProjectIdWikiPageDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a wiki page (latest or a specific version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdWikiPageGet(teamId: number, projectId: number, path: string, version?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WikiPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdWikiPageGet(teamId, projectId, path, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiApi.apiTeamsTeamIdProjectsProjectIdWikiPageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Move/rename a page, rewriting wikilinks that pointed at it
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiMoveRequest} wikiMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdWikiPageMovePost(teamId: number, projectId: number, wikiMoveRequest: WikiMoveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WikiMoveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdWikiPageMovePost(teamId, projectId, wikiMoveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiApi.apiTeamsTeamIdProjectsProjectIdWikiPageMovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create or edit a wiki page (writes a new version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiSaveRequest} wikiSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdWikiPagePut(teamId: number, projectId: number, wikiSaveRequest: WikiSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WikiPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdWikiPagePut(teamId, projectId, wikiSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiApi.apiTeamsTeamIdProjectsProjectIdWikiPagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List the project\'s wiki pages
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdWikiPagesGet(teamId: number, projectId: number, includeArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WikiPagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdWikiPagesGet(teamId, projectId, includeArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiApi.apiTeamsTeamIdProjectsProjectIdWikiPagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search page titles and bodies within the project wiki
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdWikiSearchGet(teamId: number, projectId: number, q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WikiSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdWikiSearchGet(teamId, projectId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiApi.apiTeamsTeamIdProjectsProjectIdWikiSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a wiki page\'s version history
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdProjectsProjectIdWikiVersionsGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WikiVersionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdProjectsProjectIdWikiVersionsGet(teamId, projectId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WikiApi.apiTeamsTeamIdProjectsProjectIdWikiVersionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WikiApi - factory interface
 */
export const WikiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WikiApiFp(configuration)
    return {
        /**
         * 
         * @summary Archive or unarchive a wiki page
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiArchiveRequest} wikiArchiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost(teamId: number, projectId: number, wikiArchiveRequest: WikiArchiveRequest, options?: RawAxiosRequestConfig): AxiosPromise<WikiPageResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost(teamId, projectId, wikiArchiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a wiki page and all of its versions (members only)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPageDelete(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdProjectsProjectIdWikiPageDelete200Response> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdWikiPageDelete(teamId, projectId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a wiki page (latest or a specific version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {number} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPageGet(teamId: number, projectId: number, path: string, version?: number, options?: RawAxiosRequestConfig): AxiosPromise<WikiPageResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdWikiPageGet(teamId, projectId, path, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move/rename a page, rewriting wikilinks that pointed at it
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiMoveRequest} wikiMoveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPageMovePost(teamId: number, projectId: number, wikiMoveRequest: WikiMoveRequest, options?: RawAxiosRequestConfig): AxiosPromise<WikiMoveResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdWikiPageMovePost(teamId, projectId, wikiMoveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or edit a wiki page (writes a new version)
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {WikiSaveRequest} wikiSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPagePut(teamId: number, projectId: number, wikiSaveRequest: WikiSaveRequest, options?: RawAxiosRequestConfig): AxiosPromise<WikiPageResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdWikiPagePut(teamId, projectId, wikiSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List the project\'s wiki pages
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {boolean} [includeArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiPagesGet(teamId: number, projectId: number, includeArchived?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<WikiPagesResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdWikiPagesGet(teamId, projectId, includeArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search page titles and bodies within the project wiki
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiSearchGet(teamId: number, projectId: number, q: string, options?: RawAxiosRequestConfig): AxiosPromise<WikiSearchResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdWikiSearchGet(teamId, projectId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a wiki page\'s version history
         * @param {number} teamId 
         * @param {number} projectId 
         * @param {string} path 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdProjectsProjectIdWikiVersionsGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<WikiVersionsResponse> {
            return localVarFp.apiTeamsTeamIdProjectsProjectIdWikiVersionsGet(teamId, projectId, path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WikiApi - object-oriented interface
 */
export class WikiApi extends BaseAPI {
    /**
     * 
     * @summary Archive or unarchive a wiki page
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {WikiArchiveRequest} wikiArchiveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost(teamId: number, projectId: number, wikiArchiveRequest: WikiArchiveRequest, options?: RawAxiosRequestConfig) {
        return WikiApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdWikiPageArchivePost(teamId, projectId, wikiArchiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a wiki page and all of its versions (members only)
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdWikiPageDelete(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig) {
        return WikiApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdWikiPageDelete(teamId, projectId, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a wiki page (latest or a specific version)
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {number} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdWikiPageGet(teamId: number, projectId: number, path: string, version?: number, options?: RawAxiosRequestConfig) {
        return WikiApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdWikiPageGet(teamId, projectId, path, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move/rename a page, rewriting wikilinks that pointed at it
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {WikiMoveRequest} wikiMoveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdWikiPageMovePost(teamId: number, projectId: number, wikiMoveRequest: WikiMoveRequest, options?: RawAxiosRequestConfig) {
        return WikiApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdWikiPageMovePost(teamId, projectId, wikiMoveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or edit a wiki page (writes a new version)
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {WikiSaveRequest} wikiSaveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdWikiPagePut(teamId: number, projectId: number, wikiSaveRequest: WikiSaveRequest, options?: RawAxiosRequestConfig) {
        return WikiApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdWikiPagePut(teamId, projectId, wikiSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List the project\'s wiki pages
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {boolean} [includeArchived] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdWikiPagesGet(teamId: number, projectId: number, includeArchived?: boolean, options?: RawAxiosRequestConfig) {
        return WikiApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdWikiPagesGet(teamId, projectId, includeArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search page titles and bodies within the project wiki
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} q 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdWikiSearchGet(teamId: number, projectId: number, q: string, options?: RawAxiosRequestConfig) {
        return WikiApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdWikiSearchGet(teamId, projectId, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a wiki page\'s version history
     * @param {number} teamId 
     * @param {number} projectId 
     * @param {string} path 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdProjectsProjectIdWikiVersionsGet(teamId: number, projectId: number, path: string, options?: RawAxiosRequestConfig) {
        return WikiApiFp(this.configuration).apiTeamsTeamIdProjectsProjectIdWikiVersionsGet(teamId, projectId, path, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkStreamsApi - axios parameter creator
 */
export const WorkStreamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamGuidanceRequest} workStreamGuidanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueWorkStream: async (workStreamId: number, workStreamGuidanceRequest: WorkStreamGuidanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('continueWorkStream', 'workStreamId', workStreamId)
            // verify required parameter 'workStreamGuidanceRequest' is not null or undefined
            assertParamExists('continueWorkStream', 'workStreamGuidanceRequest', workStreamGuidanceRequest)
            const localVarPath = `/api/work-streams/{workStreamId}/continuation`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workStreamGuidanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Internal Cloud Scheduler endpoint authenticated by the shared dispatch token.
         * @summary Run bounded Work stream artifact retention sweeps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchDueWorkStreamArtifactRetention: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/work-stream-artifacts/retention/dispatch-due`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTeamChatConversationWorkStream: async (teamId: number, conversationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getLatestTeamChatConversationWorkStream', 'teamId', teamId)
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getLatestTeamChatConversationWorkStream', 'conversationId', conversationId)
            const localVarPath = `/api/teams/{teamId}/chat-conversations/{conversationId}/work-streams`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"conversationId"}}`, encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStream: async (workStreamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('getWorkStream', 'workStreamId', workStreamId)
            const localVarPath = `/api/work-streams/{workStreamId}`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} frameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStreamBrowserFrameContent: async (workStreamId: number, frameId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('getWorkStreamBrowserFrameContent', 'workStreamId', workStreamId)
            // verify required parameter 'frameId' is not null or undefined
            assertParamExists('getWorkStreamBrowserFrameContent', 'frameId', frameId)
            const localVarPath = `/api/work-streams/{workStreamId}/browser-frames/{frameId}/content`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)))
                .replace(`{${"frameId"}}`, encodeURIComponent(String(frameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} fileStateId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStreamFile: async (workStreamId: number, fileStateId: number, runId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('getWorkStreamFile', 'workStreamId', workStreamId)
            // verify required parameter 'fileStateId' is not null or undefined
            assertParamExists('getWorkStreamFile', 'fileStateId', fileStateId)
            const localVarPath = `/api/work-streams/{workStreamId}/files/{fileStateId}`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)))
                .replace(`{${"fileStateId"}}`, encodeURIComponent(String(fileStateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runId !== undefined) {
                localVarQueryParameter['runId'] = runId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} eventId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStreamSkill: async (workStreamId: number, eventId: number, runId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('getWorkStreamSkill', 'workStreamId', workStreamId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getWorkStreamSkill', 'eventId', eventId)
            const localVarPath = `/api/work-streams/{workStreamId}/skills/{eventId}`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runId !== undefined) {
                localVarQueryParameter['runId'] = runId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStreamWorkSummary: async (workStreamId: number, runId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('getWorkStreamWorkSummary', 'workStreamId', workStreamId)
            const localVarPath = `/api/work-streams/{workStreamId}/summary`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runId !== undefined) {
                localVarQueryParameter['runId'] = runId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamGuidanceRequest} workStreamGuidanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guideWorkStream: async (workStreamId: number, workStreamGuidanceRequest: WorkStreamGuidanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('guideWorkStream', 'workStreamId', workStreamId)
            // verify required parameter 'workStreamGuidanceRequest' is not null or undefined
            assertParamExists('guideWorkStream', 'workStreamGuidanceRequest', workStreamGuidanceRequest)
            const localVarPath = `/api/work-streams/{workStreamId}/guidance`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workStreamGuidanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardWorkStreams: async (cardId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('listCardWorkStreams', 'cardId', cardId)
            const localVarPath = `/api/project-cards/{cardId}/work-streams`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Current, queued, and recently finished agent work for a team, filterable to one agent or one project. Card items are restricted to boards the caller can see; team-chat items require team-chat view. Omit bucket for the grouped snapshot; pass bucket=recent with beforeId for older finished work. 
         * @summary Team-wide agent work queue
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {number} [projectId] 
         * @param {ListTeamWorkBucketEnum} [bucket] 
         * @param {number} [beforeId] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamWork: async (teamId: number, agentId?: number, projectId?: number, bucket?: ListTeamWorkBucketEnum, beforeId?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamWork', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/work`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }

            if (beforeId !== undefined) {
                localVarQueryParameter['beforeId'] = beforeId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkStreamBrowserFrames: async (workStreamId: number, runId?: number, before?: string, after?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('listWorkStreamBrowserFrames', 'workStreamId', workStreamId)
            const localVarPath = `/api/work-streams/{workStreamId}/browser-frames`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runId !== undefined) {
                localVarQueryParameter['runId'] = runId;
            }

            if (before !== undefined) {
                localVarQueryParameter['before'] = before;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkStreamEvents: async (workStreamId: number, before?: string, after?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('listWorkStreamEvents', 'workStreamId', workStreamId)
            const localVarPath = `/api/work-streams/{workStreamId}/events`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (before !== undefined) {
                localVarQueryParameter['before'] = before;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkStreamFiles: async (workStreamId: number, runId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('listWorkStreamFiles', 'workStreamId', workStreamId)
            const localVarPath = `/api/work-streams/{workStreamId}/files`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runId !== undefined) {
                localVarQueryParameter['runId'] = runId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkStreamSkills: async (workStreamId: number, runId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('listWorkStreamSkills', 'workStreamId', workStreamId)
            const localVarPath = `/api/work-streams/{workStreamId}/skills`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runId !== undefined) {
                localVarQueryParameter['runId'] = runId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamBrowserRecordingResolveRequest} workStreamBrowserRecordingResolveRequest 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWorkStreamBrowserRecordings: async (workStreamId: number, workStreamBrowserRecordingResolveRequest: WorkStreamBrowserRecordingResolveRequest, runId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('resolveWorkStreamBrowserRecordings', 'workStreamId', workStreamId)
            // verify required parameter 'workStreamBrowserRecordingResolveRequest' is not null or undefined
            assertParamExists('resolveWorkStreamBrowserRecordings', 'workStreamBrowserRecordingResolveRequest', workStreamBrowserRecordingResolveRequest)
            const localVarPath = `/api/work-streams/{workStreamId}/browser-recordings/resolve`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (runId !== undefined) {
                localVarQueryParameter['runId'] = runId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workStreamBrowserRecordingResolveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {CancelCardNextActionRequest} [cancelCardNextActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopWorkStream: async (workStreamId: number, cancelCardNextActionRequest?: CancelCardNextActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workStreamId' is not null or undefined
            assertParamExists('stopWorkStream', 'workStreamId', workStreamId)
            const localVarPath = `/api/work-streams/{workStreamId}/stop`
                .replace(`{${"workStreamId"}}`, encodeURIComponent(String(workStreamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelCardNextActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkStreamsApi - functional programming interface
 */
export const WorkStreamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkStreamsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamGuidanceRequest} workStreamGuidanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continueWorkStream(workStreamId: number, workStreamGuidanceRequest: WorkStreamGuidanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContinueWorkStream201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continueWorkStream(workStreamId, workStreamGuidanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.continueWorkStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Internal Cloud Scheduler endpoint authenticated by the shared dispatch token.
         * @summary Run bounded Work stream artifact retention sweeps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dispatchDueWorkStreamArtifactRetention(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dispatchDueWorkStreamArtifactRetention(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.dispatchDueWorkStreamArtifactRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestTeamChatConversationWorkStream(teamId: number, conversationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLatestTeamChatConversationWorkStream200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestTeamChatConversationWorkStream(teamId, conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.getLatestTeamChatConversationWorkStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkStream(workStreamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkStream200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkStream(workStreamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.getWorkStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} frameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkStreamBrowserFrameContent(workStreamId: number, frameId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkStreamBrowserFrameContent(workStreamId, frameId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.getWorkStreamBrowserFrameContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} fileStateId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkStreamFile(workStreamId: number, fileStateId: number, runId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkStreamFile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkStreamFile(workStreamId, fileStateId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.getWorkStreamFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} eventId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkStreamSkill(workStreamId: number, eventId: number, runId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkStreamSkill200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkStreamSkill(workStreamId, eventId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.getWorkStreamSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkStreamWorkSummary(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkStreamWorkSummary200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkStreamWorkSummary(workStreamId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.getWorkStreamWorkSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamGuidanceRequest} workStreamGuidanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async guideWorkStream(workStreamId: number, workStreamGuidanceRequest: WorkStreamGuidanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuideWorkStream201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.guideWorkStream(workStreamId, workStreamGuidanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.guideWorkStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCardWorkStreams(cardId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCardWorkStreams200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCardWorkStreams(cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.listCardWorkStreams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Current, queued, and recently finished agent work for a team, filterable to one agent or one project. Card items are restricted to boards the caller can see; team-chat items require team-chat view. Omit bucket for the grouped snapshot; pass bucket=recent with beforeId for older finished work. 
         * @summary Team-wide agent work queue
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {number} [projectId] 
         * @param {ListTeamWorkBucketEnum} [bucket] 
         * @param {number} [beforeId] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamWork(teamId: number, agentId?: number, projectId?: number, bucket?: ListTeamWorkBucketEnum, beforeId?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamWorkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamWork(teamId, agentId, projectId, bucket, beforeId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.listTeamWork']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkStreamBrowserFrames(workStreamId: number, runId?: number, before?: string, after?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkStreamBrowserFrames200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkStreamBrowserFrames(workStreamId, runId, before, after, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.listWorkStreamBrowserFrames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkStreamEvents(workStreamId: number, before?: string, after?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkStreamEvents200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkStreamEvents(workStreamId, before, after, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.listWorkStreamEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkStreamFiles(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkStreamFiles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkStreamFiles(workStreamId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.listWorkStreamFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkStreamSkills(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkStreamSkills200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkStreamSkills(workStreamId, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.listWorkStreamSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamBrowserRecordingResolveRequest} workStreamBrowserRecordingResolveRequest 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveWorkStreamBrowserRecordings(workStreamId: number, workStreamBrowserRecordingResolveRequest: WorkStreamBrowserRecordingResolveRequest, runId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkStreamBrowserRecordingResolveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveWorkStreamBrowserRecordings(workStreamId, workStreamBrowserRecordingResolveRequest, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.resolveWorkStreamBrowserRecordings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {CancelCardNextActionRequest} [cancelCardNextActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopWorkStream(workStreamId: number, cancelCardNextActionRequest?: CancelCardNextActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StopWorkStream202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopWorkStream(workStreamId, cancelCardNextActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkStreamsApi.stopWorkStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkStreamsApi - factory interface
 */
export const WorkStreamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkStreamsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamGuidanceRequest} workStreamGuidanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueWorkStream(workStreamId: number, workStreamGuidanceRequest: WorkStreamGuidanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContinueWorkStream201Response> {
            return localVarFp.continueWorkStream(workStreamId, workStreamGuidanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Internal Cloud Scheduler endpoint authenticated by the shared dispatch token.
         * @summary Run bounded Work stream artifact retention sweeps
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchDueWorkStreamArtifactRetention(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dispatchDueWorkStreamArtifactRetention(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} teamId 
         * @param {number} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTeamChatConversationWorkStream(teamId: number, conversationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetLatestTeamChatConversationWorkStream200Response> {
            return localVarFp.getLatestTeamChatConversationWorkStream(teamId, conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStream(workStreamId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetWorkStream200Response> {
            return localVarFp.getWorkStream(workStreamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} frameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStreamBrowserFrameContent(workStreamId: number, frameId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getWorkStreamBrowserFrameContent(workStreamId, frameId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} fileStateId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStreamFile(workStreamId: number, fileStateId: number, runId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetWorkStreamFile200Response> {
            return localVarFp.getWorkStreamFile(workStreamId, fileStateId, runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} eventId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStreamSkill(workStreamId: number, eventId: number, runId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetWorkStreamSkill200Response> {
            return localVarFp.getWorkStreamSkill(workStreamId, eventId, runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkStreamWorkSummary(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetWorkStreamWorkSummary200Response> {
            return localVarFp.getWorkStreamWorkSummary(workStreamId, runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamGuidanceRequest} workStreamGuidanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        guideWorkStream(workStreamId: number, workStreamGuidanceRequest: WorkStreamGuidanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<GuideWorkStream201Response> {
            return localVarFp.guideWorkStream(workStreamId, workStreamGuidanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCardWorkStreams(cardId: number, options?: RawAxiosRequestConfig): AxiosPromise<ListCardWorkStreams200Response> {
            return localVarFp.listCardWorkStreams(cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Current, queued, and recently finished agent work for a team, filterable to one agent or one project. Card items are restricted to boards the caller can see; team-chat items require team-chat view. Omit bucket for the grouped snapshot; pass bucket=recent with beforeId for older finished work. 
         * @summary Team-wide agent work queue
         * @param {number} teamId 
         * @param {number} [agentId] 
         * @param {number} [projectId] 
         * @param {ListTeamWorkBucketEnum} [bucket] 
         * @param {number} [beforeId] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamWork(teamId: number, agentId?: number, projectId?: number, bucket?: ListTeamWorkBucketEnum, beforeId?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<TeamWorkResponse> {
            return localVarFp.listTeamWork(teamId, agentId, projectId, bucket, beforeId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkStreamBrowserFrames(workStreamId: number, runId?: number, before?: string, after?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListWorkStreamBrowserFrames200Response> {
            return localVarFp.listWorkStreamBrowserFrames(workStreamId, runId, before, after, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {string} [before] 
         * @param {string} [after] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkStreamEvents(workStreamId: number, before?: string, after?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListWorkStreamEvents200Response> {
            return localVarFp.listWorkStreamEvents(workStreamId, before, after, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkStreamFiles(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListWorkStreamFiles200Response> {
            return localVarFp.listWorkStreamFiles(workStreamId, runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkStreamSkills(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListWorkStreamSkills200Response> {
            return localVarFp.listWorkStreamSkills(workStreamId, runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {WorkStreamBrowserRecordingResolveRequest} workStreamBrowserRecordingResolveRequest 
         * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWorkStreamBrowserRecordings(workStreamId: number, workStreamBrowserRecordingResolveRequest: WorkStreamBrowserRecordingResolveRequest, runId?: number, options?: RawAxiosRequestConfig): AxiosPromise<WorkStreamBrowserRecordingResolveResponse> {
            return localVarFp.resolveWorkStreamBrowserRecordings(workStreamId, workStreamBrowserRecordingResolveRequest, runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} workStreamId 
         * @param {CancelCardNextActionRequest} [cancelCardNextActionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopWorkStream(workStreamId: number, cancelCardNextActionRequest?: CancelCardNextActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StopWorkStream202Response> {
            return localVarFp.stopWorkStream(workStreamId, cancelCardNextActionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkStreamsApi - object-oriented interface
 */
export class WorkStreamsApi extends BaseAPI {
    /**
     * 
     * @param {number} workStreamId 
     * @param {WorkStreamGuidanceRequest} workStreamGuidanceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public continueWorkStream(workStreamId: number, workStreamGuidanceRequest: WorkStreamGuidanceRequest, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).continueWorkStream(workStreamId, workStreamGuidanceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Internal Cloud Scheduler endpoint authenticated by the shared dispatch token.
     * @summary Run bounded Work stream artifact retention sweeps
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dispatchDueWorkStreamArtifactRetention(options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).dispatchDueWorkStreamArtifactRetention(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} teamId 
     * @param {number} conversationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestTeamChatConversationWorkStream(teamId: number, conversationId: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).getLatestTeamChatConversationWorkStream(teamId, conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkStream(workStreamId: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).getWorkStream(workStreamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {number} frameId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkStreamBrowserFrameContent(workStreamId: number, frameId: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).getWorkStreamBrowserFrameContent(workStreamId, frameId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {number} fileStateId 
     * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkStreamFile(workStreamId: number, fileStateId: number, runId?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).getWorkStreamFile(workStreamId, fileStateId, runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {number} eventId 
     * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkStreamSkill(workStreamId: number, eventId: number, runId?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).getWorkStreamSkill(workStreamId, eventId, runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWorkStreamWorkSummary(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).getWorkStreamWorkSummary(workStreamId, runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {WorkStreamGuidanceRequest} workStreamGuidanceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public guideWorkStream(workStreamId: number, workStreamGuidanceRequest: WorkStreamGuidanceRequest, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).guideWorkStream(workStreamId, workStreamGuidanceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCardWorkStreams(cardId: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).listCardWorkStreams(cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Current, queued, and recently finished agent work for a team, filterable to one agent or one project. Card items are restricted to boards the caller can see; team-chat items require team-chat view. Omit bucket for the grouped snapshot; pass bucket=recent with beforeId for older finished work. 
     * @summary Team-wide agent work queue
     * @param {number} teamId 
     * @param {number} [agentId] 
     * @param {number} [projectId] 
     * @param {ListTeamWorkBucketEnum} [bucket] 
     * @param {number} [beforeId] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTeamWork(teamId: number, agentId?: number, projectId?: number, bucket?: ListTeamWorkBucketEnum, beforeId?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).listTeamWork(teamId, agentId, projectId, bucket, beforeId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
     * @param {string} [before] 
     * @param {string} [after] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkStreamBrowserFrames(workStreamId: number, runId?: number, before?: string, after?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).listWorkStreamBrowserFrames(workStreamId, runId, before, after, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {string} [before] 
     * @param {string} [after] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkStreamEvents(workStreamId: number, before?: string, after?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).listWorkStreamEvents(workStreamId, before, after, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkStreamFiles(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).listWorkStreamFiles(workStreamId, runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listWorkStreamSkills(workStreamId: number, runId?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).listWorkStreamSkills(workStreamId, runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {WorkStreamBrowserRecordingResolveRequest} workStreamBrowserRecordingResolveRequest 
     * @param {number} [runId] Restrict the projection to one immutable run; omit for all runs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resolveWorkStreamBrowserRecordings(workStreamId: number, workStreamBrowserRecordingResolveRequest: WorkStreamBrowserRecordingResolveRequest, runId?: number, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).resolveWorkStreamBrowserRecordings(workStreamId, workStreamBrowserRecordingResolveRequest, runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} workStreamId 
     * @param {CancelCardNextActionRequest} [cancelCardNextActionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stopWorkStream(workStreamId: number, cancelCardNextActionRequest?: CancelCardNextActionRequest, options?: RawAxiosRequestConfig) {
        return WorkStreamsApiFp(this.configuration).stopWorkStream(workStreamId, cancelCardNextActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ListTeamWorkBucketEnum = {
    Recent: 'recent'
} as const;
export type ListTeamWorkBucketEnum = typeof ListTeamWorkBucketEnum[keyof typeof ListTeamWorkBucketEnum];


/**
 * WorkspacesApi - axios parameter creator
 */
export const WorkspacesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Read workspace resource policy for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacePolicyGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacePolicyGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/workspace-policy`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update workspace resource policy for a team
         * @param {number} teamId 
         * @param {WorkspacePolicy} workspacePolicy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacePolicyPut: async (teamId: number, workspacePolicy: WorkspacePolicy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacePolicyPut', 'teamId', teamId)
            // verify required parameter 'workspacePolicy' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacePolicyPut', 'workspacePolicy', workspacePolicy)
            const localVarPath = `/api/teams/{teamId}/workspace-policy`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspacePolicy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read public workspace provider capabilities
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum} providerKey 
         * @param {string} [region] 
         * @param {boolean} [providerLimits] Return provider ceilings without applying the saved team policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet: async (teamId: number, providerKey: ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum, region?: string, providerLimits?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet', 'teamId', teamId)
            // verify required parameter 'providerKey' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet', 'providerKey', providerKey)
            const localVarPath = `/api/teams/{teamId}/workspace-providers/{providerKey}/capabilities`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"providerKey"}}`, encodeURIComponent(String(providerKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (providerLimits !== undefined) {
                localVarQueryParameter['providerLimits'] = providerLimits;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read the public workspace provider price catalog
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum} providerKey 
         * @param {string} [region] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet: async (teamId: number, providerKey: ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum, region?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet', 'teamId', teamId)
            // verify required parameter 'providerKey' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet', 'providerKey', providerKey)
            const localVarPath = `/api/teams/{teamId}/workspace-providers/{providerKey}/catalog`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"providerKey"}}`, encodeURIComponent(String(providerKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List workspace requests for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsGet: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/workspace-requests`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenApprovePost: async (teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenApprovePost', 'teamId', teamId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenApprovePost', 'token', token)
            // verify required parameter 'apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenApprovePost', 'apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest', apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest)
            const localVarPath = `/api/teams/{teamId}/workspace-requests/{token}/approve`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenCancelPost: async (teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenCancelPost', 'teamId', teamId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenCancelPost', 'token', token)
            // verify required parameter 'apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenCancelPost', 'apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest', apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest)
            const localVarPath = `/api/teams/{teamId}/workspace-requests/{token}/cancel`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a workspace request and its current revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenGet: async (teamId: number, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenGet', 'teamId', teamId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenGet', 'token', token)
            const localVarPath = `/api/teams/{teamId}/workspace-requests/{token}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revise a pending workspace request as a team member
         * @param {number} teamId 
         * @param {string} token 
         * @param {WorkspaceRequestRevisionInput} workspaceRequestRevisionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenPatch: async (teamId: number, token: string, workspaceRequestRevisionInput: WorkspaceRequestRevisionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenPatch', 'teamId', teamId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenPatch', 'token', token)
            // verify required parameter 'workspaceRequestRevisionInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenPatch', 'workspaceRequestRevisionInput', workspaceRequestRevisionInput)
            const localVarPath = `/api/teams/{teamId}/workspace-requests/{token}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceRequestRevisionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenRejectPost: async (teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenRejectPost', 'teamId', teamId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenRejectPost', 'token', token)
            // verify required parameter 'apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspaceRequestsTokenRejectPost', 'apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest', apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest)
            const localVarPath = `/api/teams/{teamId}/workspace-requests/{token}/reject`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List workspaces for a team
         * @param {number} teamId 
         * @param {number} [agentId] Filter to workspaces created by this agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesGet: async (teamId: number, agentId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/workspaces`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a workspace resource request authored and approved by the calling team member and fulfills it immediately. The workspace is not attached to any conversation; the agent adopts it later with its workspace tools. 
         * @summary Provision a workspace for an agent directly
         * @param {number} teamId 
         * @param {WorkspaceProvisionInput} workspaceProvisionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesPost: async (teamId: number, workspaceProvisionInput: WorkspaceProvisionInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesPost', 'teamId', teamId)
            // verify required parameter 'workspaceProvisionInput' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesPost', 'workspaceProvisionInput', workspaceProvisionInput)
            const localVarPath = `/api/teams/{teamId}/workspaces`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceProvisionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change CPU, memory, or GPU allocation for a workspace
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest} apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut: async (teamId: number, workspaceId: number, apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest: ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut', 'teamId', teamId)
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut', 'workspaceId', workspaceId)
            // verify required parameter 'apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut', 'apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest', apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest)
            const localVarPath = `/api/teams/{teamId}/workspaces/{workspaceId}/allocation`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read the command log an agent produced in a workspace
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {number} agentId Agent whose command log to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet: async (teamId: number, workspaceId: number, agentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet', 'teamId', teamId)
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet', 'workspaceId', workspaceId)
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet', 'agentId', agentId)
            const localVarPath = `/api/teams/{teamId}/workspaces/{workspaceId}/command-log`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently delete a workspace and its persistent data
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesWorkspaceIdDelete: async (teamId: number, workspaceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesWorkspaceIdDelete', 'teamId', teamId)
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('apiTeamsTeamIdWorkspacesWorkspaceIdDelete', 'workspaceId', workspaceId)
            const localVarPath = `/api/teams/{teamId}/workspaces/{workspaceId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"workspaceId"}}`, encodeURIComponent(String(workspaceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkspacesApi - functional programming interface
 */
export const WorkspacesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkspacesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Read workspace resource policy for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspacePolicyGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdWorkspacePolicyGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspacePolicyGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspacePolicyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update workspace resource policy for a team
         * @param {number} teamId 
         * @param {WorkspacePolicy} workspacePolicy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspacePolicyPut(teamId: number, workspacePolicy: WorkspacePolicy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdWorkspacePolicyGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspacePolicyPut(teamId, workspacePolicy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspacePolicyPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read public workspace provider capabilities
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum} providerKey 
         * @param {string} [region] 
         * @param {boolean} [providerLimits] Return provider ceilings without applying the saved team policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet(teamId: number, providerKey: ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum, region?: string, providerLimits?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet(teamId, providerKey, region, providerLimits, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read the public workspace provider price catalog
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum} providerKey 
         * @param {string} [region] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet(teamId: number, providerKey: ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum, region?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet(teamId, providerKey, region, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List workspace requests for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspaceRequestsGet(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdWorkspaceRequestsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspaceRequestsGet(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspaceRequestsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Approve the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspaceRequestsTokenApprovePost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceResourceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspaceRequestsTokenApprovePost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspaceRequestsTokenApprovePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspaceRequestsTokenCancelPost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceResourceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspaceRequestsTokenCancelPost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspaceRequestsTokenCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a workspace request and its current revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspaceRequestsTokenGet(teamId: number, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceResourceRequestDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspaceRequestsTokenGet(teamId, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspaceRequestsTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revise a pending workspace request as a team member
         * @param {number} teamId 
         * @param {string} token 
         * @param {WorkspaceRequestRevisionInput} workspaceRequestRevisionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspaceRequestsTokenPatch(teamId: number, token: string, workspaceRequestRevisionInput: WorkspaceRequestRevisionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceResourceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspaceRequestsTokenPatch(teamId, token, workspaceRequestRevisionInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspaceRequestsTokenPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspaceRequestsTokenRejectPost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceResourceRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspaceRequestsTokenRejectPost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspaceRequestsTokenRejectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List workspaces for a team
         * @param {number} teamId 
         * @param {number} [agentId] Filter to workspaces created by this agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspacesGet(teamId: number, agentId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspacesGet(teamId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspacesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a workspace resource request authored and approved by the calling team member and fulfills it immediately. The workspace is not attached to any conversation; the agent adopts it later with its workspace tools. 
         * @summary Provision a workspace for an agent directly
         * @param {number} teamId 
         * @param {WorkspaceProvisionInput} workspaceProvisionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspacesPost(teamId: number, workspaceProvisionInput: WorkspaceProvisionInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceProvisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspacesPost(teamId, workspaceProvisionInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspacesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change CPU, memory, or GPU allocation for a workspace
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest} apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut(teamId: number, workspaceId: number, apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest: ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut(teamId, workspaceId, apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read the command log an agent produced in a workspace
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {number} agentId Agent whose command log to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet(teamId: number, workspaceId: number, agentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceCommandLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet(teamId, workspaceId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Permanently delete a workspace and its persistent data
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdWorkspacesWorkspaceIdDelete(teamId: number, workspaceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdWorkspacesWorkspaceIdDelete(teamId, workspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspacesApi.apiTeamsTeamIdWorkspacesWorkspaceIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkspacesApi - factory interface
 */
export const WorkspacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkspacesApiFp(configuration)
    return {
        /**
         * 
         * @summary Read workspace resource policy for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacePolicyGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdWorkspacePolicyGet200Response> {
            return localVarFp.apiTeamsTeamIdWorkspacePolicyGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update workspace resource policy for a team
         * @param {number} teamId 
         * @param {WorkspacePolicy} workspacePolicy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacePolicyPut(teamId: number, workspacePolicy: WorkspacePolicy, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdWorkspacePolicyGet200Response> {
            return localVarFp.apiTeamsTeamIdWorkspacePolicyPut(teamId, workspacePolicy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read public workspace provider capabilities
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum} providerKey 
         * @param {string} [region] 
         * @param {boolean} [providerLimits] Return provider ceilings without applying the saved team policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet(teamId: number, providerKey: ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum, region?: string, providerLimits?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet200Response> {
            return localVarFp.apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet(teamId, providerKey, region, providerLimits, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read the public workspace provider price catalog
         * @param {number} teamId 
         * @param {ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum} providerKey 
         * @param {string} [region] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet(teamId: number, providerKey: ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum, region?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet200Response> {
            return localVarFp.apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet(teamId, providerKey, region, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List workspace requests for a team
         * @param {number} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsGet(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdWorkspaceRequestsGet200Response> {
            return localVarFp.apiTeamsTeamIdWorkspaceRequestsGet(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenApprovePost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceResourceRequestResponse> {
            return localVarFp.apiTeamsTeamIdWorkspaceRequestsTokenApprovePost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenCancelPost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceResourceRequestResponse> {
            return localVarFp.apiTeamsTeamIdWorkspaceRequestsTokenCancelPost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a workspace request and its current revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenGet(teamId: number, token: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceResourceRequestDetail> {
            return localVarFp.apiTeamsTeamIdWorkspaceRequestsTokenGet(teamId, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revise a pending workspace request as a team member
         * @param {number} teamId 
         * @param {string} token 
         * @param {WorkspaceRequestRevisionInput} workspaceRequestRevisionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenPatch(teamId: number, token: string, workspaceRequestRevisionInput: WorkspaceRequestRevisionInput, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceResourceRequestResponse> {
            return localVarFp.apiTeamsTeamIdWorkspaceRequestsTokenPatch(teamId, token, workspaceRequestRevisionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject the current workspace request revision
         * @param {number} teamId 
         * @param {string} token 
         * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspaceRequestsTokenRejectPost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceResourceRequestResponse> {
            return localVarFp.apiTeamsTeamIdWorkspaceRequestsTokenRejectPost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List workspaces for a team
         * @param {number} teamId 
         * @param {number} [agentId] Filter to workspaces created by this agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesGet(teamId: number, agentId?: number, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceListResponse> {
            return localVarFp.apiTeamsTeamIdWorkspacesGet(teamId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a workspace resource request authored and approved by the calling team member and fulfills it immediately. The workspace is not attached to any conversation; the agent adopts it later with its workspace tools. 
         * @summary Provision a workspace for an agent directly
         * @param {number} teamId 
         * @param {WorkspaceProvisionInput} workspaceProvisionInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesPost(teamId: number, workspaceProvisionInput: WorkspaceProvisionInput, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceProvisionResponse> {
            return localVarFp.apiTeamsTeamIdWorkspacesPost(teamId, workspaceProvisionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change CPU, memory, or GPU allocation for a workspace
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest} apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut(teamId: number, workspaceId: number, apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest: ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut200Response> {
            return localVarFp.apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut(teamId, workspaceId, apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read the command log an agent produced in a workspace
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {number} agentId Agent whose command log to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet(teamId: number, workspaceId: number, agentId: number, options?: RawAxiosRequestConfig): AxiosPromise<WorkspaceCommandLogResponse> {
            return localVarFp.apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet(teamId, workspaceId, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently delete a workspace and its persistent data
         * @param {number} teamId 
         * @param {number} workspaceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdWorkspacesWorkspaceIdDelete(teamId: number, workspaceId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdWorkspacesWorkspaceIdDelete(teamId, workspaceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkspacesApi - object-oriented interface
 */
export class WorkspacesApi extends BaseAPI {
    /**
     * 
     * @summary Read workspace resource policy for a team
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspacePolicyGet(teamId: number, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspacePolicyGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update workspace resource policy for a team
     * @param {number} teamId 
     * @param {WorkspacePolicy} workspacePolicy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspacePolicyPut(teamId: number, workspacePolicy: WorkspacePolicy, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspacePolicyPut(teamId, workspacePolicy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read public workspace provider capabilities
     * @param {number} teamId 
     * @param {ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum} providerKey 
     * @param {string} [region] 
     * @param {boolean} [providerLimits] Return provider ceilings without applying the saved team policy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet(teamId: number, providerKey: ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum, region?: string, providerLimits?: boolean, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGet(teamId, providerKey, region, providerLimits, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read the public workspace provider price catalog
     * @param {number} teamId 
     * @param {ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum} providerKey 
     * @param {string} [region] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet(teamId: number, providerKey: ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum, region?: string, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGet(teamId, providerKey, region, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List workspace requests for a team
     * @param {number} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspaceRequestsGet(teamId: number, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspaceRequestsGet(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve the current workspace request revision
     * @param {number} teamId 
     * @param {string} token 
     * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspaceRequestsTokenApprovePost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspaceRequestsTokenApprovePost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel the current workspace request revision
     * @param {number} teamId 
     * @param {string} token 
     * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspaceRequestsTokenCancelPost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspaceRequestsTokenCancelPost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a workspace request and its current revision
     * @param {number} teamId 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspaceRequestsTokenGet(teamId: number, token: string, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspaceRequestsTokenGet(teamId, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revise a pending workspace request as a team member
     * @param {number} teamId 
     * @param {string} token 
     * @param {WorkspaceRequestRevisionInput} workspaceRequestRevisionInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspaceRequestsTokenPatch(teamId: number, token: string, workspaceRequestRevisionInput: WorkspaceRequestRevisionInput, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspaceRequestsTokenPatch(teamId, token, workspaceRequestRevisionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject the current workspace request revision
     * @param {number} teamId 
     * @param {string} token 
     * @param {ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest} apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspaceRequestsTokenRejectPost(teamId: number, token: string, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest: ApiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspaceRequestsTokenRejectPost(teamId, token, apiTeamsTeamIdWorkspaceRequestsTokenApprovePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List workspaces for a team
     * @param {number} teamId 
     * @param {number} [agentId] Filter to workspaces created by this agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspacesGet(teamId: number, agentId?: number, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspacesGet(teamId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a workspace resource request authored and approved by the calling team member and fulfills it immediately. The workspace is not attached to any conversation; the agent adopts it later with its workspace tools. 
     * @summary Provision a workspace for an agent directly
     * @param {number} teamId 
     * @param {WorkspaceProvisionInput} workspaceProvisionInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspacesPost(teamId: number, workspaceProvisionInput: WorkspaceProvisionInput, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspacesPost(teamId, workspaceProvisionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change CPU, memory, or GPU allocation for a workspace
     * @param {number} teamId 
     * @param {number} workspaceId 
     * @param {ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest} apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut(teamId: number, workspaceId: number, apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest: ApiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPut(teamId, workspaceId, apiTeamsTeamIdWorkspacesWorkspaceIdAllocationPutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read the command log an agent produced in a workspace
     * @param {number} teamId 
     * @param {number} workspaceId 
     * @param {number} agentId Agent whose command log to read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet(teamId: number, workspaceId: number, agentId: number, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspacesWorkspaceIdCommandLogGet(teamId, workspaceId, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently delete a workspace and its persistent data
     * @param {number} teamId 
     * @param {number} workspaceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdWorkspacesWorkspaceIdDelete(teamId: number, workspaceId: number, options?: RawAxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).apiTeamsTeamIdWorkspacesWorkspaceIdDelete(teamId, workspaceId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum = {
    Local: 'local',
    Gke: 'gke',
    Firecracker: 'firecracker'
} as const;
export type ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum = typeof ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum[keyof typeof ApiTeamsTeamIdWorkspaceProvidersProviderKeyCapabilitiesGetProviderKeyEnum];
export const ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum = {
    Local: 'local',
    Gke: 'gke',
    Firecracker: 'firecracker'
} as const;
export type ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum = typeof ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum[keyof typeof ApiTeamsTeamIdWorkspaceProvidersProviderKeyCatalogGetProviderKeyEnum];


